webpackJsonp([0],[
/* 0 */,
/* 1 */,
/* 2 */,
/* 3 */,
/* 4 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return accounts; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return updateAccount; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return accountPlan; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return accountCategories; });
/* unused harmony export revenueAndCosts */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return materialUsage; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return suppliers; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return costpricePerHour; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return costsDivision; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return keyFigures; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return accountingYearsCheck; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return compareKeyfigures; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return compareRevenue; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return compareCoveragePercent; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return compareCoverage; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return compareCoveragePerHour; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return compareCustomerHours; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__HttpService__ = __webpack_require__(5);


var namespace = '';

var accounts = function accounts(params, cb, errorCb) {
    __WEBPACK_IMPORTED_MODULE_0__HttpService__["a" /* get */](namespace + 'accounts', params, cb, errorCb);
};

var accountPlan = function accountPlan(params, cb, errorCb) {
    __WEBPACK_IMPORTED_MODULE_0__HttpService__["a" /* get */](namespace + 'accounts/plan', params, cb, errorCb);
};

var accountCategories = function accountCategories(params, cb, errorCb) {
    __WEBPACK_IMPORTED_MODULE_0__HttpService__["a" /* get */](namespace + 'account-categories', params, cb, errorCb);
};

var updateAccount = function updateAccount(uuid, body, params, cb, errorCb) {
    __WEBPACK_IMPORTED_MODULE_0__HttpService__["e" /* put */](namespace + 'accounts/' + uuid, body, params, cb, errorCb);
};

var revenueAndCosts = function revenueAndCosts(params, cb, errorCb) {
    __WEBPACK_IMPORTED_MODULE_0__HttpService__["a" /* get */](namespace + 'calculations/economy/revenueandcosts', params, cb, errorCb);
};

var materialUsage = function materialUsage(params, cb, errorCb) {
    __WEBPACK_IMPORTED_MODULE_0__HttpService__["a" /* get */](namespace + 'calculations/economy/material-usage', params, cb, errorCb);
};

var suppliers = function suppliers(params, cb, errorCb) {
    __WEBPACK_IMPORTED_MODULE_0__HttpService__["a" /* get */](namespace + 'calculations/economy/suppliers', params, cb, errorCb);
};

var costpricePerHour = function costpricePerHour(params, cb, errorCb) {
    __WEBPACK_IMPORTED_MODULE_0__HttpService__["a" /* get */](namespace + 'calculations/economy/costprice-per-hour', params, cb, errorCb);
};

var costsDivision = function costsDivision(params, cb, errorCb) {
    __WEBPACK_IMPORTED_MODULE_0__HttpService__["a" /* get */](namespace + 'calculations/economy/costs-division', params, cb, errorCb);
};

var keyFigures = function keyFigures(params, cb, errorCb) {
    __WEBPACK_IMPORTED_MODULE_0__HttpService__["a" /* get */](namespace + 'calculations/economy', params, cb, errorCb);
};
var accountingYearsCheck = function accountingYearsCheck(params, cb, errorCb) {
    __WEBPACK_IMPORTED_MODULE_0__HttpService__["a" /* get */](namespace + 'accounting-years-check', params, cb, errorCb);
};

var compareKeyfigures = function compareKeyfigures(params, cb, errorCb) {
    __WEBPACK_IMPORTED_MODULE_0__HttpService__["a" /* get */](namespace + 'calculations/compare-keyfigures', params, cb, errorCb);
};

var compareRevenue = function compareRevenue(params, cb, errorCb) {
    __WEBPACK_IMPORTED_MODULE_0__HttpService__["a" /* get */](namespace + 'calculations/compare-revenue', params, cb, errorCb);
};

var compareCoveragePercent = function compareCoveragePercent(params, cb, errorCb) {
    __WEBPACK_IMPORTED_MODULE_0__HttpService__["a" /* get */](namespace + 'calculations/compare-coverage-percent', params, cb, errorCb);
};

var compareCoverage = function compareCoverage(params, cb, errorCb) {
    __WEBPACK_IMPORTED_MODULE_0__HttpService__["a" /* get */](namespace + 'calculations/compare-coverage', params, cb, errorCb);
};

var compareCoveragePerHour = function compareCoveragePerHour(params, cb, errorCb) {
    __WEBPACK_IMPORTED_MODULE_0__HttpService__["a" /* get */](namespace + 'calculations/compare-coverage-per-hour', params, cb, errorCb);
};

var compareCustomerHours = function compareCustomerHours(params, cb, errorCb) {
    __WEBPACK_IMPORTED_MODULE_0__HttpService__["a" /* get */](namespace + 'calculations/compare-customer-hours', params, cb, errorCb);
};



/***/ }),
/* 5 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return get; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return remove; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return post; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return put; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return patch; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__store_index__ = __webpack_require__(84);



var requestsTotal = 0;
var requestCompleted = 0;
var postTotal = 0;
var postCompleted = 0;

var get = function get(path, data, cb, errorCb) {
    requestsTotal++;
    __WEBPACK_IMPORTED_MODULE_1__store_index__["a" /* default */].state.loading = true;
    __WEBPACK_IMPORTED_MODULE_1__store_index__["a" /* default */].state.errors = [];
    __WEBPACK_IMPORTED_MODULE_0_vue__["default"].axios.get(path, { params: data }).then(function (response) {
        requestCompleted++;
        loading();
        cb(response);
    }).catch(function (error) {
        requestCompleted++;
        loading();
        errorCb(error);
    });
};

var remove = function remove(path, cb, errorCb) {
    requestsTotal++;
    __WEBPACK_IMPORTED_MODULE_1__store_index__["a" /* default */].state.loading = true;
    __WEBPACK_IMPORTED_MODULE_1__store_index__["a" /* default */].state.errors = [];
    __WEBPACK_IMPORTED_MODULE_0_vue__["default"].axios.delete(path).then(function (response) {
        requestCompleted++;
        loading();
        cb(response);
    }).catch(function (error) {
        requestCompleted++;
        loading();
        errorCb(error);
    });
};

var post = function post(path, data, cb, errorCb) {
    postTotal++;
    __WEBPACK_IMPORTED_MODULE_1__store_index__["a" /* default */].state.inputLoading = true;
    __WEBPACK_IMPORTED_MODULE_0_vue__["default"].axios.post(path, data).then(function (response) {
        postCompleted++;
        PostLoading();
        cb(response);
    }).catch(function (error) {
        postCompleted++;
        PostLoading();
        if (errorCb !== undefined) {
            errorCb(error.response);
        }
    });
};

var put = function put(path, data, cb, errorCb) {
    postTotal++;
    __WEBPACK_IMPORTED_MODULE_1__store_index__["a" /* default */].state.inputLoading = true;
    __WEBPACK_IMPORTED_MODULE_1__store_index__["a" /* default */].state.errors = [];
    data['_method'] = 'PUT';
    __WEBPACK_IMPORTED_MODULE_0_vue__["default"].axios.post(path, data).then(function (response) {
        postCompleted++;
        PostLoading();
        cb(response);
    }).catch(function (error) {
        postCompleted++;
        PostLoading();
        if (error.response !== undefined) {
            if (error.response.status === 422) {
                __WEBPACK_IMPORTED_MODULE_1__store_index__["a" /* default */].state.errors = error.response.data;
            }
        }
    });
};

var patch = function patch(path, data, cb, errorCb) {
    postTotal++;
    __WEBPACK_IMPORTED_MODULE_1__store_index__["a" /* default */].state.inputLoading = true;
    __WEBPACK_IMPORTED_MODULE_1__store_index__["a" /* default */].state.errors = [];
    data['_method'] = 'PATCH';
    __WEBPACK_IMPORTED_MODULE_0_vue__["default"].axios.post(path, data).then(function (response) {
        postCompleted++;
        PostLoading();
        cb(response);
    }).catch(function (error) {
        postCompleted++;
        PostLoading();
        if (error.response !== undefined) {
            if (error.response.status === 422) {
                __WEBPACK_IMPORTED_MODULE_1__store_index__["a" /* default */].state.errors = error.response.data;
            }
        }
    });
};

function loading() {
    if (requestsTotal === requestCompleted) {
        requestsTotal = 0;
        requestCompleted = 0;
        __WEBPACK_IMPORTED_MODULE_1__store_index__["a" /* default */].state.loading = false;
    }
}

function PostLoading() {
    if (postTotal === postCompleted) {
        postTotal = 0;
        postCompleted = 0;
        __WEBPACK_IMPORTED_MODULE_1__store_index__["a" /* default */].state.inputLoading = false;
    }
}



/***/ }),
/* 6 */,
/* 7 */,
/* 8 */,
/* 9 */,
/* 10 */,
/* 11 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return find; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return between; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return update; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return claims; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__HttpService__ = __webpack_require__(5);



var namespace = 'projects';

var find = function find(params, cb, errorCb) {
    __WEBPACK_IMPORTED_MODULE_1__HttpService__["a" /* get */](namespace, params, cb, errorCb);
};

var between = function between(dateFrom, dateTo, department, params, cb, errorCb) {
    params = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, params, { 'filter[between]': dateFrom + ',' + dateTo }, { 'per_page': 50 });
    if (department.uuid) {
        params = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, params, { 'filter[department]': department.name });
    }
    __WEBPACK_IMPORTED_MODULE_1__HttpService__["a" /* get */](namespace, params, cb, errorCb);
};

var update = function update(params, cb, errorCb) {
    __WEBPACK_IMPORTED_MODULE_1__HttpService__["b" /* post */](namespace + '/update', params, cb, errorCb);
};

var claims = function claims(params, cb, errorCb) {
    __WEBPACK_IMPORTED_MODULE_1__HttpService__["a" /* get */](namespace, params, cb, errorCb);
};



/***/ }),
/* 12 */,
/* 13 */,
/* 14 */,
/* 15 */,
/* 16 */,
/* 17 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__services_projectService_js__ = __webpack_require__(11);



/* harmony default export */ __webpack_exports__["a"] = ({
    getData: function getData() {
        var _this = this;

        var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : { 'dateInterval': true };

        return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
            if (!_this.$store.state.config.loaded) return;
            _this.rows = [];
            _this.loading = true;
            if (options.dateInterval === true) {
                __WEBPACK_IMPORTED_MODULE_1__services_projectService_js__["d" /* between */](_this.$store.getters.getStartDate, _this.$store.getters.getEndDate, _this.$store.getters.getCurrentDepartment, _this.params, function (response) {
                    _this.rows = response.data;
                    _this.loading = false;
                    _this.$emit('finishedLoading', _this.rows.length);
                    resolve(response.data);
                }, function (err) {
                    reject(err);
                });
            } else {
                __WEBPACK_IMPORTED_MODULE_1__services_projectService_js__["a" /* find */](_this.params, function (response) {
                    _this.rows = response.data;
                    _this.loading = false;
                    _this.$emit('finishedLoading', _this.rows.length);
                    resolve(response.data);
                }, function (err) {
                    reject(err);
                });
            }
        });
    },
    searchOptions: {
        enabled: true,
        trigger: 'enter',
        placeholder: 'Søg og tryk enter ...',
        skipDiacritics: true
    },
    paginationOptions: {
        enabled: true,
        perPage: 30,
        rowsPerPageLabel: 'Rækker pr. side',
        allLabel: 'Alle',
        nextLabel: 'Næste',
        prevLabel: 'Forrige',
        ofLabel: 'af',
        pageLabel: 'side'
    },
    sortOptions: {
        enabled: true
    }
});

/***/ }),
/* 18 */,
/* 19 */,
/* 20 */,
/* 21 */,
/* 22 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return findAll; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return update; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return skills; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return revenue; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return compareResponsibleEmployees; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return compareResponsibleEmployeesProjectTypes; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__HttpService__ = __webpack_require__(5);


var namespace = 'employees';

var findAll = function findAll(params, cb, errorCb) {
    __WEBPACK_IMPORTED_MODULE_0__HttpService__["a" /* get */](namespace, params, cb, errorCb);
};

var update = function update(uuid, body, cb, errorCb) {
    __WEBPACK_IMPORTED_MODULE_0__HttpService__["e" /* put */](namespace + '/' + uuid, body, cb, errorCb);
};

var skills = function skills(uuid, params, cb, errorCb) {
    __WEBPACK_IMPORTED_MODULE_0__HttpService__["a" /* get */](namespace + '/' + uuid + '/skill', params, cb, errorCb);
};

var revenue = function revenue(params, cb, errorCb) {
    __WEBPACK_IMPORTED_MODULE_0__HttpService__["a" /* get */](namespace + '/revenue', params, cb, errorCb);
};

var compareResponsibleEmployees = function compareResponsibleEmployees(params, cb, errorCb) {
    __WEBPACK_IMPORTED_MODULE_0__HttpService__["a" /* get */](namespace + '/compare/responsible', params, cb, errorCb);
};

var compareResponsibleEmployeesProjectTypes = function compareResponsibleEmployeesProjectTypes(params, cb, errorCb) {
    __WEBPACK_IMPORTED_MODULE_0__HttpService__["a" /* get */](namespace + '/compare/responsible-project-types', params, cb, errorCb);
};



/***/ }),
/* 23 */,
/* 24 */,
/* 25 */,
/* 26 */,
/* 27 */,
/* 28 */,
/* 29 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return find; });
/* unused harmony export findAll */
/* unused harmony export ebitda */
/* unused harmony export create */
/* unused harmony export remove */
/* unused harmony export update */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return valueChain; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return projectTypesPotential; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__HttpService__ = __webpack_require__(5);


var namespace = 'calculations';

var find = function find(id, options, cb, errorCb) {
    __WEBPACK_IMPORTED_MODULE_0__HttpService__["a" /* get */](namespace + '/' + id, options, cb, errorCb);
};

var findAll = function findAll(params, cb, errorCb) {
    __WEBPACK_IMPORTED_MODULE_0__HttpService__["a" /* get */](namespace, params, cb, errorCb);
};

var ebitda = function ebitda(companyId, params, cb, errorCb) {
    __WEBPACK_IMPORTED_MODULE_0__HttpService__["a" /* get */](namespace + '/' + companyId + '/ebitda', params, cb, errorCb);
};

var create = function create(body, cb, errorCb) {
    __WEBPACK_IMPORTED_MODULE_0__HttpService__["b" /* post */](namespace, body, cb, errorCb);
};

var remove = function remove(id, cb, errorCb) {
    __WEBPACK_IMPORTED_MODULE_0__HttpService__["d" /* remove */](namespace + '/' + id, cb, errorCb);
};

var update = function update(id, body, cb, errorCb) {
    __WEBPACK_IMPORTED_MODULE_0__HttpService__["e" /* put */](namespace + '/' + id, body, cb, errorCb);
};

var valueChain = function valueChain(params, cb, errorCb) {
    __WEBPACK_IMPORTED_MODULE_0__HttpService__["a" /* get */](namespace + '/value-chain', params, cb, errorCb);
};

var projectTypesPotential = function projectTypesPotential(params, cb, errorCb) {
    __WEBPACK_IMPORTED_MODULE_0__HttpService__["a" /* get */](namespace + '/potential/project-types', params, cb, errorCb);
};



/***/ }),
/* 30 */,
/* 31 */,
/* 32 */,
/* 33 */,
/* 34 */,
/* 35 */,
/* 36 */,
/* 37 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return findAll; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return change; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return budgetCalc; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return updateBudgetCalc; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return employeeCalc; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return updateEmployeeCalc; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__HttpService__ = __webpack_require__(5);


var namespace = 'companies';

var findAll = function findAll(options, cb, errorCb) {
    __WEBPACK_IMPORTED_MODULE_0__HttpService__["a" /* get */](namespace, options, cb, errorCb);
};

var budgetCalc = function budgetCalc(options, cb, errorCb) {
    __WEBPACK_IMPORTED_MODULE_0__HttpService__["a" /* get */]('company/budget', options, cb, errorCb);
};

var updateBudgetCalc = function updateBudgetCalc(body, cb, errorCb) {
    __WEBPACK_IMPORTED_MODULE_0__HttpService__["b" /* post */]('company/budget', body, cb, errorCb);
};

var employeeCalc = function employeeCalc(options, cb, errorCb) {
    __WEBPACK_IMPORTED_MODULE_0__HttpService__["a" /* get */]('company/employee-calc', options, cb, errorCb);
};

var updateEmployeeCalc = function updateEmployeeCalc(body, cb, errorCb) {
    __WEBPACK_IMPORTED_MODULE_0__HttpService__["b" /* post */]('company/employee-calc', body, cb, errorCb);
};

var change = function change(body, cb, errorCb) {
    __WEBPACK_IMPORTED_MODULE_0__HttpService__["b" /* post */]('change-company', body, cb, errorCb);
};



/***/ }),
/* 38 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return find; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return all; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return unpaid; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return between; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__HttpService__ = __webpack_require__(5);



var namespace = '/invoices';

var find = function find(params, cb, errorCb) {
    __WEBPACK_IMPORTED_MODULE_1__HttpService__["a" /* get */](namespace, params, cb, errorCb);
};

var all = function all(params, cb, errorCb) {
    __WEBPACK_IMPORTED_MODULE_1__HttpService__["a" /* get */]('all-invoices', params, cb, errorCb);
};

var unpaid = function unpaid(params, cb, errorCb) {
    __WEBPACK_IMPORTED_MODULE_1__HttpService__["a" /* get */]('unpaid-invoices', params, cb, errorCb);
};

var between = function between(dateFrom, dateTo, department, params, cb, errorCb) {
    params = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, params, { 'filter[between]': dateFrom + ',' + dateTo }, { 'per_page': 50 });
    if (department.uuid) {
        params = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, params, { 'filter[department]': department.name });
    }
    __WEBPACK_IMPORTED_MODULE_1__HttpService__["a" /* get */](namespace, params, cb, errorCb);
};



/***/ }),
/* 39 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export all */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return projectTypes; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return main; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return employees; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return subProjectTypes; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__HttpService__ = __webpack_require__(5);


var namespace = 'enterprise/main-projects';

var all = function all(params, cb, errorCb) {
    __WEBPACK_IMPORTED_MODULE_0__HttpService__["a" /* get */](namespace, params, cb, errorCb);
};

var projectTypes = function projectTypes(params, cb, errorCb) {
    __WEBPACK_IMPORTED_MODULE_0__HttpService__["a" /* get */](namespace + '/types', params, cb, errorCb);
};

var main = function main(params, cb, errorCb) {
    __WEBPACK_IMPORTED_MODULE_0__HttpService__["a" /* get */](namespace + '/list', params, cb, errorCb);
};

var employees = function employees(params, cb, errorCb) {
    __WEBPACK_IMPORTED_MODULE_0__HttpService__["a" /* get */]('enterprise/employees', params, cb, errorCb);
};

var subProjectTypes = function subProjectTypes(params, cb, errorCb) {
    __WEBPACK_IMPORTED_MODULE_0__HttpService__["a" /* get */]('enterprise/sub-project-types', params, cb, errorCb);
};



/***/ }),
/* 40 */,
/* 41 */,
/* 42 */,
/* 43 */,
/* 44 */,
/* 45 */,
/* 46 */,
/* 47 */,
/* 48 */,
/* 49 */,
/* 50 */,
/* 51 */,
/* 52 */,
/* 53 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__services_invoiceService_js__ = __webpack_require__(38);



/* harmony default export */ __webpack_exports__["a"] = ({
    getData: function getData() {
        var _this = this;

        var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : { 'dateInterval': true };

        return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
            if (!_this.$store.state.config.loaded) return;
            _this.rows = [];
            _this.loading = true;
            if (options.dateInterval === true) {
                __WEBPACK_IMPORTED_MODULE_1__services_invoiceService_js__["b" /* between */](_this.$store.getters.getStartDate, _this.$store.getters.getEndDate, _this.$store.getters.getCurrentDepartment, _this.params, function (response) {
                    _this.rows = response.data;
                    _this.loading = false;
                    _this.$emit('finishedLoading', _this.rows.length);
                    resolve(response.data);
                }, function (err) {
                    reject(err);
                });
            } else {
                __WEBPACK_IMPORTED_MODULE_1__services_invoiceService_js__["c" /* find */](_this.params, function (response) {
                    _this.rows = response.data;
                    _this.loading = false;
                    _this.$emit('finishedLoading', _this.rows.length);
                    resolve(response.data);
                }, function (err) {
                    reject(err);
                });
            }
        });
    },
    searchOptions: {
        enabled: true,
        trigger: 'enter',
        placeholder: 'Søg og tryk enter ...',
        skipDiacritics: true
    },
    paginationOptions: {
        enabled: true,
        perPage: 30,
        rowsPerPageLabel: 'Rækker pr. side',
        allLabel: 'Alle',
        nextLabel: 'Næste',
        prevLabel: 'Forrige',
        ofLabel: 'af',
        pageLabel: 'side'
    },
    sortOptions: {
        enabled: true
    }
});

/***/ }),
/* 54 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return development; });
/* unused harmony export findAll */
/* unused harmony export skills */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return projectTypeSkills; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return coveragePerHour; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__HttpService__ = __webpack_require__(5);


var namespace = 'project-types';

var development = function development(params, cb, errorCb) {
    __WEBPACK_IMPORTED_MODULE_0__HttpService__["a" /* get */](namespace + '/development', params, cb, errorCb);
};

var findAll = function findAll(params, cb, errorCb) {
    __WEBPACK_IMPORTED_MODULE_0__HttpService__["a" /* get */](namespace, params, cb, errorCb);
};

var skills = function skills(uuid, params, cb, errorCb) {
    __WEBPACK_IMPORTED_MODULE_0__HttpService__["a" /* get */](namespace + '/' + uuid + '/main-employees', params, cb, errorCb);
};

var projectTypeSkills = function projectTypeSkills(params, cb, errorCb) {
    __WEBPACK_IMPORTED_MODULE_0__HttpService__["a" /* get */]('project-types-skills', params, cb, errorCb);
};

var coveragePerHour = function coveragePerHour(params, cb, errorCb) {
    __WEBPACK_IMPORTED_MODULE_0__HttpService__["a" /* get */](namespace + '/coverage-per-hour', params, cb, errorCb);
};



/***/ }),
/* 55 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return all; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return skills; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return employees; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__HttpService__ = __webpack_require__(5);


var namespace = 'calculations/time-usage';

var all = function all(params, cb, errorCb) {
    __WEBPACK_IMPORTED_MODULE_0__HttpService__["a" /* get */](namespace, params, cb, errorCb);
};

var skills = function skills(params, cb, errorCb) {
    __WEBPACK_IMPORTED_MODULE_0__HttpService__["a" /* get */](namespace + '/skills', params, cb, errorCb);
};

var employees = function employees(params, cb, errorCb) {
    __WEBPACK_IMPORTED_MODULE_0__HttpService__["a" /* get */]('time-usage/employees', params, cb, errorCb);
};



/***/ }),
/* 56 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return all; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return create; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return update; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return remove; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return forgotPassword; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__HttpService__ = __webpack_require__(5);


var namespace = 'users';

var all = function all(params, cb, errorCb) {
    __WEBPACK_IMPORTED_MODULE_0__HttpService__["a" /* get */](namespace, params, cb, errorCb);
};

var create = function create(body, cb, errorCb) {
    __WEBPACK_IMPORTED_MODULE_0__HttpService__["b" /* post */](namespace, body, cb, errorCb);
};

var update = function update(uuid, body, cb, errorCb) {
    __WEBPACK_IMPORTED_MODULE_0__HttpService__["c" /* patch */](namespace + '/' + uuid, body, cb, errorCb);
};

var remove = function remove(uuid, cb, errorCb) {
    __WEBPACK_IMPORTED_MODULE_0__HttpService__["d" /* remove */](namespace + '/' + uuid, cb, errorCb);
};

var forgotPassword = function forgotPassword(params, cb, errorCb) {
    __WEBPACK_IMPORTED_MODULE_0__HttpService__["a" /* get */]('forgot-password', params, cb, errorCb);
};



/***/ }),
/* 57 */,
/* 58 */,
/* 59 */,
/* 60 */,
/* 61 */,
/* 62 */,
/* 63 */,
/* 64 */,
/* 65 */,
/* 66 */,
/* 67 */,
/* 68 */,
/* 69 */,
/* 70 */,
/* 71 */,
/* 72 */,
/* 73 */,
/* 74 */,
/* 75 */,
/* 76 */,
/* 77 */,
/* 78 */,
/* 79 */,
/* 80 */,
/* 81 */,
/* 82 */,
/* 83 */,
/* 84 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(94);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(953);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__services_configService__ = __webpack_require__(348);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash__ = __webpack_require__(80);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_lodash__);







__WEBPACK_IMPORTED_MODULE_1_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* default */]);

var allDepartments = {
    uuid: 0,
    name: 'Virksomheden'
};

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* default */].Store({
    state: {
        config: {
            companyMeta: {},
            availableAccountingYears: [],
            availableDepartments: [allDepartments],
            currentDepartment: allDepartments,
            startDate: 'Jan 1, 2019 00:00:00',
            endDate: new Date(),
            loaded: false
        },
        view: 'drift',
        efficiencyData: {},
        closedRows: [],
        customerRevenueRows: [],

        graphColors: ['#1e807c', '#7aa8d4', '#c53e4a', '#e8c531', '#91c891', '#246ab2', '#7a215c', '#e75645', '#c8a146', '#cccccc', '#000000']
    },
    getters: {
        groupedProjects: function groupedProjects(state) {
            if (state.closedRows.length) {
                return __WEBPACK_IMPORTED_MODULE_5_lodash___default.a.groupBy(state.closedRows, function (project) {
                    return project.type ? project.type.name : 'Ingen type';
                });
            }
            return null;
        },
        getStartDate: function getStartDate(state) {
            return __WEBPACK_IMPORTED_MODULE_3_moment___default()(state.config.startDate).format('YYYY-MM-DD');
        },
        getEndDate: function getEndDate(state) {
            return __WEBPACK_IMPORTED_MODULE_3_moment___default()(state.config.endDate).format('YYYY-MM-DD');
        },
        getAvailableDepartments: function getAvailableDepartments(state) {
            return state.config.availableDepartments;
        },
        getCurrentDepartment: function getCurrentDepartment(state) {
            return state.config.currentDepartment;
        },
        getCurrentAccountingYear: function getCurrentAccountingYear(state) {
            return state.config.availableAccountingYears[0];
        }
    },
    actions: {
        getConfig: function getConfig(context) {
            __WEBPACK_IMPORTED_MODULE_4__services_configService__["a" /* get */]({}, function (response) {
                context.commit('setConfig', response.data);
                context.dispatch('setDatesPreset', 'currentAccountingYear');
            });
        },

        setDatesPreset: function setDatesPreset(context, preset) {
            var date = new Date();
            var startDate = null;var endDate = null;
            switch (preset) {
                case 'currentAccountingYear':
                    startDate = context.state.config.availableAccountingYears[0].from_date;
                    endDate = context.state.config.availableAccountingYears[0].to_date;
                    break;
                case 'currentWeek':
                    var first = date.getDate() - date.getDay() + 1;
                    var last = first + 6;
                    startDate = new Date(date.setDate(first));
                    endDate = new Date(date.setDate(last));
                    break;
                case 'currentMonth':
                    startDate = new Date(date.getFullYear(), date.getMonth(), 1);
                    endDate = new Date(date.getFullYear(), date.getMonth() + 1, 0);
                    break;
                default:
                    console.log('fejl i setDatesPreset: ' + preset + ' eksisterer ikke');
            }
            context.commit('setDates', { startDate: startDate, endDate: endDate });
        }
    },
    mutations: {
        setCurrentDepartment: function setCurrentDepartment(state, department) {
            state.config.currentDepartment = department;
        },
        resetCurrentDepartment: function resetCurrentDepartment(state) {
            state.config.currentDepartment = allDepartments;
        },
        setConfig: function setConfig(state, config) {
            state.config.lastSynced = config.last_sync;
            state.config.availableAccountingYears = config.accounting_years.reverse();
            state.config.availableDepartments = [allDepartments].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(config.departments));
            state.config.companyMeta = config.company;
            state.config.loaded = true;
        },
        setDates: function setDates(state, dates) {
            state.config.startDate = dates.startDate;
            state.config.endDate = dates.endDate;
        },
        setClosedRows: function setClosedRows(state, rows) {
            state.closedRows = rows;
        },
        setCustomerRevenueRows: function setCustomerRevenueRows(state, rows) {
            state.customerRevenueRows = rows;
        }
    }
}));

/***/ }),
/* 85 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(946)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(433),
  /* template */
  __webpack_require__(886),
  /* scopeId */
  "data-v-d8e10d84",
  /* cssModules */
  null
)
Component.options.__file = "/opt/build/repo/src/pages/login/login.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key !== "__esModule"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] login.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-d8e10d84", Component.options)
  } else {
    hotAPI.reload("data-v-d8e10d84", Component.options)
  }
})()}

module.exports = Component.exports


/***/ }),
/* 86 */,
/* 87 */,
/* 88 */,
/* 89 */,
/* 90 */,
/* 91 */,
/* 92 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export customerRevenue */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return customerActivity; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return customerCategoryActivity; });
/* unused harmony export typeRevenue */
/* unused harmony export customerRevenueSingle */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__HttpService__ = __webpack_require__(5);


var namespace = 'customers';

var customerRevenue = function customerRevenue(params, cb, errorCb) {
    __WEBPACK_IMPORTED_MODULE_0__HttpService__["a" /* get */](namespace, params, cb, errorCb);
};

var customerActivity = function customerActivity(params, cb, errorCb) {
    __WEBPACK_IMPORTED_MODULE_0__HttpService__["a" /* get */]('customer-activity', params, cb, errorCb);
};

var customerCategoryActivity = function customerCategoryActivity(params, cb, errorCb) {
    __WEBPACK_IMPORTED_MODULE_0__HttpService__["a" /* get */]('customer-category-activity', params, cb, errorCb);
};

var typeRevenue = function typeRevenue(params, cb, errorCb) {
    __WEBPACK_IMPORTED_MODULE_0__HttpService__["a" /* get */]('customer-categories', params, cb, errorCb);
};

var customerRevenueSingle = function customerRevenueSingle(uuid, params, cb, errorCb) {
    __WEBPACK_IMPORTED_MODULE_0__HttpService__["a" /* get */](namespace + '/' + uuid, params, cb, errorCb);
};



/***/ }),
/* 93 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return cleanup; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return update; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__HttpService__ = __webpack_require__(5);


var namespace = 'settings';

var cleanup = function cleanup(params, cb, errorCb) {
    __WEBPACK_IMPORTED_MODULE_0__HttpService__["a" /* get */](namespace + '/cleanup', params, cb, errorCb);
};

var update = function update(body, cb, errorCb) {
    __WEBPACK_IMPORTED_MODULE_0__HttpService__["b" /* post */]('company/settings', body, cb, errorCb);
};



/***/ }),
/* 94 */,
/* 95 */,
/* 96 */,
/* 97 */,
/* 98 */,
/* 99 */,
/* 100 */,
/* 101 */,
/* 102 */,
/* 103 */,
/* 104 */,
/* 105 */,
/* 106 */,
/* 107 */,
/* 108 */,
/* 109 */,
/* 110 */,
/* 111 */,
/* 112 */,
/* 113 */,
/* 114 */,
/* 115 */,
/* 116 */,
/* 117 */,
/* 118 */,
/* 119 */,
/* 120 */,
/* 121 */,
/* 122 */,
/* 123 */,
/* 124 */,
/* 125 */,
/* 126 */,
/* 127 */,
/* 128 */,
/* 129 */,
/* 130 */,
/* 131 */,
/* 132 */,
/* 133 */,
/* 134 */,
/* 135 */,
/* 136 */,
/* 137 */,
/* 138 */,
/* 139 */,
/* 140 */,
/* 141 */,
/* 142 */,
/* 143 */,
/* 144 */,
/* 145 */,
/* 146 */,
/* 147 */,
/* 148 */,
/* 149 */,
/* 150 */,
/* 151 */,
/* 152 */,
/* 153 */,
/* 154 */,
/* 155 */,
/* 156 */,
/* 157 */,
/* 158 */,
/* 159 */,
/* 160 */,
/* 161 */,
/* 162 */,
/* 163 */,
/* 164 */,
/* 165 */,
/* 166 */,
/* 167 */,
/* 168 */,
/* 169 */,
/* 170 */,
/* 171 */,
/* 172 */,
/* 173 */,
/* 174 */,
/* 175 */,
/* 176 */,
/* 177 */,
/* 178 */,
/* 179 */,
/* 180 */,
/* 181 */,
/* 182 */,
/* 183 */,
/* 184 */,
/* 185 */,
/* 186 */,
/* 187 */,
/* 188 */,
/* 189 */,
/* 190 */,
/* 191 */,
/* 192 */,
/* 193 */,
/* 194 */,
/* 195 */,
/* 196 */,
/* 197 */,
/* 198 */,
/* 199 */,
/* 200 */,
/* 201 */,
/* 202 */,
/* 203 */,
/* 204 */,
/* 205 */,
/* 206 */,
/* 207 */,
/* 208 */,
/* 209 */,
/* 210 */,
/* 211 */,
/* 212 */,
/* 213 */,
/* 214 */,
/* 215 */,
/* 216 */,
/* 217 */,
/* 218 */,
/* 219 */,
/* 220 */,
/* 221 */,
/* 222 */,
/* 223 */,
/* 224 */,
/* 225 */,
/* 226 */,
/* 227 */,
/* 228 */,
/* 229 */,
/* 230 */,
/* 231 */,
/* 232 */,
/* 233 */,
/* 234 */,
/* 235 */,
/* 236 */,
/* 237 */,
/* 238 */,
/* 239 */,
/* 240 */,
/* 241 */,
/* 242 */,
/* 243 */,
/* 244 */,
/* 245 */,
/* 246 */,
/* 247 */,
/* 248 */,
/* 249 */,
/* 250 */,
/* 251 */,
/* 252 */,
/* 253 */,
/* 254 */,
/* 255 */,
/* 256 */,
/* 257 */,
/* 258 */,
/* 259 */,
/* 260 */,
/* 261 */,
/* 262 */,
/* 263 */,
/* 264 */,
/* 265 */,
/* 266 */,
/* 267 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(917)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(413),
  /* template */
  __webpack_require__(810),
  /* scopeId */
  "data-v-2f6d19d5",
  /* cssModules */
  null
)
Component.options.__file = "/opt/build/repo/src/pages/employees/learning/components/pie.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key !== "__esModule"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] pie.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-2f6d19d5", Component.options)
  } else {
    hotAPI.reload("data-v-2f6d19d5", Component.options)
  }
})()}

module.exports = Component.exports


/***/ }),
/* 268 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(421),
  /* template */
  __webpack_require__(783),
  /* scopeId */
  null,
  /* cssModules */
  null
)
Component.options.__file = "/opt/build/repo/src/pages/employees/operations/claims.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key !== "__esModule"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] claims.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-0f6346ab", Component.options)
  } else {
    hotAPI.reload("data-v-0f6346ab", Component.options)
  }
})()}

module.exports = Component.exports


/***/ }),
/* 269 */,
/* 270 */,
/* 271 */,
/* 272 */,
/* 273 */,
/* 274 */
/***/ (function(module, exports, __webpack_require__) {


module.exports = {

    request: function request(req, token) {
        var API_URL = "https://demoapi.proebitda.dk/v1";
        var authLoginUrl = API_URL + '/login';
        var resetLoginUrl = API_URL + '/password/reset';

        if (req.url === authLoginUrl || req.url === resetLoginUrl) {
            localStorage.removeItem('user-token');
            this.options.http._setHeaders.call(this, req, { Authorization: '' });
        } else {
            this.options.http._setHeaders.call(this, req, { Authorization: 'Bearer ' + token });
        }
    },

    response: function response(res) {
        var token = res.data.access_token;

        if (token) {
            token = token.split(/Bearer\:?\s?/i);

            return token[token.length > 1 ? 1 : 0].trim();
        }
    }
};

/***/ }),
/* 275 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(329);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_axios___default.a.create({
    baseURL: "https://demoapi.proebitda.dk/v1",
    headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json'
    }
}));

/***/ }),
/* 276 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(898);



__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  mode: 'history',
  scrollBehavior: function scrollBehavior() {
    return { y: 0 };
  },
  routes: [{
    path: '/404',
    name: '404',
    redirect: '/',
    component: __webpack_require__(689)
  }, {
    path: '*',
    redirect: '/'
  }, {
    path: '/',
    name: 'Index',
    component: __webpack_require__(742),
    meta: {
      auth: true
    }
  }, {
    path: '/oekonomi',
    name: 'Economy',
    component: __webpack_require__(710),
    meta: {
      auth: true
    },
    children: [{
      path: 'drift',
      name: 'EconomyOperations',
      component: __webpack_require__(718)
    }, {
      path: 'oekonomi',
      name: 'EconomyLearning',
      component: __webpack_require__(711)
    }]
  }, {
    path: '/kunder',
    name: 'Customers',
    component: __webpack_require__(691),
    meta: {
      auth: true
    },
    children: [{
      path: 'drift',
      name: 'CustomersOperations',
      component: __webpack_require__(693)
    }, {
      path: 'udvikling-og-laering',
      name: 'CustomersLearning',
      component: __webpack_require__(692)
    }]
  }, {
    path: '/opgaver',
    name: 'Projects',
    component: __webpack_require__(751),
    meta: {
      auth: true
    },
    children: [{
      path: 'drift',
      name: 'ProjectsOperations',
      component: __webpack_require__(750)
    }, {
      path: 'udvikling-og-laering',
      name: 'ProjectsLearning',
      component: __webpack_require__(749)
    }]
  }, {
    path: '/medarbejdere',
    name: 'Employees',
    component: __webpack_require__(720),
    meta: {
      auth: true
    },
    children: [{
      path: 'drift',
      name: 'EmployeesOperations',
      component: __webpack_require__(731)
    }, {
      path: 'udvikling-og-laering',
      name: 'EmployeesLearning',
      component: __webpack_require__(721)
    }]
  }, {
    path: '/ansvarlige',
    name: 'Responsibles',
    component: __webpack_require__(753),
    meta: {
      auth: true
    }
  }, {
    path: '/potentiale',
    name: 'Potential',
    component: __webpack_require__(744),
    meta: {
      auth: true
    }
  }, {
    path: '/register',
    name: 'Register',
    component: __webpack_require__(752),
    meta: {
      auth: false
    }
  }, {
    path: '/login',
    name: 'Login',
    component: __webpack_require__(85),
    meta: {
      auth: false
    }
  }, {
    path: '/indstillinger',
    name: 'Settings',
    component: __webpack_require__(772),
    meta: {
      auth: true
    }
  }, {
    path: '/entreprise',
    name: 'Enterprise',
    component: __webpack_require__(740),
    meta: {
      auth: true
    }
  }, {
    path: 'skift-virksomhed',
    name: 'ChangeCompany',
    component: __webpack_require__(762),
    meta: {
      auth: true
    }
  }, {
    path: '/super-admin',
    name: 'SuperAdmin',
    component: __webpack_require__(773),
    meta: {
      auth: true
    }
  }, {
    path: '/kommer-snart',
    name: 'ComingSoon',
    component: __webpack_require__(690),
    meta: {
      auth: true
    }
  }]
}));

/***/ }),
/* 277 */,
/* 278 */,
/* 279 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 280 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 281 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 282 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 283 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 284 */,
/* 285 */,
/* 286 */,
/* 287 */,
/* 288 */,
/* 289 */,
/* 290 */,
/* 291 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(923)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(351),
  /* template */
  __webpack_require__(825),
  /* scopeId */
  null,
  /* cssModules */
  null
)
Component.options.__file = "/opt/build/repo/src/App.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key !== "__esModule"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] App.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-427a9fc7", Component.options)
  } else {
    hotAPI.reload("data-v-427a9fc7", Component.options)
  }
})()}

module.exports = Component.exports


/***/ }),
/* 292 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(941)

var Component = __webpack_require__(1)(
  /* script */
  null,
  /* template */
  __webpack_require__(868),
  /* scopeId */
  "data-v-87b029dc",
  /* cssModules */
  null
)
Component.options.__file = "/opt/build/repo/src/components/core/offline.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key !== "__esModule"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] offline.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-87b029dc", Component.options)
  } else {
    hotAPI.reload("data-v-87b029dc", Component.options)
  }
})()}

module.exports = Component.exports


/***/ }),
/* 293 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(943)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(352),
  /* template */
  __webpack_require__(878),
  /* scopeId */
  null,
  /* cssModules */
  null
)
Component.options.__file = "/opt/build/repo/src/components/elements/BoxHelper.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key !== "__esModule"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] BoxHelper.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-b2eeed00", Component.options)
  } else {
    hotAPI.reload("data-v-b2eeed00", Component.options)
  }
})()}

module.exports = Component.exports


/***/ }),
/* 294 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(944)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(353),
  /* template */
  __webpack_require__(882),
  /* scopeId */
  "data-v-c979e24c",
  /* cssModules */
  null
)
Component.options.__file = "/opt/build/repo/src/components/elements/BoxLoading.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key !== "__esModule"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] BoxLoading.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-c979e24c", Component.options)
  } else {
    hotAPI.reload("data-v-c979e24c", Component.options)
  }
})()}

module.exports = Component.exports


/***/ }),
/* 295 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(940)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(354),
  /* template */
  __webpack_require__(867),
  /* scopeId */
  "data-v-804e69b6",
  /* cssModules */
  null
)
Component.options.__file = "/opt/build/repo/src/components/elements/BudgetTooltip.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key !== "__esModule"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] BudgetTooltip.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-804e69b6", Component.options)
  } else {
    hotAPI.reload("data-v-804e69b6", Component.options)
  }
})()}

module.exports = Component.exports


/***/ }),
/* 296 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(926)
__webpack_require__(925)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(356),
  /* template */
  __webpack_require__(827),
  /* scopeId */
  "data-v-46c39325",
  /* cssModules */
  null
)
Component.options.__file = "/opt/build/repo/src/components/elements/GraphCard.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key !== "__esModule"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] GraphCard.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-46c39325", Component.options)
  } else {
    hotAPI.reload("data-v-46c39325", Component.options)
  }
})()}

module.exports = Component.exports


/***/ }),
/* 297 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(913)

var Component = __webpack_require__(1)(
  /* script */
  null,
  /* template */
  __webpack_require__(799),
  /* scopeId */
  "data-v-23bfba74",
  /* cssModules */
  null
)
Component.options.__file = "/opt/build/repo/src/components/elements/NoData.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key !== "__esModule"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] NoData.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-23bfba74", Component.options)
  } else {
    hotAPI.reload("data-v-23bfba74", Component.options)
  }
})()}

module.exports = Component.exports


/***/ }),
/* 298 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(951)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(357),
  /* template */
  __webpack_require__(893),
  /* scopeId */
  "data-v-ee45503c",
  /* cssModules */
  null
)
Component.options.__file = "/opt/build/repo/src/components/elements/NumberCard.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key !== "__esModule"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] NumberCard.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-ee45503c", Component.options)
  } else {
    hotAPI.reload("data-v-ee45503c", Component.options)
  }
})()}

module.exports = Component.exports


/***/ }),
/* 299 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(910)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(358),
  /* template */
  __webpack_require__(797),
  /* scopeId */
  "data-v-22a330da",
  /* cssModules */
  null
)
Component.options.__file = "/opt/build/repo/src/components/elements/ProjectTooltip.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key !== "__esModule"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] ProjectTooltip.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-22a330da", Component.options)
  } else {
    hotAPI.reload("data-v-22a330da", Component.options)
  }
})()}

module.exports = Component.exports


/***/ }),
/* 300 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(900)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(360),
  /* template */
  __webpack_require__(777),
  /* scopeId */
  "data-v-06a459bd",
  /* cssModules */
  null
)
Component.options.__file = "/opt/build/repo/src/components/elements/SummaryCard.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key !== "__esModule"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] SummaryCard.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-06a459bd", Component.options)
  } else {
    hotAPI.reload("data-v-06a459bd", Component.options)
  }
})()}

module.exports = Component.exports


/***/ }),
/* 301 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(920)
__webpack_require__(919)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(361),
  /* template */
  __webpack_require__(812),
  /* scopeId */
  "data-v-30dee4b6",
  /* cssModules */
  null
)
Component.options.__file = "/opt/build/repo/src/components/elements/TableCard.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key !== "__esModule"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] TableCard.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-30dee4b6", Component.options)
  } else {
    hotAPI.reload("data-v-30dee4b6", Component.options)
  }
})()}

module.exports = Component.exports


/***/ }),
/* 302 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(909)

var Component = __webpack_require__(1)(
  /* script */
  null,
  /* template */
  __webpack_require__(795),
  /* scopeId */
  "data-v-20fa3fe5",
  /* cssModules */
  null
)
Component.options.__file = "/opt/build/repo/src/components/elements/comingSoon.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key !== "__esModule"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] comingSoon.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-20fa3fe5", Component.options)
  } else {
    hotAPI.reload("data-v-20fa3fe5", Component.options)
  }
})()}

module.exports = Component.exports


/***/ }),
/* 303 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(362),
  /* template */
  __webpack_require__(801),
  /* scopeId */
  null,
  /* cssModules */
  null
)
Component.options.__file = "/opt/build/repo/src/components/elements/contentSwitch.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key !== "__esModule"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] contentSwitch.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-25425858", Component.options)
  } else {
    hotAPI.reload("data-v-25425858", Component.options)
  }
})()}

module.exports = Component.exports


/***/ }),
/* 304 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(932)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(363),
  /* template */
  __webpack_require__(844),
  /* scopeId */
  "data-v-5e3ac208",
  /* cssModules */
  null
)
Component.options.__file = "/opt/build/repo/src/components/elements/dTooltip.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key !== "__esModule"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] dTooltip.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-5e3ac208", Component.options)
  } else {
    hotAPI.reload("data-v-5e3ac208", Component.options)
  }
})()}

module.exports = Component.exports


/***/ }),
/* 305 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(945)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(364),
  /* template */
  __webpack_require__(883),
  /* scopeId */
  "data-v-cd5cc2c2",
  /* cssModules */
  null
)
Component.options.__file = "/opt/build/repo/src/components/elements/title.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key !== "__esModule"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] title.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-cd5cc2c2", Component.options)
  } else {
    hotAPI.reload("data-v-cd5cc2c2", Component.options)
  }
})()}

module.exports = Component.exports


/***/ }),
/* 306 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(938)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(365),
  /* template */
  __webpack_require__(863),
  /* scopeId */
  "data-v-77c8f022",
  /* cssModules */
  null
)
Component.options.__file = "/opt/build/repo/src/components/elements/viewToggle.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key !== "__esModule"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] viewToggle.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-77c8f022", Component.options)
  } else {
    hotAPI.reload("data-v-77c8f022", Component.options)
  }
})()}

module.exports = Component.exports


/***/ }),
/* 307 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(904)
__webpack_require__(903)

var Component = __webpack_require__(1)(
  /* script */
  null,
  /* template */
  __webpack_require__(792),
  /* scopeId */
  "data-v-1bc34b89",
  /* cssModules */
  null
)
Component.options.__file = "/opt/build/repo/src/components/layout/loader.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key !== "__esModule"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] loader.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-1bc34b89", Component.options)
  } else {
    hotAPI.reload("data-v-1bc34b89", Component.options)
  }
})()}

module.exports = Component.exports


/***/ }),
/* 308 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(368),
  /* template */
  __webpack_require__(894),
  /* scopeId */
  null,
  /* cssModules */
  null
)
Component.options.__file = "/opt/build/repo/src/components/tables/invoices/allInvoices.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key !== "__esModule"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] allInvoices.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-f1adc6ce", Component.options)
  } else {
    hotAPI.reload("data-v-f1adc6ce", Component.options)
  }
})()}

module.exports = Component.exports


/***/ }),
/* 309 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(369),
  /* template */
  __webpack_require__(818),
  /* scopeId */
  null,
  /* cssModules */
  null
)
Component.options.__file = "/opt/build/repo/src/components/tables/invoices/exceededPayments.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key !== "__esModule"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] exceededPayments.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-3dffcec4", Component.options)
  } else {
    hotAPI.reload("data-v-3dffcec4", Component.options)
  }
})()}

module.exports = Component.exports


/***/ }),
/* 310 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(370),
  /* template */
  __webpack_require__(871),
  /* scopeId */
  null,
  /* cssModules */
  null
)
Component.options.__file = "/opt/build/repo/src/components/tables/invoices/unpaid.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key !== "__esModule"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] unpaid.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-976ca23a", Component.options)
  } else {
    hotAPI.reload("data-v-976ca23a", Component.options)
  }
})()}

module.exports = Component.exports


/***/ }),
/* 311 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(371),
  /* template */
  __webpack_require__(879),
  /* scopeId */
  null,
  /* cssModules */
  null
)
Component.options.__file = "/opt/build/repo/src/components/tables/projects/claims.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key !== "__esModule"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] claims.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-c22142be", Component.options)
  } else {
    hotAPI.reload("data-v-c22142be", Component.options)
  }
})()}

module.exports = Component.exports


/***/ }),
/* 312 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(372),
  /* template */
  __webpack_require__(833),
  /* scopeId */
  null,
  /* cssModules */
  null
)
Component.options.__file = "/opt/build/repo/src/components/tables/projects/closed.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key !== "__esModule"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] closed.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-4fc3fdd6", Component.options)
  } else {
    hotAPI.reload("data-v-4fc3fdd6", Component.options)
  }
})()}

module.exports = Component.exports


/***/ }),
/* 313 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(373),
  /* template */
  __webpack_require__(820),
  /* scopeId */
  null,
  /* cssModules */
  null
)
Component.options.__file = "/opt/build/repo/src/components/tables/projects/noInvoice.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key !== "__esModule"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] noInvoice.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-3ef7d5b2", Component.options)
  } else {
    hotAPI.reload("data-v-3ef7d5b2", Component.options)
  }
})()}

module.exports = Component.exports


/***/ }),
/* 314 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(374),
  /* template */
  __webpack_require__(822),
  /* scopeId */
  null,
  /* cssModules */
  null
)
Component.options.__file = "/opt/build/repo/src/components/tables/projects/offer.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key !== "__esModule"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] offer.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-408ffce2", Component.options)
  } else {
    hotAPI.reload("data-v-408ffce2", Component.options)
  }
})()}

module.exports = Component.exports


/***/ }),
/* 315 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(375),
  /* template */
  __webpack_require__(813),
  /* scopeId */
  null,
  /* cssModules */
  null
)
Component.options.__file = "/opt/build/repo/src/components/tables/projects/ongoing.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key !== "__esModule"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] ongoing.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-320abf01", Component.options)
  } else {
    hotAPI.reload("data-v-320abf01", Component.options)
  }
})()}

module.exports = Component.exports


/***/ }),
/* 316 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(376),
  /* template */
  __webpack_require__(865),
  /* scopeId */
  null,
  /* cssModules */
  null
)
Component.options.__file = "/opt/build/repo/src/components/tables/projects/open.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key !== "__esModule"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] open.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-7d1a7034", Component.options)
  } else {
    hotAPI.reload("data-v-7d1a7034", Component.options)
  }
})()}

module.exports = Component.exports


/***/ }),
/* 317 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(377),
  /* template */
  __webpack_require__(824),
  /* scopeId */
  null,
  /* cssModules */
  null
)
Component.options.__file = "/opt/build/repo/src/components/tables/projects/showTypeRevenue.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key !== "__esModule"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] showTypeRevenue.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-41336e6a", Component.options)
  } else {
    hotAPI.reload("data-v-41336e6a", Component.options)
  }
})()}

module.exports = Component.exports


/***/ }),
/* 318 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(378),
  /* template */
  __webpack_require__(881),
  /* scopeId */
  null,
  /* cssModules */
  null
)
Component.options.__file = "/opt/build/repo/src/components/tables/projects/snoozed.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key !== "__esModule"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] snoozed.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-c8f5e578", Component.options)
  } else {
    hotAPI.reload("data-v-c8f5e578", Component.options)
  }
})()}

module.exports = Component.exports


/***/ }),
/* 319 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(379),
  /* template */
  __webpack_require__(796),
  /* scopeId */
  null,
  /* cssModules */
  null
)
Component.options.__file = "/opt/build/repo/src/components/tables/projects/typesRevenue.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key !== "__esModule"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] typesRevenue.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-22694666", Component.options)
  } else {
    hotAPI.reload("data-v-22694666", Component.options)
  }
})()}

module.exports = Component.exports


/***/ }),
/* 320 */,
/* 321 */,
/* 322 */,
/* 323 */,
/* 324 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
    close: 'Close',
    dataIterator: {
      pageText: 'Viser {0} - {1} af {2} resultater',
      noResultsText: 'Ingen resultater fundet',
      loadingText: 'Indlæser data...',
    },
    dataTable: {
      itemsPerPageText: 'Rækker per side:',
      ariaLabel: {
        sortDescending: ': Sorteret faldende. Aktivér for at fjerne sortering.',
        sortAscending: ': Sorteret stigende. Aktivér for at sortere faldende.',
        sortNone: ': Ikke sorteret. Aktivér for at sortere stigende.',
      },
      sortBy: 'Sorter efter',
    },
    dataFooter: {
      itemsPerPageText: 'Resultater pr side:',
      itemsPerPageAll: 'Alle',
      nextPage: 'Næste side',
      prevPage: 'Forrige side',
      firstPage: 'Første side',
      lastPage: 'Sidste side',
    },
    datePicker: {
      itemsSelected: '{0} valgt',
    },
    noDataText: 'Ingen data fundet',
    carousel: {
      prev: 'Forrige',
      next: 'Næste',
    },
    calendar: {
      moreEvents: '{0} flere',
    },
    fileInput: {
      counter: '{0} filer',
      counterSize: '{0} filer ({1} total)',
    },
});

/***/ }),
/* 325 */,
/* 326 */,
/* 327 */,
/* 328 */,
/* 329 */,
/* 330 */,
/* 331 */,
/* 332 */,
/* 333 */,
/* 334 */,
/* 335 */,
/* 336 */,
/* 337 */,
/* 338 */,
/* 339 */,
/* 340 */,
/* 341 */,
/* 342 */,
/* 343 */,
/* 344 */,
/* 345 */,
/* 346 */,
/* 347 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_is_integer__ = __webpack_require__(277);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_is_integer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_is_integer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__App__ = __webpack_require__(291);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__App___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__App__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__router__ = __webpack_require__(276);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__axios__ = __webpack_require__(275);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_axios__ = __webpack_require__(287);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vue_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__store__ = __webpack_require__(84);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_moment__ = __webpack_require__(320);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_vue_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_es6_promise_auto__ = __webpack_require__(278);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_es6_promise_auto___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_es6_promise_auto__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_raven_js__ = __webpack_require__(285);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_raven_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_raven_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_raven_js_plugins_vue__ = __webpack_require__(284);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_raven_js_plugins_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_raven_js_plugins_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_vuetify__ = __webpack_require__(322);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_vuetify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_vuetify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_vuetify_dist_vuetify_min_css__ = __webpack_require__(283);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_vuetify_dist_vuetify_min_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_vuetify_dist_vuetify_min_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_material_icons_iconfont_material_icons_css__ = __webpack_require__(280);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_material_icons_iconfont_material_icons_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_material_icons_iconfont_material_icons_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_vue_count_to__ = __webpack_require__(288);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_vue_count_to___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_vue_count_to__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_v_tooltip__ = __webpack_require__(286);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_vuetify_es5_locale_en__ = __webpack_require__(323);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_vuetify_es5_locale_en___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_vuetify_es5_locale_en__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__dk_ts__ = __webpack_require__(324);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__deveodk_vue_seo__ = __webpack_require__(269);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__deveodk_vue_seo___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18__deveodk_vue_seo__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__deveodk_vue_toastr__ = __webpack_require__(270);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__deveodk_vue_toastr___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19__deveodk_vue_toastr__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__deveodk_vue_toastr_dist_deveodk_vue_toastr_css__ = __webpack_require__(279);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__deveodk_vue_toastr_dist_deveodk_vue_toastr_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20__deveodk_vue_toastr_dist_deveodk_vue_toastr_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_vue_good_table__ = __webpack_require__(289);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_vue_good_table_dist_vue_good_table_css__ = __webpack_require__(282);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_vue_good_table_dist_vue_good_table_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_22_vue_good_table_dist_vue_good_table_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_vue_sweetalert2__ = __webpack_require__(321);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24_sweetalert2_dist_sweetalert2_min_css__ = __webpack_require__(281);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24_sweetalert2_dist_sweetalert2_min_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_24_sweetalert2_dist_sweetalert2_min_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25_vue_js_modal__ = __webpack_require__(290);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25_vue_js_modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_25_vue_js_modal__);


















__WEBPACK_IMPORTED_MODULE_1_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_15_v_tooltip__["a" /* default */]);

__WEBPACK_IMPORTED_MODULE_1_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_11_vuetify___default.a);



__WEBPACK_IMPORTED_MODULE_1_vue__["default"].component('count-to', __WEBPACK_IMPORTED_MODULE_14_vue_count_to___default.a);

__WEBPACK_IMPORTED_MODULE_9_raven_js___default.a.addPlugin(__WEBPACK_IMPORTED_MODULE_10_raven_js_plugins_vue___default.a, __WEBPACK_IMPORTED_MODULE_1_vue__["default"]).install();
__WEBPACK_IMPORTED_MODULE_1_vue__["default"].prototype.$raven = __WEBPACK_IMPORTED_MODULE_9_raven_js___default.a;


__WEBPACK_IMPORTED_MODULE_1_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_18__deveodk_vue_seo___default.a);

__WEBPACK_IMPORTED_MODULE_1_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_5_vue_axios___default.a, __WEBPACK_IMPORTED_MODULE_4__axios__["a" /* default */]);



__WEBPACK_IMPORTED_MODULE_1_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_19__deveodk_vue_toastr___default.a, {
    defaultPosition: 'toast-bottom-right',
    defaultType: 'info',
    defaultTimeout: 5000
});



__WEBPACK_IMPORTED_MODULE_1_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_21_vue_good_table__["a" /* default */]);



__WEBPACK_IMPORTED_MODULE_1_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_23_vue_sweetalert2__["a" /* default */]);


__WEBPACK_IMPORTED_MODULE_1_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_25_vue_js_modal___default.a);

__WEBPACK_IMPORTED_MODULE_1_vue__["default"].component('box-helper', __webpack_require__(293));
__WEBPACK_IMPORTED_MODULE_1_vue__["default"].component('no-data', __webpack_require__(297));
__WEBPACK_IMPORTED_MODULE_1_vue__["default"].component('box-loading', __webpack_require__(294));
__WEBPACK_IMPORTED_MODULE_1_vue__["default"].component('offline', __webpack_require__(292));
__WEBPACK_IMPORTED_MODULE_1_vue__["default"].component('loader', __webpack_require__(307));
__WEBPACK_IMPORTED_MODULE_1_vue__["default"].component('title-block', __webpack_require__(305));
__WEBPACK_IMPORTED_MODULE_1_vue__["default"].component('summary-card', __webpack_require__(300));
__WEBPACK_IMPORTED_MODULE_1_vue__["default"].component('number-card', __webpack_require__(298));
__WEBPACK_IMPORTED_MODULE_1_vue__["default"].component('login', __webpack_require__(85));
__WEBPACK_IMPORTED_MODULE_1_vue__["default"].component('table-card', __webpack_require__(301));
__WEBPACK_IMPORTED_MODULE_1_vue__["default"].component('graph-card', __webpack_require__(296));
__WEBPACK_IMPORTED_MODULE_1_vue__["default"].component('projectTypeRevenue-table', __webpack_require__(319));
__WEBPACK_IMPORTED_MODULE_1_vue__["default"].component('showTypeRevenue-table', __webpack_require__(317));
__WEBPACK_IMPORTED_MODULE_1_vue__["default"].component('closedProjects-table', __webpack_require__(312));
__WEBPACK_IMPORTED_MODULE_1_vue__["default"].component('offerProjects-table', __webpack_require__(314));
__WEBPACK_IMPORTED_MODULE_1_vue__["default"].component('ongoingProjects-table', __webpack_require__(315));
__WEBPACK_IMPORTED_MODULE_1_vue__["default"].component('snoozedProjects-table', __webpack_require__(318));
__WEBPACK_IMPORTED_MODULE_1_vue__["default"].component('claimsProjects-table', __webpack_require__(311));
__WEBPACK_IMPORTED_MODULE_1_vue__["default"].component('openProjects-table', __webpack_require__(316));
__WEBPACK_IMPORTED_MODULE_1_vue__["default"].component('noInvoiceProjects-table', __webpack_require__(313));
__WEBPACK_IMPORTED_MODULE_1_vue__["default"].component('unpaidInvoices-table', __webpack_require__(310));
__WEBPACK_IMPORTED_MODULE_1_vue__["default"].component('view-toggle', __webpack_require__(306));
__WEBPACK_IMPORTED_MODULE_1_vue__["default"].component('coming-soon', __webpack_require__(302));
__WEBPACK_IMPORTED_MODULE_1_vue__["default"].component('content-switch', __webpack_require__(303));
__WEBPACK_IMPORTED_MODULE_1_vue__["default"].component('exceededPayments-table', __webpack_require__(309));
__WEBPACK_IMPORTED_MODULE_1_vue__["default"].component('d-tooltip', __webpack_require__(304));
__WEBPACK_IMPORTED_MODULE_1_vue__["default"].component('budget-tooltip', __webpack_require__(295));
__WEBPACK_IMPORTED_MODULE_1_vue__["default"].component('project-tooltip', __webpack_require__(299));
__WEBPACK_IMPORTED_MODULE_1_vue__["default"].component('all-invoices', __webpack_require__(308));

__WEBPACK_IMPORTED_MODULE_1_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_7_vue_moment___default.a);
__webpack_require__(51);

__WEBPACK_IMPORTED_MODULE_1_vue__["default"].filter('truncate', function (input) {
    if (input.length > 50) {
        return input.slice(0, 50) + ' ...';
    } else {
        return input.slice(0, 50);
    }
});

__WEBPACK_IMPORTED_MODULE_1_vue__["default"].filter('currency', function (input) {
    if (!input) {
        return '0 kr.';
    }
    input = Math.round(input);
    return input.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.') + ' kr.';
});

__WEBPACK_IMPORTED_MODULE_1_vue__["default"].filter('realCurrency', function (input) {
    if (!input) {
        return 0 + ' kr.';
    }
    input = Math.round(input);
    return input.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.') + ' kr.';
});

__WEBPACK_IMPORTED_MODULE_1_vue__["default"].filter('number', function (input) {
    if (!input) {
        return '-';
    }
    input = Math.round(input);
    return input.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.');
});

__WEBPACK_IMPORTED_MODULE_1_vue__["default"].filter('realNumber', function (input) {
    if (!input) {
        return 0;
    }
    input = Number(input);
    if (!__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_is_integer___default()(input)) {
        input = input.toFixed(2);
    }

    return input;
});

__WEBPACK_IMPORTED_MODULE_1_vue__["default"].filter('numberWithDecimals', function (input) {
    if (!input) {
        return '-';
    }

    input = Number(input).toFixed(2);
    return input.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.');
});

__WEBPACK_IMPORTED_MODULE_1_vue__["default"].filter('rounded', function (input) {
    if (!input) {
        return 0;
    }
    return Math.round(input);
});

__WEBPACK_IMPORTED_MODULE_1_vue__["default"].config.productionTip = false;

__WEBPACK_IMPORTED_MODULE_1_vue__["default"].router = __WEBPACK_IMPORTED_MODULE_3__router__["a" /* default */];

__WEBPACK_IMPORTED_MODULE_1_vue__["default"].use(__webpack_require__(273), {
    auth: __webpack_require__(274),
    http: __webpack_require__(271),
    router: __webpack_require__(272),
    parseUserData: function parseUserData(data) {
        return data;
    },
    authRedirect: { path: '/login' },
    refreshData: { enabled: false },
    loginData: { url: '/login' },
    logoutData: { url: '/logout', method: 'GET' },
    fetchData: { url: "https://demoapi.proebitda.dk/v1" + '/me' }
});

new __WEBPACK_IMPORTED_MODULE_1_vue__["default"]({
    el: '#app',
    vuetify: new __WEBPACK_IMPORTED_MODULE_11_vuetify___default.a({
        icons: {
            iconfont: 'md'
        },
        lang: {
            locales: { en: __WEBPACK_IMPORTED_MODULE_16_vuetify_es5_locale_en___default.a, dk: __WEBPACK_IMPORTED_MODULE_17__dk_ts__["a" /* default */] },
            current: 'dk'
        }
    }),
    store: __WEBPACK_IMPORTED_MODULE_6__store__["a" /* default */],
    router: __WEBPACK_IMPORTED_MODULE_3__router__["a" /* default */],
    template: '<App/>',
    components: { App: __WEBPACK_IMPORTED_MODULE_2__App___default.a }
});

/***/ }),
/* 348 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return get; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__HttpService__ = __webpack_require__(5);


var namespace = 'company';

var get = function get(options, cb, errorCb) {
    __WEBPACK_IMPORTED_MODULE_0__HttpService__["a" /* get */](namespace + '/config', options, cb, errorCb);
};

/***/ }),
/* 349 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return findAll; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return statusTypes; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return update; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__HttpService__ = __webpack_require__(5);


var namespace = 'project-statuses';

var findAll = function findAll(params, cb, errorCb) {
    __WEBPACK_IMPORTED_MODULE_0__HttpService__["a" /* get */](namespace, params, cb, errorCb);
};

var statusTypes = function statusTypes(params, cb, errorCb) {
    __WEBPACK_IMPORTED_MODULE_0__HttpService__["a" /* get */]('status-types', params, cb, errorCb);
};

var update = function update(uuid, body, cb, errorCb) {
    __WEBPACK_IMPORTED_MODULE_0__HttpService__["c" /* patch */](namespace + '/' + uuid, body, cb, errorCb);
};



/***/ }),
/* 350 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
    data: function data() {
        return {
            selectedOption: {
                name: ''
            },
            showMenu: false,
            placeholderText: 'Please select an item'
        };
    },

    props: {
        options: {
            type: [Array, Object]
        },
        selected: {},
        placeholder: [String],
        closeOnOutsideClick: {
            type: [Boolean],
            default: true
        }
    },

    mounted: function mounted() {
        this.selectedOption = this.selected;
        if (this.placeholder) {
            this.placeholderText = this.placeholder;
        }

        if (this.closeOnOutsideClick) {
            document.addEventListener('click', this.clickHandler);
        }
    },
    beforeDestroy: function beforeDestroy() {
        document.removeEventListener('click', this.clickHandler);
    },


    methods: {
        updateOption: function updateOption(option) {
            this.selectedOption = option;
            this.showMenu = false;
            this.$emit('updateOption', this.selectedOption);
        },
        toggleMenu: function toggleMenu() {
            this.showMenu = !this.showMenu;
        },
        clickHandler: function clickHandler(event) {
            var target = event.target;
            var $el = this.$el;


            if (!$el.contains(target)) {
                this.showMenu = false;
            }
        }
    }
});

/***/ }),
/* 351 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'app',
  components: {
    'layout': __webpack_require__(688)
  }
});

/***/ }),
/* 352 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
    props: ['headline', 'identifier'],
    data: function data() {
        return {
            show: false,
            content: null
        };
    },
    created: function created() {
        if (this.identifier !== null) {
            this.getDataFromContentful();
        }
    },

    methods: {
        showHelper: function showHelper() {
            this.show = true;
        },
        hideHelper: function hideHelper() {
            this.show = false;
        },
        getDataFromContentful: function getDataFromContentful() {
            var _this = this;

            var contentful = __webpack_require__(57);
            var client = contentful.createClient({
                space: '3h0kg5qa88is',

                accessToken: 'KL17Lh_FTD4ZN6iksXFClsWCVJ_OEVVUbIt7RUGofwc'
            });

            client.getEntries({
                content_type: 'hjaelpebokse',

                'fields.relation[in]': this.identifier
            }).then(function (entries) {
                if (entries.items[0].fields.htmlIndhold.content.length > 0) {
                    _this.content = '<h1>' + _this.headline + '</h1>';
                    entries.items[0].fields.htmlIndhold.content.forEach(function (block) {
                        if (block.nodeType === 'heading-3') {
                            _this.content += '<h3>';
                            if (block.content.length > 0) {
                                block.content.forEach(function (childBlock) {
                                    if (childBlock.marks.length > 0) {
                                        childBlock.marks.forEach(function (mark) {
                                            if (mark.type === 'bold') {
                                                _this.content += '<b>';
                                            }
                                            if (mark.type === 'underline') {
                                                _this.content += '<u>';
                                            }
                                            _this.content += childBlock.value;
                                            if (mark.type === 'bold') {
                                                _this.content += '</b>';
                                            }
                                            if (mark.type === 'underline') {
                                                _this.content += '</u>';
                                            }
                                        });
                                    } else {
                                        _this.content += childBlock.value;
                                    }
                                });
                            } else {
                                _this.content += block.content[0].value;
                            }
                            _this.content += '</h3>';
                        }
                        if (block.nodeType === 'paragraph') {
                            _this.content += '<p>';
                            if (block.content.length > 0) {
                                block.content.forEach(function (childBlock) {
                                    if (childBlock.marks.length > 0) {
                                        childBlock.marks.forEach(function (mark) {
                                            if (mark.type === 'bold') {
                                                _this.content += '<b>';
                                            }
                                            if (mark.type === 'underline') {
                                                _this.content += '<u>';
                                            }
                                            _this.content += childBlock.value;
                                            if (mark.type === 'bold') {
                                                _this.content += '</b>';
                                            }
                                            if (mark.type === 'underline') {
                                                _this.content += '</u>';
                                            }
                                        });
                                    } else {
                                        _this.content += childBlock.value;
                                    }
                                });
                            } else {
                                _this.content += block.content[0].value;
                            }
                            _this.content += '</p>';
                        }
                        if (block.nodeType === 'unordered-list') {
                            _this.content += '<ul style="padding-left:40px;margin-bottom:15px;">';
                            block.content.forEach(function (listItem) {
                                _this.content += '<li>';
                                if (listItem.content[0].content.length > 0) {
                                    listItem.content[0].content.forEach(function (childListItem) {
                                        if (childListItem.marks.length > 0) {
                                            listItem.content[0].content[0].marks.forEach(function (mark) {
                                                if (mark.type === 'bold') {
                                                    _this.content += '<b>';
                                                }
                                                if (mark.type === 'underline') {
                                                    _this.content += '<u>';
                                                }
                                                _this.content += listItem.content[0].content[0].value;
                                                if (mark.type === 'bold') {
                                                    _this.content += '</b>';
                                                }
                                                if (mark.type === 'underline') {
                                                    _this.content += '</u>';
                                                }
                                            });
                                        } else {
                                            _this.content += childListItem.value;
                                        }
                                        _this.content += '<br>';
                                    });
                                } else {}
                                _this.content += '</li>';
                            });
                            _this.content += '</ul>';
                        }
                        if (block.nodeType === 'ordered-list') {
                            _this.content += '<ol style="padding-left:40px;margin-bottom:15px;">';
                            block.content.forEach(function (listItem) {
                                _this.content += '<li>';
                                if (listItem.content[0].content.length > 0) {
                                    listItem.content[0].content.forEach(function (childListItem) {
                                        if (childListItem.marks.length > 0) {
                                            listItem.content[0].content[0].marks.forEach(function (mark) {
                                                if (mark.type === 'bold') {
                                                    _this.content += '<b>';
                                                }
                                                if (mark.type === 'underline') {
                                                    _this.content += '<u>';
                                                }
                                                _this.content += listItem.content[0].content[0].value;
                                                if (mark.type === 'bold') {
                                                    _this.content += '</b>';
                                                }
                                                if (mark.type === 'underline') {
                                                    _this.content += '</u>';
                                                }
                                            });
                                        } else {
                                            _this.content += childListItem.value;
                                        }
                                        _this.content += '<br>';
                                    });
                                } else {}
                                _this.content += '</li>';
                            });
                            _this.content += '</ol>';
                        }
                    });
                }
            }).catch(function (err) {
                return console.log(err);
            });
        }
    }
});

/***/ }),
/* 353 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
    props: ['height']
});

/***/ }),
/* 354 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
    props: ['project'],
    data: function data() {
        return {
            show: false,
            options: {
                popover: {
                    defaultClass: 'd-tooltip',
                    defaultBaseClass: 'd-tooltip',
                    trigger: 'hover'
                }
            }
        };
    }
});

/***/ }),
/* 355 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuejs_datepicker__ = __webpack_require__(83);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuejs_datepicker_dist_locale__ = __webpack_require__(82);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuejs_datepicker_dist_locale___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vuejs_datepicker_dist_locale__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_dropdowns__ = __webpack_require__(774);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_dropdowns___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue_dropdowns__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_moment__);







/* harmony default export */ __webpack_exports__["default"] = ({
    data: function data() {
        return {
            departments: [],
            selectedDepartment: null,
            selectedTimePeriod: 'Vælg tidsinterval',
            datepickerLocale: __WEBPACK_IMPORTED_MODULE_1_vuejs_datepicker_dist_locale__["da"]
        };
    },
    mounted: function mounted() {
        this.getDepartments();
    },

    methods: {
        selectAccountingYear: function selectAccountingYear(accountingYear) {
            var dates = {
                startDate: accountingYear.from_date,
                endDate: accountingYear.to_date
            };
            this.$store.commit('setDates', dates);
            this.selectedTimePeriod = 'Vælg tidsinterval';
        },
        goToCleanUp: function goToCleanUp() {
            this.$router.push({ name: 'Settings', params: { selected: 'cleanup' } });
        },
        getDepartments: function getDepartments() {
            this.departments = this.$store.getters.getAvailableDepartments;
            this.selectedDepartment = this.$store.getters.getCurrentDepartment;
            this.departments.push({ name: 'Ingen afdeling tilknyttet' });
            if (this.$auth.user().roles[0].name === 'department-responsible') {
                if (!this.$auth.user().department || !this.$auth.user().relation_department_id) {
                    alert('Din profil er oprettet som afdelingsansvarlig, men du er ikke tilknyttet en afdeling. Du logges nu ud af proEBITDA. Kontakt din administrator for at opdatere din brugerprofil.');
                    this.$auth.logout();
                }
                console.log('Du er afdelingsansvarlig! Nice...');
                this.selectDepartment(this.$auth.user().department);
                this.selectedDepartment = this.$auth.user().department;
            }
        },
        selectDepartment: function selectDepartment(department) {
            this.selectedTimePeriod = 'Vælg tidsinterval';
            if (department.name === 'Ingen afdeling tilknyttet') {
                this.$router.push({ name: 'Settings', params: { selected: 'cleanup' } });
            } else {
                this.$store.commit('setCurrentDepartment', department);
            }
        },
        selectTimePeriod: function selectTimePeriod(event) {
            var _this = this;

            this.customTimeIntervals.forEach(function (interval) {
                if (interval.name === event.target.value) {
                    _this.$store.state.config.startDate = interval.start;
                    _this.$store.state.config.endDate = interval.end;
                }
            });
        }
    },
    components: {
        Datepicker: __WEBPACK_IMPORTED_MODULE_0_vuejs_datepicker__["a" /* default */],
        dropdown: __WEBPACK_IMPORTED_MODULE_2_vue_dropdowns___default.a
    },
    computed: {
        startDate: function startDate() {
            return this.$store.state.getters.getStartDate;
        },
        customTimeIntervals: function customTimeIntervals() {
            var timeIntervals = [{
                name: 'Denne uge',
                start: __WEBPACK_IMPORTED_MODULE_3_moment___default()().startOf('week').format('YYYY-MM-DD'),
                end: __WEBPACK_IMPORTED_MODULE_3_moment___default()().endOf('week').format('YYYY-MM-DD')
            }, {
                name: 'Sidste uge',
                start: __WEBPACK_IMPORTED_MODULE_3_moment___default()().subtract(1, 'week').startOf('week').format('YYYY-MM-DD'),
                end: __WEBPACK_IMPORTED_MODULE_3_moment___default()().subtract(1, 'week').endOf('week').format('YYYY-MM-DD')
            }, {
                name: 'Denne måned',
                start: __WEBPACK_IMPORTED_MODULE_3_moment___default()().startOf('month').format('YYYY-MM-DD'),
                end: __WEBPACK_IMPORTED_MODULE_3_moment___default()().endOf('month').format('YYYY-MM-DD')
            }, {
                name: 'Sidste 3 måneder',
                start: __WEBPACK_IMPORTED_MODULE_3_moment___default()().subtract(3, 'months').format('YYYY-MM-DD'),
                end: __WEBPACK_IMPORTED_MODULE_3_moment___default()().format('YYYY-MM-DD')
            }, {
                name: 'Sidste 6 måneder',
                start: __WEBPACK_IMPORTED_MODULE_3_moment___default()().subtract(6, 'months').format('YYYY-MM-DD'),
                end: __WEBPACK_IMPORTED_MODULE_3_moment___default()().format('YYYY-MM-DD')
            }];
            return timeIntervals;
        }
    }
});

/***/ }),
/* 356 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(94);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuejs_datepicker__ = __webpack_require__(83);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_apexcharts__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_apexcharts___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vue_apexcharts__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__services_calculationService__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vuejs_datepicker_dist_locale__ = __webpack_require__(82);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vuejs_datepicker_dist_locale___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_vuejs_datepicker_dist_locale__);











/* harmony default export */ __webpack_exports__["default"] = ({
    components: {
        Datepicker: __WEBPACK_IMPORTED_MODULE_3_vuejs_datepicker__["a" /* default */],
        VueApexCharts: __WEBPACK_IMPORTED_MODULE_4_vue_apexcharts___default.a
    },
    props: {
        heading: String,
        unit: String,
        ylabel: String,
        height: String,
        trend: Boolean,
        endpoint: String,
        paramsInEndpoint: Boolean,
        dynamicInterval: Boolean,
        series: Array
    },
    data: function data() {
        var _this = this;

        return {
            datepickerLocale: __WEBPACK_IMPORTED_MODULE_7_vuejs_datepicker_dist_locale__["da"],
            loading: true,
            startDate: this.$store.state.config.startDate,
            endDate: this.$store.state.config.endDate,
            values: [].concat(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray___default()(this.series)),
            options: {
                colors: ['#172b43', '#F44336', '#9C27B0', '#3F51B5', '#4CAF50', '#FF9800'],
                labels: [],
                plotOptions: {
                    bar: {
                        columnWidth: '50%'
                    }
                },
                stroke: {
                    width: [].concat(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray___default()(function () {
                        return _this.series.map(function (series) {
                            return series.width;
                        });
                    }()), [3]),
                    curve: 'smooth'
                },
                dataLabels: {
                    enabled: false
                },
                yaxis: {
                    labels: {
                        formatter: function formatter(value) {
                            return Math.round(value) + ' ' + _this.unit;
                        }
                    },
                    title: {
                        text: this.ylabel
                    },
                    min: 0,
                    max: 100
                },
                tooltip: {
                    shared: true,
                    intersect: false,
                    followCursor: true,
                    y: {
                        formatter: function formatter(y) {
                            if (typeof y !== 'undefined') {
                                return y.toFixed(0) + ' ' + _this.unit;
                            }
                            return y;
                        }
                    }
                },
                chart: {
                    toolbar: {
                        show: false
                    }
                }
            }
        };
    },

    computed: {
        companyId: function companyId() {
            return this.$store.state.companyId || this.$auth.user().company_id;
        },
        dataUrl: function dataUrl() {
            return this.endpoint + (this.paramsInEndpoint ? '&' : '?') + 'date_from=' + this.formatDate(this.startDate) + '&date_to=' + this.formatDate(this.endDate);
        },
        storeStartDate: function storeStartDate() {
            return this.$store.state.config.startDate;
        },
        storeEndDate: function storeEndDate() {
            return this.$store.state.config.endDate;
        },
        getSeries: function getSeries() {
            if (this.trend) {
                return [].concat(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray___default()(this.values), [this.average]);
            } else {
                return [].concat(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray___default()(this.values));
            }
        },
        average: function average() {
            var averages = [];
            if (this.values[0].data) {
                var sum = 0;
                var n = 1;
                this.values[0].data.forEach(function (value) {
                    sum += value;
                    averages.push(sum / n);
                    n++;
                });
            }
            return {
                name: 'Trend',
                type: 'line',
                data: averages
            };
        }
    },
    methods: {
        getData: function getData() {
            var _this2 = this;

            this.loading = true;
            __WEBPACK_IMPORTED_MODULE_5__services_calculationService__["c" /* find */](this.dataUrl, {}, function (response) {
                _this2.options = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, _this2.options, {
                    labels: response.data.labels
                });

                __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(response.data.values).forEach(function (seriesKey, index) {
                    _this2.values = [__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, _this2.values[index], {
                        data: response.data.values[seriesKey]
                    })];
                    var maxValue = Math.max.apply(Math, __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray___default()(_this2.values[index].data));
                    if (_this2.dynamicInterval && maxValue > _this2.options.yaxis.max) {
                        _this2.options.yaxis.max = maxValue * 1.2;
                    }
                });
                _this2.loading = false;
            }, function (err) {
                _this2.loading = false;
                return err;
            });
        },
        formatDate: function formatDate(date) {
            return __WEBPACK_IMPORTED_MODULE_6_moment___default()(date).format('YYYY-MM-DD');
        }
    },
    created: function created() {
        this.getData();
    },

    watch: {
        storeStartDate: function storeStartDate(date) {
            this.startDate = date;
        },
        storeEndDate: function storeEndDate(date) {
            this.endDate = date;
        },
        dataUrl: function dataUrl() {
            this.getData();
        }
    }
});

/***/ }),
/* 357 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
    data: function data() {
        return {
            paused: true
        };
    },

    methods: {
        startCounter: function startCounter() {
            this.$refs.counter.start();
        },
        goTo: function goTo() {
            if (this.linkParent) {
                this.$router.push({ name: this.linkParent, params: { selectedItem: this.linkChild } });
            }
        }
    },
    props: ['heading', 'description', 'number', 'icon', 'state', 'totalValue', 'linkParent', 'linkChild', 'tooltipIdentifier']
});

/***/ }),
/* 358 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
    props: ['project'],
    data: function data() {
        return {
            show: false,
            options: {
                popover: {
                    defaultClass: 'd-tooltip',
                    defaultBaseClass: 'd-tooltip',
                    trigger: 'hover'
                }
            }
        };
    }
});

/***/ }),
/* 359 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_moment__);




/* harmony default export */ __webpack_exports__["default"] = ({
    data: function data() {
        return {
            routes: [{
                name: 'Startside',
                icon: 'home',
                route: 'Index',
                onlySuperAdmin: false
            }, {
                name: 'Økonomi',
                icon: 'wallet',
                route: 'Economy',
                onlySuperAdmin: true
            }, {
                name: 'Kunder',
                icon: 'briefcase',
                route: 'Customers',
                onlySuperAdmin: true
            }, {
                name: 'Opgaver',
                icon: 'clipboard-list-check',
                route: 'ProjectsOperations',
                onlySuperAdmin: false
            }, {
                name: 'Medarbejdere',
                icon: 'users',
                route: 'Employees',
                onlySuperAdmin: true
            }, {
                name: 'Indstillinger',
                icon: 'cog',
                route: 'Settings',
                onlySuperAdmin: true
            }, {
                name: 'Super Admin',
                icon: 'user-cog',
                route: 'SuperAdmin',
                onlySuperAdmin: true
            }]
        };
    },

    computed: {
        initials: function initials() {
            if (this.$auth.user().name) {
                var initials = this.$auth.user().name.split(' ').map(function (n) {
                    return n[0];
                }).join('');
                var splittedString = initials.match(/.{1,2}/g);
                return splittedString[0];
            }
        },
        lastSync: function lastSync() {
            if (this.$store.state.config && this.$store.state.config.lastSynced) {
                var date = this.$store.state.config.lastSynced;
                var formatted = __WEBPACK_IMPORTED_MODULE_0_moment___default()(date).format('D. MMMM YYYY [kl.] HH:mm');

                return formatted;
            }
            return null;
        }
    },
    methods: {
        goToRoute: function goToRoute(item) {
            if (this.$auth.user().userrole_id === 1) {
                this.$router.push({ name: item.route });
            } else {
                this.$router.push({ name: 'ComingSoon' });
            }
        },
        subIsActive: function subIsActive(input) {
            var _this = this;

            var paths = Array.isArray(input) ? input : [input];
            return paths.some(function (path) {
                return _this.$route.path.indexOf(path) === 0;
            });
        },
        logout: function logout() {
            this.$auth.logout({
                makeRequest: true
            });
        }
    }
});

/***/ }),
/* 360 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
    props: ['heading', 'number'],
    components: {}
});

/***/ }),
/* 361 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuejs_datepicker__ = __webpack_require__(83);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__services_projectService__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuejs_datepicker_dist_locale__ = __webpack_require__(82);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuejs_datepicker_dist_locale___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vuejs_datepicker_dist_locale__);








/* harmony default export */ __webpack_exports__["default"] = ({
    data: function data() {
        return {
            datepickerLocale: __WEBPACK_IMPORTED_MODULE_4_vuejs_datepicker_dist_locale__["da"],
            loading: true,
            search: '',
            startDate: this.$store.state.config.startDate,
            endDate: this.$store.state.config.endDate,
            data: []
        };
    },

    props: ['heading', 'endpoint', 'headers', 'customClass', 'icon', 'group', 'filters', 'includes'],
    computed: {
        companyId: function companyId() {
            return this.$store.state.companyId || this.$auth.user().company_id;
        },
        dataUrl: function dataUrl() {
            return this.endpoint + '/' + this.companyId + '/' + this.formatDate(this.startDate) + '/' + this.formatDate(this.endDate) + this.filterString + this.includeString;
        },
        storeStartDate: function storeStartDate() {
            return this.$store.state.config.startDate;
        },
        storeEndDate: function storeEndDate() {
            return this.$store.state.endDate;
        },
        items: function items() {
            return this.data.map(function (project) {
                return {
                    name: project.description,
                    customer: project.customer.name,
                    project: project.description,
                    projectType: project.type.name,
                    revenue: '-',
                    date: project.start_date,
                    db: project.coverage,
                    dbPerHour: project.coverage_per_hour,
                    dg: project.coverage_percent,
                    projectmanager: project.projectmanager
                };
            });
        },
        filterString: function filterString() {
            var _this = this;

            var filters = '';
            if (this.filters) {
                __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(this.filters).forEach(function (filter, filterCounter) {
                    if (filterCounter === 0) {
                        filters += '?filter[' + filter + ']=';
                    } else {
                        filters += '&filter[' + filter + ']=';
                    }
                    _this.filters[filter].forEach(function (value, valueCounter) {
                        if (valueCounter === 0) {
                            filters += value;
                        } else {
                            filters += ', ' + value;
                        }
                    });
                });
            }
            return filters;
        },
        includeString: function includeString() {
            var includes = '';
            if (this.includes) {
                if (this.filters) includes += '&';
                this.includes.forEach(function (include, includeCounter) {
                    if (includeCounter === 0) {
                        includes += 'include=' + include;
                    } else {
                        includes += ',' + include;
                    }
                });
            }
            return includes;
        }
    },
    methods: {
        getData: function getData() {
            var _this2 = this;

            this.loading = true;
            __WEBPACK_IMPORTED_MODULE_2__services_projectService__["a" /* find */](this.dataUrl, {}, function (response) {
                _this2.data = response.data.data;
                setTimeout(function () {
                    _this2.loading = false;
                }, 2000);
            }, function (err) {
                console.log(err);
                _this2.loading = false;
            });
        },
        formatDate: function formatDate(date) {
            return __WEBPACK_IMPORTED_MODULE_3_moment___default()(date).format('YYYY-MM-DD');
        }
    },
    created: function created() {},

    watch: {
        storeStartDate: function storeStartDate(date) {
            this.startDate = date;
        },
        storeEndDate: function storeEndDate(date) {
            this.endDate = date;
        },
        dataUrl: function dataUrl() {
            this.getData();
        }
    },
    components: {
        Datepicker: __WEBPACK_IMPORTED_MODULE_1_vuejs_datepicker__["a" /* default */]
    }
});

/***/ }),
/* 362 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
    props: {
        selectedItem: String,
        items: Array,
        counts: Object
    },
    methods: {
        handleClick: function handleClick(item) {
            this.$emit('selectItem', item);
        }
    }
});

/***/ }),
/* 363 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);



/* harmony default export */ __webpack_exports__["default"] = ({
    props: {
        identifier: String,
        placement: String,
        icon: String,
        space: Boolean
    },
    data: function data() {
        return {
            options: {
                content: null,
                popover: {
                    defaultClass: 'd-tooltip',
                    defaultBaseClass: 'd-tooltip'
                }
            }
        };
    },
    created: function created() {
        if (this.identifier !== null) {
            this.getDataFromContentful();
        }
    },

    methods: {
        getDataFromContentful: function getDataFromContentful() {
            var _this = this;

            var contentful = __webpack_require__(57);
            var client = contentful.createClient({
                space: '3h0kg5qa88is',

                accessToken: 'KL17Lh_FTD4ZN6iksXFClsWCVJ_OEVVUbIt7RUGofwc'
            });

            client.getEntries({
                content_type: 'informationsbokse',

                'fields.relation[in]': this.identifier
            }).then(function (entries) {
                if (entries.items[0].fields.htmlForklaring.content.length > 0) {
                    _this.options.content = '';
                    _this.options.content += '<div style="margin-bottom:-15px;">';
                    entries.items[0].fields.htmlForklaring.content.forEach(function (content) {
                        if (content.nodeType === 'paragraph') {
                            _this.options.content += '<p style="margin-bottom:15px;">' + content.content[0].value + '</p>';
                        } else if (content.nodeType === 'unordered-list') {
                            _this.options.content += '<ul style="padding-left:20px;margin-bottom:15px;">';
                            content.content.forEach(function (listItem) {
                                _this.options.content += '<li>' + listItem.content[0].content[0].value + '</li>';
                            });
                            _this.options.content += '</ul>';
                        }
                    });
                    _this.options.content += '</div>';
                    _this.options.content = _this.options.content.replace(/(?:\r\n|\r|\n)/g, '<br>');
                }
            }).catch(function (err) {
                return console.log(err);
            });
        }
    },
    computed: {
        styleOptions: function styleOptions() {
            var cases = {
                left: 'float: left',
                right: 'float: right',
                inline: 'display: inline-block'
            };
            if (!__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(cases).includes(this.placement)) {
                console.log('fejl i placement prop');
                return '';
            }
            return cases[this.placement];
        }
    }
});

/***/ }),
/* 364 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
    props: ['headline', 'position', 'customClass']
});

/***/ }),
/* 365 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
    props: {
        operationsName: {
            required: true,
            type: String
        },
        operationsLink: {
            required: true,
            type: String
        },
        learningName: {
            required: true,
            type: String
        },
        learningLink: {
            required: true,
            type: String
        }

    },
    methods: {
        doToggle: function doToggle(state, routeName) {
            this.$store.state.view = state;
            this.$router.push({ name: routeName });
        }
    }
});

/***/ }),
/* 366 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
    data: function data() {
        return {
            show: false,
            abbreviations: [{
                abb: 'EBITDA',
                exp: 'Resultatet før renter, skat, afskrivninger og nedbringelse af gæld',
                comment: 'EBITDA er virksomhedens driftsoverskud. Med andre ord viser EBTIDA, hvor stærk en “motor” virksomheden har til at kunne betale renter, afbetale på gæld og mindst lige så vigtig at skabe overskud til virksomhedens ejer. EBITDA er også en væsentligt indikator for, hvor meget virksomheden er værd. Hvor meget vil du betale for en virksomhed, der har et driftsoverskud på 300.000 kr.? Hvis virksomheden sælges for f.eks. 1.500.000 kr., vil det tage 5 år, inden investeringen er kommet hjem. For hver krone EBTIDA øges, vil virksomheden stige i værdi.'
            }, {
                abb: 'DB',
                exp: 'Dækningsbidrag',
                comment: 'Dækningsbidraget er et udtryk for, hvor stort et beløb der er tilbage på en opgave, når de direkte omkostninger er afholdt (lønninger, materialer). Dækningsbidrag er dermed lig overskud pr. opgave.'
            }, {
                abb: 'DG',
                exp: 'Dækningsgrad',
                comment: 'Dækningsgraden er et udtryk for hvor meget dit overskud pr. opgave udgør i % af den samlede omsætning på en opgave. Hvis du eksempelvis har opnået et overskud på 2.000 kr på en opgave til 4.000 kr vil din DG være 50 (50%).'
            }, {
                abb: 'DB pr. time',
                exp: 'Dækningsbidrag pr. time',
                comment: 'Dækningsbidraget pr. time er et udtryk for dækningsbidraget divideret med antal timer brugt. Dvs. hvor "effektive" svendene har været. DB. pr time er dermed lig overskud pr. time.'
            }]
        };
    },

    methods: {
        toggle: function toggle() {
            this.show = !this.show;
        }
    }
});

/***/ }),
/* 367 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_elements_Sidebar__ = __webpack_require__(686);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_elements_Sidebar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_elements_Sidebar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_elements_ConfigBar__ = __webpack_require__(685);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_elements_ConfigBar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_elements_ConfigBar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_layout_footer__ = __webpack_require__(687);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_layout_footer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_layout_footer__);






/* harmony default export */ __webpack_exports__["default"] = ({
    components: {
        Sidebar: __WEBPACK_IMPORTED_MODULE_0__components_elements_Sidebar___default.a,
        ConfigBar: __WEBPACK_IMPORTED_MODULE_1__components_elements_ConfigBar___default.a,
        'foo': __WEBPACK_IMPORTED_MODULE_2__components_layout_footer___default.a
    },
    created: function created() {
        this.$store.dispatch('getConfig');
    }
});

/***/ }),
/* 368 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__shared_js__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__services_invoiceService__ = __webpack_require__(38);






/* harmony default export */ __webpack_exports__["default"] = ({
    data: function data() {
        return {
            loading: true,
            columns: [{ label: 'Faktura', field: 'invoice_number', type: 'number', width: '10%', align: 'left', sortable: true }, { label: 'Type', field: 'type', type: 'string', width: '10%', align: 'left', sortable: true }, { label: 'Ordre', field: 'external_project_id', type: 'string', width: '10%', align: 'left', sortable: true }, { label: 'Kunde', field: 'customer_name', type: 'string', width: '15%', sortable: true }, { label: 'Beløb', field: 'amount', type: 'number', width: '15%', sortable: true }, { label: 'Beskrivelse', field: 'description', type: 'string', width: '20%', sortable: true }, { label: 'Forfaldsdato', field: 'due_at', type: 'string', width: '10%', sortable: true }, { label: 'Status', field: 'paid', type: 'boolean', width: '10%', sortable: true }],
            rows: [],
            searchOptions: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __WEBPACK_IMPORTED_MODULE_1__shared_js__["a" /* default */].searchOptions),
            paginationOptions: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __WEBPACK_IMPORTED_MODULE_1__shared_js__["a" /* default */].paginationOptions),
            sortOptions: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __WEBPACK_IMPORTED_MODULE_1__shared_js__["a" /* default */].sortOptions, {
                initialSortBy: {
                    field: 'customer_name',
                    type: 'asc'
                }
            }),
            styleClass: 'vgt-table',
            params: {}
        };
    },
    created: function created() {
        if (this.$auth.user().company.api_provider.slug === 'minuba') {
            this.columns.push({ label: 'Åbn', field: 'minuba_external_id' });
        }
        this.getData();
    },

    methods: {
        getData: function getData() {
            var _this = this;

            this.loading = true;
            this.$emit('finishedLoading', null);
            var params = {
                date_from: this.$store.getters.getStartDate,
                date_to: this.$store.getters.getEndDate
            };
            if (this.$store.getters.getCurrentDepartment.uuid !== 0) {
                params['filter[by_department_uuid]'] = this.$store.getters.getCurrentDepartment.uuid;
            }
            __WEBPACK_IMPORTED_MODULE_2__services_invoiceService__["a" /* all */](params, function (response) {
                _this.rows = response.data;
                _this.$emit('finishedLoading', _this.rows.length);
                _this.loading = false;
            }, function (err) {
                console.log(err);
                _this.loading = false;
            });
        }
    },
    computed: {
        globalParams: function globalParams() {
            var startDate = this.$store.getters.getStartDate;
            var endDate = this.$store.getters.getEndDate;
            var department = this.$store.getters.getCurrentDepartment.uuid;
            return startDate + endDate + department;
        }
    },
    watch: {
        globalParams: function globalParams() {
            this.getData();
        }
    }
});

/***/ }),
/* 369 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__shared_js__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__services_invoiceService__ = __webpack_require__(38);






/* harmony default export */ __webpack_exports__["default"] = ({
    data: function data() {
        return {
            loading: true,
            columns: [{ label: 'Faktura', field: 'invoice_number', type: 'number', width: '10%', align: 'left' }, { label: 'Ordre', field: 'project.case_number', type: 'string', width: '10%', align: 'left' }, { label: 'Kunde', field: 'customer.name', type: 'string', width: '15%' }, { label: 'Beløb', field: 'amount', type: 'number', width: '15%' }, { label: 'Beskrivelse', field: 'description', type: 'string', width: '20%' }, { label: 'Forfaldsdato', field: 'due_at', type: 'string', width: '10%' }],
            rows: [],
            searchOptions: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __WEBPACK_IMPORTED_MODULE_1__shared_js__["a" /* default */].searchOptions),
            paginationOptions: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __WEBPACK_IMPORTED_MODULE_1__shared_js__["a" /* default */].paginationOptions),
            sortOptions: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __WEBPACK_IMPORTED_MODULE_1__shared_js__["a" /* default */].sortOptions),
            styleClass: 'vgt-table',
            params: {
                'filter[unpaid]': true,
                'filter[overdue]': true,
                'filter[type]': '1,3',
                'include': 'customer'
            }
        };
    },
    created: function created() {
        if (this.$auth.user().company.api_provider.slug === 'minuba') {
            this.columns.push({ label: 'Åbn', field: 'project.minuba_external_id' });
        }
        this.getData();
    },

    methods: {
        getData: function getData() {
            var _this = this;

            this.loading = true;
            this.$emit('finishedLoading', null);
            var params = {
                'filter[unpaid]': 'true',
                'filter[overdue]': true,
                'filter[type]': '1,3',
                include: 'customer,project',
                date_from: this.$store.getters.getStartDate,
                date_to: this.$store.getters.getEndDate
            };
            if (this.$store.getters.getCurrentDepartment.uuid !== 0) {
                params['filter[by_department_uuid]'] = this.$store.getters.getCurrentDepartment.uuid;
            }
            __WEBPACK_IMPORTED_MODULE_2__services_invoiceService__["c" /* find */](params, function (response) {
                _this.rows = response.data;
                _this.$emit('finishedLoading', _this.rows.length);
                _this.loading = false;
            }, function (err) {
                console.log(err);
                _this.loading = false;
            });
        }
    },
    computed: {
        globalParams: function globalParams() {
            var startDate = this.$store.getters.getStartDate;
            var endDate = this.$store.getters.getEndDate;
            var department = this.$store.getters.getCurrentDepartment.uuid;
            return startDate + endDate + department;
        }
    },
    watch: {
        globalParams: function globalParams() {
            this.getData();
        }
    }
});

/***/ }),
/* 370 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__shared_js__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__services_invoiceService__ = __webpack_require__(38);






/* harmony default export */ __webpack_exports__["default"] = ({
    data: function data() {
        return {
            loading: true,
            columns: [{ label: 'Faktura', field: 'invoice_number', type: 'number', width: '10%', align: 'left', sortable: true }, { label: 'Ordre', field: 'external_project_id', type: 'string', width: '10%', align: 'left', sortable: true }, { label: 'Kunde', field: 'customer_name', type: 'string', width: '15%', sortable: true }, { label: 'Beløb', field: 'amount', type: 'number', width: '15%', sortable: true }, { label: 'Beskrivelse', field: 'description', type: 'string', width: '20%', sortable: true }, { label: 'Forfaldsdato', field: 'due_at', type: 'string', width: '10%', sortable: true }, { label: 'Status', field: 'paid', type: 'boolean', width: '10%', sortable: true }],
            rows: [],
            searchOptions: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __WEBPACK_IMPORTED_MODULE_1__shared_js__["a" /* default */].searchOptions),
            paginationOptions: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __WEBPACK_IMPORTED_MODULE_1__shared_js__["a" /* default */].paginationOptions),
            sortOptions: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __WEBPACK_IMPORTED_MODULE_1__shared_js__["a" /* default */].sortOptions, {
                initialSortBy: {
                    field: 'customer_name',
                    type: 'asc'
                }
            }),
            styleClass: 'vgt-table'
        };
    },
    created: function created() {
        if (this.$auth.user().company.api_provider.slug === 'minuba') {
            this.columns.push({ label: 'Åbn', field: 'minuba_external_id' });
        }
        this.getData();
    },

    methods: {
        getData: function getData() {
            var _this = this;

            this.loading = true;
            this.$emit('finishedLoading', null);
            var params = {
                date_from: this.$store.getters.getStartDate,
                date_to: this.$store.getters.getEndDate
            };
            __WEBPACK_IMPORTED_MODULE_2__services_invoiceService__["d" /* unpaid */](params, function (response) {
                console.log(response.data);
                _this.rows = response.data;
                _this.$emit('finishedLoading', _this.rows.length);
                _this.loading = false;
            }, function (err) {
                console.log(err);
                _this.loading = false;
            });
        }
    }
});

/***/ }),
/* 371 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__shared_js__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__services_projectService__ = __webpack_require__(11);






/* harmony default export */ __webpack_exports__["default"] = ({
    props: ['title', 'rpp'],
    data: function data() {
        return {
            loading: true,
            columns: [{ label: 'Ordre', field: 'case_number', type: 'number' }, { label: 'Opgavetype', field: 'type.name', type: 'string' }, { label: 'Opgave', field: 'description', type: 'string' }, { label: 'Kunde', field: 'customer.name', type: 'string' }, { label: 'Startdato', field: 'start_date', type: 'string' }, { label: 'Status', field: 'status.name', type: 'string' }],
            rows: [],
            searchOptions: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __WEBPACK_IMPORTED_MODULE_1__shared_js__["a" /* default */].searchOptions),
            paginationOptions: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __WEBPACK_IMPORTED_MODULE_1__shared_js__["a" /* default */].paginationOptions),
            sortOptions: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __WEBPACK_IMPORTED_MODULE_1__shared_js__["a" /* default */].sortOptions),
            styleClass: 'vgt-table'
        };
    },
    created: function created() {
        if (this.$auth.user().company.api_provider.slug === 'minuba') {
            this.columns.push({ label: 'Åbn', field: 'minuba_external_id' });
        }
        this.getData();
    },

    methods: {
        getData: function getData() {
            var _this = this;

            this.loading = true;
            this.$emit('finishedLoading', null);
            var params = {
                'filter[complaint]': true,
                'filter[status]': 'pending,ongoing',
                'filter[visible]': true,
                include: 'customer,type,status',
                date_from: this.$store.getters.getStartDate,
                date_to: this.$store.getters.getEndDate
            };
            if (this.$store.getters.getCurrentDepartment.uuid !== 0) {
                params['filter[by_department_uuid]'] = this.$store.getters.getCurrentDepartment.uuid;
            }
            __WEBPACK_IMPORTED_MODULE_2__services_projectService__["a" /* find */](params, function (response) {
                _this.rows = response.data;
                _this.$emit('finishedLoading', _this.rows.length);
                _this.loading = false;
            }, function (err) {
                console.log(err);
                _this.loading = false;
            });
        }
    },
    computed: {
        globalParams: function globalParams() {
            var startDate = this.$store.getters.getStartDate;
            var endDate = this.$store.getters.getEndDate;
            var department = this.$store.getters.getCurrentDepartment.uuid;
            return startDate + endDate + department;
        }
    },
    watch: {
        globalParams: function globalParams() {
            this.getData();
        }
    }
});

/***/ }),
/* 372 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__shared_js__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__services_projectService__ = __webpack_require__(11);






/* harmony default export */ __webpack_exports__["default"] = ({
    props: ['title', 'rpp'],
    data: function data() {
        return {
            testData: [],
            loading: true,
            columns: [{ label: 'Ordre', field: 'case_number', type: 'number' }, { label: 'Opgavetype', field: 'type.name', type: 'string' }, { label: 'Opgave', field: 'description', type: 'string', width: '20%' }, { label: 'Kunde', field: 'customer.name', type: 'string' }, { label: 'Startdato', field: 'start_date', type: 'string' }, { label: 'Omsætning', field: 'invoices_total', type: 'number' }, { label: 'DB', field: 'coverage', width: '10%', type: 'number' }, { label: 'DG', field: 'coverage_percent', width: '8%', type: 'number' }, { label: 'DB/time', field: 'coverage_per_hour', width: '8%', type: 'number' }],
            rows: [],
            searchOptions: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __WEBPACK_IMPORTED_MODULE_1__shared_js__["a" /* default */].searchOptions),
            paginationOptions: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __WEBPACK_IMPORTED_MODULE_1__shared_js__["a" /* default */].paginationOptions),
            sortOptions: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __WEBPACK_IMPORTED_MODULE_1__shared_js__["a" /* default */].sortOptions, {
                initialSortBy: {
                    field: 'coverage',
                    type: 'desc'
                }
            }),
            styleClass: 'vgt-table',
            params: {
                'filter[status]': 'billed,posted',
                'include': 'customer,type'
            }
        };
    },
    created: function created() {
        if (this.$auth.user().company.api_provider.slug === 'minuba') {
            this.columns.push({ label: 'Åbn', field: 'minuba_external_id' });
        }
        this.getData();
    },

    methods: {
        getData: function getData() {
            var _this = this;

            if (this.$store.state.closedRows.length) {
                this.$store.commit('setClosedRows', null);
            }
            this.loading = true;
            this.$emit('finishedLoading', null);
            var dateFrom = this.$store.getters.getStartDate;
            var dateTo = this.$store.getters.getEndDate;
            var params = {
                'filter[status]': 'billed,posted',
                include: 'customer,type',
                'filter[between]': dateFrom + ',' + dateTo
            };
            if (this.$store.getters.getCurrentDepartment.uuid !== 0) {
                params['filter[by_department_uuid]'] = this.$store.getters.getCurrentDepartment.uuid;
            }
            __WEBPACK_IMPORTED_MODULE_2__services_projectService__["a" /* find */](params, function (response) {
                _this.rows = response.data;
                _this.$emit('finishedLoading', _this.rows.length);
                _this.loading = false;
                _this.$store.commit('setClosedRows', _this.rows);
            }, function (err) {
                console.log(err);
                _this.loading = false;
            });
        }
    },
    computed: {
        globalParams: function globalParams() {
            var startDate = this.$store.getters.getStartDate;
            var endDate = this.$store.getters.getEndDate;
            var department = this.$store.getters.getCurrentDepartment.uuid;
            return startDate + endDate + department;
        }
    },
    watch: {
        globalParams: function globalParams() {
            this.getData();
        }
    }
});

/***/ }),
/* 373 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__shared_js__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__services_projectService__ = __webpack_require__(11);






/* harmony default export */ __webpack_exports__["default"] = ({
    data: function data() {
        return {
            explanation: 'Denne tabel viser alle opgaver med en status, der angiver at den er afsluttet, men hvor der endnu ikke ligger en eller flere fakturaer tilknyttet opgaven. Hvis opgaven <b>er</b> blevet faktureret, bør du undersøge om fakturaen er tilknyttet opgaven i dit ordrestyrings-program.',
            loading: true,
            columns: [{ label: 'Ordre', field: 'case_number', type: 'number' }, { label: 'Kunde', field: 'customer.name', type: 'string' }, { label: 'Opgave', field: 'description', type: 'string' }, { label: 'Opgavetype', field: 'type.name', type: 'string' }, { label: 'Startdato', field: 'start_date', type: 'string' }, { label: 'Status', field: 'status.name', type: 'string' }],
            rows: [],
            searchOptions: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __WEBPACK_IMPORTED_MODULE_1__shared_js__["a" /* default */].searchOptions),
            paginationOptions: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __WEBPACK_IMPORTED_MODULE_1__shared_js__["a" /* default */].paginationOptions),
            sortOptions: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __WEBPACK_IMPORTED_MODULE_1__shared_js__["a" /* default */].sortOptions, {
                initialSortBy: {
                    field: 'start_date',
                    type: 'asc'
                }
            }),
            styleClass: 'vgt-table'
        };
    },
    created: function created() {
        if (this.$auth.user().company.api_provider.slug === 'minuba') {
            this.columns.push({ label: 'Åbn', field: 'minuba_external_id' });
        }
        this.getData();
    },

    methods: {
        getData: function getData() {
            var _this = this;

            this.loading = true;
            this.$emit('finishedLoading', null);
            var params = {
                'filter[status]': 'unbilled',

                'filter[visible]': true,
                include: 'type,customer,status',
                date_from: this.$store.getters.getStartDate,
                date_to: this.$store.getters.getEndDate
            };
            if (this.$store.getters.getCurrentDepartment.uuid !== 0) {
                params['filter[by_department_uuid]'] = this.$store.getters.getCurrentDepartment.uuid;
            }
            __WEBPACK_IMPORTED_MODULE_2__services_projectService__["a" /* find */](params, function (response) {
                _this.rows = response.data;
                _this.$emit('finishedLoading', _this.rows.length);
                _this.loading = false;
            }, function (err) {
                console.log(err);
                _this.loading = false;
            });
        }
    },
    computed: {
        globalParams: function globalParams() {
            var startDate = this.$store.getters.getStartDate;
            var endDate = this.$store.getters.getEndDate;
            var department = this.$store.getters.getCurrentDepartment.uuid;
            return startDate + endDate + department;
        }
    },
    watch: {
        globalParams: function globalParams() {
            this.getData();
        }
    }
});

/***/ }),
/* 374 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__shared_js__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__services_projectService__ = __webpack_require__(11);






/* harmony default export */ __webpack_exports__["default"] = ({
    props: ['title', 'rpp'],
    data: function data() {
        return {
            loading: true,
            columns: [{ label: 'Ordre', field: 'case_number', type: 'number' }, { label: 'Opgavetype', field: 'type.name', type: 'string' }, { label: 'Opgave', field: 'description', type: 'string' }, { label: 'Kunde', field: 'customer.name', type: 'string' }, { label: 'Startdato', field: 'start_date', type: 'string' }, { label: 'Status', field: 'status.name', type: 'string' }],
            rows: [],
            searchOptions: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __WEBPACK_IMPORTED_MODULE_1__shared_js__["a" /* default */].searchOptions),
            paginationOptions: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __WEBPACK_IMPORTED_MODULE_1__shared_js__["a" /* default */].paginationOptions),
            sortOptions: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __WEBPACK_IMPORTED_MODULE_1__shared_js__["a" /* default */].sortOptions),
            styleClass: 'vgt-table'
        };
    },
    created: function created() {
        if (this.$auth.user().company.api_provider.slug === 'minuba') {
            this.columns.push({ label: 'Åbn', field: 'minuba_external_id' });
        }
        this.getData();
    },

    methods: {
        getData: function getData() {
            var _this = this;

            this.loading = true;
            this.$emit('finishedLoading', null);
            var params = {
                'filter[status]': 'offer',
                'filter[visible]': true,
                include: 'customer,type,status',
                date_from: this.$store.getters.getStartDate,
                date_to: this.$store.getters.getEndDate
            };
            if (this.$store.getters.getCurrentDepartment.uuid !== 0) {
                params['filter[by_department_uuid]'] = this.$store.getters.getCurrentDepartment.uuid;
            }
            __WEBPACK_IMPORTED_MODULE_2__services_projectService__["a" /* find */](params, function (response) {
                _this.rows = response.data;
                _this.$emit('finishedLoading', _this.rows.length);
                _this.loading = false;
            }, function (err) {
                console.log(err);
                _this.loading = false;
            });
        }
    },
    computed: {
        globalParams: function globalParams() {
            var startDate = this.$store.getters.getStartDate;
            var endDate = this.$store.getters.getEndDate;
            var department = this.$store.getters.getCurrentDepartment.uuid;
            return startDate + endDate + department;
        }
    },
    watch: {
        globalParams: function globalParams() {
            this.getData();
        }
    }
});

/***/ }),
/* 375 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__shared_js__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__services_projectService__ = __webpack_require__(11);






/* harmony default export */ __webpack_exports__["default"] = ({
    props: ['title', 'rpp'],
    data: function data() {
        return {
            loading: true,
            columns: [{ label: 'Ordre', field: 'case_number', type: 'number' }, { label: 'Opgavetype', field: 'type.name', type: 'string' }, { label: 'Opgave', field: 'description', type: 'string' }, { label: 'Kunde', field: 'customer.name', type: 'string' }, { label: 'Startdato', field: 'start_date', type: 'string' }, { label: 'Status', field: 'status.name', type: 'string' }],
            rows: [],
            searchOptions: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __WEBPACK_IMPORTED_MODULE_1__shared_js__["a" /* default */].searchOptions),
            paginationOptions: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __WEBPACK_IMPORTED_MODULE_1__shared_js__["a" /* default */].paginationOptions),
            sortOptions: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __WEBPACK_IMPORTED_MODULE_1__shared_js__["a" /* default */].sortOptions),
            styleClass: 'vgt-table'
        };
    },
    created: function created() {
        if (this.$auth.user().company.api_provider.slug === 'minuba') {
            this.columns.push({ label: 'Åbn', field: 'minuba_external_id' });
        }
        this.getData();
    },

    methods: {
        getData: function getData() {
            var _this = this;

            this.loading = true;
            this.$emit('finishedLoading', null);
            var params = {
                'filter[status]': 'ongoing',
                'filter[visible]': true,
                include: 'customer,type,status',
                date_from: this.$store.getters.getStartDate,
                date_to: this.$store.getters.getEndDate
            };
            if (this.$store.getters.getCurrentDepartment.uuid !== 0) {
                params['filter[by_department_uuid]'] = this.$store.getters.getCurrentDepartment.uuid;
            }
            __WEBPACK_IMPORTED_MODULE_2__services_projectService__["a" /* find */](params, function (response) {
                _this.rows = response.data;
                _this.$emit('finishedLoading', _this.rows.length);
                _this.loading = false;
            }, function (err) {
                console.log(err);
                _this.loading = false;
            });
        }
    },
    computed: {
        globalParams: function globalParams() {
            var startDate = this.$store.getters.getStartDate;
            var endDate = this.$store.getters.getEndDate;
            var department = this.$store.getters.getCurrentDepartment.uuid;
            return startDate + endDate + department;
        }
    },
    watch: {
        globalParams: function globalParams() {
            this.getData();
        }
    }
});

/***/ }),
/* 376 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__shared_js__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__services_projectService__ = __webpack_require__(11);






/* harmony default export */ __webpack_exports__["default"] = ({
    props: ['title', 'rpp'],
    data: function data() {
        return {
            loading: true,
            columns: [{ label: 'Ordre', field: 'case_number', type: 'number' }, { label: 'Opgavetype', field: 'type.name', type: 'string' }, { label: 'Opgave', field: 'description', type: 'string' }, { label: 'Kunde', field: 'customer.name', type: 'string' }, { label: 'Startdato', field: 'start_date', type: 'string' }, { label: 'Status', field: 'status.name', type: 'string' }],
            rows: [],
            searchOptions: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __WEBPACK_IMPORTED_MODULE_1__shared_js__["a" /* default */].searchOptions),
            paginationOptions: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __WEBPACK_IMPORTED_MODULE_1__shared_js__["a" /* default */].paginationOptions),
            sortOptions: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __WEBPACK_IMPORTED_MODULE_1__shared_js__["a" /* default */].sortOptions),
            styleClass: 'vgt-table'
        };
    },
    created: function created() {
        if (this.$auth.user().company.api_provider.slug === 'minuba') {
            this.columns.push({ label: 'Åbn', field: 'minuba_external_id' });
        }
        this.getData();
    },

    methods: {
        getData: function getData() {
            var _this = this;

            this.loading = true;
            this.$emit('finishedLoading', null);
            var params = {
                'filter[status]': 'pending',
                'filter[visible]': true,
                include: 'customer,type,status',
                date_from: this.$store.getters.getStartDate,
                date_to: this.$store.getters.getEndDate
            };
            if (this.$store.getters.getCurrentDepartment.uuid !== 0) {
                params['filter[by_department_uuid]'] = this.$store.getters.getCurrentDepartment.uuid;
            }
            __WEBPACK_IMPORTED_MODULE_2__services_projectService__["a" /* find */](params, function (response) {
                _this.rows = response.data;
                _this.$emit('finishedLoading', _this.rows.length);
                _this.loading = false;
            }, function (err) {
                console.log(err);
                _this.loading = false;
            });
        }
    },
    computed: {
        globalParams: function globalParams() {
            var startDate = this.$store.getters.getStartDate;
            var endDate = this.$store.getters.getEndDate;
            var department = this.$store.getters.getCurrentDepartment.uuid;
            return startDate + endDate + department;
        }
    },
    watch: {
        globalParams: function globalParams() {
            this.getData();
        }
    }
});

/***/ }),
/* 377 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__shared_js__ = __webpack_require__(17);





/* harmony default export */ __webpack_exports__["default"] = ({
    props: ['title', 'rows'],
    data: function data() {
        return {
            testData: [],
            columns: [{ label: 'Ordre', field: 'case_number', type: 'number' }, { label: 'Opgave', field: 'description', type: 'string', width: '20%' }, { label: 'Kunde', field: 'customer.name', type: 'string' }, { label: 'Startdato', field: 'start_date', type: 'string' }, { label: 'Omsætning', field: 'invoices_total', type: 'number' }, { label: 'DB', field: 'coverage', width: '10%', type: 'number' }, { label: 'DG', field: 'coverage_percent', width: '8%', type: 'number' }, { label: 'DB/time', field: 'coverage_per_hour', width: '8%', type: 'number' }],
            rows: [],
            searchOptions: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __WEBPACK_IMPORTED_MODULE_1__shared_js__["a" /* default */].searchOptions),
            paginationOptions: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __WEBPACK_IMPORTED_MODULE_1__shared_js__["a" /* default */].paginationOptions),
            sortOptions: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __WEBPACK_IMPORTED_MODULE_1__shared_js__["a" /* default */].sortOptions, {
                initialSortBy: {
                    field: 'coverage',
                    type: 'desc'
                }
            }),
            styleClass: 'vgt-table'
        };
    },

    computed: {
        globalParams: function globalParams() {
            var startDate = this.$store.getters.getStartDate;
            var endDate = this.$store.getters.getEndDate;
            var department = this.$store.getters.getCurrentDepartment.uuid;

            return startDate + endDate + department;
        }
    },
    mounted: function mounted() {
        if (this.$auth.user().company.api_provider.slug === 'minuba') {
            this.columns.push({ label: 'Åbn', field: 'minuba_external_id' });
        }
        this.getData();
    },

    methods: {
        openExternalLink: function openExternalLink(id) {
            alert('Åbn sagsnummer ' + id + ' i Ordrestyring nu');
        }
    }
});

/***/ }),
/* 378 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__shared_js__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__services_projectService__ = __webpack_require__(11);






/* harmony default export */ __webpack_exports__["default"] = ({
    props: ['title', 'rpp'],
    data: function data() {
        return {
            loading: true,
            columns: [{ label: 'Ordre', field: 'case_number', type: 'number' }, { label: 'Opgavetype', field: 'type.name', type: 'string' }, { label: 'Opgave', field: 'description', type: 'string' }, { label: 'Kunde', field: 'customer.name', type: 'string' }, { label: 'Startdato', field: 'start_date', type: 'string' }, { label: 'Status', field: 'status.name', type: 'string' }],
            rows: [],
            searchOptions: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __WEBPACK_IMPORTED_MODULE_1__shared_js__["a" /* default */].searchOptions),
            paginationOptions: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __WEBPACK_IMPORTED_MODULE_1__shared_js__["a" /* default */].paginationOptions),
            sortOptions: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __WEBPACK_IMPORTED_MODULE_1__shared_js__["a" /* default */].sortOptions),
            styleClass: 'vgt-table'
        };
    },
    created: function created() {
        if (this.$auth.user().company.api_provider.slug === 'minuba') {
            this.columns.push({ label: 'Åbn', field: 'minuba_external_id' });
        }
        this.getData();
    },

    methods: {
        getData: function getData() {
            var _this = this;

            this.loading = true;
            this.$emit('finishedLoading', null);
            var params = {
                'filter[snoozed]': true,
                'filter[status]': 'ongoing',
                'filter[visible]': true,
                include: 'customer,type,status',
                date_from: this.$store.getters.getStartDate,
                date_to: this.$store.getters.getEndDate
            };
            if (this.$store.getters.getCurrentDepartment.uuid !== 0) {
                params['filter[by_department_uuid]'] = this.$store.getters.getCurrentDepartment.uuid;
            }
            __WEBPACK_IMPORTED_MODULE_2__services_projectService__["a" /* find */](params, function (response) {
                console.log(response);
                _this.rows = response.data;
                _this.$emit('finishedLoading', _this.rows.length);
                _this.loading = false;
            }, function (err) {
                console.log(err);
                _this.loading = false;
            });
        }
    },
    computed: {
        globalParams: function globalParams() {
            var startDate = this.$store.getters.getStartDate;
            var endDate = this.$store.getters.getEndDate;
            var department = this.$store.getters.getCurrentDepartment.uuid;
            return startDate + endDate + department;
        }
    },
    watch: {
        globalParams: function globalParams() {
            this.getData();
        }
    }
});

/***/ }),
/* 379 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash__ = __webpack_require__(80);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash__);





/* harmony default export */ __webpack_exports__["default"] = ({
    props: ['title'],
    data: function data() {
        return {
            selectedProjectType: null,
            columns: [{ label: 'Opgavetype', field: 'type', type: 'string' }, { label: 'Antal', field: 'count', type: 'number' }, { label: 'Omsætning', field: 'invoices_total', type: 'number' }, { label: 'DB', field: 'coverage', width: '10%', type: 'number' }, { label: 'DG', field: 'coverage_percent', width: '8%', type: 'number' }, { label: 'DB/time', field: 'coverage_per_hour', width: '8%', type: 'number' }],
            rows: [],
            searchOptions: {
                enabled: true,
                trigger: 'enter',
                placeholder: 'Søg og tryk enter ...',
                skipDiacritics: true
            },
            paginationOptions: {
                enabled: true,
                perPage: 30,
                rowsPerPageLabel: 'Rækker pr. side',
                allLabel: 'Alle',
                nextLabel: 'Næste',
                prevLabel: 'Forrige',
                ofLabel: 'af',
                pageLabel: 'side'
            },
            sortOptions: {
                enabled: true,
                initialSortBy: {
                    field: 'coverage',
                    type: 'desc'
                }
            },
            styleClass: 'vgt-table'
        };
    },

    computed: {
        closedRows: function closedRows() {
            return this.$store.state.closedRows;
        }
    },
    watch: {
        closedRows: function closedRows() {
            this.rows = [];
            this.$emit('finishedLoading', null);
            if (this.closedRows && this.closedRows.length) {
                this.calculateData();
            } else {
                this.$emit('finishedLoading', 0);
            }
        }
    },
    methods: {
        selectedRowClass: function selectedRowClass(row) {
            if (row.type === this.selectedProjectType) {
                return 'selected';
            }
        },
        selectProjectType: function selectProjectType(params) {
            this.selectedProjectType = params.row.type;
            this.$emit('selectProjectType', params.row.type);
        },
        openExternalLink: function openExternalLink(id) {
            alert('Åbn sagsnummer ' + id + ' i Ordrestyring nu');
        },
        calculateData: function calculateData() {
            var _this = this;

            this.rows = [];
            var groupedProjects = this.$store.getters.groupedProjects;

            __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(groupedProjects).forEach(function (projectType) {
                var invoicesTotalArray = groupedProjects[projectType].map(function (project) {
                    return Math.round(project.invoices_total);
                });

                var summedInvoicesTotal = __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.reduce(invoicesTotalArray, function (sum, invoicesTotal) {
                    return sum + invoicesTotal;
                });

                var coverageArray = groupedProjects[projectType].map(function (project) {
                    return Math.round(project.coverage);
                });

                var summedCoverage = __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.reduce(coverageArray, function (sum, coverage) {
                    return sum + coverage;
                });

                var timelogArray = groupedProjects[projectType].map(function (project) {
                    return Math.round(project.timelog_hours);
                });

                var summedTimelogTotal = __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.reduce(timelogArray, function (sum, timelogHours) {
                    return sum + timelogHours;
                });

                var coveragePercentArray = [];
                var coveragePerHourArray = [];
                groupedProjects[projectType].forEach(function (project) {
                    if (project.coverage_percent) {
                        coveragePercentArray.push(Math.round(project.coverage_percent));
                    }
                    if (project.coverage_per_hour) {
                        coveragePerHourArray.push(project.coverage_per_hour);
                    }
                });

                var averageCoveragePercent = __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.mean(coveragePercentArray);
                var averageCoveragePerHour = __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.mean(coveragePerHourArray);

                var item = {
                    type: projectType,
                    count: groupedProjects[projectType].length,
                    invoices_total: summedInvoicesTotal,
                    coverage: summedCoverage,
                    coverage_percent_avg: Math.round(averageCoveragePercent),
                    coverage_percent: Math.round(summedCoverage / summedInvoicesTotal * 100),
                    coverage_per_hour_avg: Math.round(averageCoveragePerHour),
                    coverage_per_hour: summedTimelogTotal > 0 && summedCoverage > 0 ? Math.round(summedCoverage / summedTimelogTotal) : 0
                };
                _this.rows.push(item);
            });
            this.$emit('finishedLoading', this.rows.length);
        }
    }
});

/***/ }),
/* 380 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
    data: function data() {
        return {
            showHelper: false,
            selectedTable: 'customerTypeRevenue',
            sidebarMenuItems: [{
                name: 'Hvilke kundetyper tjener vi penge på?',
                tableName: 'customerTypeRevenue'
            }]
        };
    },

    computed: {},
    methods: {
        updateCount: function updateCount(tableName, event) {
            this.counts[tableName] = event;
        }
    }
});

/***/ }),
/* 381 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
    data: function data() {
        return {
            selectedItem: 'customerTypeRevenue',
            counts: {
                customerRevenue: null,
                customerTypeRevenue: null
            },
            switchItems: [{
                name: 'Hvilke kundetyper tjener vi penge på?',
                slug: 'customerTypeRevenue'
            }, {
                name: 'Hvilke konkrete kunder tjener vi penge på?',
                slug: 'customerRevenue'
            }, {
                name: 'Hvordan er kunderne fordelt på omsætning?',
                slug: 'customerRevenueGrouped'
            }]
        };
    },

    methods: {
        updateCount: function updateCount(slug, event) {
            this.counts[slug] = event;
        },
        handleSelectItem: function handleSelectItem(item) {
            this.selectedItem = item;
        }
    },
    mounted: function mounted() {
        this.$store.state.view = 'learning';
    },

    components: {
        'customer-revenue': __webpack_require__(695),
        'customer-type-revenue': __webpack_require__(698),
        'customer-revenue-grouped': __webpack_require__(696)
    }
});

/***/ }),
/* 382 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
    data: function data() {
        return {
            selectedItem: 'openProjects',
            counts: {
                openProjects: null,
                snoozedProjects: null,
                noInvoiceProjects: null,
                ongoingProjects: null,
                openClaims: null,
                projectsCloseToBudget: '-'
            },
            switchItems: [{
                name: 'Ikke igangsatte opgaver',
                slug: 'openProjects'
            }, {
                name: 'Opgaver uden bevægelse i ' + this.$store.state.config.companyMeta.settings.snoozed_days + ' dage',
                slug: 'snoozedProjects'
            }, {
                name: 'Afsluttede opgaver, der ikke er fakturerede',
                slug: 'noInvoiceProjects'
            }, {
                name: 'Igangværende opgaver',
                slug: 'ongoingProjects'
            }, {
                name: 'Igangværende reklamationer',
                slug: 'openClaims'
            }]
        };
    },

    methods: {
        updateCount: function updateCount(slug, event) {
            this.counts[slug] = event;
        },
        handleSelectItem: function handleSelectItem(item) {
            this.selectedItem = item;
        }
    },
    mounted: function mounted() {
        this.$store.state.view = 'operations';
    }
});

/***/ }),
/* 383 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
    props: {
        customers: {
            type: Array,
            default: function _default() {
                return [];
            }
        },
        name: {
            type: String
        }
    },
    data: function data() {
        return {
            selectedRow: null,
            rows: [],
            columns: [{ label: 'Kunde', field: 'name', type: 'string' }, { label: 'Omsætning', field: 'invoices_total', type: 'number' }, { label: 'DB', field: 'coverage', type: 'number' }, { label: 'DG', field: 'coverage_percent', type: 'number' }, { label: 'DB pr. time', field: 'coverage_per_hour', type: 'number' }],
            searchOptions: {
                enabled: true,
                trigger: 'enter',
                placeholder: 'Søg og tryk enter ...',
                skipDiacritics: true
            },
            paginationOptions: {
                enabled: true,
                perPage: 10,
                rowsPerPageLabel: 'Rækker pr. side',
                allLabel: 'Alle',
                nextLabel: 'Næste',
                prevLabel: 'Forrige',
                ofLabel: 'af',
                pageLabel: 'side'
            },
            sortOptions: {
                enabled: true,
                initialSortBy: {
                    field: 'coverage',
                    type: 'desc'
                }
            },
            styleClass: 'vgt-table'
        };
    }
});

/***/ }),
/* 384 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__(470);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(468);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__services_customerService__ = __webpack_require__(92);







/* harmony default export */ __webpack_exports__["default"] = ({
    data: function data() {
        return {
            selectedRow: null,
            loading: false,
            rows: [],
            columns: [{ label: 'Kunde', field: 'name', type: 'string' }, { label: 'Omsætning', field: 'invoices_total', type: 'number' }, { label: 'DB', field: 'coverage', type: 'number' }, { label: 'DG', field: 'coverage_percent', type: 'number' }, { label: 'DB pr. time', field: 'coverage_per_hour', type: 'number' }],
            searchOptions: {
                enabled: true,
                trigger: 'enter',
                placeholder: 'Søg og tryk enter ...',
                skipDiacritics: true
            },
            paginationOptions: {
                enabled: true,
                perPage: 30,
                rowsPerPageLabel: 'Rækker pr. side',
                allLabel: 'Alle',
                nextLabel: 'Næste',
                prevLabel: 'Forrige',
                ofLabel: 'af',
                pageLabel: 'side'
            },
            sortOptions: {
                enabled: true,
                initialSortBy: {
                    field: 'coverage',
                    type: 'desc'
                }
            },
            styleClass: 'vgt-table'
        };
    },
    created: function created() {
        var _this = this;

        __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee() {
            return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
                while (1) {
                    switch (_context.prev = _context.next) {
                        case 0:
                            _context.next = 2;
                            return _this.getData();

                        case 2:
                        case 'end':
                            return _context.stop();
                    }
                }
            }, _callee, _this);
        }))();
    },

    methods: {
        getData: function getData() {
            var _this2 = this;

            return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
                _this2.loading = true;
                _this2.$emit('finishedLoading', null);
                _this2.$store.commit('setCustomerRevenueRows', []);
                _this2.selectedRow = null;
                var params = {
                    date_from: _this2.$store.getters.getStartDate,
                    date_to: _this2.$store.getters.getEndDate
                };
                if (_this2.$store.getters.getCurrentDepartment.uuid !== 0) {
                    params.department = _this2.$store.getters.getCurrentDepartment.uuid;
                }
                __WEBPACK_IMPORTED_MODULE_3__services_customerService__["b" /* customerActivity */](params, function (response) {
                    _this2.rows = response.data;
                    _this2.$emit('finishedLoading', _this2.rows.length);
                    _this2.loading = false;
                    _this2.$store.commit('setCustomerRevenueRows', _this2.rows);
                    resolve(response.data);
                }, function (err) {
                    console.log(err);
                    _this2.loading = false;
                    reject(err);
                });
            });
        },
        selectCustomer: function selectCustomer(customer) {
            this.selectedRow = customer.row;
        },
        selectedRowClass: function selectedRowClass(row) {
            if (this.selectedRow && row.uuid === this.selectedRow.uuid) {
                return 'selected';
            }
        }
    },
    components: {
        'customer-revenue-single': __webpack_require__(697)
    },
    computed: {
        globalParams: function globalParams() {
            var startDate = this.$store.getters.getStartDate;
            var endDate = this.$store.getters.getEndDate;
            var department = this.$store.getters.getCurrentDepartment.uuid;
            return startDate + endDate + department;
        }
    },
    watch: {
        globalParams: function globalParams() {
            this.getData();
        }
    }
});

/***/ }),
/* 385 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash__ = __webpack_require__(80);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash__);





/* harmony default export */ __webpack_exports__["default"] = ({
    props: ['title'],
    data: function data() {
        return {
            groupBy: 'invoices_total',
            selectedBracket: '',
            selectedProjectType: null,
            selectedRow: null,
            loading: false,
            columns: [{ label: 'Omsætning pr. kunde', field: 'bracket', type: 'string', sortable: false }, { label: 'Kunder', field: 'count', type: 'number' }, { label: 'Omsætning i alt', field: 'invoices_total', width: '10%', type: 'number' }, { label: 'DB', field: 'coverage', width: '10%', type: 'number' }, { label: 'DG', field: 'coverage_percent', width: '8%', type: 'number' }, { label: 'DB/time', field: 'coverage_per_hour', width: '8%', type: 'number' }],
            rows: [],
            searchOptions: {
                enabled: true,
                trigger: 'enter',
                placeholder: 'Søg og tryk enter ...',
                skipDiacritics: true
            },
            paginationOptions: {
                enabled: true,
                perPage: 30,
                rowsPerPageLabel: 'Rækker pr. side',
                allLabel: 'Alle',
                nextLabel: 'Næste',
                prevLabel: 'Forrige',
                ofLabel: 'af',
                pageLabel: 'side'
            },
            sortOptions: {
                enabled: true
            },
            styleClass: 'vgt-table'
        };
    },

    computed: {
        customerRevenueRows: function customerRevenueRows() {
            return this.$store.state.customerRevenueRows;
        },
        groupedCustomers: function groupedCustomers() {
            return __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.groupBy(this.customerRevenueRows, function (customer) {
                if (customer.invoices_total <= 2000) {
                    return '0 - 2.000';
                } else if (customer.invoices_total <= 5000) {
                    return '2.001 - 5.000';
                } else if (customer.invoices_total <= 10000) {
                    return '5.001 - 10.000';
                } else if (customer.invoices_total <= 20000) {
                    return '10.001 - 20.000';
                } else if (customer.invoices_total <= 50000) {
                    return '20.001 - 50.000';
                } else if (customer.invoices_total <= 100000) {
                    return '50.001 - 100.000';
                } else {
                    return 'over 100.000';
                }
            });
        }
    },
    watch: {
        customerRevenueRows: function customerRevenueRows() {
            if (this.customerRevenueRows.length) {
                this.calculateData();
            }
        }
    },
    methods: {
        selectedRowClass: function selectedRowClass(row) {
            if (row.bracket === this.selectedBracket) {
                return 'selected';
            }
        },
        handleRowClick: function handleRowClick(params) {
            this.selectedBracket = params.row.bracket;
        },
        openExternalLink: function openExternalLink(id) {
            alert('Åbn sagsnummer ' + id + ' i Ordrestyring nu');
        },
        calculateData: function calculateData() {
            var _this = this;

            this.rows = [];
            __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(this.groupedCustomers).forEach(function (customerBracket) {
                var invoicesTotalArray = _this.groupedCustomers[customerBracket].map(function (customer) {
                    return Math.round(customer.invoices_total);
                });

                var summedInvoicesTotal = __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.reduce(invoicesTotalArray, function (sum, invoicesTotal) {
                    return sum + invoicesTotal;
                });

                var coverageArray = _this.groupedCustomers[customerBracket].map(function (customer) {
                    return Math.round(customer.coverage);
                });

                var summedCoverage = __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.reduce(coverageArray, function (sum, coverage) {
                    return sum + coverage;
                });

                var coveragePercentArray = [];
                var coveragePerHourArray = [];
                _this.groupedCustomers[customerBracket].forEach(function (customer) {
                    if (customer.coverage_percent) {
                        coveragePercentArray.push(Math.round(customer.coverage_percent));
                    }
                    if (customer.coverage_per_hour) {
                        coveragePerHourArray.push(customer.coverage_per_hour);
                    }
                });

                var averageCoveragePercent = __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.mean(coveragePercentArray);
                var averageCoveragePerHour = __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.mean(coveragePerHourArray);

                var item = {
                    bracket: customerBracket,
                    count: _this.groupedCustomers[customerBracket].length,
                    invoices_total: summedInvoicesTotal,
                    coverage: summedCoverage,
                    coverage_percent_avg: Math.round(averageCoveragePercent),
                    coverage_percent: Math.round(summedCoverage / summedInvoicesTotal * 100),
                    coverage_per_hour: Math.round(averageCoveragePerHour)
                };
                _this.rows.push(item);
            });
            this.rows.sort(function (a, b) {
                var aSubstring = parseInt(a.bracket.substring(a.bracket.lastIndexOf(' ') + 1, a.bracket.lastIndexOf('.')));
                var bSubstring = parseInt(b.bracket.substring(b.bracket.lastIndexOf(' ') + 1, b.bracket.lastIndexOf('.')));
                return aSubstring > bSubstring ? 1 : -1;
            });
            this.$emit('finishedLoading', this.rows.length);
        }
    },
    components: {
        'customer-grouped-single': __webpack_require__(694)
    }
});

/***/ }),
/* 386 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
    props: {
        data: {
            required: true
        }
    },
    mounted: function mounted() {
        if (this.$auth.user().company.api_provider.slug === 'minuba') {
            this.columns.push({ label: 'Åbn', field: 'minuba_external_id' });
        }
    },
    data: function data() {
        return {
            customer: null,
            rows: [],
            columns: [{ label: 'Ordre', field: 'case_number', type: 'string' }, { label: 'Opgave', field: 'description', type: 'string' }, { label: 'Omsætning', field: 'invoices_total', type: 'number' }, { label: 'DB', field: 'coverage', type: 'number' }, { label: 'DG', field: 'coverage_percent', type: 'number' }, { label: 'DB pr. time', field: 'coverage_per_hour', type: 'number' }],
            searchOptions: {
                enabled: true,
                trigger: 'enter',
                placeholder: 'Søg og tryk enter ...',
                skipDiacritics: true
            },
            paginationOptions: {
                enabled: true,
                perPage: 30,
                rowsPerPageLabel: 'Rækker pr. side',
                allLabel: 'Alle',
                nextLabel: 'Næste',
                prevLabel: 'Forrige',
                ofLabel: 'af',
                pageLabel: 'side'
            },
            sortOptions: {
                enabled: true,
                initialSortBy: {
                    field: 'coverage',
                    type: 'desc'
                }
            },
            styleClass: 'vgt-table'
        };
    }
});

/***/ }),
/* 387 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_customerService__ = __webpack_require__(92);




/* harmony default export */ __webpack_exports__["default"] = ({
    data: function data() {
        return {
            selectedRow: null,
            loading: true,
            rows: [],
            columns: [{ label: 'Kundetype', field: 'name', type: 'string' }, { label: 'Antal', field: 'customers_count', type: 'number' }, { label: 'Omsætning', field: 'invoices_total', type: 'number' }, { label: 'DB', field: 'coverage', type: 'number' }, { label: 'DG', field: 'coverage_percent', type: 'number' }, { label: 'DB pr. time', field: 'coverage_per_hour', type: 'number' }],
            searchOptions: {
                enabled: true,
                trigger: 'enter',
                placeholder: 'Søg og tryk enter ...',
                skipDiacritics: true
            },
            paginationOptions: {
                enabled: true,
                perPage: 30,
                rowsPerPageLabel: 'Rækker pr. side',
                allLabel: 'Alle',
                nextLabel: 'Næste',
                prevLabel: 'Forrige',
                ofLabel: 'af',
                pageLabel: 'side'
            },
            sortOptions: {
                enabled: true,
                initialSortBy: {
                    field: 'coverage',
                    type: 'desc'
                }
            },
            styleClass: 'vgt-table'
        };
    },
    created: function created() {
        this.getData();
    },

    methods: {
        getData: function getData() {
            var _this = this;

            this.loading = true;
            this.$emit('finishedLoading', null);
            this.selectedRow = null;
            var params = {
                date_from: this.$store.getters.getStartDate,
                date_to: this.$store.getters.getEndDate
            };
            if (this.$store.getters.getCurrentDepartment.uuid !== 0) {
                params.department = this.$store.getters.getCurrentDepartment.uuid;
            }
            __WEBPACK_IMPORTED_MODULE_0__services_customerService__["a" /* customerCategoryActivity */](params, function (response) {
                _this.rows = response.data;
                _this.loading = false;
                _this.$emit('finishedLoading', _this.rows.length);
            }, function (err) {
                console.log(err);
                _this.loading = false;
            });
        },
        selectCustomerType: function selectCustomerType(customerType) {
            this.selectedRow = customerType.row;
        },
        selectedRowClass: function selectedRowClass(row) {
            if (this.selectedRow && row.name === this.selectedRow.name) {
                return 'selected';
            }
        }
    },
    components: {
        'customer-type-revenue-single': __webpack_require__(699)
    },
    computed: {
        globalParams: function globalParams() {
            var startDate = this.$store.getters.getStartDate;
            var endDate = this.$store.getters.getEndDate;
            var department = this.$store.getters.getCurrentDepartment.uuid;
            return startDate + endDate + department;
        }
    },
    watch: {
        globalParams: function globalParams() {
            this.getData();
        }
    }
});

/***/ }),
/* 388 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
    props: ['data'],
    data: function data() {
        return {
            loading: false,
            customer: null,
            rows: [],
            columns: [{ label: 'Kunde', field: 'name', type: 'string' }, { label: 'Omsætning', field: 'invoices_total', type: 'number' }, { label: 'DB', field: 'coverage', type: 'number' }, { label: 'DG', field: 'coverage_percent', type: 'number' }, { label: 'DB pr. time', field: 'coverage_per_hour', type: 'number' }],
            searchOptions: {
                enabled: true,
                trigger: 'enter',
                placeholder: 'Søg og tryk enter ...',
                skipDiacritics: true
            },
            paginationOptions: {
                enabled: true,
                perPage: 30,
                rowsPerPageLabel: 'Rækker pr. side',
                allLabel: 'Alle',
                nextLabel: 'Næste',
                prevLabel: 'Forrige',
                ofLabel: 'af',
                pageLabel: 'side'
            },
            sortOptions: {
                enabled: true,
                initialSortBy: {
                    field: 'coverage',
                    type: 'desc'
                }
            },
            styleClass: 'vgt-table'
        };
    }
});

/***/ }),
/* 389 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_apexcharts__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_apexcharts___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_apexcharts__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__services_economyService__ = __webpack_require__(4);





/* harmony default export */ __webpack_exports__["default"] = ({
    data: function data() {
        var _this = this;

        return {
            loading: true,
            height: '400',
            unit: ' kr.',
            options: {
                labels: [],
                yaxis: {
                    labels: {
                        formatter: function formatter(value) {
                            return _this.$options.filters.currency(value);
                        }
                    },
                    title: {
                        text: this.ylabel
                    },
                    forceNiceScale: true,
                    min: 0
                },
                stroke: {
                    width: 3,
                    curve: 'smooth'
                },
                legend: {
                    offsetY: 10,
                    itemMargin: {
                        horizontal: 5,
                        vertical: 10
                    },
                    position: 'bottom'
                },
                colors: this.$store.state.graphColors
            },
            series: []
        };
    },

    components: {
        VueApexCharts: __WEBPACK_IMPORTED_MODULE_0_vue_apexcharts___default.a
    },
    created: function created() {
        this.getData();
    },

    methods: {
        getData: function getData() {
            var _this2 = this;

            this.loading = true;
            this.series = [];
            var params = {
                date_from: this.$store.getters.getStartDate,
                date_to: this.$store.getters.getEndDate
            };

            __WEBPACK_IMPORTED_MODULE_1__services_economyService__["k" /* compareCoverage */](params, function (response) {
                _this2.options.labels = response.data.labels;
                _this2.series = response.data.series;

                _this2.loading = false;
                _this2.$emit('finishedLoading', response.data.series.length);
            }, function (err) {
                console.log(err);
                _this2.loading = false;
            });
        }
    },
    computed: {
        globalParams: function globalParams() {
            var startDate = this.$store.getters.getStartDate;
            var endDate = this.$store.getters.getEndDate;

            return startDate + endDate;
        }
    },
    watch: {
        globalParams: function globalParams() {
            this.getData();
        }
    }
});

/***/ }),
/* 390 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_apexcharts__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_apexcharts___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_apexcharts__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__services_economyService__ = __webpack_require__(4);





/* harmony default export */ __webpack_exports__["default"] = ({
    data: function data() {
        var _this = this;

        return {
            loading: true,
            height: '400',
            unit: ' kr.',
            options: {
                labels: [],
                yaxis: {
                    labels: {
                        formatter: function formatter(value) {
                            return _this.$options.filters.currency(value);
                        }
                    },
                    title: {
                        text: this.ylabel
                    },
                    forceNiceScale: true,
                    min: 0
                },
                stroke: {
                    width: 3,
                    curve: 'smooth'
                },
                legend: {
                    offsetY: 10,
                    itemMargin: {
                        horizontal: 5,
                        vertical: 10
                    },
                    position: 'bottom'
                },
                colors: this.$store.state.graphColors
            },
            series: []
        };
    },

    components: {
        VueApexCharts: __WEBPACK_IMPORTED_MODULE_0_vue_apexcharts___default.a
    },
    created: function created() {
        this.getData();
    },

    methods: {
        getData: function getData() {
            var _this2 = this;

            this.loading = true;
            this.series = [];
            var params = {
                date_from: this.$store.getters.getStartDate,
                date_to: this.$store.getters.getEndDate
            };

            __WEBPACK_IMPORTED_MODULE_1__services_economyService__["j" /* compareCoveragePerHour */](params, function (response) {
                _this2.options.labels = response.data.labels;
                _this2.series = response.data.series;

                _this2.loading = false;
                _this2.$emit('finishedLoading', response.data.series.length);
            }, function (err) {
                console.log(err);
                _this2.loading = false;
            });
        }
    },
    computed: {
        globalParams: function globalParams() {
            var startDate = this.$store.getters.getStartDate;
            var endDate = this.$store.getters.getEndDate;

            return startDate + endDate;
        }
    },
    watch: {
        globalParams: function globalParams() {
            this.getData();
        }
    }
});

/***/ }),
/* 391 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_apexcharts__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_apexcharts___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_apexcharts__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__services_economyService__ = __webpack_require__(4);





/* harmony default export */ __webpack_exports__["default"] = ({
    data: function data() {
        return {
            loading: true,
            height: '400',
            unit: ' %',
            options: {
                labels: [],
                yaxis: {
                    labels: {
                        formatter: function formatter(value) {
                            if (value > 0) {
                                return value + ' %';
                            } else {
                                return '- %';
                            }
                        }
                    },
                    title: {
                        text: this.ylabel
                    },
                    forceNiceScale: false,
                    min: 0,
                    max: 100
                },
                stroke: {
                    width: 3,
                    curve: 'smooth'
                },
                legend: {
                    offsetY: 10,
                    itemMargin: {
                        horizontal: 5,
                        vertical: 10
                    },
                    position: 'bottom'
                },
                colors: this.$store.state.graphColors
            },
            series: []
        };
    },

    components: {
        VueApexCharts: __WEBPACK_IMPORTED_MODULE_0_vue_apexcharts___default.a
    },
    created: function created() {
        this.getData();
    },

    methods: {
        getData: function getData() {
            var _this = this;

            this.loading = true;
            this.series = [];
            var params = {
                date_from: this.$store.getters.getStartDate,
                date_to: this.$store.getters.getEndDate
            };

            __WEBPACK_IMPORTED_MODULE_1__services_economyService__["l" /* compareCoveragePercent */](params, function (response) {
                _this.options.labels = response.data.labels;
                _this.series = response.data.series;

                _this.loading = false;
                _this.$emit('finishedLoading', response.data.series.length);
            }, function (err) {
                console.log(err);
                _this.loading = false;
            });
        }
    },
    computed: {
        globalParams: function globalParams() {
            var startDate = this.$store.getters.getStartDate;
            var endDate = this.$store.getters.getEndDate;

            return startDate + endDate;
        }
    },
    watch: {
        globalParams: function globalParams() {
            this.getData();
        }
    }
});

/***/ }),
/* 392 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_apexcharts__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_apexcharts___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_apexcharts__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__services_economyService__ = __webpack_require__(4);





/* harmony default export */ __webpack_exports__["default"] = ({
    data: function data() {
        return {
            loading: true,
            height: '400',
            unit: ' %',
            options: {
                labels: [],
                yaxis: {
                    labels: {
                        formatter: function formatter(value) {
                            if (value > 0) {
                                return value + ' %';
                            } else {
                                return '- %';
                            }
                        }
                    },
                    title: {
                        text: this.ylabel
                    },
                    forceNiceScale: false,
                    min: 0,
                    max: 100
                },
                stroke: {
                    width: 3,
                    curve: 'smooth'
                },
                legend: {
                    offsetY: 10,
                    itemMargin: {
                        horizontal: 5,
                        vertical: 10
                    },
                    position: 'bottom'
                },
                colors: this.$store.state.graphColors
            },
            series: []
        };
    },

    components: {
        VueApexCharts: __WEBPACK_IMPORTED_MODULE_0_vue_apexcharts___default.a
    },
    created: function created() {
        this.getData();
    },

    methods: {
        getData: function getData() {
            var _this = this;

            this.loading = true;
            this.series = [];
            var params = {
                date_from: this.$store.getters.getStartDate,
                date_to: this.$store.getters.getEndDate
            };

            __WEBPACK_IMPORTED_MODULE_1__services_economyService__["i" /* compareCustomerHours */](params, function (response) {
                _this.options.labels = response.data.labels;
                _this.series = response.data.series;

                _this.loading = false;
                _this.$emit('finishedLoading', response.data.series.length);
            }, function (err) {
                console.log(err);
                _this.loading = false;
            });
        }
    },
    computed: {
        globalParams: function globalParams() {
            var startDate = this.$store.getters.getStartDate;
            var endDate = this.$store.getters.getEndDate;

            return startDate + endDate;
        }
    },
    watch: {
        globalParams: function globalParams() {
            this.getData();
        }
    }
});

/***/ }),
/* 393 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_economyService__ = __webpack_require__(4);




/* harmony default export */ __webpack_exports__["default"] = ({
    data: function data() {
        return {
            loading: true,
            rows: [],
            columns: [{ label: 'Afdeling', field: 'name', type: 'string' }, { label: 'Opgaver', field: 'projects_count', type: 'number' }, { label: 'Omsætning', field: 'total_revenue', type: 'number' }, { label: 'Dækningsbidrag', field: 'coverage', type: 'number' }, { label: 'DG', field: 'coverage_percent', type: 'number' }, { label: 'DB pr. time', field: 'coverage_per_hour', type: 'number' }, { label: 'Tid hos kunder', field: 'hours_with_customers', type: 'number' }],
            searchOptions: {
                enabled: true,
                trigger: 'enter',
                placeholder: 'Søg og tryk enter ...',
                skipDiacritics: true
            },
            paginationOptions: {
                enabled: true,
                perPage: 15,
                rowsPerPageLabel: 'Rækker pr. side',
                allLabel: 'Alle',
                nextLabel: 'Næste',
                prevLabel: 'Forrige',
                ofLabel: 'af',
                pageLabel: 'side'
            },
            sortOptions: {
                enabled: true,
                initialSortBy: {
                    field: 'coverage',
                    type: 'desc'
                }
            },
            styleClass: 'vgt-table'
        };
    },
    created: function created() {
        this.getData();
    },

    methods: {
        getData: function getData() {
            var _this = this;

            this.loading = true;
            var params = {
                date_from: this.$store.getters.getStartDate,
                date_to: this.$store.getters.getEndDate
            };

            __WEBPACK_IMPORTED_MODULE_0__services_economyService__["n" /* compareKeyfigures */](params, function (response) {
                _this.rows = response.data;
                _this.loading = false;
            }, function (err) {
                console.log(err);
                _this.loading = false;
            });
        }
    },
    computed: {
        globalParams: function globalParams() {
            var startDate = this.$store.getters.getStartDate;
            var endDate = this.$store.getters.getEndDate;

            return startDate + endDate;
        }
    },
    watch: {
        globalParams: function globalParams() {
            this.getData();
        }
    }
});

/***/ }),
/* 394 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_apexcharts__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_apexcharts___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_apexcharts__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__services_economyService__ = __webpack_require__(4);





/* harmony default export */ __webpack_exports__["default"] = ({
    data: function data() {
        var _this = this;

        return {
            loading: true,
            height: '400',
            unit: ' kr.',
            options: {
                labels: [],
                yaxis: {
                    labels: {
                        formatter: function formatter(value) {
                            return _this.$options.filters.currency(value);
                        }
                    },
                    title: {
                        text: this.ylabel
                    },
                    forceNiceScale: true,
                    min: 0
                },
                stroke: {
                    width: 3,
                    curve: 'smooth'
                },
                legend: {
                    offsetY: 10,
                    itemMargin: {
                        horizontal: 5,
                        vertical: 10
                    },
                    position: 'bottom'
                },
                colors: this.$store.state.graphColors
            },
            series: []
        };
    },

    components: {
        VueApexCharts: __WEBPACK_IMPORTED_MODULE_0_vue_apexcharts___default.a
    },
    created: function created() {
        this.getData();
    },

    methods: {
        getData: function getData() {
            var _this2 = this;

            this.loading = true;
            this.series = [];
            var params = {
                date_from: this.$store.getters.getStartDate,
                date_to: this.$store.getters.getEndDate
            };

            __WEBPACK_IMPORTED_MODULE_1__services_economyService__["m" /* compareRevenue */](params, function (response) {
                _this2.options.labels = response.data.labels;
                _this2.series = response.data.series;

                _this2.loading = false;
                _this2.$emit('finishedLoading', response.data.series.length);
            }, function (err) {
                console.log(err);
                _this2.loading = false;
            });
        }
    },
    computed: {
        globalParams: function globalParams() {
            var startDate = this.$store.getters.getStartDate;
            var endDate = this.$store.getters.getEndDate;

            return startDate + endDate;
        }
    },
    watch: {
        globalParams: function globalParams() {
            this.getData();
        }
    }
});

/***/ }),
/* 395 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_economyService__ = __webpack_require__(4);




/* harmony default export */ __webpack_exports__["default"] = ({
    data: function data() {
        return {
            loading: false,
            showCalculations: true,
            data: null
        };
    },
    created: function created() {
        this.getData();
    },

    methods: {
        getData: function getData() {
            var _this = this;

            this.loading = true;
            this.data = null;

            var params = {
                date_from: this.$store.getters.getStartDate,
                date_to: this.$store.getters.getEndDate
            };
            __WEBPACK_IMPORTED_MODULE_0__services_economyService__["h" /* costpricePerHour */](params, function (response) {
                _this.data = response.data;
                _this.loading = false;
            }, function (err) {
                console.log(err);
                _this.loading = false;
            });
        }
    },
    computed: {
        globalParams: function globalParams() {
            var startDate = this.$store.getters.getStartDate;
            var endDate = this.$store.getters.getEndDate;
            var department = this.$store.getters.getCurrentDepartment.uuid;
            return startDate + endDate + department;
        }
    },
    watch: {
        globalParams: function globalParams() {
            this.getData();
        }
    }
});

/***/ }),
/* 396 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_economyService__ = __webpack_require__(4);




/* harmony default export */ __webpack_exports__["default"] = ({
    data: function data() {
        return {
            loading: false,
            data: null
        };
    },
    created: function created() {
        this.getData();
    },

    methods: {
        getData: function getData() {
            var _this = this;

            this.loading = true;
            this.data = null;
            var params = {
                date_from: this.$store.getters.getStartDate,
                date_to: this.$store.getters.getEndDate
            };
            if (this.$store.getters.getCurrentDepartment.uuid !== 0) {
                params.department = this.$store.getters.getCurrentDepartment.uuid;
            }
            __WEBPACK_IMPORTED_MODULE_0__services_economyService__["g" /* costsDivision */](params, function (response) {
                _this.data = response.data;
                _this.loading = false;
            }, function (err) {
                console.log(err);
                _this.loading = false;
            });
        }
    },
    computed: {
        globalParams: function globalParams() {
            var startDate = this.$store.getters.getStartDate;
            var endDate = this.$store.getters.getEndDate;
            var department = this.$store.getters.getCurrentDepartment.uuid;
            return startDate + endDate + department;
        }
    },
    watch: {
        globalParams: function globalParams() {
            this.getData();
        }
    }
});

/***/ }),
/* 397 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_economyService__ = __webpack_require__(4);




/* harmony default export */ __webpack_exports__["default"] = ({
    data: function data() {
        return {
            loading: true,
            rows: [],
            columns: [{ label: 'Navn', field: 'name', type: 'string' }, { label: 'Antal brugt', field: 'total_quantity', type: 'number' }, { label: 'Total kostpris', field: 'total_cost', type: 'number' }],
            searchOptions: {
                enabled: true,
                trigger: 'enter',
                placeholder: 'Søg og tryk enter ...',
                skipDiacritics: true
            },
            paginationOptions: {
                enabled: true,
                perPage: 15,
                rowsPerPageLabel: 'Rækker pr. side',
                allLabel: 'Alle',
                nextLabel: 'Næste',
                prevLabel: 'Forrige',
                ofLabel: 'af',
                pageLabel: 'side'
            },
            sortOptions: {
                enabled: true,
                initialSortBy: {
                    field: 'total_cost',
                    type: 'desc'
                }
            },
            styleClass: 'vgt-table'
        };
    },
    created: function created() {
        this.getData();
    },

    methods: {
        getData: function getData() {
            var _this = this;

            this.loading = true;
            var params = {
                date_from: this.$store.getters.getStartDate,
                date_to: this.$store.getters.getEndDate
            };
            if (this.$store.getters.getCurrentDepartment.uuid !== 0) {
                params.department = this.$store.getters.getCurrentDepartment.uuid;
            }
            __WEBPACK_IMPORTED_MODULE_0__services_economyService__["f" /* materialUsage */](params, function (response) {
                _this.rows = response.data;
                _this.loading = false;
            }, function (err) {
                console.log(err);
                _this.loading = false;
            });
        }
    },
    computed: {
        globalParams: function globalParams() {
            var startDate = this.$store.getters.getStartDate;
            var endDate = this.$store.getters.getEndDate;
            var department = this.$store.getters.getCurrentDepartment.uuid;
            return startDate + endDate + department;
        }
    },
    watch: {
        globalParams: function globalParams() {
            this.getData();
        }
    }
});

/***/ }),
/* 398 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_economyService__ = __webpack_require__(4);




/* harmony default export */ __webpack_exports__["default"] = ({
    data: function data() {
        return {
            loading: true,
            rows: [],
            columns: [{ label: 'Navn', field: 'name', type: 'string' }, { label: 'Antal købt', field: 'total_quantity', type: 'number' }, { label: 'Total købspris', field: 'total_cost', type: 'number' }, { label: 'Kostpris pr. enhed (gns)', field: 'avg_price_per_material', type: 'number' }],
            searchOptions: {
                enabled: true,
                trigger: 'enter',
                placeholder: 'Søg og tryk enter ...',
                skipDiacritics: true
            },
            paginationOptions: {
                enabled: true,
                perPage: 15,
                rowsPerPageLabel: 'Rækker pr. side',
                allLabel: 'Alle',
                nextLabel: 'Næste',
                prevLabel: 'Forrige',
                ofLabel: 'af',
                pageLabel: 'side'
            },
            sortOptions: {
                enabled: true,
                initialSortBy: {
                    field: 'total_cost',
                    type: 'desc'
                }
            },
            styleClass: 'vgt-table'
        };
    },
    created: function created() {
        this.getData();
    },

    methods: {
        getData: function getData() {
            var _this = this;

            this.loading = true;
            var params = {
                date_from: this.$store.getters.getStartDate,
                date_to: this.$store.getters.getEndDate
            };
            if (this.$store.getters.getCurrentDepartment.uuid !== 0) {
                params.department = this.$store.getters.getCurrentDepartment.uuid;
            }
            __WEBPACK_IMPORTED_MODULE_0__services_economyService__["e" /* suppliers */](params, function (response) {
                _this.rows = response.data;
                _this.loading = false;
            }, function (err) {
                console.log(err);
                _this.loading = false;
            });
        }
    },
    computed: {
        globalParams: function globalParams() {
            var startDate = this.$store.getters.getStartDate;
            var endDate = this.$store.getters.getEndDate;
            var department = this.$store.getters.getCurrentDepartment.uuid;
            return startDate + endDate + department;
        }
    },
    watch: {
        globalParams: function globalParams() {
            this.getData();
        }
    }
});

/***/ }),
/* 399 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
    data: function data() {
        return {
            showHelper: false,
            selectedTable: 'KeyFigures',
            sidebarMenuItems: [{
                name: 'Nøgletal',
                tableName: 'KeyFigures'
            }]
        };
    },

    computed: {},
    methods: {
        onRowClick: function onRowClick(params) {
            console.log(params);
        },
        rowStyleClassFn: function rowStyleClassFn(row) {
            return row.age > 18 ? 'green' : 'red';
        },
        updateCount: function updateCount(tableName, event) {
            this.counts[tableName] = event;
        }
    }
});

/***/ }),
/* 400 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__learning_revenueAndCosts_vue__ = __webpack_require__(717);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__learning_revenueAndCosts_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__learning_revenueAndCosts_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__learning_ebitda_vue__ = __webpack_require__(713);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__learning_ebitda_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__learning_ebitda_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__learning_compare_vue__ = __webpack_require__(712);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__learning_compare_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__learning_compare_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__learning_potential_vue__ = __webpack_require__(716);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__learning_potential_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__learning_potential_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__learning_keyFigures_vue__ = __webpack_require__(714);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__learning_keyFigures_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__learning_keyFigures_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__learning_materials_vue__ = __webpack_require__(715);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__learning_materials_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__learning_materials_vue__);









/* harmony default export */ __webpack_exports__["default"] = ({
    components: {
        revenueAndCosts: __WEBPACK_IMPORTED_MODULE_0__learning_revenueAndCosts_vue___default.a,
        ebitda: __WEBPACK_IMPORTED_MODULE_1__learning_ebitda_vue___default.a,
        compare: __WEBPACK_IMPORTED_MODULE_2__learning_compare_vue___default.a,
        potential: __WEBPACK_IMPORTED_MODULE_3__learning_potential_vue___default.a,
        keyFigures: __WEBPACK_IMPORTED_MODULE_4__learning_keyFigures_vue___default.a,
        materials: __WEBPACK_IMPORTED_MODULE_5__learning_materials_vue___default.a
    },
    data: function data() {
        return {
            selectedItem: 'ebitda',
            counts: {
                EconomyOperationsUnbilledProjects: null,
                EconomyOperationsExceededPayments: null,
                allInvoices: null
            },
            switchItems: [{
                name: 'EBITDA',
                slug: 'ebitda',
                dTooltip: 'economy.ebitda'
            }, {
                name: 'Værdikæde',
                slug: 'revenueAndCosts'
            }, {
                name: 'Nøgletal',
                slug: 'keyFigures'
            }, {
                name: 'Vareforbrug',
                slug: 'materials'
            }, {
                name: 'Alle fakturaer og kreditnotaer',
                slug: 'allInvoices'
            }]
        };
    },

    methods: {
        updateCount: function updateCount(slug, event) {
            this.counts[slug] = event;
        },
        handleSelectItem: function handleSelectItem(item) {
            this.selectedItem = item;
        }
    },
    mounted: function mounted() {
        this.$store.state.view = 'learning';
        if (this.$store.state.config.availableDepartments.length > 2) {
            this.switchItems.splice(4, 0, { name: 'Sammenlign afdelinger', slug: 'compare' });
        }
    }
});

/***/ }),
/* 401 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
    components: {
        'compare-keyfigures': __webpack_require__(704),
        'compare-revenue': __webpack_require__(705),
        'compare-coverage-percent': __webpack_require__(702),
        'compare-coverage': __webpack_require__(700),
        'compare-coverage-per-hour': __webpack_require__(701),
        'compare-customer-hours': __webpack_require__(703)
    }
});

/***/ }),
/* 402 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_economyService__ = __webpack_require__(4);




/* harmony default export */ __webpack_exports__["default"] = ({
    data: function data() {
        return {
            accountingYearsCheck: null,
            accounts: null,
            selectedAccountCategory: null,
            loading: true
        };
    },
    created: function created() {
        this.getData();
        this.getContentfulData();
    },

    methods: {
        getContentfulData: function getContentfulData() {
            var contentful = __webpack_require__(57);
            var client = contentful.createClient({
                space: '3h0kg5qa88is',

                accessToken: 'KL17Lh_FTD4ZN6iksXFClsWCVJ_OEVVUbIt7RUGofwc'
            });

            client.getEntry('4SzlILGMZwweEFr9myvbxT').then(function (entry) {
                console.log(entry);
                console.log(entry.fields.tekst.content);
            }).catch(function (err) {
                return console.log(err);
            });
        },
        getData: function getData() {
            var _this = this;

            __WEBPACK_IMPORTED_MODULE_0__services_economyService__["o" /* accountPlan */]({}, function (response) {
                _this.accounts = response.data;
                _this.loading = false;
                _this.checkAccountingYears();
            }, function (err) {
                _this.loading = false;
                console.log(err);
            });
        },
        selectAccountCategory: function selectAccountCategory(accountCategory) {
            this.selectedAccountCategory = accountCategory;
        },
        checkAccountingYears: function checkAccountingYears() {
            var _this2 = this;

            __WEBPACK_IMPORTED_MODULE_0__services_economyService__["p" /* accountingYearsCheck */]({}, function (response) {
                _this2.accountingYearsCheck = response.data;
            }, function (err) {
                console.log(err);
            });
        }
    },
    computed: {
        sortedAccounts: function sortedAccounts() {
            if (this.accounts) {
                var arr = [];
                this.accounts.forEach(function (account) {
                    if (!Array.isArray(account)) {
                        arr.push(account);
                    } else {
                        account.forEach(function (child) {
                            arr.push(child);
                        });
                    }
                });
                console.log(arr);
                return arr;
            }
        },
        calculatedEbitda: function calculatedEbitda() {
            if (this.accounts) {
                var ebitda = 0;
                this.accounts.forEach(function (account) {
                    ebitda += account.total_balance;
                });
                return ebitda;
            }
        }
    }
});

/***/ }),
/* 403 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
    data: function data() {
        return {
            revenueSeries: [{ 'name': 'Omsætning', 'type': 'line', 'width': 3 }, { 'name': 'Dækningsbidrag', 'type': 'area', 'width': 3 }]
        };
    },

    components: {
        'costprice-per-hour': __webpack_require__(706),
        'costs-division': __webpack_require__(707)
    }
});

/***/ }),
/* 404 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
    components: {
        'material-usage': __webpack_require__(708),
        'suppliers': __webpack_require__(709)
    }
});

/***/ }),
/* 405 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_economyService__ = __webpack_require__(4);




/* harmony default export */ __webpack_exports__["default"] = ({
    data: function data() {
        return {
            loading: true,
            data: null,
            ebitda: null,
            customerHours: {
                now: 46,
                min: 0,
                max: 54,
                value: 0,
                label: '%'
            },
            projectRevenue: {
                now: 12300,
                min: 0,
                max: 100,
                value: 0,
                label: '%'
            },
            materialsUsage: {
                now: 2400,
                min: 0,
                max: 100,
                value: 0,
                label: '%'
            },
            coveragePercent: {
                now: 45,
                min: 0,
                max: 100,
                value: 0,
                label: '%'
            }
        };
    },
    created: function created() {
        this.getData();
    },

    methods: {
        getData: function getData() {
            var _this = this;

            this.loading = true;
            var params = {
                date_from: this.$store.getters.getStartDate,
                date_to: this.$store.getters.getEndDate
            };
            __WEBPACK_IMPORTED_MODULE_0__services_economyService__["d" /* keyFigures */](params, function (response) {
                _this.data = response.data;
                _this.ebitda = _this.data.economy.ebitda;
                _this.customerHours.now = response.data.timeloggings.avg_percent;
                _this.customerHours.max = 100 - response.data.timeloggings.avg_percent;
                _this.loading = false;
            }, function (err) {
                console.log(err);
                _this.loading = false;
            });
        }
    },
    computed: {
        customerHoursTotal: function customerHoursTotal() {
            if (this.data) {
                return this.data.coverage.total * (this.customerHours.value / this.customerHours.now);
            }
            return 0;
        },
        projectRevenueTotal: function projectRevenueTotal() {
            if (this.data) {
                return this.data.revenue.invoices_total * (this.projectRevenue.value / 100);
            }
            return 0;
        },
        materialsUsageTotal: function materialsUsageTotal() {
            if (this.data) {
                return this.data.materials.total * (this.materialsUsage.value / 100);
            }
            return 0;
        },
        projects: function projects() {
            var _this2 = this;

            if (this.data && this.coveragePercent.value !== 0) {
                var projects = this.data.coverage.projects;
                var responseProjects = [];
                projects.forEach(function (project) {
                    if (project.coverage_percent && project.coverage_percent < _this2.coveragePercent.value && project.coverage_percent > 0 && project.invoices_total > 0) {
                        responseProjects.push(project);
                    }
                });
                return responseProjects;
            }
        },
        coveragePercentTotal: function coveragePercentTotal() {
            var _this3 = this;

            if (this.data && this.coveragePercent.value !== 0) {
                var projects = this.projects;
                var count = 0;
                projects.forEach(function (project) {
                    if (project.coverage_percent && project.coverage_percent < _this3.coveragePercent.value && project.coverage_percent > 0 && project.invoices_total > 0) {
                        count += (_this3.coveragePercent.value - project.coverage_percent) / 100 * project.invoices_total;
                    }
                });
                return count;
            }
            return 0;
        },
        totalPotential: function totalPotential() {
            return this.ebitda + this.customerHoursTotal + this.projectRevenueTotal + this.materialsUsageTotal + this.coveragePercentTotal;
        },
        globalParams: function globalParams() {
            var startDate = this.$store.getters.getStartDate;
            var endDate = this.$store.getters.getEndDate;
            var department = this.$store.getters.getCurrentDepartment.uuid;
            return startDate + endDate + department;
        }
    },
    watch: {
        globalParams: function globalParams() {
            this.getData();
        }
    }
});

/***/ }),
/* 406 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_calculationService__ = __webpack_require__(29);




/* harmony default export */ __webpack_exports__["default"] = ({
    data: function data() {
        return {
            loading: true,
            showChildren: true,
            figures: null
        };
    },
    created: function created() {
        this.getData();
    },

    methods: {
        getData: function getData() {
            var _this = this;

            this.loading = true;
            var params = {};
            if (this.$store.getters.getCurrentDepartment.uuid !== 0) {
                params.department = this.$store.getters.getCurrentDepartment.uuid;
            }
            __WEBPACK_IMPORTED_MODULE_0__services_calculationService__["b" /* valueChain */](params, function (response) {
                _this.figures = response.data;
                if (_this.$auth.user().name.includes('Demo')) {
                    _this.figures.unbilled.count = 2;
                    _this.figures.unbilled.revenue = 80577;
                    _this.figures.unbilled.coverage = 35454;
                    _this.figures.unpaid_invoices.count = 8;
                    _this.figures.unpaid_invoices.revenue = 322311;
                    _this.figures.unpaid_invoices.coverage = 141816;
                }
                _this.loading = false;
            }, function (err) {
                console.log(err);
                _this.loading = false;
            });
        }
    },
    computed: {
        total: function total() {
            var revenue = this.figures.expected_revenue + this.figures.revenue_in_pipeline;
            var costs = this.figures.expected_costs;
            return revenue - costs;
        },
        globalParams: function globalParams() {
            var department = this.$store.getters.getCurrentDepartment.uuid;
            return department;
        },
        revenueTotal: function revenueTotal() {
            if (this.figures) {
                var total = this.figures.offer.expected_revenue + this.figures.open.expected_revenue + this.figures.ongoing.expected_revenue + this.figures.unbilled.expected_revenue + this.figures.unpaid_invoices.expected_revenue + this.figures.overdue_invoices.expected_revenue;
                return total;
            }
        },
        coverageTotal: function coverageTotal() {
            if (this.figures) {
                var total = this.figures.offer.expected_coverage + this.figures.open.expected_coverage + this.figures.ongoing.expected_coverage + this.figures.unbilled.expected_coverage + this.figures.unpaid_invoices.expected_coverage + this.figures.overdue_invoices.expected_coverage;
                return total;
            }
        }
    },
    watch: {
        globalParams: function globalParams() {
            this.getData();
        }
    }
});

/***/ }),
/* 407 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__operations_exceededPayments_vue__ = __webpack_require__(719);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__operations_exceededPayments_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__operations_exceededPayments_vue__);




/* harmony default export */ __webpack_exports__["default"] = ({
    components: {
        exceededPayments: __WEBPACK_IMPORTED_MODULE_0__operations_exceededPayments_vue___default.a
    },
    data: function data() {
        return {
            selectedItem: 'noInvoiceProjects',
            counts: {
                noInvoiceProjects: null,
                exceededPayments: null,
                allInvoices: null
            },
            switchItems: [{
                name: 'Afsluttede opgaver, der ikke er fakturerede',
                slug: 'noInvoiceProjects'
            }, {
                name: 'Fakturaer, der ikke er betalt',
                slug: 'unpaidInvoices'
            }, {
                name: 'Fakturaer, hvor betalingsfristen er overskredet med ' + this.$store.state.config.companyMeta.settings.overdue_days + ' dage',
                slug: 'exceededPayments'
            }, {
                name: 'Alle fakturaer og kreditnotaer',
                slug: 'allInvoices'
            }]
        };
    },

    methods: {
        updateCount: function updateCount(slug, event) {
            this.counts[slug] = event;
        },
        handleSelectItem: function handleSelectItem(item) {
            this.selectedItem = item;
        }
    },
    mounted: function mounted() {
        this.$store.state.view = 'operations';
        if (this.$route.params.selectedItem) {
            this.selectedItem = this.$route.params.selectedItem;
        }
    }
});

/***/ }),
/* 408 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
    data: function data() {
        return {
            showHelper: false
        };
    }
});

/***/ }),
/* 409 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
    data: function data() {
        return {
            selectedItem: 'timeUsageSkills',
            counts: {},
            switchItems: [{
                name: 'Hvor gode er vi til at registrere tid?',
                slug: 'timeUsageSkills'
            }, {
                name: 'Hvad bruger vi tiden på?',
                slug: 'timeUsage'
            }, {
                name: 'Hvilke svende er gode til hvilke opgaver?',
                slug: 'employeeSkills'
            }, {
                name: 'Hvordan er medarbejdernes indtjening?',
                slug: 'employeeRevenue'
            }, {
                name: 'Hvor meget tid bruger svendene hos kunderne?',
                slug: 'efficiencyGraph'
            }]
        };
    },

    methods: {
        updateCount: function updateCount(slug, event) {
            this.counts[slug] = event;
        },
        handleSelectItem: function handleSelectItem(item) {
            this.selectedItem = item;
        }
    },
    mounted: function mounted() {
        this.$store.state.view = 'learning';
    },

    components: {
        'employee-skills': __webpack_require__(727),
        'time-usage': __webpack_require__(729),
        'time-usage-skills': __webpack_require__(730),
        'employee-revenue': __webpack_require__(726),
        'efficiency-graph': __webpack_require__(725)
    }
});

/***/ }),
/* 410 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
    props: ['data'],
    data: function data() {
        return {
            columns: [{ label: 'Ordre', field: 'case_number', type: 'string' }, { label: 'Opgave', field: 'description', type: 'string', width: '20%' }, { label: 'Kunde', field: 'customer.name', type: 'string' }, { label: 'Startdato', field: 'start_date', type: 'string' }, { label: 'Omsætning', field: 'invoices_total', type: 'number' }, { label: 'DB', field: 'coverage', width: '10%', type: 'number' }, { label: 'DG', field: 'coverage_percent', width: '8%', type: 'number' }, { label: 'DB/time', field: 'coverage_per_hour', width: '8%', type: 'number' }],
            searchOptions: {
                enabled: true,
                trigger: 'enter',
                placeholder: 'Søg og tryk enter ...',
                skipDiacritics: true
            },
            paginationOptions: {
                enabled: true,
                perPage: 10,
                rowsPerPageLabel: 'Rækker pr. side',
                allLabel: 'Alle',
                nextLabel: 'Næste',
                prevLabel: 'Forrige',
                ofLabel: 'af',
                pageLabel: 'side'
            },
            sortOptions: {
                enabled: true,
                initialSortBy: {
                    field: 'coverage',
                    type: 'desc'
                }
            },
            styleClass: 'vgt-table'
        };
    },
    mounted: function mounted() {
        if (this.$auth.user().company.api_provider.slug === 'minuba') {
            this.columns.push({ label: 'Åbn', field: 'minuba_external_id' });
        }
    }
});

/***/ }),
/* 411 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_apexcharts__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_apexcharts___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_apexcharts__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__services_timeUsageService__ = __webpack_require__(55);





/* harmony default export */ __webpack_exports__["default"] = ({
    props: ['employeeWorkingFieldName'],
    data: function data() {
        return {
            loading: true,
            selectedRow: null,
            rows: [],
            columns: [{ label: 'Navn', field: 'name', type: 'string' }, { label: 'Tid hos kunder', field: 'hoursWithCustomers', type: 'number' }, { label: 'Sygefravær', field: 'sicknessPercent', type: 'number' }],
            searchOptions: {
                enabled: true,
                trigger: 'enter',
                placeholder: 'Søg og tryk enter ...',
                skipDiacritics: true
            },
            paginationOptions: {
                enabled: true,
                perPage: 15,
                rowsPerPageLabel: 'Rækker pr. side',
                allLabel: 'Alle',
                nextLabel: 'Næste',
                prevLabel: 'Forrige',
                ofLabel: 'af',
                pageLabel: 'side'
            },
            sortOptions: {
                enabled: true,
                initialSortBy: {
                    field: 'hoursWithCustomers',
                    type: 'desc'
                }
            },
            styleClass: 'vgt-table'
        };
    },
    created: function created() {
        this.getData();
    },

    methods: {
        getData: function getData() {
            var _this = this;

            this.loading = true;
            this.rows = [];
            this.selectedRow = null;
            var params = {
                date_from: this.$store.getters.getStartDate,
                date_to: this.$store.getters.getEndDate
            };
            if (this.employeeWorkingFieldName !== '') {
                params.working_field_name = this.employeeWorkingFieldName;
            }
            __WEBPACK_IMPORTED_MODULE_1__services_timeUsageService__["c" /* employees */](params, function (response) {
                console.log(response.data);
                response.data.forEach(function (item) {
                    var hoursWithCustomers = item.hours_division.series[0];
                    var hoursWithoutCustomers = item.hours_division.series[1];
                    item.hoursWithCustomers = Math.round(hoursWithCustomers / (hoursWithCustomers + hoursWithoutCustomers) * 100);
                    var hours = 0;
                    var totalHours = 0;
                    item.hours_without_customers.series.forEach(function (series) {
                        totalHours = totalHours + series;
                    });
                    item.hours_without_customers.labels.forEach(function (label, index) {
                        if (label.toString(16).toLowerCase().includes('syg')) {
                            hours = hours + item.hours_without_customers.series[index];
                        }
                    });
                    item.sicknessPercent = hours > 0 && totalHours > 0 ? Math.round(hours / item.available_hours * 100) : 0;
                });
                _this.rows = response.data;
                _this.loading = false;
            }, function (err) {
                console.log(err);
                _this.loading = false;
            });
        },
        selectCustomer: function selectCustomer(employee) {
            var _this2 = this;

            this.selectedRow = null;
            setTimeout(function () {
                _this2.selectedRow = employee.row;
            }, 250);
        },
        selectedRowClass: function selectedRowClass(row) {
            if (this.selectedRow && row.uuid === this.selectedRow.uuid) {
                return 'selected';
            }
        }
    },
    components: {
        VueApexCharts: __WEBPACK_IMPORTED_MODULE_0_vue_apexcharts___default.a,
        'hours-with-customers': __webpack_require__(724),
        'pie': __webpack_require__(267)
    },
    computed: {
        globalParams: function globalParams() {
            var startDate = this.$store.getters.getStartDate;
            var endDate = this.$store.getters.getEndDate;
            var department = this.$store.getters.getCurrentDepartment.uuid;
            return startDate + endDate + department;
        }
    },
    watch: {
        globalParams: function globalParams() {
            this.getData();
        },
        employeeWorkingFieldName: function employeeWorkingFieldName() {
            this.getData();
        }
    }
});

/***/ }),
/* 412 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_apexcharts__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_apexcharts___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_apexcharts__);




/* harmony default export */ __webpack_exports__["default"] = ({
    props: ['data'],
    data: function data() {
        var _this = this;

        return {
            chartOptions: {
                series: [],
                labels: [],
                colors: ['#4CAF50', '#FF5252'],
                chart: {
                    type: 'pie',
                    height: '300px'
                },
                tooltip: {
                    enabled: true,
                    y: {
                        formatter: function formatter(value) {
                            var percent = Math.round(value / _this.data.hours_total * 100);
                            return _this.$options.filters.rounded(value) + ' timer (' + percent + '%)';
                        }
                    }
                },
                dataLabels: {
                    enabled: true,
                    formatter: function formatter(val) {
                        return _this.$options.filters.rounded(val) + ' %';
                    }
                },
                legend: {
                    position: 'bottom',
                    offsetY: 10,
                    itemMargin: {
                        horizontal: 5,
                        vertical: 10
                    }
                },
                plotOptions: {
                    pie: {
                        donut: {
                            labels: {
                                show: false
                            }
                        }
                    }
                }
            }
        };
    },
    created: function created() {
        this.setData();
    },

    methods: {
        setData: function setData() {
            this.chartOptions.labels = this.data.efficiency_series.labels;
            this.chartOptions.series = this.data.efficiency_series.series;
        }
    },
    watch: {
        componentData: function componentData() {
            this.setData();
        }
    },
    components: {
        VueApexCharts: __WEBPACK_IMPORTED_MODULE_0_vue_apexcharts___default.a
    },
    computed: {
        componentData: function componentData() {
            return this.data;
        }
    }
});

/***/ }),
/* 413 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_apexcharts__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_apexcharts___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_apexcharts__);




/* harmony default export */ __webpack_exports__["default"] = ({
    props: ['headline', 'series', 'labels', 'division'],
    data: function data() {
        var _this = this;

        return {
            chartOptions: {
                series: [],
                labels: this.labels ? this.labels : null,
                colors: this.division === true ? ['#4CAF50', '#FF5252'] : this.$store.state.graphColors,
                chart: {
                    type: 'pie',
                    height: '300px'
                },
                tooltip: {
                    enabled: true,
                    y: {
                        formatter: function formatter(value) {
                            var percent = Math.round(value / _this.total * 100);
                            return _this.$options.filters.rounded(value) + ' timer (' + percent + '%)';
                        }
                    }
                },
                dataLabels: {
                    enabled: true,
                    formatter: function formatter(val) {
                        return _this.$options.filters.rounded(val) + ' %';
                    }
                },
                legend: {
                    show: false,
                    position: 'bottom',
                    offsetY: 10,
                    itemMargin: {
                        horizontal: 5,
                        vertical: 10
                    }
                },
                plotOptions: {
                    pie: {
                        donut: {
                            labels: {
                                show: true,
                                value: {
                                    formatter: function formatter(value) {
                                        var percent = Math.round(value / _this.total * 100);
                                        return _this.$options.filters.rounded(value) + ' timer (' + percent + '%)';
                                    }
                                }
                            }
                        }
                    }
                }
            }
        };
    },

    components: {
        VueApexCharts: __WEBPACK_IMPORTED_MODULE_0_vue_apexcharts___default.a
    },
    computed: {
        total: function total() {
            var count = 0;
            this.series.forEach(function (item) {
                count += item;
            });
            return count;
        }
    }
});

/***/ }),
/* 414 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
    data: function data() {
        return {
            efficiencyGraph: 'efficiency',
            efficiencyGraphParams: false,
            efficiencyGraphSeries: [{ 'name': 'Arbejde hos kunderne', 'type': 'bar', 'width': 0 }]
        };
    },

    methods: {
        toggleEfficiency: function toggleEfficiency() {
            if (this.efficiencyGraph === 'efficiency') {
                this.efficiencyGraph = 'efficiency?weekdays=1';
                this.efficiencyGraphParams = true;
            } else {
                this.efficiencyGraph = 'efficiency';
                this.efficiencyGraphParams = false;
            }
        }
    }
});

/***/ }),
/* 415 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_employeeService__ = __webpack_require__(22);




/* harmony default export */ __webpack_exports__["default"] = ({
    data: function data() {
        return {
            loading: true,
            rows: [],
            columns: [{ label: 'Initialer', field: 'initials', type: 'string' }, { label: 'Medarbejder', field: 'full_name', type: 'string' }, { label: 'Antal opgaver', field: 'total_projects', type: 'number' }, { label: 'Omsætning', field: 'invoices_total', type: 'number' }, { label: 'DB', field: 'coverage', type: 'number' }, { label: 'DG', field: 'coverage_percent', type: 'number' }, { label: 'DB pr. time', field: 'coverage_per_hour', type: 'number' }],
            searchOptions: {
                enabled: true,
                trigger: 'enter',
                placeholder: 'Søg og tryk enter ...',
                skipDiacritics: true
            },
            paginationOptions: {
                enabled: true,
                perPage: 30,
                rowsPerPageLabel: 'Rækker pr. side',
                allLabel: 'Alle',
                nextLabel: 'Næste',
                prevLabel: 'Forrige',
                ofLabel: 'af',
                pageLabel: 'side'
            },
            sortOptions: {
                enabled: true,
                initialSortBy: {
                    field: 'coverage',
                    type: 'desc'
                }
            },
            styleClass: 'vgt-table'
        };
    },
    mounted: function mounted() {
        this.getData();
    },

    methods: {
        getData: function getData() {
            var _this = this;

            this.loading = true;
            var params = {
                date_from: this.$store.getters.getStartDate,
                date_to: this.$store.getters.getEndDate
            };
            if (this.$store.getters.getCurrentDepartment.uuid !== 0) {
                params.department = this.$store.getters.getCurrentDepartment.uuid;
            }
            __WEBPACK_IMPORTED_MODULE_0__services_employeeService__["e" /* revenue */](params, function (response) {
                _this.rows = response.data;
                _this.loading = false;
            }, function (err) {
                console.log(err);
                _this.loading = false;
            });
        }
    },
    computed: {
        globalParams: function globalParams() {
            var startDate = this.$store.getters.getStartDate;
            var endDate = this.$store.getters.getEndDate;
            var department = this.$store.getters.getCurrentDepartment.uuid;
            return startDate + endDate + department;
        }
    },
    watch: {
        data: function data() {
            this.getData();
        },
        globalParams: function globalParams() {
            this.getData();
        }
    }
});

/***/ }),
/* 416 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_employeeService__ = __webpack_require__(22);




/* harmony default export */ __webpack_exports__["default"] = ({
    data: function data() {
        return {
            selectedRow: null,
            loading: true,
            rows: [],
            columns: [{ label: 'Initialer', field: 'initials', type: 'string' }, { label: 'Medarbejder', field: 'full_name', type: 'string' }],
            searchOptions: {
                enabled: true,
                trigger: 'enter',
                placeholder: 'Søg og tryk enter ...',
                skipDiacritics: true
            },
            paginationOptions: {
                enabled: true,
                perPage: 10,
                rowsPerPageLabel: 'Rækker pr. side',
                allLabel: 'Alle',
                nextLabel: 'Næste',
                prevLabel: 'Forrige',
                ofLabel: 'af',
                pageLabel: 'side'
            },
            sortOptions: {
                enabled: true
            },
            styleClass: 'vgt-table'
        };
    },
    created: function created() {
        this.getData();
    },

    methods: {
        getData: function getData() {
            var _this = this;

            this.loading = true;
            __WEBPACK_IMPORTED_MODULE_0__services_employeeService__["a" /* findAll */]({}, function (response) {
                var employees = [];
                response.data.forEach(function (employee) {
                    if (employee.working_field) {
                        employees.push(employee);
                    }
                });
                _this.rows = employees;
                _this.$emit('finishedLoading', _this.rows.length);
                _this.loading = false;
            }, function (err) {
                console.log(err);
                _this.loading = false;
            });
        },
        selectEmployee: function selectEmployee(employee) {
            this.selectedRow = employee.row;
        },
        selectedRowClass: function selectedRowClass(row) {
            if (this.selectedRow && row.uuid === this.selectedRow.uuid) {
                return 'selected';
            }
        }
    },
    components: {
        'employee-skills-single': __webpack_require__(728)
    }
});

/***/ }),
/* 417 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_employeeService__ = __webpack_require__(22);




/* harmony default export */ __webpack_exports__["default"] = ({
    props: ['data'],
    data: function data() {
        return {
            loading: true,
            selectedRow: null,
            rows: [],
            columns: [{ label: 'Opgavetype', field: 'name', type: 'string' }, { label: 'Antal i perioden', field: 'projects_count', type: 'number' }, { label: 'Omsætning', field: 'invoices_total', type: 'number' }, { label: 'DB', field: 'coverage', type: 'number' }, { label: 'DG', field: 'coverage_percent', type: 'number' }, { label: 'DB pr. time', field: 'coverage_per_hour', type: 'number' }],
            searchOptions: {
                enabled: true,
                trigger: 'enter',
                placeholder: 'Søg og tryk enter ...',
                skipDiacritics: true
            },
            paginationOptions: {
                enabled: true,
                perPage: 10,
                rowsPerPageLabel: 'Rækker pr. side',
                allLabel: 'Alle',
                nextLabel: 'Næste',
                prevLabel: 'Forrige',
                ofLabel: 'af',
                pageLabel: 'side'
            },
            sortOptions: {
                enabled: true,
                initialSortBy: {
                    field: 'coverage',
                    type: 'desc'
                }
            },
            styleClass: 'vgt-table'
        };
    },
    mounted: function mounted() {
        this.getData();
    },

    methods: {
        getData: function getData() {
            var _this = this;

            this.loading = true;
            this.selectedRow = null;
            var params = {
                date_from: this.$store.getters.getStartDate,
                date_to: this.$store.getters.getEndDate
            };
            if (this.$store.getters.getCurrentDepartment.uuid !== 0) {
                params.department = this.$store.getters.getCurrentDepartment.uuid;
            }
            __WEBPACK_IMPORTED_MODULE_0__services_employeeService__["f" /* skills */](this.data.uuid, params, function (response) {
                _this.rows = response.data.project_types;
                _this.loading = false;
            }, function (err) {
                console.log(err);
                _this.loading = false;
            });
        },
        selectProjectType: function selectProjectType(projectType) {
            this.selectedRow = projectType.row;
            console.log(projectType);
        },
        selectedRowClass: function selectedRowClass(row) {
            if (this.selectedRow && row.name === this.selectedRow.name) {
                return 'selected';
            }
        }
    },
    computed: {
        globalParams: function globalParams() {
            var startDate = this.$store.getters.getStartDate;
            var endDate = this.$store.getters.getEndDate;
            var department = this.$store.getters.getCurrentDepartment.uuid;
            return startDate + endDate + department;
        }
    },
    watch: {
        data: function data() {
            this.getData();
        },
        globalParams: function globalParams() {
            this.getData();
        }
    },
    components: {
        'employee-skills-single-projects': __webpack_require__(722)
    }
});

/***/ }),
/* 418 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_apexcharts__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_apexcharts___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_apexcharts__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__services_timeUsageService__ = __webpack_require__(55);





/* harmony default export */ __webpack_exports__["default"] = ({
    data: function data() {
        var _this = this;

        return {
            employeeWorkingFieldName: '',
            loading: true,
            hoursDivision: {
                series: null,
                labels: null
            },
            hoursWithCustomers: {
                series: null,
                labels: null
            },
            hoursWithoutCustomers: {
                series: null,
                labels: null
            },
            chartOptions: {
                series: [],
                labels: [],
                colors: this.$store.state.graphColors,
                chart: {
                    type: 'pie',
                    height: '600px'
                },
                tooltip: {
                    enabled: true,
                    y: {
                        formatter: function formatter(value) {
                            var percent = Math.round(value / _this.total * 100);
                            return _this.$options.filters.rounded(value) + ' timer (' + percent + '%)';
                        }
                    }
                },
                dataLabels: {
                    enabled: true,
                    formatter: function formatter(val) {
                        return _this.$options.filters.rounded(val) + ' %';
                    }
                },
                legend: {
                    position: 'left'
                },
                plotOptions: {
                    pie: {
                        donut: {
                            labels: {
                                show: true,
                                value: {
                                    formatter: function formatter(value) {
                                        var percent = Math.round(value / _this.total * 100);
                                        return _this.$options.filters.rounded(value) + ' timer (' + percent + '%)';
                                    }
                                }
                            }
                        }
                    }
                }
            }
        };
    },
    created: function created() {
        this.getData();
    },

    methods: {
        getData: function getData() {
            var _this2 = this;

            this.loading = true;
            this.data = null;
            var params = {
                date_from: this.$store.getters.getStartDate,
                date_to: this.$store.getters.getEndDate
            };
            if (this.$store.getters.getCurrentDepartment.uuid !== 0) {
                params.department = this.$store.getters.getCurrentDepartment.uuid;
            }
            if (this.employeeWorkingFieldName !== '') {
                params.working_field_name = this.employeeWorkingFieldName;
            }
            __WEBPACK_IMPORTED_MODULE_1__services_timeUsageService__["b" /* all */](params, function (response) {
                _this2.hoursDivision.series = response.data.hours_division.series;
                _this2.hoursDivision.labels = response.data.hours_division.labels;
                _this2.hoursWithCustomers.series = response.data.hours_with_customers.series;
                _this2.hoursWithCustomers.labels = response.data.hours_with_customers.labels;
                _this2.hoursWithoutCustomers.series = response.data.hours_without_customers.series;
                _this2.hoursWithoutCustomers.labels = response.data.hours_without_customers.labels;
                _this2.loading = false;
            }, function (err) {
                console.log(err);
                _this2.loading = false;
            });
        }
    },
    components: {
        VueApexCharts: __WEBPACK_IMPORTED_MODULE_0_vue_apexcharts___default.a,
        'employee-time-usage': __webpack_require__(723),
        'pie': __webpack_require__(267)
    },
    computed: {
        globalParams: function globalParams() {
            var startDate = this.$store.getters.getStartDate;
            var endDate = this.$store.getters.getEndDate;
            var department = this.$store.getters.getCurrentDepartment.uuid;
            return startDate + endDate + department;
        },
        total: function total() {
            if (this.chartOptions.series.length > 0) {
                return this.chartOptions.series.reduce(function (a, b) {
                    return a + b;
                }, 0);
            }
        }
    },
    watch: {
        globalParams: function globalParams() {
            this.getData();
        },
        employeeWorkingFieldName: function employeeWorkingFieldName() {
            this.getData();
        }
    }
});

/***/ }),
/* 419 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_timeUsageService__ = __webpack_require__(55);




/* harmony default export */ __webpack_exports__["default"] = ({
    data: function data() {
        return {
            employeeWorkingFieldName: '',
            loading: true,
            data: null,
            columns: [{ label: 'Initialer', field: 'initials', type: 'string' }, { label: 'Medarbejder', field: 'full_name', type: 'string' }, { label: 'Timer til rådighed', field: 'available_hours', type: 'number' }, { label: 'Timer registreret', field: 'logged_hours', type: 'number' }, { label: 'Registreret tid', field: 'efficiency', type: 'number' }],
            searchOptions: {
                enabled: true,
                trigger: 'enter',
                placeholder: 'Søg og tryk enter ...',
                skipDiacritics: true
            },
            paginationOptions: {
                enabled: true,
                perPage: 15,
                rowsPerPageLabel: 'Rækker pr. side',
                allLabel: 'Alle',
                nextLabel: 'Næste',
                prevLabel: 'Forrige',
                ofLabel: 'af',
                pageLabel: 'side'
            },
            sortOptions: {
                enabled: true,
                initialSortBy: {
                    field: 'efficiency',
                    type: 'desc'
                }
            },
            styleClass: 'vgt-table'
        };
    },
    created: function created() {
        this.getData();
    },

    methods: {
        getData: function getData() {
            var _this = this;

            this.loading = true;
            this.data = null;
            var params = {
                date_from: this.$store.getters.getStartDate,
                date_to: this.$store.getters.getEndDate
            };
            if (this.$store.getters.getCurrentDepartment.uuid !== 0) {
                params.department = this.$store.getters.getCurrentDepartment.uuid;
            }
            if (this.employeeWorkingFieldName !== '') {
                params.working_field_name = this.employeeWorkingFieldName;
            }
            __WEBPACK_IMPORTED_MODULE_0__services_timeUsageService__["a" /* skills */](params, function (response) {
                _this.data = response.data;
                _this.loading = false;
            }, function (err) {
                console.log(err);
                _this.loading = false;
            });
        }
    },
    computed: {
        globalParams: function globalParams() {
            var startDate = this.$store.getters.getStartDate;
            var endDate = this.$store.getters.getEndDate;

            return startDate + endDate;
        }
    },
    watch: {
        globalParams: function globalParams() {
            this.getData();
        },
        employeeWorkingFieldName: function employeeWorkingFieldName() {
            this.getData();
        }
    }
});

/***/ }),
/* 420 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
    data: function data() {
        return {
            selectedItem: 'claims',
            counts: {
                claims: null
            },
            switchItems: [{
                name: 'Afsluttede reklamationer',
                slug: 'claims'
            }]
        };
    },

    methods: {
        updateCount: function updateCount(slug, event) {
            this.counts[slug] = event;
        },
        handleSelectItem: function handleSelectItem(item) {
            this.selectedItem = item;
        }
    },
    mounted: function mounted() {
        this.$store.state.view = 'operations';
    },

    components: {
        'claims-table': __webpack_require__(268)
    }
});

/***/ }),
/* 421 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_projectService__ = __webpack_require__(11);




/* harmony default export */ __webpack_exports__["default"] = ({
    data: function data() {
        return {
            loading: true,
            columns: [{ label: 'Ordre', field: 'case_number', type: 'number' }, { label: 'Ansvarlig', field: 'responsible_employee.full_name', type: 'string' }, { label: 'Opgave', field: 'description', type: 'string', width: '30%' }, { label: 'Kunde', field: 'customer.name', type: 'string', width: '30%' }, { label: 'Startdato', field: 'start_date', type: 'string', width: '10%' }, { label: 'Omsætning', field: 'invoices_total', type: 'number' }, { label: 'DB', field: 'coverage', width: '10%', type: 'number' }, { label: 'DG', field: 'coverage_percent', width: '8%', type: 'number' }, { label: 'DB/time', field: 'coverage_per_hour', width: '8%', type: 'number' }],
            rows: [],
            searchOptions: {
                enabled: true,
                trigger: 'enter',
                placeholder: 'Søg og tryk enter ...',
                skipDiacritics: true
            },
            paginationOptions: {
                enabled: true,
                perPage: 10,
                rowsPerPageLabel: 'Rækker pr. side',
                allLabel: 'Alle',
                nextLabel: 'Næste',
                prevLabel: 'Forrige',
                ofLabel: 'af',
                pageLabel: 'side'
            },
            sortOptions: {
                enabled: true,
                initialSortBy: {
                    field: 'responsible_employee.full_name',
                    type: 'asc'
                }
            },
            styleClass: 'vgt-table'
        };
    },
    created: function created() {
        if (this.$auth.user().company.api_provider.slug === 'minuba') {
            this.columns.push({ label: 'Åbn', field: 'minuba_external_id' });
        }
        this.getData();
    },

    methods: {
        getData: function getData() {
            var _this = this;

            this.loading = true;
            this.$emit('finishedLoading', null);
            var dateFrom = this.$store.getters.getStartDate;
            var dateTo = this.$store.getters.getEndDate;
            var params = {
                'filter[complaint]': true,
                'filter[status]': 'billed,posted',
                'filter[between]': dateFrom + ',' + dateTo,
                include: 'customer,type,responsibleEmployee'
            };
            if (this.$store.getters.getCurrentDepartment.uuid !== 0) {
                params['filter[by_department_uuid]'] = this.$store.getters.getCurrentDepartment.uuid;
            }
            __WEBPACK_IMPORTED_MODULE_0__services_projectService__["c" /* claims */](params, function (response) {
                _this.rows = response.data;
                _this.$emit('finishedLoading', _this.rows.length);
                _this.loading = false;
            }, function (err) {
                console.log(err);
                _this.loading = false;
            });
        }
    },
    computed: {
        globalParams: function globalParams() {
            var startDate = this.$store.getters.getStartDate;
            var endDate = this.$store.getters.getEndDate;
            var department = this.$store.getters.getCurrentDepartment.uuid;
            return startDate + endDate + department;
        }
    },
    watch: {
        globalParams: function globalParams() {
            this.getData();
        }
    }
});

/***/ }),
/* 422 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_mainProjectService__ = __webpack_require__(39);




/* harmony default export */ __webpack_exports__["default"] = ({
    data: function data() {
        return {
            selectedRow: null,
            loading: true,
            rows: [],
            columns: [{ label: 'Navn', field: 'name' }, { label: 'Antal', field: 'sub_projects_count', type: 'number' }, { label: 'Budget omk.', field: 'budget' }, { label: 'Realiseret', field: 'sub_projects_total_expenses', type: 'number' }, { label: 'Eff. grad', field: 'efficiency' }],
            searchOptions: {
                enabled: true,
                trigger: 'enter',
                placeholder: 'Søg og tryk enter ...',
                skipDiacritics: true
            },
            paginationOptions: {
                enabled: true,
                perPage: 10,
                rowsPerPageLabel: 'Rækker pr. side',
                allLabel: 'Alle',
                nextLabel: 'Næste',
                prevLabel: 'Forrige',
                ofLabel: 'af',
                pageLabel: 'side'
            },
            sortOptions: {
                enabled: true
            },
            styleClass: 'vgt-table'
        };
    },
    created: function created() {
        this.getData();
    },

    methods: {
        getData: function getData() {
            var _this = this;

            this.loading = true;
            this.$emit('finishedLoading', null);
            this.selectedRow = null;
            var params = {
                date_from: this.$store.getters.getStartDate,
                date_to: this.$store.getters.getEndDate
            };
            if (this.$store.getters.getCurrentDepartment.uuid !== 0) {
                params.department = this.$store.getters.getCurrentDepartment.uuid;
            }
            __WEBPACK_IMPORTED_MODULE_0__services_mainProjectService__["b" /* employees */](params, function (response) {
                _this.rows = response.data;
                _this.loading = false;
                _this.$emit('finishedLoading', _this.rows.length);
            }, function (err) {
                console.log(err);
                _this.loading = false;
            });
        },
        selectEmployee: function selectEmployee(employee) {
            this.selectedRow = employee.row;
        },
        selectedRowClass: function selectedRowClass(row) {
            if (this.selectedRow && row.uuid === this.selectedRow.uuid) {
                return 'selected';
            }
        }
    },
    components: {
        'employee-sub-projects-single': __webpack_require__(733)
    },
    computed: {
        globalParams: function globalParams() {
            var startDate = this.$store.getters.getStartDate;
            var endDate = this.$store.getters.getEndDate;
            var department = this.$store.getters.getCurrentDepartment.uuid;
            return startDate + endDate + department;
        }
    },
    watch: {
        globalParams: function globalParams() {
            this.getData();
        }
    }
});

/***/ }),
/* 423 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
    props: {
        data: {
            required: true
        }
    },
    data: function data() {
        return {
            selectedRow: null,
            rows: [],
            columns: [{ label: 'Ordre', field: 'case_number' }, { label: 'Opgave', field: 'description', type: 'string' }, { label: 'Budget omk.', field: 'budget', type: 'string' }, { label: 'Realiseret', field: 'total_expenses', type: 'number' }, { label: 'Eff. grad', field: 'efficiency', type: 'string' }],
            searchOptions: {
                enabled: true,
                trigger: 'enter',
                placeholder: 'Søg og tryk enter ...',
                skipDiacritics: true
            },
            paginationOptions: {
                enabled: true,
                perPage: 30,
                rowsPerPageLabel: 'Rækker pr. side',
                allLabel: 'Alle',
                nextLabel: 'Næste',
                prevLabel: 'Forrige',
                ofLabel: 'af',
                pageLabel: 'side'
            },
            sortOptions: {
                enabled: true
            },
            styleClass: 'vgt-table'
        };
    }
});

/***/ }),
/* 424 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
    props: {
        data: {
            required: true
        }
    },
    data: function data() {
        return {
            selectedRow: null,
            rows: [],
            columns: [{ label: 'Ordre', field: 'case_number', type: 'string' }, { label: 'Opgave', field: 'description', type: 'string' }, { label: 'Kunde', field: 'customer.name' }, { label: 'Startdato', field: 'external_created_at' }, { label: 'Omsætning', field: 'invoices_total', type: 'number' }, { label: 'DB', field: 'coverage', type: 'number' }, { label: 'DG', field: 'coverage_percent', type: 'number' }, { label: 'DB pr. time', field: 'coverage_per_hour', type: 'number' }],
            searchOptions: {
                enabled: true,
                trigger: 'enter',
                placeholder: 'Søg og tryk enter ...',
                skipDiacritics: true
            },
            paginationOptions: {
                enabled: true,
                perPage: 10,
                rowsPerPageLabel: 'Rækker pr. side',
                allLabel: 'Alle',
                nextLabel: 'Næste',
                prevLabel: 'Forrige',
                ofLabel: 'af',
                pageLabel: 'side'
            },
            sortOptions: {
                enabled: true,
                initialSortBy: {
                    field: 'coverage',
                    type: 'desc'
                }
            },
            styleClass: 'vgt-table'
        };
    },

    methods: {
        selectProjectType: function selectProjectType(projectType) {
            this.selectedRow = projectType.row;
            this.$emit('showSubProjects', this.selectedRow);
        },
        selectedRowClass: function selectedRowClass(row) {
            if (this.selectedRow && row.uuid === this.selectedRow.uuid) {
                return 'selected';
            }
        }
    }
});

/***/ }),
/* 425 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_mainProjectService__ = __webpack_require__(39);




/* harmony default export */ __webpack_exports__["default"] = ({
    data: function data() {
        return {
            selectedSubProjectType: null,
            selectedRow: null,
            loading: true,
            rows: [],
            columns: [{ label: 'Entreprisetype', field: 'name', type: 'string' }, { label: 'Antal', field: 'count', type: 'number' }, { label: 'Omsætning', field: 'invoices_total', type: 'number' }, { label: 'DB', field: 'coverage', type: 'number' }, { label: 'DG', field: 'coverage_percent', type: 'number' }, { label: 'DB pr. time', field: 'coverage_per_hour', type: 'number' }],
            searchOptions: {
                enabled: true,
                trigger: 'enter',
                placeholder: 'Søg og tryk enter ...',
                skipDiacritics: true
            },
            paginationOptions: {
                enabled: true,
                perPage: 30,
                rowsPerPageLabel: 'Rækker pr. side',
                allLabel: 'Alle',
                nextLabel: 'Næste',
                prevLabel: 'Forrige',
                ofLabel: 'af',
                pageLabel: 'side'
            },
            sortOptions: {
                enabled: true,
                initialSortBy: {
                    field: 'coverage',
                    type: 'desc'
                }
            },
            styleClass: 'vgt-table'
        };
    },
    created: function created() {
        this.getData();
    },

    methods: {
        getData: function getData() {
            var _this = this;

            this.loading = true;
            this.$emit('finishedLoading', null);
            this.selectedRow = null;
            var params = {
                date_from: this.$store.getters.getStartDate,
                date_to: this.$store.getters.getEndDate
            };
            if (this.$store.getters.getCurrentDepartment.uuid !== 0) {
                params.department = this.$store.getters.getCurrentDepartment.uuid;
            }
            __WEBPACK_IMPORTED_MODULE_0__services_mainProjectService__["d" /* projectTypes */](params, function (response) {
                _this.rows = response.data;
                _this.loading = false;
                _this.$emit('finishedLoading', _this.rows.length);
            }, function (err) {
                console.log(err);
                _this.loading = false;
            });
        },
        selectMainProjectType: function selectMainProjectType(mainProjectType) {
            this.selectedRow = mainProjectType.row;
        },
        selectedRowClass: function selectedRowClass(row) {
            if (this.selectedRow && row.name === this.selectedRow.name) {
                return 'selected';
            }
        },
        setSubProjects: function setSubProjects(subProjectType) {
            this.selectedSubProjectType = subProjectType;
        }
    },
    components: {
        'main-project-type-single': __webpack_require__(734),
        'sub-projects': __webpack_require__(739)
    },
    computed: {
        globalParams: function globalParams() {
            var startDate = this.$store.getters.getStartDate;
            var endDate = this.$store.getters.getEndDate;
            var department = this.$store.getters.getCurrentDepartment.uuid;
            return startDate + endDate + department;
        }
    },
    watch: {
        globalParams: function globalParams() {
            this.getData();
        }
    }
});

/***/ }),
/* 426 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_mainProjectService__ = __webpack_require__(39);




/* harmony default export */ __webpack_exports__["default"] = ({
    data: function data() {
        return {
            loading: true,
            rows: [],
            columns: [{ label: 'Ordre', field: 'case_number', type: 'number' }, { label: 'Entreprisetype', field: 'type.name', type: 'string' }, { label: 'Opgave', field: 'description', type: 'string', width: '20%' }, { label: 'Kunde', field: 'customer.name', type: 'string' }, { label: 'Startdato', field: 'external_created_at', type: 'string' }, { label: 'Omsætning', field: 'invoices_total', type: 'number' }, { label: 'DB', field: 'coverage', width: '10%', type: 'number' }, { label: 'DG', field: 'coverage_percent', width: '8%', type: 'number' }, { label: 'DB/time', field: 'coverage_per_hour', width: '8%', type: 'number' }],
            searchOptions: {
                enabled: true,
                trigger: 'enter',
                placeholder: 'Søg og tryk enter ...',
                skipDiacritics: true
            },
            paginationOptions: {
                enabled: true,
                perPage: 30,
                rowsPerPageLabel: 'Rækker pr. side',
                allLabel: 'Alle',
                nextLabel: 'Næste',
                prevLabel: 'Forrige',
                ofLabel: 'af',
                pageLabel: 'side'
            },
            sortOptions: {
                enabled: true,
                initialSortBy: {
                    field: 'coverage',
                    type: 'desc'
                }
            },
            styleClass: 'vgt-table'
        };
    },
    created: function created() {
        this.getData();
    },

    methods: {
        getData: function getData() {
            var _this = this;

            this.loading = true;
            this.$emit('finishedLoading', null);
            var params = {
                date_from: this.$store.getters.getStartDate,
                date_to: this.$store.getters.getEndDate
            };
            if (this.$store.getters.getCurrentDepartment.uuid !== 0) {
                params.department = this.$store.getters.getCurrentDepartment.uuid;
            }
            __WEBPACK_IMPORTED_MODULE_0__services_mainProjectService__["c" /* main */](params, function (response) {
                _this.rows = response.data;
                _this.loading = false;
                _this.$emit('finishedLoading', _this.rows.length);
            }, function (err) {
                console.log(err);
                _this.loading = false;
            });
        }
    },
    computed: {
        globalParams: function globalParams() {
            var startDate = this.$store.getters.getStartDate;
            var endDate = this.$store.getters.getEndDate;
            var department = this.$store.getters.getCurrentDepartment.uuid;
            return startDate + endDate + department;
        }
    },
    watch: {
        globalParams: function globalParams() {
            this.getData();
        }
    }
});

/***/ }),
/* 427 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_mainProjectService__ = __webpack_require__(39);




/* harmony default export */ __webpack_exports__["default"] = ({
    data: function data() {
        return {
            selectedRow: null,
            loading: true,
            rows: [],
            columns: [{ label: 'Navn', field: 'name' }, { label: 'Antal', field: 'sub_projects_count', type: 'number' }, { label: 'Budget omk.', field: 'budget' }, { label: 'Realiseret', field: 'total_expenses', type: 'number' }, { label: 'Eff. grad', field: 'efficiency' }],
            searchOptions: {
                enabled: true,
                trigger: 'enter',
                placeholder: 'Søg og tryk enter ...',
                skipDiacritics: true
            },
            paginationOptions: {
                enabled: true,
                perPage: 10,
                rowsPerPageLabel: 'Rækker pr. side',
                allLabel: 'Alle',
                nextLabel: 'Næste',
                prevLabel: 'Forrige',
                ofLabel: 'af',
                pageLabel: 'side'
            },
            sortOptions: {
                enabled: true
            },
            styleClass: 'vgt-table'
        };
    },
    created: function created() {
        this.getData();
    },

    methods: {
        getData: function getData() {
            var _this = this;

            this.loading = true;
            this.$emit('finishedLoading', null);
            this.selectedRow = null;
            var params = {
                date_from: this.$store.getters.getStartDate,
                date_to: this.$store.getters.getEndDate
            };
            if (this.$store.getters.getCurrentDepartment.uuid !== 0) {
                params.department = this.$store.getters.getCurrentDepartment.uuid;
            }
            __WEBPACK_IMPORTED_MODULE_0__services_mainProjectService__["a" /* subProjectTypes */](params, function (response) {
                _this.rows = response.data;
                _this.loading = false;
                _this.$emit('finishedLoading', _this.rows.length);
            }, function (err) {
                console.log(err);
                _this.loading = false;
            });
        },
        selectSubProjectType: function selectSubProjectType(subProjectType) {
            this.selectedRow = subProjectType.row;
        },
        selectedRowClass: function selectedRowClass(row) {
            if (this.selectedRow && row.name === this.selectedRow.name) {
                return 'selected';
            }
        }
    },
    components: {
        'sub-project-types-single': __webpack_require__(738)
    },
    computed: {
        globalParams: function globalParams() {
            var startDate = this.$store.getters.getStartDate;
            var endDate = this.$store.getters.getEndDate;
            var department = this.$store.getters.getCurrentDepartment.uuid;
            return startDate + endDate + department;
        }
    },
    watch: {
        globalParams: function globalParams() {
            this.getData();
        }
    }
});

/***/ }),
/* 428 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
    props: {
        data: {
            required: true
        }
    },
    data: function data() {
        return {
            selectedRow: null,
            rows: [],
            columns: [{ label: 'Ordre', field: 'case_number' }, { label: 'Opgave', field: 'description', type: 'string' }, { label: 'Budget omk.', field: 'budget', type: 'string' }, { label: 'Realiseret', field: 'total_expenses', type: 'number' }, { label: 'Eff. grad', field: 'efficiency', type: 'string' }],
            searchOptions: {
                enabled: true,
                trigger: 'enter',
                placeholder: 'Søg og tryk enter ...',
                skipDiacritics: true
            },
            paginationOptions: {
                enabled: true,
                perPage: 30,
                rowsPerPageLabel: 'Rækker pr. side',
                allLabel: 'Alle',
                nextLabel: 'Næste',
                prevLabel: 'Forrige',
                ofLabel: 'af',
                pageLabel: 'side'
            },
            sortOptions: {
                enabled: true
            },
            styleClass: 'vgt-table'
        };
    }
});

/***/ }),
/* 429 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
    props: {
        data: {
            required: true
        }
    },
    data: function data() {
        return {
            selectedRow: null,
            rows: [],
            columns: [{ label: 'Ordre', field: 'case_number', type: 'string' }, { label: 'Opgave', field: 'description', type: 'string' }, { label: 'Kunde', field: 'customer.name', type: 'string' }, { label: 'Budget omk.', field: 'budget_expenses', type: 'string' }, { label: 'Realiseret', field: 'total_expenses', type: 'number' }, { label: 'Eff. grad', field: 'efficiency_percent', type: 'string' }],
            searchOptions: {
                enabled: true,
                trigger: 'enter',
                placeholder: 'Søg og tryk enter ...',
                skipDiacritics: true
            },
            paginationOptions: {
                enabled: true,
                perPage: 30,
                rowsPerPageLabel: 'Rækker pr. side',
                allLabel: 'Alle',
                nextLabel: 'Næste',
                prevLabel: 'Forrige',
                ofLabel: 'af',
                pageLabel: 'side'
            },
            sortOptions: {
                enabled: true,
                initialSortBy: {
                    field: 'coverage',
                    type: 'desc'
                }
            },
            styleClass: 'vgt-table'
        };
    }
});

/***/ }),
/* 430 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
    data: function data() {
        return {
            showHelper: false,
            selectedItem: 'mainProjectTypes',
            counts: {
                mainProjectTypes: null,
                mainProjects: null,
                employeesSubProjects: null,
                subProjectTypes: null
            },
            switchItems: [{
                name: 'Hvilke entreprisetyper tjenes der penge på?',
                slug: 'mainProjectTypes'
            }, {
                name: 'Hvilke konkrete entrepriseopgaver tjenes der penge på?',
                slug: 'mainProjects'
            }, {
                name: 'Hvordan er effektiviteten på underentrepriserne?',
                slug: 'subProjectTypes'
            }, {
                name: 'Hvordan er medarbejdernes effektivitet?',
                slug: 'employeesSubProjects'
            }]
        };
    },

    methods: {
        updateCount: function updateCount(slug, event) {
            this.counts[slug] = event;
        },
        handleSelectItem: function handleSelectItem(item) {
            this.selectedItem = item;
        }
    },
    components: {
        'main-project-types': __webpack_require__(735),
        'main-projects': __webpack_require__(736),
        'employees-sub-projects': __webpack_require__(732),
        'sub-project-types': __webpack_require__(737)
    }
});

/***/ }),
/* 431 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_calculationService__ = __webpack_require__(29);




/* harmony default export */ __webpack_exports__["default"] = ({
    data: function data() {
        return {
            loading: true,
            data: null
        };
    },
    created: function created() {
        this.getData();
    },

    methods: {
        getData: function getData() {
            var _this = this;

            this.loading = true;
            var params = {
                date_from: this.$store.getters.getStartDate,
                date_to: this.$store.getters.getEndDate
            };
            if (this.$store.getters.getCurrentDepartment.uuid !== 0) {
                params.department = this.$store.getters.getCurrentDepartment.uuid;
            }
            __WEBPACK_IMPORTED_MODULE_0__services_calculationService__["b" /* valueChain */](params, function (response) {
                _this.data = response.data;
                _this.loading = false;
            }, function (err) {
                console.log(err);
                _this.loading = false;
            });
        }
    },
    computed: {
        globalParams: function globalParams() {
            var department = this.$store.getters.getCurrentDepartment.uuid;
            return department;
        }
    },
    watch: {
        globalParams: function globalParams() {
            this.getData();
        }
    }
});

/***/ }),
/* 432 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_calculationService__ = __webpack_require__(29);




/* harmony default export */ __webpack_exports__["default"] = ({
    data: function data() {
        return {
            showHelper: false,
            keyfigures: null,
            calculations: {
                offer: null,
                claims: null,
                close_to_budget: null,
                ongoing: null,
                open: null,
                payment_pending: null,
                payment_exceeded: null,
                payment_exceeded_total: null,
                snoozed: null,
                unbilled: null
            }
        };
    },

    methods: {
        getCalculations: function getCalculations() {
            var _this = this;

            this.calculations = {
                claims: null,
                close_to_budget: null,
                ongoing: null,
                open: null,
                payment_exceeded: null,
                payment_exceeded_total: null,
                snoozed: null,
                unbilled: null
            };
            var params = {
                date_from: this.$store.getters.getStartDate,
                date_to: this.$store.getters.getEndDate
            };
            if (this.$store.getters.getCurrentDepartment.uuid !== 0) {
                params.department = this.$store.getters.getCurrentDepartment.uuid;
            }
            __WEBPACK_IMPORTED_MODULE_0__services_calculationService__["c" /* find */]('index/counts', params, function (response) {
                _this.calculations = response.data;
            }, function (err) {
                console.log(err);
            });
            __WEBPACK_IMPORTED_MODULE_0__services_calculationService__["c" /* find */]('index-economy', params, function (response) {
                _this.keyfigures = response.data;
            }, function (err) {
                console.log(err);
            });
        }
    },
    created: function created() {
        this.getCalculations();
    },

    computed: {
        globalParams: function globalParams() {
            var department = this.$store.getters.getCurrentDepartment.uuid;
            return department;
        }
    },
    watch: {
        globalParams: function globalParams() {
            this.getCalculations();
        }
    },
    components: {
        'value-chain': __webpack_require__(741)
    }
});

/***/ }),
/* 433 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_userService__ = __webpack_require__(56);




/* harmony default export */ __webpack_exports__["default"] = ({
    data: function data() {
        return {
            username: '',
            password: '',
            rememberMe: false,
            showResetPasswordForm: false,
            passwordResetted: false
        };
    },
    created: function created() {
        this.checkIfDemoEnvironment();
    },

    methods: {
        checkIfDemoEnvironment: function checkIfDemoEnvironment() {
            if (true) {
                this.username = 'demo@proebitda.dk';
                this.password = 'demo';
            }
        },
        login: function login() {
            var _this = this;

            var body = {
                username: this.username,
                password: this.password
            };
            this.$auth.login({
                data: body,
                rememberMe: this.rememberMe,
                fetchUser: true,
                redirect: { name: 'Index' },
                success: function success(response) {
                    _this.$emit('loggedIn');
                    _this.$store.dispatch('getConfig');
                    var username = _this.$auth.user().name.split(' ')[0];
                    _this.$toastr('success', 'Velkommen, ' + username + '!', 'Logget ind');
                },
                error: function error(_error) {
                    console.log(_error);
                }
            });
        },
        toggleResetPasswordForm: function toggleResetPasswordForm() {
            this.showResetPasswordForm = true;
        },
        doReset: function doReset() {
            var _this2 = this;

            var params = {
                email: this.username
            };
            __WEBPACK_IMPORTED_MODULE_0__services_userService__["e" /* forgotPassword */](params, function (response) {
                _this2.passwordResetted = true;
            }, function (err) {
                alert('Der skete desværre en fejl ved nulstilling af din adgangskode. Tjek, at du har skrevet en gyldig e-mail adresse og prøv venligst igen.');
                console.log(err);
            });
        }
    }
});

/***/ }),
/* 434 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_calculationService__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_moment__);





/* harmony default export */ __webpack_exports__["default"] = ({
    data: function data() {
        return {
            loading: true,
            projectTypes: []
        };
    },
    created: function created() {
        this.getData();
    },

    methods: {
        getData: function getData() {
            var _this = this;

            this.loading = true;
            var params = {
                date_from: this.$store.getters.getStartDate,
                date_to: this.$store.getters.getEndDate
            };
            __WEBPACK_IMPORTED_MODULE_0__services_calculationService__["a" /* projectTypesPotential */](params, function (response) {
                if (_this.projectTypes.length > 0) {
                    response.data.forEach(function (responseType) {
                        _this.projectTypes.forEach(function (projectType) {
                            if (projectType.name === responseType.name) {
                                responseType.value = projectType.value;
                            }
                        });
                    });
                }
                _this.projectTypes = response.data;
                _this.loading = false;
            }, function (err) {
                console.log(err);
                _this.loading = false;
            });
        }
    },
    computed: {
        total: function total() {
            if (this.projectTypes.length > 0) {
                var total = 0;
                this.projectTypes.forEach(function (projectType) {
                    var value = projectType.total_revenue / 100 * projectType.value;
                    total += value;
                });
                return total * this.convertToYear;
            }
        },
        globalParams: function globalParams() {
            var startDate = this.$store.getters.getStartDate;
            var endDate = this.$store.getters.getEndDate;
            var department = this.$store.getters.getCurrentDepartment.uuid;
            return startDate + endDate + department;
        },
        convertToYear: function convertToYear() {
            var startDate = __WEBPACK_IMPORTED_MODULE_1_moment___default()(this.$store.getters.getStartDate);
            var endDate = __WEBPACK_IMPORTED_MODULE_1_moment___default()(this.$store.getters.getEndDate);
            if (endDate > __WEBPACK_IMPORTED_MODULE_1_moment___default()()) {
                endDate = __WEBPACK_IMPORTED_MODULE_1_moment___default()();
            }
            var duration = __WEBPACK_IMPORTED_MODULE_1_moment___default.a.duration(endDate.diff(startDate));
            var days = duration.asDays() + 1;
            return 365 / days;
        }
    },
    watch: {
        globalParams: function globalParams() {
            this.getData();
        }
    }
});

/***/ }),
/* 435 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_economyService__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_moment__);





/* harmony default export */ __webpack_exports__["default"] = ({
    data: function data() {
        return {
            loading: true,
            data: null,
            ebitda: null,
            customerHours: {
                now: 46,
                min: 0,
                max: 54,
                value: 0,
                label: '%'
            },
            projectRevenue: {
                now: 12300,
                min: 0,
                max: 50,
                value: 0,
                label: '%'
            },
            materialsUsage: {
                now: 2400,
                min: 0,
                max: 50,
                value: 0,
                label: '%'
            },
            coveragePercent: {
                now: 45,
                min: 0,
                max: 75,
                value: 0,
                label: '%'
            },
            hourPrice: {
                min: 0,
                max: 100,
                value: 0,
                label: 'kr.'
            }
        };
    },
    created: function created() {
        this.getData();
    },

    methods: {
        getData: function getData() {
            var _this = this;

            this.loading = true;
            var params = {
                date_from: this.$store.getters.getStartDate,
                date_to: this.$store.getters.getEndDate
            };
            __WEBPACK_IMPORTED_MODULE_0__services_economyService__["d" /* keyFigures */](params, function (response) {
                _this.data = response.data;
                _this.ebitda = _this.data.economy.ebitda;
                _this.customerHours.now = response.data.timeloggings.avg_percent;
                _this.customerHours.max = 100 - response.data.timeloggings.avg_percent;
                _this.loading = false;
            }, function (err) {
                console.log(err);
                _this.loading = false;
            });
        }
    },
    computed: {
        customerHoursTotal: function customerHoursTotal() {
            if (this.data && this.data.coverage.total && this.customerHours.value) {
                return this.data.coverage.total * (this.customerHours.value / this.customerHours.now) * this.convertToYear;
            }
            return 0;
        },
        projectRevenueTotal: function projectRevenueTotal() {
            if (this.data && this.data.revenue.invoices_total && this.projectRevenue.value) {
                return this.data.revenue.invoices_total * (this.projectRevenue.value / 100);
            }
            return 0;
        },
        materialsUsageTotal: function materialsUsageTotal() {
            if (this.data) {
                return this.data.materials.total * (this.materialsUsage.value / 100);
            }
            return 0;
        },
        projects: function projects() {
            var _this2 = this;

            if (this.data && this.coveragePercent.value !== 0) {
                var projects = this.data.coverage.projects;
                var responseProjects = [];
                projects.forEach(function (project) {
                    if (project.coverage_percent && project.coverage_percent < _this2.coveragePercent.value && project.coverage_percent > 0 && project.invoices_total > 0) {
                        responseProjects.push(project);
                    }
                });
                return responseProjects;
            }
        },
        coveragePercentTotal: function coveragePercentTotal() {
            var _this3 = this;

            if (this.data && this.coveragePercent.value !== 0) {
                var projects = this.projects;
                var count = 0;
                projects.forEach(function (project) {
                    if (project.coverage_percent && project.coverage_percent < _this3.coveragePercent.value && project.coverage_percent > 0 && project.invoices_total > 0) {
                        count += (_this3.coveragePercent.value - project.coverage_percent) / 100 * project.invoices_total;
                    }
                });
                return count * this.convertToYear;
            }
            return 0;
        },
        hourPriceTotal: function hourPriceTotal() {
            if (this.data && this.hourPrice.value !== 0) {
                return this.hourPrice.value * Math.round(this.data.timeloggings.total_with_project);
            }
            return 0;
        },
        totalPotential: function totalPotential() {
            return this.customerHoursTotal + this.projectRevenueTotal + this.materialsUsageTotal + this.coveragePercentTotal + this.hourPriceTotal;
        },
        globalParams: function globalParams() {
            var startDate = this.$store.getters.getStartDate;
            var endDate = this.$store.getters.getEndDate;
            var department = this.$store.getters.getCurrentDepartment.uuid;
            return startDate + endDate + department;
        },
        convertToYear: function convertToYear() {
            var startDate = __WEBPACK_IMPORTED_MODULE_1_moment___default()(this.$store.getters.getStartDate);
            var endDate = __WEBPACK_IMPORTED_MODULE_1_moment___default()(this.$store.getters.getEndDate);
            if (endDate > __WEBPACK_IMPORTED_MODULE_1_moment___default()()) {
                endDate = __WEBPACK_IMPORTED_MODULE_1_moment___default()();
            }
            var duration = __WEBPACK_IMPORTED_MODULE_1_moment___default.a.duration(endDate.diff(startDate));
            var days = duration.asDays() + 1;
            return 365 / days;
        }
    },
    watch: {
        globalParams: function globalParams() {
            this.getData();
        }
    },
    components: {
        'project-types-potential': __webpack_require__(743)
    }
});

/***/ }),
/* 436 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_projectTypeService__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_apexcharts__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_apexcharts___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_apexcharts__);





/* harmony default export */ __webpack_exports__["default"] = ({
    data: function data() {
        var _this = this;

        return {
            loading: true,
            columns: [{ label: 'Opgavetype', field: 'name', type: 'string' }, { label: 'Antal', field: 'projects_count', type: 'number' }, { label: 'DB pr. time (gns)', field: 'coverage_per_hour_avg', type: 'number' }, { label: 'Udvikling', field: 'progress_percent', type: 'number' }],
            rows: [],
            searchOptions: {
                enabled: true,
                trigger: 'enter',
                placeholder: 'Søg og tryk enter ...',
                skipDiacritics: true
            },
            paginationOptions: {
                enabled: true,
                perPage: 30,
                rowsPerPageLabel: 'Rækker pr. side',
                allLabel: 'Alle',
                nextLabel: 'Næste',
                prevLabel: 'Forrige',
                ofLabel: 'af',
                pageLabel: 'side'
            },
            sortOptions: {
                enabled: true,
                initialSortBy: {
                    field: 'coverage_per_hour_avg',
                    type: 'desc'
                }
            },
            styleClass: 'vgt-table',
            params: {
                'filter[status]': 'billed,posted',
                'include': 'customer,type'
            },
            height: '450',
            unit: ' kr.',
            options: {
                labels: [],
                yaxis: {
                    labels: {
                        formatter: function formatter(value) {
                            if (value > 0) {
                                return _this.$options.filters.currency(value);
                            }
                        }
                    },
                    title: {
                        text: this.ylabel
                    },
                    forceNiceScale: true,
                    min: 0
                },
                stroke: {
                    width: 3,
                    curve: 'smooth'
                },
                legend: {
                    offsetY: 10,
                    itemMargin: {
                        horizontal: 5,
                        vertical: 10
                    },
                    position: 'bottom'
                },
                colors: this.$store.state.graphColors
            },
            series: []
        };
    },
    created: function created() {
        this.getData();
    },

    methods: {
        getData: function getData() {
            var _this2 = this;

            this.loading = true;
            this.series = [];
            var params = {
                date_from: this.$store.getters.getStartDate,
                date_to: this.$store.getters.getEndDate
            };
            if (this.$store.getters.getCurrentDepartment.uuid !== 0) {
                params.department = this.$store.getters.getCurrentDepartment.uuid;
            }
            __WEBPACK_IMPORTED_MODULE_0__services_projectTypeService__["a" /* coveragePerHour */](params, function (response) {
                _this2.options.labels = response.data.labels;
                _this2.rows = response.data.values;

                _this2.loading = false;
                _this2.$emit('finishedLoading', response.data.values.length);
            }, function (err) {
                console.log(err);
                _this2.loading = false;
            });
        },
        selectProjectType: function selectProjectType(params) {
            this.series = [];
            this.series.push(params.row);
        },
        selectedRowClass: function selectedRowClass(row) {
            if (this.series.length > 0 && row.name === this.series[0].name) {
                return 'selected';
            }
        }
    },
    components: {
        VueApexCharts: __WEBPACK_IMPORTED_MODULE_1_vue_apexcharts___default.a
    },
    computed: {
        globalParams: function globalParams() {
            var startDate = this.$store.getters.getStartDate;
            var endDate = this.$store.getters.getEndDate;
            var department = this.$store.getters.getCurrentDepartment.uuid;
            return startDate + endDate + department;
        }
    },
    watch: {
        globalParams: function globalParams() {
            this.getData();
        }
    }
});

/***/ }),
/* 437 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_projectTypeService__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_apexcharts__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_apexcharts___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_apexcharts__);





/* harmony default export */ __webpack_exports__["default"] = ({
    data: function data() {
        var _this = this;

        return {
            loading: true,
            columns: [{ label: 'Opgavetype', field: 'name', type: 'string' }, { label: 'Antal', field: 'projects_count', type: 'number' }, { label: 'DB (sum)', field: 'coverage_avg', type: 'number' }, { label: 'Udvikling', field: 'progress_percent', type: 'number' }],
            rows: [],
            searchOptions: {
                enabled: true,
                trigger: 'enter',
                placeholder: 'Søg og tryk enter ...',
                skipDiacritics: true
            },
            paginationOptions: {
                enabled: true,
                perPage: 30,
                rowsPerPageLabel: 'Rækker pr. side',
                allLabel: 'Alle',
                nextLabel: 'Næste',
                prevLabel: 'Forrige',
                ofLabel: 'af',
                pageLabel: 'side'
            },
            sortOptions: {
                enabled: true,
                initialSortBy: {
                    field: 'coverage_avg',
                    type: 'desc'
                }
            },
            styleClass: 'vgt-table',
            params: {
                'filter[status]': 'billed,posted',
                'include': 'customer,type'
            },
            height: '450',
            unit: ' kr.',
            options: {
                labels: [],
                yaxis: {
                    labels: {
                        formatter: function formatter(value) {
                            if (value > 0) {
                                return _this.$options.filters.currency(value);
                            }
                        }
                    },
                    title: {
                        text: this.ylabel
                    },
                    forceNiceScale: true,
                    min: 0
                },
                stroke: {
                    width: 3,
                    curve: 'smooth'
                },
                legend: {
                    offsetY: 10,
                    itemMargin: {
                        horizontal: 5,
                        vertical: 10
                    },
                    position: 'bottom'
                },
                colors: this.$store.state.graphColors
            },
            series: []
        };
    },
    created: function created() {
        this.getData();
    },

    methods: {
        getData: function getData() {
            var _this2 = this;

            this.loading = true;
            this.series = [];
            var params = {
                date_from: this.$store.getters.getStartDate,
                date_to: this.$store.getters.getEndDate
            };
            if (this.$store.getters.getCurrentDepartment.uuid !== 0) {
                params.department = this.$store.getters.getCurrentDepartment.uuid;
            }
            __WEBPACK_IMPORTED_MODULE_0__services_projectTypeService__["c" /* development */](params, function (response) {
                _this2.options.labels = response.data.labels;
                _this2.rows = response.data.values;

                _this2.loading = false;
                _this2.$emit('finishedLoading', response.data.values.length);
            }, function (err) {
                console.log(err);
                _this2.loading = false;
            });
        },
        selectProjectType: function selectProjectType(params) {
            this.series = [];
            this.series.push(params.row);
        },
        selectedRowClass: function selectedRowClass(row) {
            if (this.series.length > 0 && row.name === this.series[0].name) {
                return 'selected';
            }
        }
    },
    components: {
        VueApexCharts: __WEBPACK_IMPORTED_MODULE_1_vue_apexcharts___default.a
    },
    computed: {
        globalParams: function globalParams() {
            var startDate = this.$store.getters.getStartDate;
            var endDate = this.$store.getters.getEndDate;
            var department = this.$store.getters.getCurrentDepartment.uuid;
            return startDate + endDate + department;
        }
    },
    watch: {
        globalParams: function globalParams() {
            this.getData();
        }
    }
});

/***/ }),
/* 438 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_projectTypeService__ = __webpack_require__(54);




/* harmony default export */ __webpack_exports__["default"] = ({
    data: function data() {
        return {
            selectedRow: null,
            loading: true,
            rows: [],
            columns: [{ label: 'Opgavetype', field: 'name', type: 'string' }],
            searchOptions: {
                enabled: true,
                trigger: 'enter',
                placeholder: 'Søg og tryk enter ...',
                skipDiacritics: true
            },
            paginationOptions: {
                enabled: true,
                perPage: 10,
                rowsPerPageLabel: 'Rækker pr. side',
                allLabel: 'Alle',
                nextLabel: 'Næste',
                prevLabel: 'Forrige',
                ofLabel: 'af',
                pageLabel: 'side'
            },
            sortOptions: {
                enabled: true
            },
            styleClass: 'vgt-table'
        };
    },
    created: function created() {
        this.getData();
    },

    methods: {
        getData: function getData() {
            var _this = this;

            this.loading = true;
            this.$emit('finishedLoading', null);
            this.selectedRow = null;
            var params = {
                date_from: this.$store.getters.getStartDate,
                date_to: this.$store.getters.getEndDate
            };
            if (this.$store.getters.getCurrentDepartment.uuid !== 0) {
                params.department = this.$store.getters.getCurrentDepartment.uuid;
            }
            __WEBPACK_IMPORTED_MODULE_0__services_projectTypeService__["b" /* projectTypeSkills */](params, function (response) {
                _this.rows = response.data;
                _this.$emit('finishedLoading', _this.rows.length);
                _this.loading = false;
            }, function (err) {
                console.log(err);
                _this.loading = false;
            });
        },
        selectEmployee: function selectEmployee(projectType) {
            this.selectedRow = projectType.row;
            console.log(projectType.row);
        },
        selectedRowClass: function selectedRowClass(row) {
            if (this.selectedRow && row.name === this.selectedRow.name) {
                return 'selected';
            }
        }
    },
    components: {
        'project-type-skills-single': __webpack_require__(748)
    },
    computed: {
        globalParams: function globalParams() {
            var startDate = this.$store.getters.getStartDate;
            var endDate = this.$store.getters.getEndDate;
            var department = this.$store.getters.getCurrentDepartment.uuid;
            return startDate + endDate + department;
        }
    },
    watch: {
        globalParams: function globalParams() {
            this.getData();
        }
    }
});

/***/ }),
/* 439 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
    props: ['data'],
    data: function data() {
        return {
            rows: [],
            columns: [{ label: 'Medarbejder', field: 'name', type: 'string' }, { label: 'Omsætning', field: 'invoices_total', type: 'number' }, { label: 'DB', field: 'coverage', type: 'number' }, { label: 'DG', field: 'coverage_percent', type: 'number' }, { label: 'DB pr. time', field: 'coverage_per_hour', type: 'number' }],
            searchOptions: {
                enabled: true,
                trigger: 'enter',
                placeholder: 'Søg og tryk enter ...',
                skipDiacritics: true
            },
            paginationOptions: {
                enabled: true,
                perPage: 10,
                rowsPerPageLabel: 'Rækker pr. side',
                allLabel: 'Alle',
                nextLabel: 'Næste',
                prevLabel: 'Forrige',
                ofLabel: 'af',
                pageLabel: 'side'
            },
            sortOptions: {
                enabled: true,
                initialSortBy: {
                    field: 'coverage_per_hour',
                    type: 'desc'
                }
            },
            styleClass: 'vgt-table'
        };
    }
});

/***/ }),
/* 440 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
    data: function data() {
        return {
            selectedProjectType: null,
            selectedItem: 'projectTypeRevenue',
            counts: {
                projectTypeRevenue: null,
                closedProjectsRevenue: null,
                claims: null
            },
            switchItems: [{
                name: 'Hvilke opgavetyper tjenes der penge på?',
                slug: 'projectTypeRevenue'
            }, {
                name: 'Hvilke konkrete opgaver tjenes der penge på?',
                slug: 'closedProjectsRevenue'
            }, {
                name: 'Afsluttede reklamationer',
                slug: 'claims'
            }, {
                name: 'Hvilke svende er gode til hvilke opgaver?',
                slug: 'projectTypeSkills'
            }, {
                name: 'Udviklingen i DB',
                slug: 'projectTypeDevelopment'
            }, {
                name: 'Udviklingen i DB pr. time',
                slug: 'coveragePerHourPerProjectTypeDevelopment'
            }]
        };
    },

    methods: {
        updateCount: function updateCount(slug, event) {
            this.counts[slug] = event;
        },
        setSelectedProjectType: function setSelectedProjectType(projectType) {
            this.selectedProjectType = projectType;
        },
        handleSelectItem: function handleSelectItem(item) {
            this.selectedItem = item;
        }
    },
    mounted: function mounted() {
        this.$store.state.view = 'learning';
    },

    components: {
        'project-type-development': __webpack_require__(746),
        'project-type-skills': __webpack_require__(747),
        'project-type-coverage-per-hour-development': __webpack_require__(745),
        'claims-table': __webpack_require__(268)
    }
});

/***/ }),
/* 441 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
    data: function data() {
        return {
            selectedItem: 'offerProjects',
            counts: {
                offerProjects: null,
                openProjects: null,
                snoozedProjects: null,
                noInvoiceProjects: null,
                ongoingProjects: null,
                openClaims: null,
                projectsCloseToBudget: '-'
            },
            switchItems: [{
                name: 'Tilbud',
                slug: 'offerProjects'
            }, {
                name: 'Ikke igangsatte opgaver',
                slug: 'openProjects'
            }, {
                name: 'Opgaver uden bevægelse i ' + this.$store.state.config.companyMeta.settings.snoozed_days + ' dage',
                slug: 'snoozedProjects'
            }, {
                name: 'Afsluttede opgaver, der ikke er fakturerede',
                slug: 'noInvoiceProjects'
            }, {
                name: 'Igangværende opgaver',
                slug: 'ongoingProjects'
            }, {
                name: 'Igangværende reklamationer',
                slug: 'openClaims'
            }]
        };
    },

    methods: {
        updateCount: function updateCount(slug, event) {
            this.counts[slug] = event;
        },
        handleSelectItem: function handleSelectItem(item) {
            this.selectedItem = item;
        }
    },
    mounted: function mounted() {
        this.$store.state.view = 'operations';
        if (this.$route.params.selectedItem) {
            this.selectedItem = this.$route.params.selectedItem;
        }
    }
});

/***/ }),
/* 442 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
    data: function data() {
        return {
            showHelper: false,
            selectedTable: 'closedProjectsRevenue',
            counts: {
                closedProjectsRevenue: null,
                ongoingProjects: null,
                snoozedProjects: null,
                openClaims: null,
                openProjects: null
            },
            sidebarMenuItems: [{
                name: 'Hvilke opgavetyper tjenes der penge på?',
                tableName: 'projectTypeRevenue'
            }, {
                name: 'Hvilke konkrete opgaver tjenes der penge på?',
                tableName: 'closedProjectsRevenue'
            }, {
                name: 'Igangværende opgaver',
                tableName: 'ongoingProjects'
            }, {
                name: 'Opgaver uden bevægelse de sidste ' + this.$store.state.config.companyMeta.settings.snoozed_days + ' dage',
                tableName: 'snoozedProjects'
            }, {
                name: 'Igangværende reklamationer',
                tableName: 'openClaims'
            }, {
                name: 'Ikke igangsatte opgaver',
                tableName: 'openProjects'
            }],
            goodTable: {
                columns: [{
                    label: 'Opgavetype',
                    field: 'type.name',
                    type: 'string'
                }, {
                    label: 'Opgave',
                    field: 'description',
                    type: 'string',
                    width: '20%'
                }, {
                    label: 'Kunde',
                    field: 'customer.name',
                    type: 'string'
                }, {
                    label: 'Omsætning',
                    field: 'revenue',
                    type: 'number'
                }, {
                    label: 'DB',
                    field: 'coverage',
                    width: '10%',
                    type: 'number'
                }, {
                    label: 'DG',
                    field: 'coverage_percent',
                    width: '8%',
                    type: 'number'
                }, {
                    label: 'DB/time',
                    field: 'coverage_per_hour',
                    width: '8%',
                    type: 'number'
                }],
                rows: []
            }
        };
    },

    computed: {},
    methods: {
        onRowClick: function onRowClick(params) {
            console.log(params);
        },
        rowStyleClassFn: function rowStyleClassFn(row) {
            return row.age > 18 ? 'green' : 'red';
        },
        updateCount: function updateCount(tableName, event) {
            this.counts[tableName] = event;
        }
    }
});

/***/ }),
/* 443 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
    data: function data() {
        return {
            username: '',
            password: '',
            rememberMe: false
        };
    },

    methods: {
        register: function register() {
            var body = {
                name: this.username,
                password: this.password
            };
            this.$auth.login({
                url: "https://demoapi.proebitda.dk/v1" + '/auth/register',
                data: body,
                rememberMe: this.rememberMe,
                fetchUser: true,
                redirect: { name: 'Login' },
                success: function success(response) {
                    console.log(response);
                },
                error: function error(_error) {
                    console.log(_error);
                }
            });
        }
    },
    components: {}
});

/***/ }),
/* 444 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
    data: function data() {
        return {
            showHelper: false,
            selectedItem: 'compareResponsibleEmployees',
            counts: {},
            switchItems: [{
                name: 'Hvilke ansvarlige er gode til hvilke opgaver?',
                slug: 'compareResponsibleEmployees'
            }, {
                name: 'Hvilke opgavetyper er den enkelte ansvarlige god til?',
                slug: 'compareProjectTypesForResponsibles'
            }]
        };
    },

    methods: {
        updateCount: function updateCount(slug, event) {
            this.counts[slug] = event;
        },
        handleSelectItem: function handleSelectItem(item) {
            this.selectedItem = item;
        }
    },
    components: {
        'compare-responsible-employees': __webpack_require__(755),
        'compare-project-types-for-responsibles': __webpack_require__(754)
    }
});

/***/ }),
/* 445 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_employeeService__ = __webpack_require__(22);




/* harmony default export */ __webpack_exports__["default"] = ({
    data: function data() {
        return {
            selectedRow: null,
            loading: true,
            rows: [],
            columns: [{ label: 'Opgavetype', field: 'name' }, { label: 'Ansvarlige', field: 'responsibles_count', type: 'number' }, { label: 'Omsætning', field: 'total_revenue', type: 'number' }, { label: 'DB', field: 'total_coverage', width: '10%', type: 'number' }, { label: 'DG', field: 'coverage_percent', width: '8%', type: 'number' }, { label: 'DB/time', field: 'coverage_per_hour', width: '8%', type: 'number' }],
            searchOptions: {
                enabled: true,
                trigger: 'enter',
                placeholder: 'Søg og tryk enter ...',
                skipDiacritics: true
            },
            paginationOptions: {
                enabled: true,
                perPage: 30,
                rowsPerPageLabel: 'Rækker pr. side',
                allLabel: 'Alle',
                nextLabel: 'Næste',
                prevLabel: 'Forrige',
                ofLabel: 'af',
                pageLabel: 'side'
            },
            sortOptions: {
                enabled: true,
                initialSortBy: {
                    field: 'total_coverage',
                    type: 'desc'
                }
            },
            styleClass: 'vgt-table'
        };
    },
    created: function created() {
        this.getData();
    },

    methods: {
        getData: function getData() {
            var _this = this;

            this.selectedRow = null;
            this.loading = true;
            var params = {
                date_from: this.$store.getters.getStartDate,
                date_to: this.$store.getters.getEndDate
            };
            if (this.$store.getters.getCurrentDepartment.uuid !== 0) {
                params['filter[by_department_uuid]'] = this.$store.getters.getCurrentDepartment.uuid;
            }
            __WEBPACK_IMPORTED_MODULE_0__services_employeeService__["c" /* compareResponsibleEmployeesProjectTypes */](params, function (response) {
                console.log(response.data);
                _this.rows = response.data;
                _this.$emit('finishedLoading', _this.rows.length);
                _this.loading = false;
            }, function (err) {
                console.log(err);
                _this.loading = false;
            });
        },
        selectProjectType: function selectProjectType(projectType) {
            this.selectedRow = projectType.row;
        },
        selectedRowClass: function selectedRowClass(row) {
            if (this.selectedRow && row.name === this.selectedRow.name) {
                return 'selected';
            }
        }
    },
    components: {
        'project-types-responsibles': __webpack_require__(757)
    },
    computed: {
        globalParams: function globalParams() {
            var startDate = this.$store.getters.getStartDate;
            var endDate = this.$store.getters.getEndDate;
            var department = this.$store.getters.getCurrentDepartment.uuid;
            return startDate + endDate + department;
        }
    },
    watch: {
        globalParams: function globalParams() {
            this.getData();
        }
    }
});

/***/ }),
/* 446 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_employeeService__ = __webpack_require__(22);




/* harmony default export */ __webpack_exports__["default"] = ({
    data: function data() {
        return {
            selectedRow: null,
            loading: true,
            rows: [],
            columns: [{ label: 'Ansvarlig', field: 'name' }, { label: 'Antal opgaver', field: 'total_projects', type: 'number' }, { label: 'Omsætning', field: 'total_revenue', type: 'number' }, { label: 'DB', field: 'total_coverage', width: '10%', type: 'number' }, { label: 'DG', field: 'coverage_percent', width: '8%', type: 'number' }, { label: 'DB/time', field: 'coverage_per_hour', width: '8%', type: 'number' }],
            searchOptions: {
                enabled: true,
                trigger: 'enter',
                placeholder: 'Søg og tryk enter ...',
                skipDiacritics: true
            },
            paginationOptions: {
                enabled: true,
                perPage: 30,
                rowsPerPageLabel: 'Rækker pr. side',
                allLabel: 'Alle',
                nextLabel: 'Næste',
                prevLabel: 'Forrige',
                ofLabel: 'af',
                pageLabel: 'side'
            },
            sortOptions: {
                enabled: true,
                initialSortBy: {
                    field: 'total_coverage',
                    type: 'desc'
                }
            },
            styleClass: 'vgt-table'
        };
    },
    created: function created() {
        this.getData();
    },

    methods: {
        getData: function getData() {
            var _this = this;

            this.loading = true;
            this.selectedRow = null;
            var params = {
                date_from: this.$store.getters.getStartDate,
                date_to: this.$store.getters.getEndDate
            };
            if (this.$store.getters.getCurrentDepartment.uuid !== 0) {
                params['filter[by_department_uuid]'] = this.$store.getters.getCurrentDepartment.uuid;
            }
            __WEBPACK_IMPORTED_MODULE_0__services_employeeService__["d" /* compareResponsibleEmployees */](params, function (response) {
                console.log(response.data);
                _this.rows = response.data;
                _this.$emit('finishedLoading', _this.rows.length);
                _this.loading = false;
            }, function (err) {
                console.log(err);
                _this.loading = false;
            });
        },
        selectEmployee: function selectEmployee(employee) {
            this.selectedRow = employee.row;
        },
        selectedRowClass: function selectedRowClass(row) {
            if (this.selectedRow && row.uuid === this.selectedRow.uuid) {
                return 'selected';
            }
        }
    },
    components: {
        'responsible-project-types': __webpack_require__(758)
    },
    computed: {
        globalParams: function globalParams() {
            var startDate = this.$store.getters.getStartDate;
            var endDate = this.$store.getters.getEndDate;
            var department = this.$store.getters.getCurrentDepartment.uuid;
            return startDate + endDate + department;
        }
    },
    watch: {
        globalParams: function globalParams() {
            this.getData();
        }
    }
});

/***/ }),
/* 447 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
    props: ['data'],
    data: function data() {
        return {
            columns: [{ label: 'Ordre', field: 'case_number', type: 'number' }, { label: 'Opgave', field: 'name' }, { label: 'Kunde', field: 'customer_name', type: 'string' }, { label: 'Startdato', field: 'start_date', type: 'string' }, { label: 'Omsætning', field: 'total_revenue', type: 'number' }, { label: 'DB', field: 'total_coverage', width: '10%', type: 'number' }, { label: 'DG', field: 'coverage_percent', width: '8%', type: 'number' }, { label: 'DB/time', field: 'coverage_per_hour', width: '8%', type: 'number' }],
            searchOptions: {
                enabled: true,
                trigger: 'enter',
                placeholder: 'Søg og tryk enter ...',
                skipDiacritics: true
            },
            paginationOptions: {
                enabled: true,
                perPage: 10,
                rowsPerPageLabel: 'Rækker pr. side',
                allLabel: 'Alle',
                nextLabel: 'Næste',
                prevLabel: 'Forrige',
                ofLabel: 'af',
                pageLabel: 'side'
            },
            sortOptions: {
                enabled: true,
                initialSortBy: {
                    field: 'total_coverage',
                    type: 'desc'
                }
            },
            styleClass: 'vgt-table'
        };
    },
    mounted: function mounted() {
        if (this.$auth.user().company.api_provider.slug === 'minuba') {
            this.columns.push({ label: 'Åbn', field: 'minuba_external_id' });
        }
    }
});

/***/ }),
/* 448 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
    props: ['data'],
    data: function data() {
        return {
            selectedRow: null,
            columns: [{ label: 'Ansvarlig', field: 'name' }, { label: 'Antal opgaver', field: 'sub_projects_count', type: 'number' }, { label: 'Omsætning', field: 'total_revenue', type: 'number' }, { label: 'DB', field: 'total_coverage', width: '10%', type: 'number' }, { label: 'DG', field: 'coverage_percent', width: '8%', type: 'number' }, { label: 'DB/time', field: 'coverage_per_hour', width: '8%', type: 'number' }],
            searchOptions: {
                enabled: true,
                trigger: 'enter',
                placeholder: 'Søg og tryk enter ...',
                skipDiacritics: true
            },
            paginationOptions: {
                enabled: true,
                perPage: 10,
                rowsPerPageLabel: 'Rækker pr. side',
                allLabel: 'Alle',
                nextLabel: 'Næste',
                prevLabel: 'Forrige',
                ofLabel: 'af',
                pageLabel: 'side'
            },
            sortOptions: {
                enabled: true,
                initialSortBy: {
                    field: 'total_coverage',
                    type: 'desc'
                }
            },
            styleClass: 'vgt-table'
        };
    },

    methods: {
        selectResponsible: function selectResponsible(responsible) {
            this.selectedRow = responsible.row;
        },
        selectedRowClass: function selectedRowClass(row) {
            if (this.selectedRow && row.name === this.selectedRow.name) {
                return 'selected';
            }
        },
        clearSelectedProjectType: function clearSelectedProjectType() {
            this.selectedRow = null;
        }
    },
    watch: {
        'data': 'clearSelectedProjectType'
    },
    components: {
        'project-types-projects': __webpack_require__(756)
    }
});

/***/ }),
/* 449 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
    props: ['data'],
    data: function data() {
        return {
            selectedRow: null,
            columns: [{ label: 'Opgavetype', field: 'name' }, { label: 'Antal opgaver', field: 'total_projects', type: 'number' }, { label: 'Omsætning', field: 'total_revenue', type: 'number' }, { label: 'DB', field: 'total_coverage', width: '10%', type: 'number' }, { label: 'DG', field: 'coverage_percent', width: '8%', type: 'number' }, { label: 'DB/time', field: 'coverage_per_hour', width: '8%', type: 'number' }],
            searchOptions: {
                enabled: true,
                trigger: 'enter',
                placeholder: 'Søg og tryk enter ...',
                skipDiacritics: true
            },
            paginationOptions: {
                enabled: true,
                perPage: 10,
                rowsPerPageLabel: 'Rækker pr. side',
                allLabel: 'Alle',
                nextLabel: 'Næste',
                prevLabel: 'Forrige',
                ofLabel: 'af',
                pageLabel: 'side'
            },
            sortOptions: {
                enabled: true,
                initialSortBy: {
                    field: 'total_coverage',
                    type: 'desc'
                }
            },
            styleClass: 'vgt-table'
        };
    },

    methods: {
        selectProjectType: function selectProjectType(projectType) {
            this.selectedRow = projectType.row;
        },
        selectedRowClass: function selectedRowClass(row) {
            if (this.selectedRow && row.name === this.selectedRow.name) {
                return 'selected';
            }
        },
        clearSelectedProjectType: function clearSelectedProjectType() {
            this.selectedRow = null;
        }
    },
    watch: {
        'data': 'clearSelectedProjectType'
    },
    components: {
        'responsible-projects': __webpack_require__(759)
    }
});

/***/ }),
/* 450 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
    props: ['data'],
    data: function data() {
        return {
            columns: [{ label: 'Ordre', field: 'case_number', type: 'number' }, { label: 'Opgave', field: 'name' }, { label: 'Kunde', field: 'customer_name', type: 'string' }, { label: 'Startdato', field: 'start_date', type: 'string' }, { label: 'Omsætning', field: 'total_revenue', type: 'number' }, { label: 'DB', field: 'total_coverage', width: '10%', type: 'number' }, { label: 'DG', field: 'coverage_percent', width: '8%', type: 'number' }, { label: 'DB/time', field: 'coverage_per_hour', width: '8%', type: 'number' }],
            searchOptions: {
                enabled: true,
                trigger: 'enter',
                placeholder: 'Søg og tryk enter ...',
                skipDiacritics: true
            },
            paginationOptions: {
                enabled: true,
                perPage: 10,
                rowsPerPageLabel: 'Rækker pr. side',
                allLabel: 'Alle',
                nextLabel: 'Næste',
                prevLabel: 'Forrige',
                ofLabel: 'af',
                pageLabel: 'side'
            },
            sortOptions: {
                enabled: true,
                initialSortBy: {
                    field: 'total_coverage',
                    type: 'desc'
                }
            },
            styleClass: 'vgt-table'
        };
    },
    mounted: function mounted() {
        if (this.$auth.user().company.api_provider.slug === 'minuba') {
            this.columns.push({ label: 'Åbn', field: 'minuba_external_id' });
        }
    }
});

/***/ }),
/* 451 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_economyService__ = __webpack_require__(4);




/* harmony default export */ __webpack_exports__["default"] = ({
    data: function data() {
        return {
            showEmptyAccounts: false,
            loading: true,
            accounts: null,
            accountCategories: null
        };
    },
    created: function created() {
        this.getAccountCategories();
        this.getAccounts();
    },

    methods: {
        getAccountCategories: function getAccountCategories() {
            var _this = this;

            var params = {};
            __WEBPACK_IMPORTED_MODULE_0__services_economyService__["a" /* accountCategories */](params, function (response) {
                _this.accountCategories = response.data;
            }, function (err) {
                console.log(err);
            });
        },
        getAccounts: function getAccounts() {
            var _this2 = this;

            this.loading = true;
            var params = {};
            __WEBPACK_IMPORTED_MODULE_0__services_economyService__["c" /* accounts */](params, function (response) {
                _this2.accounts = response.data;
                _this2.loading = false;
            }, function (err) {
                console.log(err);
                _this2.loading = false;
            });
        },
        updateAccount: function updateAccount(account, event) {
            var _this3 = this;

            if (this.$auth.user().name.includes('Demo')) {
                alert('Det er ikke muligt at ændre indstillinger i demo-versionen.');
                return;
            }
            var body = {
                budget: account.budget,
                account_category_uuid: event
            };
            if (event.target) {
                body.account_category_uuid = event.target.value;
            }
            __WEBPACK_IMPORTED_MODULE_0__services_economyService__["b" /* updateAccount */](account.uuid, body, function (response) {
                _this3.$toastr('success', 'Kontoen blev opdateret', 'Sådan!');
            });
        },
        toggleAccount: function toggleAccount(account) {
            var _this4 = this;

            if (this.$auth.user().name.includes('Demo')) {
                alert('Det er ikke muligt at ændre indstillinger i demo-versionen.');
                return;
            }
            var body = {
                show: account.show
            };
            __WEBPACK_IMPORTED_MODULE_0__services_economyService__["b" /* updateAccount */](account.uuid, body, function (response) {
                _this4.$toastr('success', 'Kontoen blev opdateret', 'Sådan!');
            });
        }
    },
    computed: {
        filteredAccounts: function filteredAccounts() {
            var _this5 = this;

            if (this.accounts) {
                var accounts = [];
                this.accounts.forEach(function (account) {
                    if (_this5.showEmptyAccounts) {
                        accounts.push(account);
                    } else {
                        if (account.balance && account.balance !== 0 && account.balance !== '0' && account.balance !== '0.00') {
                            accounts.push(account);
                        }
                    }
                });
                return accounts;
            }
        }
    }
});

/***/ }),
/* 452 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(469);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__services_economyService__ = __webpack_require__(4);





/* harmony default export */ __webpack_exports__["default"] = ({
    data: function data() {
        return {
            loading: true,
            accountCategories: null,
            budgetCalc: null
        };
    },
    mounted: function mounted() {
        this.getAccountCategories();
    },

    methods: {
        getAccountCategories: function getAccountCategories() {
            var _this = this;

            __WEBPACK_IMPORTED_MODULE_1__services_economyService__["a" /* accountCategories */]({}, function (response) {
                _this.accountCategories = response.data;
                _this.loading = false;
            }, function (err) {
                console.log(err);
            });
        },
        updateValue: function updateValue(uuid, month, value) {
            var _this2 = this;

            var body = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()({}, 'budget_' + month, value);
            __WEBPACK_IMPORTED_MODULE_1__services_economyService__["b" /* updateAccount */](uuid, body, function (response) {}, function (err) {
                console.log(err);
                _this2.$toastr('error', 'Der skete en fejl ved opdatering af budgettet', 'Hovsa!');
            });
        }
    }
});

/***/ }),
/* 453 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_companyService__ = __webpack_require__(37);




/* harmony default export */ __webpack_exports__["default"] = ({
    data: function data() {
        return {
            loading: false,
            companies: null
        };
    },
    created: function created() {
        this.getCompanies();
    },

    methods: {
        getCompanies: function getCompanies() {
            var _this = this;

            this.loading = true;
            var params = {
                include: 'api_provider'
            };
            __WEBPACK_IMPORTED_MODULE_0__services_companyService__["a" /* findAll */](params, function (response) {
                _this.companies = response.data;
                _this.loading = false;
            }, function (err) {
                console.log(err);
                _this.loading = false;
            });
        },
        changeCompany: function changeCompany(company) {
            var _this2 = this;

            var body = {
                company_uuid: company.uuid
            };
            __WEBPACK_IMPORTED_MODULE_0__services_companyService__["b" /* change */](body, function (response) {
                _this2.$toastr('success', 'Virksomhed opdateret. Opdaterer siden.', 'Sådan!');
                setTimeout(function () {
                    window.location.href = '/';
                }, 1000);
            }, function (err) {
                console.log(err);
            });
        }
    }
});

/***/ }),
/* 454 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_settingsService__ = __webpack_require__(93);




/* harmony default export */ __webpack_exports__["default"] = ({
    data: function data() {
        return {
            loading: true,
            rows: [],
            columns: [{ label: 'Ordre', field: 'case_number', type: 'number' }, { label: 'Opgavetype', field: 'type.name', type: 'string' }, { label: 'Opgave', field: 'description', type: 'string', width: '20%' }, { label: 'Kunde', field: 'customer.name', type: 'string' }, { label: 'Startdato', field: 'start_date', type: 'string' }],
            searchOptions: {
                enabled: true,
                trigger: 'enter',
                placeholder: 'Søg og tryk enter ...',
                skipDiacritics: true
            },
            paginationOptions: {
                enabled: true,
                perPage: 30,
                rowsPerPageLabel: 'Rækker pr. side',
                allLabel: 'Alle',
                nextLabel: 'Næste',
                prevLabel: 'Forrige',
                ofLabel: 'af',
                pageLabel: 'side'
            },
            sortOptions: {
                enabled: true,
                initialSortBy: {
                    field: 'case_number',
                    type: 'asc'
                }
            },
            styleClass: 'vgt-table'
        };
    },
    created: function created() {
        if (this.$auth.user().company.api_provider.slug === 'minuba') {
            this.columns.push({ label: 'Åbn', field: 'minuba_external_id' });
        }
        this.getData();
    },

    methods: {
        getData: function getData() {
            var _this = this;

            this.loading = true;
            var params = {
                date_from: this.$store.getters.getStartDate,
                date_to: this.$store.getters.getEndDate
            };
            if (this.$store.getters.getCurrentDepartment.uuid !== 0) {
                params.department = this.$store.getters.getCurrentDepartment.uuid;
            }
            __WEBPACK_IMPORTED_MODULE_0__services_settingsService__["a" /* cleanup */](params, function (response) {
                _this.rows = response.data.projects.rows;
                _this.loading = false;
            }, function (err) {
                console.log(err);
                _this.loading = false;
            });
        }
    }
});

/***/ }),
/* 455 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_employeeService__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__services_companyService__ = __webpack_require__(37);





/* harmony default export */ __webpack_exports__["default"] = ({
    data: function data() {
        return {
            employeeTypes: ['Svend, funktionær', 'Svend, timelønnet', 'Lærling'],
            showUpdateButton: null,
            employees: null,
            employeeCalc: ''
        };
    },
    created: function created() {
        this.getEmployees();
    },

    methods: {
        getEmployeeCalc: function getEmployeeCalc() {
            var _this = this;

            __WEBPACK_IMPORTED_MODULE_1__services_companyService__["c" /* employeeCalc */]({}, function (response) {
                _this.employeeCalc = response.data;
            }, function (err) {
                console.log(err);
            });
        },
        selectEmployeeCalc: function selectEmployeeCalc(type) {
            var _this2 = this;

            var body = {
                employeeCalc: type
            };
            __WEBPACK_IMPORTED_MODULE_1__services_companyService__["d" /* updateEmployeeCalc */](body, function (response) {
                console.log(response);
                _this2.getEmployeeCalc();
                _this2.$toastr('success', 'Medarbejder indtjening indstillingen blev opdateret', 'Sådan!');
            }, function (err) {
                console.log(err);
            });
        },
        getEmployees: function getEmployees() {
            var _this3 = this;

            __WEBPACK_IMPORTED_MODULE_0__services_employeeService__["a" /* findAll */]({}, function (response) {
                _this3.employees = response.data;
            }, function (err) {
                console.log(err);
            });
        },
        updateEmployee: function updateEmployee(employee) {
            var _this4 = this;

            if (this.$auth.user().name.includes('Demo')) {
                alert('Det er ikke muligt at ændre indstillinger i demo-versionen.');
                return;
            }
            this.showUpdateButton = null;
            var body = {
                working_field: employee.working_field,
                responsible_field: employee.responsible_field,
                weekly_hours_working: employee.weekly_hours_working,
                working_field_name: employee.working_field_name ? employee.working_field_name : ''
            };
            __WEBPACK_IMPORTED_MODULE_0__services_employeeService__["b" /* update */](employee.uuid, body, function (response) {
                _this4.$toastr('success', 'Medarbejderen blev opdateret', 'Sådan!');
            }, function (err) {
                _this4.$toastr('error', 'Der skete en fejl ved opdatering af medarbejderen', 'Hov!');
                console.log(err);
            });
        }
    }
});

/***/ }),
/* 456 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_projectService__ = __webpack_require__(11);




/* harmony default export */ __webpack_exports__["default"] = ({
    data: function data() {
        return {
            loading: true,
            columns: [{ label: 'Ordre', field: 'case_number' }, { label: 'Opgave', field: 'description' }, { label: 'Kunde', field: 'customer.name' }, { label: 'Startdato', field: 'start_date' }, { label: 'Synlighed', field: 'show', type: 'number' }, { label: 'Vis/skjul', field: 'action' }],
            rows: [],
            searchOptions: {
                enabled: true,
                trigger: 'enter',
                placeholder: 'Søg og tryk enter ...',
                skipDiacritics: true
            },
            paginationOptions: {
                enabled: true,
                perPage: 30,
                rowsPerPageLabel: 'Rækker pr. side',
                allLabel: 'Alle',
                nextLabel: 'Næste',
                prevLabel: 'Forrige',
                ofLabel: 'af',
                pageLabel: 'side'
            },
            sortOptions: {
                enabled: true,
                initialSortBy: {
                    field: 'case_number',
                    type: 'asc'
                }
            }
        };
    },
    mounted: function mounted() {
        if (this.$auth.user().company.api_provider.slug === 'minuba') {
            this.columns.push({ label: 'Åbn', field: 'minuba_external_id' });
        }
        this.getData();
    },

    methods: {
        getData: function getData() {
            var _this = this;

            this.loading = true;
            var params = {
                'include': 'type,customer,status',
                'filter[status]': 'pending,ongoing,unbilled'
            };
            __WEBPACK_IMPORTED_MODULE_0__services_projectService__["a" /* find */](params, function (response) {
                _this.rows = response.data;
                _this.loading = false;
            }, function (err) {
                console.log(err);
                _this.loading = false;
            });
        },
        updateProject: function updateProject(project, show) {
            var params = {
                'uuid': project.uuid,
                'show': show ? 1 : 0
            };
            __WEBPACK_IMPORTED_MODULE_0__services_projectService__["b" /* update */](params, function (response) {
                console.log(response);
                project.show = response.data.show;
            }, function (err) {
                console.log(err);
            });
        }
    }
});

/***/ }),
/* 457 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(465);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__services_settingsService__ = __webpack_require__(93);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__services_companyService__ = __webpack_require__(37);






/* harmony default export */ __webpack_exports__["default"] = ({
    data: function data() {
        return {
            settings: null,
            employeeCalc: null
        };
    },
    mounted: function mounted() {
        this.setSettings();
        this.getEmployeeCalc();
    },

    methods: {
        getEmployeeCalc: function getEmployeeCalc() {
            var _this = this;

            __WEBPACK_IMPORTED_MODULE_2__services_companyService__["c" /* employeeCalc */]({}, function (response) {
                _this.employeeCalc = response.data;
            }, function (err) {
                console.log(err);
            });
        },
        selectEmployeeCalc: function selectEmployeeCalc(type) {
            var _this2 = this;

            var body = {
                employeeCalc: type
            };
            __WEBPACK_IMPORTED_MODULE_2__services_companyService__["d" /* updateEmployeeCalc */](body, function (response) {
                console.log(response);
                _this2.getEmployeeCalc();
            }, function (err) {
                console.log(err);
            });
        },
        setSettings: function setSettings() {
            this.settings = JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.$store.state.config.companyMeta.settings));
        },
        doSave: function doSave() {
            var _this3 = this;

            if (this.$auth.user().name.includes('Demo')) {
                alert('Det er ikke muligt at ændre indstillinger i demo-versionen.');
                return;
            }
            if (this.settings.main_employee_percent < 50) {
                alert('Værdien i feltet "Hvornår kan en opgave betragtes som værende udført af 1 svend?" er for lav. Angiv venligst minimum 50%.');
                return;
            }
            var body = {
                coverage_percent: {
                    medium: { value: this.settings.coverage_percent.medium.value },
                    high: { value: this.settings.coverage_percent.high.value }
                },
                coverage_per_hour: {
                    medium: { value: this.settings.coverage_per_hour.medium.value },
                    high: { value: this.settings.coverage_per_hour.high.value }
                },
                timelogging: {
                    medium: { value: this.settings.timelogging.medium.value },
                    high: { value: this.settings.timelogging.high.value }
                },
                main_employee_percent: this.settings.main_employee_percent,
                overdue_days: this.settings.overdue_days,
                snoozed_days: this.settings.snoozed_days
            };
            __WEBPACK_IMPORTED_MODULE_1__services_settingsService__["b" /* update */](body, function (response) {
                _this3.$toastr('success', 'Indstillingerne blev opdateret', 'Sådan!');
                setTimeout(function () {
                    window.location.href = '/';
                }, 1000);
            }, function (err) {
                console.log(err);
            });
        },
        doReset: function doReset() {
            var _this4 = this;

            if (this.$auth.user().name.includes('Demo')) {
                alert('Det er ikke muligt at ændre indstillinger i demo-versionen.');
                return;
            }
            __WEBPACK_IMPORTED_MODULE_1__services_settingsService__["b" /* update */]({}, function (response) {
                _this4.$toastr('success', 'Indstillingerne blev gendannet', 'Sådan!');
                setTimeout(function () {
                    window.location.href = '/';
                }, 1000);
            }, function (err) {
                console.log(err);
            });
        }
    }
});

/***/ }),
/* 458 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_projectStatusService__ = __webpack_require__(349);




/* harmony default export */ __webpack_exports__["default"] = ({
    data: function data() {
        return {
            statuses: null,
            statusTypes: null
        };
    },
    created: function created() {
        this.getData();
        this.getStatusTypes();
    },

    methods: {
        getData: function getData() {
            var _this = this;

            __WEBPACK_IMPORTED_MODULE_0__services_projectStatusService__["a" /* findAll */]({}, function (response) {
                _this.statuses = response.data;
            }, function (err) {
                console.log(err);
            });
        },
        getStatusTypes: function getStatusTypes() {
            var _this2 = this;

            __WEBPACK_IMPORTED_MODULE_0__services_projectStatusService__["b" /* statusTypes */]({}, function (response) {
                _this2.statusTypes = response.data;
            }, function (err) {
                console.log(err);
            });
        },
        update: function update(status, event) {
            var _this3 = this;

            if (this.$auth.user().name.includes('Demo')) {
                alert('Det er ikke muligt at ændre indstillinger i demo-versionen.');
                return;
            }
            var body = {
                status_uuid: event.target.value
            };
            __WEBPACK_IMPORTED_MODULE_0__services_projectStatusService__["c" /* update */](status.uuid, body, function (response) {
                _this3.$toastr('success', 'Opgavestatusen blev opdateret', 'Sådan!');
            }, function (err) {
                console.log(err);
            });
        }
    }
});

/***/ }),
/* 459 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_projectService__ = __webpack_require__(11);




/* harmony default export */ __webpack_exports__["default"] = ({
    data: function data() {
        return {
            loading: true,
            columns: [{ label: 'Ordre', field: 'case_number' }, { label: 'Opgave', field: 'description' }, { label: 'Kunde', field: 'customer.name' }, { label: 'Startdato', field: 'start_date' }, { label: 'Status', field: 'status.name' }],
            rows: [],
            searchOptions: {
                enabled: true,
                trigger: 'enter',
                placeholder: 'Søg og tryk enter ...',
                skipDiacritics: true
            },
            paginationOptions: {
                enabled: true,
                perPage: 30,
                rowsPerPageLabel: 'Rækker pr. side',
                allLabel: 'Alle',
                nextLabel: 'Næste',
                prevLabel: 'Forrige',
                ofLabel: 'af',
                pageLabel: 'side'
            },
            sortOptions: {
                enabled: true,
                initialSortBy: {
                    field: 'case_number',
                    type: 'asc'
                }
            }
        };
    },
    mounted: function mounted() {
        if (this.$auth.user().company.api_provider.slug === 'minuba') {
            this.columns.push({ label: 'Åbn', field: 'minuba_external_id' });
        }
        this.getData();
    },

    methods: {
        getData: function getData() {
            var _this = this;

            var params = {
                'include': 'type,customer,status',
                'filter[status]': 'offer,pending,ongoing,unbilled',
                'filter[missingBudget]': 1
            };
            __WEBPACK_IMPORTED_MODULE_0__services_projectService__["a" /* find */](params, function (response) {
                _this.rows = response.data;
                _this.loading = false;
            }, function (err) {
                console.log(err);
                _this.loading = false;
            });
        }
    }
});

/***/ }),
/* 460 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_userService__ = __webpack_require__(56);




/* harmony default export */ __webpack_exports__["default"] = ({
    data: function data() {
        return {
            user: {
                new_password: ''
            }
        };
    },

    methods: {
        updateUser: function updateUser(user) {
            var _this = this;

            if (this.$auth.user().name.includes('Demo')) {
                alert('Det er ikke muligt at ændre indstillinger i demo-versionen.');
                return;
            }
            var body = {
                name: this.$auth.user().name,
                email: this.$auth.user().email
            };
            if (this.user.new_password !== '') {
                body.password = this.user.new_password;
                body.password_confirmation = this.user.new_password;
            }
            __WEBPACK_IMPORTED_MODULE_0__services_userService__["a" /* update */](this.$auth.user().uuid, body, function (response) {
                _this.$toastr('success', 'Profil opdateret. Opdaterer siden.', 'Sådan!');
                setTimeout(function () {
                    window.location.href = '/';
                }, 1000);
            }, function (err) {
                console.log(err);
                _this.$toastr('error', 'Der skete en fejl ved opdatering af brugeren', 'Hovsa!');
            });
        }
    }
});

/***/ }),
/* 461 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_userService__ = __webpack_require__(56);




/* harmony default export */ __webpack_exports__["default"] = ({
    data: function data() {
        return {
            loading: false,
            availableDepartments: [],
            newUser: {
                name: '',
                email: '',
                role_id: 3,
                password: '',
                relation_department_id: null
            },
            users: null
        };
    },
    created: function created() {
        this.getUsers();
        this.availableDepartments = this.$store.getters.getAvailableDepartments;
    },

    methods: {
        getUsers: function getUsers() {
            var _this = this;

            this.loading = true;
            __WEBPACK_IMPORTED_MODULE_0__services_userService__["b" /* all */]({}, function (response) {
                _this.users = response.data;
                console.log(_this.users);
                _this.loading = false;
            }, function (err) {
                console.log(err);
                _this.loading = false;
            });
        },
        resetFields: function resetFields() {
            this.newUser = {
                name: '',
                email: '',
                role_id: 3,
                password: ''
            };
        },
        createUser: function createUser() {
            var _this2 = this;

            if (this.$auth.user().name.includes('Demo')) {
                alert('Det er ikke muligt at ændre indstillinger i demo-versionen.');
                return;
            }
            if (this.newUser.role_id === 4 && !this.newUser.relation_department_id) {
                alert('Du skal angive en afdeling til den afdelingsansvarlige for at oprette brugeren.');
                return;
            }
            var body = {
                name: this.newUser.name,
                email: this.newUser.email,
                role_id: this.newUser.role_id,
                relation_department_id: this.newUser.relation_department_id,
                password: this.newUser.password,
                password_confirmation: this.newUser.password
            };
            __WEBPACK_IMPORTED_MODULE_0__services_userService__["c" /* create */](body, function (response) {
                _this2.$toastr('success', 'Brugeren blev oprettet', 'Sådan!');
                _this2.getUsers();
                _this2.resetFields();
            }, function (err) {
                _this2.$toastr('error', 'Der skete en fejl ved oprettelse af brugeren', 'Hovsa!');
                console.log(err);
            });
        },
        updateUser: function updateUser(user) {
            var _this3 = this;

            if (this.$auth.user().name.includes('Demo')) {
                alert('Det er ikke muligt at ændre indstillinger i demo-versionen.');
                return;
            }
            if (user.role_id === 4 && !user.relation_department_id) {
                alert('Vælg en afdeling til den afdelingsansvarlige for at opdatere brugeren.');
                return;
            }
            var body = {
                name: user.name,
                email: user.email,
                role_id: user.role_id,
                relation_department_id: user.relation_department_id
            };
            if (user.new_password) {
                body.password = user.new_password;
                body.password_confirmation = user.new_password;
            }
            __WEBPACK_IMPORTED_MODULE_0__services_userService__["a" /* update */](user.uuid, body, function (response) {
                _this3.$toastr('success', 'Brugeren blev opdateret', 'Sådan!');
                _this3.getUsers();
            }, function (err) {
                console.log(err);
                _this3.$toastr('error', 'Der skete en fejl ved opdatering af brugeren', 'Hovsa!');
            });
        },
        deleteUser: function deleteUser(user) {
            var _this4 = this;

            if (this.$auth.user().name.includes('Demo')) {
                alert('Det er ikke muligt at ændre indstillinger i demo-versionen.');
                return;
            }
            __WEBPACK_IMPORTED_MODULE_0__services_userService__["d" /* remove */](user.uuid, function (response) {
                _this4.$toastr('success', 'Brugeren blev slettet', 'Sådan!');
                _this4.getUsers();
            }, function (err) {
                console.log(err);
                _this4.$toastr('error', 'Der skete en fejl ved sletning af brugeren', 'Hovsa!');
            });
        }
    },
    computed: {
        sortedUsers: function sortedUsers() {
            if (this.users) {
                var users = [];
                this.users.forEach(function (user) {
                    if (user.roles[0].name !== 'super-admin') {
                        user.role_id = user.roles[0].id;
                        user.new_password = null;
                        users.push(user);
                    }
                });
                return users;
            }
        }
    }
});

/***/ }),
/* 462 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_companyService__ = __webpack_require__(37);




/* harmony default export */ __webpack_exports__["default"] = ({
    data: function data() {
        return {
            budgetCalc: null
        };
    },
    mounted: function mounted() {
        this.getBudgetSetting();
    },

    methods: {
        getBudgetSetting: function getBudgetSetting() {
            var _this = this;

            __WEBPACK_IMPORTED_MODULE_0__services_companyService__["e" /* budgetCalc */]({}, function (response) {
                _this.budgetCalc = response.data;
            }, function (err) {
                console.log(err);
            });
        },
        selectBudgetCalc: function selectBudgetCalc(type) {
            var _this2 = this;

            var body = {
                budgetCalc: type
            };
            __WEBPACK_IMPORTED_MODULE_0__services_companyService__["f" /* updateBudgetCalc */](body, function (response) {
                console.log(response);
                _this2.getBudgetSetting();
                _this2.$toastr('success', 'Budget indstillingen blev opdateret', 'Sådan!');
            }, function (err) {
                console.log(err);
            });
        }
    }
});

/***/ }),
/* 463 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
    data: function data() {
        return {
            selected: 'general',
            menuitems: [{ name: 'Generelt', slug: 'general', icon: 'cogs' }, { name: 'Kontoplan', slug: 'accountPlan', icon: 'list' }, { name: 'Budget', slug: 'budget', icon: 'calculator' }, { name: 'Medarbejdere', slug: 'employees', icon: 'users' }, { name: 'Opgavestatus', slug: 'projectStatuses', icon: 'briefcase' }, { name: 'Skjul opgaver', slug: 'excludeProjects', icon: 'times' }, { name: 'Systembrugere', slug: 'users', icon: 'users' }, { name: 'Din profil', slug: 'user', icon: 'user' }, { name: 'Opgaver uden budget', slug: 'projectsMissingBudget', icon: 'divide' }]
        };
    },

    components: {
        'accountPlan': __webpack_require__(760),
        'budget': __webpack_require__(761),
        'valuechain-calculation': __webpack_require__(771),
        'employees': __webpack_require__(764),
        'general': __webpack_require__(766),
        'cleanup': __webpack_require__(763),
        'projectStatuses': __webpack_require__(767),
        'users': __webpack_require__(770),
        'user': __webpack_require__(769),
        'exclude-projects': __webpack_require__(765),
        'projects-missing-budget': __webpack_require__(768)
    },
    mounted: function mounted() {
        if (this.$route.params.selected) {
            this.selected = this.$route.params.selected;
        }
        if (this.$store.state.config.availableDepartments.length > 2) {
            this.menuitems.push({
                name: 'Uden afdeling (oprydning)',
                slug: 'cleanup',
                icon: 'broom'
            });
        }
    }
});

/***/ }),
/* 464 */,
/* 465 */,
/* 466 */,
/* 467 */,
/* 468 */,
/* 469 */,
/* 470 */,
/* 471 */,
/* 472 */,
/* 473 */,
/* 474 */,
/* 475 */,
/* 476 */,
/* 477 */,
/* 478 */,
/* 479 */,
/* 480 */,
/* 481 */,
/* 482 */,
/* 483 */,
/* 484 */,
/* 485 */,
/* 486 */,
/* 487 */,
/* 488 */,
/* 489 */,
/* 490 */,
/* 491 */,
/* 492 */,
/* 493 */,
/* 494 */,
/* 495 */,
/* 496 */,
/* 497 */,
/* 498 */,
/* 499 */,
/* 500 */,
/* 501 */,
/* 502 */,
/* 503 */,
/* 504 */,
/* 505 */,
/* 506 */,
/* 507 */,
/* 508 */,
/* 509 */,
/* 510 */,
/* 511 */,
/* 512 */,
/* 513 */,
/* 514 */,
/* 515 */,
/* 516 */,
/* 517 */,
/* 518 */,
/* 519 */,
/* 520 */,
/* 521 */,
/* 522 */,
/* 523 */,
/* 524 */,
/* 525 */,
/* 526 */,
/* 527 */,
/* 528 */,
/* 529 */,
/* 530 */,
/* 531 */,
/* 532 */,
/* 533 */,
/* 534 */,
/* 535 */,
/* 536 */,
/* 537 */,
/* 538 */,
/* 539 */,
/* 540 */,
/* 541 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(false);
// imports


// module
exports.push([module.i, "\n.placeholder[data-v-0466fc80] {\n  height: -webkit-fit-content;\n  height: fit-content;\n}\n.ebitda-wrapper[data-v-0466fc80] {\n  font-size: 14px;\n}\n.ebitda-wrapper.child .line[data-v-0466fc80]:last-of-type {\n    font-weight: 700;\n}\n.ebitda-wrapper .line[data-v-0466fc80] {\n    display: -ms-flexbox;\n    display: flex;\n    cursor: pointer;\n    position: relative;\n}\n.ebitda-wrapper .line[data-v-0466fc80]:hover {\n      background: rgba(0, 0, 0, 0.05);\n}\n.ebitda-wrapper .line[data-v-0466fc80]:hover:before {\n        position: absolute;\n        top: -5px;\n        right: -10px;\n        bottom: -5px;\n        left: -10px;\n        content: \"\";\n        background: transparent;\n        border: 5px solid rgba(0, 0, 0, 0.05);\n        border-right-width: 10px;\n        border-left-width: 10px;\n        border-radius: 3px;\n}\n.ebitda-wrapper .line.clickable[data-v-0466fc80] {\n      cursor: pointer;\n}\n.ebitda-wrapper .line.clickable[data-v-0466fc80]:hover {\n        background: rgba(0, 0, 0, 0.05);\n}\n.ebitda-wrapper .line.bold[data-v-0466fc80] {\n      font-weight: 700;\n}\n.ebitda-wrapper .line.selected[data-v-0466fc80] {\n      background: #172b43;\n      color: #fff;\n      position: relative;\n}\n.ebitda-wrapper .line.selected[data-v-0466fc80]:before {\n        position: absolute;\n        top: -5px;\n        right: -10px;\n        bottom: -5px;\n        left: -10px;\n        content: \"\";\n        background: transparent;\n        border: 5px solid #172b43;\n        border-right-width: 10px;\n        border-left-width: 10px;\n        border-radius: 3px;\n}\n.ebitda-wrapper .line.top[data-v-0466fc80] {\n      font-weight: 700;\n}\n.ebitda-wrapper .line[data-v-0466fc80]:not(:last-of-type) {\n      margin-bottom: 15px;\n}\n.ebitda-wrapper .line[data-v-0466fc80]:last-of-type {\n      font-weight: 700;\n}\n.ebitda-wrapper .line .name[data-v-0466fc80] {\n      -ms-flex-positive: 1;\n          flex-grow: 1;\n      padding-right: 15px;\n}\n.ebitda-wrapper .line .balance[data-v-0466fc80], .ebitda-wrapper .line .budget[data-v-0466fc80], .ebitda-wrapper .line .diff[data-v-0466fc80] {\n      -ms-flex: 0 0 120px;\n          flex: 0 0 120px;\n      text-align: right;\n}\n", ""]);

// exports


/***/ }),
/* 542 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(false);
// imports


// module
exports.push([module.i, "\n.summary-card[data-v-06a459bd] {\n  margin-bottom: 15px;\n  text-align: center;\n}\n.summary-card .heading[data-v-06a459bd] {\n    font-weight: bold;\n}\n.summary-card .number[data-v-06a459bd] {\n    font-size: 2rem;\n    font-weight: bold;\n    color: #b29b81;\n}\n", ""]);

// exports


/***/ }),
/* 543 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(false);
// imports


// module
exports.push([module.i, "\n.sidebar[data-v-1313447a] {\n  padding: 30px;\n  height: 100vh;\n  overflow-y: auto;\n  background: #172b43;\n  color: #ffffff;\n  position: relative;\n  z-index: 100;\n}\n.sidebar .logo[data-v-1313447a] {\n    margin: -30px;\n    padding: 0 30px;\n    margin-bottom: 45px;\n    height: 80px;\n    display: -ms-flexbox;\n    display: flex;\n    -ms-flex-align: center;\n        align-items: center;\n    text-align: center;\n    background: #ffffff;\n}\n.sidebar .logo img[data-v-1313447a] {\n      width: 80%;\n      margin: 0 auto;\n}\n.sidebar .menu-items .menu-item[data-v-1313447a] {\n    display: -ms-flexbox;\n    display: flex;\n    -ms-flex-align: center;\n        align-items: center;\n    color: #ffffff;\n    text-decoration: none;\n    font-weight: 300;\n    padding: 7.5px;\n    border-radius: 3px;\n    font-family: \"Montserrat\", sans-serif;\n    font-size: 16px;\n    cursor: pointer;\n    transition: 0.3s ease all;\n}\n.sidebar .menu-items .menu-item.disabled[data-v-1313447a] {\n      opacity: .5;\n      cursor: not-allowed;\n}\n.sidebar .menu-items .menu-item[data-v-1313447a]:hover {\n      background: rgba(255, 255, 255, 0.15);\n      padding-left: 15px;\n}\n.sidebar .menu-items .menu-item[data-v-1313447a]:not(:last-of-type) {\n      margin-bottom: 7.5px;\n}\n.sidebar .menu-items .menu-item.router-link-exact-active[data-v-1313447a] {\n      background: #ffffff;\n      color: #172b43;\n      font-weight: 500;\n      padding-left: 15px;\n}\n.sidebar .menu-items .menu-item .icon[data-v-1313447a] {\n      margin-right: 15px;\n      font-size: 20px;\n}\n.sidebar .bottom[data-v-1313447a] {\n    position: absolute;\n    bottom: 15px;\n    left: 15px;\n    width: calc(100% - 30px);\n}\n.sidebar .bottom .super-admin-options[data-v-1313447a] {\n      padding-top: 15px;\n}\n.sidebar .bottom .super-admin-options .change-company[data-v-1313447a] {\n        background: #ffffff;\n        box-sizing: border-box;\n        border-radius: 3px;\n        padding: 4px 10px;\n        color: #172b43;\n        text-align: center;\n        font-size: 14px;\n        cursor: pointer;\n}\n.sidebar .bottom .super-admin-options .change-company[data-v-1313447a]:hover {\n          background: rgba(255, 255, 255, 0.9);\n}\n.sidebar .bottom .last-sync[data-v-1313447a] {\n      font-size: 12px;\n      text-align: center;\n      padding-bottom: 7.5px;\n}\n.sidebar .user[data-v-1313447a] {\n    display: -ms-flexbox;\n    display: flex;\n    -ms-flex-align: center;\n        align-items: center;\n    font-family: \"Montserrat\", sans-serif;\n    cursor: pointer;\n    padding: 7.5px;\n    border-radius: 3px;\n    line-height: 1.4;\n}\n.sidebar .user[data-v-1313447a]:hover {\n      background: rgba(255, 255, 255, 0.15);\n}\n.sidebar .user .avatar[data-v-1313447a] {\n      margin-right: 15px;\n      border-radius: 1000px;\n      background: #ffffff;\n      height: 40px;\n      width: 40px;\n      line-height: 40px;\n      text-align: center;\n      font-weight: 700;\n      letter-spacing: 1px;\n      color: #172b43;\n}\n.sidebar .user .text[data-v-1313447a] {\n      width: calc(100% - 60px);\n}\n.sidebar .user .text .name[data-v-1313447a] {\n        font-weight: 500;\n        white-space: nowrap;\n        text-overflow: ellipsis;\n        overflow: hidden;\n}\n.sidebar .user .text .company[data-v-1313447a] {\n        font-size: 12px;\n}\n", ""]);

// exports


/***/ }),
/* 544 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(false);
// imports


// module
exports.push([module.i, "\n.placeholder[data-v-1837e2a0] {\n  height: -webkit-fit-content;\n  height: fit-content;\n}\n.box[data-v-1837e2a0] {\n  font-family: \"Montserrat\", sans-serif;\n}\n.box .progress[data-v-1837e2a0] {\n    height: 30px;\n    width: 100%;\n    background: rgba(0, 0, 0, 0.15);\n    position: relative;\n    margin: 7.5px 0;\n    border-radius: 3px;\n    overflow: hidden;\n    font-weight: 600;\n    font-size: 14px;\n    font-family: \"Open Sans\", sans-serif;\n}\n.box .progress .timeloggings[data-v-1837e2a0] {\n      background: #172b43;\n      display: block;\n      content: \"\";\n      position: absolute;\n      top: 0;\n      left: 0;\n      height: 100%;\n}\n.box .progress .overlay[data-v-1837e2a0] {\n      position: absolute;\n      top: 0;\n      right: 0;\n      bottom: 0;\n      left: 0;\n      display: -ms-flexbox;\n      display: flex;\n      -ms-flex-pack: justify;\n          justify-content: space-between;\n      -ms-flex-align: center;\n          align-items: center;\n      padding: 0 7.5px;\n}\n.box .progress .overlay .timeloggings-percent[data-v-1837e2a0] {\n        color: #ffffff;\n}\n.box .progress .overlay .materials-percent[data-v-1837e2a0] {\n        color: #172b43;\n}\n.box .explainer[data-v-1837e2a0] {\n    display: -ms-flexbox;\n    display: flex;\n    -ms-flex-pack: justify;\n        justify-content: space-between;\n}\n.box .explainer.bold[data-v-1837e2a0] {\n      font-weight: 600;\n}\n.box .explainer .small[data-v-1837e2a0] {\n      margin-top: 7.5px;\n}\n", ""]);

// exports


/***/ }),
/* 545 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(false);
// imports


// module
exports.push([module.i, "\n.lds-ellipsis {\n  display: inline-block;\n  position: relative;\n  width: 64px;\n  height: 64px;\n}\n.lds-ellipsis div {\n  position: absolute;\n  top: 27px;\n  width: 11px;\n  height: 11px;\n  border-radius: 50%;\n  background: #fff;\n  animation-timing-function: cubic-bezier(0, 1, 1, 0);\n}\n.lds-ellipsis div:nth-child(1) {\n  left: 6px;\n  animation: lds-ellipsis1 0.6s infinite;\n}\n.lds-ellipsis div:nth-child(2) {\n  left: 6px;\n  animation: lds-ellipsis2 0.6s infinite;\n}\n.lds-ellipsis div:nth-child(3) {\n  left: 26px;\n  animation: lds-ellipsis2 0.6s infinite;\n}\n.lds-ellipsis div:nth-child(4) {\n  left: 45px;\n  animation: lds-ellipsis3 0.6s infinite;\n}\n@keyframes lds-ellipsis1 {\n0% {\n    transform: scale(0);\n}\n100% {\n    transform: scale(1);\n}\n}\n@keyframes lds-ellipsis3 {\n0% {\n    transform: scale(1);\n}\n100% {\n    transform: scale(0);\n}\n}\n@keyframes lds-ellipsis2 {\n0% {\n    transform: translate(0, 0);\n}\n100% {\n    transform: translate(19px, 0);\n}\n}\n", ""]);

// exports


/***/ }),
/* 546 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(false);
// imports


// module
exports.push([module.i, "\n@keyframes fadeOut {\n0% {\n    opacity: 1;\n}\n50% {\n    opacity: 1;\n}\n100% {\n    opacity: 0;\n}\n}\n.loader[data-v-1bc34b89] {\n  position: fixed;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  background: #172b43;\n  z-index: 9999;\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-pack: center;\n      justify-content: center;\n  -ms-flex-align: center;\n      align-items: center;\n  color: #ffffff;\n  font-size: 30px;\n  font-family: \"Montserrat\", sans-serif;\n  animation: 2s fadeOut ease-in-out forwards;\n}\n.loader .inner[data-v-1bc34b89] {\n    text-align: center;\n}\n", ""]);

// exports


/***/ }),
/* 547 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(false);
// imports


// module
exports.push([module.i, "\n@charset \"UTF-8\";\n.break {\n  margin: 30px 0;\n  height: 1px;\n  background: rgba(23, 43, 67, 0.15);\n}\nspan.small {\n  font-size: 16px;\n}\n.lines .line {\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-pack: justify;\n      justify-content: space-between;\n  margin-bottom: 15px;\n}\n.lines .line .left, .lines .line .right {\n    white-space: nowrap;\n}\n.lines .line.small {\n    font-size: 14px;\n}\n.lines .line__total {\n    margin-top: 15px;\n    margin-bottom: 0;\n    font-weight: 700;\n}\n.lines .break {\n  height: 1px;\n  background: #172b43;\n}\n.vgt-table thead tr th {\n  white-space: nowrap;\n}\nth.vgt-left-align,\nth.vgt-right-align {\n  text-align: left !important;\n}\nspan.soon {\n  font-size: 24px;\n}\n.vgt-global-search input:-ms-input-placeholder {\n  opacity: 0.75;\n}\n.vgt-global-search input::placeholder {\n  opacity: 0.75;\n}\n.vgt-global-search__input .input__icon .magnifying-glass {\n  border-color: #172b43 !important;\n}\n.vgt-global-search__input .input__icon .magnifying-glass:before {\n  background: #172b43 !important;\n}\n.vgt-input:focus, .vgt-select:focus {\n  border-color: #172b43 !important;\n  color: #172b43;\n}\n.table-column__description {\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  overflow: hidden;\n  max-width: 200px;\n}\n.table-column__description--long {\n    text-overflow: ellipsis;\n    white-space: nowrap;\n    overflow: hidden;\n    max-width: 500px;\n}\n.table-column__external-id {\n  text-align: left;\n}\n.table-column__customer {\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  overflow: hidden;\n  max-width: 200px;\n}\n.table-column__type {\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  overflow: hidden;\n  max-width: 200px;\n}\ntable.vgt-table td {\n  color: #172b43 !important;\n}\n.layout {\n  font-family: \"Open Sans\", sans-serif;\n  color: #172b43;\n  font-size: 16px;\n}\n.layout .wrapper {\n    display: -ms-flexbox;\n    display: flex;\n    min-height: 100vh;\n}\n.layout .row:not(.nomargin) > div {\n    margin-bottom: 30px;\n}\n.layout .row:not(.nomargin) {\n    margin-bottom: -30px;\n}\n.layout .sidebar {\n    -ms-flex: 0 0 250px;\n        flex: 0 0 250px;\n}\n.layout .color__main {\n    color: #b29b81;\n}\n.layout .color__good {\n    color: #4CAF50;\n}\n.layout .color__avg {\n    color: #FFA000;\n}\n.layout .color__bad {\n    color: #FF5252;\n}\n.layout .page {\n    padding-top: 80px;\n    -ms-flex: 1;\n        flex: 1;\n    overflow-y: auto;\n    height: 100vh;\n    background: #f2f2f5;\n    position: relative;\n    width: calc(100vw - 250px);\n}\n.layout h1, .layout h2, .layout h3, .layout h4, .layout h5, .layout h6, .layout .title, .layout .headline {\n    font-family: \"Montserrat\", sans-serif;\n    font-weight: 700;\n}\n.layout .section {\n    padding: 45px;\n}\n.layout .placeholder {\n    background: #ffffff;\n    box-shadow: 0 5px 15px rgba(40, 60, 134, 0.15);\n    border-radius: 3px;\n    overflow: hidden;\n    height: 100%;\n}\n.layout .placeholder.fit-content {\n      height: -webkit-fit-content;\n      height: fit-content;\n}\n.layout .placeholder .placeholder {\n      overflow: unset;\n}\n.layout .placeholder.padding {\n      padding: 30px;\n}\n.layout .placeholder.align-self-center {\n      display: -ms-flexbox;\n      display: flex;\n      -ms-flex-align: center;\n          align-items: center;\n      -ms-flex-pack: center;\n          justify-content: center;\n      text-align: center;\n}\n.layout .placeholder__heading {\n      font-size: 14px;\n      padding: 15px;\n      font-weight: 700;\n      color: #ffffff;\n      background: #172b43;\n      text-align: center;\n}\n.layout .placeholder__total {\n      text-align: center;\n      padding: 15px;\n      font-weight: 700;\n}\n.layout .placeholder__total input {\n        border: 1px solid rgba(0, 0, 0, 0.15);\n        border-radius: 3px;\n        width: 40px;\n        font-size: 16px;\n        text-align: center;\n}\n.layout .placeholder__total button {\n        background: #f2f2f5;\n        padding: 0 7.5px;\n        border-radius: 3px;\n}\n.layout .placeholder__total button:first-of-type {\n          background: #172b43;\n          color: #fff;\n}\n.layout .placeholder__number-title {\n      font-weight: 500;\n      margin-bottom: 7.5px;\n}\n.layout .placeholder__number-value {\n      font-size: 30px;\n      font-weight: 700;\n      font-family: \"Montserrat\", sans-serif;\n}\n.layout .helper {\n    position: absolute;\n    top: calc(80px + 45px);\n    right: 45px;\n    background: #172b43;\n    padding: 15px;\n    color: #ffffff;\n    width: 50px;\n    height: 50px;\n    display: -ms-flexbox;\n    display: flex;\n    -ms-flex-pack: center;\n        justify-content: center;\n    -ms-flex-align: center;\n        align-items: center;\n    box-shadow: 0px 5px 15px rgba(0, 0, 0, 0.15);\n    border-radius: 3px;\n    opacity: .5;\n    cursor: pointer;\n    transition: 0.3s ease all;\n}\n.layout .helper:hover {\n      opacity: 1;\n}\n.box-date-range {\n  display: -ms-flexbox;\n  display: flex;\n  position: absolute;\n  bottom: 0;\n  left: 0;\n  padding: 15px;\n  font-size: 12px;\n  animation: fadeIn 0.3s ease-in-out forwards;\n}\n.box-date-range .text {\n    font-weight: 700;\n}\n.box-date-range > div:not(:first-of-type) {\n    margin-left: 5px;\n}\n.box-date-range .vdp-datepicker__calendar {\n    top: -285px;\n}\n.vdp-datepicker input {\n  outline: none !important;\n}\n.vdp-datepicker__calendar .cell.selected {\n  background: #172b43 !important;\n  color: #fff !important;\n}\n.vdp-datepicker__calendar .cell:not(.blank):not(.disabled).day:hover, .vdp-datepicker__calendar .cell:not(.blank):not(.disabled).month:hover, .vdp-datepicker__calendar .cell:not(.blank):not(.disabled).year:hover {\n  border: 1px solid #172b43 !important;\n}\n.v-data-footer {\n  height: 50px;\n}\n.v-data-footer__select {\n  display: none !important;\n}\n.v-data-table th {\n  text-align: left;\n}\n.v-data-table__wrapper table tbody tr td.text-start:first-of-type {\n  font-weight: bold;\n}\n.v-data-table__wrapper table tbody tr td {\n  overflow: hidden;\n}\n@media (min-width: 1264px) {\n.container {\n    max-width: 1600px !important;\n}\n}\n.divider {\n  height: 1px;\n  background: rgba(0, 0, 0, 0.15);\n  margin: 30px 0;\n}\n.color-good {\n  color: #4CAF50;\n}\n.color-avg {\n  color: #FFA000;\n}\n.color-bad {\n  color: #FF5252;\n}\n.day__month_btn.up,\n.month__year_btn.up {\n  position: relative;\n  line-height: 24px;\n  height: 40px;\n  font-weight: bold;\n}\n.day__month_btn.up::before,\n.month__year_btn.up::before {\n  content: \"Tryk for at v\\E6lge m\\E5ned\";\n  position: absolute;\n  bottom: 0;\n  left: 50%;\n  transform: translate(-50%, 0);\n  z-index: 99999999999999;\n  color: #172b43;\n  font-size: 12px;\n  white-space: nowrap;\n  font-weight: normal;\n  opacity: 0.75;\n}\n.month__year_btn.up::before {\n  content: \"Tryk for at v\\E6lge \\E5rstal\";\n}\n\n/* Chrome, Safari, Edge, Opera */\ninput::-webkit-outer-spin-button,\ninput::-webkit-inner-spin-button {\n  -webkit-appearance: none;\n  margin: 0;\n}\n\n/* Firefox */\ninput[type=number] {\n  -moz-appearance: textfield;\n}\n.pretty-button {\n  background: #388E3C;\n  display: inline-block;\n  padding: 15px;\n  border-radius: 3px;\n  box-shadow: 0 5px 15px rgba(40, 60, 134, 0.15);\n  color: #ffffff;\n  cursor: pointer;\n  transition: 0.3s ease all;\n}\n.pretty-button.fw {\n    width: 100%;\n    text-align: center;\n}\n.pretty-button:hover {\n    background: #317c34;\n}\n.pretty-button.inverse {\n    background: transparent;\n    margin: 0 15px;\n    color: #172b43;\n    box-shadow: none;\n}\n.pretty-button.inverse:hover {\n      background: #172b43;\n      color: #ffffff;\n}\n.warning {\n  background: #FF5252;\n  padding: 15px;\n  margin-bottom: 30px;\n  font-size: 14px;\n  line-height: 1.5;\n  border-radius: 3px;\n}\n.warning b {\n    display: block;\n}\n", ""]);

// exports


/***/ }),
/* 548 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(false);
// imports


// module
exports.push([module.i, "/* .apexcharts-legend-series {\n        margin-top: $margin--small !important;\n    } */\n.helper-content {\n  position: fixed;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  background: rgba(0, 0, 0, 0.5);\n  z-index: 99999;\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-pack: center;\n      justify-content: center;\n  -ms-flex-align: center;\n      align-items: center;\n}\n.helper-content .inner {\n    max-width: 80%;\n    max-height: 80%;\n    overflow-y: auto;\n    width: 800px;\n    background: #fff;\n    padding: 30px;\n    border-radius: 10px;\n    box-shadow: 0 5px 15px rgba(40, 60, 134, 0.15);\n}\n.helper-content .inner .title__big {\n      font-size: 24px;\n      font-weight: 700;\n      margin-bottom: 15px;\n}\n.helper-content .inner .title__medium {\n      font-size: 16px;\n      font-weight: 700;\n      margin-bottom: 15px;\n      border-bottom: 1px solid #172b43;\n      padding-bottom: 5px;\n}\n.helper-content .inner ol, .helper-content .inner ul {\n      padding-left: 40px;\n}\n.helper-content .inner table {\n      width: 100%;\n      text-align: center;\n      table-layout: fixed;\n}\n.helper-content .inner table td {\n        padding: 3.75px;\n}\n.swal2-container,\n.swal2-container * {\n  font-family: \"Montserrat\", sans-serif;\n}\n.swal2-container a,\n.swal2-icon.swal2-info {\n  color: #172b43 !important;\n  border-color: #172b43 !important;\n}\n.swal2-confirm {\n  background: #172b43 !important;\n}\n.table-title {\n  font-size: 14px;\n  padding: 15px;\n  font-weight: 700;\n  color: #ffffff;\n  background: #172b43;\n  text-align: center;\n  border-radius: 3px 3px 0 0;\n}\ntable.vgt-table {\n  font-size: 14px !important;\n}\ntable.vgt-table tr.selected {\n  background: #172b43;\n}\ntable.vgt-table tr.selected * {\n    color: #ffffff;\n}\ntable.vgt-table tr.clickable:hover {\n  background: rgba(0, 0, 0, 0.15) !important;\n}\ntable.vgt-table tr.clickable.selected:hover {\n  background: #172b43 !important;\n}\n.vgt-table thead th.sorting-desc:after {\n  border-top-color: #172b43 !important;\n}\n.vgt-table th.sorting:after {\n  border-bottom-color: #172b43 !important;\n}\n.vgt-wrap__footer {\n  border-radius: 0 0 3px 3px;\n}\n.vgt-wrap__footer .footer__navigation__page-btn .chevron.left::after {\n  border-right-color: #172b43 !important;\n}\n.vgt-wrap__footer .footer__navigation__page-btn .chevron.right::after {\n  border-left-color: #172b43 !important;\n}\ntable.vgt-table td {\n  vertical-align: middle !important;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n.coverage-cell {\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-align: center;\n      align-items: center;\n  -ms-flex-pack: end;\n      justify-content: flex-end;\n  -ms-flex-direction: row-reverse;\n      flex-direction: row-reverse;\n}\n.vgt-right-align {\n  text-align: left !important;\n}\n.coverage-indicator {\n  width: 10px;\n  height: 10px;\n  border-radius: 10px;\n  display: inline-block;\n  margin-right: 5px;\n  background: none;\n}\n.coverage-indicator.bad {\n    background: #FF5252;\n}\n.coverage-indicator.avg {\n    background: #FFA000;\n}\n.coverage-indicator.good {\n    background: #4CAF50;\n}\n.coverage-indicator.status {\n    background: #69798d;\n}\n.g-table__action i {\n  padding: 4px;\n  cursor: pointer;\n}\n.g-table__action:hover i {\n  --fa-secondary-color: $color--dark;\n  --fa-secondary-opacity: 1;\n}\n.tooltip {\n  display: block !important;\n  z-index: 10000;\n  max-width: 400px;\n}\n.tooltip .tooltip-inner {\n  background: #ffffff;\n  color: #172b43;\n  border-radius: 16px;\n  padding: 30px;\n  font-family: \"Open Sans\", sans-serif;\n  font-weight: 400;\n  box-shadow: 0 5px 15px rgba(40, 60, 134, 0.15);\n  font-size: 14px;\n  line-height: 1.5;\n}\n.tooltip .tooltip-arrow {\n  width: 0;\n  height: 0;\n  border-style: solid;\n  position: absolute;\n  margin: 5px;\n  border-color: #ffffff;\n}\n.tooltip[x-placement^=\"top\"] {\n  margin-bottom: 5px;\n}\n.tooltip[x-placement^=\"top\"] .tooltip-arrow {\n  border-width: 5px 5px 0 5px;\n  border-left-color: transparent !important;\n  border-right-color: transparent !important;\n  border-bottom-color: transparent !important;\n  bottom: -5px;\n  left: calc(50% - 5px);\n  margin-top: 0;\n  margin-bottom: 0;\n}\n.tooltip[x-placement^=\"bottom\"] {\n  margin-top: 5px;\n}\n.tooltip[x-placement^=\"bottom\"] .tooltip-arrow {\n  border-width: 0 5px 5px 5px;\n  border-left-color: transparent !important;\n  border-right-color: transparent !important;\n  border-top-color: transparent !important;\n  top: -5px;\n  left: calc(50% - 5px);\n  margin-top: 0;\n  margin-bottom: 0;\n}\n.tooltip[x-placement^=\"right\"] {\n  margin-left: 5px;\n}\n.tooltip[x-placement^=\"right\"] .tooltip-arrow {\n  border-width: 5px 5px 5px 0;\n  border-left-color: transparent !important;\n  border-top-color: transparent !important;\n  border-bottom-color: transparent !important;\n  left: -5px;\n  top: calc(50% - 5px);\n  margin-left: 0;\n  margin-right: 0;\n}\n.tooltip[x-placement^=\"left\"] {\n  margin-right: 5px;\n}\n.tooltip[x-placement^=\"left\"] .tooltip-arrow {\n  border-width: 5px 0 5px 5px;\n  border-top-color: transparent !important;\n  border-right-color: transparent !important;\n  border-bottom-color: transparent !important;\n  right: -5px;\n  top: calc(50% - 5px);\n  margin-left: 0;\n  margin-right: 0;\n}\n.tooltip[aria-hidden='true'] {\n  visibility: hidden;\n  opacity: 0;\n  transition: opacity .15s, visibility .15s;\n}\n.tooltip[aria-hidden='false'] {\n  visibility: visible;\n  opacity: 1;\n  transition: opacity .15s;\n}\n.g-table-wrapper {\n  background: #ffffff;\n  border-radius: 0 0 3px 3px;\n  box-shadow: 0 5px 15px rgba(40, 60, 134, 0.15);\n}\ntable.vgt-table td {\n  overflow: unset !important;\n}\n.dropdown-toggle {\n  background: #172b43 !important;\n  color: #ffffff !important;\n  font-weight: 700 !important;\n  border-radius: 3px !important;\n  overflow: hidden !important;\n  font-size: 12px !important;\n}\n.dropdown-toggle .caret {\n    top: 17px !important;\n}\n.employee-switcher {\n  display: -ms-inline-flexbox;\n  display: inline-flex;\n  border-radius: 3px;\n  overflow: hidden;\n  box-shadow: 0px 5px 15px rgba(0, 0, 0, 0.15);\n  font-size: 14px;\n  margin-bottom: 10px;\n}\n.employee-switcher-option {\n    padding: 10px 15px;\n    background: #fff;\n    cursor: pointer;\n    transition: 0.3s ease all;\n}\n.employee-switcher-option:hover {\n      box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);\n}\n.employee-switcher-option.selected {\n      background: #172b43;\n      color: #fff;\n}\n.employee-switcher-option:not(:last-of-type) {\n      border-right: 1px solid rgba(0, 0, 0, 0.1);\n}\n", ""]);

// exports


/***/ }),
/* 549 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(false);
// imports


// module
exports.push([module.i, "\ninput[type=range] {\n  -webkit-appearance: none;\n  margin: 18px 0;\n  width: 100%;\n}\ninput[type=range]:focus {\n  outline: none;\n}\ninput[type=range]::-webkit-slider-runnable-track {\n  width: 100%;\n  height: 8.4px;\n  cursor: pointer;\n  animate: 0.2s;\n  box-shadow: 0 5px 15px rgba(40, 60, 134, 0.15);\n  border-radius: 1000px;\n  border: 0.2px solid #010101;\n  background: #172b43;\n}\ninput[type=range]::-webkit-slider-thumb {\n  box-shadow: 0 5px 15px rgba(40, 60, 134, 0.15);\n  border: 1px solid rgba(0, 0, 0, 0.3);\n  height: 20px;\n  width: 20px;\n  border-radius: 3px;\n  background: #ffffff;\n  cursor: pointer;\n  -webkit-appearance: none;\n  margin-top: -6px;\n  border-radius: 1000px;\n}\ninput[type=range]:focus::-webkit-slider-runnable-track {\n  background: #172b43;\n}\ninput[type=range]::-moz-range-track {\n  width: 100%;\n  height: 8.4px;\n  cursor: pointer;\n  animate: 0.2s;\n  box-shadow: 1px 1px 1px #000000, 0px 0px 1px #0d0d0d;\n  background: #172b43;\n  border-radius: 1.3px;\n  border: 0.2px solid #010101;\n}\ninput[type=range]::-moz-range-thumb {\n  box-shadow: 1px 1px 1px #000000, 0px 0px 1px #0d0d0d;\n  border: 1px solid #000000;\n  height: 36px;\n  width: 16px;\n  border-radius: 3px;\n  background: #ffffff;\n  cursor: pointer;\n}\ninput[type=range]::-ms-track {\n  width: 100%;\n  height: 8.4px;\n  cursor: pointer;\n  animate: 0.2s;\n  background: transparent;\n  border-color: transparent;\n  border-width: 16px 0;\n  color: transparent;\n}\ninput[type=range]::-ms-fill-lower {\n  background: #172b43;\n  border: 0.2px solid #010101;\n  border-radius: 2.6px;\n  box-shadow: 1px 1px 1px #000000, 0px 0px 1px #0d0d0d;\n}\ninput[type=range]::-ms-fill-upper {\n  background: #172b43;\n  border: 0.2px solid #010101;\n  border-radius: 2.6px;\n  box-shadow: 1px 1px 1px #000000, 0px 0px 1px #0d0d0d;\n}\ninput[type=range]::-ms-thumb {\n  box-shadow: 1px 1px 1px #000000, 0px 0px 1px #0d0d0d;\n  border: 1px solid #000000;\n  height: 36px;\n  width: 16px;\n  border-radius: 3px;\n  background: #ffffff;\n  cursor: pointer;\n}\ninput[type=range]:focus::-ms-fill-lower {\n  background: #172b43;\n}\ninput[type=range]:focus::-ms-fill-upper {\n  background: #172b43;\n}\n", ""]);

// exports


/***/ }),
/* 550 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(false);
// imports


// module
exports.push([module.i, "\n.intro[data-v-1fe26433] {\n  font-size: 19.2px;\n  margin-bottom: 30px;\n  text-align: center;\n}\n.box[data-v-1fe26433] {\n  text-align: center;\n  font-family: \"Montserrat\", sans-serif;\n  line-height: 1.5;\n}\n.box .heading[data-v-1fe26433] {\n    font-weight: 600;\n}\n.box .heading .small[data-v-1fe26433] {\n      font-weight: normal;\n      margin-top: 0;\n}\n.box .slider[data-v-1fe26433] {\n    margin: 15px 0;\n}\n.box .slider input[data-v-1fe26433] {\n      max-width: 75%;\n}\n.box .result[data-v-1fe26433] {\n    font-size: 24px;\n    font-weight: bold;\n    color: #388E3C;\n}\n.box .small[data-v-1fe26433] {\n    font-size: 12px;\n    margin-top: 15px;\n}\n.overview[data-v-1fe26433] {\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-align: center;\n      align-items: center;\n  -ms-flex-pack: distribute;\n      justify-content: space-around;\n}\n.overview .today[data-v-1fe26433], .overview .potential[data-v-1fe26433] {\n    font-size: 16px;\n    text-align: center;\n}\n.overview .today .value[data-v-1fe26433], .overview .potential .value[data-v-1fe26433] {\n      font-size: 30px;\n      font-weight: 700;\n}\n.overview .arrow[data-v-1fe26433] {\n    font-size: 30px;\n}\n.overview .potential .value[data-v-1fe26433] {\n    color: #388E3C;\n}\n.percentage[data-v-1fe26433] {\n  margin-top: 30px;\n  text-align: center;\n}\n", ""]);

// exports


/***/ }),
/* 551 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(false);
// imports


// module
exports.push([module.i, "\n@keyframes spin {\nto {\n    transform: rotate(360deg);\n}\n}\n.coming-soon[data-v-20fa3fe5] {\n  background: #ffffff;\n  min-height: 300px;\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-pack: center;\n      justify-content: center;\n  -ms-flex-align: center;\n      align-items: center;\n  font-family: \"Montserrat\", sans-serif;\n  font-size: 24px;\n  text-align: center;\n  box-shadow: 0 5px 15px rgba(40, 60, 134, 0.15);\n  border-radius: 3px;\n}\n.coming-soon i.fal[data-v-20fa3fe5] {\n    font-size: 48px;\n    display: block;\n    animation: spin 5s infinite linear;\n}\n", ""]);

// exports


/***/ }),
/* 552 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(false);
// imports


// module
exports.push([module.i, "\n.tooltip-target[data-v-22a330da] {\n  opacity: .5;\n}\n.tooltip-target[data-v-22a330da]:hover {\n    opacity: 1;\n}\n.line[data-v-22a330da] {\n  min-width: 250px;\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-pack: justify;\n      justify-content: space-between;\n  white-space: nowrap;\n  margin-bottom: 7.5px;\n  font-weight: 600;\n}\n.line .good[data-v-22a330da] {\n    color: #4CAF50;\n}\n.line .bad[data-v-22a330da] {\n    color: #FF5252;\n}\n.line.total[data-v-22a330da] {\n    color: inherit;\n    margin-bottom: 0;\n    font-weight: 700;\n}\n", ""]);

// exports


/***/ }),
/* 553 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(false);
// imports


// module
exports.push([module.i, "\ninput[type=range] {\n  -webkit-appearance: none;\n  margin: 18px 0;\n  width: 100%;\n}\ninput[type=range]:focus {\n  outline: none;\n}\ninput[type=range]::-webkit-slider-runnable-track {\n  width: 100%;\n  height: 8.4px;\n  cursor: pointer;\n  animate: 0.2s;\n  box-shadow: 0 5px 15px rgba(40, 60, 134, 0.15);\n  border-radius: 1000px;\n  border: 0.2px solid #010101;\n  background: #172b43;\n}\ninput[type=range]::-webkit-slider-thumb {\n  box-shadow: 0 5px 15px rgba(40, 60, 134, 0.15);\n  border: 1px solid rgba(0, 0, 0, 0.3);\n  height: 20px;\n  width: 20px;\n  border-radius: 3px;\n  background: #ffffff;\n  cursor: pointer;\n  -webkit-appearance: none;\n  margin-top: -6px;\n  border-radius: 1000px;\n}\ninput[type=range]:focus::-webkit-slider-runnable-track {\n  background: #172b43;\n}\ninput[type=range]::-moz-range-track {\n  width: 100%;\n  height: 8.4px;\n  cursor: pointer;\n  animate: 0.2s;\n  box-shadow: 1px 1px 1px #000000, 0px 0px 1px #0d0d0d;\n  background: #172b43;\n  border-radius: 1.3px;\n  border: 0.2px solid #010101;\n}\ninput[type=range]::-moz-range-thumb {\n  box-shadow: 1px 1px 1px #000000, 0px 0px 1px #0d0d0d;\n  border: 1px solid #000000;\n  height: 36px;\n  width: 16px;\n  border-radius: 3px;\n  background: #ffffff;\n  cursor: pointer;\n}\ninput[type=range]::-ms-track {\n  width: 100%;\n  height: 8.4px;\n  cursor: pointer;\n  animate: 0.2s;\n  background: transparent;\n  border-color: transparent;\n  border-width: 16px 0;\n  color: transparent;\n}\ninput[type=range]::-ms-fill-lower {\n  background: #172b43;\n  border: 0.2px solid #010101;\n  border-radius: 2.6px;\n  box-shadow: 1px 1px 1px #000000, 0px 0px 1px #0d0d0d;\n}\ninput[type=range]::-ms-fill-upper {\n  background: #172b43;\n  border: 0.2px solid #010101;\n  border-radius: 2.6px;\n  box-shadow: 1px 1px 1px #000000, 0px 0px 1px #0d0d0d;\n}\ninput[type=range]::-ms-thumb {\n  box-shadow: 1px 1px 1px #000000, 0px 0px 1px #0d0d0d;\n  border: 1px solid #000000;\n  height: 36px;\n  width: 16px;\n  border-radius: 3px;\n  background: #ffffff;\n  cursor: pointer;\n}\ninput[type=range]:focus::-ms-fill-lower {\n  background: #172b43;\n}\ninput[type=range]:focus::-ms-fill-upper {\n  background: #172b43;\n}\n", ""]);

// exports


/***/ }),
/* 554 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(false);
// imports


// module
exports.push([module.i, "\n.box[data-v-238bdf1c] {\n  margin-bottom: 5px !important;\n  padding-bottom: 5px !important;\n  border-bottom: 1px solid rgba(0, 0, 0, 0.1) !important;\n}\n.box.last[data-v-238bdf1c] {\n  margin-bottom: 30px !important;\n}\n.intro[data-v-238bdf1c] {\n  font-size: 19.2px;\n  margin-bottom: 30px;\n  text-align: center;\n}\n.box[data-v-238bdf1c] {\n  text-align: center;\n  font-family: \"Montserrat\", sans-serif;\n  line-height: 1.5;\n}\n.box .heading[data-v-238bdf1c] {\n    font-weight: 600;\n}\n.box .heading .small[data-v-238bdf1c] {\n      font-weight: normal;\n      margin-top: 0;\n}\n.box .slider[data-v-238bdf1c] {\n    margin: 15px 0;\n}\n.box .slider input[data-v-238bdf1c] {\n      max-width: 75%;\n}\n.box .result[data-v-238bdf1c] {\n    font-size: 24px;\n    font-weight: bold;\n    color: #388E3C;\n}\n.box .small[data-v-238bdf1c] {\n    font-size: 14px;\n    margin-top: 15px;\n}\n.overview[data-v-238bdf1c] {\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-align: center;\n      align-items: center;\n  -ms-flex-pack: distribute;\n      justify-content: space-around;\n}\n.overview .today[data-v-238bdf1c], .overview .potential[data-v-238bdf1c] {\n    font-size: 16px;\n    text-align: center;\n}\n.overview .today .value[data-v-238bdf1c], .overview .potential .value[data-v-238bdf1c] {\n      font-size: 30px;\n      font-weight: 700;\n}\n.overview .arrow[data-v-238bdf1c] {\n    font-size: 30px;\n}\n.overview .potential .value[data-v-238bdf1c] {\n    color: #388E3C;\n}\n.percentage[data-v-238bdf1c] {\n  margin-top: 30px;\n  text-align: center;\n}\n", ""]);

// exports


/***/ }),
/* 555 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(false);
// imports


// module
exports.push([module.i, "\n.no-data a[data-v-23bfba74] {\n  color: #172b43;\n}\n", ""]);

// exports


/***/ }),
/* 556 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(false);
// imports


// module
exports.push([module.i, "\n.user .small-title[data-v-242b0c66] {\n  font-size: 20px;\n  margin-bottom: 15px;\n}\n.user .create-user[data-v-242b0c66] {\n  background: #ffffff;\n  padding: 30px;\n  border-radius: 3px;\n  box-shadow: 0 5px 15px rgba(40, 60, 134, 0.15);\n}\n.user .create-user .small[data-v-242b0c66] {\n    font-size: 12px;\n    margin-top: 4px;\n}\n.user .create-user label[data-v-242b0c66] {\n    font-weight: 600;\n    margin-bottom: 5px;\n    display: block;\n}\n.user .create-user input[data-v-242b0c66], .user .create-user select[data-v-242b0c66] {\n    height: 40px;\n    padding: 4px 10px;\n    border: 1px solid rgba(0, 0, 0, 0.15);\n    box-sizing: border-box;\n    border-radius: 3px;\n    cursor: pointer;\n    width: 100%;\n}\n.user .list .user[data-v-242b0c66] {\n  padding: 30px;\n  background: #ffffff;\n  border-radius: 3px;\n  box-shadow: 0 5px 15px rgba(40, 60, 134, 0.15);\n  margin-bottom: -30px;\n}\n.user .list .user input[data-v-242b0c66], .user .list .user select[data-v-242b0c66] {\n    height: 40px;\n    padding: 4px 10px;\n    border: 1px solid rgba(0, 0, 0, 0.15);\n    box-sizing: border-box;\n    border-radius: 3px;\n    cursor: pointer;\n    width: 100%;\n    margin-bottom: 15px;\n}\n.user .list .user .name[data-v-242b0c66] {\n    -ms-flex: 0 0 30%;\n        flex: 0 0 30%;\n    font-weight: 600;\n}\n.user .list .user .name .role[data-v-242b0c66] {\n      font-weight: normal;\n      font-size: 14px;\n}\n.user .list .user .email[data-v-242b0c66] {\n    -ms-flex: 0 0 30%;\n        flex: 0 0 30%;\n}\n.user .list .user .password[data-v-242b0c66] {\n    -ms-flex: 0 0 25%;\n        flex: 0 0 25%;\n}\n.user .list .user .actions[data-v-242b0c66] {\n    -ms-flex: 0 0 15%;\n        flex: 0 0 15%;\n    display: -ms-flexbox;\n    display: flex;\n    -ms-flex-pack: justify;\n        justify-content: space-between;\n}\n.user .list .user .actions .action[data-v-242b0c66] {\n      cursor: pointer;\n}\n.user .list .user[data-v-242b0c66]:not(:last-of-type) {\n    margin-bottom: 15px;\n}\n", ""]);

// exports


/***/ }),
/* 557 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(false);
// imports


// module
exports.push([module.i, "\n.custom-time-period .btn-group {\n  height: unset !important;\n  margin: 0px !important;\n  padding: 0px !important;\n}\n.custom-time-period .dropdown-toggle {\n  padding: 0 !important;\n  background: none !important;\n  color: #172b43 !important;\n  font-size: 14px !important;\n  margin: 10px 0 0 0 !important;\n}\n.custom-time-period .dropdown-toggle .caret {\n    padding: 0px !important;\n    margin: 0px !important;\n    top: 17px !important;\n    right: 8px !important;\n    bottom: unset !important;\n    left: unset !important;\n}\n", ""]);

// exports


/***/ }),
/* 558 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(false);
// imports


// module
exports.push([module.i, "\n.configbar[data-v-2631a998] {\n  position: fixed;\n  top: 0;\n  background: #ffffff;\n  box-shadow: 0 5px 15px rgba(40, 60, 134, 0.15);\n  height: 80px;\n  z-index: 99;\n  padding: 0 45px;\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-align: center;\n      align-items: center;\n  -ms-flex-pack: justify;\n      justify-content: space-between;\n  left: 250px;\n  width: calc(100% - 250px);\n  font-size: 14px;\n}\n.configbar .options[data-v-2631a998] {\n    white-space: nowrap;\n    display: -ms-flexbox;\n    display: flex;\n    -ms-flex-align: center;\n        align-items: center;\n    -ms-flex-pack: start;\n        justify-content: flex-start;\n}\n.configbar .options.reversed[data-v-2631a998] {\n      -ms-flex-pack: end;\n          justify-content: flex-end;\n}\n.configbar .options .single-option[data-v-2631a998] {\n      padding: 2px 8px;\n      transition: 0.3s ease all;\n      cursor: pointer;\n      border-radius: 3px;\n}\n.configbar .options .single-option[data-v-2631a998]:hover {\n        background: rgba(0, 0, 0, 0.15);\n}\n.configbar .options .single-option.selected[data-v-2631a998] {\n        background: #172b43;\n        color: #ffffff;\n}\n.configbar .options .single-option[data-v-2631a998]:not(:last-of-type) {\n        margin-right: 15px;\n}\n.configbar > div[data-v-2631a998] {\n    -ms-flex: 0 0 20%;\n        flex: 0 0 20%;\n}\n.configbar .super-admin[data-v-2631a998],\n  .configbar .logged-in-as[data-v-2631a998] {\n    display: -ms-flexbox;\n    display: flex;\n    -ms-flex-pack: end;\n        justify-content: flex-end;\n}\n.configbar .super-admin > b[data-v-2631a998],\n    .configbar .logged-in-as > b[data-v-2631a998] {\n      margin-right: 15px;\n}\n.configbar .date-range .flex[data-v-2631a998] {\n    display: -ms-flexbox;\n    display: flex;\n    -ms-flex-pack: center;\n        justify-content: center;\n}\n.configbar .date-range .flex > div[data-v-2631a998]:not(:first-of-type) {\n      margin-left: 15px;\n}\n.configbar .custom-time-period[data-v-2631a998] {\n    text-align: center;\n    margin-top: 10px;\n}\n.configbar .custom-time-period select[data-v-2631a998] {\n      text-align: center;\n      text-align-last: center;\n      font-weight: 700;\n}\n.configbar .fiscalyear[data-v-2631a998] {\n    display: -ms-flexbox;\n    display: flex;\n    -ms-flex-align: center;\n        align-items: center;\n}\n.configbar .select[data-v-2631a998] {\n    display: -ms-flexbox;\n    display: flex;\n}\n.configbar .select .option[data-v-2631a998] {\n      border-radius: 3px;\n      padding: 3.75px 15px;\n      transition: 0.3s ease all;\n}\n.configbar .select .option[data-v-2631a998]:not(.selected) {\n        cursor: pointer;\n}\n.configbar .select .option[data-v-2631a998]:hover {\n        background: #f2f2f5;\n}\n.configbar .select .option[data-v-2631a998]:not(:last-of-type) {\n        margin-right: 7.5px;\n}\n.configbar .select .option.selected[data-v-2631a998] {\n        background: #172b43;\n        color: #ffffff;\n        font-weight: 500;\n        cursor: default;\n}\n", ""]);

// exports


/***/ }),
/* 559 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(false);
// imports


// module
exports.push([module.i, "\n.headline[data-v-2f6d19d5] {\n  font-size: 16px;\n  font-weight: 600;\n  margin-bottom: 15px;\n  text-align: center;\n  font-family: \"Open Sans\", sans-serif;\n}\n", ""]);

// exports


/***/ }),
/* 560 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(false);
// imports


// module
exports.push([module.i, "\n.error-page-wrapper[data-v-301a1469]{\n    width: 100%;\n    height: calc(100vh - 98px);\n    position: relative;\n}\n.error-page-inner[data-v-301a1469]{\n    position: absolute;\n    top: 50%;\n    left: 50%;\n    transform: translate(-50%, -50%);\n    background: rgba(255,255,255,0.95);\n    border-radius: 4px;\n    padding: 20px 30px 30px 30px;\n    width: 100%;\n    max-width: 400px;\n    box-shadow: 0 0 0 1px rgba(0, 0, 0, 0.02), 0 4px 10px 0 rgba(0, 0, 0, 0.08);\n}\n.error-page-inner h1[data-v-301a1469]{\n    margin-top: 0;\n    margin-bottom: 0;\n    font-weight: bold;\n}\n.error-page-inner h3[data-v-301a1469]{\n    margin-top: 0;\n    margin-bottom: 10px;\n}\n", ""]);

// exports


/***/ }),
/* 561 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(false);
// imports


// module
exports.push([module.i, "\n.v-data-table__wrapper table {\n  min-height: 300px;\n}\n.v-data-table__wrapper table tbody tr, .v-data-table__wrapper table tbody td {\n    height: 50px !important;\n    max-height: 50px !important;\n}\n.v-data-table__wrapper table tbody tr td, .v-data-table__wrapper table tbody td td {\n      overflow: hidden;\n}\n", ""]);

// exports


/***/ }),
/* 562 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(false);
// imports


// module
exports.push([module.i, "\n.v-data-table[data-v-30dee4b6] {\n  min-height: 350px;\n  animation: fadeIn 0.3s ease-in-out forwards;\n}\n.table-card[data-v-30dee4b6] {\n  height: 100%;\n  position: relative;\n}\n.table-card .table-title[data-v-30dee4b6] {\n    font-size: 14px;\n    padding: 15px;\n    font-weight: 700;\n    color: #ffffff;\n    background: #172b43;\n    text-align: center;\n}\n.v-data-table td[data-v-30dee4b6] {\n  font-size: 12px !important;\n  font-weight: 500 !important;\n  font-family: \"Open Sans\", sans-serif !important;\n  cursor: pointer;\n}\n.v-data-table td[data-v-30dee4b6]:first-of-type {\n    font-weight: 700 !important;\n}\n.v-data-table th span[data-v-30dee4b6] {\n  float: left;\n}\n.v-data-table th i[data-v-30dee4b6] {\n  display: none !important;\n}\n.v-data-table.finishedProjects tr td[data-v-30dee4b6]:last-of-type {\n  background: #FF5252;\n  color: #ffffff;\n  font-weight: 700 !important;\n}\n.v-data-table.finishedProjects tr:nth-of-type(1) td[data-v-30dee4b6]:last-of-type,\n.v-data-table.finishedProjects tr:nth-of-type(2) td[data-v-30dee4b6]:last-of-type {\n  background: #4CAF50;\n}\n.v-data-table.finishedProjects tr:nth-of-type(4) td[data-v-30dee4b6]:last-of-type {\n  background: #FFA000;\n}\n.v-data-table.customerTypeRevenue tr td[data-v-30dee4b6]:last-of-type, .v-data-table.customerRevenue tr td[data-v-30dee4b6]:last-of-type, .v-data-table.revenueEarningsShare tr td[data-v-30dee4b6]:last-of-type, .v-data-table.customerContribution tr td[data-v-30dee4b6]:last-of-type {\n  background: #FF5252;\n  color: #ffffff;\n  font-weight: 700 !important;\n}\n.v-data-table.customerTypeRevenue tr:nth-of-type(1) td[data-v-30dee4b6]:last-of-type,\n.v-data-table.customerTypeRevenue tr:nth-of-type(2) td[data-v-30dee4b6]:last-of-type, .v-data-table.customerRevenue tr:nth-of-type(1) td[data-v-30dee4b6]:last-of-type,\n.v-data-table.customerRevenue tr:nth-of-type(2) td[data-v-30dee4b6]:last-of-type, .v-data-table.revenueEarningsShare tr:nth-of-type(1) td[data-v-30dee4b6]:last-of-type,\n.v-data-table.revenueEarningsShare tr:nth-of-type(2) td[data-v-30dee4b6]:last-of-type, .v-data-table.customerContribution tr:nth-of-type(1) td[data-v-30dee4b6]:last-of-type,\n.v-data-table.customerContribution tr:nth-of-type(2) td[data-v-30dee4b6]:last-of-type {\n  background: #4CAF50;\n}\n.v-data-table.customerTypeRevenue tr:nth-of-type(3) td[data-v-30dee4b6]:last-of-type,\n.v-data-table.customerTypeRevenue tr:nth-of-type(4) td[data-v-30dee4b6]:last-of-type, .v-data-table.customerRevenue tr:nth-of-type(3) td[data-v-30dee4b6]:last-of-type,\n.v-data-table.customerRevenue tr:nth-of-type(4) td[data-v-30dee4b6]:last-of-type, .v-data-table.revenueEarningsShare tr:nth-of-type(3) td[data-v-30dee4b6]:last-of-type,\n.v-data-table.revenueEarningsShare tr:nth-of-type(4) td[data-v-30dee4b6]:last-of-type, .v-data-table.customerContribution tr:nth-of-type(3) td[data-v-30dee4b6]:last-of-type,\n.v-data-table.customerContribution tr:nth-of-type(4) td[data-v-30dee4b6]:last-of-type {\n  background: #FFA000;\n}\n", ""]);

// exports


/***/ }),
/* 563 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(false);
// imports


// module
exports.push([module.i, "\n.placeholder[data-v-3756a0f3] {\n  margin-bottom: 30px;\n}\n.title[data-v-3756a0f3] {\n  margin-bottom: 15px;\n}\n.row .inside[data-v-3756a0f3] {\n  padding: 15px;\n  background: rgba(0, 0, 0, 0.05);\n  border-radius: 3px;\n  font-size: 13.2px;\n  font-weight: 600;\n  height: 100%;\n}\n.row .inside .small[data-v-3756a0f3] {\n    margin-top: 15px;\n    font-size: 13.2px;\n    font-weight: normal;\n}\n.employees .employee[data-v-3756a0f3] {\n  background: #ffffff;\n  padding: 30px 30px;\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-pack: justify;\n      justify-content: space-between;\n  -ms-flex-align: center;\n      align-items: center;\n  border-radius: 3px;\n  margin-bottom: 15px;\n  box-shadow: 0px 5px 15px rgba(0, 0, 0, 0.05);\n}\n.employees .employee .name[data-v-3756a0f3] {\n    -ms-flex: 0 0 25%;\n        flex: 0 0 25%;\n    font-weight: 600;\n}\n.employees .employee .hours[data-v-3756a0f3] {\n    -ms-flex: 0 0 20%;\n        flex: 0 0 20%;\n    display: -ms-flexbox;\n    display: flex;\n    -ms-flex-align: center;\n        align-items: center;\n}\n.employees .employee .hours input[data-v-3756a0f3] {\n      margin-left: 15px;\n      border: 1px solid rgba(0, 0, 0, 0.15);\n      width: 50px;\n      border-radius: 3px;\n      padding-left: 10px;\n}\n.employees .employee .working[data-v-3756a0f3] {\n    -ms-flex: 0 0 20%;\n        flex: 0 0 20%;\n    display: -ms-flexbox;\n    display: flex;\n    -ms-flex-align: center;\n        align-items: center;\n}\n.employees .employee .working input[data-v-3756a0f3] {\n      margin-right: 15px;\n}\n.employees .employee .working-field-name[data-v-3756a0f3] {\n    -ms-flex: 0 0 20%;\n        flex: 0 0 20%;\n}\n.employees .employee .working-field-name select[data-v-3756a0f3] {\n      padding: 4px 10px;\n      border: 1px solid rgba(0, 0, 0, 0.15);\n      border-radius: 3px;\n      cursor: pointer;\n      box-sizing: border-box;\n}\n", ""]);

// exports


/***/ }),
/* 564 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(false);
// imports


// module
exports.push([module.i, "\n.inside[data-v-3d3aa354] {\n  padding: 15px;\n  background: rgba(0, 0, 0, 0.05);\n  border-radius: 3px;\n  font-size: 13.2px;\n  font-weight: 600;\n  height: 100%;\n}\n.inside input[type=radio][data-v-3d3aa354] {\n    border: 0px;\n    width: 100%;\n    height: 1.4em;\n}\n.inside .small[data-v-3d3aa354] {\n    margin-top: 15px;\n    font-size: 13.2px;\n    font-weight: normal;\n}\n.box[data-v-3d3aa354] {\n  background: #ffffff;\n  padding: 30px;\n  border-radius: 3px;\n  box-shadow: 0 5px 15px rgba(40, 60, 134, 0.15);\n}\n.box__title[data-v-3d3aa354] {\n    font-weight: 700;\n    font-family: \"Montserrat\", sans-serif;\n    margin-bottom: 30px;\n    text-align: center;\n}\n.box .options[data-v-3d3aa354] {\n    display: -ms-flexbox;\n    display: flex;\n    -ms-flex-pack: justify;\n        justify-content: space-between;\n}\n.box .options .option[data-v-3d3aa354] {\n      -ms-flex: 0 0 30%;\n          flex: 0 0 30%;\n      text-align: center;\n}\n.box .options .option.fw[data-v-3d3aa354] {\n        -ms-flex: 0 0 100%;\n            flex: 0 0 100%;\n}\n.box .options .option input[data-v-3d3aa354] {\n        border: 1px solid rgba(0, 0, 0, 0.15);\n        border-radius: 3px;\n        width: 50px;\n        height: 40px;\n        text-align: center;\n        font-weight: bold;\n        margin: 15px 0;\n        background: #ffffff;\n}\n.box .options .option .small[data-v-3d3aa354] {\n        font-size: 12px;\n        margin-top: 15px;\n}\n.box .options .option .fake-input[data-v-3d3aa354] {\n        height: 40px;\n        line-height: 40px;\n        margin: 15px 0;\n}\n", ""]);

// exports


/***/ }),
/* 565 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(false);
// imports
exports.i(__webpack_require__(596), "");

// module
exports.push([module.i, "\n", ""]);

// exports


/***/ }),
/* 566 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(false);
// imports


// module
exports.push([module.i, "\n.intro[data-v-45eaf5ea] {\n  font-size: 19.2px;\n  margin-bottom: 30px;\n  text-align: center;\n}\n.list .single[data-v-45eaf5ea] {\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-align: center;\n      align-items: center;\n  padding: 15px 0;\n  border-bottom: 1px solid rgba(0, 0, 0, 0.1);\n  font-family: \"Montserrat\", sans-serif;\n}\n.list .single[data-v-45eaf5ea]:first-of-type {\n    padding-top: 0px;\n}\n.list .single[data-v-45eaf5ea]:last-of-type {\n    border: none;\n    padding: 30px 0 15px 0;\n}\n.list .single .small[data-v-45eaf5ea] {\n    font-size: 14px;\n}\n.list .single .small b[data-v-45eaf5ea] {\n      font-weight: 600;\n}\n.list .single .info[data-v-45eaf5ea] {\n    -ms-flex: 0 0 50%;\n        flex: 0 0 50%;\n}\n.list .single .info.big[data-v-45eaf5ea] {\n      font-weight: 700;\n      font-size: 20px;\n}\n.list .single .info strong[data-v-45eaf5ea] {\n      font-weight: 600;\n      color: #172b43;\n      margin-bottom: 10px;\n      display: block;\n}\n.list .single .slider[data-v-45eaf5ea] {\n    -ms-flex: 0 0 25%;\n        flex: 0 0 25%;\n}\n.list .single .slider .slider-value[data-v-45eaf5ea] {\n      text-align: center;\n}\n.list .single .result[data-v-45eaf5ea] {\n    -ms-flex: 0 0 25%;\n        flex: 0 0 25%;\n    font-weight: 600;\n    font-size: 24px;\n    text-align: center;\n}\n.list .single .result.big[data-v-45eaf5ea] {\n      font-size: 30px;\n      font-weight: 700;\n}\n.list .single .result.positive[data-v-45eaf5ea] {\n      color: #4CAF50;\n}\n.list .single .result.negative[data-v-45eaf5ea] {\n      color: #FF5252;\n}\n", ""]);

// exports


/***/ }),
/* 567 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(false);
// imports


// module
exports.push([module.i, "\n.apexcharts-legend.center.position-bottom {\n  bottom: 0px !important;\n}\n", ""]);

// exports


/***/ }),
/* 568 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(false);
// imports


// module
exports.push([module.i, "\n.graph-data-box[data-v-46c39325] {\n  height: 450px !important;\n  animation: fadeIn 0.3s ease-in-out forwards;\n}\n.graph-header[data-v-46c39325] {\n  /* display: flex;\n        justify-content: space-between; */\n}\n.graph-header .table-heading[data-v-46c39325] {\n    font-size: 14px;\n    padding: 15px;\n    font-weight: 700;\n    color: #ffffff;\n    background: #172b43;\n    text-align: center;\n}\n", ""]);

// exports


/***/ }),
/* 569 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(false);
// imports


// module
exports.push([module.i, "\n.btn-group {\n  min-width: 160px;\n  height: 40px;\n  position: relative;\n  margin: 10px 1px;\n  display: inline-block;\n  vertical-align: middle;\n}\n.btn-group a:hover {\n  text-decoration: none;\n}\n.dropdown-toggle {\n  color: #636b6f;\n  min-width: 160px;\n  padding: 10px 20px 10px 10px;\n  text-transform: none;\n  font-weight: 300;\n  margin-bottom: 7px;\n  border: 0;\n  background-image: linear-gradient(#009688, #009688), linear-gradient(#D2D2D2, #D2D2D2);\n  background-size: 0 2px, 100% 1px;\n  background-repeat: no-repeat;\n  background-position: center bottom, center calc(100% - 1px);\n  background-color: transparent;\n  transition: background 0s ease-out;\n  float: none;\n  box-shadow: none;\n  border-radius: 0;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n  overflow: hidden;\n}\n.dropdown-toggle:hover {\n  background: #e1e1e1;\n  cursor: pointer;\n}\n.dropdown-menu {\n  position: absolute;\n  top: 100%;\n  left: 0;\n  z-index: 1000;\n  float: left;\n  min-width: 160px;\n  padding: 5px 0;\n  margin: 2px 0 0;\n  list-style: none;\n  font-size: 14px;\n  text-align: left;\n  background-color: #fff;\n  border: 1px solid #ccc;\n  border-radius: 4px;\n  box-shadow: 0 6px 12px rgba(0, 0, 0, 0.175);\n  background-clip: padding-box;\n}\n.dropdown-menu > li > a {\n  padding: 10px 30px;\n  display: block;\n  clear: both;\n  font-weight: normal;\n  line-height: 1.6;\n  color: #333333;\n  white-space: nowrap;\n  text-decoration: none;\n}\n.dropdown-menu > li > a:hover {\n  background: #efefef;\n  color: #409FCB;\n}\n.dropdown-menu > li {\n  overflow: hidden;\n  width: 100%;\n  position: relative;\n  margin: 0;\n}\n.caret {\n  width: 0;\n  position: absolute;\n  top: 19px;\n  height: 0;\n  margin-left: -24px;\n  vertical-align: middle;\n  border-top: 4px dashed;\n  border-top: 4px solid \\9;\n  border-right: 4px solid transparent;\n  border-left: 4px solid transparent;\n  right: 10px;\n}\nli {\n    list-style: none;\n}\n", ""]);

// exports


/***/ }),
/* 570 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(false);
// imports


// module
exports.push([module.i, "\n.budget[data-v-55170067] {\n  margin-top: 15px;\n}\n.budget .budget-bar-wrapper[data-v-55170067] {\n    display: block;\n    width: 100%;\n    height: 10px;\n    background: #ddd;\n    border-radius: 100px;\n    overflow: hidden;\n}\n.budget .budget-bar-wrapper .budget-bar-inner[data-v-55170067] {\n      display: block;\n      height: 10px;\n      width: 0px;\n      background: #172b43;\n}\n.chain[data-v-55170067] {\n  background: #ffffff;\n  padding: 30px 0;\n  border: 1px solid rgba(0, 0, 0, 0.15);\n  border-radius: 3px;\n  margin-bottom: 30px;\n}\n.chain__title[data-v-55170067] {\n    text-align: center;\n    margin-bottom: 45px;\n    font-size: 24px;\n    font-weight: 700;\n}\n.chain .links[data-v-55170067] {\n    display: -ms-grid;\n    display: grid;\n    -ms-grid-columns: 1fr 1fr 1fr 1fr 1fr 1fr;\n        grid-template-columns: 1fr 1fr 1fr 1fr 1fr 1fr;\n}\n.chain .link[data-v-55170067] {\n    position: relative;\n    line-height: 1.5;\n    padding: 0 30px;\n    font-size: 14px;\n}\n.chain .link[data-v-55170067]:not(:last-of-type)::before {\n      content: \"\\F356\";\n      font-family: \"Font Awesome 5 Pro\";\n      position: absolute;\n      top: 50%;\n      transform: translate(0, -50%);\n      right: 0;\n      color: #388E3C;\n      font-weight: 700;\n      font-size: 24px;\n}\n.chain .link .name[data-v-55170067] {\n      font-size: 14.4px;\n      font-weight: 700;\n}\n.chain .link .name .icon[data-v-55170067] {\n        font-size: 24px;\n        margin-bottom: 7.5px;\n}\n.chain .link .name > b[data-v-55170067] {\n        font-weight: 700;\n}\n.chain .link .name i[data-v-55170067] {\n        /* font-size: $fontsize--large;\n                    margin-bottom: $margin--small / 2; */\n}\n.chain .link .small[data-v-55170067] {\n      font-size: 14px;\n      display: block;\n      font-weight: normal;\n      color: #172b43;\n}\n.chain .link .revenue[data-v-55170067] {\n      font-weight: 700;\n      margin-top: 15px;\n      font-size: 16px;\n}\n.chain .link .coverage[data-v-55170067] {\n      font-weight: 700;\n      margin-top: 15px;\n      font-size: 20px;\n}\n", ""]);

// exports


/***/ }),
/* 571 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(false);
// imports


// module
exports.push([module.i, "\n.title[data-v-57bd4472] {\n  margin-bottom: 15px;\n}\ntable[data-v-57bd4472] {\n  text-align: left;\n}\ntable th[data-v-57bd4472], table td[data-v-57bd4472] {\n    min-width: 100px;\n    padding: 5px 15px 5px 0px;\n}\ntable th.name[data-v-57bd4472], table td.name[data-v-57bd4472] {\n      min-width: 200px;\n}\ntable input[data-v-57bd4472] {\n    border: 1px solid #ccc;\n    border-radius: 4px;\n    padding: 4px 8px;\n    width: 100%;\n}\ntable .totals[data-v-57bd4472] {\n    font-weight: bold;\n}\n", ""]);

// exports


/***/ }),
/* 572 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(false);
// imports


// module
exports.push([module.i, "\n.small[data-v-59df3e14] {\n  font-size: 12px;\n}\n.users .small-title[data-v-59df3e14] {\n  font-size: 20px;\n  margin-bottom: 15px;\n}\n.users .create-user[data-v-59df3e14] {\n  background: #ffffff;\n  padding: 30px;\n  border-radius: 3px;\n  box-shadow: 0 5px 15px rgba(40, 60, 134, 0.15);\n}\n.users .create-user .small[data-v-59df3e14] {\n    font-size: 12px;\n    margin-top: 4px;\n}\n.users .create-user label[data-v-59df3e14] {\n    font-weight: 600;\n    margin-bottom: 5px;\n    display: block;\n}\n.users .create-user input[data-v-59df3e14], .users .create-user select[data-v-59df3e14] {\n    height: 40px;\n    padding: 4px 10px;\n    border: 1px solid rgba(0, 0, 0, 0.15);\n    box-sizing: border-box;\n    border-radius: 3px;\n    cursor: pointer;\n    width: 100%;\n}\n.users .list .user[data-v-59df3e14] {\n  padding: 30px;\n  background: #ffffff;\n  border-radius: 3px;\n  box-shadow: 0 5px 15px rgba(40, 60, 134, 0.15);\n  margin-bottom: -30px;\n}\n.users .list .user input[data-v-59df3e14], .users .list .user select[data-v-59df3e14] {\n    height: 40px;\n    padding: 4px 10px;\n    border: 1px solid rgba(0, 0, 0, 0.15);\n    box-sizing: border-box;\n    border-radius: 3px;\n    cursor: pointer;\n    width: 100%;\n    margin-bottom: 15px;\n}\n.users .list .user .name[data-v-59df3e14] {\n    -ms-flex: 0 0 30%;\n        flex: 0 0 30%;\n    font-weight: 600;\n}\n.users .list .user .name .role[data-v-59df3e14] {\n      font-weight: normal;\n      font-size: 14px;\n}\n.users .list .user .email[data-v-59df3e14] {\n    -ms-flex: 0 0 30%;\n        flex: 0 0 30%;\n}\n.users .list .user .password[data-v-59df3e14] {\n    -ms-flex: 0 0 25%;\n        flex: 0 0 25%;\n}\n.users .list .user .actions[data-v-59df3e14] {\n    -ms-flex: 0 0 15%;\n        flex: 0 0 15%;\n    display: -ms-flexbox;\n    display: flex;\n    -ms-flex-pack: justify;\n        justify-content: space-between;\n}\n.users .list .user .actions .action[data-v-59df3e14] {\n      cursor: pointer;\n}\n.users .list .user[data-v-59df3e14]:not(:last-of-type) {\n    margin-bottom: 15px;\n}\n", ""]);

// exports


/***/ }),
/* 573 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(false);
// imports


// module
exports.push([module.i, "\n.lines .line.bold[data-v-5d6ac280] {\n  font-weight: bold;\n}\n.lines .line .name[data-v-5d6ac280] {\n  -ms-flex: 0 0 50% !important;\n      flex: 0 0 50% !important;\n}\n.lines .line .revenue[data-v-5d6ac280] {\n  -ms-flex: 0 0 25%;\n      flex: 0 0 25%;\n  text-align: right !important;\n}\n.lines .line .coverage[data-v-5d6ac280] {\n  -ms-flex: 0 0 25%;\n      flex: 0 0 25%;\n  text-align: right !important;\n}\n", ""]);

// exports


/***/ }),
/* 574 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(false);
// imports


// module
exports.push([module.i, "\n.inline[data-v-5e3ac208] {\n  display: inline-block;\n}\nbutton[data-v-5e3ac208] {\n  opacity: 0.8;\n}\nbutton[data-v-5e3ac208]:hover {\n    opacity: 1;\n}\nbutton.spaced[data-v-5e3ac208] {\n    margin-right: 6px;\n    color: #172b43;\n    opacity: .75;\n}\nbutton.spaced[data-v-5e3ac208]:hover {\n      opacity: 1;\n}\n", ""]);

// exports


/***/ }),
/* 575 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(false);
// imports


// module
exports.push([module.i, "\n.footer .container[data-v-5ebecd11] {\n  text-align: center;\n}\n.footer .container .toggle[data-v-5ebecd11] {\n    display: inline-block;\n    margin: 0 auto;\n    cursor: pointer;\n    margin-bottom: 30px;\n    border-bottom: 1px solid transparent;\n}\n.footer .container .toggle[data-v-5ebecd11]:hover {\n      border-bottom: 1px solid #172b43;\n}\n.footer .container .explainer[data-v-5ebecd11] {\n    font-size: 14px;\n    background: #ffffff;\n    max-width: 800px;\n    padding: 30px;\n    box-shadow: 0 5px 15px rgba(40, 60, 134, 0.15);\n    margin: 0 auto 30px auto;\n    text-align: left;\n}\n.footer .container .explainer .lines .line[data-v-5ebecd11] {\n      display: -ms-flexbox;\n      display: flex;\n}\n.footer .container .explainer .lines .line .abb[data-v-5ebecd11] {\n        -ms-flex: 0 0 15%;\n            flex: 0 0 15%;\n        font-weight: 700;\n}\n.footer .container .explainer .lines .line .exp[data-v-5ebecd11] {\n        -ms-flex: 0 0 35%;\n            flex: 0 0 35%;\n        padding-left: 30px;\n}\n.footer .container .explainer .lines .line .comment[data-v-5ebecd11] {\n        -ms-flex: 0 0 50%;\n            flex: 0 0 50%;\n        padding-left: 30px;\n}\n.footer .container .explainer .lines .line[data-v-5ebecd11]:not(:last-of-type) {\n        margin-bottom: 15px;\n}\n", ""]);

// exports


/***/ }),
/* 576 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(false);
// imports


// module
exports.push([module.i, "\n.sidebar-menu {\n  background: none;\n  margin-bottom: 30px;\n}\n.sidebar-menu .items {\n    display: -ms-flexbox;\n    display: flex;\n    -ms-flex-pack: start;\n        justify-content: flex-start;\n}\n.sidebar-menu .items.six-columns .item {\n      width: calc(16.66% - 10px) !important;\n}\n.sidebar-menu .items.six-columns .item:not(:first-of-type) {\n        margin-left: 12px;\n}\n.sidebar-menu .items .item {\n      padding: 15px;\n      width: calc(20% - 10px);\n      text-align: center;\n      font-size: 14px;\n      display: -ms-flexbox;\n      display: flex;\n      -ms-flex-align: center;\n          align-items: center;\n      position: relative;\n      cursor: pointer;\n      box-sizing: border-box;\n      background: #ffffff;\n      border-radius: 3px;\n      box-shadow: 0 5px 15px rgba(40, 60, 134, 0.15);\n      min-height: 100px;\n}\n.sidebar-menu .items .item .coming-soon {\n        font-weight: bold;\n        margin-bottom: 7.5px;\n}\n.sidebar-menu .items .item:not(:first-of-type) {\n        margin-left: 12.5px;\n}\n.sidebar-menu .items .item .inner {\n        width: 100%;\n}\n.sidebar-menu .items .item:hover {\n        background: #efefef;\n}\n.sidebar-menu .items .item.selected {\n        background: #172b43;\n        color: #ffffff;\n}\n.sidebar-menu .items .item .name {\n        -ms-flex-positive: 1;\n            flex-grow: 1;\n}\n.sidebar-menu .items .item .count {\n        font-size: 24px;\n        font-weight: 700;\n}\n.sidebar-menu .items .item .icon {\n        position: absolute;\n        bottom: -15px;\n        left: 50%;\n        transform: translate(-50%, 0);\n}\n.sidebar-menu .items .item .icon svg {\n          height: 15px;\n}\n.sidebar-menu .items .item .icon svg polygon {\n            fill: #172b43;\n}\n", ""]);

// exports


/***/ }),
/* 577 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(false);
// imports


// module
exports.push([module.i, "\n.settings-menu .menu-item[data-v-60f315bb] {\n  cursor: pointer;\n  transition: margin 0.3s ease;\n}\n.settings-menu .menu-item[data-v-60f315bb]:hover {\n    margin-left: 7.5px;\n}\n.settings-menu .menu-item[data-v-60f315bb]:not(:last-of-type) {\n    margin-bottom: 15px;\n}\n.settings-menu .menu-item.selected[data-v-60f315bb] {\n    font-weight: bold;\n}\n", ""]);

// exports


/***/ }),
/* 578 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(false);
// imports


// module
exports.push([module.i, "\n.highlight[data-v-70ce8938] {\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-pack: justify;\n      justify-content: space-between;\n}\n.highlight[data-v-70ce8938]:not(:last-of-type) {\n    margin-bottom: 15px;\n    padding-bottom: 15px;\n    border-bottom: 1px solid rgba(0, 0, 0, 0.05);\n}\n.highlight .value[data-v-70ce8938] {\n    font-weight: bold;\n}\n", ""]);

// exports


/***/ }),
/* 579 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(false);
// imports


// module
exports.push([module.i, "\n.list .project-status[data-v-74a30572] {\n  background: #ffffff;\n  padding: 30px;\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-pack: justify;\n      justify-content: space-between;\n  -ms-flex-align: center;\n      align-items: center;\n  margin-bottom: 30px;\n  border-radius: 3px;\n  box-shadow: 0 5px 15px rgba(40, 60, 134, 0.15);\n}\n.list .project-status .name[data-v-74a30572] {\n    font-weight: 600;\n}\n.list .project-status .type select[data-v-74a30572] {\n    padding: 4px 10px;\n    border: 1px solid rgba(0, 0, 0, 0.15);\n    cursor: pointer;\n    border-radius: 3px;\n}\n", ""]);

// exports


/***/ }),
/* 580 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(false);
// imports


// module
exports.push([module.i, "\n.view-toggle[data-v-77c8f022] {\n  margin-bottom: 45px;\n  margin-top: -30px;\n  text-align: center;\n}\n.view-toggle .options[data-v-77c8f022] {\n    display: -ms-inline-flexbox;\n    display: inline-flex;\n}\n.view-toggle .options .option[data-v-77c8f022] {\n      border-radius: 3px;\n      border: 1px solid rgba(0, 0, 0, 0.15);\n      background: #ffffff;\n      padding: 15px 30px;\n      font-size: 14px;\n      cursor: pointer;\n      transition: 0.3s ease all;\n}\n.view-toggle .options .option[data-v-77c8f022]:not(:first-of-type) {\n        margin-left: 15px;\n}\n.view-toggle .options .option[data-v-77c8f022]:hover {\n        box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);\n}\n.view-toggle .options .option.selected[data-v-77c8f022] {\n        background: #388E3C;\n        color: #ffffff;\n        box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);\n}\n.view-toggle .options .option.selected.udvikling[data-v-77c8f022] {\n          color: #ffffff;\n          background: #388E3C;\n}\n", ""]);

// exports


/***/ }),
/* 581 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(false);
// imports


// module
exports.push([module.i, "\n.index .economy-overview {\n  background: #172b43;\n  margin-bottom: 60px;\n  margin-bottom: 45px;\n  padding: 30px;\n  border-radius: 3px;\n  text-align: center;\n  box-shadow: 0 5px 15px rgba(40, 60, 134, 0.15);\n  color: #fff;\n}\n.index .economy-overview [class^=\"col-\"]:nth-of-type(2) {\n    border-left: 1px solid #244369;\n    border-right: 1px solid #244369;\n}\n.index .economy-overview [class^=\"col-\"] .text {\n    font-size: 16px;\n    font-weight: 500;\n    margin-bottom: 7.5px;\n}\n.index .economy-overview [class^=\"col-\"] .number {\n    font-size: 36px;\n    font-weight: 700;\n    font-family: \"Montserrat\", sans-serif;\n}\n.index .number-overview {\n  margin-bottom: 60px;\n  margin-bottom: 30px;\n}\n.index .tables-overview {\n  margin-bottom: 60px;\n  margin-bottom: 30px;\n}\n", ""]);

// exports


/***/ }),
/* 582 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(false);
// imports


// module
exports.push([module.i, "\n.tooltip-target[data-v-804e69b6] {\n  opacity: .5;\n}\n.tooltip-target[data-v-804e69b6]:hover {\n    opacity: 1;\n}\n.line[data-v-804e69b6] {\n  min-width: 250px;\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-pack: justify;\n      justify-content: space-between;\n  white-space: nowrap;\n  margin-bottom: 7.5px;\n  font-weight: 600;\n}\n.line .good[data-v-804e69b6] {\n    color: #4CAF50;\n}\n.line .bad[data-v-804e69b6] {\n    color: #FF5252;\n}\n.line.total[data-v-804e69b6] {\n    color: inherit;\n    margin-bottom: 0;\n    font-weight: 700;\n}\n", ""]);

// exports


/***/ }),
/* 583 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(false);
// imports


// module
exports.push([module.i, "\n.offline-wrapper[data-v-87b029dc]{\n    width: 100%;\n    height: 100vh;\n    position: relative;\n}\n.offline-inner[data-v-87b029dc]{\n    position: absolute;\n    top: 50%;\n    left: 50%;\n    margin: auto;\n    transform: translate(-50%, -50%);\n    width: 100%;\n    max-width: 600px;\n    background: rgba(255,255,255,0.95);\n    border-radius: 4px;\n    padding: 0px 30px 30px 30px;\n    text-align: center;\n    box-shadow: 0 0 0 1px rgba(0, 0, 0, 0.02), 0 4px 10px 0 rgba(0, 0, 0, 0.08);\n}\np.description[data-v-87b029dc]{\n    margin: 10px 0px;\n    font-weight: 300;\n}\nh1[data-v-87b029dc]{\n    font-weight: bold;\n    margin-bottom: 0;\n    margin-top: 0;\n}\nh3[data-v-87b029dc]{\n    font-weight: 400;\n    margin-top: 0px;\n}\n.icon[data-v-87b029dc]{\n    color: #333;\n    font-size: 100px;\n    margin: 0;\n}\n", ""]);

// exports


/***/ }),
/* 584 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(false);
// imports


// module
exports.push([module.i, "\nbutton[data-v-ad10ac3c] {\n  background: #172b43;\n  color: #fff;\n  padding: 2px 4px;\n  border-radius: 4px;\n}\n", ""]);

// exports


/***/ }),
/* 585 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(false);
// imports


// module
exports.push([module.i, "\n.box-helper-wrapper {\n  position: absolute;\n  right: 45px;\n  top: calc((30px * 1.5) + 80px);\n}\n.box-helper-button .button {\n  width: 60px;\n  height: 60px;\n  display: inline-block;\n  border-radius: 3px;\n  color: #172b43;\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-align: center;\n      align-items: center;\n  -ms-flex-pack: center;\n      justify-content: center;\n  font-size: 24px;\n  cursor: pointer;\n  transition: 0.3s ease all;\n}\n.box-helper-button .button:hover {\n    opacity: 1;\n}\n.box-helper {\n  background: rgba(0, 0, 0, 0.5);\n  position: fixed;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  z-index: 9999;\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-align: center;\n      align-items: center;\n  -ms-flex-pack: center;\n      justify-content: center;\n}\n.box-helper .content {\n    padding: 30px;\n    background: #ffffff;\n    width: 800px;\n    max-width: 90%;\n    max-height: 80vh;\n    overflow-y: auto;\n    border-radius: 3px;\n    box-shadow: 0px 5px 15px rgba(0, 0, 0, 0.15);\n    position: relative;\n}\n.box-helper .content .close {\n      position: fixed;\n      top: 30px;\n      right: 30px;\n      height: 30px;\n      width: 30px;\n      color: #fff;\n      font-weight: bold;\n      text-align: center;\n      cursor: pointer;\n      font-size: 30px;\n}\n.box-helper .content h3 {\n      margin-top: 30px;\n      margin-bottom: 15px;\n      border-bottom: 1px solid #172b43;\n      padding-bottom: 5px;\n}\n.box-helper .content p {\n      margin-bottom: 15px;\n}\n.box-helper .content ul, .box-helper .content ol {\n      margin-bottom: 15px;\n}\n.box-helper .content ul li:not(:last-of-type), .box-helper .content ol li:not(:last-of-type) {\n        margin-bottom: 7.5px;\n}\n", ""]);

// exports


/***/ }),
/* 586 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(false);
// imports


// module
exports.push([module.i, "\n@keyframes drawStroke {\n50% {\n    stroke-dashoffset: 0;\n}\n100% {\n    stroke-dashoffset: 1800;\n}\n}\n.box-loading[data-v-c979e24c] {\n  height: 350px;\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-pack: center;\n      justify-content: center;\n  -ms-flex-align: center;\n      align-items: center;\n  animation: fadeIn 0.3s ease-in-out forwards;\n  font-family: \"Montserrat\", sans-serif;\n  font-size: 20px;\n  text-align: center;\n}\n.box-loading .inner[data-v-c979e24c] {\n    display: -ms-flexbox;\n    display: flex;\n    -ms-flex-direction: column;\n        flex-direction: column;\n    -ms-flex-align: center;\n        align-items: center;\n}\n.box-loading svg[data-v-c979e24c] {\n    width: 80px;\n    display: block;\n    overflow: unset;\n}\n.box-loading svg path[data-v-c979e24c] {\n      stroke: #172b43;\n      stroke-dasharray: 1800;\n      stroke-dashoffset: 1800;\n      animation: drawStroke 3s ease-in-out infinite;\n}\n", ""]);

// exports


/***/ }),
/* 587 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(false);
// imports


// module
exports.push([module.i, "\n.title-block.left[data-v-cd5cc2c2] {\n  text-align: left;\n}\n.title-block.left p[data-v-cd5cc2c2] {\n    max-width: 500px;\n}\n.title-block.center[data-v-cd5cc2c2] {\n  text-align: center;\n}\n.title-block.center p[data-v-cd5cc2c2] {\n    padding: 0 calc(50% - (500px / 2));\n}\n.title-block.right[data-v-cd5cc2c2] {\n  text-align: right;\n}\n.title-block.right p[data-v-cd5cc2c2] {\n    padding-left: calc(100% - 500px);\n}\n.title-block.mb-xl[data-v-cd5cc2c2] {\n  margin-bottom: 60px;\n}\n.title-block .title[data-v-cd5cc2c2] {\n  font-size: 30px;\n  font-family: \"Montserrat\", sans-serif;\n  font-weight: 500;\n  color: #172b43;\n  line-height: 1.4;\n}\n.title-block .divider[data-v-cd5cc2c2] {\n  display: inline-block;\n  height: 1px;\n  width: 50px;\n  background: #172b43;\n  display: none;\n}\n.title-block p[data-v-cd5cc2c2] {\n  font-family: \"Open Sans\", sans-serif;\n  color: #172b43;\n  font-weight: 300;\n  font-size: 16px;\n  line-height: 24px;\n  margin-top: 0;\n}\n.title-block p a[data-v-cd5cc2c2] {\n    text-decoration: none;\n    color: #b29b81;\n    font-weight: 500;\n}\n", ""]);

// exports


/***/ }),
/* 588 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(false);
// imports


// module
exports.push([module.i, "\n.login[data-v-d8e10d84] {\n  background: #172b43;\n  width: 100%;\n  padding: 100px 0;\n  min-height: 100vh;\n}\n@media screen and (max-width: 768px) {\n.login[data-v-d8e10d84] {\n      padding-top: 60px;\n}\n}\n.login .inner .logo[data-v-d8e10d84] {\n    color: #ffffff;\n    text-align: center;\n    margin-bottom: 30px;\n}\n.login .inner .logo img[data-v-d8e10d84] {\n      width: 200px;\n      max-width: 100%;\n}\n.login .inner .logo .slogan[data-v-d8e10d84] {\n      margin-top: 7.5px;\n      font-size: 12px;\n      font-family: \"Montserrat\", sans-serif;\n      font-weight: 300;\n}\n.login .inner .box[data-v-d8e10d84] {\n    margin: 0 auto;\n    background: #ffffff;\n    width: 400px;\n    max-width: calc(100% - 60px);\n    padding: 30px;\n    border-radius: 10px;\n    box-shadow: 0 5px 15px rgba(40, 60, 134, 0.15);\n}\n.login .inner .box .header[data-v-d8e10d84] {\n      font-size: 30px;\n      font-family: \"Montserrat\", sans-serif;\n      font-weight: 700;\n      margin-bottom: 30px;\n      text-align: center;\n}\n.login .inner .box .input.username[data-v-d8e10d84] {\n      margin-bottom: 15px;\n}\n.login .inner .box .input label[data-v-d8e10d84] {\n      display: block;\n      margin-bottom: 7.5px;\n      text-transform: uppercase;\n      color: #69798d;\n      font-size: 12px;\n}\n.login .inner .box .input input[data-v-d8e10d84] {\n      display: block;\n      height: 30px;\n      width: 100%;\n      border: none;\n      border-radius: 3px;\n      border: 1px solid rgba(0, 0, 0, 0.15);\n      font-size: 14px;\n      padding: 15px 7.5px;\n      outline: none;\n}\n.login .inner .box .input input[data-v-d8e10d84]:-ms-input-placeholder {\n        color: rgba(0, 0, 0, 0.15);\n}\n.login .inner .box .input input[data-v-d8e10d84]::placeholder {\n        color: rgba(0, 0, 0, 0.15);\n}\n.login .inner .box .input input[data-v-d8e10d84]:active, .login .inner .box .input input[data-v-d8e10d84]:focus {\n        border-color: #172b43;\n}\n.login .inner .box .meta[data-v-d8e10d84] {\n      display: -ms-flexbox;\n      display: flex;\n      -ms-flex-align: center;\n          align-items: center;\n      -ms-flex-pack: justify;\n          justify-content: space-between;\n      margin: 30px 0;\n      font-size: 14px;\n}\n.login .inner .box .meta .remember-me input[data-v-d8e10d84] {\n        margin-bottom: 0;\n}\n.login .inner .box .meta .forgot-password a[data-v-d8e10d84] {\n        color: #172b43;\n        text-decoration: none;\n}\n.login .inner .box .meta .forgot-password a[data-v-d8e10d84]:hover {\n          text-decoration: underline;\n}\n.login .inner .box .button[data-v-d8e10d84] {\n      background: #172b43;\n      color: #ffffff;\n      padding: 15px;\n      border-radius: 3px;\n      text-align: center;\n      font-weight: 700;\n      font-family: \"Montserrat\", sans-serif;\n      cursor: pointer;\n}\n.login .inner .box .button[data-v-d8e10d84]:hover {\n        background: #101f30;\n}\n", ""]);

// exports


/***/ }),
/* 589 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(false);
// imports


// module
exports.push([module.i, "\n.register-card[data-v-d921176c] {\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-pack: center;\n      justify-content: center;\n  width: 500px;\n  margin: 15vh auto;\n  padding: 30px;\n}\n.wrapper[data-v-d921176c] {\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-direction: column;\n      flex-direction: column;\n  -ms-flex-pack: distribute;\n      justify-content: space-around;\n  height: 250px;\n}\n.remember[data-v-d921176c] {\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-pack: justify;\n      justify-content: space-between;\n  width: 55%;\n}\nbutton[data-v-d921176c] {\n  background: #eee;\n  padding: 5px;\n  border: 1px solid #bbb;\n}\ninput[data-v-d921176c] {\n  border: 1px solid #bbb;\n  padding: 2px;\n}\nform[data-v-d921176c] {\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-direction: column;\n      flex-direction: column;\n  -ms-flex-pack: justify;\n      justify-content: space-between;\n}\nh3[data-v-d921176c] {\n  margin: 0;\n}\n", ""]);

// exports


/***/ }),
/* 590 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(false);
// imports


// module
exports.push([module.i, "\n.company[data-v-db2305ca] {\n  background: #ffffff;\n  padding: 30px;\n  box-shadow: 0px 5px 15px rgba(0, 0, 0, 0.15);\n  border-radius: 3px;\n  margin-bottom: 15px;\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-align: center;\n      align-items: center;\n  -ms-flex-pack: justify;\n      justify-content: space-between;\n}\n.company .name[data-v-db2305ca] {\n    font-weight: 600;\n}\n.company .action[data-v-db2305ca] {\n    background: #172b43;\n    color: #ffffff;\n    padding: 4px 10px;\n    border-radius: 3px;\n    cursor: pointer;\n}\n.company .action[data-v-db2305ca]:hover {\n      opacity: 0.9;\n}\n", ""]);

// exports


/***/ }),
/* 591 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(false);
// imports


// module
exports.push([module.i, "\n.placeholder[data-v-e1cbaa30] {\n  height: -webkit-fit-content;\n  height: fit-content;\n}\n.box[data-v-e1cbaa30] {\n  text-align: center;\n  font-family: \"Montserrat\", sans-serif;\n  line-height: 1.5;\n}\n.box .large[data-v-e1cbaa30] {\n    font-size: 30px;\n    margin-bottom: 15px;\n    font-weight: 600;\n}\n.toggle[data-v-e1cbaa30] {\n  margin-top: 15px;\n  cursor: pointer;\n}\n.toggle[data-v-e1cbaa30]:hover {\n    font-weight: 600;\n}\n.account[data-v-e1cbaa30] {\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-pack: justify;\n      justify-content: space-between;\n}\n.account.total[data-v-e1cbaa30] {\n    font-weight: 600;\n}\n", ""]);

// exports


/***/ }),
/* 592 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(false);
// imports


// module
exports.push([module.i, "\n.accounts[data-v-ed1d8338] {\n  background: #ffffff;\n  padding: 15px;\n  box-shadow: 0 5px 15px rgba(40, 60, 134, 0.15);\n  border-radius: 3px;\n}\n.accounts .account[data-v-ed1d8338] {\n    display: -ms-flexbox;\n    display: flex;\n    -ms-flex-align: center;\n        align-items: center;\n    padding: 7.5px 0;\n}\n.accounts .account[data-v-ed1d8338]:not(:first-of-type):not(:last-of-type) {\n      border-bottom: 1px solid rgba(0, 0, 0, 0.15);\n}\n.accounts .account.bold[data-v-ed1d8338] {\n      font-weight: 600;\n}\n.accounts .account input[data-v-ed1d8338], .accounts .account select[data-v-ed1d8338] {\n      background: #fff;\n}\n.accounts .account .number[data-v-ed1d8338] {\n      -ms-flex: 0 0 10%;\n          flex: 0 0 10%;\n      font-weight: 600;\n}\n.accounts .account .name[data-v-ed1d8338] {\n      -ms-flex: 0 0 40%;\n          flex: 0 0 40%;\n      padding-right: 15px;\n}\n.accounts .account .value[data-v-ed1d8338] {\n      -ms-flex: 0 0 20%;\n          flex: 0 0 20%;\n}\n.accounts .account .budget[data-v-ed1d8338] {\n      -ms-flex: 0 0 20%;\n          flex: 0 0 20%;\n}\n.accounts .account .category[data-v-ed1d8338] {\n      -ms-flex: 0 0 20%;\n          flex: 0 0 20%;\n      padding-right: 15px;\n}\n.accounts .account .show[data-v-ed1d8338] {\n      -ms-flex: 0 0 10%;\n          flex: 0 0 10%;\n}\n.accounts .account .budget input[data-v-ed1d8338],\n    .accounts .account .category select[data-v-ed1d8338] {\n      padding: 4px 10px;\n      border: 1px solid rgba(0, 0, 0, 0.15);\n      box-sizing: border-box;\n      border-radius: 3px;\n      cursor: pointer;\n}\n.accounts .account .budget input[data-v-ed1d8338] {\n      width: calc(100% - 15px);\n}\n.accounts .account .category select[data-v-ed1d8338] {\n      width: 100%;\n}\n", ""]);

// exports


/***/ }),
/* 593 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(false);
// imports


// module
exports.push([module.i, "\n.tooltip-bottom-right[data-v-ee45503c] {\n  position: absolute;\n  bottom: 15px;\n  right: 15px;\n}\n.number-card[data-v-ee45503c] {\n  background: #ffffff;\n  padding: 15px;\n  border-radius: 3px;\n  border: 1px solid rgba(0, 0, 0, 0.15);\n  position: relative;\n  cursor: pointer;\n  transition: 0.3s ease all;\n  min-height: 136px;\n}\n.number-card[data-v-ee45503c]:hover {\n    border-color: #172b43;\n}\n.number-card .icon[data-v-ee45503c] {\n    position: absolute;\n    top: 15px;\n    right: 15px;\n    font-size: 30px;\n    opacity: .75;\n}\n.number-card .number[data-v-ee45503c] {\n    font-size: 30px;\n    font-weight: 700;\n    margin-bottom: 7.5px;\n    font-family: \"Montserrat\", sans-serif;\n    color: #b29b81;\n}\n.number-card .heading[data-v-ee45503c] {\n    font-family: \"Montserrat\", sans-serif;\n    font-weight: 600;\n    margin-bottom: 3.75px;\n    font-size: 14.4px;\n}\n.number-card .description[data-v-ee45503c] {\n    font-weight: 300;\n    font-size: 14px;\n}\n.number-card .total[data-v-ee45503c] {\n    margin-top: 10px;\n    font-size: 14px;\n    color: #b29b81;\n    font-family: \"Montserrat\", sans-serif;\n    font-weight: 700;\n}\n", ""]);

// exports


/***/ }),
/* 594 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(false);
// imports


// module
exports.push([module.i, "/*!\n * Bootstrap Grid v4.3.1 (https://getbootstrap.com/)\n * Copyright 2011-2019 The Bootstrap Authors\n * Copyright 2011-2019 Twitter, Inc.\n * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)\n */\n html {\n    box-sizing: border-box;\n    -ms-overflow-style: scrollbar;\n  }\n  \n  *,\n  *::before,\n  *::after {\n    box-sizing: inherit;\n  }\n  \n  /* .container {\n    width: 100%;\n    margin-right: auto;\n    margin-left: auto;\n  }\n  \n  @media (min-width: 576px) {\n    .container {\n      max-width: 540px;\n    }\n  }\n  \n  @media (min-width: 768px) {\n    .container {\n      max-width: 720px;\n    }\n  }\n  \n  @media (min-width: 992px) {\n    .container {\n      max-width: 960px;\n    }\n  }\n  \n  @media (min-width: 1200px) {\n    .container {\n      max-width: 1140px;\n    }\n  }\n  \n  .container-fluid {\n    width: 100%;\n    padding-right: 15px;\n    padding-left: 15px;\n    margin-right: auto;\n    margin-left: auto;\n  } */\n  \n  .row {\n    display: -ms-flexbox;\n    display: flex;\n    -ms-flex-wrap: wrap;\n    flex-wrap: wrap;\n    margin-right: -15px;\n    margin-left: -15px;\n  }\n  \n  .no-gutters {\n    margin-right: 0;\n    margin-left: 0;\n  }\n  \n  .no-gutters > .col,\n  .no-gutters > [class*=\"col-\"] {\n    padding-right: 0;\n    padding-left: 0;\n  }\n  \n  .col-1, .col-2, .col-3, .col-4, .col-5, .col-6, .col-7, .col-8, .col-9, .col-10, .col-11, .col-12, .col,\n  .col-auto, .col-sm-1, .col-sm-2, .col-sm-3, .col-sm-4, .col-sm-5, .col-sm-6, .col-sm-7, .col-sm-8, .col-sm-9, .col-sm-10, .col-sm-11, .col-sm-12, .col-sm,\n  .col-sm-auto, .col-md-1, .col-md-2, .col-md-3, .col-md-4, .col-md-5, .col-md-6, .col-md-7, .col-md-8, .col-md-9, .col-md-10, .col-md-11, .col-md-12, .col-md,\n  .col-md-auto, .col-lg-1, .col-lg-2, .col-lg-3, .col-lg-4, .col-lg-5, .col-lg-6, .col-lg-7, .col-lg-8, .col-lg-9, .col-lg-10, .col-lg-11, .col-lg-12, .col-lg,\n  .col-lg-auto, .col-xl-1, .col-xl-2, .col-xl-3, .col-xl-4, .col-xl-5, .col-xl-6, .col-xl-7, .col-xl-8, .col-xl-9, .col-xl-10, .col-xl-11, .col-xl-12, .col-xl,\n  .col-xl-auto {\n    position: relative;\n    width: 100%;\n    padding-right: 15px;\n    padding-left: 15px;\n  }\n  \n  .col {\n    -ms-flex-preferred-size: 0;\n    flex-basis: 0;\n    -ms-flex-positive: 1;\n    flex-grow: 1;\n    max-width: 100%;\n  }\n  \n  .col-auto {\n    -ms-flex: 0 0 auto;\n    flex: 0 0 auto;\n    width: auto;\n    max-width: 100%;\n  }\n  \n  .col-1 {\n    -ms-flex: 0 0 8.333333%;\n    flex: 0 0 8.333333%;\n    max-width: 8.333333%;\n  }\n  \n  .col-2 {\n    -ms-flex: 0 0 16.666667%;\n    flex: 0 0 16.666667%;\n    max-width: 16.666667%;\n  }\n  \n  .col-3 {\n    -ms-flex: 0 0 25%;\n    flex: 0 0 25%;\n    max-width: 25%;\n  }\n  \n  .col-4 {\n    -ms-flex: 0 0 33.333333%;\n    flex: 0 0 33.333333%;\n    max-width: 33.333333%;\n  }\n  \n  .col-5 {\n    -ms-flex: 0 0 41.666667%;\n    flex: 0 0 41.666667%;\n    max-width: 41.666667%;\n  }\n  \n  .col-6 {\n    -ms-flex: 0 0 50%;\n    flex: 0 0 50%;\n    max-width: 50%;\n  }\n  \n  .col-7 {\n    -ms-flex: 0 0 58.333333%;\n    flex: 0 0 58.333333%;\n    max-width: 58.333333%;\n  }\n  \n  .col-8 {\n    -ms-flex: 0 0 66.666667%;\n    flex: 0 0 66.666667%;\n    max-width: 66.666667%;\n  }\n  \n  .col-9 {\n    -ms-flex: 0 0 75%;\n    flex: 0 0 75%;\n    max-width: 75%;\n  }\n  \n  .col-10 {\n    -ms-flex: 0 0 83.333333%;\n    flex: 0 0 83.333333%;\n    max-width: 83.333333%;\n  }\n  \n  .col-11 {\n    -ms-flex: 0 0 91.666667%;\n    flex: 0 0 91.666667%;\n    max-width: 91.666667%;\n  }\n  \n  .col-12 {\n    -ms-flex: 0 0 100%;\n    flex: 0 0 100%;\n    max-width: 100%;\n  }\n  \n  .order-first {\n    -ms-flex-order: -1;\n    order: -1;\n  }\n  \n  .order-last {\n    -ms-flex-order: 13;\n    order: 13;\n  }\n  \n  .order-0 {\n    -ms-flex-order: 0;\n    order: 0;\n  }\n  \n  .order-1 {\n    -ms-flex-order: 1;\n    order: 1;\n  }\n  \n  .order-2 {\n    -ms-flex-order: 2;\n    order: 2;\n  }\n  \n  .order-3 {\n    -ms-flex-order: 3;\n    order: 3;\n  }\n  \n  .order-4 {\n    -ms-flex-order: 4;\n    order: 4;\n  }\n  \n  .order-5 {\n    -ms-flex-order: 5;\n    order: 5;\n  }\n  \n  .order-6 {\n    -ms-flex-order: 6;\n    order: 6;\n  }\n  \n  .order-7 {\n    -ms-flex-order: 7;\n    order: 7;\n  }\n  \n  .order-8 {\n    -ms-flex-order: 8;\n    order: 8;\n  }\n  \n  .order-9 {\n    -ms-flex-order: 9;\n    order: 9;\n  }\n  \n  .order-10 {\n    -ms-flex-order: 10;\n    order: 10;\n  }\n  \n  .order-11 {\n    -ms-flex-order: 11;\n    order: 11;\n  }\n  \n  .order-12 {\n    -ms-flex-order: 12;\n    order: 12;\n  }\n  \n  .offset-1 {\n    margin-left: 8.333333%;\n  }\n  \n  .offset-2 {\n    margin-left: 16.666667%;\n  }\n  \n  .offset-3 {\n    margin-left: 25%;\n  }\n  \n  .offset-4 {\n    margin-left: 33.333333%;\n  }\n  \n  .offset-5 {\n    margin-left: 41.666667%;\n  }\n  \n  .offset-6 {\n    margin-left: 50%;\n  }\n  \n  .offset-7 {\n    margin-left: 58.333333%;\n  }\n  \n  .offset-8 {\n    margin-left: 66.666667%;\n  }\n  \n  .offset-9 {\n    margin-left: 75%;\n  }\n  \n  .offset-10 {\n    margin-left: 83.333333%;\n  }\n  \n  .offset-11 {\n    margin-left: 91.666667%;\n  }\n  \n  @media (min-width: 576px) {\n    .col-sm {\n      -ms-flex-preferred-size: 0;\n      flex-basis: 0;\n      -ms-flex-positive: 1;\n      flex-grow: 1;\n      max-width: 100%;\n    }\n    .col-sm-auto {\n      -ms-flex: 0 0 auto;\n      flex: 0 0 auto;\n      width: auto;\n      max-width: 100%;\n    }\n    .col-sm-1 {\n      -ms-flex: 0 0 8.333333%;\n      flex: 0 0 8.333333%;\n      max-width: 8.333333%;\n    }\n    .col-sm-2 {\n      -ms-flex: 0 0 16.666667%;\n      flex: 0 0 16.666667%;\n      max-width: 16.666667%;\n    }\n    .col-sm-3 {\n      -ms-flex: 0 0 25%;\n      flex: 0 0 25%;\n      max-width: 25%;\n    }\n    .col-sm-4 {\n      -ms-flex: 0 0 33.333333%;\n      flex: 0 0 33.333333%;\n      max-width: 33.333333%;\n    }\n    .col-sm-5 {\n      -ms-flex: 0 0 41.666667%;\n      flex: 0 0 41.666667%;\n      max-width: 41.666667%;\n    }\n    .col-sm-6 {\n      -ms-flex: 0 0 50%;\n      flex: 0 0 50%;\n      max-width: 50%;\n    }\n    .col-sm-7 {\n      -ms-flex: 0 0 58.333333%;\n      flex: 0 0 58.333333%;\n      max-width: 58.333333%;\n    }\n    .col-sm-8 {\n      -ms-flex: 0 0 66.666667%;\n      flex: 0 0 66.666667%;\n      max-width: 66.666667%;\n    }\n    .col-sm-9 {\n      -ms-flex: 0 0 75%;\n      flex: 0 0 75%;\n      max-width: 75%;\n    }\n    .col-sm-10 {\n      -ms-flex: 0 0 83.333333%;\n      flex: 0 0 83.333333%;\n      max-width: 83.333333%;\n    }\n    .col-sm-11 {\n      -ms-flex: 0 0 91.666667%;\n      flex: 0 0 91.666667%;\n      max-width: 91.666667%;\n    }\n    .col-sm-12 {\n      -ms-flex: 0 0 100%;\n      flex: 0 0 100%;\n      max-width: 100%;\n    }\n    .order-sm-first {\n      -ms-flex-order: -1;\n      order: -1;\n    }\n    .order-sm-last {\n      -ms-flex-order: 13;\n      order: 13;\n    }\n    .order-sm-0 {\n      -ms-flex-order: 0;\n      order: 0;\n    }\n    .order-sm-1 {\n      -ms-flex-order: 1;\n      order: 1;\n    }\n    .order-sm-2 {\n      -ms-flex-order: 2;\n      order: 2;\n    }\n    .order-sm-3 {\n      -ms-flex-order: 3;\n      order: 3;\n    }\n    .order-sm-4 {\n      -ms-flex-order: 4;\n      order: 4;\n    }\n    .order-sm-5 {\n      -ms-flex-order: 5;\n      order: 5;\n    }\n    .order-sm-6 {\n      -ms-flex-order: 6;\n      order: 6;\n    }\n    .order-sm-7 {\n      -ms-flex-order: 7;\n      order: 7;\n    }\n    .order-sm-8 {\n      -ms-flex-order: 8;\n      order: 8;\n    }\n    .order-sm-9 {\n      -ms-flex-order: 9;\n      order: 9;\n    }\n    .order-sm-10 {\n      -ms-flex-order: 10;\n      order: 10;\n    }\n    .order-sm-11 {\n      -ms-flex-order: 11;\n      order: 11;\n    }\n    .order-sm-12 {\n      -ms-flex-order: 12;\n      order: 12;\n    }\n    .offset-sm-0 {\n      margin-left: 0;\n    }\n    .offset-sm-1 {\n      margin-left: 8.333333%;\n    }\n    .offset-sm-2 {\n      margin-left: 16.666667%;\n    }\n    .offset-sm-3 {\n      margin-left: 25%;\n    }\n    .offset-sm-4 {\n      margin-left: 33.333333%;\n    }\n    .offset-sm-5 {\n      margin-left: 41.666667%;\n    }\n    .offset-sm-6 {\n      margin-left: 50%;\n    }\n    .offset-sm-7 {\n      margin-left: 58.333333%;\n    }\n    .offset-sm-8 {\n      margin-left: 66.666667%;\n    }\n    .offset-sm-9 {\n      margin-left: 75%;\n    }\n    .offset-sm-10 {\n      margin-left: 83.333333%;\n    }\n    .offset-sm-11 {\n      margin-left: 91.666667%;\n    }\n  }\n  \n  @media (min-width: 768px) {\n    .col-md {\n      -ms-flex-preferred-size: 0;\n      flex-basis: 0;\n      -ms-flex-positive: 1;\n      flex-grow: 1;\n      max-width: 100%;\n    }\n    .col-md-auto {\n      -ms-flex: 0 0 auto;\n      flex: 0 0 auto;\n      width: auto;\n      max-width: 100%;\n    }\n    .col-md-1 {\n      -ms-flex: 0 0 8.333333%;\n      flex: 0 0 8.333333%;\n      max-width: 8.333333%;\n    }\n    .col-md-2 {\n      -ms-flex: 0 0 16.666667%;\n      flex: 0 0 16.666667%;\n      max-width: 16.666667%;\n    }\n    .col-md-3 {\n      -ms-flex: 0 0 25%;\n      flex: 0 0 25%;\n      max-width: 25%;\n    }\n    .col-md-4 {\n      -ms-flex: 0 0 33.333333%;\n      flex: 0 0 33.333333%;\n      max-width: 33.333333%;\n    }\n    .col-md-5 {\n      -ms-flex: 0 0 41.666667%;\n      flex: 0 0 41.666667%;\n      max-width: 41.666667%;\n    }\n    .col-md-6 {\n      -ms-flex: 0 0 50%;\n      flex: 0 0 50%;\n      max-width: 50%;\n    }\n    .col-md-7 {\n      -ms-flex: 0 0 58.333333%;\n      flex: 0 0 58.333333%;\n      max-width: 58.333333%;\n    }\n    .col-md-8 {\n      -ms-flex: 0 0 66.666667%;\n      flex: 0 0 66.666667%;\n      max-width: 66.666667%;\n    }\n    .col-md-9 {\n      -ms-flex: 0 0 75%;\n      flex: 0 0 75%;\n      max-width: 75%;\n    }\n    .col-md-10 {\n      -ms-flex: 0 0 83.333333%;\n      flex: 0 0 83.333333%;\n      max-width: 83.333333%;\n    }\n    .col-md-11 {\n      -ms-flex: 0 0 91.666667%;\n      flex: 0 0 91.666667%;\n      max-width: 91.666667%;\n    }\n    .col-md-12 {\n      -ms-flex: 0 0 100%;\n      flex: 0 0 100%;\n      max-width: 100%;\n    }\n    .order-md-first {\n      -ms-flex-order: -1;\n      order: -1;\n    }\n    .order-md-last {\n      -ms-flex-order: 13;\n      order: 13;\n    }\n    .order-md-0 {\n      -ms-flex-order: 0;\n      order: 0;\n    }\n    .order-md-1 {\n      -ms-flex-order: 1;\n      order: 1;\n    }\n    .order-md-2 {\n      -ms-flex-order: 2;\n      order: 2;\n    }\n    .order-md-3 {\n      -ms-flex-order: 3;\n      order: 3;\n    }\n    .order-md-4 {\n      -ms-flex-order: 4;\n      order: 4;\n    }\n    .order-md-5 {\n      -ms-flex-order: 5;\n      order: 5;\n    }\n    .order-md-6 {\n      -ms-flex-order: 6;\n      order: 6;\n    }\n    .order-md-7 {\n      -ms-flex-order: 7;\n      order: 7;\n    }\n    .order-md-8 {\n      -ms-flex-order: 8;\n      order: 8;\n    }\n    .order-md-9 {\n      -ms-flex-order: 9;\n      order: 9;\n    }\n    .order-md-10 {\n      -ms-flex-order: 10;\n      order: 10;\n    }\n    .order-md-11 {\n      -ms-flex-order: 11;\n      order: 11;\n    }\n    .order-md-12 {\n      -ms-flex-order: 12;\n      order: 12;\n    }\n    .offset-md-0 {\n      margin-left: 0;\n    }\n    .offset-md-1 {\n      margin-left: 8.333333%;\n    }\n    .offset-md-2 {\n      margin-left: 16.666667%;\n    }\n    .offset-md-3 {\n      margin-left: 25%;\n    }\n    .offset-md-4 {\n      margin-left: 33.333333%;\n    }\n    .offset-md-5 {\n      margin-left: 41.666667%;\n    }\n    .offset-md-6 {\n      margin-left: 50%;\n    }\n    .offset-md-7 {\n      margin-left: 58.333333%;\n    }\n    .offset-md-8 {\n      margin-left: 66.666667%;\n    }\n    .offset-md-9 {\n      margin-left: 75%;\n    }\n    .offset-md-10 {\n      margin-left: 83.333333%;\n    }\n    .offset-md-11 {\n      margin-left: 91.666667%;\n    }\n  }\n  \n  @media (min-width: 992px) {\n    .col-lg {\n      -ms-flex-preferred-size: 0;\n      flex-basis: 0;\n      -ms-flex-positive: 1;\n      flex-grow: 1;\n      max-width: 100%;\n    }\n    .col-lg-auto {\n      -ms-flex: 0 0 auto;\n      flex: 0 0 auto;\n      width: auto;\n      max-width: 100%;\n    }\n    .col-lg-1 {\n      -ms-flex: 0 0 8.333333%;\n      flex: 0 0 8.333333%;\n      max-width: 8.333333%;\n    }\n    .col-lg-2 {\n      -ms-flex: 0 0 16.666667%;\n      flex: 0 0 16.666667%;\n      max-width: 16.666667%;\n    }\n    .col-lg-3 {\n      -ms-flex: 0 0 25%;\n      flex: 0 0 25%;\n      max-width: 25%;\n    }\n    .col-lg-4 {\n      -ms-flex: 0 0 33.333333%;\n      flex: 0 0 33.333333%;\n      max-width: 33.333333%;\n    }\n    .col-lg-5 {\n      -ms-flex: 0 0 41.666667%;\n      flex: 0 0 41.666667%;\n      max-width: 41.666667%;\n    }\n    .col-lg-6 {\n      -ms-flex: 0 0 50%;\n      flex: 0 0 50%;\n      max-width: 50%;\n    }\n    .col-lg-7 {\n      -ms-flex: 0 0 58.333333%;\n      flex: 0 0 58.333333%;\n      max-width: 58.333333%;\n    }\n    .col-lg-8 {\n      -ms-flex: 0 0 66.666667%;\n      flex: 0 0 66.666667%;\n      max-width: 66.666667%;\n    }\n    .col-lg-9 {\n      -ms-flex: 0 0 75%;\n      flex: 0 0 75%;\n      max-width: 75%;\n    }\n    .col-lg-10 {\n      -ms-flex: 0 0 83.333333%;\n      flex: 0 0 83.333333%;\n      max-width: 83.333333%;\n    }\n    .col-lg-11 {\n      -ms-flex: 0 0 91.666667%;\n      flex: 0 0 91.666667%;\n      max-width: 91.666667%;\n    }\n    .col-lg-12 {\n      -ms-flex: 0 0 100%;\n      flex: 0 0 100%;\n      max-width: 100%;\n    }\n    .order-lg-first {\n      -ms-flex-order: -1;\n      order: -1;\n    }\n    .order-lg-last {\n      -ms-flex-order: 13;\n      order: 13;\n    }\n    .order-lg-0 {\n      -ms-flex-order: 0;\n      order: 0;\n    }\n    .order-lg-1 {\n      -ms-flex-order: 1;\n      order: 1;\n    }\n    .order-lg-2 {\n      -ms-flex-order: 2;\n      order: 2;\n    }\n    .order-lg-3 {\n      -ms-flex-order: 3;\n      order: 3;\n    }\n    .order-lg-4 {\n      -ms-flex-order: 4;\n      order: 4;\n    }\n    .order-lg-5 {\n      -ms-flex-order: 5;\n      order: 5;\n    }\n    .order-lg-6 {\n      -ms-flex-order: 6;\n      order: 6;\n    }\n    .order-lg-7 {\n      -ms-flex-order: 7;\n      order: 7;\n    }\n    .order-lg-8 {\n      -ms-flex-order: 8;\n      order: 8;\n    }\n    .order-lg-9 {\n      -ms-flex-order: 9;\n      order: 9;\n    }\n    .order-lg-10 {\n      -ms-flex-order: 10;\n      order: 10;\n    }\n    .order-lg-11 {\n      -ms-flex-order: 11;\n      order: 11;\n    }\n    .order-lg-12 {\n      -ms-flex-order: 12;\n      order: 12;\n    }\n    .offset-lg-0 {\n      margin-left: 0;\n    }\n    .offset-lg-1 {\n      margin-left: 8.333333%;\n    }\n    .offset-lg-2 {\n      margin-left: 16.666667%;\n    }\n    .offset-lg-3 {\n      margin-left: 25%;\n    }\n    .offset-lg-4 {\n      margin-left: 33.333333%;\n    }\n    .offset-lg-5 {\n      margin-left: 41.666667%;\n    }\n    .offset-lg-6 {\n      margin-left: 50%;\n    }\n    .offset-lg-7 {\n      margin-left: 58.333333%;\n    }\n    .offset-lg-8 {\n      margin-left: 66.666667%;\n    }\n    .offset-lg-9 {\n      margin-left: 75%;\n    }\n    .offset-lg-10 {\n      margin-left: 83.333333%;\n    }\n    .offset-lg-11 {\n      margin-left: 91.666667%;\n    }\n  }\n  \n  @media (min-width: 1200px) {\n    .col-xl {\n      -ms-flex-preferred-size: 0;\n      flex-basis: 0;\n      -ms-flex-positive: 1;\n      flex-grow: 1;\n      max-width: 100%;\n    }\n    .col-xl-auto {\n      -ms-flex: 0 0 auto;\n      flex: 0 0 auto;\n      width: auto;\n      max-width: 100%;\n    }\n    .col-xl-1 {\n      -ms-flex: 0 0 8.333333%;\n      flex: 0 0 8.333333%;\n      max-width: 8.333333%;\n    }\n    .col-xl-2 {\n      -ms-flex: 0 0 16.666667%;\n      flex: 0 0 16.666667%;\n      max-width: 16.666667%;\n    }\n    .col-xl-3 {\n      -ms-flex: 0 0 25%;\n      flex: 0 0 25%;\n      max-width: 25%;\n    }\n    .col-xl-4 {\n      -ms-flex: 0 0 33.333333%;\n      flex: 0 0 33.333333%;\n      max-width: 33.333333%;\n    }\n    .col-xl-5 {\n      -ms-flex: 0 0 41.666667%;\n      flex: 0 0 41.666667%;\n      max-width: 41.666667%;\n    }\n    .col-xl-6 {\n      -ms-flex: 0 0 50%;\n      flex: 0 0 50%;\n      max-width: 50%;\n    }\n    .col-xl-7 {\n      -ms-flex: 0 0 58.333333%;\n      flex: 0 0 58.333333%;\n      max-width: 58.333333%;\n    }\n    .col-xl-8 {\n      -ms-flex: 0 0 66.666667%;\n      flex: 0 0 66.666667%;\n      max-width: 66.666667%;\n    }\n    .col-xl-9 {\n      -ms-flex: 0 0 75%;\n      flex: 0 0 75%;\n      max-width: 75%;\n    }\n    .col-xl-10 {\n      -ms-flex: 0 0 83.333333%;\n      flex: 0 0 83.333333%;\n      max-width: 83.333333%;\n    }\n    .col-xl-11 {\n      -ms-flex: 0 0 91.666667%;\n      flex: 0 0 91.666667%;\n      max-width: 91.666667%;\n    }\n    .col-xl-12 {\n      -ms-flex: 0 0 100%;\n      flex: 0 0 100%;\n      max-width: 100%;\n    }\n    .order-xl-first {\n      -ms-flex-order: -1;\n      order: -1;\n    }\n    .order-xl-last {\n      -ms-flex-order: 13;\n      order: 13;\n    }\n    .order-xl-0 {\n      -ms-flex-order: 0;\n      order: 0;\n    }\n    .order-xl-1 {\n      -ms-flex-order: 1;\n      order: 1;\n    }\n    .order-xl-2 {\n      -ms-flex-order: 2;\n      order: 2;\n    }\n    .order-xl-3 {\n      -ms-flex-order: 3;\n      order: 3;\n    }\n    .order-xl-4 {\n      -ms-flex-order: 4;\n      order: 4;\n    }\n    .order-xl-5 {\n      -ms-flex-order: 5;\n      order: 5;\n    }\n    .order-xl-6 {\n      -ms-flex-order: 6;\n      order: 6;\n    }\n    .order-xl-7 {\n      -ms-flex-order: 7;\n      order: 7;\n    }\n    .order-xl-8 {\n      -ms-flex-order: 8;\n      order: 8;\n    }\n    .order-xl-9 {\n      -ms-flex-order: 9;\n      order: 9;\n    }\n    .order-xl-10 {\n      -ms-flex-order: 10;\n      order: 10;\n    }\n    .order-xl-11 {\n      -ms-flex-order: 11;\n      order: 11;\n    }\n    .order-xl-12 {\n      -ms-flex-order: 12;\n      order: 12;\n    }\n    .offset-xl-0 {\n      margin-left: 0;\n    }\n    .offset-xl-1 {\n      margin-left: 8.333333%;\n    }\n    .offset-xl-2 {\n      margin-left: 16.666667%;\n    }\n    .offset-xl-3 {\n      margin-left: 25%;\n    }\n    .offset-xl-4 {\n      margin-left: 33.333333%;\n    }\n    .offset-xl-5 {\n      margin-left: 41.666667%;\n    }\n    .offset-xl-6 {\n      margin-left: 50%;\n    }\n    .offset-xl-7 {\n      margin-left: 58.333333%;\n    }\n    .offset-xl-8 {\n      margin-left: 66.666667%;\n    }\n    .offset-xl-9 {\n      margin-left: 75%;\n    }\n    .offset-xl-10 {\n      margin-left: 83.333333%;\n    }\n    .offset-xl-11 {\n      margin-left: 91.666667%;\n    }\n  }\n  \n  .d-none {\n    display: none !important;\n  }\n  \n  .d-inline {\n    display: inline !important;\n  }\n  \n  .d-inline-block {\n    display: inline-block !important;\n  }\n  \n  .d-block {\n    display: block !important;\n  }\n  \n  .d-table {\n    display: table !important;\n  }\n  \n  .d-table-row {\n    display: table-row !important;\n  }\n  \n  .d-table-cell {\n    display: table-cell !important;\n  }\n  \n  .d-flex {\n    display: -ms-flexbox !important;\n    display: flex !important;\n  }\n  \n  .d-inline-flex {\n    display: -ms-inline-flexbox !important;\n    display: inline-flex !important;\n  }\n  \n  @media (min-width: 576px) {\n    .d-sm-none {\n      display: none !important;\n    }\n    .d-sm-inline {\n      display: inline !important;\n    }\n    .d-sm-inline-block {\n      display: inline-block !important;\n    }\n    .d-sm-block {\n      display: block !important;\n    }\n    .d-sm-table {\n      display: table !important;\n    }\n    .d-sm-table-row {\n      display: table-row !important;\n    }\n    .d-sm-table-cell {\n      display: table-cell !important;\n    }\n    .d-sm-flex {\n      display: -ms-flexbox !important;\n      display: flex !important;\n    }\n    .d-sm-inline-flex {\n      display: -ms-inline-flexbox !important;\n      display: inline-flex !important;\n    }\n  }\n  \n  @media (min-width: 768px) {\n    .d-md-none {\n      display: none !important;\n    }\n    .d-md-inline {\n      display: inline !important;\n    }\n    .d-md-inline-block {\n      display: inline-block !important;\n    }\n    .d-md-block {\n      display: block !important;\n    }\n    .d-md-table {\n      display: table !important;\n    }\n    .d-md-table-row {\n      display: table-row !important;\n    }\n    .d-md-table-cell {\n      display: table-cell !important;\n    }\n    .d-md-flex {\n      display: -ms-flexbox !important;\n      display: flex !important;\n    }\n    .d-md-inline-flex {\n      display: -ms-inline-flexbox !important;\n      display: inline-flex !important;\n    }\n  }\n  \n  @media (min-width: 992px) {\n    .d-lg-none {\n      display: none !important;\n    }\n    .d-lg-inline {\n      display: inline !important;\n    }\n    .d-lg-inline-block {\n      display: inline-block !important;\n    }\n    .d-lg-block {\n      display: block !important;\n    }\n    .d-lg-table {\n      display: table !important;\n    }\n    .d-lg-table-row {\n      display: table-row !important;\n    }\n    .d-lg-table-cell {\n      display: table-cell !important;\n    }\n    .d-lg-flex {\n      display: -ms-flexbox !important;\n      display: flex !important;\n    }\n    .d-lg-inline-flex {\n      display: -ms-inline-flexbox !important;\n      display: inline-flex !important;\n    }\n  }\n  \n  @media (min-width: 1200px) {\n    .d-xl-none {\n      display: none !important;\n    }\n    .d-xl-inline {\n      display: inline !important;\n    }\n    .d-xl-inline-block {\n      display: inline-block !important;\n    }\n    .d-xl-block {\n      display: block !important;\n    }\n    .d-xl-table {\n      display: table !important;\n    }\n    .d-xl-table-row {\n      display: table-row !important;\n    }\n    .d-xl-table-cell {\n      display: table-cell !important;\n    }\n    .d-xl-flex {\n      display: -ms-flexbox !important;\n      display: flex !important;\n    }\n    .d-xl-inline-flex {\n      display: -ms-inline-flexbox !important;\n      display: inline-flex !important;\n    }\n  }\n  \n  @media print {\n    .d-print-none {\n      display: none !important;\n    }\n    .d-print-inline {\n      display: inline !important;\n    }\n    .d-print-inline-block {\n      display: inline-block !important;\n    }\n    .d-print-block {\n      display: block !important;\n    }\n    .d-print-table {\n      display: table !important;\n    }\n    .d-print-table-row {\n      display: table-row !important;\n    }\n    .d-print-table-cell {\n      display: table-cell !important;\n    }\n    .d-print-flex {\n      display: -ms-flexbox !important;\n      display: flex !important;\n    }\n    .d-print-inline-flex {\n      display: -ms-inline-flexbox !important;\n      display: inline-flex !important;\n    }\n  }\n  \n  .flex-row {\n    -ms-flex-direction: row !important;\n    flex-direction: row !important;\n  }\n  \n  .flex-column {\n    -ms-flex-direction: column !important;\n    flex-direction: column !important;\n  }\n  \n  .flex-row-reverse {\n    -ms-flex-direction: row-reverse !important;\n    flex-direction: row-reverse !important;\n  }\n  \n  .flex-column-reverse {\n    -ms-flex-direction: column-reverse !important;\n    flex-direction: column-reverse !important;\n  }\n  \n  .flex-wrap {\n    -ms-flex-wrap: wrap !important;\n    flex-wrap: wrap !important;\n  }\n  \n  .flex-nowrap {\n    -ms-flex-wrap: nowrap !important;\n    flex-wrap: nowrap !important;\n  }\n  \n  .flex-wrap-reverse {\n    -ms-flex-wrap: wrap-reverse !important;\n    flex-wrap: wrap-reverse !important;\n  }\n  \n  .flex-fill {\n    -ms-flex: 1 1 auto !important;\n    flex: 1 1 auto !important;\n  }\n  \n  .flex-grow-0 {\n    -ms-flex-positive: 0 !important;\n    flex-grow: 0 !important;\n  }\n  \n  .flex-grow-1 {\n    -ms-flex-positive: 1 !important;\n    flex-grow: 1 !important;\n  }\n  \n  .flex-shrink-0 {\n    -ms-flex-negative: 0 !important;\n    flex-shrink: 0 !important;\n  }\n  \n  .flex-shrink-1 {\n    -ms-flex-negative: 1 !important;\n    flex-shrink: 1 !important;\n  }\n  \n  .justify-content-start {\n    -ms-flex-pack: start !important;\n    justify-content: flex-start !important;\n  }\n  \n  .justify-content-end {\n    -ms-flex-pack: end !important;\n    justify-content: flex-end !important;\n  }\n  \n  .justify-content-center {\n    -ms-flex-pack: center !important;\n    justify-content: center !important;\n  }\n  \n  .justify-content-between {\n    -ms-flex-pack: justify !important;\n    justify-content: space-between !important;\n  }\n  \n  .justify-content-around {\n    -ms-flex-pack: distribute !important;\n    justify-content: space-around !important;\n  }\n  \n  .align-items-start {\n    -ms-flex-align: start !important;\n    align-items: flex-start !important;\n  }\n  \n  .align-items-end {\n    -ms-flex-align: end !important;\n    align-items: flex-end !important;\n  }\n  \n  .align-items-center {\n    -ms-flex-align: center !important;\n    align-items: center !important;\n  }\n  \n  .align-items-baseline {\n    -ms-flex-align: baseline !important;\n    align-items: baseline !important;\n  }\n  \n  .align-items-stretch {\n    -ms-flex-align: stretch !important;\n    align-items: stretch !important;\n  }\n  \n  .align-content-start {\n    -ms-flex-line-pack: start !important;\n    align-content: flex-start !important;\n  }\n  \n  .align-content-end {\n    -ms-flex-line-pack: end !important;\n    align-content: flex-end !important;\n  }\n  \n  .align-content-center {\n    -ms-flex-line-pack: center !important;\n    align-content: center !important;\n  }\n  \n  .align-content-between {\n    -ms-flex-line-pack: justify !important;\n    align-content: space-between !important;\n  }\n  \n  .align-content-around {\n    -ms-flex-line-pack: distribute !important;\n    align-content: space-around !important;\n  }\n  \n  .align-content-stretch {\n    -ms-flex-line-pack: stretch !important;\n    align-content: stretch !important;\n  }\n  \n  .align-self-auto {\n    -ms-flex-item-align: auto !important;\n    align-self: auto !important;\n  }\n  \n  .align-self-start {\n    -ms-flex-item-align: start !important;\n    align-self: flex-start !important;\n  }\n  \n  .align-self-end {\n    -ms-flex-item-align: end !important;\n    align-self: flex-end !important;\n  }\n  \n  .align-self-center {\n    -ms-flex-item-align: center !important;\n    align-self: center !important;\n  }\n  \n  .align-self-baseline {\n    -ms-flex-item-align: baseline !important;\n    align-self: baseline !important;\n  }\n  \n  .align-self-stretch {\n    -ms-flex-item-align: stretch !important;\n    align-self: stretch !important;\n  }\n  \n  @media (min-width: 576px) {\n    .flex-sm-row {\n      -ms-flex-direction: row !important;\n      flex-direction: row !important;\n    }\n    .flex-sm-column {\n      -ms-flex-direction: column !important;\n      flex-direction: column !important;\n    }\n    .flex-sm-row-reverse {\n      -ms-flex-direction: row-reverse !important;\n      flex-direction: row-reverse !important;\n    }\n    .flex-sm-column-reverse {\n      -ms-flex-direction: column-reverse !important;\n      flex-direction: column-reverse !important;\n    }\n    .flex-sm-wrap {\n      -ms-flex-wrap: wrap !important;\n      flex-wrap: wrap !important;\n    }\n    .flex-sm-nowrap {\n      -ms-flex-wrap: nowrap !important;\n      flex-wrap: nowrap !important;\n    }\n    .flex-sm-wrap-reverse {\n      -ms-flex-wrap: wrap-reverse !important;\n      flex-wrap: wrap-reverse !important;\n    }\n    .flex-sm-fill {\n      -ms-flex: 1 1 auto !important;\n      flex: 1 1 auto !important;\n    }\n    .flex-sm-grow-0 {\n      -ms-flex-positive: 0 !important;\n      flex-grow: 0 !important;\n    }\n    .flex-sm-grow-1 {\n      -ms-flex-positive: 1 !important;\n      flex-grow: 1 !important;\n    }\n    .flex-sm-shrink-0 {\n      -ms-flex-negative: 0 !important;\n      flex-shrink: 0 !important;\n    }\n    .flex-sm-shrink-1 {\n      -ms-flex-negative: 1 !important;\n      flex-shrink: 1 !important;\n    }\n    .justify-content-sm-start {\n      -ms-flex-pack: start !important;\n      justify-content: flex-start !important;\n    }\n    .justify-content-sm-end {\n      -ms-flex-pack: end !important;\n      justify-content: flex-end !important;\n    }\n    .justify-content-sm-center {\n      -ms-flex-pack: center !important;\n      justify-content: center !important;\n    }\n    .justify-content-sm-between {\n      -ms-flex-pack: justify !important;\n      justify-content: space-between !important;\n    }\n    .justify-content-sm-around {\n      -ms-flex-pack: distribute !important;\n      justify-content: space-around !important;\n    }\n    .align-items-sm-start {\n      -ms-flex-align: start !important;\n      align-items: flex-start !important;\n    }\n    .align-items-sm-end {\n      -ms-flex-align: end !important;\n      align-items: flex-end !important;\n    }\n    .align-items-sm-center {\n      -ms-flex-align: center !important;\n      align-items: center !important;\n    }\n    .align-items-sm-baseline {\n      -ms-flex-align: baseline !important;\n      align-items: baseline !important;\n    }\n    .align-items-sm-stretch {\n      -ms-flex-align: stretch !important;\n      align-items: stretch !important;\n    }\n    .align-content-sm-start {\n      -ms-flex-line-pack: start !important;\n      align-content: flex-start !important;\n    }\n    .align-content-sm-end {\n      -ms-flex-line-pack: end !important;\n      align-content: flex-end !important;\n    }\n    .align-content-sm-center {\n      -ms-flex-line-pack: center !important;\n      align-content: center !important;\n    }\n    .align-content-sm-between {\n      -ms-flex-line-pack: justify !important;\n      align-content: space-between !important;\n    }\n    .align-content-sm-around {\n      -ms-flex-line-pack: distribute !important;\n      align-content: space-around !important;\n    }\n    .align-content-sm-stretch {\n      -ms-flex-line-pack: stretch !important;\n      align-content: stretch !important;\n    }\n    .align-self-sm-auto {\n      -ms-flex-item-align: auto !important;\n      align-self: auto !important;\n    }\n    .align-self-sm-start {\n      -ms-flex-item-align: start !important;\n      align-self: flex-start !important;\n    }\n    .align-self-sm-end {\n      -ms-flex-item-align: end !important;\n      align-self: flex-end !important;\n    }\n    .align-self-sm-center {\n      -ms-flex-item-align: center !important;\n      align-self: center !important;\n    }\n    .align-self-sm-baseline {\n      -ms-flex-item-align: baseline !important;\n      align-self: baseline !important;\n    }\n    .align-self-sm-stretch {\n      -ms-flex-item-align: stretch !important;\n      align-self: stretch !important;\n    }\n  }\n  \n  @media (min-width: 768px) {\n    .flex-md-row {\n      -ms-flex-direction: row !important;\n      flex-direction: row !important;\n    }\n    .flex-md-column {\n      -ms-flex-direction: column !important;\n      flex-direction: column !important;\n    }\n    .flex-md-row-reverse {\n      -ms-flex-direction: row-reverse !important;\n      flex-direction: row-reverse !important;\n    }\n    .flex-md-column-reverse {\n      -ms-flex-direction: column-reverse !important;\n      flex-direction: column-reverse !important;\n    }\n    .flex-md-wrap {\n      -ms-flex-wrap: wrap !important;\n      flex-wrap: wrap !important;\n    }\n    .flex-md-nowrap {\n      -ms-flex-wrap: nowrap !important;\n      flex-wrap: nowrap !important;\n    }\n    .flex-md-wrap-reverse {\n      -ms-flex-wrap: wrap-reverse !important;\n      flex-wrap: wrap-reverse !important;\n    }\n    .flex-md-fill {\n      -ms-flex: 1 1 auto !important;\n      flex: 1 1 auto !important;\n    }\n    .flex-md-grow-0 {\n      -ms-flex-positive: 0 !important;\n      flex-grow: 0 !important;\n    }\n    .flex-md-grow-1 {\n      -ms-flex-positive: 1 !important;\n      flex-grow: 1 !important;\n    }\n    .flex-md-shrink-0 {\n      -ms-flex-negative: 0 !important;\n      flex-shrink: 0 !important;\n    }\n    .flex-md-shrink-1 {\n      -ms-flex-negative: 1 !important;\n      flex-shrink: 1 !important;\n    }\n    .justify-content-md-start {\n      -ms-flex-pack: start !important;\n      justify-content: flex-start !important;\n    }\n    .justify-content-md-end {\n      -ms-flex-pack: end !important;\n      justify-content: flex-end !important;\n    }\n    .justify-content-md-center {\n      -ms-flex-pack: center !important;\n      justify-content: center !important;\n    }\n    .justify-content-md-between {\n      -ms-flex-pack: justify !important;\n      justify-content: space-between !important;\n    }\n    .justify-content-md-around {\n      -ms-flex-pack: distribute !important;\n      justify-content: space-around !important;\n    }\n    .align-items-md-start {\n      -ms-flex-align: start !important;\n      align-items: flex-start !important;\n    }\n    .align-items-md-end {\n      -ms-flex-align: end !important;\n      align-items: flex-end !important;\n    }\n    .align-items-md-center {\n      -ms-flex-align: center !important;\n      align-items: center !important;\n    }\n    .align-items-md-baseline {\n      -ms-flex-align: baseline !important;\n      align-items: baseline !important;\n    }\n    .align-items-md-stretch {\n      -ms-flex-align: stretch !important;\n      align-items: stretch !important;\n    }\n    .align-content-md-start {\n      -ms-flex-line-pack: start !important;\n      align-content: flex-start !important;\n    }\n    .align-content-md-end {\n      -ms-flex-line-pack: end !important;\n      align-content: flex-end !important;\n    }\n    .align-content-md-center {\n      -ms-flex-line-pack: center !important;\n      align-content: center !important;\n    }\n    .align-content-md-between {\n      -ms-flex-line-pack: justify !important;\n      align-content: space-between !important;\n    }\n    .align-content-md-around {\n      -ms-flex-line-pack: distribute !important;\n      align-content: space-around !important;\n    }\n    .align-content-md-stretch {\n      -ms-flex-line-pack: stretch !important;\n      align-content: stretch !important;\n    }\n    .align-self-md-auto {\n      -ms-flex-item-align: auto !important;\n      align-self: auto !important;\n    }\n    .align-self-md-start {\n      -ms-flex-item-align: start !important;\n      align-self: flex-start !important;\n    }\n    .align-self-md-end {\n      -ms-flex-item-align: end !important;\n      align-self: flex-end !important;\n    }\n    .align-self-md-center {\n      -ms-flex-item-align: center !important;\n      align-self: center !important;\n    }\n    .align-self-md-baseline {\n      -ms-flex-item-align: baseline !important;\n      align-self: baseline !important;\n    }\n    .align-self-md-stretch {\n      -ms-flex-item-align: stretch !important;\n      align-self: stretch !important;\n    }\n  }\n  \n  @media (min-width: 992px) {\n    .flex-lg-row {\n      -ms-flex-direction: row !important;\n      flex-direction: row !important;\n    }\n    .flex-lg-column {\n      -ms-flex-direction: column !important;\n      flex-direction: column !important;\n    }\n    .flex-lg-row-reverse {\n      -ms-flex-direction: row-reverse !important;\n      flex-direction: row-reverse !important;\n    }\n    .flex-lg-column-reverse {\n      -ms-flex-direction: column-reverse !important;\n      flex-direction: column-reverse !important;\n    }\n    .flex-lg-wrap {\n      -ms-flex-wrap: wrap !important;\n      flex-wrap: wrap !important;\n    }\n    .flex-lg-nowrap {\n      -ms-flex-wrap: nowrap !important;\n      flex-wrap: nowrap !important;\n    }\n    .flex-lg-wrap-reverse {\n      -ms-flex-wrap: wrap-reverse !important;\n      flex-wrap: wrap-reverse !important;\n    }\n    .flex-lg-fill {\n      -ms-flex: 1 1 auto !important;\n      flex: 1 1 auto !important;\n    }\n    .flex-lg-grow-0 {\n      -ms-flex-positive: 0 !important;\n      flex-grow: 0 !important;\n    }\n    .flex-lg-grow-1 {\n      -ms-flex-positive: 1 !important;\n      flex-grow: 1 !important;\n    }\n    .flex-lg-shrink-0 {\n      -ms-flex-negative: 0 !important;\n      flex-shrink: 0 !important;\n    }\n    .flex-lg-shrink-1 {\n      -ms-flex-negative: 1 !important;\n      flex-shrink: 1 !important;\n    }\n    .justify-content-lg-start {\n      -ms-flex-pack: start !important;\n      justify-content: flex-start !important;\n    }\n    .justify-content-lg-end {\n      -ms-flex-pack: end !important;\n      justify-content: flex-end !important;\n    }\n    .justify-content-lg-center {\n      -ms-flex-pack: center !important;\n      justify-content: center !important;\n    }\n    .justify-content-lg-between {\n      -ms-flex-pack: justify !important;\n      justify-content: space-between !important;\n    }\n    .justify-content-lg-around {\n      -ms-flex-pack: distribute !important;\n      justify-content: space-around !important;\n    }\n    .align-items-lg-start {\n      -ms-flex-align: start !important;\n      align-items: flex-start !important;\n    }\n    .align-items-lg-end {\n      -ms-flex-align: end !important;\n      align-items: flex-end !important;\n    }\n    .align-items-lg-center {\n      -ms-flex-align: center !important;\n      align-items: center !important;\n    }\n    .align-items-lg-baseline {\n      -ms-flex-align: baseline !important;\n      align-items: baseline !important;\n    }\n    .align-items-lg-stretch {\n      -ms-flex-align: stretch !important;\n      align-items: stretch !important;\n    }\n    .align-content-lg-start {\n      -ms-flex-line-pack: start !important;\n      align-content: flex-start !important;\n    }\n    .align-content-lg-end {\n      -ms-flex-line-pack: end !important;\n      align-content: flex-end !important;\n    }\n    .align-content-lg-center {\n      -ms-flex-line-pack: center !important;\n      align-content: center !important;\n    }\n    .align-content-lg-between {\n      -ms-flex-line-pack: justify !important;\n      align-content: space-between !important;\n    }\n    .align-content-lg-around {\n      -ms-flex-line-pack: distribute !important;\n      align-content: space-around !important;\n    }\n    .align-content-lg-stretch {\n      -ms-flex-line-pack: stretch !important;\n      align-content: stretch !important;\n    }\n    .align-self-lg-auto {\n      -ms-flex-item-align: auto !important;\n      align-self: auto !important;\n    }\n    .align-self-lg-start {\n      -ms-flex-item-align: start !important;\n      align-self: flex-start !important;\n    }\n    .align-self-lg-end {\n      -ms-flex-item-align: end !important;\n      align-self: flex-end !important;\n    }\n    .align-self-lg-center {\n      -ms-flex-item-align: center !important;\n      align-self: center !important;\n    }\n    .align-self-lg-baseline {\n      -ms-flex-item-align: baseline !important;\n      align-self: baseline !important;\n    }\n    .align-self-lg-stretch {\n      -ms-flex-item-align: stretch !important;\n      align-self: stretch !important;\n    }\n  }\n  \n  @media (min-width: 1200px) {\n    .flex-xl-row {\n      -ms-flex-direction: row !important;\n      flex-direction: row !important;\n    }\n    .flex-xl-column {\n      -ms-flex-direction: column !important;\n      flex-direction: column !important;\n    }\n    .flex-xl-row-reverse {\n      -ms-flex-direction: row-reverse !important;\n      flex-direction: row-reverse !important;\n    }\n    .flex-xl-column-reverse {\n      -ms-flex-direction: column-reverse !important;\n      flex-direction: column-reverse !important;\n    }\n    .flex-xl-wrap {\n      -ms-flex-wrap: wrap !important;\n      flex-wrap: wrap !important;\n    }\n    .flex-xl-nowrap {\n      -ms-flex-wrap: nowrap !important;\n      flex-wrap: nowrap !important;\n    }\n    .flex-xl-wrap-reverse {\n      -ms-flex-wrap: wrap-reverse !important;\n      flex-wrap: wrap-reverse !important;\n    }\n    .flex-xl-fill {\n      -ms-flex: 1 1 auto !important;\n      flex: 1 1 auto !important;\n    }\n    .flex-xl-grow-0 {\n      -ms-flex-positive: 0 !important;\n      flex-grow: 0 !important;\n    }\n    .flex-xl-grow-1 {\n      -ms-flex-positive: 1 !important;\n      flex-grow: 1 !important;\n    }\n    .flex-xl-shrink-0 {\n      -ms-flex-negative: 0 !important;\n      flex-shrink: 0 !important;\n    }\n    .flex-xl-shrink-1 {\n      -ms-flex-negative: 1 !important;\n      flex-shrink: 1 !important;\n    }\n    .justify-content-xl-start {\n      -ms-flex-pack: start !important;\n      justify-content: flex-start !important;\n    }\n    .justify-content-xl-end {\n      -ms-flex-pack: end !important;\n      justify-content: flex-end !important;\n    }\n    .justify-content-xl-center {\n      -ms-flex-pack: center !important;\n      justify-content: center !important;\n    }\n    .justify-content-xl-between {\n      -ms-flex-pack: justify !important;\n      justify-content: space-between !important;\n    }\n    .justify-content-xl-around {\n      -ms-flex-pack: distribute !important;\n      justify-content: space-around !important;\n    }\n    .align-items-xl-start {\n      -ms-flex-align: start !important;\n      align-items: flex-start !important;\n    }\n    .align-items-xl-end {\n      -ms-flex-align: end !important;\n      align-items: flex-end !important;\n    }\n    .align-items-xl-center {\n      -ms-flex-align: center !important;\n      align-items: center !important;\n    }\n    .align-items-xl-baseline {\n      -ms-flex-align: baseline !important;\n      align-items: baseline !important;\n    }\n    .align-items-xl-stretch {\n      -ms-flex-align: stretch !important;\n      align-items: stretch !important;\n    }\n    .align-content-xl-start {\n      -ms-flex-line-pack: start !important;\n      align-content: flex-start !important;\n    }\n    .align-content-xl-end {\n      -ms-flex-line-pack: end !important;\n      align-content: flex-end !important;\n    }\n    .align-content-xl-center {\n      -ms-flex-line-pack: center !important;\n      align-content: center !important;\n    }\n    .align-content-xl-between {\n      -ms-flex-line-pack: justify !important;\n      align-content: space-between !important;\n    }\n    .align-content-xl-around {\n      -ms-flex-line-pack: distribute !important;\n      align-content: space-around !important;\n    }\n    .align-content-xl-stretch {\n      -ms-flex-line-pack: stretch !important;\n      align-content: stretch !important;\n    }\n    .align-self-xl-auto {\n      -ms-flex-item-align: auto !important;\n      align-self: auto !important;\n    }\n    .align-self-xl-start {\n      -ms-flex-item-align: start !important;\n      align-self: flex-start !important;\n    }\n    .align-self-xl-end {\n      -ms-flex-item-align: end !important;\n      align-self: flex-end !important;\n    }\n    .align-self-xl-center {\n      -ms-flex-item-align: center !important;\n      align-self: center !important;\n    }\n    .align-self-xl-baseline {\n      -ms-flex-item-align: baseline !important;\n      align-self: baseline !important;\n    }\n    .align-self-xl-stretch {\n      -ms-flex-item-align: stretch !important;\n      align-self: stretch !important;\n    }\n  }\n  \n  .m-0 {\n    margin: 0 !important;\n  }\n  \n  .mt-0,\n  .my-0 {\n    margin-top: 0 !important;\n  }\n  \n  .mr-0,\n  .mx-0 {\n    margin-right: 0 !important;\n  }\n  \n  .mb-0,\n  .my-0 {\n    margin-bottom: 0 !important;\n  }\n  \n  .ml-0,\n  .mx-0 {\n    margin-left: 0 !important;\n  }\n  \n  .m-1 {\n    margin: 0.25rem !important;\n  }\n  \n  .mt-1,\n  .my-1 {\n    margin-top: 0.25rem !important;\n  }\n  \n  .mr-1,\n  .mx-1 {\n    margin-right: 0.25rem !important;\n  }\n  \n  .mb-1,\n  .my-1 {\n    margin-bottom: 0.25rem !important;\n  }\n  \n  .ml-1,\n  .mx-1 {\n    margin-left: 0.25rem !important;\n  }\n  \n  .m-2 {\n    margin: 0.5rem !important;\n  }\n  \n  .mt-2,\n  .my-2 {\n    margin-top: 0.5rem !important;\n  }\n  \n  .mr-2,\n  .mx-2 {\n    margin-right: 0.5rem !important;\n  }\n  \n  .mb-2,\n  .my-2 {\n    margin-bottom: 0.5rem !important;\n  }\n  \n  .ml-2,\n  .mx-2 {\n    margin-left: 0.5rem !important;\n  }\n  \n  .m-3 {\n    margin: 1rem !important;\n  }\n  \n  .mt-3,\n  .my-3 {\n    margin-top: 1rem !important;\n  }\n  \n  .mr-3,\n  .mx-3 {\n    margin-right: 1rem !important;\n  }\n  \n  .mb-3,\n  .my-3 {\n    margin-bottom: 1rem !important;\n  }\n  \n  .ml-3,\n  .mx-3 {\n    margin-left: 1rem !important;\n  }\n  \n  .m-4 {\n    margin: 1.5rem !important;\n  }\n  \n  .mt-4,\n  .my-4 {\n    margin-top: 1.5rem !important;\n  }\n  \n  .mr-4,\n  .mx-4 {\n    margin-right: 1.5rem !important;\n  }\n  \n  .mb-4,\n  .my-4 {\n    margin-bottom: 1.5rem !important;\n  }\n  \n  .ml-4,\n  .mx-4 {\n    margin-left: 1.5rem !important;\n  }\n  \n  .m-5 {\n    margin: 3rem !important;\n  }\n  \n  .mt-5,\n  .my-5 {\n    margin-top: 3rem !important;\n  }\n  \n  .mr-5,\n  .mx-5 {\n    margin-right: 3rem !important;\n  }\n  \n  .mb-5,\n  .my-5 {\n    margin-bottom: 3rem !important;\n  }\n  \n  .ml-5,\n  .mx-5 {\n    margin-left: 3rem !important;\n  }\n  \n  .p-0 {\n    padding: 0 !important;\n  }\n  \n  .pt-0,\n  .py-0 {\n    padding-top: 0 !important;\n  }\n  \n  .pr-0,\n  .px-0 {\n    padding-right: 0 !important;\n  }\n  \n  .pb-0,\n  .py-0 {\n    padding-bottom: 0 !important;\n  }\n  \n  .pl-0,\n  .px-0 {\n    padding-left: 0 !important;\n  }\n  \n  .p-1 {\n    padding: 0.25rem !important;\n  }\n  \n  .pt-1,\n  .py-1 {\n    padding-top: 0.25rem !important;\n  }\n  \n  .pr-1,\n  .px-1 {\n    padding-right: 0.25rem !important;\n  }\n  \n  .pb-1,\n  .py-1 {\n    padding-bottom: 0.25rem !important;\n  }\n  \n  .pl-1,\n  .px-1 {\n    padding-left: 0.25rem !important;\n  }\n  \n  .p-2 {\n    padding: 0.5rem !important;\n  }\n  \n  .pt-2,\n  .py-2 {\n    padding-top: 0.5rem !important;\n  }\n  \n  .pr-2,\n  .px-2 {\n    padding-right: 0.5rem !important;\n  }\n  \n  .pb-2,\n  .py-2 {\n    padding-bottom: 0.5rem !important;\n  }\n  \n  .pl-2,\n  .px-2 {\n    padding-left: 0.5rem !important;\n  }\n  \n  .p-3 {\n    padding: 1rem !important;\n  }\n  \n  .pt-3,\n  .py-3 {\n    padding-top: 1rem !important;\n  }\n  \n  .pr-3,\n  .px-3 {\n    padding-right: 1rem !important;\n  }\n  \n  .pb-3,\n  .py-3 {\n    padding-bottom: 1rem !important;\n  }\n  \n  .pl-3,\n  .px-3 {\n    padding-left: 1rem !important;\n  }\n  \n  .p-4 {\n    padding: 1.5rem !important;\n  }\n  \n  .pt-4,\n  .py-4 {\n    padding-top: 1.5rem !important;\n  }\n  \n  .pr-4,\n  .px-4 {\n    padding-right: 1.5rem !important;\n  }\n  \n  .pb-4,\n  .py-4 {\n    padding-bottom: 1.5rem !important;\n  }\n  \n  .pl-4,\n  .px-4 {\n    padding-left: 1.5rem !important;\n  }\n  \n  .p-5 {\n    padding: 3rem !important;\n  }\n  \n  .pt-5,\n  .py-5 {\n    padding-top: 3rem !important;\n  }\n  \n  .pr-5,\n  .px-5 {\n    padding-right: 3rem !important;\n  }\n  \n  .pb-5,\n  .py-5 {\n    padding-bottom: 3rem !important;\n  }\n  \n  .pl-5,\n  .px-5 {\n    padding-left: 3rem !important;\n  }\n  \n  .m-n1 {\n    margin: -0.25rem !important;\n  }\n  \n  .mt-n1,\n  .my-n1 {\n    margin-top: -0.25rem !important;\n  }\n  \n  .mr-n1,\n  .mx-n1 {\n    margin-right: -0.25rem !important;\n  }\n  \n  .mb-n1,\n  .my-n1 {\n    margin-bottom: -0.25rem !important;\n  }\n  \n  .ml-n1,\n  .mx-n1 {\n    margin-left: -0.25rem !important;\n  }\n  \n  .m-n2 {\n    margin: -0.5rem !important;\n  }\n  \n  .mt-n2,\n  .my-n2 {\n    margin-top: -0.5rem !important;\n  }\n  \n  .mr-n2,\n  .mx-n2 {\n    margin-right: -0.5rem !important;\n  }\n  \n  .mb-n2,\n  .my-n2 {\n    margin-bottom: -0.5rem !important;\n  }\n  \n  .ml-n2,\n  .mx-n2 {\n    margin-left: -0.5rem !important;\n  }\n  \n  .m-n3 {\n    margin: -1rem !important;\n  }\n  \n  .mt-n3,\n  .my-n3 {\n    margin-top: -1rem !important;\n  }\n  \n  .mr-n3,\n  .mx-n3 {\n    margin-right: -1rem !important;\n  }\n  \n  .mb-n3,\n  .my-n3 {\n    margin-bottom: -1rem !important;\n  }\n  \n  .ml-n3,\n  .mx-n3 {\n    margin-left: -1rem !important;\n  }\n  \n  .m-n4 {\n    margin: -1.5rem !important;\n  }\n  \n  .mt-n4,\n  .my-n4 {\n    margin-top: -1.5rem !important;\n  }\n  \n  .mr-n4,\n  .mx-n4 {\n    margin-right: -1.5rem !important;\n  }\n  \n  .mb-n4,\n  .my-n4 {\n    margin-bottom: -1.5rem !important;\n  }\n  \n  .ml-n4,\n  .mx-n4 {\n    margin-left: -1.5rem !important;\n  }\n  \n  .m-n5 {\n    margin: -3rem !important;\n  }\n  \n  .mt-n5,\n  .my-n5 {\n    margin-top: -3rem !important;\n  }\n  \n  .mr-n5,\n  .mx-n5 {\n    margin-right: -3rem !important;\n  }\n  \n  .mb-n5,\n  .my-n5 {\n    margin-bottom: -3rem !important;\n  }\n  \n  .ml-n5,\n  .mx-n5 {\n    margin-left: -3rem !important;\n  }\n  \n  .m-auto {\n    margin: auto !important;\n  }\n  \n  .mt-auto,\n  .my-auto {\n    margin-top: auto !important;\n  }\n  \n  .mr-auto,\n  .mx-auto {\n    margin-right: auto !important;\n  }\n  \n  .mb-auto,\n  .my-auto {\n    margin-bottom: auto !important;\n  }\n  \n  .ml-auto,\n  .mx-auto {\n    margin-left: auto !important;\n  }\n  \n  @media (min-width: 576px) {\n    .m-sm-0 {\n      margin: 0 !important;\n    }\n    .mt-sm-0,\n    .my-sm-0 {\n      margin-top: 0 !important;\n    }\n    .mr-sm-0,\n    .mx-sm-0 {\n      margin-right: 0 !important;\n    }\n    .mb-sm-0,\n    .my-sm-0 {\n      margin-bottom: 0 !important;\n    }\n    .ml-sm-0,\n    .mx-sm-0 {\n      margin-left: 0 !important;\n    }\n    .m-sm-1 {\n      margin: 0.25rem !important;\n    }\n    .mt-sm-1,\n    .my-sm-1 {\n      margin-top: 0.25rem !important;\n    }\n    .mr-sm-1,\n    .mx-sm-1 {\n      margin-right: 0.25rem !important;\n    }\n    .mb-sm-1,\n    .my-sm-1 {\n      margin-bottom: 0.25rem !important;\n    }\n    .ml-sm-1,\n    .mx-sm-1 {\n      margin-left: 0.25rem !important;\n    }\n    .m-sm-2 {\n      margin: 0.5rem !important;\n    }\n    .mt-sm-2,\n    .my-sm-2 {\n      margin-top: 0.5rem !important;\n    }\n    .mr-sm-2,\n    .mx-sm-2 {\n      margin-right: 0.5rem !important;\n    }\n    .mb-sm-2,\n    .my-sm-2 {\n      margin-bottom: 0.5rem !important;\n    }\n    .ml-sm-2,\n    .mx-sm-2 {\n      margin-left: 0.5rem !important;\n    }\n    .m-sm-3 {\n      margin: 1rem !important;\n    }\n    .mt-sm-3,\n    .my-sm-3 {\n      margin-top: 1rem !important;\n    }\n    .mr-sm-3,\n    .mx-sm-3 {\n      margin-right: 1rem !important;\n    }\n    .mb-sm-3,\n    .my-sm-3 {\n      margin-bottom: 1rem !important;\n    }\n    .ml-sm-3,\n    .mx-sm-3 {\n      margin-left: 1rem !important;\n    }\n    .m-sm-4 {\n      margin: 1.5rem !important;\n    }\n    .mt-sm-4,\n    .my-sm-4 {\n      margin-top: 1.5rem !important;\n    }\n    .mr-sm-4,\n    .mx-sm-4 {\n      margin-right: 1.5rem !important;\n    }\n    .mb-sm-4,\n    .my-sm-4 {\n      margin-bottom: 1.5rem !important;\n    }\n    .ml-sm-4,\n    .mx-sm-4 {\n      margin-left: 1.5rem !important;\n    }\n    .m-sm-5 {\n      margin: 3rem !important;\n    }\n    .mt-sm-5,\n    .my-sm-5 {\n      margin-top: 3rem !important;\n    }\n    .mr-sm-5,\n    .mx-sm-5 {\n      margin-right: 3rem !important;\n    }\n    .mb-sm-5,\n    .my-sm-5 {\n      margin-bottom: 3rem !important;\n    }\n    .ml-sm-5,\n    .mx-sm-5 {\n      margin-left: 3rem !important;\n    }\n    .p-sm-0 {\n      padding: 0 !important;\n    }\n    .pt-sm-0,\n    .py-sm-0 {\n      padding-top: 0 !important;\n    }\n    .pr-sm-0,\n    .px-sm-0 {\n      padding-right: 0 !important;\n    }\n    .pb-sm-0,\n    .py-sm-0 {\n      padding-bottom: 0 !important;\n    }\n    .pl-sm-0,\n    .px-sm-0 {\n      padding-left: 0 !important;\n    }\n    .p-sm-1 {\n      padding: 0.25rem !important;\n    }\n    .pt-sm-1,\n    .py-sm-1 {\n      padding-top: 0.25rem !important;\n    }\n    .pr-sm-1,\n    .px-sm-1 {\n      padding-right: 0.25rem !important;\n    }\n    .pb-sm-1,\n    .py-sm-1 {\n      padding-bottom: 0.25rem !important;\n    }\n    .pl-sm-1,\n    .px-sm-1 {\n      padding-left: 0.25rem !important;\n    }\n    .p-sm-2 {\n      padding: 0.5rem !important;\n    }\n    .pt-sm-2,\n    .py-sm-2 {\n      padding-top: 0.5rem !important;\n    }\n    .pr-sm-2,\n    .px-sm-2 {\n      padding-right: 0.5rem !important;\n    }\n    .pb-sm-2,\n    .py-sm-2 {\n      padding-bottom: 0.5rem !important;\n    }\n    .pl-sm-2,\n    .px-sm-2 {\n      padding-left: 0.5rem !important;\n    }\n    .p-sm-3 {\n      padding: 1rem !important;\n    }\n    .pt-sm-3,\n    .py-sm-3 {\n      padding-top: 1rem !important;\n    }\n    .pr-sm-3,\n    .px-sm-3 {\n      padding-right: 1rem !important;\n    }\n    .pb-sm-3,\n    .py-sm-3 {\n      padding-bottom: 1rem !important;\n    }\n    .pl-sm-3,\n    .px-sm-3 {\n      padding-left: 1rem !important;\n    }\n    .p-sm-4 {\n      padding: 1.5rem !important;\n    }\n    .pt-sm-4,\n    .py-sm-4 {\n      padding-top: 1.5rem !important;\n    }\n    .pr-sm-4,\n    .px-sm-4 {\n      padding-right: 1.5rem !important;\n    }\n    .pb-sm-4,\n    .py-sm-4 {\n      padding-bottom: 1.5rem !important;\n    }\n    .pl-sm-4,\n    .px-sm-4 {\n      padding-left: 1.5rem !important;\n    }\n    .p-sm-5 {\n      padding: 3rem !important;\n    }\n    .pt-sm-5,\n    .py-sm-5 {\n      padding-top: 3rem !important;\n    }\n    .pr-sm-5,\n    .px-sm-5 {\n      padding-right: 3rem !important;\n    }\n    .pb-sm-5,\n    .py-sm-5 {\n      padding-bottom: 3rem !important;\n    }\n    .pl-sm-5,\n    .px-sm-5 {\n      padding-left: 3rem !important;\n    }\n    .m-sm-n1 {\n      margin: -0.25rem !important;\n    }\n    .mt-sm-n1,\n    .my-sm-n1 {\n      margin-top: -0.25rem !important;\n    }\n    .mr-sm-n1,\n    .mx-sm-n1 {\n      margin-right: -0.25rem !important;\n    }\n    .mb-sm-n1,\n    .my-sm-n1 {\n      margin-bottom: -0.25rem !important;\n    }\n    .ml-sm-n1,\n    .mx-sm-n1 {\n      margin-left: -0.25rem !important;\n    }\n    .m-sm-n2 {\n      margin: -0.5rem !important;\n    }\n    .mt-sm-n2,\n    .my-sm-n2 {\n      margin-top: -0.5rem !important;\n    }\n    .mr-sm-n2,\n    .mx-sm-n2 {\n      margin-right: -0.5rem !important;\n    }\n    .mb-sm-n2,\n    .my-sm-n2 {\n      margin-bottom: -0.5rem !important;\n    }\n    .ml-sm-n2,\n    .mx-sm-n2 {\n      margin-left: -0.5rem !important;\n    }\n    .m-sm-n3 {\n      margin: -1rem !important;\n    }\n    .mt-sm-n3,\n    .my-sm-n3 {\n      margin-top: -1rem !important;\n    }\n    .mr-sm-n3,\n    .mx-sm-n3 {\n      margin-right: -1rem !important;\n    }\n    .mb-sm-n3,\n    .my-sm-n3 {\n      margin-bottom: -1rem !important;\n    }\n    .ml-sm-n3,\n    .mx-sm-n3 {\n      margin-left: -1rem !important;\n    }\n    .m-sm-n4 {\n      margin: -1.5rem !important;\n    }\n    .mt-sm-n4,\n    .my-sm-n4 {\n      margin-top: -1.5rem !important;\n    }\n    .mr-sm-n4,\n    .mx-sm-n4 {\n      margin-right: -1.5rem !important;\n    }\n    .mb-sm-n4,\n    .my-sm-n4 {\n      margin-bottom: -1.5rem !important;\n    }\n    .ml-sm-n4,\n    .mx-sm-n4 {\n      margin-left: -1.5rem !important;\n    }\n    .m-sm-n5 {\n      margin: -3rem !important;\n    }\n    .mt-sm-n5,\n    .my-sm-n5 {\n      margin-top: -3rem !important;\n    }\n    .mr-sm-n5,\n    .mx-sm-n5 {\n      margin-right: -3rem !important;\n    }\n    .mb-sm-n5,\n    .my-sm-n5 {\n      margin-bottom: -3rem !important;\n    }\n    .ml-sm-n5,\n    .mx-sm-n5 {\n      margin-left: -3rem !important;\n    }\n    .m-sm-auto {\n      margin: auto !important;\n    }\n    .mt-sm-auto,\n    .my-sm-auto {\n      margin-top: auto !important;\n    }\n    .mr-sm-auto,\n    .mx-sm-auto {\n      margin-right: auto !important;\n    }\n    .mb-sm-auto,\n    .my-sm-auto {\n      margin-bottom: auto !important;\n    }\n    .ml-sm-auto,\n    .mx-sm-auto {\n      margin-left: auto !important;\n    }\n  }\n  \n  @media (min-width: 768px) {\n    .m-md-0 {\n      margin: 0 !important;\n    }\n    .mt-md-0,\n    .my-md-0 {\n      margin-top: 0 !important;\n    }\n    .mr-md-0,\n    .mx-md-0 {\n      margin-right: 0 !important;\n    }\n    .mb-md-0,\n    .my-md-0 {\n      margin-bottom: 0 !important;\n    }\n    .ml-md-0,\n    .mx-md-0 {\n      margin-left: 0 !important;\n    }\n    .m-md-1 {\n      margin: 0.25rem !important;\n    }\n    .mt-md-1,\n    .my-md-1 {\n      margin-top: 0.25rem !important;\n    }\n    .mr-md-1,\n    .mx-md-1 {\n      margin-right: 0.25rem !important;\n    }\n    .mb-md-1,\n    .my-md-1 {\n      margin-bottom: 0.25rem !important;\n    }\n    .ml-md-1,\n    .mx-md-1 {\n      margin-left: 0.25rem !important;\n    }\n    .m-md-2 {\n      margin: 0.5rem !important;\n    }\n    .mt-md-2,\n    .my-md-2 {\n      margin-top: 0.5rem !important;\n    }\n    .mr-md-2,\n    .mx-md-2 {\n      margin-right: 0.5rem !important;\n    }\n    .mb-md-2,\n    .my-md-2 {\n      margin-bottom: 0.5rem !important;\n    }\n    .ml-md-2,\n    .mx-md-2 {\n      margin-left: 0.5rem !important;\n    }\n    .m-md-3 {\n      margin: 1rem !important;\n    }\n    .mt-md-3,\n    .my-md-3 {\n      margin-top: 1rem !important;\n    }\n    .mr-md-3,\n    .mx-md-3 {\n      margin-right: 1rem !important;\n    }\n    .mb-md-3,\n    .my-md-3 {\n      margin-bottom: 1rem !important;\n    }\n    .ml-md-3,\n    .mx-md-3 {\n      margin-left: 1rem !important;\n    }\n    .m-md-4 {\n      margin: 1.5rem !important;\n    }\n    .mt-md-4,\n    .my-md-4 {\n      margin-top: 1.5rem !important;\n    }\n    .mr-md-4,\n    .mx-md-4 {\n      margin-right: 1.5rem !important;\n    }\n    .mb-md-4,\n    .my-md-4 {\n      margin-bottom: 1.5rem !important;\n    }\n    .ml-md-4,\n    .mx-md-4 {\n      margin-left: 1.5rem !important;\n    }\n    .m-md-5 {\n      margin: 3rem !important;\n    }\n    .mt-md-5,\n    .my-md-5 {\n      margin-top: 3rem !important;\n    }\n    .mr-md-5,\n    .mx-md-5 {\n      margin-right: 3rem !important;\n    }\n    .mb-md-5,\n    .my-md-5 {\n      margin-bottom: 3rem !important;\n    }\n    .ml-md-5,\n    .mx-md-5 {\n      margin-left: 3rem !important;\n    }\n    .p-md-0 {\n      padding: 0 !important;\n    }\n    .pt-md-0,\n    .py-md-0 {\n      padding-top: 0 !important;\n    }\n    .pr-md-0,\n    .px-md-0 {\n      padding-right: 0 !important;\n    }\n    .pb-md-0,\n    .py-md-0 {\n      padding-bottom: 0 !important;\n    }\n    .pl-md-0,\n    .px-md-0 {\n      padding-left: 0 !important;\n    }\n    .p-md-1 {\n      padding: 0.25rem !important;\n    }\n    .pt-md-1,\n    .py-md-1 {\n      padding-top: 0.25rem !important;\n    }\n    .pr-md-1,\n    .px-md-1 {\n      padding-right: 0.25rem !important;\n    }\n    .pb-md-1,\n    .py-md-1 {\n      padding-bottom: 0.25rem !important;\n    }\n    .pl-md-1,\n    .px-md-1 {\n      padding-left: 0.25rem !important;\n    }\n    .p-md-2 {\n      padding: 0.5rem !important;\n    }\n    .pt-md-2,\n    .py-md-2 {\n      padding-top: 0.5rem !important;\n    }\n    .pr-md-2,\n    .px-md-2 {\n      padding-right: 0.5rem !important;\n    }\n    .pb-md-2,\n    .py-md-2 {\n      padding-bottom: 0.5rem !important;\n    }\n    .pl-md-2,\n    .px-md-2 {\n      padding-left: 0.5rem !important;\n    }\n    .p-md-3 {\n      padding: 1rem !important;\n    }\n    .pt-md-3,\n    .py-md-3 {\n      padding-top: 1rem !important;\n    }\n    .pr-md-3,\n    .px-md-3 {\n      padding-right: 1rem !important;\n    }\n    .pb-md-3,\n    .py-md-3 {\n      padding-bottom: 1rem !important;\n    }\n    .pl-md-3,\n    .px-md-3 {\n      padding-left: 1rem !important;\n    }\n    .p-md-4 {\n      padding: 1.5rem !important;\n    }\n    .pt-md-4,\n    .py-md-4 {\n      padding-top: 1.5rem !important;\n    }\n    .pr-md-4,\n    .px-md-4 {\n      padding-right: 1.5rem !important;\n    }\n    .pb-md-4,\n    .py-md-4 {\n      padding-bottom: 1.5rem !important;\n    }\n    .pl-md-4,\n    .px-md-4 {\n      padding-left: 1.5rem !important;\n    }\n    .p-md-5 {\n      padding: 3rem !important;\n    }\n    .pt-md-5,\n    .py-md-5 {\n      padding-top: 3rem !important;\n    }\n    .pr-md-5,\n    .px-md-5 {\n      padding-right: 3rem !important;\n    }\n    .pb-md-5,\n    .py-md-5 {\n      padding-bottom: 3rem !important;\n    }\n    .pl-md-5,\n    .px-md-5 {\n      padding-left: 3rem !important;\n    }\n    .m-md-n1 {\n      margin: -0.25rem !important;\n    }\n    .mt-md-n1,\n    .my-md-n1 {\n      margin-top: -0.25rem !important;\n    }\n    .mr-md-n1,\n    .mx-md-n1 {\n      margin-right: -0.25rem !important;\n    }\n    .mb-md-n1,\n    .my-md-n1 {\n      margin-bottom: -0.25rem !important;\n    }\n    .ml-md-n1,\n    .mx-md-n1 {\n      margin-left: -0.25rem !important;\n    }\n    .m-md-n2 {\n      margin: -0.5rem !important;\n    }\n    .mt-md-n2,\n    .my-md-n2 {\n      margin-top: -0.5rem !important;\n    }\n    .mr-md-n2,\n    .mx-md-n2 {\n      margin-right: -0.5rem !important;\n    }\n    .mb-md-n2,\n    .my-md-n2 {\n      margin-bottom: -0.5rem !important;\n    }\n    .ml-md-n2,\n    .mx-md-n2 {\n      margin-left: -0.5rem !important;\n    }\n    .m-md-n3 {\n      margin: -1rem !important;\n    }\n    .mt-md-n3,\n    .my-md-n3 {\n      margin-top: -1rem !important;\n    }\n    .mr-md-n3,\n    .mx-md-n3 {\n      margin-right: -1rem !important;\n    }\n    .mb-md-n3,\n    .my-md-n3 {\n      margin-bottom: -1rem !important;\n    }\n    .ml-md-n3,\n    .mx-md-n3 {\n      margin-left: -1rem !important;\n    }\n    .m-md-n4 {\n      margin: -1.5rem !important;\n    }\n    .mt-md-n4,\n    .my-md-n4 {\n      margin-top: -1.5rem !important;\n    }\n    .mr-md-n4,\n    .mx-md-n4 {\n      margin-right: -1.5rem !important;\n    }\n    .mb-md-n4,\n    .my-md-n4 {\n      margin-bottom: -1.5rem !important;\n    }\n    .ml-md-n4,\n    .mx-md-n4 {\n      margin-left: -1.5rem !important;\n    }\n    .m-md-n5 {\n      margin: -3rem !important;\n    }\n    .mt-md-n5,\n    .my-md-n5 {\n      margin-top: -3rem !important;\n    }\n    .mr-md-n5,\n    .mx-md-n5 {\n      margin-right: -3rem !important;\n    }\n    .mb-md-n5,\n    .my-md-n5 {\n      margin-bottom: -3rem !important;\n    }\n    .ml-md-n5,\n    .mx-md-n5 {\n      margin-left: -3rem !important;\n    }\n    .m-md-auto {\n      margin: auto !important;\n    }\n    .mt-md-auto,\n    .my-md-auto {\n      margin-top: auto !important;\n    }\n    .mr-md-auto,\n    .mx-md-auto {\n      margin-right: auto !important;\n    }\n    .mb-md-auto,\n    .my-md-auto {\n      margin-bottom: auto !important;\n    }\n    .ml-md-auto,\n    .mx-md-auto {\n      margin-left: auto !important;\n    }\n  }\n  \n  @media (min-width: 992px) {\n    .m-lg-0 {\n      margin: 0 !important;\n    }\n    .mt-lg-0,\n    .my-lg-0 {\n      margin-top: 0 !important;\n    }\n    .mr-lg-0,\n    .mx-lg-0 {\n      margin-right: 0 !important;\n    }\n    .mb-lg-0,\n    .my-lg-0 {\n      margin-bottom: 0 !important;\n    }\n    .ml-lg-0,\n    .mx-lg-0 {\n      margin-left: 0 !important;\n    }\n    .m-lg-1 {\n      margin: 0.25rem !important;\n    }\n    .mt-lg-1,\n    .my-lg-1 {\n      margin-top: 0.25rem !important;\n    }\n    .mr-lg-1,\n    .mx-lg-1 {\n      margin-right: 0.25rem !important;\n    }\n    .mb-lg-1,\n    .my-lg-1 {\n      margin-bottom: 0.25rem !important;\n    }\n    .ml-lg-1,\n    .mx-lg-1 {\n      margin-left: 0.25rem !important;\n    }\n    .m-lg-2 {\n      margin: 0.5rem !important;\n    }\n    .mt-lg-2,\n    .my-lg-2 {\n      margin-top: 0.5rem !important;\n    }\n    .mr-lg-2,\n    .mx-lg-2 {\n      margin-right: 0.5rem !important;\n    }\n    .mb-lg-2,\n    .my-lg-2 {\n      margin-bottom: 0.5rem !important;\n    }\n    .ml-lg-2,\n    .mx-lg-2 {\n      margin-left: 0.5rem !important;\n    }\n    .m-lg-3 {\n      margin: 1rem !important;\n    }\n    .mt-lg-3,\n    .my-lg-3 {\n      margin-top: 1rem !important;\n    }\n    .mr-lg-3,\n    .mx-lg-3 {\n      margin-right: 1rem !important;\n    }\n    .mb-lg-3,\n    .my-lg-3 {\n      margin-bottom: 1rem !important;\n    }\n    .ml-lg-3,\n    .mx-lg-3 {\n      margin-left: 1rem !important;\n    }\n    .m-lg-4 {\n      margin: 1.5rem !important;\n    }\n    .mt-lg-4,\n    .my-lg-4 {\n      margin-top: 1.5rem !important;\n    }\n    .mr-lg-4,\n    .mx-lg-4 {\n      margin-right: 1.5rem !important;\n    }\n    .mb-lg-4,\n    .my-lg-4 {\n      margin-bottom: 1.5rem !important;\n    }\n    .ml-lg-4,\n    .mx-lg-4 {\n      margin-left: 1.5rem !important;\n    }\n    .m-lg-5 {\n      margin: 3rem !important;\n    }\n    .mt-lg-5,\n    .my-lg-5 {\n      margin-top: 3rem !important;\n    }\n    .mr-lg-5,\n    .mx-lg-5 {\n      margin-right: 3rem !important;\n    }\n    .mb-lg-5,\n    .my-lg-5 {\n      margin-bottom: 3rem !important;\n    }\n    .ml-lg-5,\n    .mx-lg-5 {\n      margin-left: 3rem !important;\n    }\n    .p-lg-0 {\n      padding: 0 !important;\n    }\n    .pt-lg-0,\n    .py-lg-0 {\n      padding-top: 0 !important;\n    }\n    .pr-lg-0,\n    .px-lg-0 {\n      padding-right: 0 !important;\n    }\n    .pb-lg-0,\n    .py-lg-0 {\n      padding-bottom: 0 !important;\n    }\n    .pl-lg-0,\n    .px-lg-0 {\n      padding-left: 0 !important;\n    }\n    .p-lg-1 {\n      padding: 0.25rem !important;\n    }\n    .pt-lg-1,\n    .py-lg-1 {\n      padding-top: 0.25rem !important;\n    }\n    .pr-lg-1,\n    .px-lg-1 {\n      padding-right: 0.25rem !important;\n    }\n    .pb-lg-1,\n    .py-lg-1 {\n      padding-bottom: 0.25rem !important;\n    }\n    .pl-lg-1,\n    .px-lg-1 {\n      padding-left: 0.25rem !important;\n    }\n    .p-lg-2 {\n      padding: 0.5rem !important;\n    }\n    .pt-lg-2,\n    .py-lg-2 {\n      padding-top: 0.5rem !important;\n    }\n    .pr-lg-2,\n    .px-lg-2 {\n      padding-right: 0.5rem !important;\n    }\n    .pb-lg-2,\n    .py-lg-2 {\n      padding-bottom: 0.5rem !important;\n    }\n    .pl-lg-2,\n    .px-lg-2 {\n      padding-left: 0.5rem !important;\n    }\n    .p-lg-3 {\n      padding: 1rem !important;\n    }\n    .pt-lg-3,\n    .py-lg-3 {\n      padding-top: 1rem !important;\n    }\n    .pr-lg-3,\n    .px-lg-3 {\n      padding-right: 1rem !important;\n    }\n    .pb-lg-3,\n    .py-lg-3 {\n      padding-bottom: 1rem !important;\n    }\n    .pl-lg-3,\n    .px-lg-3 {\n      padding-left: 1rem !important;\n    }\n    .p-lg-4 {\n      padding: 1.5rem !important;\n    }\n    .pt-lg-4,\n    .py-lg-4 {\n      padding-top: 1.5rem !important;\n    }\n    .pr-lg-4,\n    .px-lg-4 {\n      padding-right: 1.5rem !important;\n    }\n    .pb-lg-4,\n    .py-lg-4 {\n      padding-bottom: 1.5rem !important;\n    }\n    .pl-lg-4,\n    .px-lg-4 {\n      padding-left: 1.5rem !important;\n    }\n    .p-lg-5 {\n      padding: 3rem !important;\n    }\n    .pt-lg-5,\n    .py-lg-5 {\n      padding-top: 3rem !important;\n    }\n    .pr-lg-5,\n    .px-lg-5 {\n      padding-right: 3rem !important;\n    }\n    .pb-lg-5,\n    .py-lg-5 {\n      padding-bottom: 3rem !important;\n    }\n    .pl-lg-5,\n    .px-lg-5 {\n      padding-left: 3rem !important;\n    }\n    .m-lg-n1 {\n      margin: -0.25rem !important;\n    }\n    .mt-lg-n1,\n    .my-lg-n1 {\n      margin-top: -0.25rem !important;\n    }\n    .mr-lg-n1,\n    .mx-lg-n1 {\n      margin-right: -0.25rem !important;\n    }\n    .mb-lg-n1,\n    .my-lg-n1 {\n      margin-bottom: -0.25rem !important;\n    }\n    .ml-lg-n1,\n    .mx-lg-n1 {\n      margin-left: -0.25rem !important;\n    }\n    .m-lg-n2 {\n      margin: -0.5rem !important;\n    }\n    .mt-lg-n2,\n    .my-lg-n2 {\n      margin-top: -0.5rem !important;\n    }\n    .mr-lg-n2,\n    .mx-lg-n2 {\n      margin-right: -0.5rem !important;\n    }\n    .mb-lg-n2,\n    .my-lg-n2 {\n      margin-bottom: -0.5rem !important;\n    }\n    .ml-lg-n2,\n    .mx-lg-n2 {\n      margin-left: -0.5rem !important;\n    }\n    .m-lg-n3 {\n      margin: -1rem !important;\n    }\n    .mt-lg-n3,\n    .my-lg-n3 {\n      margin-top: -1rem !important;\n    }\n    .mr-lg-n3,\n    .mx-lg-n3 {\n      margin-right: -1rem !important;\n    }\n    .mb-lg-n3,\n    .my-lg-n3 {\n      margin-bottom: -1rem !important;\n    }\n    .ml-lg-n3,\n    .mx-lg-n3 {\n      margin-left: -1rem !important;\n    }\n    .m-lg-n4 {\n      margin: -1.5rem !important;\n    }\n    .mt-lg-n4,\n    .my-lg-n4 {\n      margin-top: -1.5rem !important;\n    }\n    .mr-lg-n4,\n    .mx-lg-n4 {\n      margin-right: -1.5rem !important;\n    }\n    .mb-lg-n4,\n    .my-lg-n4 {\n      margin-bottom: -1.5rem !important;\n    }\n    .ml-lg-n4,\n    .mx-lg-n4 {\n      margin-left: -1.5rem !important;\n    }\n    .m-lg-n5 {\n      margin: -3rem !important;\n    }\n    .mt-lg-n5,\n    .my-lg-n5 {\n      margin-top: -3rem !important;\n    }\n    .mr-lg-n5,\n    .mx-lg-n5 {\n      margin-right: -3rem !important;\n    }\n    .mb-lg-n5,\n    .my-lg-n5 {\n      margin-bottom: -3rem !important;\n    }\n    .ml-lg-n5,\n    .mx-lg-n5 {\n      margin-left: -3rem !important;\n    }\n    .m-lg-auto {\n      margin: auto !important;\n    }\n    .mt-lg-auto,\n    .my-lg-auto {\n      margin-top: auto !important;\n    }\n    .mr-lg-auto,\n    .mx-lg-auto {\n      margin-right: auto !important;\n    }\n    .mb-lg-auto,\n    .my-lg-auto {\n      margin-bottom: auto !important;\n    }\n    .ml-lg-auto,\n    .mx-lg-auto {\n      margin-left: auto !important;\n    }\n  }\n  \n  @media (min-width: 1200px) {\n    .m-xl-0 {\n      margin: 0 !important;\n    }\n    .mt-xl-0,\n    .my-xl-0 {\n      margin-top: 0 !important;\n    }\n    .mr-xl-0,\n    .mx-xl-0 {\n      margin-right: 0 !important;\n    }\n    .mb-xl-0,\n    .my-xl-0 {\n      margin-bottom: 0 !important;\n    }\n    .ml-xl-0,\n    .mx-xl-0 {\n      margin-left: 0 !important;\n    }\n    .m-xl-1 {\n      margin: 0.25rem !important;\n    }\n    .mt-xl-1,\n    .my-xl-1 {\n      margin-top: 0.25rem !important;\n    }\n    .mr-xl-1,\n    .mx-xl-1 {\n      margin-right: 0.25rem !important;\n    }\n    .mb-xl-1,\n    .my-xl-1 {\n      margin-bottom: 0.25rem !important;\n    }\n    .ml-xl-1,\n    .mx-xl-1 {\n      margin-left: 0.25rem !important;\n    }\n    .m-xl-2 {\n      margin: 0.5rem !important;\n    }\n    .mt-xl-2,\n    .my-xl-2 {\n      margin-top: 0.5rem !important;\n    }\n    .mr-xl-2,\n    .mx-xl-2 {\n      margin-right: 0.5rem !important;\n    }\n    .mb-xl-2,\n    .my-xl-2 {\n      margin-bottom: 0.5rem !important;\n    }\n    .ml-xl-2,\n    .mx-xl-2 {\n      margin-left: 0.5rem !important;\n    }\n    .m-xl-3 {\n      margin: 1rem !important;\n    }\n    .mt-xl-3,\n    .my-xl-3 {\n      margin-top: 1rem !important;\n    }\n    .mr-xl-3,\n    .mx-xl-3 {\n      margin-right: 1rem !important;\n    }\n    .mb-xl-3,\n    .my-xl-3 {\n      margin-bottom: 1rem !important;\n    }\n    .ml-xl-3,\n    .mx-xl-3 {\n      margin-left: 1rem !important;\n    }\n    .m-xl-4 {\n      margin: 1.5rem !important;\n    }\n    .mt-xl-4,\n    .my-xl-4 {\n      margin-top: 1.5rem !important;\n    }\n    .mr-xl-4,\n    .mx-xl-4 {\n      margin-right: 1.5rem !important;\n    }\n    .mb-xl-4,\n    .my-xl-4 {\n      margin-bottom: 1.5rem !important;\n    }\n    .ml-xl-4,\n    .mx-xl-4 {\n      margin-left: 1.5rem !important;\n    }\n    .m-xl-5 {\n      margin: 3rem !important;\n    }\n    .mt-xl-5,\n    .my-xl-5 {\n      margin-top: 3rem !important;\n    }\n    .mr-xl-5,\n    .mx-xl-5 {\n      margin-right: 3rem !important;\n    }\n    .mb-xl-5,\n    .my-xl-5 {\n      margin-bottom: 3rem !important;\n    }\n    .ml-xl-5,\n    .mx-xl-5 {\n      margin-left: 3rem !important;\n    }\n    .p-xl-0 {\n      padding: 0 !important;\n    }\n    .pt-xl-0,\n    .py-xl-0 {\n      padding-top: 0 !important;\n    }\n    .pr-xl-0,\n    .px-xl-0 {\n      padding-right: 0 !important;\n    }\n    .pb-xl-0,\n    .py-xl-0 {\n      padding-bottom: 0 !important;\n    }\n    .pl-xl-0,\n    .px-xl-0 {\n      padding-left: 0 !important;\n    }\n    .p-xl-1 {\n      padding: 0.25rem !important;\n    }\n    .pt-xl-1,\n    .py-xl-1 {\n      padding-top: 0.25rem !important;\n    }\n    .pr-xl-1,\n    .px-xl-1 {\n      padding-right: 0.25rem !important;\n    }\n    .pb-xl-1,\n    .py-xl-1 {\n      padding-bottom: 0.25rem !important;\n    }\n    .pl-xl-1,\n    .px-xl-1 {\n      padding-left: 0.25rem !important;\n    }\n    .p-xl-2 {\n      padding: 0.5rem !important;\n    }\n    .pt-xl-2,\n    .py-xl-2 {\n      padding-top: 0.5rem !important;\n    }\n    .pr-xl-2,\n    .px-xl-2 {\n      padding-right: 0.5rem !important;\n    }\n    .pb-xl-2,\n    .py-xl-2 {\n      padding-bottom: 0.5rem !important;\n    }\n    .pl-xl-2,\n    .px-xl-2 {\n      padding-left: 0.5rem !important;\n    }\n    .p-xl-3 {\n      padding: 1rem !important;\n    }\n    .pt-xl-3,\n    .py-xl-3 {\n      padding-top: 1rem !important;\n    }\n    .pr-xl-3,\n    .px-xl-3 {\n      padding-right: 1rem !important;\n    }\n    .pb-xl-3,\n    .py-xl-3 {\n      padding-bottom: 1rem !important;\n    }\n    .pl-xl-3,\n    .px-xl-3 {\n      padding-left: 1rem !important;\n    }\n    .p-xl-4 {\n      padding: 1.5rem !important;\n    }\n    .pt-xl-4,\n    .py-xl-4 {\n      padding-top: 1.5rem !important;\n    }\n    .pr-xl-4,\n    .px-xl-4 {\n      padding-right: 1.5rem !important;\n    }\n    .pb-xl-4,\n    .py-xl-4 {\n      padding-bottom: 1.5rem !important;\n    }\n    .pl-xl-4,\n    .px-xl-4 {\n      padding-left: 1.5rem !important;\n    }\n    .p-xl-5 {\n      padding: 3rem !important;\n    }\n    .pt-xl-5,\n    .py-xl-5 {\n      padding-top: 3rem !important;\n    }\n    .pr-xl-5,\n    .px-xl-5 {\n      padding-right: 3rem !important;\n    }\n    .pb-xl-5,\n    .py-xl-5 {\n      padding-bottom: 3rem !important;\n    }\n    .pl-xl-5,\n    .px-xl-5 {\n      padding-left: 3rem !important;\n    }\n    .m-xl-n1 {\n      margin: -0.25rem !important;\n    }\n    .mt-xl-n1,\n    .my-xl-n1 {\n      margin-top: -0.25rem !important;\n    }\n    .mr-xl-n1,\n    .mx-xl-n1 {\n      margin-right: -0.25rem !important;\n    }\n    .mb-xl-n1,\n    .my-xl-n1 {\n      margin-bottom: -0.25rem !important;\n    }\n    .ml-xl-n1,\n    .mx-xl-n1 {\n      margin-left: -0.25rem !important;\n    }\n    .m-xl-n2 {\n      margin: -0.5rem !important;\n    }\n    .mt-xl-n2,\n    .my-xl-n2 {\n      margin-top: -0.5rem !important;\n    }\n    .mr-xl-n2,\n    .mx-xl-n2 {\n      margin-right: -0.5rem !important;\n    }\n    .mb-xl-n2,\n    .my-xl-n2 {\n      margin-bottom: -0.5rem !important;\n    }\n    .ml-xl-n2,\n    .mx-xl-n2 {\n      margin-left: -0.5rem !important;\n    }\n    .m-xl-n3 {\n      margin: -1rem !important;\n    }\n    .mt-xl-n3,\n    .my-xl-n3 {\n      margin-top: -1rem !important;\n    }\n    .mr-xl-n3,\n    .mx-xl-n3 {\n      margin-right: -1rem !important;\n    }\n    .mb-xl-n3,\n    .my-xl-n3 {\n      margin-bottom: -1rem !important;\n    }\n    .ml-xl-n3,\n    .mx-xl-n3 {\n      margin-left: -1rem !important;\n    }\n    .m-xl-n4 {\n      margin: -1.5rem !important;\n    }\n    .mt-xl-n4,\n    .my-xl-n4 {\n      margin-top: -1.5rem !important;\n    }\n    .mr-xl-n4,\n    .mx-xl-n4 {\n      margin-right: -1.5rem !important;\n    }\n    .mb-xl-n4,\n    .my-xl-n4 {\n      margin-bottom: -1.5rem !important;\n    }\n    .ml-xl-n4,\n    .mx-xl-n4 {\n      margin-left: -1.5rem !important;\n    }\n    .m-xl-n5 {\n      margin: -3rem !important;\n    }\n    .mt-xl-n5,\n    .my-xl-n5 {\n      margin-top: -3rem !important;\n    }\n    .mr-xl-n5,\n    .mx-xl-n5 {\n      margin-right: -3rem !important;\n    }\n    .mb-xl-n5,\n    .my-xl-n5 {\n      margin-bottom: -3rem !important;\n    }\n    .ml-xl-n5,\n    .mx-xl-n5 {\n      margin-left: -3rem !important;\n    }\n    .m-xl-auto {\n      margin: auto !important;\n    }\n    .mt-xl-auto,\n    .my-xl-auto {\n      margin-top: auto !important;\n    }\n    .mr-xl-auto,\n    .mx-xl-auto {\n      margin-right: auto !important;\n    }\n    .mb-xl-auto,\n    .my-xl-auto {\n      margin-bottom: auto !important;\n    }\n    .ml-xl-auto,\n    .mx-xl-auto {\n      margin-left: auto !important;\n    }\n  }", ""]);

// exports


/***/ }),
/* 595 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(false);
// imports


// module
exports.push([module.i, "html, body{    \n    margin: 0;\n}\n\n@media screen and (max-width: 1400px) {\n    body {\n        zoom: 85%;\n    }\n    .layout .page {\n        width: calc(100vw - 212.5px) !important;\n        height: 117.6vh !important;\n    }\n    .layout .sidebar .sidebar {\n        height: 117.6vh !important;\n    }\n}\n\n.fade-enter-active, .fade-leave-active {\n    transition-property: opacity;\n    transition-duration: .25s;\n}\n  \n.fade-enter-active {\n    transition-delay: .25s;\n}\n\n.fade-enter, .fade-leave-active {\n    opacity: 0\n}\n\n.vx-card .vx-card__collapsible-content .vx-card__body {\n    padding: 1.5rem;\n}\n\n.vdp-datepicker input {\n    width: 10ch;\n    cursor: pointer;\n    text-align: center;\n}\n\n.vs-table {\n    padding: 1.5rem 2rem;\n}\n.vs-table th {\n    font-size: 1rem;\n}\n.vs-table td {\n    font-size: 0.9rem;\n}\n\n.tooltip-inner {\n    /* */\n}\n\n@font-face {\n    font-family: 'BLOKK';\n    src: url('/static/fonts/BLOKK/BLOKKNeue-Regular.eot');\n    src: url('/static/fonts/BLOKK/BLOKKNeue-Regular.eot?#iefix') format('embedded-opentype'),\n         url('/static/fonts/BLOKK/BLOKKNeue-Regular.woff2') format('woff2'),\n         url('/static/fonts/BLOKK/BLOKKNeue-Regular.woff') format('woff'),\n         url('/static/fonts/BLOKK/BLOKKNeue-Regular.otf') format('opentype'),\n         url('/static/fonts/BLOKK/BLOKKNeue-Regular.ttf') format('truetype'),\n         url('/static/fonts/BLOKK/BLOKKNeue-Regular.svg#BLOKKRegular') format('svg');\n    font-weight: normal;\n    font-style: normal;\n}\n\n@media screen and (-webkit-min-device-pixel-ratio:0) {\n    @font-face {\n        font-family: 'BLOKK';\n        src: url('/static/fonts/BLOKK/BLOKKNeue-Regular.svg') format('svg');\n    }\n}\n\nbody {\n    -webkit-font-smoothing: antialiased;\n    -moz-osx-font-smoothing: grayscale;\n}\n\n.blokk {\n    font-family: 'BLOKK' !important;\n}\n\n.apexcharts-pie-label, .apexcharts-datalabel, .apexcharts-datalabel-label, .apexcharts-datalabel-value,\n.apexcharts-tooltip-text-label,\n.apexcharts-tooltip-text-value {\n    font-size: 16px !important;\n}\n\n.minuba-link {\n    color: #69798d;\n}\n\n.minuba-link:hover {\n    color: #172b43;\n}", ""]);

// exports


/***/ }),
/* 596 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(false);
// imports
exports.i(__webpack_require__(595), "");
exports.i(__webpack_require__(594), "");

// module
exports.push([module.i, "/* Custom styles */", ""]);

// exports


/***/ }),
/* 597 */,
/* 598 */,
/* 599 */,
/* 600 */,
/* 601 */,
/* 602 */,
/* 603 */,
/* 604 */,
/* 605 */,
/* 606 */,
/* 607 */,
/* 608 */,
/* 609 */,
/* 610 */,
/* 611 */,
/* 612 */,
/* 613 */,
/* 614 */,
/* 615 */,
/* 616 */,
/* 617 */,
/* 618 */,
/* 619 */,
/* 620 */,
/* 621 */,
/* 622 */,
/* 623 */,
/* 624 */,
/* 625 */,
/* 626 */,
/* 627 */,
/* 628 */,
/* 629 */,
/* 630 */,
/* 631 */,
/* 632 */,
/* 633 */,
/* 634 */,
/* 635 */,
/* 636 */,
/* 637 */,
/* 638 */,
/* 639 */,
/* 640 */,
/* 641 */,
/* 642 */,
/* 643 */,
/* 644 */,
/* 645 */,
/* 646 */,
/* 647 */,
/* 648 */,
/* 649 */,
/* 650 */,
/* 651 */,
/* 652 */,
/* 653 */,
/* 654 */,
/* 655 */,
/* 656 */,
/* 657 */,
/* 658 */,
/* 659 */,
/* 660 */,
/* 661 */,
/* 662 */,
/* 663 */,
/* 664 */,
/* 665 */,
/* 666 */,
/* 667 */,
/* 668 */,
/* 669 */,
/* 670 */,
/* 671 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./af": 137,
	"./af.js": 137,
	"./ar": 144,
	"./ar-dz": 138,
	"./ar-dz.js": 138,
	"./ar-kw": 139,
	"./ar-kw.js": 139,
	"./ar-ly": 140,
	"./ar-ly.js": 140,
	"./ar-ma": 141,
	"./ar-ma.js": 141,
	"./ar-sa": 142,
	"./ar-sa.js": 142,
	"./ar-tn": 143,
	"./ar-tn.js": 143,
	"./ar.js": 144,
	"./az": 145,
	"./az.js": 145,
	"./be": 146,
	"./be.js": 146,
	"./bg": 147,
	"./bg.js": 147,
	"./bm": 148,
	"./bm.js": 148,
	"./bn": 149,
	"./bn.js": 149,
	"./bo": 150,
	"./bo.js": 150,
	"./br": 151,
	"./br.js": 151,
	"./bs": 152,
	"./bs.js": 152,
	"./ca": 153,
	"./ca.js": 153,
	"./cs": 154,
	"./cs.js": 154,
	"./cv": 155,
	"./cv.js": 155,
	"./cy": 156,
	"./cy.js": 156,
	"./da": 51,
	"./da.js": 51,
	"./de": 159,
	"./de-at": 157,
	"./de-at.js": 157,
	"./de-ch": 158,
	"./de-ch.js": 158,
	"./de.js": 159,
	"./dv": 160,
	"./dv.js": 160,
	"./el": 161,
	"./el.js": 161,
	"./en-SG": 162,
	"./en-SG.js": 162,
	"./en-au": 163,
	"./en-au.js": 163,
	"./en-ca": 164,
	"./en-ca.js": 164,
	"./en-gb": 165,
	"./en-gb.js": 165,
	"./en-ie": 166,
	"./en-ie.js": 166,
	"./en-il": 167,
	"./en-il.js": 167,
	"./en-nz": 168,
	"./en-nz.js": 168,
	"./eo": 169,
	"./eo.js": 169,
	"./es": 172,
	"./es-do": 170,
	"./es-do.js": 170,
	"./es-us": 171,
	"./es-us.js": 171,
	"./es.js": 172,
	"./et": 173,
	"./et.js": 173,
	"./eu": 174,
	"./eu.js": 174,
	"./fa": 175,
	"./fa.js": 175,
	"./fi": 176,
	"./fi.js": 176,
	"./fo": 177,
	"./fo.js": 177,
	"./fr": 180,
	"./fr-ca": 178,
	"./fr-ca.js": 178,
	"./fr-ch": 179,
	"./fr-ch.js": 179,
	"./fr.js": 180,
	"./fy": 181,
	"./fy.js": 181,
	"./ga": 182,
	"./ga.js": 182,
	"./gd": 183,
	"./gd.js": 183,
	"./gl": 184,
	"./gl.js": 184,
	"./gom-latn": 185,
	"./gom-latn.js": 185,
	"./gu": 186,
	"./gu.js": 186,
	"./he": 187,
	"./he.js": 187,
	"./hi": 188,
	"./hi.js": 188,
	"./hr": 189,
	"./hr.js": 189,
	"./hu": 190,
	"./hu.js": 190,
	"./hy-am": 191,
	"./hy-am.js": 191,
	"./id": 192,
	"./id.js": 192,
	"./is": 193,
	"./is.js": 193,
	"./it": 195,
	"./it-ch": 194,
	"./it-ch.js": 194,
	"./it.js": 195,
	"./ja": 196,
	"./ja.js": 196,
	"./jv": 197,
	"./jv.js": 197,
	"./ka": 198,
	"./ka.js": 198,
	"./kk": 199,
	"./kk.js": 199,
	"./km": 200,
	"./km.js": 200,
	"./kn": 201,
	"./kn.js": 201,
	"./ko": 202,
	"./ko.js": 202,
	"./ku": 203,
	"./ku.js": 203,
	"./ky": 204,
	"./ky.js": 204,
	"./lb": 205,
	"./lb.js": 205,
	"./lo": 206,
	"./lo.js": 206,
	"./lt": 207,
	"./lt.js": 207,
	"./lv": 208,
	"./lv.js": 208,
	"./me": 209,
	"./me.js": 209,
	"./mi": 210,
	"./mi.js": 210,
	"./mk": 211,
	"./mk.js": 211,
	"./ml": 212,
	"./ml.js": 212,
	"./mn": 213,
	"./mn.js": 213,
	"./mr": 214,
	"./mr.js": 214,
	"./ms": 216,
	"./ms-my": 215,
	"./ms-my.js": 215,
	"./ms.js": 216,
	"./mt": 217,
	"./mt.js": 217,
	"./my": 218,
	"./my.js": 218,
	"./nb": 219,
	"./nb.js": 219,
	"./ne": 220,
	"./ne.js": 220,
	"./nl": 222,
	"./nl-be": 221,
	"./nl-be.js": 221,
	"./nl.js": 222,
	"./nn": 223,
	"./nn.js": 223,
	"./pa-in": 224,
	"./pa-in.js": 224,
	"./pl": 225,
	"./pl.js": 225,
	"./pt": 227,
	"./pt-br": 226,
	"./pt-br.js": 226,
	"./pt.js": 227,
	"./ro": 228,
	"./ro.js": 228,
	"./ru": 229,
	"./ru.js": 229,
	"./sd": 230,
	"./sd.js": 230,
	"./se": 231,
	"./se.js": 231,
	"./si": 232,
	"./si.js": 232,
	"./sk": 233,
	"./sk.js": 233,
	"./sl": 234,
	"./sl.js": 234,
	"./sq": 235,
	"./sq.js": 235,
	"./sr": 237,
	"./sr-cyrl": 236,
	"./sr-cyrl.js": 236,
	"./sr.js": 237,
	"./ss": 238,
	"./ss.js": 238,
	"./sv": 239,
	"./sv.js": 239,
	"./sw": 240,
	"./sw.js": 240,
	"./ta": 241,
	"./ta.js": 241,
	"./te": 242,
	"./te.js": 242,
	"./tet": 243,
	"./tet.js": 243,
	"./tg": 244,
	"./tg.js": 244,
	"./th": 245,
	"./th.js": 245,
	"./tl-ph": 246,
	"./tl-ph.js": 246,
	"./tlh": 247,
	"./tlh.js": 247,
	"./tr": 248,
	"./tr.js": 248,
	"./tzl": 249,
	"./tzl.js": 249,
	"./tzm": 251,
	"./tzm-latn": 250,
	"./tzm-latn.js": 250,
	"./tzm.js": 251,
	"./ug-cn": 252,
	"./ug-cn.js": 252,
	"./uk": 253,
	"./uk.js": 253,
	"./ur": 254,
	"./ur.js": 254,
	"./uz": 256,
	"./uz-latn": 255,
	"./uz-latn.js": 255,
	"./uz.js": 256,
	"./vi": 257,
	"./vi.js": 257,
	"./x-pseudo": 258,
	"./x-pseudo.js": 258,
	"./yo": 259,
	"./yo.js": 259,
	"./zh-cn": 260,
	"./zh-cn.js": 260,
	"./zh-hk": 261,
	"./zh-hk.js": 261,
	"./zh-tw": 262,
	"./zh-tw.js": 262
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 671;

/***/ }),
/* 672 */,
/* 673 */,
/* 674 */,
/* 675 */,
/* 676 */,
/* 677 */,
/* 678 */,
/* 679 */,
/* 680 */,
/* 681 */,
/* 682 */,
/* 683 */,
/* 684 */,
/* 685 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(916)
__webpack_require__(915)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(355),
  /* template */
  __webpack_require__(802),
  /* scopeId */
  "data-v-2631a998",
  /* cssModules */
  null
)
Component.options.__file = "/opt/build/repo/src/components/elements/ConfigBar.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key !== "__esModule"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] ConfigBar.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-2631a998", Component.options)
  } else {
    hotAPI.reload("data-v-2631a998", Component.options)
  }
})()}

module.exports = Component.exports


/***/ }),
/* 686 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(901)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(359),
  /* template */
  __webpack_require__(784),
  /* scopeId */
  "data-v-1313447a",
  /* cssModules */
  null
)
Component.options.__file = "/opt/build/repo/src/components/elements/Sidebar.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key !== "__esModule"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] Sidebar.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-1313447a", Component.options)
  } else {
    hotAPI.reload("data-v-1313447a", Component.options)
  }
})()}

module.exports = Component.exports


/***/ }),
/* 687 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(933)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(366),
  /* template */
  __webpack_require__(845),
  /* scopeId */
  "data-v-5ebecd11",
  /* cssModules */
  null
)
Component.options.__file = "/opt/build/repo/src/components/layout/footer.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key !== "__esModule"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] footer.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-5ebecd11", Component.options)
  } else {
    hotAPI.reload("data-v-5ebecd11", Component.options)
  }
})()}

module.exports = Component.exports


/***/ }),
/* 688 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(905)
__webpack_require__(906)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(367),
  /* template */
  __webpack_require__(793),
  /* scopeId */
  null,
  /* cssModules */
  null
)
Component.options.__file = "/opt/build/repo/src/components/layout/layout.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key !== "__esModule"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] layout.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-1e6fb320", Component.options)
  } else {
    hotAPI.reload("data-v-1e6fb320", Component.options)
  }
})()}

module.exports = Component.exports


/***/ }),
/* 689 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(918)

var Component = __webpack_require__(1)(
  /* script */
  null,
  /* template */
  __webpack_require__(811),
  /* scopeId */
  "data-v-301a1469",
  /* cssModules */
  null
)
Component.options.__file = "/opt/build/repo/src/pages/common/404.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key !== "__esModule"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] 404.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-301a1469", Component.options)
  } else {
    hotAPI.reload("data-v-301a1469", Component.options)
  }
})()}

module.exports = Component.exports


/***/ }),
/* 690 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  null,
  /* template */
  __webpack_require__(851),
  /* scopeId */
  null,
  /* cssModules */
  null
)
Component.options.__file = "/opt/build/repo/src/pages/common/comingsoon.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key !== "__esModule"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] comingsoon.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-6665b95b", Component.options)
  } else {
    hotAPI.reload("data-v-6665b95b", Component.options)
  }
})()}

module.exports = Component.exports


/***/ }),
/* 691 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(380),
  /* template */
  __webpack_require__(876),
  /* scopeId */
  null,
  /* cssModules */
  null
)
Component.options.__file = "/opt/build/repo/src/pages/customers/customers.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key !== "__esModule"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] customers.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-a790bfd4", Component.options)
  } else {
    hotAPI.reload("data-v-a790bfd4", Component.options)
  }
})()}

module.exports = Component.exports


/***/ }),
/* 692 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(381),
  /* template */
  __webpack_require__(785),
  /* scopeId */
  null,
  /* cssModules */
  null
)
Component.options.__file = "/opt/build/repo/src/pages/customers/learning.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key !== "__esModule"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] learning.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-1453ac26", Component.options)
  } else {
    hotAPI.reload("data-v-1453ac26", Component.options)
  }
})()}

module.exports = Component.exports


/***/ }),
/* 693 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(382),
  /* template */
  __webpack_require__(819),
  /* scopeId */
  null,
  /* cssModules */
  null
)
Component.options.__file = "/opt/build/repo/src/pages/customers/operations.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key !== "__esModule"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] operations.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-3e3af40a", Component.options)
  } else {
    hotAPI.reload("data-v-3e3af40a", Component.options)
  }
})()}

module.exports = Component.exports


/***/ }),
/* 694 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(383),
  /* template */
  __webpack_require__(816),
  /* scopeId */
  null,
  /* cssModules */
  null
)
Component.options.__file = "/opt/build/repo/src/pages/customers/operations/customerGroupedSingle.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key !== "__esModule"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] customerGroupedSingle.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-39b67b18", Component.options)
  } else {
    hotAPI.reload("data-v-39b67b18", Component.options)
  }
})()}

module.exports = Component.exports


/***/ }),
/* 695 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(384),
  /* template */
  __webpack_require__(781),
  /* scopeId */
  null,
  /* cssModules */
  null
)
Component.options.__file = "/opt/build/repo/src/pages/customers/operations/customerRevenue.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key !== "__esModule"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] customerRevenue.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-0d5ac2ca", Component.options)
  } else {
    hotAPI.reload("data-v-0d5ac2ca", Component.options)
  }
})()}

module.exports = Component.exports


/***/ }),
/* 696 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(385),
  /* template */
  __webpack_require__(829),
  /* scopeId */
  null,
  /* cssModules */
  null
)
Component.options.__file = "/opt/build/repo/src/pages/customers/operations/customerRevenueGrouped.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key !== "__esModule"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] customerRevenueGrouped.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-49678e64", Component.options)
  } else {
    hotAPI.reload("data-v-49678e64", Component.options)
  }
})()}

module.exports = Component.exports


/***/ }),
/* 697 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(386),
  /* template */
  __webpack_require__(856),
  /* scopeId */
  null,
  /* cssModules */
  null
)
Component.options.__file = "/opt/build/repo/src/pages/customers/operations/customerRevenueSingle.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key !== "__esModule"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] customerRevenueSingle.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-702551b2", Component.options)
  } else {
    hotAPI.reload("data-v-702551b2", Component.options)
  }
})()}

module.exports = Component.exports


/***/ }),
/* 698 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(387),
  /* template */
  __webpack_require__(821),
  /* scopeId */
  null,
  /* cssModules */
  null
)
Component.options.__file = "/opt/build/repo/src/pages/customers/operations/customerTypeRevenue.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key !== "__esModule"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] customerTypeRevenue.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-4076f830", Component.options)
  } else {
    hotAPI.reload("data-v-4076f830", Component.options)
  }
})()}

module.exports = Component.exports


/***/ }),
/* 699 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(388),
  /* template */
  __webpack_require__(880),
  /* scopeId */
  null,
  /* cssModules */
  null
)
Component.options.__file = "/opt/build/repo/src/pages/customers/operations/customerTypeRevenueSingle.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key !== "__esModule"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] customerTypeRevenueSingle.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-c77d3ad0", Component.options)
  } else {
    hotAPI.reload("data-v-c77d3ad0", Component.options)
  }
})()}

module.exports = Component.exports


/***/ }),
/* 700 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(389),
  /* template */
  __webpack_require__(859),
  /* scopeId */
  null,
  /* cssModules */
  null
)
Component.options.__file = "/opt/build/repo/src/pages/economy/components/compareCoverage.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key !== "__esModule"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] compareCoverage.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-72d1c53a", Component.options)
  } else {
    hotAPI.reload("data-v-72d1c53a", Component.options)
  }
})()}

module.exports = Component.exports


/***/ }),
/* 701 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(390),
  /* template */
  __webpack_require__(891),
  /* scopeId */
  null,
  /* cssModules */
  null
)
Component.options.__file = "/opt/build/repo/src/pages/economy/components/compareCoveragePerHour.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key !== "__esModule"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] compareCoveragePerHour.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-eabb0c92", Component.options)
  } else {
    hotAPI.reload("data-v-eabb0c92", Component.options)
  }
})()}

module.exports = Component.exports


/***/ }),
/* 702 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(391),
  /* template */
  __webpack_require__(850),
  /* scopeId */
  null,
  /* cssModules */
  null
)
Component.options.__file = "/opt/build/repo/src/pages/economy/components/compareCoveragePercent.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key !== "__esModule"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] compareCoveragePercent.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-628e275b", Component.options)
  } else {
    hotAPI.reload("data-v-628e275b", Component.options)
  }
})()}

module.exports = Component.exports


/***/ }),
/* 703 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(392),
  /* template */
  __webpack_require__(846),
  /* scopeId */
  null,
  /* cssModules */
  null
)
Component.options.__file = "/opt/build/repo/src/pages/economy/components/compareCustomerHours.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key !== "__esModule"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] compareCustomerHours.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-5f18f122", Component.options)
  } else {
    hotAPI.reload("data-v-5f18f122", Component.options)
  }
})()}

module.exports = Component.exports


/***/ }),
/* 704 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(393),
  /* template */
  __webpack_require__(782),
  /* scopeId */
  null,
  /* cssModules */
  null
)
Component.options.__file = "/opt/build/repo/src/pages/economy/components/compareKeyfigures.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key !== "__esModule"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] compareKeyfigures.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-0dd66fa2", Component.options)
  } else {
    hotAPI.reload("data-v-0dd66fa2", Component.options)
  }
})()}

module.exports = Component.exports


/***/ }),
/* 705 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(394),
  /* template */
  __webpack_require__(832),
  /* scopeId */
  null,
  /* cssModules */
  null
)
Component.options.__file = "/opt/build/repo/src/pages/economy/components/compareRevenue.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key !== "__esModule"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] compareRevenue.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-4f03b8ba", Component.options)
  } else {
    hotAPI.reload("data-v-4f03b8ba", Component.options)
  }
})()}

module.exports = Component.exports


/***/ }),
/* 706 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(949)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(395),
  /* template */
  __webpack_require__(889),
  /* scopeId */
  "data-v-e1cbaa30",
  /* cssModules */
  null
)
Component.options.__file = "/opt/build/repo/src/pages/economy/components/costpricePerHour.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key !== "__esModule"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] costpricePerHour.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-e1cbaa30", Component.options)
  } else {
    hotAPI.reload("data-v-e1cbaa30", Component.options)
  }
})()}

module.exports = Component.exports


/***/ }),
/* 707 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(902)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(396),
  /* template */
  __webpack_require__(789),
  /* scopeId */
  "data-v-1837e2a0",
  /* cssModules */
  null
)
Component.options.__file = "/opt/build/repo/src/pages/economy/components/costsDivision.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key !== "__esModule"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] costsDivision.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-1837e2a0", Component.options)
  } else {
    hotAPI.reload("data-v-1837e2a0", Component.options)
  }
})()}

module.exports = Component.exports


/***/ }),
/* 708 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(397),
  /* template */
  __webpack_require__(869),
  /* scopeId */
  null,
  /* cssModules */
  null
)
Component.options.__file = "/opt/build/repo/src/pages/economy/components/materialUsage.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key !== "__esModule"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] materialUsage.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-8f9a7272", Component.options)
  } else {
    hotAPI.reload("data-v-8f9a7272", Component.options)
  }
})()}

module.exports = Component.exports


/***/ }),
/* 709 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(398),
  /* template */
  __webpack_require__(853),
  /* scopeId */
  null,
  /* cssModules */
  null
)
Component.options.__file = "/opt/build/repo/src/pages/economy/components/suppliers.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key !== "__esModule"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] suppliers.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-6c3ec234", Component.options)
  } else {
    hotAPI.reload("data-v-6c3ec234", Component.options)
  }
})()}

module.exports = Component.exports


/***/ }),
/* 710 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(399),
  /* template */
  __webpack_require__(847),
  /* scopeId */
  null,
  /* cssModules */
  null
)
Component.options.__file = "/opt/build/repo/src/pages/economy/economy.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key !== "__esModule"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] economy.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-5f59a4e8", Component.options)
  } else {
    hotAPI.reload("data-v-5f59a4e8", Component.options)
  }
})()}

module.exports = Component.exports


/***/ }),
/* 711 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(400),
  /* template */
  __webpack_require__(884),
  /* scopeId */
  null,
  /* cssModules */
  null
)
Component.options.__file = "/opt/build/repo/src/pages/economy/learning.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key !== "__esModule"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] learning.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-d55ee438", Component.options)
  } else {
    hotAPI.reload("data-v-d55ee438", Component.options)
  }
})()}

module.exports = Component.exports


/***/ }),
/* 712 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(401),
  /* template */
  __webpack_require__(806),
  /* scopeId */
  null,
  /* cssModules */
  null
)
Component.options.__file = "/opt/build/repo/src/pages/economy/learning/compare.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key !== "__esModule"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] compare.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-2c7820ba", Component.options)
  } else {
    hotAPI.reload("data-v-2c7820ba", Component.options)
  }
})()}

module.exports = Component.exports


/***/ }),
/* 713 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(899)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(402),
  /* template */
  __webpack_require__(776),
  /* scopeId */
  "data-v-0466fc80",
  /* cssModules */
  null
)
Component.options.__file = "/opt/build/repo/src/pages/economy/learning/ebitda.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key !== "__esModule"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] ebitda.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-0466fc80", Component.options)
  } else {
    hotAPI.reload("data-v-0466fc80", Component.options)
  }
})()}

module.exports = Component.exports


/***/ }),
/* 714 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(403),
  /* template */
  __webpack_require__(831),
  /* scopeId */
  null,
  /* cssModules */
  null
)
Component.options.__file = "/opt/build/repo/src/pages/economy/learning/keyFigures.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key !== "__esModule"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] keyFigures.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-4d666c6b", Component.options)
  } else {
    hotAPI.reload("data-v-4d666c6b", Component.options)
  }
})()}

module.exports = Component.exports


/***/ }),
/* 715 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(404),
  /* template */
  __webpack_require__(809),
  /* scopeId */
  null,
  /* cssModules */
  null
)
Component.options.__file = "/opt/build/repo/src/pages/economy/learning/materials.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key !== "__esModule"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] materials.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-2efd2d41", Component.options)
  } else {
    hotAPI.reload("data-v-2efd2d41", Component.options)
  }
})()}

module.exports = Component.exports


/***/ }),
/* 716 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(908)
__webpack_require__(907)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(405),
  /* template */
  __webpack_require__(794),
  /* scopeId */
  "data-v-1fe26433",
  /* cssModules */
  null
)
Component.options.__file = "/opt/build/repo/src/pages/economy/learning/potential.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key !== "__esModule"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] potential.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-1fe26433", Component.options)
  } else {
    hotAPI.reload("data-v-1fe26433", Component.options)
  }
})()}

module.exports = Component.exports


/***/ }),
/* 717 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(931)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(406),
  /* template */
  __webpack_require__(843),
  /* scopeId */
  "data-v-5d6ac280",
  /* cssModules */
  null
)
Component.options.__file = "/opt/build/repo/src/pages/economy/learning/revenueAndCosts.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key !== "__esModule"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] revenueAndCosts.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-5d6ac280", Component.options)
  } else {
    hotAPI.reload("data-v-5d6ac280", Component.options)
  }
})()}

module.exports = Component.exports


/***/ }),
/* 718 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(407),
  /* template */
  __webpack_require__(890),
  /* scopeId */
  null,
  /* cssModules */
  null
)
Component.options.__file = "/opt/build/repo/src/pages/economy/operations.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key !== "__esModule"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] operations.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-e9586f9c", Component.options)
  } else {
    hotAPI.reload("data-v-e9586f9c", Component.options)
  }
})()}

module.exports = Component.exports


/***/ }),
/* 719 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  null,
  /* template */
  __webpack_require__(807),
  /* scopeId */
  null,
  /* cssModules */
  null
)
Component.options.__file = "/opt/build/repo/src/pages/economy/operations/exceededPayments.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key !== "__esModule"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] exceededPayments.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-2d04ea8d", Component.options)
  } else {
    hotAPI.reload("data-v-2d04ea8d", Component.options)
  }
})()}

module.exports = Component.exports


/***/ }),
/* 720 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(408),
  /* template */
  __webpack_require__(860),
  /* scopeId */
  null,
  /* cssModules */
  null
)
Component.options.__file = "/opt/build/repo/src/pages/employees/employees.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key !== "__esModule"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] employees.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-72e01a76", Component.options)
  } else {
    hotAPI.reload("data-v-72e01a76", Component.options)
  }
})()}

module.exports = Component.exports


/***/ }),
/* 721 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(409),
  /* template */
  __webpack_require__(872),
  /* scopeId */
  null,
  /* cssModules */
  null
)
Component.options.__file = "/opt/build/repo/src/pages/employees/learning.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key !== "__esModule"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] learning.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-9c993686", Component.options)
  } else {
    hotAPI.reload("data-v-9c993686", Component.options)
  }
})()}

module.exports = Component.exports


/***/ }),
/* 722 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(410),
  /* template */
  __webpack_require__(875),
  /* scopeId */
  null,
  /* cssModules */
  null
)
Component.options.__file = "/opt/build/repo/src/pages/employees/learning/components/employeeSkillsSingleProjects.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key !== "__esModule"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] employeeSkillsSingleProjects.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-a7100ece", Component.options)
  } else {
    hotAPI.reload("data-v-a7100ece", Component.options)
  }
})()}

module.exports = Component.exports


/***/ }),
/* 723 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(411),
  /* template */
  __webpack_require__(803),
  /* scopeId */
  null,
  /* cssModules */
  null
)
Component.options.__file = "/opt/build/repo/src/pages/employees/learning/components/employeeTimeUsage.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key !== "__esModule"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] employeeTimeUsage.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-2815c14f", Component.options)
  } else {
    hotAPI.reload("data-v-2815c14f", Component.options)
  }
})()}

module.exports = Component.exports


/***/ }),
/* 724 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(412),
  /* template */
  __webpack_require__(862),
  /* scopeId */
  null,
  /* cssModules */
  null
)
Component.options.__file = "/opt/build/repo/src/pages/employees/learning/components/hoursWithCustomers.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key !== "__esModule"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] hoursWithCustomers.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-77c6b227", Component.options)
  } else {
    hotAPI.reload("data-v-77c6b227", Component.options)
  }
})()}

module.exports = Component.exports


/***/ }),
/* 725 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(414),
  /* template */
  __webpack_require__(855),
  /* scopeId */
  null,
  /* cssModules */
  null
)
Component.options.__file = "/opt/build/repo/src/pages/employees/learning/efficiencyGraph.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key !== "__esModule"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] efficiencyGraph.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-6c838013", Component.options)
  } else {
    hotAPI.reload("data-v-6c838013", Component.options)
  }
})()}

module.exports = Component.exports


/***/ }),
/* 726 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(415),
  /* template */
  __webpack_require__(839),
  /* scopeId */
  null,
  /* cssModules */
  null
)
Component.options.__file = "/opt/build/repo/src/pages/employees/learning/employeeRevenue.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key !== "__esModule"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] employeeRevenue.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-580314bc", Component.options)
  } else {
    hotAPI.reload("data-v-580314bc", Component.options)
  }
})()}

module.exports = Component.exports


/***/ }),
/* 727 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(416),
  /* template */
  __webpack_require__(790),
  /* scopeId */
  null,
  /* cssModules */
  null
)
Component.options.__file = "/opt/build/repo/src/pages/employees/learning/employeeSkills.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key !== "__esModule"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] employeeSkills.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-185fd65c", Component.options)
  } else {
    hotAPI.reload("data-v-185fd65c", Component.options)
  }
})()}

module.exports = Component.exports


/***/ }),
/* 728 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(417),
  /* template */
  __webpack_require__(834),
  /* scopeId */
  null,
  /* cssModules */
  null
)
Component.options.__file = "/opt/build/repo/src/pages/employees/learning/employeeSkillsSingle.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key !== "__esModule"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] employeeSkillsSingle.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-5106fdba", Component.options)
  } else {
    hotAPI.reload("data-v-5106fdba", Component.options)
  }
})()}

module.exports = Component.exports


/***/ }),
/* 729 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(418),
  /* template */
  __webpack_require__(778),
  /* scopeId */
  null,
  /* cssModules */
  null
)
Component.options.__file = "/opt/build/repo/src/pages/employees/learning/timeUsage.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key !== "__esModule"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] timeUsage.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-06c72782", Component.options)
  } else {
    hotAPI.reload("data-v-06c72782", Component.options)
  }
})()}

module.exports = Component.exports


/***/ }),
/* 730 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(936)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(419),
  /* template */
  __webpack_require__(857),
  /* scopeId */
  "data-v-70ce8938",
  /* cssModules */
  null
)
Component.options.__file = "/opt/build/repo/src/pages/employees/learning/timeUsageSkills.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key !== "__esModule"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] timeUsageSkills.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-70ce8938", Component.options)
  } else {
    hotAPI.reload("data-v-70ce8938", Component.options)
  }
})()}

module.exports = Component.exports


/***/ }),
/* 731 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(420),
  /* template */
  __webpack_require__(791),
  /* scopeId */
  null,
  /* cssModules */
  null
)
Component.options.__file = "/opt/build/repo/src/pages/employees/operations.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key !== "__esModule"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] operations.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-1a5c4ccb", Component.options)
  } else {
    hotAPI.reload("data-v-1a5c4ccb", Component.options)
  }
})()}

module.exports = Component.exports


/***/ }),
/* 732 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(422),
  /* template */
  __webpack_require__(804),
  /* scopeId */
  null,
  /* cssModules */
  null
)
Component.options.__file = "/opt/build/repo/src/pages/enterprise/components/employeesSubProjects.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key !== "__esModule"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] employeesSubProjects.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-292ea815", Component.options)
  } else {
    hotAPI.reload("data-v-292ea815", Component.options)
  }
})()}

module.exports = Component.exports


/***/ }),
/* 733 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(423),
  /* template */
  __webpack_require__(885),
  /* scopeId */
  null,
  /* cssModules */
  null
)
Component.options.__file = "/opt/build/repo/src/pages/enterprise/components/employeesSubProjectsSingle.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key !== "__esModule"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] employeesSubProjectsSingle.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-d7a65a86", Component.options)
  } else {
    hotAPI.reload("data-v-d7a65a86", Component.options)
  }
})()}

module.exports = Component.exports


/***/ }),
/* 734 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(424),
  /* template */
  __webpack_require__(864),
  /* scopeId */
  null,
  /* cssModules */
  null
)
Component.options.__file = "/opt/build/repo/src/pages/enterprise/components/mainProjectTypeSingle.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key !== "__esModule"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] mainProjectTypeSingle.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-7b821fdc", Component.options)
  } else {
    hotAPI.reload("data-v-7b821fdc", Component.options)
  }
})()}

module.exports = Component.exports


/***/ }),
/* 735 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(425),
  /* template */
  __webpack_require__(828),
  /* scopeId */
  null,
  /* cssModules */
  null
)
Component.options.__file = "/opt/build/repo/src/pages/enterprise/components/mainProjectTypes.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key !== "__esModule"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] mainProjectTypes.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-46de1d39", Component.options)
  } else {
    hotAPI.reload("data-v-46de1d39", Component.options)
  }
})()}

module.exports = Component.exports


/***/ }),
/* 736 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(426),
  /* template */
  __webpack_require__(873),
  /* scopeId */
  null,
  /* cssModules */
  null
)
Component.options.__file = "/opt/build/repo/src/pages/enterprise/components/mainProjects.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key !== "__esModule"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] mainProjects.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-a19a875a", Component.options)
  } else {
    hotAPI.reload("data-v-a19a875a", Component.options)
  }
})()}

module.exports = Component.exports


/***/ }),
/* 737 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(427),
  /* template */
  __webpack_require__(895),
  /* scopeId */
  null,
  /* cssModules */
  null
)
Component.options.__file = "/opt/build/repo/src/pages/enterprise/components/subProjectTypes.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key !== "__esModule"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] subProjectTypes.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-fd6ce220", Component.options)
  } else {
    hotAPI.reload("data-v-fd6ce220", Component.options)
  }
})()}

module.exports = Component.exports


/***/ }),
/* 738 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(428),
  /* template */
  __webpack_require__(780),
  /* scopeId */
  null,
  /* cssModules */
  null
)
Component.options.__file = "/opt/build/repo/src/pages/enterprise/components/subProjectTypesSingle.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key !== "__esModule"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] subProjectTypesSingle.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-0af7e958", Component.options)
  } else {
    hotAPI.reload("data-v-0af7e958", Component.options)
  }
})()}

module.exports = Component.exports


/***/ }),
/* 739 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(429),
  /* template */
  __webpack_require__(805),
  /* scopeId */
  null,
  /* cssModules */
  null
)
Component.options.__file = "/opt/build/repo/src/pages/enterprise/components/subProjects.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key !== "__esModule"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] subProjects.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-2a91a18a", Component.options)
  } else {
    hotAPI.reload("data-v-2a91a18a", Component.options)
  }
})()}

module.exports = Component.exports


/***/ }),
/* 740 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(430),
  /* template */
  __webpack_require__(808),
  /* scopeId */
  null,
  /* cssModules */
  null
)
Component.options.__file = "/opt/build/repo/src/pages/enterprise/index.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key !== "__esModule"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] index.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-2d9a7c39", Component.options)
  } else {
    hotAPI.reload("data-v-2d9a7c39", Component.options)
  }
})()}

module.exports = Component.exports


/***/ }),
/* 741 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(928)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(431),
  /* template */
  __webpack_require__(836),
  /* scopeId */
  "data-v-55170067",
  /* cssModules */
  null
)
Component.options.__file = "/opt/build/repo/src/pages/index/components/valueChain.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key !== "__esModule"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] valueChain.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-55170067", Component.options)
  } else {
    hotAPI.reload("data-v-55170067", Component.options)
  }
})()}

module.exports = Component.exports


/***/ }),
/* 742 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(939)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(432),
  /* template */
  __webpack_require__(866),
  /* scopeId */
  null,
  /* cssModules */
  null
)
Component.options.__file = "/opt/build/repo/src/pages/index/index.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key !== "__esModule"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] index.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-7dd1bf60", Component.options)
  } else {
    hotAPI.reload("data-v-7dd1bf60", Component.options)
  }
})()}

module.exports = Component.exports


/***/ }),
/* 743 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(924)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(434),
  /* template */
  __webpack_require__(826),
  /* scopeId */
  "data-v-45eaf5ea",
  /* cssModules */
  null
)
Component.options.__file = "/opt/build/repo/src/pages/potential/components/projectTypesPotential.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key !== "__esModule"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] projectTypesPotential.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-45eaf5ea", Component.options)
  } else {
    hotAPI.reload("data-v-45eaf5ea", Component.options)
  }
})()}

module.exports = Component.exports


/***/ }),
/* 744 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(912)
__webpack_require__(911)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(435),
  /* template */
  __webpack_require__(798),
  /* scopeId */
  "data-v-238bdf1c",
  /* cssModules */
  null
)
Component.options.__file = "/opt/build/repo/src/pages/potential/index.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key !== "__esModule"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] index.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-238bdf1c", Component.options)
  } else {
    hotAPI.reload("data-v-238bdf1c", Component.options)
  }
})()}

module.exports = Component.exports


/***/ }),
/* 745 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(436),
  /* template */
  __webpack_require__(787),
  /* scopeId */
  null,
  /* cssModules */
  null
)
Component.options.__file = "/opt/build/repo/src/pages/projects/components/projectTypeCoveragePerHourDevelopment.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key !== "__esModule"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] projectTypeCoveragePerHourDevelopment.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-1679aeac", Component.options)
  } else {
    hotAPI.reload("data-v-1679aeac", Component.options)
  }
})()}

module.exports = Component.exports


/***/ }),
/* 746 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(437),
  /* template */
  __webpack_require__(854),
  /* scopeId */
  null,
  /* cssModules */
  null
)
Component.options.__file = "/opt/build/repo/src/pages/projects/components/projectTypeDevelopment.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key !== "__esModule"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] projectTypeDevelopment.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-6c73c961", Component.options)
  } else {
    hotAPI.reload("data-v-6c73c961", Component.options)
  }
})()}

module.exports = Component.exports


/***/ }),
/* 747 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(438),
  /* template */
  __webpack_require__(840),
  /* scopeId */
  null,
  /* cssModules */
  null
)
Component.options.__file = "/opt/build/repo/src/pages/projects/components/projectTypeSkills.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key !== "__esModule"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] projectTypeSkills.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-5949fbe8", Component.options)
  } else {
    hotAPI.reload("data-v-5949fbe8", Component.options)
  }
})()}

module.exports = Component.exports


/***/ }),
/* 748 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(439),
  /* template */
  __webpack_require__(775),
  /* scopeId */
  null,
  /* cssModules */
  null
)
Component.options.__file = "/opt/build/repo/src/pages/projects/components/projectTypeSkillsSingle.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key !== "__esModule"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] projectTypeSkillsSingle.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-02159774", Component.options)
  } else {
    hotAPI.reload("data-v-02159774", Component.options)
  }
})()}

module.exports = Component.exports


/***/ }),
/* 749 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(440),
  /* template */
  __webpack_require__(823),
  /* scopeId */
  null,
  /* cssModules */
  null
)
Component.options.__file = "/opt/build/repo/src/pages/projects/learning.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key !== "__esModule"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] learning.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-41150ece", Component.options)
  } else {
    hotAPI.reload("data-v-41150ece", Component.options)
  }
})()}

module.exports = Component.exports


/***/ }),
/* 750 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(441),
  /* template */
  __webpack_require__(838),
  /* scopeId */
  null,
  /* cssModules */
  null
)
Component.options.__file = "/opt/build/repo/src/pages/projects/operations.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key !== "__esModule"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] operations.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-57fbb69c", Component.options)
  } else {
    hotAPI.reload("data-v-57fbb69c", Component.options)
  }
})()}

module.exports = Component.exports


/***/ }),
/* 751 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(934)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(442),
  /* template */
  __webpack_require__(848),
  /* scopeId */
  null,
  /* cssModules */
  null
)
Component.options.__file = "/opt/build/repo/src/pages/projects/projects.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key !== "__esModule"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] projects.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-6020b3ac", Component.options)
  } else {
    hotAPI.reload("data-v-6020b3ac", Component.options)
  }
})()}

module.exports = Component.exports


/***/ }),
/* 752 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(947)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(443),
  /* template */
  __webpack_require__(887),
  /* scopeId */
  "data-v-d921176c",
  /* cssModules */
  null
)
Component.options.__file = "/opt/build/repo/src/pages/register/register.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key !== "__esModule"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] register.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-d921176c", Component.options)
  } else {
    hotAPI.reload("data-v-d921176c", Component.options)
  }
})()}

module.exports = Component.exports


/***/ }),
/* 753 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(444),
  /* template */
  __webpack_require__(786),
  /* scopeId */
  null,
  /* cssModules */
  null
)
Component.options.__file = "/opt/build/repo/src/pages/responsibles/index.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key !== "__esModule"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] index.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-15d9b2d5", Component.options)
  } else {
    hotAPI.reload("data-v-15d9b2d5", Component.options)
  }
})()}

module.exports = Component.exports


/***/ }),
/* 754 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(445),
  /* template */
  __webpack_require__(852),
  /* scopeId */
  null,
  /* cssModules */
  null
)
Component.options.__file = "/opt/build/repo/src/pages/responsibles/learning/compareProjectTypesForResponsibles.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key !== "__esModule"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] compareProjectTypesForResponsibles.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-6b20ccd5", Component.options)
  } else {
    hotAPI.reload("data-v-6b20ccd5", Component.options)
  }
})()}

module.exports = Component.exports


/***/ }),
/* 755 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(446),
  /* template */
  __webpack_require__(779),
  /* scopeId */
  null,
  /* cssModules */
  null
)
Component.options.__file = "/opt/build/repo/src/pages/responsibles/learning/compareResponsibleEmployees.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key !== "__esModule"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] compareResponsibleEmployees.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-07bd4ce0", Component.options)
  } else {
    hotAPI.reload("data-v-07bd4ce0", Component.options)
  }
})()}

module.exports = Component.exports


/***/ }),
/* 756 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(447),
  /* template */
  __webpack_require__(814),
  /* scopeId */
  null,
  /* cssModules */
  null
)
Component.options.__file = "/opt/build/repo/src/pages/responsibles/learning/components/projectTypesProjects.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key !== "__esModule"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] projectTypesProjects.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-33b1612f", Component.options)
  } else {
    hotAPI.reload("data-v-33b1612f", Component.options)
  }
})()}

module.exports = Component.exports


/***/ }),
/* 757 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(448),
  /* template */
  __webpack_require__(896),
  /* scopeId */
  null,
  /* cssModules */
  null
)
Component.options.__file = "/opt/build/repo/src/pages/responsibles/learning/components/projectTypesResponsibles.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key !== "__esModule"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] projectTypesResponsibles.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-ff591e1c", Component.options)
  } else {
    hotAPI.reload("data-v-ff591e1c", Component.options)
  }
})()}

module.exports = Component.exports


/***/ }),
/* 758 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(449),
  /* template */
  __webpack_require__(788),
  /* scopeId */
  null,
  /* cssModules */
  null
)
Component.options.__file = "/opt/build/repo/src/pages/responsibles/learning/components/responsibleProjectTypes.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key !== "__esModule"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] responsibleProjectTypes.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-168dfb51", Component.options)
  } else {
    hotAPI.reload("data-v-168dfb51", Component.options)
  }
})()}

module.exports = Component.exports


/***/ }),
/* 759 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(450),
  /* template */
  __webpack_require__(842),
  /* scopeId */
  null,
  /* cssModules */
  null
)
Component.options.__file = "/opt/build/repo/src/pages/responsibles/learning/components/responsibleProjects.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key !== "__esModule"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] responsibleProjects.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-5a15332a", Component.options)
  } else {
    hotAPI.reload("data-v-5a15332a", Component.options)
  }
})()}

module.exports = Component.exports


/***/ }),
/* 760 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(950)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(451),
  /* template */
  __webpack_require__(892),
  /* scopeId */
  "data-v-ed1d8338",
  /* cssModules */
  null
)
Component.options.__file = "/opt/build/repo/src/pages/settings/components/accountPlan.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key !== "__esModule"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] accountPlan.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-ed1d8338", Component.options)
  } else {
    hotAPI.reload("data-v-ed1d8338", Component.options)
  }
})()}

module.exports = Component.exports


/***/ }),
/* 761 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(929)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(452),
  /* template */
  __webpack_require__(837),
  /* scopeId */
  "data-v-57bd4472",
  /* cssModules */
  null
)
Component.options.__file = "/opt/build/repo/src/pages/settings/components/budget.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key !== "__esModule"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] budget.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-57bd4472", Component.options)
  } else {
    hotAPI.reload("data-v-57bd4472", Component.options)
  }
})()}

module.exports = Component.exports


/***/ }),
/* 762 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(948)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(453),
  /* template */
  __webpack_require__(888),
  /* scopeId */
  "data-v-db2305ca",
  /* cssModules */
  null
)
Component.options.__file = "/opt/build/repo/src/pages/settings/components/changeCompany.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key !== "__esModule"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] changeCompany.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-db2305ca", Component.options)
  } else {
    hotAPI.reload("data-v-db2305ca", Component.options)
  }
})()}

module.exports = Component.exports


/***/ }),
/* 763 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(454),
  /* template */
  __webpack_require__(870),
  /* scopeId */
  null,
  /* cssModules */
  null
)
Component.options.__file = "/opt/build/repo/src/pages/settings/components/cleanup.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key !== "__esModule"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] cleanup.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-96b483dc", Component.options)
  } else {
    hotAPI.reload("data-v-96b483dc", Component.options)
  }
})()}

module.exports = Component.exports


/***/ }),
/* 764 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(921)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(455),
  /* template */
  __webpack_require__(815),
  /* scopeId */
  "data-v-3756a0f3",
  /* cssModules */
  null
)
Component.options.__file = "/opt/build/repo/src/pages/settings/components/employees.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key !== "__esModule"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] employees.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-3756a0f3", Component.options)
  } else {
    hotAPI.reload("data-v-3756a0f3", Component.options)
  }
})()}

module.exports = Component.exports


/***/ }),
/* 765 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(942)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(456),
  /* template */
  __webpack_require__(877),
  /* scopeId */
  "data-v-ad10ac3c",
  /* cssModules */
  null
)
Component.options.__file = "/opt/build/repo/src/pages/settings/components/excludeProjects.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key !== "__esModule"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] excludeProjects.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-ad10ac3c", Component.options)
  } else {
    hotAPI.reload("data-v-ad10ac3c", Component.options)
  }
})()}

module.exports = Component.exports


/***/ }),
/* 766 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(922)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(457),
  /* template */
  __webpack_require__(817),
  /* scopeId */
  "data-v-3d3aa354",
  /* cssModules */
  null
)
Component.options.__file = "/opt/build/repo/src/pages/settings/components/general.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key !== "__esModule"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] general.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-3d3aa354", Component.options)
  } else {
    hotAPI.reload("data-v-3d3aa354", Component.options)
  }
})()}

module.exports = Component.exports


/***/ }),
/* 767 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(937)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(458),
  /* template */
  __webpack_require__(861),
  /* scopeId */
  "data-v-74a30572",
  /* cssModules */
  null
)
Component.options.__file = "/opt/build/repo/src/pages/settings/components/projectStatuses.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key !== "__esModule"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] projectStatuses.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-74a30572", Component.options)
  } else {
    hotAPI.reload("data-v-74a30572", Component.options)
  }
})()}

module.exports = Component.exports


/***/ }),
/* 768 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(459),
  /* template */
  __webpack_require__(830),
  /* scopeId */
  null,
  /* cssModules */
  null
)
Component.options.__file = "/opt/build/repo/src/pages/settings/components/projectsMissingBudget.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key !== "__esModule"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] projectsMissingBudget.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-4ad6705f", Component.options)
  } else {
    hotAPI.reload("data-v-4ad6705f", Component.options)
  }
})()}

module.exports = Component.exports


/***/ }),
/* 769 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(914)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(460),
  /* template */
  __webpack_require__(800),
  /* scopeId */
  "data-v-242b0c66",
  /* cssModules */
  null
)
Component.options.__file = "/opt/build/repo/src/pages/settings/components/user.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key !== "__esModule"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] user.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-242b0c66", Component.options)
  } else {
    hotAPI.reload("data-v-242b0c66", Component.options)
  }
})()}

module.exports = Component.exports


/***/ }),
/* 770 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(930)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(461),
  /* template */
  __webpack_require__(841),
  /* scopeId */
  "data-v-59df3e14",
  /* cssModules */
  null
)
Component.options.__file = "/opt/build/repo/src/pages/settings/components/users.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key !== "__esModule"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] users.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-59df3e14", Component.options)
  } else {
    hotAPI.reload("data-v-59df3e14", Component.options)
  }
})()}

module.exports = Component.exports


/***/ }),
/* 771 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(462),
  /* template */
  __webpack_require__(874),
  /* scopeId */
  null,
  /* cssModules */
  null
)
Component.options.__file = "/opt/build/repo/src/pages/settings/components/valuechainCalculation.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key !== "__esModule"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] valuechainCalculation.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-a59a59b2", Component.options)
  } else {
    hotAPI.reload("data-v-a59a59b2", Component.options)
  }
})()}

module.exports = Component.exports


/***/ }),
/* 772 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(935)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(463),
  /* template */
  __webpack_require__(849),
  /* scopeId */
  "data-v-60f315bb",
  /* cssModules */
  null
)
Component.options.__file = "/opt/build/repo/src/pages/settings/index.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key !== "__esModule"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] index.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-60f315bb", Component.options)
  } else {
    hotAPI.reload("data-v-60f315bb", Component.options)
  }
})()}

module.exports = Component.exports


/***/ }),
/* 773 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  null,
  /* template */
  __webpack_require__(858),
  /* scopeId */
  null,
  /* cssModules */
  null
)
Component.options.__file = "/opt/build/repo/src/pages/superadmin/index.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key !== "__esModule"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] index.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-70ff05cc", Component.options)
  } else {
    hotAPI.reload("data-v-70ff05cc", Component.options)
  }
})()}

module.exports = Component.exports


/***/ }),
/* 774 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(927)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(350),
  /* template */
  __webpack_require__(835),
  /* scopeId */
  null,
  /* cssModules */
  null
)
Component.options.__file = "/opt/build/repo/node_modules/vue-dropdowns/Dropdown.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key !== "__esModule"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] Dropdown.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-52ebedca", Component.options)
  } else {
    hotAPI.reload("data-v-52ebedca", Component.options)
  }
})()}

module.exports = Component.exports


/***/ }),
/* 775 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "project-type-skills-single"
  }, [_c('div', {
    staticClass: "placeholder"
  }, [_c('div', {
    staticClass: "placeholder__heading"
  }, [_vm._v("\n            " + _vm._s(_vm.data.name) + "\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "placeholder"
  }, [_c('vue-good-table', {
    attrs: {
      "columns": _vm.columns,
      "rows": _vm.data.employees,
      "search-options": _vm.searchOptions,
      "pagination-options": _vm.paginationOptions,
      "sort-options": _vm.sortOptions,
      "styleClass": _vm.styleClass
    },
    scopedSlots: _vm._u([{
      key: "table-row",
      fn: function(props) {
        return [(props.column.field == 'coverage_percent') ? _c('div', {
          staticClass: "coverage-cell"
        }, [_vm._v("\n                        " + _vm._s(_vm._f("rounded")(props.row.coverage_percent)) + " \n                        "), (props.row.coverage_percent !== null) ? _c('div', {
          staticClass: "coverage-indicator",
          class: {
            'bad': props.row.coverage_percent < _vm.$store.state.config.companyMeta.settings.coverage_percent.medium.value, 'avg': _vm.$options.filters.rounded(props.row.coverage_percent) >= _vm.$store.state.config.companyMeta.settings.coverage_percent.medium.value, 'good': _vm.$options.filters.rounded(props.row.coverage_percent) >= _vm.$store.state.config.companyMeta.settings.coverage_percent.high.value
          }
        }) : _vm._e()]) : (props.column.field == 'first_name') ? _c('div', [_vm._v("\n                        " + _vm._s(props.row.first_name) + "\n                        " + _vm._s(props.row.last_name) + "\n                    ")]) : (props.column.field == 'name') ? _c('div', {
          staticClass: "table-column__description",
          attrs: {
            "title": props.row.name
          }
        }, [_vm._v("\n                        " + _vm._s(props.row.name) + "\n                    ")]) : (props.column.field == 'coverage') ? _c('div', [_vm._v("\n                        " + _vm._s(_vm._f("currency")(props.row.coverage)) + "\n                    ")]) : (props.column.field == 'invoices_total') ? _c('div', [_vm._v("\n                        " + _vm._s(_vm._f("currency")(props.row.invoices_total)) + "\n                    ")]) : (props.column.field == 'coverage_per_hour') ? _c('div', {
          staticClass: "coverage-cell"
        }, [_vm._v("\n                        " + _vm._s(_vm._f("currency")(props.row.coverage_per_hour)) + " \n                        "), (props.row.coverage_per_hour !== null) ? _c('div', {
          staticClass: "coverage-indicator",
          class: {
            'bad': props.row.coverage_per_hour < _vm.$store.state.config.companyMeta.settings.coverage_per_hour.medium.value, 'avg': _vm.$options.filters.rounded(props.row.coverage_per_hour) >= _vm.$store.state.config.companyMeta.settings.coverage_per_hour.medium.value, 'good': _vm.$options.filters.rounded(props.row.coverage_per_hour) >= _vm.$store.state.config.companyMeta.settings.coverage_per_hour.high.value
          }
        }) : _vm._e()]) : _c('div', {
          attrs: {
            "title": props.formattedRow[props.column.field]
          }
        }, [_vm._v("\n                        " + _vm._s(props.formattedRow[props.column.field]) + "\n                    ")])]
      }
    }])
  }, [_c('div', {
    attrs: {
      "slot": "emptystate"
    },
    slot: "emptystate"
  }, [_vm._v("\n                    Ingen data ...\n                ")])])], 1)])])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-02159774", module.exports)
  }
}

/***/ }),
/* 776 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "economy-learning-compare"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-6"
  }, [_c('div', {
    staticClass: "placeholder"
  }, [_c('div', {
    staticClass: "placeholder__heading"
  }, [_c('d-tooltip', {
    attrs: {
      "placement": "left",
      "identifier": "oekonomi.ebitda"
    }
  }), _vm._v("\n                    Kontoplan\n                ")], 1), _vm._v(" "), _c('div', {
    staticClass: "placeholder padding"
  }, [(_vm.accountingYearsCheck && 'last_year_closed' in _vm.accountingYearsCheck && _vm.accountingYearsCheck.last_year_closed === false && !_vm.$auth.user().name.includes('Demo')) ? _c('div', {
    staticClass: "warning"
  }, [_c('b', [_vm._v("OBS! Seneste regnskabsår (" + _vm._s(_vm.accountingYearsCheck.year) + ") er ikke lukket i e-conomic.")]), _vm._v("\n                        Dette betyder, at tallene i din kontoplan summeres for både seneste regnskabsår samt det nuværende. Log in på e-conomic og luk det seneste regnskabsår for at se de korrekte tal. OBS! Du kan lukke og åbne et regnskabsår lige så ofte, det er nødvendigt.\n                    ")]) : _vm._e(), _vm._v(" "), (_vm.sortedAccounts) ? _c('div', {
    staticClass: "ebitda-wrapper"
  }, [_vm._m(0), _vm._v(" "), _vm._l((_vm.sortedAccounts), function(accountCategory) {
    return _c('div', {
      key: accountCategory.uuid,
      staticClass: "line",
      class: {
        'bold': accountCategory.account_type === 'custom', 'selected': _vm.selectedAccountCategory && _vm.selectedAccountCategory.uuid === accountCategory.uuid
      },
      on: {
        "click": function($event) {
          return _vm.selectAccountCategory(accountCategory)
        }
      }
    }, [_c('div', {
      staticClass: "name"
    }, [_vm._v("\n                                " + _vm._s(accountCategory.name) + "\n                            ")]), _vm._v(" "), _c('div', {
      staticClass: "balance"
    }, [_vm._v("\n                                " + _vm._s(_vm._f("currency")(accountCategory.total_balance)) + "\n                            ")])])
  })], 2) : _c('box-loading', {
    attrs: {
      "height": "350"
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-6"
  }, [(_vm.selectedAccountCategory) ? _c('div', {
    staticClass: "placeholder"
  }, [_c('div', {
    staticClass: "placeholder__heading"
  }, [_vm._v("\n                    " + _vm._s(_vm.selectedAccountCategory.name) + "\n                ")]), _vm._v(" "), _c('div', {
    staticClass: "placeholder padding"
  }, [(_vm.selectedAccountCategory.accounts.length > 0) ? _c('div', {
    staticClass: "ebitda-wrapper child"
  }, [_vm._m(1), _vm._v(" "), _vm._l((_vm.selectedAccountCategory.accounts), function(account) {
    return (account.balance && account.balance !== '0.00' && !account.balance.startsWith('0.')) ? _c('div', {
      key: account.account_number,
      staticClass: "line"
    }, [_c('div', {
      staticClass: "name"
    }, [_vm._v("\n                                " + _vm._s(account.account_number) + "\n                                -\n                                " + _vm._s(account.name) + "\n                            ")]), _vm._v(" "), _c('div', {
      staticClass: "balance"
    }, [_vm._v("\n                                " + _vm._s(_vm._f("currency")(account.balance)) + "\n                            ")])]) : _vm._e()
  }), _vm._v(" "), _c('div', {
    staticClass: "line"
  }, [_c('div', {
    staticClass: "name"
  }, [_vm._v("\n                                " + _vm._s(_vm.selectedAccountCategory.name) + "\n                            ")]), _vm._v(" "), _c('div', {
    staticClass: "balance"
  }, [_vm._v("\n                                " + _vm._s(_vm._f("currency")(_vm.selectedAccountCategory.total_balance)) + "\n                            ")])])], 2) : _c('div', [_vm._v("\n                        Denne konto har ingen underkonti\n                    ")])])]) : _c('div', [_vm._v("\n                Vælg en konto for at se dens underkonti her\n            ")])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "line top"
  }, [_c('div', {
    staticClass: "name"
  }, [_vm._v("Konto")]), _vm._v(" "), _c('div', {
    staticClass: "balance"
  }, [_vm._v("Realiseret / bogført")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "line top"
  }, [_c('div', {
    staticClass: "name"
  }, [_vm._v("Konto")]), _vm._v(" "), _c('div', {
    staticClass: "balance"
  }, [_vm._v("Bogført")])])
}]}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-0466fc80", module.exports)
  }
}

/***/ }),
/* 777 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "summary-card"
  }, [_c('div', {
    staticClass: "heading"
  }, [_vm._v("\n        " + _vm._s(_vm.heading) + "\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "number"
  }, [_c('count-to', {
    attrs: {
      "startVal": 0,
      "endVal": parseInt(_vm.number, 10),
      "duration": 2000
    }
  })], 1)])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-06a459bd", module.exports)
  }
}

/***/ }),
/* 778 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "time-usage"
  }, [_c('div', {
    staticClass: "employee-switcher"
  }, [_c('div', {
    staticClass: "employee-switcher-option",
    class: {
      'selected': _vm.employeeWorkingFieldName === ''
    },
    on: {
      "click": function($event) {
        _vm.employeeWorkingFieldName = ''
      }
    }
  }, [_vm._v("\n            Alle medarbejdere\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "employee-switcher-option",
    class: {
      'selected': _vm.employeeWorkingFieldName === 'Svend, funktionær'
    },
    on: {
      "click": function($event) {
        _vm.employeeWorkingFieldName = 'Svend, funktionær'
      }
    }
  }, [_vm._v("\n            Svende, funktionær\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "employee-switcher-option",
    class: {
      'selected': _vm.employeeWorkingFieldName === 'Svend, timelønnet'
    },
    on: {
      "click": function($event) {
        _vm.employeeWorkingFieldName = 'Svend, timelønnet'
      }
    }
  }, [_vm._v("\n            Svende, timelønnet\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "employee-switcher-option",
    class: {
      'selected': _vm.employeeWorkingFieldName === 'Lærling'
    },
    on: {
      "click": function($event) {
        _vm.employeeWorkingFieldName = 'Lærling'
      }
    }
  }, [_vm._v("\n            Lærlinge\n        ")])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-12"
  }, [_c('div', {
    staticClass: "placeholder"
  }, [_c('div', {
    staticClass: "placeholder__heading"
  }, [_c('d-tooltip', {
    attrs: {
      "placement": "left",
      "identifier": "employees.timeUsage"
    }
  }), _vm._v("\n                    Opsummering\n                ")], 1), _vm._v(" "), _c('div', {
    staticClass: "placeholder padding"
  }, [(!_vm.loading) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-4"
  }, [_c('pie', {
    attrs: {
      "headline": "Tid brugt hos kunderne",
      "series": _vm.hoursDivision.series,
      "labels": _vm.hoursDivision.labels,
      "division": true
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-lg-4"
  }, [_c('pie', {
    attrs: {
      "headline": "Fordeling af tid hos kunderne",
      "series": _vm.hoursWithCustomers.series,
      "labels": _vm.hoursWithCustomers.labels,
      "division": false
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-lg-4"
  }, [_c('pie', {
    attrs: {
      "headline": "Fordeling af anden tid",
      "series": _vm.hoursWithoutCustomers.series,
      "labels": _vm.hoursWithoutCustomers.labels,
      "division": false
    }
  })], 1)]) : _c('box-loading', {
    attrs: {
      "height": "350"
    }
  })], 1)])])]), _vm._v(" "), _c('employee-time-usage', {
    attrs: {
      "employeeWorkingFieldName": _vm.employeeWorkingFieldName
    }
  })], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-06c72782", module.exports)
  }
}

/***/ }),
/* 779 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "compare-responsible-employees"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    class: _vm.selectedRow ? 'col-lg-3' : 'col-lg-6'
  }, [_c('div', {
    staticClass: "placeholder fit-content"
  }, [_c('div', {
    staticClass: "placeholder__heading"
  }, [_vm._v("\n                    Ansvarlige\n                ")]), _vm._v(" "), _c('div', {
    staticClass: "placeholder fit-content"
  }, [(!_vm.loading) ? _c('vue-good-table', {
    attrs: {
      "columns": _vm.columns,
      "rows": _vm.rows,
      "search-options": _vm.searchOptions,
      "pagination-options": _vm.paginationOptions,
      "sort-options": _vm.sortOptions,
      "styleClass": _vm.styleClass,
      "row-style-class": _vm.selectedRowClass
    },
    on: {
      "on-row-click": _vm.selectEmployee
    },
    scopedSlots: _vm._u([{
      key: "table-row",
      fn: function(props) {
        return [(props.column.field == 'coverage_percent') ? _c('div', {
          staticClass: "coverage-cell"
        }, [_vm._v("\n                                " + _vm._s(_vm._f("rounded")(props.row.coverage_percent)) + " \n                                "), (props.row.coverage_percent !== null) ? _c('div', {
          staticClass: "coverage-indicator",
          class: {
            'bad': props.row.coverage_percent < _vm.$store.state.config.companyMeta.settings.coverage_percent.medium.value, 'avg': _vm.$options.filters.rounded(props.row.coverage_percent) >= _vm.$store.state.config.companyMeta.settings.coverage_percent.medium.value, 'good': _vm.$options.filters.rounded(props.row.coverage_percent) >= _vm.$store.state.config.companyMeta.settings.coverage_percent.high.value
          }
        }) : _vm._e()]) : (props.column.field == 'total_revenue') ? _c('div', [_vm._v("\n                                " + _vm._s(_vm._f("currency")(props.row.total_revenue)) + "\n                            ")]) : (props.column.field == 'total_coverage') ? _c('div', [_vm._v("\n                                " + _vm._s(_vm._f("currency")(props.row.total_coverage)) + "\n                            ")]) : (props.column.field == 'coverage_per_hour') ? _c('div', {
          staticClass: "coverage-cell"
        }, [_vm._v("\n                                " + _vm._s(_vm._f("currency")(props.row.coverage_per_hour)) + " \n                                "), (props.row.coverage_per_hour !== null) ? _c('div', {
          staticClass: "coverage-indicator",
          class: {
            'bad': props.row.coverage_per_hour < _vm.$store.state.config.companyMeta.settings.coverage_per_hour.medium.value, 'avg': _vm.$options.filters.rounded(props.row.coverage_per_hour) >= _vm.$store.state.config.companyMeta.settings.coverage_per_hour.medium.value, 'good': _vm.$options.filters.rounded(props.row.coverage_per_hour) >= _vm.$store.state.config.companyMeta.settings.coverage_per_hour.high.value
          }
        }) : _vm._e()]) : _c('div', [_vm._v("\n                                " + _vm._s(props.formattedRow[props.column.field]) + "\n                            ")])]
      }
    }], null, false, 1445950624)
  }, [_c('div', {
    attrs: {
      "slot": "emptystate"
    },
    slot: "emptystate"
  }, [_vm._v("\n                            Ingen data. Husk at angive i indstillingerne hvilke medarbejdere, der skal listes her\n                        ")])]) : _c('box-loading', {
    attrs: {
      "height": "350"
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    class: _vm.selectedRow ? 'col-lg-9' : 'col-lg-6'
  }, [(!_vm.selectedRow) ? _c('div', {
    staticClass: "info"
  }, [_vm._v("\n                Vælg en ansvarlig for at se et overblik over de enkelte opgaver og opgavetyper her\n            ")]) : _vm._e(), _vm._v(" "), (_vm.selectedRow) ? _c('div', [_c('div', {
    staticStyle: {
      "margin-bottom": "5px"
    }
  }, [_c('a', {
    staticStyle: {
      "text-decoration": "none",
      "color": "#172b43",
      "font-weight": "600"
    },
    attrs: {
      "href": "javascript:void(0)"
    },
    on: {
      "click": function($event) {
        _vm.selectedRow = null
      }
    }
  }, [_c('i', {
    staticClass: "far fa-times"
  }), _vm._v(" Luk\n                    ")])])]) : _vm._e(), _vm._v(" "), (_vm.selectedRow) ? _c('responsible-project-types', {
    attrs: {
      "data": _vm.selectedRow
    }
  }) : _vm._e()], 1)])])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-07bd4ce0", module.exports)
  }
}

/***/ }),
/* 780 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "sub-project-types-single"
  }, [_c('div', {
    staticClass: "placeholder"
  }, [_c('div', {
    staticClass: "placeholder__heading"
  }, [_vm._v("\n            " + _vm._s(_vm.data.name) + "\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "placeholder"
  }, [_c('vue-good-table', {
    attrs: {
      "columns": _vm.columns,
      "rows": _vm.data.sub_projects,
      "search-options": _vm.searchOptions,
      "pagination-options": _vm.paginationOptions,
      "sort-options": _vm.sortOptions,
      "styleClass": _vm.styleClass
    },
    scopedSlots: _vm._u([{
      key: "table-row",
      fn: function(props) {
        return [(props.column.field == 'coverage_percent') ? _c('div', {
          staticClass: "coverage-cell"
        }, [_vm._v("\n                        " + _vm._s(_vm._f("rounded")(props.row.coverage_percent)) + " \n                        "), (props.row.coverage_percent !== null) ? _c('div', {
          staticClass: "coverage-indicator",
          class: {
            'bad': props.row.coverage_percent < _vm.$store.state.config.companyMeta.settings.coverage_percent.medium.value, 'avg': _vm.$options.filters.rounded(props.row.coverage_percent) >= _vm.$store.state.config.companyMeta.settings.coverage_percent.medium.value, 'good': _vm.$options.filters.rounded(props.row.coverage_percent) >= _vm.$store.state.config.companyMeta.settings.coverage_percent.high.value
          }
        }) : _vm._e()]) : (props.column.field == 'description') ? _c('div', {
          staticClass: "table-column__description",
          attrs: {
            "title": props.row.description
          }
        }, [_vm._v("\n                        " + _vm._s(props.row.description) + "\n                    ")]) : (props.column.field == 'coverage') ? _c('div', [_vm._v("\n                        " + _vm._s(_vm._f("currency")(props.row.coverage)) + "\n                    ")]) : (props.column.field == 'invoices_total') ? _c('div', {
          staticStyle: {
            "text-align": "left"
          }
        }, [_vm._v("\n                        " + _vm._s(_vm._f("currency")(props.row.invoices_total)) + "\n                    ")]) : (props.column.field == 'total_expenses') ? _c('div', {
          staticStyle: {
            "text-align": "left"
          }
        }, [_vm._v("\n                        " + _vm._s(_vm._f("currency")(props.row.total_expenses)) + "\n                    ")]) : (props.column.field == 'coverage_per_hour') ? _c('div', {
          staticClass: "coverage-cell"
        }, [_vm._v("\n                        " + _vm._s(_vm._f("currency")(props.row.coverage_per_hour)) + " \n                        "), (props.row.coverage_per_hour !== null) ? _c('div', {
          staticClass: "coverage-indicator",
          class: {
            'bad': props.row.coverage_per_hour < _vm.$store.state.config.companyMeta.settings.coverage_per_hour.medium.value, 'avg': _vm.$options.filters.rounded(props.row.coverage_per_hour) >= _vm.$store.state.config.companyMeta.settings.coverage_per_hour.medium.value, 'good': _vm.$options.filters.rounded(props.row.coverage_per_hour) >= _vm.$store.state.config.companyMeta.settings.coverage_per_hour.high.value
          }
        }) : _vm._e()]) : (props.column.field == 'name') ? _c('div', {
          staticClass: "table-column__description",
          attrs: {
            "title": props.row.name ? props.row.name : '-'
          }
        }, [_vm._v("\n                        " + _vm._s(props.row.name ? props.row.name : '-') + "\n                    ")]) : (props.column.field == 'budget') ? _c('div', [_vm._v("\n                        -\n                    ")]) : (props.column.field == 'efficiency') ? _c('div', [_vm._v("\n                        -\n                    ")]) : (props.column.field == 'total_expenses') ? _c('div', [_vm._v("\n                        " + _vm._s(_vm._f("currency")(props.row.total_expenses)) + "\n                    ")]) : _c('div', {
          attrs: {
            "title": props.formattedRow[props.column.field]
          }
        }, [_vm._v("\n                        " + _vm._s(props.formattedRow[props.column.field]) + "\n                    ")])]
      }
    }])
  }, [_c('div', {
    attrs: {
      "slot": "emptystate"
    },
    slot: "emptystate"
  }, [_vm._v("\n                    Ingen data ...\n                ")])])], 1)])])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-0af7e958", module.exports)
  }
}

/***/ }),
/* 781 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "customer-revenue"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-6"
  }, [_c('div', {
    staticClass: "placeholder"
  }, [_c('div', {
    staticClass: "placeholder__heading"
  }, [_c('d-tooltip', {
    attrs: {
      "placement": "left",
      "identifier": "customers.customerRevenue"
    }
  }), _vm._v("\n                    Hvilke konkrete kunder tjener vi penge på?\n                ")], 1), _vm._v(" "), _c('div', {
    staticClass: "placeholder"
  }, [(!_vm.loading) ? _c('vue-good-table', {
    attrs: {
      "columns": _vm.columns,
      "rows": _vm.rows,
      "search-options": _vm.searchOptions,
      "pagination-options": _vm.paginationOptions,
      "sort-options": _vm.sortOptions,
      "styleClass": _vm.styleClass,
      "row-style-class": _vm.selectedRowClass
    },
    on: {
      "on-row-click": _vm.selectCustomer
    },
    scopedSlots: _vm._u([{
      key: "table-row",
      fn: function(props) {
        return [(props.column.field == 'coverage_percent') ? _c('div', {
          staticClass: "coverage-cell"
        }, [_vm._v("\n                                " + _vm._s(_vm._f("rounded")(props.row.coverage_percent)) + " \n                                "), (props.row.coverage_percent !== null) ? _c('div', {
          staticClass: "coverage-indicator",
          class: {
            'bad': props.row.coverage_percent < _vm.$store.state.config.companyMeta.settings.coverage_percent.medium.value, 'avg': _vm.$options.filters.rounded(props.row.coverage_percent) >= _vm.$store.state.config.companyMeta.settings.coverage_percent.medium.value, 'good': _vm.$options.filters.rounded(props.row.coverage_percent) >= _vm.$store.state.config.companyMeta.settings.coverage_percent.high.value
          }
        }) : _vm._e()]) : (props.column.field == 'name') ? _c('div', {
          staticClass: "table-column__description",
          attrs: {
            "title": props.row.name
          }
        }, [_vm._v("\n                                " + _vm._s(props.row.name) + "\n                            ")]) : (props.column.field == 'coverage') ? _c('div', [_vm._v("\n                                " + _vm._s(_vm._f("currency")(props.row.coverage)) + "\n                            ")]) : (props.column.field == 'invoices_total') ? _c('div', [_vm._v("\n                                " + _vm._s(_vm._f("currency")(props.row.invoices_total)) + "\n                            ")]) : (props.column.field == 'coverage_per_hour') ? _c('div', {
          staticClass: "coverage-cell"
        }, [_vm._v("\n                                " + _vm._s(_vm._f("currency")(props.row.coverage_per_hour)) + " \n                                "), (props.row.coverage_per_hour !== null) ? _c('div', {
          staticClass: "coverage-indicator",
          class: {
            'bad': props.row.coverage_per_hour < _vm.$store.state.config.companyMeta.settings.coverage_per_hour.medium.value, 'avg': _vm.$options.filters.rounded(props.row.coverage_per_hour) >= _vm.$store.state.config.companyMeta.settings.coverage_per_hour.medium.value, 'good': _vm.$options.filters.rounded(props.row.coverage_per_hour) >= _vm.$store.state.config.companyMeta.settings.coverage_per_hour.high.value
          }
        }) : _vm._e()]) : _c('div', {
          attrs: {
            "title": props.formattedRow[props.column.field]
          }
        }, [_vm._v("\n                                " + _vm._s(props.formattedRow[props.column.field]) + "\n                            ")])]
      }
    }], null, false, 1508989395)
  }, [_c('div', {
    attrs: {
      "slot": "emptystate"
    },
    slot: "emptystate"
  }, [_vm._v("\n                            Ingen data ...\n                        ")])]) : _c('box-loading', {
    attrs: {
      "height": "350"
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-6"
  }, [(!_vm.selectedRow) ? _c('div', {
    staticClass: "info"
  }, [_vm._v("\n                Vælg en kunde for at se en liste over alle kundens opgaver\n            ")]) : _c('customer-revenue-single', {
    attrs: {
      "data": _vm.selectedRow
    }
  })], 1)])])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-0d5ac2ca", module.exports)
  }
}

/***/ }),
/* 782 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "compare-keyfigures"
  }, [_c('div', {
    staticClass: "placeholder"
  }, [_c('div', {
    staticClass: "placeholder__heading"
  }, [_c('d-tooltip', {
    attrs: {
      "placement": "left",
      "identifier": "economy.compare.keyFigures"
    }
  }), _vm._v("\n            Nøgletal\n        ")], 1), _vm._v(" "), _c('div', {
    staticClass: "placeholder"
  }, [(!_vm.loading) ? _c('vue-good-table', {
    attrs: {
      "columns": _vm.columns,
      "rows": _vm.rows,
      "search-options": _vm.searchOptions,
      "pagination-options": _vm.paginationOptions,
      "sort-options": _vm.sortOptions,
      "styleClass": _vm.styleClass
    },
    scopedSlots: _vm._u([{
      key: "table-row",
      fn: function(props) {
        return [(props.column.field == 'coverage_percent') ? _c('div', {
          staticClass: "coverage-cell"
        }, [(props.row.coverage_percent !== 0) ? _c('span', [_vm._v("\n                            " + _vm._s(_vm._f("rounded")(props.row.coverage_percent)) + " \n                            "), (props.row.coverage_percent !== null) ? _c('div', {
          staticClass: "coverage-indicator",
          class: {
            'bad': props.row.coverage_percent < _vm.$store.state.config.companyMeta.settings.coverage_percent.medium.value, 'avg': _vm.$options.filters.rounded(props.row.coverage_percent) >= _vm.$store.state.config.companyMeta.settings.coverage_percent.medium.value, 'good': _vm.$options.filters.rounded(props.row.coverage_percent) >= _vm.$store.state.config.companyMeta.settings.coverage_percent.high.value
          }
        }) : _vm._e()]) : _c('span', [_vm._v("\n                            -\n                        ")])]) : (props.column.field == 'total_revenue') ? _c('div', [(props.row.total_revenue !== 0) ? _c('span', [_vm._v("\n                            " + _vm._s(_vm._f("currency")(props.row.total_revenue)) + "\n                        ")]) : _c('span', [_vm._v("\n                            -\n                        ")])]) : (props.column.field == 'coverage') ? _c('div', [(props.row.coverage !== 0) ? _c('span', [_vm._v("\n                            " + _vm._s(_vm._f("currency")(props.row.coverage)) + "\n                        ")]) : _c('span', [_vm._v("\n                            -\n                        ")])]) : (props.column.field == 'coverage_per_hour') ? _c('div', {
          staticClass: "coverage-cell"
        }, [(props.row.coverage_per_hour !== 0) ? _c('span', [_vm._v("\n                            " + _vm._s(_vm._f("currency")(props.row.coverage_per_hour)) + " \n                            "), (props.row.coverage_per_hour !== null) ? _c('div', {
          staticClass: "coverage-indicator",
          class: {
            'bad': props.row.coverage_per_hour < _vm.$store.state.config.companyMeta.settings.coverage_per_hour.medium.value, 'avg': _vm.$options.filters.rounded(props.row.coverage_per_hour) >= _vm.$store.state.config.companyMeta.settings.coverage_per_hour.medium.value, 'good': _vm.$options.filters.rounded(props.row.coverage_per_hour) >= _vm.$store.state.config.companyMeta.settings.coverage_per_hour.high.value
          }
        }) : _vm._e()]) : _c('span', [_vm._v("\n                            -\n                        ")])]) : (props.column.field == 'hours_with_customers') ? _c('div', {
          staticClass: "coverage-cell",
          staticStyle: {
            "text-align": "left"
          }
        }, [(props.row.hours_with_customers !== 0) ? _c('span', [_vm._v("\n                            " + _vm._s(_vm._f("rounded")(props.row.hours_with_customers)) + " %\n                            "), (props.row.hours_with_customers) ? _c('div', {
          staticClass: "coverage-indicator",
          class: {
            'bad': props.row.hours_with_customers < _vm.$store.state.config.companyMeta.settings.timelogging.medium.value, 'avg': _vm.$options.filters.rounded(props.row.hours_with_customers) >= _vm.$store.state.config.companyMeta.settings.timelogging.medium.value, 'good': _vm.$options.filters.rounded(props.row.hours_with_customers) >= _vm.$store.state.config.companyMeta.settings.timelogging.high.value
          }
        }) : _vm._e()]) : _c('span', [_vm._v("\n                            -\n                        ")])]) : (props.column.field == 'name') ? _c('div', [_c('strong', [_vm._v(_vm._s(props.row.name))])]) : _c('div', [_vm._v("\n                        " + _vm._s(props.formattedRow[props.column.field]) + "\n                    ")])]
      }
    }], null, false, 2147335162)
  }, [_c('div', {
    attrs: {
      "slot": "emptystate"
    },
    slot: "emptystate"
  }, [_vm._v("\n                    Ingen data ...\n                ")])]) : _c('box-loading', {
    attrs: {
      "height": "350"
    }
  })], 1)])])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-0dd66fa2", module.exports)
  }
}

/***/ }),
/* 783 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "placeholder"
  }, [_c('div', {
    staticClass: "placeholder__heading"
  }, [_c('d-tooltip', {
    attrs: {
      "placement": "left",
      "identifier": "employees.claims"
    }
  }), _vm._v("\n        Afsluttede reklamationer\n    ")], 1), _vm._v(" "), _c('div', {
    staticClass: "placeholder"
  }, [(!_vm.loading) ? _c('vue-good-table', {
    attrs: {
      "columns": _vm.columns,
      "rows": _vm.rows,
      "search-options": _vm.searchOptions,
      "pagination-options": _vm.paginationOptions,
      "sort-options": _vm.sortOptions,
      "styleClass": _vm.styleClass
    },
    scopedSlots: _vm._u([{
      key: "table-row",
      fn: function(props) {
        return [(props.column.field == 'coverage_percent') ? _c('div', {
          staticClass: "coverage-cell"
        }, [_vm._v("\n                    " + _vm._s(_vm._f("rounded")(props.row.coverage_percent)) + " \n                    "), (props.row.coverage_percent !== null) ? _c('div', {
          staticClass: "coverage-indicator",
          class: {
            'bad': props.row.coverage_percent < _vm.$store.state.config.companyMeta.settings.coverage_percent.medium.value, 'avg': _vm.$options.filters.rounded(props.row.coverage_percent) >= _vm.$store.state.config.companyMeta.settings.coverage_percent.medium.value, 'good': _vm.$options.filters.rounded(props.row.coverage_percent) >= _vm.$store.state.config.companyMeta.settings.coverage_percent.high.value
          }
        }) : _vm._e()]) : (props.column.field == 'case_number') ? _c('div', {
          staticClass: "table-column__ordernumber",
          staticStyle: {
            "text-align": "left"
          }
        }, [_vm._v("\n                    " + _vm._s(props.row.case_number) + "\n                ")]) : (props.column.field == 'description') ? _c('div', {
          staticClass: "table-column__description",
          attrs: {
            "title": props.row.description
          }
        }, [_vm._v("\n                    " + _vm._s(props.row.description) + "\n                ")]) : (props.column.field == 'customer.name') ? _c('div', {
          staticClass: "table-column__customer",
          attrs: {
            "title": props.row.customer.name
          }
        }, [(props.row.customer) ? _c('span', [_vm._v("\n                        " + _vm._s(props.row.customer.name) + "\n                    ")]) : _c('span', [_vm._v(" - ")])]) : (props.column.field == 'invoices_total') ? _c('div', [_vm._v("\n                    " + _vm._s(_vm._f("currency")(props.row.invoices_total)) + "\n                ")]) : (props.column.field == 'coverage') ? _c('div', [_vm._v("\n                    " + _vm._s(_vm._f("currency")(props.row.invoices_total - props.row.total_expenses)) + "\n                ")]) : (props.column.field == 'coverage_per_hour') ? _c('div', {
          staticClass: "coverage-cell"
        }, [_vm._v("\n                    " + _vm._s(_vm._f("currency")(props.row.coverage_per_hour)) + " \n                    "), (props.row.coverage_per_hour !== null) ? _c('div', {
          staticClass: "coverage-indicator",
          class: {
            'bad': props.row.coverage_per_hour < _vm.$store.state.config.companyMeta.settings.coverage_per_hour.medium.value, 'avg': _vm.$options.filters.rounded(props.row.coverage_per_hour) >= _vm.$store.state.config.companyMeta.settings.coverage_per_hour.medium.value, 'good': _vm.$options.filters.rounded(props.row.coverage_per_hour) >= _vm.$store.state.config.companyMeta.settings.coverage_per_hour.high.value
          }
        }) : _vm._e()]) : (props.column.field == 'action') ? _c('div', {
          staticClass: "g-table__action",
          on: {
            "click": function($event) {
              return _vm.openExternalLink(props.row.external_id)
            }
          }
        }, [_c('i', {
          staticClass: "fad fa-eye"
        })]) : (props.column.field == 'start_date') ? _c('div', [_vm._v("\n                    " + _vm._s(_vm._f("moment")(props.row.start_date, "DD. MMM YYYY")) + "\n                ")]) : (props.column.field == 'minuba_external_id') ? _c('div', [_c('a', {
          staticClass: "minuba-link",
          attrs: {
            "href": 'https://app.minuba.dk/?op=casedetails&glist=' + props.row.minuba_external_id,
            "target": "_blank"
          }
        }, [_c('i', {
          staticClass: "fas fa-eye"
        })])]) : _c('div', {
          attrs: {
            "title": props.formattedRow[props.column.field]
          }
        }, [_vm._v("\n                    " + _vm._s(props.formattedRow[props.column.field]) + "\n                ")])]
      }
    }], null, false, 1030187739)
  }, [_c('div', {
    attrs: {
      "slot": "emptystate"
    },
    slot: "emptystate"
  }, [_vm._v("\n                Ingen data ...\n            ")])]) : _c('box-loading', {
    attrs: {
      "height": "350"
    }
  })], 1)])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-0f6346ab", module.exports)
  }
}

/***/ }),
/* 784 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "sidebar"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "menu-items"
  }, [_c('router-link', {
    staticClass: "menu-item",
    attrs: {
      "tag": "div",
      "to": {
        name: 'Index'
      }
    }
  }, [_c('div', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fad fa-fw fa-th-large"
  })]), _vm._v(" "), _c('div', {
    staticClass: "name"
  }, [_vm._v("\n                Overblik\n            ")])]), _vm._v(" "), (_vm.$auth.user().roles[0].name !== 'department-responsible') ? _c('router-link', {
    staticClass: "menu-item",
    class: {
      'router-link-exact-active': _vm.subIsActive('/oekonomi')
    },
    attrs: {
      "tag": "div",
      "to": {
        name: 'EconomyLearning'
      }
    }
  }, [_c('div', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fad fa-fw fa-wallet"
  })]), _vm._v(" "), _c('div', {
    staticClass: "name"
  }, [_vm._v("\n                Økonomi\n            ")])]) : _vm._e(), _vm._v(" "), _c('router-link', {
    staticClass: "menu-item",
    class: {
      'router-link-exact-active': _vm.subIsActive('/opgaver')
    },
    attrs: {
      "tag": "div",
      "to": {
        name: 'ProjectsLearning'
      }
    }
  }, [_c('div', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fad fa-fw fa-clipboard-list-check"
  })]), _vm._v(" "), _c('div', {
    staticClass: "name"
  }, [_vm._v("\n                Opgaver\n            ")])]), _vm._v(" "), _c('router-link', {
    staticClass: "menu-item",
    class: {
      'router-link-exact-active': _vm.subIsActive('/kunder')
    },
    attrs: {
      "tag": "div",
      "to": {
        name: 'CustomersLearning'
      }
    }
  }, [_c('div', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fad fa-fw fa-briefcase"
  })]), _vm._v(" "), _c('div', {
    staticClass: "name"
  }, [_vm._v("\n                Kunder\n            ")])]), _vm._v(" "), _c('router-link', {
    staticClass: "menu-item",
    class: {
      'router-link-exact-active': _vm.subIsActive('/medarbejdere')
    },
    attrs: {
      "tag": "div",
      "to": {
        name: 'EmployeesLearning'
      }
    }
  }, [_c('div', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fad fa-fw fa-users"
  })]), _vm._v(" "), _c('div', {
    staticClass: "name"
  }, [_vm._v("\n                Medarbejdere\n            ")])]), _vm._v(" "), _c('router-link', {
    staticClass: "menu-item",
    class: {
      'router-link-exact-active': _vm.subIsActive('/ansvarlige')
    },
    attrs: {
      "tag": "div",
      "to": {
        name: 'Responsibles'
      }
    }
  }, [_c('div', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fad fa-fw fa-user-hard-hat"
  })]), _vm._v(" "), _c('div', {
    staticClass: "name"
  }, [_vm._v("\n                Ansvarlige\n            ")])]), _vm._v(" "), (_vm.$auth.user().roles[0].name !== 'department-responsible') ? _c('router-link', {
    staticClass: "menu-item",
    class: {
      'router-link-exact-active': _vm.subIsActive('/potentiale')
    },
    attrs: {
      "tag": "div",
      "to": {
        name: 'Potential'
      }
    }
  }, [_c('div', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fas fa-fw fa-star"
  })]), _vm._v(" "), _c('div', {
    staticClass: "name"
  }, [_vm._v("\n                Potentiale\n            ")])]) : _vm._e(), _vm._v(" "), (_vm.$auth.user().roles[0].name !== 'user' && _vm.$auth.user().roles[0].name !== 'department-responsible') ? _c('router-link', {
    staticClass: "menu-item",
    attrs: {
      "tag": "div",
      "to": {
        name: 'Settings'
      }
    }
  }, [_c('div', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fad fa-fw fa-cog"
  })]), _vm._v(" "), _c('div', {
    staticClass: "name"
  }, [_vm._v("\n                Indstillinger\n            ")])]) : _vm._e(), _vm._v(" "), (_vm.$auth.user().roles[0].name === 'super-admin') ? _c('router-link', {
    staticClass: "menu-item",
    attrs: {
      "tag": "div",
      "to": {
        name: 'Enterprise'
      }
    }
  }, [_c('div', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fad fa-fw fa-tools"
  })]), _vm._v(" "), _c('div', {
    staticClass: "name"
  }, [_vm._v("\n                Entreprise\n            ")])]) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "bottom"
  }, [(_vm.lastSync) ? _c('div', {
    staticClass: "last-sync"
  }, [_vm._v("\n            Data opdateret:\n            "), _c('br'), _vm._v("\n            " + _vm._s(_vm.lastSync) + "\n        ")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "user",
    on: {
      "click": _vm.logout
    }
  }, [_c('div', {
    staticClass: "avatar"
  }, [_vm._v("\n                " + _vm._s(_vm.initials) + "\n            ")]), _vm._v(" "), _c('div', {
    staticClass: "text"
  }, [_c('div', {
    staticClass: "name"
  }, [_vm._v("\n                    " + _vm._s(_vm.$auth.user().name) + "\n                ")]), _vm._v(" "), (_vm.$store.state.config.companyMeta) ? _c('div', {
    staticClass: "company"
  }, [_vm._v("\n                    " + _vm._s(_vm.$store.state.config.companyMeta.name) + "\n                ")]) : _vm._e()])]), _vm._v(" "), (_vm.$auth.user().roles[0].name === 'super-admin') ? _c('router-link', {
    staticClass: "super-admin-options",
    attrs: {
      "tag": "div",
      "to": {
        name: 'ChangeCompany'
      }
    }
  }, [_c('div', {
    staticClass: "change-company"
  }, [_c('i', {
    staticClass: "fas fa-building fa-fw"
  }), _vm._v("\n                Skift virksomhed\n            ")])]) : _vm._e()], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "logo"
  }, [_c('img', {
    attrs: {
      "src": "/static/img/proebitda_logo_color.png"
    }
  })])
}]}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-1313447a", module.exports)
  }
}

/***/ }),
/* 785 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "customers-learning"
  }, [_c('content-switch', {
    attrs: {
      "items": _vm.switchItems,
      "selectedItem": _vm.selectedItem,
      "counts": _vm.counts
    },
    on: {
      "selectItem": function($event) {
        return _vm.handleSelectItem($event)
      }
    }
  }), _vm._v(" "), _c('customer-revenue', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.selectedItem === 'customerRevenue'),
      expression: "selectedItem === 'customerRevenue'"
    }],
    on: {
      "finishedLoading": function($event) {
        return _vm.updateCount('customerRevenue', $event)
      }
    }
  }), _vm._v(" "), _c('customer-type-revenue', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.selectedItem === 'customerTypeRevenue'),
      expression: "selectedItem === 'customerTypeRevenue'"
    }],
    on: {
      "finishedLoading": function($event) {
        return _vm.updateCount('customerTypeRevenue', $event)
      }
    }
  }), _vm._v(" "), _c('customer-revenue-grouped', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.selectedItem === 'customerRevenueGrouped'),
      expression: "selectedItem === 'customerRevenueGrouped'"
    }]
  })], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-1453ac26", module.exports)
  }
}

/***/ }),
/* 786 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "responsibles"
  }, [_c('box-helper', {
    attrs: {
      "headline": "Ansvarlige",
      "identifier": "responsibles"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "container section"
  }, [_c('title-block', {
    staticClass: "mb-xl",
    attrs: {
      "headline": "<b>Ansvarlige</b>",
      "position": "center"
    }
  }, [_c('p', {
    attrs: {
      "slot": "text"
    },
    slot: "text"
  }, [_vm._v("\n                Ét samlet overblik over dine ansvarlige\n            ")])]), _vm._v(" "), _c('content-switch', {
    attrs: {
      "items": _vm.switchItems,
      "selectedItem": _vm.selectedItem,
      "counts": _vm.counts
    },
    on: {
      "selectItem": function($event) {
        return _vm.handleSelectItem($event)
      }
    }
  }), _vm._v(" "), _c('compare-responsible-employees', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.selectedItem === 'compareResponsibleEmployees'),
      expression: "selectedItem === 'compareResponsibleEmployees'"
    }]
  }), _vm._v(" "), _c('compare-project-types-for-responsibles', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.selectedItem === 'compareProjectTypesForResponsibles'),
      expression: "selectedItem === 'compareProjectTypesForResponsibles'"
    }]
  })], 1)], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-15d9b2d5", module.exports)
  }
}

/***/ }),
/* 787 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "project-type-coverage-per-hour-development"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-6"
  }, [_c('div', {
    staticClass: "placeholder"
  }, [_c('div', {
    staticClass: "placeholder__heading"
  }, [_c('d-tooltip', {
    attrs: {
      "placement": "left",
      "identifier": "projects.coveragePerHourDevelopment"
    }
  }), _vm._v("\n                    Udviklingen i DB pr. time pr. opgavetype\n                ")], 1), _vm._v(" "), _c('div', {
    staticClass: "placeholder"
  }, [(!_vm.loading) ? _c('vue-good-table', {
    attrs: {
      "columns": _vm.columns,
      "rows": _vm.rows,
      "search-options": _vm.searchOptions,
      "pagination-options": _vm.paginationOptions,
      "sort-options": _vm.sortOptions,
      "styleClass": _vm.styleClass,
      "row-style-class": _vm.selectedRowClass
    },
    on: {
      "on-row-click": _vm.selectProjectType
    },
    scopedSlots: _vm._u([{
      key: "table-row",
      fn: function(props) {
        return [(props.column.field == 'progress_percent') ? _c('div', {
          staticStyle: {
            "text-align": "left"
          }
        }, [(props.row.progress_percent >= 5) ? _c('span', {
          staticClass: "color-good"
        }, [_c('i', {
          staticClass: "fas fa-arrow-up"
        })]) : (props.row.progress_percent === 0 || props.row.progress_percent > -5 && props.row.progress_percent < 5) ? _c('span', [_c('i', {
          staticClass: "fas fa-arrow-right color-avg"
        })]) : _c('span', {
          staticClass: "color-bad"
        }, [_c('i', {
          staticClass: "fas fa-arrow-down"
        })])]) : (props.column.field == 'coverage_per_hour_avg') ? _c('div', {
          staticStyle: {
            "text-align": "left"
          }
        }, [_vm._v("\n                                " + _vm._s(_vm._f("currency")(props.row.coverage_per_hour_avg)) + " \n                                "), (props.row.coverage_per_hour_avg) ? _c('div', {
          staticClass: "coverage-indicator",
          class: {
            'bad': props.row.coverage_per_hour_avg < _vm.$store.state.config.companyMeta.settings.coverage_per_hour.medium.value, 'avg': _vm.$options.filters.rounded(props.row.coverage_per_hour_avg) >= _vm.$store.state.config.companyMeta.settings.coverage_per_hour.medium.value, 'good': _vm.$options.filters.rounded(props.row.coverage_per_hour_avg) >= _vm.$store.state.config.companyMeta.settings.coverage_per_hour.high.value
          }
        }) : _vm._e()]) : (props.column.field == 'projects_count') ? _c('div', {
          staticStyle: {
            "text-align": "left"
          }
        }, [_vm._v("\n                                " + _vm._s(_vm._f("number")(props.row.projects_count)) + "\n                            ")]) : (props.column.field == 'name') ? _c('div', {
          staticClass: "table-column__description",
          attrs: {
            "title": props.row.name ? props.row.name : '-'
          }
        }, [_vm._v("\n                                " + _vm._s(props.row.name ? props.row.name : '-') + "\n                            ")]) : _c('div', {
          attrs: {
            "title": props.formattedRow[props.column.field]
          }
        }, [_vm._v("\n                                " + _vm._s(props.formattedRow[props.column.field]) + "\n                            ")])]
      }
    }], null, false, 1958614940)
  }, [_c('div', {
    attrs: {
      "slot": "emptystate"
    },
    slot: "emptystate"
  }, [_vm._v("\n                            Ingen data ...\n                        ")])]) : _c('box-loading', {
    attrs: {
      "height": "350"
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-6"
  }, [(!_vm.loading && _vm.series.length > 0) ? _c('div', {
    staticClass: "placeholder fit-content"
  }, [_c('div', {
    staticClass: "placeholder__heading"
  }, [_vm._v("\n                    " + _vm._s(_vm.series[0].name) + "\n                ")]), _vm._v(" "), _c('div', {
    staticClass: "placeholder padding"
  }, [(!_vm.loading && _vm.series.length > 0) ? _c('vue-apex-charts', {
    ref: "tester",
    attrs: {
      "height": _vm.height,
      "options": _vm.options,
      "series": _vm.series,
      "type": "line"
    }
  }) : _vm._e()], 1)]) : _c('div', [_vm._v("\n                Vælg en opgavetype for at se fremgangen i en graf\n            ")])])])])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-1679aeac", module.exports)
  }
}

/***/ }),
/* 788 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "responsible-project-types"
  }, [_c('div', {
    staticClass: "placeholder mb-4"
  }, [_c('div', {
    staticClass: "placeholder__heading"
  }, [_vm._v("\n            " + _vm._s(_vm.data.name) + "\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "placeholder"
  }, [_c('vue-good-table', {
    attrs: {
      "columns": _vm.columns,
      "rows": _vm.data.project_types,
      "search-options": _vm.searchOptions,
      "pagination-options": _vm.paginationOptions,
      "sort-options": _vm.sortOptions,
      "styleClass": _vm.styleClass,
      "row-style-class": _vm.selectedRowClass
    },
    on: {
      "on-row-click": _vm.selectProjectType
    },
    scopedSlots: _vm._u([{
      key: "table-row",
      fn: function(props) {
        return [(props.column.field == 'coverage_percent') ? _c('div', {
          staticClass: "coverage-cell"
        }, [_vm._v("\n                        " + _vm._s(_vm._f("rounded")(props.row.coverage_percent)) + " \n                        "), (props.row.coverage_percent !== null) ? _c('div', {
          staticClass: "coverage-indicator",
          class: {
            'bad': props.row.coverage_percent < _vm.$store.state.config.companyMeta.settings.coverage_percent.medium.value, 'avg': _vm.$options.filters.rounded(props.row.coverage_percent) >= _vm.$store.state.config.companyMeta.settings.coverage_percent.medium.value, 'good': _vm.$options.filters.rounded(props.row.coverage_percent) >= _vm.$store.state.config.companyMeta.settings.coverage_percent.high.value
          }
        }) : _vm._e()]) : (props.column.field == 'total_revenue') ? _c('div', [_vm._v("\n                        " + _vm._s(_vm._f("currency")(props.row.total_revenue)) + "\n                    ")]) : (props.column.field == 'total_coverage') ? _c('div', [_vm._v("\n                        " + _vm._s(_vm._f("currency")(props.row.total_coverage)) + "\n                    ")]) : (props.column.field == 'coverage_per_hour') ? _c('div', {
          staticClass: "coverage-cell"
        }, [_vm._v("\n                        " + _vm._s(_vm._f("currency")(props.row.coverage_per_hour)) + " \n                        "), (props.row.coverage_per_hour !== null) ? _c('div', {
          staticClass: "coverage-indicator",
          class: {
            'bad': props.row.coverage_per_hour < _vm.$store.state.config.companyMeta.settings.coverage_per_hour.medium.value, 'avg': _vm.$options.filters.rounded(props.row.coverage_per_hour) >= _vm.$store.state.config.companyMeta.settings.coverage_per_hour.medium.value, 'good': _vm.$options.filters.rounded(props.row.coverage_per_hour) >= _vm.$store.state.config.companyMeta.settings.coverage_per_hour.high.value
          }
        }) : _vm._e()]) : _c('div', [_vm._v("\n                        " + _vm._s(props.formattedRow[props.column.field]) + "\n                    ")])]
      }
    }])
  }, [_c('div', {
    attrs: {
      "slot": "emptystate"
    },
    slot: "emptystate"
  }, [_vm._v("\n                    Ingen data ...\n                ")])])], 1)]), _vm._v(" "), (_vm.selectedRow) ? _c('responsible-projects', {
    attrs: {
      "data": _vm.selectedRow
    }
  }) : _c('div', [_vm._v("\n        Vælg en opgavetype for at se de enkelte opgaver her\n    ")])], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-168dfb51", module.exports)
  }
}

/***/ }),
/* 789 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "placeholder"
  }, [_c('div', {
    staticClass: "placeholder__heading"
  }, [_c('d-tooltip', {
    attrs: {
      "placement": "left",
      "identifier": "oekonomi.fordeling"
    }
  }), _vm._v("\n        Fordeling mellem time- og vareforbrug (kostpriser)\n    ")], 1), _vm._v(" "), (_vm.data && !_vm.loading && _vm.data.timeloggings.total > 0 && _vm.data.materials.total > 0) ? _c('div', {
    staticClass: "placeholder padding"
  }, [_c('div', {
    staticClass: "box"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "progress"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.data),
      expression: "data"
    }],
    staticClass: "timeloggings",
    style: ('width:' + _vm.data.timeloggings.percent + '%;')
  }), _vm._v(" "), _c('div', {
    staticClass: "overlay"
  }, [_c('div', {
    staticClass: "timeloggings-percent"
  }, [_vm._v("\n                        " + _vm._s(_vm._f("rounded")(_vm.data.timeloggings.percent)) + " %\n                    ")]), _vm._v(" "), _c('div', {
    staticClass: "materials-percent"
  }, [_vm._v("\n                        " + _vm._s(_vm._f("rounded")(_vm.data.materials.percent)) + " %\n                    ")])])]), _vm._v(" "), _c('div', {
    staticClass: "explainer"
  }, [_c('div', {
    staticClass: "timeloggings"
  }, [_vm._v("\n                    " + _vm._s(_vm._f("currency")(_vm.data.timeloggings.total)) + "\n                ")]), _vm._v(" "), _c('div', {
    staticClass: "materials"
  }, [_vm._v("\n                    " + _vm._s(_vm._f("currency")(_vm.data.materials.total)) + "\n                ")])])])]) : (!_vm.data && _vm.loading) ? _c('box-loading', {
    attrs: {
      "height": "350"
    }
  }) : _c('div', {
    staticClass: "placeholder padding"
  }, [_vm._v("\n        Vi kunne ikke udregne fordelingen af udgifter. Tjek, at du har angivet hvilke medarbejdere, der skal regnes med i denne udregning. Dette kan du ændre i indstillinger under \"Medarbejdere\"\n    ")])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "explainer bold"
  }, [_c('div', {
    staticClass: "timeloggings"
  }, [_c('i', {
    staticClass: "fas fa-clock fa-fw"
  }), _vm._v("\n                    Timer\n                ")]), _vm._v(" "), _c('div', {
    staticClass: "materials"
  }, [_vm._v("\n                    Materialer\n                    "), _c('i', {
    staticClass: "fas fa-wrench fa-fw"
  })])])
}]}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-1837e2a0", module.exports)
  }
}

/***/ }),
/* 790 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "employee-skills"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-4"
  }, [_c('div', {
    staticClass: "placeholder fit-content"
  }, [_c('div', {
    staticClass: "placeholder__heading"
  }, [_c('d-tooltip', {
    attrs: {
      "placement": "left",
      "identifier": "employees.employeeSkills"
    }
  }), _vm._v("\n                    Hvilke svende er gode til hvilke opgaver?\n                ")], 1), _vm._v(" "), _c('div', {
    staticClass: "placeholder fit-content"
  }, [(!_vm.loading) ? _c('vue-good-table', {
    attrs: {
      "columns": _vm.columns,
      "rows": _vm.rows,
      "search-options": _vm.searchOptions,
      "pagination-options": _vm.paginationOptions,
      "sort-options": _vm.sortOptions,
      "styleClass": _vm.styleClass,
      "row-style-class": _vm.selectedRowClass
    },
    on: {
      "on-row-click": _vm.selectEmployee
    },
    scopedSlots: _vm._u([{
      key: "table-row",
      fn: function(props) {
        return [_c('div', [_vm._v("\n                                " + _vm._s(props.formattedRow[props.column.field]) + "\n                            ")])]
      }
    }], null, false, 1212287911)
  }, [_c('div', {
    attrs: {
      "slot": "emptystate"
    },
    slot: "emptystate"
  }, [_vm._v("\n                            Ingen data ...\n                        ")])]) : _vm._e()], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-8"
  }, [(!_vm.selectedRow) ? _c('div', {
    staticClass: "info"
  }, [_vm._v("\n                Vælg en medarbejder for at se hvor god denne er til forskellige opgavetyper\n            ")]) : _c('employee-skills-single', {
    attrs: {
      "data": _vm.selectedRow
    }
  })], 1)])])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-185fd65c", module.exports)
  }
}

/***/ }),
/* 791 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "customers-learning"
  }, [_c('content-switch', {
    attrs: {
      "items": _vm.switchItems,
      "selectedItem": _vm.selectedItem,
      "counts": _vm.counts
    },
    on: {
      "selectItem": function($event) {
        return _vm.handleSelectItem($event)
      }
    }
  }), _vm._v(" "), _c('claims-table', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.selectedItem === 'claims'),
      expression: "selectedItem === 'claims'"
    }],
    on: {
      "finishedLoading": function($event) {
        return _vm.updateCount('claims', $event)
      }
    }
  })], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-1a5c4ccb", module.exports)
  }
}

/***/ }),
/* 792 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "loader"
  }, [_c('div', {
    staticClass: "inner"
  }, [_c('div', {
    staticClass: "lds-ellipsis"
  }, [_c('div'), _c('div'), _c('div'), _c('div')]), _vm._v(" "), _c('div', [_vm._v("Indlæser")])])])
}]}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-1bc34b89", module.exports)
  }
}

/***/ }),
/* 793 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.$auth.ready()) ? _c('div', {
    staticClass: "layout"
  }, [(_vm.$auth.check()) ? _c('div', [(_vm.$store.state.config.loaded) ? _c('div', {
    staticClass: "wrapper"
  }, [_c('div', {
    staticClass: "sidebar"
  }, [_c('sidebar')], 1), _vm._v(" "), _c('div', {
    staticClass: "page"
  }, [_c('config-bar'), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [_c('router-view')], 1), _vm._v(" "), _c('foo')], 1)]) : _c('loader')], 1) : _c('login')], 1) : _c('loader')
},staticRenderFns: []}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-1e6fb320", module.exports)
  }
}

/***/ }),
/* 794 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "economy-learning-claims"
  }, [_c('div', {
    staticClass: "placeholder"
  }, [_vm._m(0), _vm._v(" "), (_vm.data && !_vm.loading) ? _c('div', {
    staticClass: "placeholder padding"
  }, [_c('div', {
    staticClass: "intro"
  }, [_vm._v("\n                Hvordan vil din bundlinje se ud, hvis du kan opnå...\n            ")]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-3"
  }, [_c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "heading"
  }, [_vm._v("\n                            Flere timer hos kunderne\n                            "), _c('div', {
    staticClass: "small"
  }, [_vm._v("\n                                I dag: " + _vm._s(_vm.customerHours.now) + " %\n                            ")])]), _vm._v(" "), (_vm.customerHours.now > 0) ? _c('div', {
    staticClass: "slider"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.customerHours.value),
      expression: "customerHours.value"
    }],
    attrs: {
      "type": "range",
      "min": _vm.customerHours.min,
      "max": _vm.customerHours.max
    },
    domProps: {
      "value": (_vm.customerHours.value)
    },
    on: {
      "__r": function($event) {
        return _vm.$set(_vm.customerHours, "value", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('label', [_vm._v("\n                                +\n                                " + _vm._s(_vm.customerHours.value) + "\n                                " + _vm._s(_vm.customerHours.label) + "\n                            ")])]) : _vm._e(), _vm._v(" "), (_vm.customerHours.now > 0) ? _c('div', {
    staticClass: "result"
  }, [(_vm.customerHours.value != _vm.customerHours.min) ? _c('span', [_vm._v("\n                                + " + _vm._s(_vm._f("currency")(_vm.customerHoursTotal)) + "\n                            ")]) : _c('span', [_vm._v("\n                                -\n                            ")])]) : _c('div', {
    staticClass: "small"
  }, [_vm._v("\n                            Timer hos kunderne kan ikke udregnes. Tjek, at du har angivet hvilke medarbejdere, der skal tages med i denne udregning.\n                        ")]), _vm._v(" "), (_vm.customerHours.value != _vm.customerHours.min) ? _c('div', {
    staticClass: "small"
  }, [_vm._v("\n                            Udregningen svarer til, at svendene i gennemsnit bruger "), _c('b', [_vm._v(_vm._s(Number(_vm.customerHours.now) + Number(_vm.customerHours.value)) + "%")]), _vm._v(" af deres tid hos kunderne\n                        ")]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-3"
  }, [_c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "heading"
  }, [_vm._v("\n                            Meromsætning pr. opgave\n                            "), _c('div', {
    staticClass: "small"
  }, [_vm._v("\n                                I dag: " + _vm._s(_vm._f("currency")(_vm.data.revenue.avg_per_project)) + " pr. opgave\n                            ")])]), _vm._v(" "), _c('div', {
    staticClass: "slider"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.projectRevenue.value),
      expression: "projectRevenue.value"
    }],
    attrs: {
      "type": "range",
      "min": _vm.projectRevenue.min,
      "max": _vm.projectRevenue.max
    },
    domProps: {
      "value": (_vm.projectRevenue.value)
    },
    on: {
      "__r": function($event) {
        return _vm.$set(_vm.projectRevenue, "value", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('label', [_vm._v("\n                                +\n                                " + _vm._s(_vm.projectRevenue.value) + "\n                                " + _vm._s(_vm.projectRevenue.label) + "\n                            ")])]), _vm._v(" "), _c('div', {
    staticClass: "result"
  }, [(_vm.projectRevenue.value != _vm.projectRevenue.min) ? _c('span', [_vm._v("\n                                + " + _vm._s(_vm._f("currency")(_vm.projectRevenueTotal)) + "\n                            ")]) : _c('span', [_vm._v("\n                                -\n                            ")])]), _vm._v(" "), (_vm.projectRevenue.value != _vm.projectRevenue.min) ? _c('div', {
    staticClass: "small"
  }, [_vm._v("\n                            Udregningen svarer til, at den gennemsnitlige pris pr. opgave øges med "), _c('b', [_vm._v(_vm._s(_vm._f("currency")(_vm.projectRevenueTotal / _vm.data.revenue.total_projects)))])]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-3"
  }, [_c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "heading"
  }, [_vm._v("\n                            Besparelse på vareforbrug\n                            "), _c('div', {
    staticClass: "small"
  }, [_vm._v("\n                                I dag: " + _vm._s(_vm._f("currency")(_vm.data.materials.total / _vm.data.revenue.total_projects)) + " pr. opgave\n                            ")])]), _vm._v(" "), _c('div', {
    staticClass: "slider"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.materialsUsage.value),
      expression: "materialsUsage.value"
    }],
    attrs: {
      "type": "range",
      "min": _vm.materialsUsage.min,
      "max": _vm.materialsUsage.max
    },
    domProps: {
      "value": (_vm.materialsUsage.value)
    },
    on: {
      "__r": function($event) {
        return _vm.$set(_vm.materialsUsage, "value", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('label', [_vm._v("\n                                " + _vm._s(_vm.materialsUsage.value) + "\n                                " + _vm._s(_vm.materialsUsage.label) + "\n                            ")])]), _vm._v(" "), _c('div', {
    staticClass: "result"
  }, [(_vm.materialsUsage.value != _vm.materialsUsage.min) ? _c('span', [_vm._v("\n                                + " + _vm._s(_vm._f("currency")(_vm.materialsUsageTotal)) + "\n                            ")]) : _c('span', [_vm._v("\n                                -\n                            ")])]), _vm._v(" "), (_vm.materialsUsage.value != _vm.materialsUsage.min) ? _c('div', {
    staticClass: "small"
  }, [_vm._v("\n                            Udregningen svarer til, at den gennemsnitlige udgift til vareforbrug pr. opgave skal nedjusteres med "), _c('b', [_vm._v(_vm._s(_vm._f("currency")(_vm.materialsUsageTotal / _vm.data.revenue.total_projects)))])]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-3"
  }, [_c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "heading"
  }, [_vm._v("\n                            En forøgelse af mindste DG\n                            "), _c('div', {
    staticClass: "small"
  }, [_vm._v("\n                                Gns. DG pr. opgave i dag: " + _vm._s(_vm.data.coverage.average_percent) + "%\n                            ")])]), _vm._v(" "), _c('div', {
    staticClass: "slider"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.coveragePercent.value),
      expression: "coveragePercent.value"
    }],
    attrs: {
      "type": "range",
      "min": _vm.coveragePercent.min,
      "max": _vm.coveragePercent.max
    },
    domProps: {
      "value": (_vm.coveragePercent.value)
    },
    on: {
      "__r": function($event) {
        return _vm.$set(_vm.coveragePercent, "value", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('label', [_vm._v("\n                                " + _vm._s(_vm.coveragePercent.value) + "\n                                " + _vm._s(_vm.coveragePercent.label) + "\n                            ")])]), _vm._v(" "), _c('div', {
    staticClass: "result"
  }, [(_vm.coveragePercent.value != _vm.coveragePercent.min) ? _c('span', [_vm._v("\n                                + " + _vm._s(_vm._f("currency")(_vm.coveragePercentTotal)) + "\n                            ")]) : _c('span', [_vm._v("\n                                -\n                            ")])]), _vm._v(" "), (_vm.coveragePercent.value != _vm.coveragePercent.min) ? _c('div', {
    staticClass: "small"
  }, [_vm._v("\n                            Udregningen viser hvad du kan opnå, hvis du kan forbedre DG på alle opgaver til minimum "), _c('b', [_vm._v(_vm._s(_vm.coveragePercent.value) + "%")])]) : _vm._e()])])]), _vm._v(" "), _c('div', {
    staticClass: "break"
  }), _vm._v(" "), _c('div', {
    staticClass: "overview"
  }, [_c('div', {
    staticClass: "blank"
  }), _vm._v(" "), _c('div', {
    staticClass: "today"
  }, [_vm._v("\n                    EBITDA i dag\n                    "), _c('div', {
    staticClass: "value"
  }, [_vm._v("\n                        " + _vm._s(_vm._f("currency")(_vm.ebitda)) + "\n                    ")])]), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "potential"
  }, [_vm._v("\n                    Potentielt fremtidigt EBITDA\n                    "), (_vm.totalPotential != _vm.ebitda) ? _c('div', {
    staticClass: "value"
  }, [_vm._v("\n                        " + _vm._s(_vm._f("currency")(_vm.totalPotential)) + "\n                    ")]) : _c('div', {
    staticClass: "value"
  }, [_vm._v("\n                        -\n                    ")])]), _vm._v(" "), _c('div', {
    staticClass: "blank"
  })])]) : _c('box-loading', {
    attrs: {
      "height": "350"
    }
  })], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "placeholder__heading"
  }, [_vm._v("\n            Hvad kan give effekt "), _c('u', [_vm._v("direkte")]), _vm._v(" på bundlinjen?\n        ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "arrow"
  }, [_c('i', {
    staticClass: "far fa-arrow-right"
  })])
}]}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-1fe26433", module.exports)
  }
}

/***/ }),
/* 795 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "coming-soon"
  }, [_c('div', {
    staticClass: "inner"
  }, [_c('i', {
    staticClass: "fal fa-cog"
  }), _vm._v(" "), _c('br'), _vm._v("\n        Vi arbejder pt. på denne funktion. Kig ind senere!\n    ")])])
}]}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-20fa3fe5", module.exports)
  }
}

/***/ }),
/* 796 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "g-table-wrapper"
  }, [_c('div', {
    staticClass: "table-title"
  }, [_c('d-tooltip', {
    attrs: {
      "placement": "left",
      "identifier": "projects.projectTypeRevenue"
    }
  }), _vm._v("\n        " + _vm._s(_vm.title) + "\n    ")], 1), _vm._v(" "), (_vm.rows.length > 0 || _vm.$store.state.closedRows && _vm.$store.state.closedRows.length === 0) ? _c('vue-good-table', {
    attrs: {
      "columns": _vm.columns,
      "rows": _vm.rows,
      "search-options": _vm.searchOptions,
      "pagination-options": _vm.paginationOptions,
      "sort-options": _vm.sortOptions,
      "styleClass": _vm.styleClass,
      "row-style-class": _vm.selectedRowClass
    },
    on: {
      "on-row-click": _vm.selectProjectType
    },
    scopedSlots: _vm._u([{
      key: "table-row",
      fn: function(props) {
        return [(props.column.field == 'coverage_percent') ? _c('div', {
          staticClass: "coverage-cell"
        }, [_vm._v("\n                " + _vm._s(_vm._f("rounded")(props.row.coverage_percent)) + " \n                "), (props.row.coverage_percent !== null) ? _c('div', {
          staticClass: "coverage-indicator",
          class: {
            'bad': props.row.coverage_percent < _vm.$store.state.config.companyMeta.settings.coverage_percent.medium.value, 'avg': _vm.$options.filters.rounded(props.row.coverage_percent) >= _vm.$store.state.config.companyMeta.settings.coverage_percent.medium.value, 'good': _vm.$options.filters.rounded(props.row.coverage_percent) >= _vm.$store.state.config.companyMeta.settings.coverage_percent.high.value
          }
        }) : _vm._e()]) : (props.column.field == 'case_number') ? _c('div', {
          staticClass: "table-column__ordernumber",
          staticStyle: {
            "text-align": "left"
          }
        }, [_vm._v("\n                " + _vm._s(props.row.case_number) + "\n            ")]) : (props.column.field == 'description') ? _c('div', {
          attrs: {
            "title": props.row.description
          }
        }, [_vm._v("\n                " + _vm._s(_vm._f("truncate")(props.row.description)) + "\n            ")]) : (props.column.field == 'invoices_total') ? _c('div', [_vm._v("\n                " + _vm._s(_vm._f("currency")(props.row.invoices_total)) + "\n            ")]) : (props.column.field == 'coverage') ? _c('div', [_vm._v("\n                " + _vm._s(_vm._f("currency")(props.row.coverage)) + "\n            ")]) : (props.column.field == 'coverage_per_hour') ? _c('div', {
          staticClass: "coverage-cell"
        }, [_vm._v("\n                " + _vm._s(_vm._f("currency")(props.row.coverage_per_hour)) + " \n                "), (props.row.coverage_per_hour !== null) ? _c('div', {
          staticClass: "coverage-indicator",
          class: {
            'bad': props.row.coverage_per_hour < _vm.$store.state.config.companyMeta.settings.coverage_per_hour.medium.value, 'avg': _vm.$options.filters.rounded(props.row.coverage_per_hour) >= _vm.$store.state.config.companyMeta.settings.coverage_per_hour.medium.value, 'good': _vm.$options.filters.rounded(props.row.coverage_per_hour) >= _vm.$store.state.config.companyMeta.settings.coverage_per_hour.high.value
          }
        }) : _vm._e()]) : (props.column.field == 'action') ? _c('div', {
          staticClass: "g-table__action",
          on: {
            "click": function($event) {
              return _vm.openExternalLink(props.row.external_id)
            }
          }
        }, [_c('i', {
          staticClass: "fad fa-eye"
        })]) : (props.column.field == 'start_date') ? _c('div', [_vm._v("\n                " + _vm._s(_vm._f("moment")(props.row.start_date, "DD. MMM YYYY")) + "\n            ")]) : (props.column.field == 'type') ? _c('div', {
          staticClass: "table-column__description",
          attrs: {
            "title": props.row.type ? props.row.type : '-'
          }
        }, [_vm._v("\n                " + _vm._s(props.row.type ? props.row.type : '-') + "\n            ")]) : _c('div', {
          attrs: {
            "title": props.formattedRow[props.column.field]
          }
        }, [_vm._v("\n                " + _vm._s(props.formattedRow[props.column.field]) + "\n            ")])]
      }
    }], null, false, 2474449646)
  }, [_vm._v("\n    >\n        "), _c('div', {
    attrs: {
      "slot": "emptystate"
    },
    slot: "emptystate"
  }, [_vm._v("\n            Ingen data ...\n        ")])]) : _c('box-loading', {
    attrs: {
      "height": "350"
    }
  })], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-22694666", module.exports)
  }
}

/***/ }),
/* 797 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "display": "inline-block"
    }
  }, [_c('v-popover', {
    staticStyle: {
      "display": "inline-block"
    },
    attrs: {
      "offset": "16",
      "options": _vm.options,
      "open": _vm.show,
      "placement": "left"
    }
  }, [_c('button', {
    staticClass: "tooltip-target b3",
    staticStyle: {
      "display": "inline-block"
    },
    on: {
      "mouseover": function($event) {
        _vm.show = true
      },
      "mouseleave": function($event) {
        _vm.show = false
      }
    }
  }, [_c('i', {
    staticClass: "fas fa-usd-circle fa-fw"
  })]), _vm._v(" "), _c('template', {
    slot: "popover"
  }, [_c('div', {
    staticClass: "line good"
  }, [_c('div', {
    staticClass: "left"
  }, [_vm._v("Omsætning")]), _vm._v(" "), _c('div', {
    staticClass: "right good"
  }, [_vm._v(_vm._s(_vm._f("realCurrency")(_vm.project.invoices_total ? _vm.project.invoices_total : 0)))])]), _vm._v(" "), _c('div', {
    staticClass: "line bad"
  }, [_c('div', {
    staticClass: "left"
  }, [_vm._v(_vm._s(_vm._f("realNumber")(_vm.project.timelog_hours ? _vm.project.timelog_hours : 0)) + " timer")]), _vm._v(" "), _c('div', {
    staticClass: "right bad"
  }, [_vm._v(_vm._s(_vm._f("realCurrency")(_vm.project.timelog_total ? _vm.project.timelog_total : 0)))])]), _vm._v(" "), _c('div', {
    staticClass: "line bad"
  }, [_c('div', {
    staticClass: "left"
  }, [_vm._v(_vm._s(_vm._f("realNumber")(_vm.project.materials_count ? _vm.project.materials_count : 0)) + " materialer")]), _vm._v(" "), _c('div', {
    staticClass: "right bad"
  }, [_vm._v(_vm._s(_vm._f("realCurrency")(_vm.project.materials_total ? _vm.project.materials_total : 0)))])]), _vm._v(" "), _c('div', {
    staticClass: "divider",
    staticStyle: {
      "margin": "10px 0"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "line total"
  }, [_c('div', {
    staticClass: "left"
  }, [_vm._v("Dækningsbidrag")]), _vm._v(" "), _c('div', {
    staticClass: "right",
    class: {
      'good': _vm.project.coverage > 0, 'bad': _vm.project.coverage < 0
    }
  }, [_vm._v(_vm._s(_vm._f("realCurrency")(_vm.project.coverage ? _vm.project.coverage : 0)))])])])], 2)], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-22a330da", module.exports)
  }
}

/***/ }),
/* 798 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "potential"
  }, [_c('box-helper', {
    attrs: {
      "headline": "Potentiale",
      "identifier": "potential"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "container section"
  }, [_c('title-block', {
    staticClass: "mb-xl",
    attrs: {
      "headline": "<b>Virksomhedens potentiale</b>",
      "position": "center"
    }
  }, [_c('p', {
    attrs: {
      "slot": "text"
    },
    slot: "text"
  }, [_vm._v("\n                Hvor lidt skal der til for at forbedre bundlinjen?\n            ")])]), _vm._v(" "), _c('div', {
    staticClass: "economy-learning-claims"
  }, [_c('div', {
    staticClass: "placeholder"
  }, [_vm._m(0), _vm._v(" "), (_vm.data && !_vm.loading) ? _c('div', {
    staticClass: "placeholder padding"
  }, [_c('div', {
    staticClass: "intro"
  }, [_vm._v("\n                        Her ser du, hvad der skal til for at øge EBITDA med den eksisterende organisation. \n                    ")]), _vm._v(" "), _c('div', {
    staticClass: "box",
    staticStyle: {
      "margin-bottom": "15px",
      "padding-bottom": "15px",
      "border-bottom": "1px solid rgba(0,0,0,0.1)"
    }
  }, [_c('div', {
    staticClass: "row align-items-center"
  }, [_c('div', {
    staticClass: "col-lg-3"
  }, [_c('div', {
    staticClass: "heading",
    staticStyle: {
      "text-align": "left"
    }
  }, [_vm._v("\n                                    Flere timer hos kunderne\n                                    "), _c('d-tooltip', {
    attrs: {
      "placement": "inline",
      "identifier": "potential.moreCustomerHours",
      "icon": "question-square"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "small"
  }, [_vm._v("\n                                        I dag: " + _vm._s(_vm.customerHours.now) + " %\n                                    ")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-3"
  }, [(_vm.customerHours.now > 0) ? _c('div', {
    staticClass: "slider",
    staticStyle: {
      "margin": "0"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.customerHours.value),
      expression: "customerHours.value"
    }],
    staticStyle: {
      "margin-bottom": "10px"
    },
    attrs: {
      "type": "range",
      "min": _vm.customerHours.min,
      "max": _vm.customerHours.max
    },
    domProps: {
      "value": (_vm.customerHours.value)
    },
    on: {
      "__r": function($event) {
        return _vm.$set(_vm.customerHours, "value", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('label', [_vm._v("\n                                        +\n                                        " + _vm._s(_vm.customerHours.value) + "\n                                        " + _vm._s(_vm.customerHours.label) + "\n                                    ")])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-3"
  }, [(_vm.customerHours.now > 0) ? _c('div', {
    staticClass: "result"
  }, [(_vm.customerHours.value != _vm.customerHours.min) ? _c('span', [_vm._v("\n                                        + " + _vm._s(_vm._f("currency")(_vm.customerHoursTotal)) + "\n                                    ")]) : _c('span', [_vm._v("\n                                        -\n                                    ")])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-3"
  }, [(!_vm.customerHours.now > 0) ? _c('div', {
    staticClass: "small",
    staticStyle: {
      "margin-top": "0",
      "text-align": "left"
    }
  }, [_vm._v("\n                                    Timer hos kunderne kan ikke udregnes. Tjek, at du har angivet hvilke medarbejdere, der skal tages med i denne udregning.\n                                ")]) : _vm._e(), _vm._v(" "), (_vm.customerHours.value != _vm.customerHours.min) ? _c('div', {
    staticClass: "small",
    staticStyle: {
      "margin-top": "0",
      "text-align": "left"
    }
  }, [_vm._v("\n                                    Udregningen svarer til, at svendene i gennemsnit bruger "), _c('b', [_vm._v(_vm._s(Number(_vm.customerHours.now) + Number(_vm.customerHours.value)) + "%")]), _vm._v(" af deres tid hos kunderne\n                                ")]) : _vm._e()])])]), _vm._v(" "), _c('div', {
    staticClass: "box",
    staticStyle: {
      "margin-bottom": "15px",
      "padding-bottom": "15px",
      "border-bottom": "1px solid rgba(0,0,0,0.1)"
    }
  }, [_c('div', {
    staticClass: "row align-items-center"
  }, [_c('div', {
    staticClass: "col-lg-3"
  }, [_c('div', {
    staticClass: "heading",
    staticStyle: {
      "text-align": "left"
    }
  }, [_vm._v("\n                                    Meromsætning pr. opgave\n                                    "), _c('d-tooltip', {
    attrs: {
      "placement": "inline",
      "identifier": "potential.moreRevenue",
      "icon": "question-square"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "small"
  }, [_vm._v("\n                                        I dag: " + _vm._s(_vm._f("currency")(_vm.data.revenue.avg_per_project)) + " pr. opgave\n                                    ")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-3"
  }, [_c('div', {
    staticClass: "slider",
    staticStyle: {
      "margin": "0"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.projectRevenue.value),
      expression: "projectRevenue.value"
    }],
    staticStyle: {
      "margin-bottom": "10px"
    },
    attrs: {
      "type": "range",
      "min": _vm.projectRevenue.min,
      "max": _vm.projectRevenue.max
    },
    domProps: {
      "value": (_vm.projectRevenue.value)
    },
    on: {
      "__r": function($event) {
        return _vm.$set(_vm.projectRevenue, "value", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('label', [_vm._v("\n                                        +\n                                        " + _vm._s(_vm.projectRevenue.value) + "\n                                        " + _vm._s(_vm.projectRevenue.label) + "\n                                    ")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-3"
  }, [_c('div', {
    staticClass: "result"
  }, [(_vm.projectRevenue.value != _vm.projectRevenue.min) ? _c('span', [_vm._v("\n                                        + " + _vm._s(_vm._f("currency")(_vm.projectRevenueTotal)) + "\n                                    ")]) : _c('span', [_vm._v("\n                                        -\n                                    ")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-3"
  }, [(_vm.projectRevenue.value != _vm.projectRevenue.min) ? _c('div', {
    staticClass: "small",
    staticStyle: {
      "margin-top": "0",
      "text-align": "left"
    }
  }, [_vm._v("\n                                    Udregningen svarer til, at den gennemsnitlige pris pr. opgave øges med "), _c('b', [_vm._v(_vm._s(_vm._f("currency")(_vm.projectRevenueTotal / _vm.data.revenue.total_projects)))])]) : _vm._e()])])]), _vm._v(" "), _c('div', {
    staticClass: "box",
    staticStyle: {
      "margin-bottom": "15px",
      "padding-bottom": "15px",
      "border-bottom": "1px solid rgba(0,0,0,0.1)"
    }
  }, [_c('div', {
    staticClass: "row align-items-center"
  }, [_c('div', {
    staticClass: "col-lg-3"
  }, [_c('div', {
    staticClass: "heading",
    staticStyle: {
      "text-align": "left"
    }
  }, [_vm._v("\n                                    Besparelse på vareforbrug\n                                    "), _c('d-tooltip', {
    attrs: {
      "placement": "inline",
      "identifier": "potential.materialSavings",
      "icon": "question-square"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "small"
  }, [_vm._v("\n                                        I dag: " + _vm._s(_vm._f("currency")(_vm.data.materials.total / _vm.data.revenue.total_projects)) + " pr. opgave\n                                    ")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-3"
  }, [_c('div', {
    staticClass: "slider",
    staticStyle: {
      "margin": "0"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.materialsUsage.value),
      expression: "materialsUsage.value"
    }],
    staticStyle: {
      "margin-bottom": "10px"
    },
    attrs: {
      "type": "range",
      "min": _vm.materialsUsage.min,
      "max": _vm.materialsUsage.max
    },
    domProps: {
      "value": (_vm.materialsUsage.value)
    },
    on: {
      "__r": function($event) {
        return _vm.$set(_vm.materialsUsage, "value", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('label', [_vm._v("\n                                        " + _vm._s(_vm.materialsUsage.value) + "\n                                        " + _vm._s(_vm.materialsUsage.label) + "\n                                    ")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-3"
  }, [_c('div', {
    staticClass: "result"
  }, [(_vm.materialsUsage.value != _vm.materialsUsage.min) ? _c('span', [_vm._v("\n                                        + " + _vm._s(_vm._f("currency")(_vm.materialsUsageTotal)) + "\n                                    ")]) : _c('span', [_vm._v("\n                                        -\n                                    ")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-3"
  }, [(_vm.materialsUsage.value != _vm.materialsUsage.min) ? _c('div', {
    staticClass: "small",
    staticStyle: {
      "margin-top": "0",
      "text-align": "left"
    }
  }, [_vm._v("\n                                    Udregningen svarer til, at den gennemsnitlige udgift til vareforbrug pr. opgave skal nedjusteres med "), _c('b', [_vm._v(_vm._s(_vm._f("currency")(_vm.materialsUsageTotal / _vm.data.revenue.total_projects)))])]) : _vm._e()])])]), _vm._v(" "), _c('div', {
    staticClass: "box",
    staticStyle: {
      "margin-bottom": "15px",
      "padding-bottom": "15px",
      "border-bottom": "1px solid rgba(0,0,0,0.1)"
    }
  }, [_c('div', {
    staticClass: "row align-items-center"
  }, [_c('div', {
    staticClass: "col-lg-3"
  }, [_c('div', {
    staticClass: "heading",
    staticStyle: {
      "text-align": "left"
    }
  }, [_vm._v("\n                                    En forøgelse af mindste DG\n                                    "), _c('d-tooltip', {
    attrs: {
      "placement": "inline",
      "identifier": "potential.coverageIncrease",
      "icon": "question-square"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "small"
  }, [_vm._v("\n                                        Gns. DG pr. opgave i dag: " + _vm._s(_vm.data.coverage.average_percent) + "%\n                                    ")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-3"
  }, [_c('div', {
    staticClass: "slider",
    staticStyle: {
      "margin": "0"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.coveragePercent.value),
      expression: "coveragePercent.value"
    }],
    staticStyle: {
      "margin-bottom": "10px"
    },
    attrs: {
      "type": "range",
      "min": _vm.coveragePercent.min,
      "max": _vm.coveragePercent.max
    },
    domProps: {
      "value": (_vm.coveragePercent.value)
    },
    on: {
      "__r": function($event) {
        return _vm.$set(_vm.coveragePercent, "value", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('label', [_vm._v("\n                                        " + _vm._s(_vm.coveragePercent.value) + "\n                                        " + _vm._s(_vm.coveragePercent.label) + "\n                                    ")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-3"
  }, [_c('div', {
    staticClass: "result"
  }, [(_vm.coveragePercent.value != _vm.coveragePercent.min) ? _c('span', [_vm._v("\n                                        + " + _vm._s(_vm._f("currency")(_vm.coveragePercentTotal)) + "\n                                    ")]) : _c('span', [_vm._v("\n                                        -\n                                    ")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-3"
  }, [(_vm.coveragePercent.value != _vm.coveragePercent.min) ? _c('div', {
    staticClass: "small",
    staticStyle: {
      "margin-top": "0",
      "text-align": "left"
    }
  }, [_vm._v("\n                                    Udregningen viser hvad du kan opnå, hvis du kan forbedre DG på alle opgaver til minimum "), _c('b', [_vm._v(_vm._s(_vm.coveragePercent.value) + "%")])]) : _vm._e()])])]), _vm._v(" "), _c('div', {
    staticClass: "box last",
    staticStyle: {
      "margin-bottom": "15px"
    }
  }, [_c('div', {
    staticClass: "row align-items-center"
  }, [_c('div', {
    staticClass: "col-lg-3"
  }, [_c('div', {
    staticClass: "heading",
    staticStyle: {
      "text-align": "left"
    }
  }, [_vm._v("\n                                    Forøgelse af timepris\n                                    "), _c('d-tooltip', {
    attrs: {
      "placement": "inline",
      "identifier": "potential.hourPriceIncrease",
      "icon": "question-square"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "small"
  }, [_vm._v("\n                                        Timer i perioden: " + _vm._s(_vm._f("number")(_vm.data.timeloggings.total_with_project)) + "\n                                    ")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-3"
  }, [_c('div', {
    staticClass: "slider",
    staticStyle: {
      "margin": "0"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.hourPrice.value),
      expression: "hourPrice.value"
    }],
    staticStyle: {
      "margin-bottom": "10px"
    },
    attrs: {
      "type": "range",
      "min": _vm.hourPrice.min,
      "max": _vm.hourPrice.max
    },
    domProps: {
      "value": (_vm.hourPrice.value)
    },
    on: {
      "__r": function($event) {
        return _vm.$set(_vm.hourPrice, "value", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('label', [_vm._v("\n                                        " + _vm._s(_vm.hourPrice.value) + "\n                                        " + _vm._s(_vm.hourPrice.label) + "\n                                    ")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-3"
  }, [_c('div', {
    staticClass: "result"
  }, [(_vm.hourPrice.value != _vm.hourPrice.min) ? _c('span', [_vm._v("\n                                        + " + _vm._s(_vm._f("currency")(_vm.hourPriceTotal)) + "\n                                    ")]) : _c('span', [_vm._v("\n                                        -\n                                    ")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-3"
  }, [(_vm.hourPrice.value != _vm.hourPrice.min) ? _c('div', {
    staticClass: "small",
    staticStyle: {
      "margin-top": "0",
      "text-align": "left"
    }
  }, [_vm._v("\n                                    Udregningen viser hvad du kan opnå, hvis du forøger din timepris med "), _c('b', [_vm._v(_vm._s(_vm._f("currency")(_vm.hourPrice.value)))])]) : _vm._e()])])]), _vm._v(" "), _c('div', {
    staticClass: "overview"
  }, [_c('div', {
    staticClass: "row align-items-center"
  }, [_c('div', {
    staticClass: "col-lg-3"
  }, [_c('div', {
    staticClass: "today"
  }, [_vm._v("\n                                    EBITDA i dag\n                                    "), _c('div', {
    staticClass: "value"
  }, [_vm._v("\n                                        " + _vm._s(_vm._f("currency")(_vm.ebitda)) + "\n                                    ")])])]), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "col-lg-3"
  }, [_c('div', {
    staticClass: "potential"
  }, [_vm._v("\n                                    Potentielt årligt ekstra EBITDA\n                                    "), (_vm.totalPotential != _vm.ebitda) ? _c('div', {
    staticClass: "value"
  }, [(_vm.totalPotential > 0) ? _c('span', [_vm._v("+")]) : _vm._e(), _vm._v("\n                                        " + _vm._s(_vm._f("currency")(_vm.totalPotential)) + "\n                                    ")]) : _c('div', {
    staticClass: "value"
  }, [_vm._v("\n                                        -\n                                    ")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-3"
  }, [_vm._v("\n                                 \n                            ")])])])]) : _c('box-loading', {
    attrs: {
      "height": "350"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin": "15px 0px 30px 0px"
    }
  }, [_vm._v("\n                Tallene tager udgangspunkt i den valgte periode i toppen. Hvis du er i starten af et nyt regnskabsår, kan det give mening at vælge det forrige regnskabsår i toppen for at se et mere retvisende billede af potentialet for din virksomhed\n            ")]), _vm._v(" "), _c('project-types-potential')], 1)], 1)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "placeholder__heading"
  }, [_vm._v("\n                    Hvad kan give effekt "), _c('u', [_vm._v("direkte")]), _vm._v(" på bundlinjen?\n                ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-lg-3",
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('div', {
    staticClass: "arrow"
  }, [_c('i', {
    staticClass: "far fa-arrow-right"
  })])])
}]}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-238bdf1c", module.exports)
  }
}

/***/ }),
/* 799 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "no-data"
  }, [_vm._v("\n    Vi fandt desværre ingen data her.\n    "), _c('br'), _vm._v("\n    Hvis du mener dette er en fejl, så "), _c('a', {
    attrs: {
      "href": "mailto:troels@proebitda.dk"
    }
  }, [_vm._v("kontakt os")]), _vm._v(" venligst.\n")])
}]}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-23bfba74", module.exports)
  }
}

/***/ }),
/* 800 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "user"
  }, [_c('div', {
    staticClass: "small-title"
  }, [_vm._v("\n        Rediger dine oplysninger\n    ")]), _vm._v(" "), _c('form', {
    staticClass: "create-user",
    attrs: {
      "autocomplete": "off"
    }
  }, [_c('input', {
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "name": "hidden",
      "type": "text",
      "autocomplete": "off"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-6"
  }, [_c('div', {
    staticClass: "name"
  }, [_c('label', [_vm._v("Navn *")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.$auth.user().name),
      expression: "$auth.user().name"
    }],
    attrs: {
      "type": "text",
      "placeholder": "Navn"
    },
    domProps: {
      "value": (_vm.$auth.user().name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.$auth.user(), "name", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-6"
  }, [_c('label', [_vm._v("Brugerrolle")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "height": "40px",
      "line-height": "40px"
    }
  }, [(_vm.$auth.user().roles[0].name === 'super-admin') ? _c('span', [_vm._v("Super Admin")]) : _vm._e(), _vm._v(" "), (_vm.$auth.user().roles[0].name === 'admin') ? _c('span', [_vm._v("Administrator")]) : _vm._e(), _vm._v(" "), (_vm.$auth.user().roles[0].name === 'user') ? _c('span', [_vm._v("Bruger")]) : _vm._e()])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-6"
  }, [_c('div', {
    staticClass: "email"
  }, [_c('label', [_vm._v("E-mail *")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.$auth.user().email),
      expression: "$auth.user().email"
    }],
    attrs: {
      "type": "email",
      "name": "iufbw379fb",
      "placeholder": "E-mail"
    },
    domProps: {
      "value": (_vm.$auth.user().email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.$auth.user(), "email", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-6"
  }, [_c('div', {
    staticClass: "password"
  }, [_c('label', [_vm._v("Ny adgangskode *")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.new_password),
      expression: "user.new_password"
    }],
    attrs: {
      "type": "password",
      "autocomplete": "new-password",
      "placeholder": "Ny adgangskode"
    },
    domProps: {
      "value": (_vm.user.new_password)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.user, "new_password", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "small"
  }, [_vm._v("Min. 8 karakterer (udfyldes kun hvis du vil skifte adgangskode)")])])])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "action",
    attrs: {
      "align": "right"
    }
  }, [_c('div', {
    staticClass: "pretty-button",
    on: {
      "click": function($event) {
        return _vm.updateUser()
      }
    }
  }, [_vm._v("\n                Opdater\n            ")])])])])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-242b0c66", module.exports)
  }
}

/***/ }),
/* 801 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "sidebar-menu"
  }, [_c('div', {
    staticClass: "items"
  }, _vm._l((_vm.items), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "item",
      class: {
        'selected': _vm.selectedItem === item.slug
      },
      on: {
        "click": function($event) {
          return _vm.handleClick(item.slug)
        }
      }
    }, [_c('div', {
      staticClass: "inner"
    }, [(_vm.counts[item.slug] !== null && _vm.counts[item.slug] !== '-') ? _c('div', {
      staticClass: "count"
    }, [(_vm.counts[item.slug] !== null || _vm.counts[item.slug] !== '-') ? _c('span', [_vm._v("\n                        " + _vm._s(_vm.counts[item.slug]) + "\n                    ")]) : _vm._e()]) : (_vm.counts[item.slug] === '-') ? _c('div', {
      staticClass: "count"
    }, [_c('span', [_vm._v("\n                        -\n                    ")])]) : _c('div', {
      staticClass: "count"
    }, [_c('i', {
      staticClass: "fal fa-spinner fa-spin"
    })]), _vm._v(" "), (item.comingsoon) ? _c('div', {
      staticClass: "coming-soon"
    }, [_vm._v("\n                    Kommer snart\n                ")]) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "name"
    }, [_vm._v("\n                    " + _vm._s(item.name) + "\n                    "), (item.dTooltip) ? _c('d-tooltip', {
      attrs: {
        "placement": "inline",
        "identifier": item.dTooltip
      }
    }) : _vm._e()], 1)]), _vm._v(" "), (_vm.selectedItem === item.slug) ? _c('div', {
      staticClass: "icon"
    }, [_c('svg', {
      attrs: {
        "width": "600px",
        "height": "300px",
        "viewBox": "0 0 600 300",
        "version": "1.1",
        "xmlns": "http://www.w3.org/2000/svg",
        "xmlns:xlink": "http://www.w3.org/1999/xlink"
      }
    }, [_c('g', {
      attrs: {
        "id": "Page-1",
        "stroke": "none",
        "stroke-width": "1",
        "fill": "none",
        "fill-rule": "evenodd"
      }
    }, [_c('polygon', {
      attrs: {
        "id": "Rectangle",
        "fill": "#D8D8D8",
        "points": "0 0 600 0 300 300"
      }
    })])])]) : _vm._e()])
  }), 0)])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-25425858", module.exports)
  }
}

/***/ }),
/* 802 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "configbar"
  }, [_c('div', {
    attrs: {
      "align": "left"
    }
  }, [(_vm.$auth.user().roles[0].name === 'department-responsible' && _vm.selectedDepartment) ? _c('div', [_c('b', [_vm._v(_vm._s(_vm.selectedDepartment.name))]), _vm._v(" "), _c('br'), _vm._v(" "), _c('i', [_vm._v("Logget ind som afdelingsansvarlig")])]) : _c('div', [(_vm.selectedDepartment !== null) ? _c('dropdown', {
    attrs: {
      "options": _vm.departments,
      "selected": _vm.selectedDepartment,
      "placeholder": 'Vælg afdeling',
      "closeOnOutsideClick": true
    },
    on: {
      "updateOption": _vm.selectDepartment
    }
  }) : _vm._e()], 1)]), _vm._v(" "), _c('div', {
    staticClass: "date-range"
  }, [_c('div', {
    staticClass: "flex"
  }, [_vm._m(0), _vm._v(" "), _c('datepicker', {
    staticClass: "date-picker",
    attrs: {
      "monday-first": "",
      "language": _vm.datepickerLocale,
      "placeholder": "Startdato"
    },
    model: {
      value: (_vm.$store.state.config.startDate),
      callback: function($$v) {
        _vm.$set(_vm.$store.state.config, "startDate", $$v)
      },
      expression: "$store.state.config.startDate"
    }
  }), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('datepicker', {
    staticClass: "date-picker",
    attrs: {
      "monday-first": "",
      "language": _vm.datepickerLocale,
      "placeholder": "Slutdato"
    },
    model: {
      value: (_vm.$store.state.config.endDate),
      callback: function($$v) {
        _vm.$set(_vm.$store.state.config, "endDate", $$v)
      },
      expression: "$store.state.config.endDate"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "custom-time-period"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.selectedTimePeriod),
      expression: "selectedTimePeriod"
    }],
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.selectedTimePeriod = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, function($event) {
        return _vm.selectTimePeriod($event)
      }]
    }
  }, [_c('option', {
    attrs: {
      "value": "Vælg tidsinterval",
      "selected": "",
      "disabled": ""
    }
  }, [_vm._v("Vælg tidsinterval ↓")]), _vm._v(" "), _vm._l((_vm.customTimeIntervals), function(timeInterval, index) {
    return _c('option', {
      key: index,
      attrs: {
        "startDate": 2019,
        "endDate": 2020
      },
      domProps: {
        "value": timeInterval.name
      }
    }, [_vm._v("\n                    " + _vm._s(timeInterval.name) + "\n                ")])
  })], 2)])]), _vm._v(" "), _c('div', {
    staticClass: "smart",
    attrs: {
      "align": "right"
    }
  }, [_c('div', {
    staticClass: "options reversed"
  }, [_vm._m(2), _vm._v(" "), _vm._l((_vm.$store.state.config.availableAccountingYears), function(accountingYear, index) {
    return (index < 3) ? _c('div', {
      key: accountingYear.year,
      staticClass: "single-option",
      class: {
        'selected': accountingYear.from_date === _vm.$store.getters.getStartDate && accountingYear.to_date === _vm.$store.getters.getEndDate
      },
      on: {
        "click": function($event) {
          return _vm.selectAccountingYear(accountingYear)
        }
      }
    }, [_vm._v("\n                " + _vm._s(accountingYear.year) + "\n            ")]) : _vm._e()
  })], 2)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_c('b', [_vm._v("Vælg periode:")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('i', {
    staticClass: "fal fa-chevron-right"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "white-space": "nowrap",
      "margin-right": "30px"
    }
  }, [_c('b', [_vm._v("Vælg regnskabsår:")])])
}]}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-2631a998", module.exports)
  }
}

/***/ }),
/* 803 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "employee-time-usage"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-4"
  }, [_c('div', {
    staticClass: "placeholder fit-content"
  }, [_c('div', {
    staticClass: "placeholder__heading"
  }, [_vm._v("\n                    Medarbejdere\n                ")]), _vm._v(" "), _c('div', {
    staticClass: "placeholder"
  }, [(!_vm.loading) ? _c('vue-good-table', {
    attrs: {
      "columns": _vm.columns,
      "rows": _vm.rows,
      "search-options": _vm.searchOptions,
      "pagination-options": _vm.paginationOptions,
      "sort-options": _vm.sortOptions,
      "styleClass": _vm.styleClass,
      "row-style-class": _vm.selectedRowClass
    },
    on: {
      "on-row-click": _vm.selectCustomer
    },
    scopedSlots: _vm._u([{
      key: "table-row",
      fn: function(props) {
        return [(props.column.field == 'hoursWithCustomers') ? _c('div', [_vm._v("\n                                " + _vm._s(props.row.hoursWithCustomers) + " %\n                            ")]) : (props.column.field == 'sicknessPercent') ? _c('div', [_vm._v("\n                                " + _vm._s(props.row.sicknessPercent) + " %\n                            ")]) : _vm._e()]
      }
    }], null, false, 6116341)
  }) : _c('box-loading', {
    attrs: {
      "height": "350"
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-8"
  }, [(_vm.selectedRow && !_vm.loading) ? _c('div', {
    staticClass: "placeholder fit-content"
  }, [_c('div', {
    staticClass: "placeholder__heading"
  }, [_c('d-tooltip', {
    attrs: {
      "placement": "left",
      "identifier": "employees.timeUsage.singleEmployee"
    }
  }), _vm._v("\n                    " + _vm._s(_vm.selectedRow.name) + "\n                ")], 1), _vm._v(" "), _c('div', {
    staticClass: "placeholder padding"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-6"
  }, [(_vm.selectedRow !== null) ? _c('pie', {
    attrs: {
      "headline": "Tid brugt hos kunderne",
      "series": _vm.selectedRow.hours_division.series,
      "labels": _vm.selectedRow.hours_division.labels,
      "division": true
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "col-lg-6"
  }, [(_vm.selectedRow !== null) ? _c('pie', {
    attrs: {
      "headline": "Fordeling af tid hos kunderne",
      "series": _vm.selectedRow.hours_with_customers.series,
      "labels": _vm.selectedRow.hours_with_customers.labels,
      "division": false
    }
  }) : _vm._e()], 1)]), _vm._v(" "), _c('div', {
    staticClass: "divider"
  }), _vm._v(" "), (_vm.selectedRow !== null) ? _c('pie', {
    attrs: {
      "headline": "Fordeling af anden tid",
      "series": _vm.selectedRow.hours_without_customers.series,
      "labels": _vm.selectedRow.hours_without_customers.labels,
      "division": false
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('br'), _c('br'), _vm._v(" "), _c('b', [_vm._v("selectedRow")]), _c('br'), _vm._v("\n                        labels: " + _vm._s(_vm.selectedRow.hours_without_customers.labels)), _c('br'), _vm._v("\n                        series: " + _vm._s(_vm.selectedRow.hours_without_customers.series) + "\n                        "), _c('br'), _c('br'), _vm._v(" "), _c('b', [_vm._v("Allan Jensen")]), _c('br'), _vm._v("\n                        labels: " + _vm._s(_vm.rows[1].hours_without_customers.labels)), _c('br'), _vm._v("\n                        series: " + _vm._s(_vm.rows[1].hours_without_customers.series) + "\n                    ")])], 1)]) : _c('div', [_vm._v("\n                Vælg en svend for at se fordelingen af hans registrerede timer\n            ")])])])])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-2815c14f", module.exports)
  }
}

/***/ }),
/* 804 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "employees-sub-projects"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    class: {
      'col-lg-6': !_vm.selectedRow, 'col-lg-3': _vm.selectedRow
    }
  }, [_c('div', {
    staticClass: "placeholder fit-content"
  }, [_c('div', {
    staticClass: "placeholder__heading"
  }, [_vm._v("\n                    Medarbejdere\n                ")]), _vm._v(" "), _c('div', {
    staticClass: "placeholder"
  }, [(!_vm.loading) ? _c('vue-good-table', {
    attrs: {
      "columns": _vm.columns,
      "rows": _vm.rows,
      "search-options": _vm.searchOptions,
      "pagination-options": _vm.paginationOptions,
      "sort-options": _vm.sortOptions,
      "styleClass": _vm.styleClass,
      "row-style-class": _vm.selectedRowClass
    },
    on: {
      "on-row-click": _vm.selectEmployee
    },
    scopedSlots: _vm._u([{
      key: "table-row",
      fn: function(props) {
        return [(props.column.field == 'coverage_percent') ? _c('div', {
          staticClass: "coverage-cell"
        }, [_vm._v("\n                                " + _vm._s(_vm._f("rounded")(props.row.coverage_percent)) + " \n                                "), (props.row.coverage_percent !== null) ? _c('div', {
          staticClass: "coverage-indicator",
          class: {
            'bad': props.row.coverage_percent < _vm.$store.state.config.companyMeta.settings.coverage_percent.medium.value, 'avg': _vm.$options.filters.rounded(props.row.coverage_percent) >= _vm.$store.state.config.companyMeta.settings.coverage_percent.medium.value, 'good': _vm.$options.filters.rounded(props.row.coverage_percent) >= _vm.$store.state.config.companyMeta.settings.coverage_percent.high.value
          }
        }) : _vm._e()]) : (props.column.field == 'name') ? _c('div', {
          staticClass: "table-column__description",
          attrs: {
            "title": props.row.name ? props.row.name : '-'
          }
        }, [_vm._v("\n                                " + _vm._s(props.row.first_name ? ((props.row.first_name) + " " + (props.row.last_name)) : '-') + "\n                            ")]) : (props.column.field == 'coverage') ? _c('div', [_vm._v("\n                                " + _vm._s(_vm._f("currency")(props.row.coverage)) + "\n                            ")]) : (props.column.field == 'invoices_total') ? _c('div', [_vm._v("\n                                " + _vm._s(_vm._f("currency")(props.row.invoices_total)) + "\n                            ")]) : (props.column.field == 'coverage_per_hour') ? _c('div', {
          staticClass: "coverage-cell"
        }, [_vm._v("\n                                " + _vm._s(_vm._f("currency")(props.row.coverage_per_hour)) + " \n                                "), (props.row.coverage_per_hour !== null) ? _c('div', {
          staticClass: "coverage-indicator",
          class: {
            'bad': props.row.coverage_per_hour < _vm.$store.state.config.companyMeta.settings.coverage_per_hour.medium.value, 'avg': _vm.$options.filters.rounded(props.row.coverage_per_hour) >= _vm.$store.state.config.companyMeta.settings.coverage_per_hour.medium.value, 'good': _vm.$options.filters.rounded(props.row.coverage_per_hour) >= _vm.$store.state.config.companyMeta.settings.coverage_per_hour.high.value
          }
        }) : _vm._e()]) : (props.column.field == 'budget') ? _c('div', [_vm._v("\n                                -\n                            ")]) : (props.column.field == 'efficiency') ? _c('div', [_vm._v("\n                                -\n                            ")]) : (props.column.field == 'sub_projects_total_expenses') ? _c('div', [_vm._v("\n                                " + _vm._s(_vm._f("currency")(props.row.sub_projects_total_expenses)) + "\n                            ")]) : _c('div', {
          attrs: {
            "title": props.formattedRow[props.column.field]
          }
        }, [_vm._v("\n                                " + _vm._s(props.formattedRow[props.column.field]) + "\n                            ")])]
      }
    }], null, false, 3419592474)
  }, [_c('div', {
    attrs: {
      "slot": "emptystate"
    },
    slot: "emptystate"
  }, [_vm._v("\n                            Ingen data ...\n                        ")])]) : _c('box-loading', {
    attrs: {
      "height": "350"
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    class: {
      'col-lg-6': !_vm.selectedRow, 'col-lg-9': _vm.selectedRow
    }
  }, [(!_vm.selectedRow) ? _c('div', [_vm._v("\n                Vælg en medarbejder for at se en liste over dennes underopgaver med effektivitet\n            ")]) : _vm._e(), _vm._v(" "), (_vm.selectedRow) ? _c('div', [_c('div', {
    staticStyle: {
      "margin-bottom": "5px"
    }
  }, [_c('a', {
    staticStyle: {
      "text-decoration": "none",
      "color": "#172b43",
      "font-weight": "600"
    },
    attrs: {
      "href": "javascript:void(0)"
    },
    on: {
      "click": function($event) {
        _vm.selectedRow = null
      }
    }
  }, [_c('i', {
    staticClass: "far fa-times"
  }), _vm._v(" Luk\n                    ")])])]) : _vm._e(), _vm._v(" "), (_vm.selectedRow) ? _c('employee-sub-projects-single', {
    attrs: {
      "data": _vm.selectedRow
    }
  }) : _vm._e()], 1)])])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-292ea815", module.exports)
  }
}

/***/ }),
/* 805 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "sub-projects"
  }, [_c('div', {
    staticClass: "placeholder"
  }, [_c('div', {
    staticClass: "placeholder__heading"
  }, [_vm._v("\n            Ordre " + _vm._s(_vm.data.case_number) + " - " + _vm._s(_vm.data.customer.name) + "\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "placeholder"
  }, [_c('vue-good-table', {
    attrs: {
      "columns": _vm.columns,
      "rows": _vm.data.sub_projects,
      "search-options": _vm.searchOptions,
      "pagination-options": _vm.paginationOptions,
      "sort-options": _vm.sortOptions,
      "styleClass": _vm.styleClass
    },
    scopedSlots: _vm._u([{
      key: "table-row",
      fn: function(props) {
        return [(props.column.field == 'coverage_percent') ? _c('div', {
          staticClass: "coverage-cell"
        }, [_vm._v("\n                        " + _vm._s(_vm._f("rounded")(props.row.coverage_percent)) + " \n                        "), (props.row.coverage_percent !== null) ? _c('div', {
          staticClass: "coverage-indicator",
          class: {
            'bad': props.row.coverage_percent < _vm.$store.state.config.companyMeta.settings.coverage_percent.medium.value, 'avg': _vm.$options.filters.rounded(props.row.coverage_percent) >= _vm.$store.state.config.companyMeta.settings.coverage_percent.medium.value, 'good': _vm.$options.filters.rounded(props.row.coverage_percent) >= _vm.$store.state.config.companyMeta.settings.coverage_percent.high.value
          }
        }) : _vm._e()]) : (props.column.field == 'description') ? _c('div', {
          staticClass: "table-column__description"
        }, [_vm._v("\n                        " + _vm._s(props.row.description) + "\n                    ")]) : (props.column.field == 'coverage') ? _c('div', [_vm._v("\n                        " + _vm._s(_vm._f("currency")(props.row.coverage)) + "\n                    ")]) : (props.column.field == 'invoices_total') ? _c('div', {
          staticStyle: {
            "text-align": "left"
          }
        }, [_vm._v("\n                        " + _vm._s(_vm._f("currency")(props.row.invoices_total)) + "\n                    ")]) : (props.column.field == 'total_expenses') ? _c('div', {
          staticStyle: {
            "text-align": "left"
          }
        }, [_vm._v("\n                        " + _vm._s(_vm._f("currency")(props.row.total_expenses)) + "\n                    ")]) : (props.column.field == 'budget_expenses') ? _c('div', {
          staticStyle: {
            "text-align": "left"
          }
        }, [_vm._v("\n                        -\n                    ")]) : (props.column.field == 'efficiency_percent') ? _c('div', {
          staticStyle: {
            "text-align": "left"
          }
        }, [_vm._v("\n                        -\n                    ")]) : (props.column.field == 'coverage_per_hour') ? _c('div', {
          staticClass: "coverage-cell"
        }, [_vm._v("\n                        " + _vm._s(_vm._f("currency")(props.row.coverage_per_hour)) + " \n                        "), (props.row.coverage_per_hour !== null) ? _c('div', {
          staticClass: "coverage-indicator",
          class: {
            'bad': props.row.coverage_per_hour < _vm.$store.state.config.companyMeta.settings.coverage_per_hour.medium.value, 'avg': _vm.$options.filters.rounded(props.row.coverage_per_hour) >= _vm.$store.state.config.companyMeta.settings.coverage_per_hour.medium.value, 'good': _vm.$options.filters.rounded(props.row.coverage_per_hour) >= _vm.$store.state.config.companyMeta.settings.coverage_per_hour.high.value
          }
        }) : _vm._e()]) : _c('div', [_vm._v("\n                        " + _vm._s(props.formattedRow[props.column.field]) + "\n                    ")])]
      }
    }])
  }, [_c('div', {
    attrs: {
      "slot": "emptystate"
    },
    slot: "emptystate"
  }, [_vm._v("\n                    Ingen data ...\n                ")])])], 1)])])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-2a91a18a", module.exports)
  }
}

/***/ }),
/* 806 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.$store.state.config.availableDepartments) ? _c('div', {
    staticClass: "economy-learning-potential"
  }, [(_vm.$store.getters.getAvailableDepartments.length > 1) ? _c('div', {
    staticClass: "has-departments"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-12"
  }, [_c('compare-keyfigures')], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-6"
  }, [_c('compare-revenue')], 1), _vm._v(" "), _c('div', {
    staticClass: "col-lg-6"
  }, [_c('compare-coverage-percent')], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-6"
  }, [_c('compare-coverage')], 1), _vm._v(" "), _c('div', {
    staticClass: "col-lg-6"
  }, [_c('compare-coverage-per-hour')], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-12"
  }, [_c('compare-customer-hours')], 1)])]) : _c('div', {
    staticClass: "no-departments"
  }, [_vm._v("\n        Virksomheden har ingen afdelinger at sammenligne.\n    ")])]) : _vm._e()
},staticRenderFns: []}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-2c7820ba", module.exports)
  }
}

/***/ }),
/* 807 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "economy-operations-future-revenue"
  }, [_c('exceededPayments-table', {
    on: {
      "finishedLoading": function($event) {
        return _vm.$emit('finishedLoading', $event)
      }
    }
  })], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-2d04ea8d", module.exports)
  }
}

/***/ }),
/* 808 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "enterprise"
  }, [_c('box-helper', {
    attrs: {
      "headline": "Entreprise",
      "identifier": "enterprise"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "container section"
  }, [_c('title-block', {
    staticClass: "mb-xl",
    attrs: {
      "headline": "<b>Entreprise</b>",
      "position": "center"
    }
  }, [_c('p', {
    attrs: {
      "slot": "text"
    },
    slot: "text"
  }, [_vm._v("\n                Ét samlet overblik over din entreprise-forretning\n            ")])]), _vm._v(" "), _c('content-switch', {
    attrs: {
      "items": _vm.switchItems,
      "selectedItem": _vm.selectedItem,
      "counts": _vm.counts
    },
    on: {
      "selectItem": function($event) {
        return _vm.handleSelectItem($event)
      }
    }
  }), _vm._v(" "), _c('main-project-types', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.selectedItem === 'mainProjectTypes'),
      expression: "selectedItem === 'mainProjectTypes'"
    }],
    on: {
      "finishedLoading": function($event) {
        return _vm.updateCount('mainProjectTypes', $event)
      }
    }
  }), _vm._v(" "), _c('main-projects', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.selectedItem === 'mainProjects'),
      expression: "selectedItem === 'mainProjects'"
    }],
    on: {
      "finishedLoading": function($event) {
        return _vm.updateCount('mainProjects', $event)
      }
    }
  }), _vm._v(" "), _c('employees-sub-projects', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.selectedItem === 'employeesSubProjects'),
      expression: "selectedItem === 'employeesSubProjects'"
    }],
    on: {
      "finishedLoading": function($event) {
        return _vm.updateCount('employeesSubProjects', $event)
      }
    }
  }), _vm._v(" "), _c('sub-project-types', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.selectedItem === 'subProjectTypes'),
      expression: "selectedItem === 'subProjectTypes'"
    }],
    on: {
      "finishedLoading": function($event) {
        return _vm.updateCount('subProjectTypes', $event)
      }
    }
  })], 1)], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-2d9a7c39", module.exports)
  }
}

/***/ }),
/* 809 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "economy-learning-materials"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-6"
  }, [_c('material-usage')], 1), _vm._v(" "), _c('div', {
    staticClass: "col-lg-6"
  }, [_c('suppliers')], 1)])])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-2efd2d41", module.exports)
  }
}

/***/ }),
/* 810 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pie"
  }, [(_vm.headline) ? _c('div', {
    staticClass: "headline"
  }, [_vm._v("\n        " + _vm._s(_vm.headline) + "\n    ")]) : _vm._e(), _vm._v(" "), _c('vue-apex-charts', {
    attrs: {
      "options": _vm.chartOptions,
      "series": _vm.series,
      "labels": _vm.labels,
      "height": _vm.chartOptions.chart.height
    }
  })], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-2f6d19d5", module.exports)
  }
}

/***/ }),
/* 811 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "error-page-wrapper"
  }, [_c('div', {
    staticClass: "error-page-inner"
  }, [_c('h1', [_vm._v("404")]), _vm._v(" "), _c('h3', [_vm._v("Whoops! Something went wrong...")]), _vm._v(" "), _c('p', [_vm._v("We could not find what you were looking for.")]), _vm._v(" "), _c('router-link', {
    attrs: {
      "tag": "a",
      "to": {
        name: _vm.$route.name
      }
    }
  }, [_c('button', {
    staticClass: "btn btn-xs btn-primary"
  }, [_vm._v("\n                Refresh this page\n            ")])]), _vm._v("\n        |\n        "), _c('router-link', {
    attrs: {
      "tag": "a",
      "to": {
        name: 'Index'
      }
    }
  }, [_c('button', {
    staticClass: "btn btn-xs btn-primary"
  }, [_vm._v("\n                Go to \"home\"\n            ")])])], 1)])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-301a1469", module.exports)
  }
}

/***/ }),
/* 812 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "table-card"
  }, [_c('box-helper'), _vm._v(" "), (_vm.heading) ? _c('div', {
    staticClass: "table-title"
  }, [(_vm.icon) ? _c('i', {
    class: 'fas fa-fw fa-' + _vm.icon
  }) : _vm._e(), _vm._v("\n        " + _vm._s(_vm.heading) + "\n    ")]) : _vm._e(), _vm._v(" "), (!_vm.loading) ? _c('v-data-table', {
    class: _vm.customClass,
    attrs: {
      "search": _vm.search,
      "headers": _vm.headers,
      "items": _vm.items,
      "items-per-page": 50
    }
  }, [_c('no-data', {
    attrs: {
      "slot": "no-data"
    },
    slot: "no-data"
  }), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer.page-text"
    },
    slot: "footer.page-text"
  }, [_vm._v("\n            Footer text?\n        ")])], 1) : _c('box-loading', {
    attrs: {
      "height": "350"
    }
  }), _vm._v(" "), (!_vm.loading) ? _c('div', {
    staticClass: "box-date-range"
  }, [_vm._m(0), _vm._v(" "), _c('datepicker', {
    staticClass: "date-picker",
    attrs: {
      "language": _vm.datepickerLocale,
      "placeholder": "Startdato"
    },
    model: {
      value: (_vm.startDate),
      callback: function($$v) {
        _vm.startDate = $$v
      },
      expression: "startDate"
    }
  }), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('datepicker', {
    staticClass: "date-picker",
    attrs: {
      "language": _vm.datepickerLocale,
      "placeholder": "Slutdato"
    },
    model: {
      value: (_vm.endDate),
      callback: function($$v) {
        _vm.endDate = $$v
      },
      expression: "endDate"
    }
  })], 1) : _vm._e()], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "text"
  }, [_c('i', {
    staticClass: "fal fa-calendar"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "to"
  }, [_c('i', {
    staticClass: "fal fa-chevron-right"
  })])
}]}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-30dee4b6", module.exports)
  }
}

/***/ }),
/* 813 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "g-table-wrapper"
  }, [_c('div', {
    staticClass: "table-title"
  }, [_c('d-tooltip', {
    attrs: {
      "placement": "left",
      "identifier": "projects.ongoingProjects"
    }
  }), _vm._v("\n        Igangværende opgaver\n    ")], 1), _vm._v(" "), (!_vm.loading) ? _c('vue-good-table', {
    attrs: {
      "columns": _vm.columns,
      "rows": _vm.rows,
      "search-options": _vm.searchOptions,
      "pagination-options": _vm.paginationOptions,
      "sort-options": _vm.sortOptions,
      "styleClass": _vm.styleClass
    },
    scopedSlots: _vm._u([{
      key: "table-row",
      fn: function(props) {
        return [(props.column.field == 'coverage_percent') ? _c('div', {
          staticClass: "coverage-cell"
        }, [_vm._v("\n                " + _vm._s(_vm._f("rounded")(props.row.coverage_percent)) + " \n                "), (props.row.coverage_percent !== null) ? _c('div', {
          staticClass: "coverage-indicator",
          class: {
            'bad': props.row.coverage_percent < _vm.$store.state.config.companyMeta.settings.coverage_percent.medium.value, 'avg': _vm.$options.filters.rounded(props.row.coverage_percent) >= _vm.$store.state.config.companyMeta.settings.coverage_percent.medium.value, 'good': _vm.$options.filters.rounded(props.row.coverage_percent) >= _vm.$store.state.config.companyMeta.settings.coverage_percent.high.value
          }
        }) : _vm._e()]) : (props.column.field == 'status.name') ? _c('div', {
          staticClass: "coverage-cell"
        }, [_vm._v("\n                " + _vm._s(props.row.status.name) + "\n                "), _c('div', {
          staticClass: "coverage-indicator status",
          style: ('background:#' + props.row.status.color + ';')
        })]) : (props.column.field == 'case_number') ? _c('div', {
          staticClass: "table-column__ordernumber",
          staticStyle: {
            "text-align": "left"
          }
        }, [_vm._v("\n                " + _vm._s(props.row.case_number) + "\n            ")]) : (props.column.field == 'description') ? _c('div', {
          staticClass: "table-column__description",
          attrs: {
            "title": props.row.description
          }
        }, [(props.row.calculation_price > 0) ? _c('budget-tooltip', {
          attrs: {
            "project": props.row
          }
        }) : _vm._e(), _vm._v("\n                " + _vm._s(props.row.description ? props.row.description : '-') + "\n            ")], 1) : (props.column.field == 'customer.name') ? _c('div', {
          staticClass: "table-column__customer",
          attrs: {
            "title": props.row.customer ? props.row.customer.name : '-'
          }
        }, [_vm._v("\n                " + _vm._s(props.row.customer ? props.row.customer.name : '-') + "\n            ")]) : (props.column.field == 'action') ? _c('div', {
          staticClass: "g-table__action",
          on: {
            "click": function($event) {
              return _vm.openExternalLink(props.row.external_id)
            }
          }
        }, [_c('i', {
          staticClass: "fad fa-eye"
        })]) : (props.column.field == 'start_date') ? _c('div', [_vm._v("\n                " + _vm._s(_vm._f("moment")(props.row.start_date, "DD. MMM YYYY")) + "\n            ")]) : (props.column.field == 'type.name') ? _c('div', {
          staticClass: "table-column__description",
          attrs: {
            "title": props.row.type ? props.row.type.name : '-'
          }
        }, [_vm._v("\n                " + _vm._s(props.row.type ? props.row.type.name : '-') + "\n            ")]) : (props.column.field == 'minuba_external_id') ? _c('div', [_c('a', {
          staticClass: "minuba-link",
          attrs: {
            "href": 'https://app.minuba.dk/?op=casedetails&glist=' + props.row.minuba_external_id,
            "target": "_blank"
          }
        }, [_c('i', {
          staticClass: "fas fa-eye"
        })])]) : _c('div', {
          attrs: {
            "title": props.formattedRow[props.column.field]
          }
        }, [_vm._v("\n                " + _vm._s(props.formattedRow[props.column.field]) + "\n            ")])]
      }
    }], null, false, 1613006212)
  }, [_c('div', {
    attrs: {
      "slot": "emptystate"
    },
    slot: "emptystate"
  }, [_vm._v("\n            Ingen data ...\n        ")])]) : _c('box-loading', {
    attrs: {
      "height": "350"
    }
  })], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-320abf01", module.exports)
  }
}

/***/ }),
/* 814 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "placeholder"
  }, [_c('div', {
    staticClass: "placeholder__heading"
  }, [_vm._v("\n        " + _vm._s(_vm.data.name) + "\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "placeholder"
  }, [_c('vue-good-table', {
    attrs: {
      "columns": _vm.columns,
      "rows": _vm.data.sub_projects,
      "search-options": _vm.searchOptions,
      "pagination-options": _vm.paginationOptions,
      "sort-options": _vm.sortOptions,
      "styleClass": _vm.styleClass
    },
    scopedSlots: _vm._u([{
      key: "table-row",
      fn: function(props) {
        return [(props.column.field == 'coverage_percent') ? _c('div', {
          staticClass: "coverage-cell"
        }, [_vm._v("\n                    " + _vm._s(_vm._f("rounded")(props.row.coverage_percent)) + " \n                    "), (props.row.coverage_percent !== null) ? _c('div', {
          staticClass: "coverage-indicator",
          class: {
            'bad': props.row.coverage_percent < _vm.$store.state.config.companyMeta.settings.coverage_percent.medium.value, 'avg': _vm.$options.filters.rounded(props.row.coverage_percent) >= _vm.$store.state.config.companyMeta.settings.coverage_percent.medium.value, 'good': _vm.$options.filters.rounded(props.row.coverage_percent) >= _vm.$store.state.config.companyMeta.settings.coverage_percent.high.value
          }
        }) : _vm._e()]) : (props.column.field == 'total_revenue') ? _c('div', [_vm._v("\n                    " + _vm._s(_vm._f("currency")(props.row.total_revenue)) + "\n                ")]) : (props.column.field == 'total_coverage') ? _c('div', [_c('project-tooltip', {
          attrs: {
            "project": props.row
          }
        }), _vm._v("\n                    " + _vm._s(_vm._f("currency")(props.row.total_coverage)) + "\n                ")], 1) : (props.column.field == 'coverage_per_hour') ? _c('div', {
          staticClass: "coverage-cell"
        }, [_vm._v("\n                    " + _vm._s(_vm._f("currency")(props.row.coverage_per_hour)) + " \n                    "), (props.row.coverage_per_hour !== null) ? _c('div', {
          staticClass: "coverage-indicator",
          class: {
            'bad': props.row.coverage_per_hour < _vm.$store.state.config.companyMeta.settings.coverage_per_hour.medium.value, 'avg': _vm.$options.filters.rounded(props.row.coverage_per_hour) >= _vm.$store.state.config.companyMeta.settings.coverage_per_hour.medium.value, 'good': _vm.$options.filters.rounded(props.row.coverage_per_hour) >= _vm.$store.state.config.companyMeta.settings.coverage_per_hour.high.value
          }
        }) : _vm._e()]) : (props.column.field == 'customer_name') ? _c('div', {
          staticClass: "table-column__customer",
          attrs: {
            "title": props.row.customer_name
          }
        }, [(props.row.customer_name) ? _c('span', [_vm._v("\n                        " + _vm._s(props.row.customer_name) + "\n                    ")]) : _c('span', [_vm._v(" - ")])]) : (props.column.field == 'name') ? _c('div', {
          staticClass: "table-column__description",
          attrs: {
            "title": props.row.name
          }
        }, [_vm._v("\n                    " + _vm._s(props.row.name) + "\n                ")]) : (props.column.field == 'start_date') ? _c('div', [_vm._v("\n                    " + _vm._s(_vm._f("moment")(props.row.start_date, "DD. MMM YYYY")) + "\n                ")]) : (props.column.field == 'minuba_external_id') ? _c('div', [_c('a', {
          staticClass: "minuba-link",
          attrs: {
            "href": 'https://app.minuba.dk/?op=casedetails&glist=' + props.row.minuba_external_id,
            "target": "_blank"
          }
        }, [_c('i', {
          staticClass: "fas fa-eye"
        })])]) : _c('div', [_vm._v("\n                    " + _vm._s(props.formattedRow[props.column.field]) + "\n                ")])]
      }
    }])
  }, [_c('div', {
    attrs: {
      "slot": "emptystate"
    },
    slot: "emptystate"
  }, [_vm._v("\n                Ingen data ...\n            ")])])], 1)])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-33b1612f", module.exports)
  }
}

/***/ }),
/* 815 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "employees"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("\n        Medarbejdere (" + _vm._s(_vm.employees ? _vm.employees.length : '-') + ")\n    ")]), _vm._v(" "), _vm._l((_vm.employees), function(employee) {
    return _c('div', {
      key: employee.uuid,
      staticClass: "employee"
    }, [_c('div', {
      staticClass: "name"
    }, [_vm._v("\n            " + _vm._s(employee.full_name) + "\n        ")]), _vm._v(" "), _c('div', {
      staticClass: "hours"
    }, [_vm._v("\n            Timer/uge:\n            "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (employee.weekly_hours_working),
        expression: "employee.weekly_hours_working"
      }],
      attrs: {
        "type": "number"
      },
      domProps: {
        "value": (employee.weekly_hours_working)
      },
      on: {
        "keydown": function($event) {
          _vm.showUpdateButton = employee.uuid
        },
        "change": function($event) {
          _vm.showUpdateButton = employee.uuid
        },
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(employee, "weekly_hours_working", $event.target.value)
        }
      }
    }), _vm._v(" "), _c('button', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.showUpdateButton === employee.uuid),
        expression: "showUpdateButton === employee.uuid"
      }],
      on: {
        "click": function($event) {
          return _vm.updateEmployee(employee)
        }
      }
    }, [_vm._v("\n                 \n                Opdater\n            ")])]), _vm._v(" "), _c('div', {
      staticClass: "working-responsible"
    }, [_c('div', {
      staticClass: "mb-2"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (employee.working_field),
        expression: "employee.working_field"
      }],
      staticStyle: {
        "transform": "scale(1.2)"
      },
      attrs: {
        "type": "checkbox"
      },
      domProps: {
        "checked": Array.isArray(employee.working_field) ? _vm._i(employee.working_field, null) > -1 : (employee.working_field)
      },
      on: {
        "change": [function($event) {
          var $$a = employee.working_field,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = null,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.$set(employee, "working_field", $$a.concat([$$v])))
            } else {
              $$i > -1 && (_vm.$set(employee, "working_field", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
            }
          } else {
            _vm.$set(employee, "working_field", $$c)
          }
        }, function($event) {
          return _vm.updateEmployee(employee)
        }]
      }
    }), _vm._v("\n                Udfører arbejde hos kunder\n            ")]), _vm._v(" "), _c('div', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (employee.responsible_field),
        expression: "employee.responsible_field"
      }],
      staticStyle: {
        "transform": "scale(1.2)"
      },
      attrs: {
        "type": "checkbox"
      },
      domProps: {
        "checked": Array.isArray(employee.responsible_field) ? _vm._i(employee.responsible_field, null) > -1 : (employee.responsible_field)
      },
      on: {
        "change": [function($event) {
          var $$a = employee.responsible_field,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = null,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.$set(employee, "responsible_field", $$a.concat([$$v])))
            } else {
              $$i > -1 && (_vm.$set(employee, "responsible_field", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
            }
          } else {
            _vm.$set(employee, "responsible_field", $$c)
          }
        }, function($event) {
          return _vm.updateEmployee(employee)
        }]
      }
    }), _vm._v("\n                Er opgaveansvarlig\n            ")])]), _vm._v(" "), _c('div', {
      staticClass: "working-field-name"
    }, [_c('b', {
      staticStyle: {
        "display": "block",
        "margin-bottom": "4px"
      }
    }, [_vm._v("Medarbejdertype")]), _vm._v(" "), _c('select', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (employee.working_field_name),
        expression: "employee.working_field_name"
      }],
      on: {
        "change": [function($event) {
          var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
            return o.selected
          }).map(function(o) {
            var val = "_value" in o ? o._value : o.value;
            return val
          });
          _vm.$set(employee, "working_field_name", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
        }, function($event) {
          return _vm.updateEmployee(employee, $event)
        }]
      }
    }, _vm._l((_vm.employeeTypes), function(employeeType) {
      return _c('option', {
        key: employeeType,
        domProps: {
          "value": employeeType
        }
      }, [_vm._v("\n                    " + _vm._s(employeeType) + "\n                ")])
    }), 0)])])
  })], 2)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-3756a0f3", module.exports)
  }
}

/***/ }),
/* 816 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "customer-revenue"
  }, [_c('div', {
    staticClass: "placeholder"
  }, [_c('div', {
    staticClass: "placeholder__heading"
  }, [_vm._v("\n            " + _vm._s(_vm.name) + " kr.\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "placeholder"
  }, [_c('vue-good-table', {
    attrs: {
      "columns": _vm.columns,
      "rows": _vm.customers,
      "search-options": _vm.searchOptions,
      "pagination-options": _vm.paginationOptions,
      "sort-options": _vm.sortOptions,
      "styleClass": _vm.styleClass,
      "v-if": _vm.customers.length
    },
    scopedSlots: _vm._u([{
      key: "table-row",
      fn: function(props) {
        return [(props.column.field == 'coverage_percent') ? _c('div', {
          staticClass: "coverage-cell"
        }, [_vm._v("\n                        " + _vm._s(_vm._f("rounded")(props.row.coverage_percent)) + " \n                        "), (props.row.coverage_percent !== null) ? _c('div', {
          staticClass: "coverage-indicator",
          class: {
            'bad': props.row.coverage_percent < _vm.$store.state.config.companyMeta.settings.coverage_percent.medium.value, 'avg': _vm.$options.filters.rounded(props.row.coverage_percent) >= _vm.$store.state.config.companyMeta.settings.coverage_percent.medium.value, 'good': _vm.$options.filters.rounded(props.row.coverage_percent) >= _vm.$store.state.config.companyMeta.settings.coverage_percent.high.value
          }
        }) : _vm._e()]) : (props.column.field == 'name') ? _c('div', {
          staticClass: "table-column__description",
          attrs: {
            "title": props.row.name
          }
        }, [_vm._v("\n                        " + _vm._s(props.row.name) + "\n                    ")]) : (props.column.field == 'coverage') ? _c('div', [_vm._v("\n                        " + _vm._s(_vm._f("currency")(props.row.coverage)) + "\n                    ")]) : (props.column.field == 'invoices_total') ? _c('div', [_vm._v("\n                        " + _vm._s(_vm._f("currency")(props.row.invoices_total)) + "\n                    ")]) : (props.column.field == 'coverage_per_hour') ? _c('div', {
          staticClass: "coverage-cell"
        }, [_vm._v("\n                " + _vm._s(_vm._f("currency")(props.row.coverage_per_hour)) + " \n                "), (props.row.coverage_per_hour !== null) ? _c('div', {
          staticClass: "coverage-indicator",
          class: {
            'bad': props.row.coverage_per_hour < _vm.$store.state.config.companyMeta.settings.coverage_per_hour.medium.value, 'avg': _vm.$options.filters.rounded(props.row.coverage_per_hour) >= _vm.$store.state.config.companyMeta.settings.coverage_per_hour.medium.value, 'good': _vm.$options.filters.rounded(props.row.coverage_per_hour) >= _vm.$store.state.config.companyMeta.settings.coverage_per_hour.high.value
          }
        }) : _vm._e()]) : _c('div', {
          attrs: {
            "title": props.formattedRow[props.column.field]
          }
        }, [_vm._v("\n                        " + _vm._s(props.formattedRow[props.column.field]) + "\n                    ")])]
      }
    }])
  }, [_c('div', {
    attrs: {
      "slot": "emptystate"
    },
    slot: "emptystate"
  }, [_vm._v("\n                    Ingen data ...\n                ")])])], 1)])])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-39b67b18", module.exports)
  }
}

/***/ }),
/* 817 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "general"
  }, [(_vm.settings) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-12"
  }, [_c('div', {
    staticClass: "box coverage"
  }, [_c('div', {
    staticClass: "box__title"
  }, [_vm._v("\n                    Dækningsgrad (DG)\n                ")]), _vm._v(" "), _c('div', {
    staticClass: "options"
  }, [_c('div', {
    staticClass: "option"
  }, [_c('div', {
    staticClass: "fake-input"
  }, [_c('b', [_vm._v("0 - " + _vm._s(_vm.settings.coverage_percent.medium.value - 1) + " %")])]), _vm._v(" "), _vm._m(0), _vm._v(" "), _vm._m(1)]), _vm._v(" "), _c('div', {
    staticClass: "option"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.settings.coverage_percent.medium.value),
      expression: "settings.coverage_percent.medium.value"
    }],
    attrs: {
      "type": "number",
      "name": "coverage_percent_medium",
      "min": "0",
      "max": "80",
      "step": "1",
      "pattern": "\\d*",
      "maxlength": "2"
    },
    domProps: {
      "value": (_vm.settings.coverage_percent.medium.value)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.settings.coverage_percent.medium, "value", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('b', [_vm._v(" - " + _vm._s(_vm.settings.coverage_percent.high.value - 1) + " %")]), _vm._v(" "), _vm._m(2), _vm._v(" "), _vm._m(3)]), _vm._v(" "), _c('div', {
    staticClass: "option"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.settings.coverage_percent.high.value),
      expression: "settings.coverage_percent.high.value"
    }],
    attrs: {
      "type": "number",
      "name": "coverage_percent_high",
      "min": "0",
      "max": "80",
      "step": "1",
      "pattern": "\\d*",
      "maxlength": "2"
    },
    domProps: {
      "value": (_vm.settings.coverage_percent.high.value)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.settings.coverage_percent.high, "value", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('b', [_vm._v(" - 100 %")]), _vm._v(" "), _vm._m(4), _vm._v(" "), _vm._m(5)])])])])]) : _vm._e(), _vm._v(" "), (_vm.settings) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-12"
  }, [_c('div', {
    staticClass: "box coverage"
  }, [_c('div', {
    staticClass: "box__title"
  }, [_vm._v("\n                    Dækningsbidrag (DB) pr. time\n                ")]), _vm._v(" "), _c('div', {
    staticClass: "options"
  }, [_c('div', {
    staticClass: "option"
  }, [_c('div', {
    staticClass: "fake-input"
  }, [_c('b', [_vm._v("0 - " + _vm._s(_vm.settings.coverage_per_hour.medium.value - 1) + " kr.")])]), _vm._v(" "), _vm._m(6), _vm._v(" "), _vm._m(7)]), _vm._v(" "), _c('div', {
    staticClass: "option"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.settings.coverage_per_hour.medium.value),
      expression: "settings.coverage_per_hour.medium.value"
    }],
    attrs: {
      "type": "number",
      "name": "coverage_per_hour_medium",
      "min": "0",
      "max": "8000",
      "step": "1",
      "pattern": "\\d*",
      "maxlength": "4"
    },
    domProps: {
      "value": (_vm.settings.coverage_per_hour.medium.value)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.settings.coverage_per_hour.medium, "value", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('b', [_vm._v(" - " + _vm._s(_vm.settings.coverage_per_hour.high.value - 1) + " kr.")]), _vm._v(" "), _vm._m(8), _vm._v(" "), _vm._m(9)]), _vm._v(" "), _c('div', {
    staticClass: "option"
  }, [_vm._v("\n                        + \n                        "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.settings.coverage_per_hour.high.value),
      expression: "settings.coverage_per_hour.high.value"
    }],
    attrs: {
      "type": "number",
      "name": "coverage_per_hour_high",
      "min": "0",
      "max": "8000",
      "step": "1",
      "pattern": "\\d*",
      "maxlength": "4"
    },
    domProps: {
      "value": (_vm.settings.coverage_per_hour.high.value)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.settings.coverage_per_hour.high, "value", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('b', [_vm._v(" kr.")]), _vm._v(" "), _vm._m(10), _vm._v(" "), _vm._m(11)])])])])]) : _vm._e(), _vm._v(" "), (_vm.settings) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-12"
  }, [_c('div', {
    staticClass: "box coverage"
  }, [_c('div', {
    staticClass: "box__title"
  }, [_vm._v("\n                    Registreret tid\n                ")]), _vm._v(" "), _c('div', {
    staticClass: "options"
  }, [_c('div', {
    staticClass: "option"
  }, [_c('div', {
    staticClass: "fake-input"
  }, [_c('b', [_vm._v("0 - " + _vm._s(_vm.settings.timelogging.medium.value - 1) + " %")])]), _vm._v(" "), _vm._m(12), _vm._v(" "), _vm._m(13)]), _vm._v(" "), _c('div', {
    staticClass: "option"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.settings.timelogging.medium.value),
      expression: "settings.timelogging.medium.value"
    }],
    attrs: {
      "type": "number",
      "name": "coverage_percent_medium",
      "min": "0",
      "max": "80",
      "step": "1",
      "pattern": "\\d*",
      "maxlength": "2"
    },
    domProps: {
      "value": (_vm.settings.timelogging.medium.value)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.settings.timelogging.medium, "value", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('b', [_vm._v(" - " + _vm._s(_vm.settings.timelogging.high.value - 1) + " %")]), _vm._v(" "), _vm._m(14), _vm._v(" "), _vm._m(15)]), _vm._v(" "), _c('div', {
    staticClass: "option"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.settings.timelogging.high.value),
      expression: "settings.timelogging.high.value"
    }],
    attrs: {
      "type": "number",
      "name": "coverage_percent_high",
      "min": "0",
      "max": "80",
      "step": "1",
      "pattern": "\\d*",
      "maxlength": "2"
    },
    domProps: {
      "value": (_vm.settings.timelogging.high.value)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.settings.timelogging.high, "value", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('b', [_vm._v(" - 100 %")]), _vm._v(" "), _vm._m(16), _vm._v(" "), _vm._m(17)])])])])]) : _vm._e(), _vm._v(" "), (_vm.settings) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-12"
  }, [_c('div', {
    staticClass: "box coverage"
  }, [_c('div', {
    staticClass: "box__title"
  }, [_vm._v("\n                    Beregning af medarbejdernes indtjening\n                ")]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-6"
  }, [_c('div', {
    staticClass: "inside"
  }, [_c('div', {
    staticStyle: {
      "display": "flex"
    }
  }, [_c('span', {
    staticStyle: {
      "display": "block",
      "width": "1.4em"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.employeeCalc),
      expression: "employeeCalc"
    }],
    attrs: {
      "type": "radio",
      "name": "employee-calculation",
      "value": "responsible"
    },
    domProps: {
      "checked": _vm._q(_vm.employeeCalc, "responsible")
    },
    on: {
      "change": [function($event) {
        _vm.employeeCalc = "responsible"
      }, function($event) {
        return _vm.selectEmployeeCalc('responsible')
      }]
    }
  })]), _vm._v(" "), _c('span', {
    staticStyle: {
      "margin-left": "10px"
    }
  }, [_vm._v("Indtjening tilfalder den medarbejder, der har arbejdet mest på opgaven")])]), _vm._v(" "), _c('div', {
    staticClass: "options"
  }, [_c('div', {
    staticClass: "option fw"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.settings.main_employee_percent),
      expression: "settings.main_employee_percent"
    }],
    attrs: {
      "type": "number",
      "name": "main_employee_percent",
      "min": "50",
      "max": "99",
      "step": "1",
      "pattern": "\\d*",
      "maxlength": "2"
    },
    domProps: {
      "value": (_vm.settings.main_employee_percent)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.settings, "main_employee_percent", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('b', [_vm._v("%")])])]), _vm._v(" "), _c('div', {
    staticClass: "small"
  }, [_vm._v("\n                                Her fastsættes, hvor stor en andel af det samlede antal timer på en opgave, som skal være udført af 1 svend, før indtjeningen tildeles 1 svend. Andelen kan ikke komme under 50%\n                            ")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-6"
  }, [_c('div', {
    staticClass: "inside"
  }, [_c('div', {
    staticStyle: {
      "display": "flex"
    }
  }, [_c('span', {
    staticStyle: {
      "display": "block",
      "width": "1.4em"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.employeeCalc),
      expression: "employeeCalc"
    }],
    attrs: {
      "type": "radio",
      "name": "employee-calculation",
      "value": "calculation"
    },
    domProps: {
      "checked": _vm._q(_vm.employeeCalc, "calculation")
    },
    on: {
      "change": [function($event) {
        _vm.employeeCalc = "calculation"
      }, function($event) {
        return _vm.selectEmployeeCalc('calculation')
      }]
    }
  })]), _vm._v(" "), _c('span', {
    staticStyle: {
      "margin-left": "10px"
    }
  }, [_vm._v("Indtjening fordeles ud fra antal timer lagt i en opgave")])]), _vm._v(" "), _c('div', {
    staticClass: "small"
  }, [_vm._v("\n                                De enkelte opgavers omsætning/omkostning/indtjening fordeles på forholdsmæssigt på ALLE medarbejdere, som har arbejdet på opgaven. Hvis f.eks. “Mads” har udført 30% af timerne, tildeles han 30% af indtjeningen.\n                            ")])])])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "text-align": "center",
      "margin-top": "15px",
      "font-size": "14px"
    }
  }, [_vm._v("\n                    Bemærk, at ændringerne for begge ovenstående beregninger først træder ikraft næste dag.\n                ")])])])]) : _vm._e(), _vm._v(" "), (_vm.settings) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-6"
  }, [_c('div', {
    staticClass: "box coverage"
  }, [_c('div', {
    staticClass: "box__title"
  }, [_vm._v("\n                    Fakturaer med overskredet betaling\n                ")]), _vm._v(" "), _c('div', {
    staticClass: "options"
  }, [_c('div', {
    staticClass: "option fw"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.settings.overdue_days),
      expression: "settings.overdue_days"
    }],
    attrs: {
      "type": "number",
      "name": "overdue_days",
      "min": "0",
      "max": "99",
      "step": "1",
      "pattern": "\\d*",
      "maxlength": "2"
    },
    domProps: {
      "value": (_vm.settings.overdue_days)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.settings, "overdue_days", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('b', [_vm._v("dage")]), _vm._v(" "), _c('div', {
    staticClass: "small"
  }, [_vm._v("\n                            Her fastsættes, hvor mange dage betalingsfristen må være overskredet, før den skal vises på oversigten.\n                        ")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-6"
  }, [_c('div', {
    staticClass: "box coverage"
  }, [_c('div', {
    staticClass: "box__title"
  }, [_vm._v("\n                    Opgaver uden bevægelse\n                ")]), _vm._v(" "), _c('div', {
    staticClass: "options"
  }, [_c('div', {
    staticClass: "option fw"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.settings.snoozed_days),
      expression: "settings.snoozed_days"
    }],
    attrs: {
      "type": "number",
      "name": "snoozed_days",
      "min": "0",
      "max": "99",
      "step": "1",
      "pattern": "\\d*",
      "maxlength": "2"
    },
    domProps: {
      "value": (_vm.settings.snoozed_days)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.settings, "snoozed_days", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('b', [_vm._v("dage")]), _vm._v(" "), _c('div', {
    staticClass: "small"
  }, [_vm._v("\n                            Her fastsættes, hvor mange dage der må gå uden registrering af timer eller materialer på en opgave, før den skal vises på oversigten.\n                        ")])])])])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-12",
    attrs: {
      "align": "right"
    }
  }, [_c('div', {
    staticClass: "pretty-button inverse",
    on: {
      "click": function($event) {
        return _vm.doReset()
      }
    }
  }, [_c('i', {
    staticClass: "far fa-history fa-fw"
  }), _vm._v("\n                Gendan standardindstillinger\n            ")]), _vm._v(" "), _c('div', {
    staticClass: "pretty-button",
    on: {
      "click": function($event) {
        return _vm.doSave()
      }
    }
  }, [_c('i', {
    staticClass: "far fa-save fa-fw"
  }), _vm._v("\n                Gem\n            ")])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "name"
  }, [_c('div', {
    staticClass: "coverage-indicator bad"
  }), _vm._v("\n                            Utilfredsstillende\n                        ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "small"
  }, [_vm._v("\n                            DG vil være "), _c('span', {
    staticClass: "color bad"
  }, [_vm._v("rød")]), _vm._v(", hvis den er i dette interval\n                        ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "name"
  }, [_c('div', {
    staticClass: "coverage-indicator avg"
  }), _vm._v("\n                            Middel\n                        ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "small"
  }, [_vm._v("\n                            DG vil være "), _c('span', {
    staticClass: "color avg"
  }, [_vm._v("gul")]), _vm._v(", hvis den er i dette interval\n                        ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "name"
  }, [_c('div', {
    staticClass: "coverage-indicator good"
  }), _vm._v("\n                            Tilfredsstillende\n                        ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "small"
  }, [_vm._v("\n                            DG vil være "), _c('span', {
    staticClass: "color good"
  }, [_vm._v("grøn")]), _vm._v(", hvis den er i dette interval\n                        ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "name"
  }, [_c('div', {
    staticClass: "coverage-indicator bad"
  }), _vm._v("\n                            Utilfredsstillende\n                        ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "small"
  }, [_vm._v("\n                            DB pr. time vil være "), _c('span', {
    staticClass: "color bad"
  }, [_vm._v("rød")]), _vm._v(", hvis den er i dette interval\n                        ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "name"
  }, [_c('div', {
    staticClass: "coverage-indicator avg"
  }), _vm._v("\n                            Middel\n                        ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "small"
  }, [_vm._v("\n                            DB pr. time vil være "), _c('span', {
    staticClass: "color avg"
  }, [_vm._v("gul")]), _vm._v(", hvis den er i dette interval\n                        ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "name"
  }, [_c('div', {
    staticClass: "coverage-indicator good"
  }), _vm._v("\n                            Tilfredsstillende\n                        ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "small"
  }, [_vm._v("\n                            DB pr. time vil være "), _c('span', {
    staticClass: "color good"
  }, [_vm._v("grøn")]), _vm._v(", hvis den er over dette tal\n                        ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "name"
  }, [_c('div', {
    staticClass: "coverage-indicator bad"
  }), _vm._v("\n                            Utilfredsstillende\n                        ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "small"
  }, [_vm._v("\n                            Registreret tid vil være "), _c('span', {
    staticClass: "color bad"
  }, [_vm._v("rød")]), _vm._v(", hvis den er i dette interval\n                        ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "name"
  }, [_c('div', {
    staticClass: "coverage-indicator avg"
  }), _vm._v("\n                            Middel\n                        ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "small"
  }, [_vm._v("\n                            Registreret tid vil være "), _c('span', {
    staticClass: "color avg"
  }, [_vm._v("gul")]), _vm._v(", hvis den er i dette interval\n                        ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "name"
  }, [_c('div', {
    staticClass: "coverage-indicator good"
  }), _vm._v("\n                            Tilfredsstillende\n                        ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "small"
  }, [_vm._v("\n                            Registreret tid vil være "), _c('span', {
    staticClass: "color good"
  }, [_vm._v("grøn")]), _vm._v(", hvis den er i dette interval\n                        ")])
}]}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-3d3aa354", module.exports)
  }
}

/***/ }),
/* 818 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "g-table-wrapper"
  }, [_c('div', {
    staticClass: "table-title"
  }, [_c('d-tooltip', {
    attrs: {
      "placement": "left",
      "identifier": "oekonomi.overdueInvoices"
    }
  }), _vm._v("\n        Fakturaer hvor betalingsfristen er overskredet med " + _vm._s(_vm.$store.state.config.companyMeta.settings.overdue_days) + " dage\n    ")], 1), _vm._v(" "), (!_vm.loading) ? _c('vue-good-table', {
    attrs: {
      "columns": _vm.columns,
      "rows": _vm.rows,
      "search-options": _vm.searchOptions,
      "pagination-options": _vm.paginationOptions,
      "sort-options": _vm.sortOptions,
      "styleClass": _vm.styleClass
    },
    scopedSlots: _vm._u([{
      key: "table-row",
      fn: function(props) {
        return [(props.column.field == 'description') ? _c('div', {
          staticClass: "table-column__description--long",
          attrs: {
            "title": props.row.description
          }
        }, [_vm._v("\n                " + _vm._s(props.row.description) + "\n            ")]) : (props.column.field == 'invoice_number') ? _c('div', {
          staticStyle: {
            "text-align": "left"
          }
        }, [_vm._v("\n                " + _vm._s(props.row.invoice_number) + "\n            ")]) : (props.column.field == 'external_id') ? _c('div', {
          staticClass: "table-column__external-id"
        }, [_vm._v("\n                " + _vm._s(props.row.external_id) + "\n            ")]) : (props.column.field == 'due_at') ? _c('div', [_vm._v("\n                " + _vm._s(_vm._f("moment")(props.row.due_at, "DD. MMM YYYY")) + "\n            ")]) : (props.column.field == 'amount') ? _c('div', {
          staticStyle: {
            "text-align": "left"
          }
        }, [_vm._v("\n                " + _vm._s(_vm._f("currency")(props.row.amount)) + "\n            ")]) : (props.column.field == 'project.minuba_external_id') ? _c('div', [_c('a', {
          staticClass: "minuba-link",
          attrs: {
            "href": 'https://app.minuba.dk/?op=casedetails&glist=' + props.row.minuba_external_id,
            "target": "_blank"
          }
        }, [_c('i', {
          staticClass: "fas fa-eye"
        })])]) : _c('div', {
          attrs: {
            "title": props.formattedRow[props.column.field]
          }
        }, [_vm._v("\n                " + _vm._s(props.formattedRow[props.column.field]) + "\n            ")])]
      }
    }], null, false, 1272204435)
  }, [_c('div', {
    attrs: {
      "slot": "emptystate"
    },
    slot: "emptystate"
  }, [_vm._v("\n            Ingen data ...\n        ")])]) : _c('box-loading', {
    attrs: {
      "height": "350"
    }
  })], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-3dffcec4", module.exports)
  }
}

/***/ }),
/* 819 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "projects-operations"
  }, [_c('div', {
    staticClass: "content"
  }, [_c('content-switch', {
    attrs: {
      "items": _vm.switchItems,
      "selectedItem": _vm.selectedItem,
      "counts": _vm.counts
    },
    on: {
      "selectItem": function($event) {
        return _vm.handleSelectItem($event)
      }
    }
  }), _vm._v(" "), _c('openProjects-table', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.selectedItem === 'openProjects'),
      expression: "selectedItem === 'openProjects'"
    }],
    on: {
      "finishedLoading": function($event) {
        return _vm.updateCount('openProjects', $event)
      }
    }
  }), _vm._v(" "), _c('snoozedProjects-table', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.selectedItem === 'snoozedProjects'),
      expression: "selectedItem === 'snoozedProjects'"
    }],
    on: {
      "finishedLoading": function($event) {
        return _vm.updateCount('snoozedProjects', $event)
      }
    }
  }), _vm._v(" "), _c('noInvoiceProjects-table', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.selectedItem === 'noInvoiceProjects'),
      expression: "selectedItem === 'noInvoiceProjects'"
    }],
    on: {
      "finishedLoading": function($event) {
        return _vm.updateCount('noInvoiceProjects', $event)
      }
    }
  }), _vm._v(" "), _c('ongoingProjects-table', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.selectedItem === 'ongoingProjects'),
      expression: "selectedItem === 'ongoingProjects'"
    }],
    on: {
      "finishedLoading": function($event) {
        return _vm.updateCount('ongoingProjects', $event)
      }
    }
  }), _vm._v(" "), _c('claimsProjects-table', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.selectedItem === 'openClaims'),
      expression: "selectedItem === 'openClaims'"
    }],
    on: {
      "finishedLoading": function($event) {
        return _vm.updateCount('openClaims', $event)
      }
    }
  }), _vm._v(" "), _c('coming-soon', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.selectedItem === 'projectsCloseToBudget'),
      expression: "selectedItem === 'projectsCloseToBudget'"
    }]
  })], 1)])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-3e3af40a", module.exports)
  }
}

/***/ }),
/* 820 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "g-table-wrapper"
  }, [_c('div', {
    staticClass: "table-title"
  }, [_c('d-tooltip', {
    attrs: {
      "identifier": "oekonomi.unbilledProjects",
      "placement": "left"
    }
  }), _vm._v("\n        Afsluttede opgaver, der ikke er fakturerede\n    ")], 1), _vm._v(" "), (!_vm.loading) ? _c('vue-good-table', {
    attrs: {
      "columns": _vm.columns,
      "rows": _vm.rows,
      "search-options": _vm.searchOptions,
      "pagination-options": _vm.paginationOptions,
      "sort-options": _vm.sortOptions,
      "styleClass": _vm.styleClass
    },
    scopedSlots: _vm._u([{
      key: "table-row",
      fn: function(props) {
        return [(props.column.field == 'coverage_percent') ? _c('div', {
          staticClass: "coverage-cell"
        }, [_vm._v("\n                " + _vm._s(_vm._f("rounded")(props.row.coverage_percent)) + " \n                "), (props.row.coverage_percent !== null) ? _c('div', {
          staticClass: "coverage-indicator",
          class: {
            'bad': props.row.coverage_percent < _vm.$store.state.config.companyMeta.settings.coverage_percent.medium.value, 'avg': _vm.$options.filters.rounded(props.row.coverage_percent) >= _vm.$store.state.config.companyMeta.settings.coverage_percent.medium.value, 'good': _vm.$options.filters.rounded(props.row.coverage_percent) >= _vm.$store.state.config.companyMeta.settings.coverage_percent.high.value
          }
        }) : _vm._e()]) : (props.column.field == 'status.name') ? _c('div', {
          staticClass: "coverage-cell"
        }, [_vm._v("\n                " + _vm._s(props.row.status.name) + "\n                "), _c('div', {
          staticClass: "coverage-indicator status",
          style: ('background:#' + props.row.status.color + ';')
        })]) : (props.column.field == 'case_number') ? _c('div', {
          staticClass: "table-column__ordernumber",
          staticStyle: {
            "text-align": "left"
          }
        }, [_vm._v("\n                " + _vm._s(props.row.case_number) + "\n            ")]) : (props.column.field == 'description') ? _c('div', {
          staticClass: "table-column__description",
          attrs: {
            "title": props.row.description
          }
        }, [(props.row.calculation_price > 0) ? _c('budget-tooltip', {
          attrs: {
            "project": props.row
          }
        }) : _vm._e(), _vm._v("\n                " + _vm._s(props.row.description ? props.row.description : '-') + "\n            ")], 1) : (props.column.field == 'customer.name') ? _c('div', {
          staticClass: "table-column__customer",
          attrs: {
            "title": props.row.customer ? props.row.customer.name : '-'
          }
        }, [_vm._v("\n                " + _vm._s(props.row.customer ? props.row.customer.name : '-') + "\n            ")]) : (props.column.field == 'type.name') ? _c('div', {
          staticClass: "table-column__type",
          attrs: {
            "title": props.row.type ? props.row.type.name : '-'
          }
        }, [_vm._v("\n            " + _vm._s(props.row.type ? props.row.type.name : '-') + "\n            ")]) : (props.column.field == 'action') ? _c('div', {
          staticClass: "g-table__action",
          on: {
            "click": function($event) {
              return _vm.openExternalLink(props.row.external_id)
            }
          }
        }, [_c('i', {
          staticClass: "fad fa-eye"
        })]) : (props.column.field == 'start_date') ? _c('div', [_vm._v("\n                " + _vm._s(_vm._f("moment")(props.row.start_date, "DD. MMM YYYY")) + "\n            ")]) : (props.column.field == 'type.name') ? _c('div', {
          staticClass: "table-column__description",
          attrs: {
            "title": props.row.type ? props.row.type.name : '-'
          }
        }, [_vm._v("\n                " + _vm._s(props.row.type ? props.row.type.name : '-') + "\n            ")]) : (props.column.field == 'minuba_external_id') ? _c('div', [_c('a', {
          staticClass: "minuba-link",
          attrs: {
            "href": 'https://app.minuba.dk/?op=casedetails&glist=' + props.row.minuba_external_id,
            "target": "_blank"
          }
        }, [_c('i', {
          staticClass: "fas fa-eye"
        })])]) : _c('div', {
          attrs: {
            "title": props.formattedRow[props.column.field]
          }
        }, [_vm._v("\n                " + _vm._s(props.formattedRow[props.column.field]) + "\n            ")])]
      }
    }], null, false, 881934611)
  }, [_c('div', {
    attrs: {
      "slot": "emptystate"
    },
    slot: "emptystate"
  }, [_vm._v("\n            Ingen data ...\n        ")])]) : _c('box-loading', {
    attrs: {
      "height": "350"
    }
  })], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-3ef7d5b2", module.exports)
  }
}

/***/ }),
/* 821 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "customer-type-revenue"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    class: {
      'col-lg-6': !_vm.selectedRow, 'col-lg-3': _vm.selectedRow
    }
  }, [_c('div', {
    staticClass: "placeholder fit-content"
  }, [_c('div', {
    staticClass: "placeholder__heading"
  }, [_c('d-tooltip', {
    attrs: {
      "placement": "left",
      "identifier": "customers.customerTypeRevenue"
    }
  }), _vm._v("\n                    Hvilke kundetyper tjener vi penge på?\n                ")], 1), _vm._v(" "), _c('div', {
    staticClass: "placeholder"
  }, [(!_vm.loading) ? _c('vue-good-table', {
    attrs: {
      "columns": _vm.columns,
      "rows": _vm.rows,
      "search-options": _vm.searchOptions,
      "pagination-options": _vm.paginationOptions,
      "sort-options": _vm.sortOptions,
      "styleClass": _vm.styleClass,
      "row-style-class": _vm.selectedRowClass
    },
    on: {
      "on-row-click": _vm.selectCustomerType
    },
    scopedSlots: _vm._u([{
      key: "table-row",
      fn: function(props) {
        return [(props.column.field == 'coverage_percent') ? _c('div', {
          staticClass: "coverage-cell"
        }, [_vm._v("\n                                " + _vm._s(_vm._f("rounded")(props.row.coverage_percent)) + " \n                                "), (props.row.coverage_percent !== null) ? _c('div', {
          staticClass: "coverage-indicator",
          class: {
            'bad': props.row.coverage_percent < _vm.$store.state.config.companyMeta.settings.coverage_percent.medium.value, 'avg': _vm.$options.filters.rounded(props.row.coverage_percent) >= _vm.$store.state.config.companyMeta.settings.coverage_percent.medium.value, 'good': _vm.$options.filters.rounded(props.row.coverage_percent) >= _vm.$store.state.config.companyMeta.settings.coverage_percent.high.value
          }
        }) : _vm._e()]) : (props.column.field == 'name') ? _c('div', {
          staticClass: "table-column__description",
          attrs: {
            "title": props.row.name ? props.row.name : ''
          }
        }, [_vm._v("\n                                " + _vm._s(props.row.name ? props.row.name : '') + "\n                            ")]) : (props.column.field == 'coverage') ? _c('div', [_vm._v("\n                                " + _vm._s(_vm._f("currency")(props.row.coverage)) + "\n                            ")]) : (props.column.field == 'invoices_total') ? _c('div', [_vm._v("\n                                " + _vm._s(_vm._f("currency")(props.row.invoices_total)) + "\n                            ")]) : (props.column.field == 'coverage_per_hour') ? _c('div', {
          staticClass: "coverage-cell"
        }, [_vm._v("\n                                " + _vm._s(_vm._f("currency")(props.row.coverage_per_hour)) + " \n                                "), (props.row.coverage_per_hour !== null) ? _c('div', {
          staticClass: "coverage-indicator",
          class: {
            'bad': props.row.coverage_per_hour < _vm.$store.state.config.companyMeta.settings.coverage_per_hour.medium.value, 'avg': _vm.$options.filters.rounded(props.row.coverage_per_hour) >= _vm.$store.state.config.companyMeta.settings.coverage_per_hour.medium.value, 'good': _vm.$options.filters.rounded(props.row.coverage_per_hour) >= _vm.$store.state.config.companyMeta.settings.coverage_per_hour.high.value
          }
        }) : _vm._e()]) : _c('div', {
          attrs: {
            "title": props.formattedRow[props.column.field]
          }
        }, [_vm._v("\n                                " + _vm._s(props.formattedRow[props.column.field]) + "\n                            ")])]
      }
    }], null, false, 4067815955)
  }, [_c('div', {
    attrs: {
      "slot": "emptystate"
    },
    slot: "emptystate"
  }, [_vm._v("\n                            Ingen data ...\n                        ")])]) : _c('box-loading', {
    attrs: {
      "height": "350"
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    class: {
      'col-lg-6': !_vm.selectedRow, 'col-lg-9': _vm.selectedRow
    }
  }, [(!_vm.selectedRow) ? _c('div', [_vm._v("\n                Vælg en kundetype for at se en liste over alle opgaver med den type\n            ")]) : _vm._e(), _vm._v(" "), (_vm.selectedRow) ? _c('div', [_c('div', {
    staticStyle: {
      "margin-bottom": "5px"
    }
  }, [_c('a', {
    staticStyle: {
      "text-decoration": "none",
      "color": "#172b43",
      "font-weight": "600"
    },
    attrs: {
      "href": "javascript:void(0)"
    },
    on: {
      "click": function($event) {
        _vm.selectedRow = null
      }
    }
  }, [_c('i', {
    staticClass: "far fa-times"
  }), _vm._v(" Luk\n                    ")])])]) : _vm._e(), _vm._v(" "), (_vm.selectedRow) ? _c('customer-type-revenue-single', {
    attrs: {
      "data": _vm.selectedRow
    }
  }) : _vm._e()], 1)])])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-4076f830", module.exports)
  }
}

/***/ }),
/* 822 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "g-table-wrapper"
  }, [_c('div', {
    staticClass: "table-title"
  }, [_c('d-tooltip', {
    attrs: {
      "placement": "left",
      "identifier": "projects.offerProjects"
    }
  }), _vm._v("\n        Tilbud\n    ")], 1), _vm._v(" "), (!_vm.loading) ? _c('vue-good-table', {
    attrs: {
      "columns": _vm.columns,
      "rows": _vm.rows,
      "search-options": _vm.searchOptions,
      "pagination-options": _vm.paginationOptions,
      "sort-options": _vm.sortOptions,
      "styleClass": _vm.styleClass
    },
    scopedSlots: _vm._u([{
      key: "table-row",
      fn: function(props) {
        return [(props.column.field == 'coverage_percent') ? _c('div', {
          staticClass: "coverage-cell"
        }, [_vm._v("\n                " + _vm._s(_vm._f("rounded")(props.row.coverage_percent)) + " \n                "), (props.row.coverage_percent !== null) ? _c('div', {
          staticClass: "coverage-indicator",
          class: {
            'bad': props.row.coverage_percent < _vm.$store.state.config.companyMeta.settings.coverage_percent.medium.value, 'avg': _vm.$options.filters.rounded(props.row.coverage_percent) >= _vm.$store.state.config.companyMeta.settings.coverage_percent.medium.value, 'good': _vm.$options.filters.rounded(props.row.coverage_percent) >= _vm.$store.state.config.companyMeta.settings.coverage_percent.high.value
          }
        }) : _vm._e()]) : (props.column.field == 'status.name') ? _c('div', {
          staticClass: "coverage-cell"
        }, [_vm._v("\n                " + _vm._s(props.row.status.name) + "\n                "), _c('div', {
          staticClass: "coverage-indicator status",
          style: ('background:#' + props.row.status.color + ';')
        })]) : (props.column.field == 'case_number') ? _c('div', {
          staticClass: "table-column__ordernumber",
          staticStyle: {
            "text-align": "left"
          }
        }, [_vm._v("\n                " + _vm._s(props.row.case_number) + "\n            ")]) : (props.column.field == 'description') ? _c('div', {
          staticClass: "table-column__description",
          attrs: {
            "title": props.row.description
          }
        }, [(props.row.calculation_price > 0) ? _c('budget-tooltip', {
          attrs: {
            "project": props.row
          }
        }) : _vm._e(), _vm._v("\n                " + _vm._s(props.row.description ? props.row.description : '-') + "\n            ")], 1) : (props.column.field == 'customer.name') ? _c('div', {
          staticClass: "table-column__customer",
          attrs: {
            "title": props.row.customer ? props.row.customer.name : '-'
          }
        }, [_vm._v("\n                " + _vm._s(props.row.customer ? props.row.customer.name : '-') + "\n            ")]) : (props.column.field == 'action') ? _c('div', {
          staticClass: "g-table__action",
          on: {
            "click": function($event) {
              return _vm.openExternalLink(props.row.external_id)
            }
          }
        }, [_c('i', {
          staticClass: "fad fa-eye"
        })]) : (props.column.field == 'start_date') ? _c('div', [_vm._v("\n                " + _vm._s(_vm._f("moment")(props.row.start_date, "DD. MMM YYYY")) + "\n            ")]) : (props.column.field == 'type.name') ? _c('div', {
          staticClass: "table-column__description",
          attrs: {
            "title": props.row.type ? props.row.type.name : '-'
          }
        }, [_vm._v("\n                " + _vm._s(props.row.type ? props.row.type.name : '-') + "\n            ")]) : (props.column.field == 'minuba_external_id') ? _c('div', [_c('a', {
          staticClass: "minuba-link",
          attrs: {
            "href": 'https://app.minuba.dk/?op=casedetails&glist=' + props.row.minuba_external_id,
            "target": "_blank"
          }
        }, [_c('i', {
          staticClass: "fas fa-eye"
        })])]) : _c('div', {
          attrs: {
            "title": props.formattedRow[props.column.field]
          }
        }, [_vm._v("\n                " + _vm._s(props.formattedRow[props.column.field]) + "\n            ")])]
      }
    }], null, false, 1613006212)
  }, [_c('div', {
    attrs: {
      "slot": "emptystate"
    },
    slot: "emptystate"
  }, [_vm._v("\n            Ingen data ...\n        ")])]) : _c('box-loading', {
    attrs: {
      "height": "350"
    }
  })], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-408ffce2", module.exports)
  }
}

/***/ }),
/* 823 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "projects-learning"
  }, [_c('div', {
    staticClass: "content"
  }, [_c('content-switch', {
    attrs: {
      "items": _vm.switchItems,
      "selectedItem": _vm.selectedItem,
      "counts": _vm.counts
    },
    on: {
      "selectItem": function($event) {
        return _vm.handleSelectItem($event)
      }
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.selectedItem === 'projectTypeRevenue'),
      expression: "selectedItem === 'projectTypeRevenue'"
    }],
    staticClass: "row"
  }, [_c('div', {
    class: {
      'col-lg-6': !_vm.selectedProjectType, 'col-lg-3': _vm.selectedProjectType
    }
  }, [_c('projectTypeRevenue-table', {
    attrs: {
      "title": "Hvilke opgavetyper tjenes der penge på?"
    },
    on: {
      "selectProjectType": function($event) {
        return _vm.setSelectedProjectType($event)
      },
      "finishedLoading": function($event) {
        return _vm.updateCount('projectTypeRevenue', $event)
      }
    }
  })], 1), _vm._v(" "), (_vm.selectedProjectType) ? _c('div', {
    staticClass: "col-lg-9"
  }, [_c('div', {
    staticStyle: {
      "margin-bottom": "5px"
    }
  }, [_c('a', {
    staticStyle: {
      "text-decoration": "none",
      "color": "#172b43",
      "font-weight": "600"
    },
    attrs: {
      "href": "javascript:void(0)"
    },
    on: {
      "click": function($event) {
        _vm.selectedProjectType = null
      }
    }
  }, [_c('i', {
    staticClass: "far fa-times"
  }), _vm._v(" Luk\n                    ")])]), _vm._v(" "), _c('showTypeRevenue-table', {
    attrs: {
      "rows": _vm.$store.getters.groupedProjects[_vm.selectedProjectType],
      "title": "Konkrete opgaver"
    }
  })], 1) : _c('div', {
    staticClass: "col-lg-6"
  }, [_vm._v("\n                Vælg en opgavetype for at se en liste over alle opgaver og deres konkrete indtjening.\n            ")])]), _vm._v(" "), _c('closedProjects-table', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.selectedItem === 'closedProjectsRevenue'),
      expression: "selectedItem === 'closedProjectsRevenue'"
    }],
    attrs: {
      "title": "Hvilke konkrete opgaver tjenes der penge på?"
    },
    on: {
      "finishedLoading": function($event) {
        return _vm.updateCount('closedProjectsRevenue', $event)
      }
    }
  }), _vm._v(" "), _c('project-type-skills', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.selectedItem === 'projectTypeSkills'),
      expression: "selectedItem === 'projectTypeSkills'"
    }]
  }), _vm._v(" "), _c('project-type-development', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.selectedItem === 'projectTypeDevelopment'),
      expression: "selectedItem === 'projectTypeDevelopment'"
    }]
  }), _vm._v(" "), _c('project-type-coverage-per-hour-development', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.selectedItem === 'coveragePerHourPerProjectTypeDevelopment'),
      expression: "selectedItem === 'coveragePerHourPerProjectTypeDevelopment'"
    }]
  }), _vm._v(" "), _c('claims-table', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.selectedItem === 'claims'),
      expression: "selectedItem === 'claims'"
    }],
    on: {
      "finishedLoading": function($event) {
        return _vm.updateCount('claims', $event)
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "placeholder"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.selectedItem === 'closedProjectsRevenue'),
      expression: "selectedItem === 'closedProjectsRevenue'"
    }]
  })])], 1)])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-41150ece", module.exports)
  }
}

/***/ }),
/* 824 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "g-table-wrapper"
  }, [_c('div', {
    staticClass: "table-title"
  }, [_vm._v("\n        " + _vm._s(_vm.title) + "\n    ")]), _vm._v(" "), (_vm.rows) ? _c('vue-good-table', {
    attrs: {
      "columns": _vm.columns,
      "rows": _vm.rows,
      "search-options": _vm.searchOptions,
      "pagination-options": _vm.paginationOptions,
      "sort-options": _vm.sortOptions,
      "styleClass": _vm.styleClass
    },
    scopedSlots: _vm._u([{
      key: "table-row",
      fn: function(props) {
        return [(props.column.field == 'coverage_percent') ? _c('div', {
          staticClass: "coverage-cell"
        }, [_vm._v("\n                " + _vm._s(_vm._f("rounded")(props.row.coverage_percent)) + " \n                "), (props.row.coverage_percent !== null) ? _c('div', {
          staticClass: "coverage-indicator",
          class: {
            'bad': props.row.coverage_percent < _vm.$store.state.config.companyMeta.settings.coverage_percent.medium.value, 'avg': _vm.$options.filters.rounded(props.row.coverage_percent) >= _vm.$store.state.config.companyMeta.settings.coverage_percent.medium.value, 'good': _vm.$options.filters.rounded(props.row.coverage_percent) >= _vm.$store.state.config.companyMeta.settings.coverage_percent.high.value
          }
        }) : _vm._e()]) : (props.column.field == 'case_number') ? _c('div', {
          staticClass: "table-column__ordernumber",
          staticStyle: {
            "text-align": "left"
          }
        }, [_vm._v("\n                " + _vm._s(props.row.case_number) + "\n            ")]) : (props.column.field == 'description') ? _c('div', {
          staticClass: "table-column__description",
          attrs: {
            "title": props.row.description
          }
        }, [_vm._v("\n                " + _vm._s(props.row.description) + "\n            ")]) : (props.column.field == 'customer.name') ? _c('div', {
          staticClass: "table-column__customer",
          attrs: {
            "title": props.row.customer.name
          }
        }, [(props.row.customer) ? _c('span', [_vm._v("\n                    " + _vm._s(props.row.customer.name) + "\n                ")]) : _vm._e()]) : (props.column.field == 'invoices_total') ? _c('div', [_vm._v("\n                " + _vm._s(_vm._f("currency")(props.row.invoices_total)) + "\n            ")]) : (props.column.field == 'coverage') ? _c('div', [_vm._v("\n                " + _vm._s(_vm._f("currency")(props.row.coverage)) + "\n            ")]) : (props.column.field == 'coverage_per_hour') ? _c('div', {
          staticClass: "coverage-cell"
        }, [_vm._v("\n                " + _vm._s(_vm._f("currency")(props.row.coverage_per_hour)) + " \n                "), (props.row.coverage_per_hour !== null) ? _c('div', {
          staticClass: "coverage-indicator",
          class: {
            'bad': props.row.coverage_per_hour < _vm.$store.state.config.companyMeta.settings.coverage_per_hour.medium.value, 'avg': _vm.$options.filters.rounded(props.row.coverage_per_hour) >= _vm.$store.state.config.companyMeta.settings.coverage_per_hour.medium.value, 'good': _vm.$options.filters.rounded(props.row.coverage_per_hour) >= _vm.$store.state.config.companyMeta.settings.coverage_per_hour.high.value
          }
        }) : _vm._e()]) : (props.column.field == 'start_date') ? _c('div', [_vm._v("\n                " + _vm._s(_vm._f("moment")(props.row.start_date, "DD. MMM YYYY")) + "\n            ")]) : (props.column.field == 'action') ? _c('div', {
          staticClass: "g-table__action",
          on: {
            "click": function($event) {
              return _vm.openExternalLink(props.row.external_id)
            }
          }
        }, [_c('i', {
          staticClass: "fad fa-eye"
        })]) : (props.column.field == 'minuba_external_id') ? _c('div', [_c('a', {
          staticClass: "minuba-link",
          attrs: {
            "href": 'https://app.minuba.dk/?op=casedetails&glist=' + props.row.minuba_external_id,
            "target": "_blank"
          }
        }, [_c('i', {
          staticClass: "fas fa-eye"
        })])]) : _c('div', {
          attrs: {
            "title": props.formattedRow[props.column.field]
          }
        }, [_vm._v("\n                " + _vm._s(props.formattedRow[props.column.field]) + "\n            ")])]
      }
    }], null, false, 564695256)
  }, [_c('div', {
    attrs: {
      "slot": "emptystate"
    },
    slot: "emptystate"
  }, [_vm._v("\n            Ingen data ...\n        ")])]) : _vm._e()], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-41336e6a", module.exports)
  }
}

/***/ }),
/* 825 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('layout')], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-427a9fc7", module.exports)
  }
}

/***/ }),
/* 826 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "project-types-potential"
  }, [_c('div', {
    staticClass: "placeholder"
  }, [_c('div', {
    staticClass: "placeholder__heading"
  }, [_vm._v("\n            Potentielt ekstra årligt EBITDA pr. opgavetype\n            "), _c('d-tooltip', {
    attrs: {
      "placement": "inline",
      "identifier": "potential.projectTypePotential"
    }
  })], 1), _vm._v(" "), (_vm.projectTypes && !_vm.loading) ? _c('div', {
    staticClass: "placeholder padding"
  }, [_c('div', {
    staticClass: "intro"
  }, [_vm._v("\n                Her ser du, hvad det giver i øget årligt EBITDA, at øge prisen med få procent.\n            ")]), _vm._v(" "), (_vm.projectTypes.length > 0) ? _c('div', {
    staticClass: "list"
  }, [_vm._l((_vm.projectTypes), function(projectType) {
    return _c('div', {
      key: projectType.name,
      staticClass: "single"
    }, [_c('div', {
      staticClass: "info"
    }, [_c('strong', [_vm._v("\n                            " + _vm._s(projectType.name) + "\n                        ")]), _vm._v(" "), _c('div', {
      staticClass: "small"
    }, [_c('b', [_vm._v(_vm._s(projectType.projects_count))]), _vm._v("\n                            opgaver m. samlet omsætning på\n                            "), _c('b', [_vm._v(_vm._s(_vm._f("currency")(projectType.total_revenue)))]), _vm._v(" "), _c('br'), _vm._v("\n                            Gns. DG pr. opgave: "), _c('b', [_vm._v(_vm._s(_vm._f("number")(projectType.coverage_percent)) + "%")])])]), _vm._v(" "), _c('div', {
      staticClass: "slider"
    }, [(projectType.total_revenue > 0) ? _c('div', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (projectType.value),
        expression: "projectType.value"
      }],
      attrs: {
        "type": "range",
        "min": -100,
        "max": 100
      },
      domProps: {
        "value": (projectType.value)
      },
      on: {
        "__r": function($event) {
          return _vm.$set(projectType, "value", $event.target.value)
        }
      }
    }), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
      staticClass: "slider-value"
    }, [_c('div', {
      staticClass: "small",
      staticStyle: {
        "display": "flex",
        "justify-content": "space-between"
      }
    }, [_c('div', [_vm._v("\n                                        Meromsætning\n                                    ")]), _vm._v(" "), _c('div', [(projectType.value > 0) ? _c('span', [_vm._v("+")]) : _vm._e(), _vm._v(_vm._s(projectType.value) + " %\n                                    ")])])])]) : _c('div', {
      staticClass: "small",
      attrs: {
        "align": "center"
      }
    }, [_vm._v("\n                            Ingen data for perioden\n                        ")])]), _vm._v(" "), _c('div', {
      staticClass: "result",
      class: {
        'positive': (projectType.total_revenue / 100) * projectType.value > 0, 'negative': (projectType.total_revenue / 100) * projectType.value < 0
      }
    }, [(projectType.total_revenue > 0 && projectType.value !== 0 && projectType.value !== '0') ? _c('div', [(projectType.value > 0) ? _c('span', [_vm._v("+")]) : _vm._e(), _vm._v(_vm._s(_vm._f("currency")(((projectType.total_revenue / 100) * projectType.value * _vm.convertToYear))) + "\n                        ")]) : _c('div', [_vm._v("\n                            -\n                        ")])])])
  }), _vm._v(" "), _c('div', {
    staticClass: "single"
  }, [_c('div', {
    staticClass: "info big"
  }, [_vm._v("\n                        Potentielt ekstra årligt EBITDA\n                    ")]), _vm._v(" "), _c('div', {
    staticClass: "slider"
  }), _vm._v(" "), _c('div', {
    staticClass: "result big",
    class: {
      'positive': _vm.total > 0, 'negative': _vm.total < 0
    }
  }, [(_vm.total > 0) ? _c('span', [_vm._v("+")]) : _vm._e(), _vm._v(_vm._s(_vm._f("currency")(_vm.total)) + "\n                    ")])])], 2) : _vm._e()]) : _c('box-loading', {
    attrs: {
      "height": "350"
    }
  })], 1)])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-45eaf5ea", module.exports)
  }
}

/***/ }),
/* 827 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "graph-card"
  }, [_c('div', {
    staticClass: "graph-header"
  }, [_c('div', {
    staticClass: "table-heading"
  }, [_c('d-tooltip', {
    attrs: {
      "placement": "left",
      "identifier": "employees.timeWithCustomers"
    }
  }), _vm._v("\n            " + _vm._s(_vm.heading) + "\n            "), _vm._t("default")], 2)]), _vm._v(" "), (!_vm.loading) ? _c('vue-apex-charts', {
    staticClass: "graph-data-box",
    attrs: {
      "height": _vm.height,
      "options": _vm.options,
      "series": _vm.getSeries
    }
  }) : _c('box-loading', {
    attrs: {
      "height": "465"
    }
  })], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-46c39325", module.exports)
  }
}

/***/ }),
/* 828 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "main-project-types"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    class: {
      'col-lg-6': !_vm.selectedRow, 'col-lg-3': _vm.selectedRow
    }
  }, [_c('div', {
    staticClass: "placeholder fit-content"
  }, [_c('div', {
    staticClass: "placeholder__heading"
  }, [_c('d-tooltip', {
    attrs: {
      "placement": "left",
      "identifier": "enterprise.mainProjectType"
    }
  }), _vm._v("\n                    Hvilke entreprisetyper tjenes der penge på?\n                ")], 1), _vm._v(" "), _c('div', {
    staticClass: "placeholder"
  }, [(!_vm.loading) ? _c('vue-good-table', {
    attrs: {
      "columns": _vm.columns,
      "rows": _vm.rows,
      "search-options": _vm.searchOptions,
      "pagination-options": _vm.paginationOptions,
      "sort-options": _vm.sortOptions,
      "styleClass": _vm.styleClass,
      "row-style-class": _vm.selectedRowClass
    },
    on: {
      "on-row-click": _vm.selectMainProjectType
    },
    scopedSlots: _vm._u([{
      key: "table-row",
      fn: function(props) {
        return [(props.column.field == 'coverage_percent') ? _c('div', {
          staticClass: "coverage-cell"
        }, [_vm._v("\n                                " + _vm._s(_vm._f("rounded")(props.row.coverage_percent)) + " \n                                "), (props.row.coverage_percent !== null) ? _c('div', {
          staticClass: "coverage-indicator",
          class: {
            'bad': props.row.coverage_percent < _vm.$store.state.config.companyMeta.settings.coverage_percent.medium.value, 'avg': _vm.$options.filters.rounded(props.row.coverage_percent) >= _vm.$store.state.config.companyMeta.settings.coverage_percent.medium.value, 'good': _vm.$options.filters.rounded(props.row.coverage_percent) >= _vm.$store.state.config.companyMeta.settings.coverage_percent.high.value
          }
        }) : _vm._e()]) : (props.column.field == 'coverage') ? _c('div', [_vm._v("\n                                " + _vm._s(_vm._f("currency")(props.row.coverage)) + "\n                            ")]) : (props.column.field == 'invoices_total') ? _c('div', [_vm._v("\n                                " + _vm._s(_vm._f("currency")(props.row.invoices_total)) + "\n                            ")]) : (props.column.field == 'coverage_per_hour') ? _c('div', {
          staticClass: "coverage-cell"
        }, [_vm._v("\n                                " + _vm._s(_vm._f("currency")(props.row.coverage_per_hour)) + " \n                                "), (props.row.coverage_per_hour !== null) ? _c('div', {
          staticClass: "coverage-indicator",
          class: {
            'bad': props.row.coverage_per_hour < _vm.$store.state.config.companyMeta.settings.coverage_per_hour.medium.value, 'avg': _vm.$options.filters.rounded(props.row.coverage_per_hour) >= _vm.$store.state.config.companyMeta.settings.coverage_per_hour.medium.value, 'good': _vm.$options.filters.rounded(props.row.coverage_per_hour) >= _vm.$store.state.config.companyMeta.settings.coverage_per_hour.high.value
          }
        }) : _vm._e()]) : _c('div', {
          attrs: {
            "title": props.formattedRow[props.column.field]
          }
        }, [_vm._v("\n                                " + _vm._s(props.formattedRow[props.column.field]) + "\n                            ")])]
      }
    }], null, false, 1617846988)
  }, [_c('div', {
    attrs: {
      "slot": "emptystate"
    },
    slot: "emptystate"
  }, [_vm._v("\n                            Ingen data ...\n                        ")])]) : _c('box-loading', {
    attrs: {
      "height": "350"
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    class: {
      'col-lg-6': !_vm.selectedRow, 'col-lg-9': _vm.selectedRow
    }
  }, [(!_vm.selectedRow) ? _c('div', [_vm._v("\n                Vælg en entreprisetype for at se en liste over alle under-entreprisetyper til denne entreprisetype\n            ")]) : _vm._e(), _vm._v(" "), (_vm.selectedRow) ? _c('div', [_c('div', {
    staticStyle: {
      "margin-bottom": "5px"
    }
  }, [_c('a', {
    staticStyle: {
      "text-decoration": "none",
      "color": "#172b43",
      "font-weight": "600"
    },
    attrs: {
      "href": "javascript:void(0)"
    },
    on: {
      "click": function($event) {
        _vm.selectedRow = null;
        _vm.selectedSubProjectType = null
      }
    }
  }, [_c('i', {
    staticClass: "far fa-times"
  }), _vm._v(" Luk\n                    ")])])]) : _vm._e(), _vm._v(" "), (_vm.selectedRow) ? _c('main-project-type-single', {
    attrs: {
      "data": _vm.selectedRow
    },
    on: {
      "showSubProjects": function($event) {
        return _vm.setSubProjects($event)
      }
    }
  }) : _vm._e()], 1), _vm._v(" "), (!_vm.selectedSubProjectType) ? _c('div', {
    staticClass: "col-lg-12"
  }, [_vm._v("\n            Vælg en entrepriseopgave for at se alle underopgaverne her\n        ")]) : _vm._e(), _vm._v(" "), (_vm.selectedSubProjectType) ? _c('div', {
    staticClass: "col-lg-12"
  }, [_c('sub-projects', {
    attrs: {
      "data": _vm.selectedSubProjectType
    }
  })], 1) : _vm._e()])])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-46de1d39", module.exports)
  }
}

/***/ }),
/* 829 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "customer-invoices_total"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-6"
  }, [_c('div', {
    staticClass: "placeholder fit-content"
  }, [_c('div', {
    staticClass: "placeholder__heading"
  }, [_c('d-tooltip', {
    attrs: {
      "placement": "left",
      "identifier": "customers.customerGroups"
    }
  }), _vm._v("\n                    Hvordan er kunderne fordelt på omsætning?\n                ")], 1), _vm._v(" "), _c('div', {
    staticClass: "placeholder"
  }, [(!_vm.loading && _vm.rows.length > 0) ? _c('vue-good-table', {
    attrs: {
      "columns": _vm.columns,
      "rows": _vm.rows,
      "search-options": _vm.searchOptions,
      "pagination-options": _vm.paginationOptions,
      "sort-options": _vm.sortOptions,
      "styleClass": _vm.styleClass,
      "row-style-class": _vm.selectedRowClass
    },
    on: {
      "on-row-click": _vm.handleRowClick
    },
    scopedSlots: _vm._u([{
      key: "table-row",
      fn: function(props) {
        return [(props.column.field == 'coverage_percent') ? _c('div', {
          staticClass: "coverage-cell"
        }, [_vm._v("\n                                " + _vm._s(_vm._f("rounded")(props.row.coverage_percent)) + " \n                                "), (props.row.coverage_percent !== null) ? _c('div', {
          staticClass: "coverage-indicator",
          class: {
            'bad': props.row.coverage_percent < _vm.$store.state.config.companyMeta.settings.coverage_percent.medium.value, 'avg': _vm.$options.filters.rounded(props.row.coverage_percent) >= _vm.$store.state.config.companyMeta.settings.coverage_percent.medium.value, 'good': _vm.$options.filters.rounded(props.row.coverage_percent) >= _vm.$store.state.config.companyMeta.settings.coverage_percent.high.value
          }
        }) : _vm._e()]) : (props.column.field == 'invoices_total') ? _c('div', [_vm._v("\n                                " + _vm._s(_vm._f("currency")(props.row.invoices_total)) + "\n                            ")]) : (props.column.field == 'coverage') ? _c('div', [_vm._v("\n                                " + _vm._s(_vm._f("currency")(props.row.coverage)) + "\n                            ")]) : (props.column.field == 'coverage_per_hour') ? _c('div', {
          staticClass: "coverage-cell"
        }, [_vm._v("\n                                " + _vm._s(_vm._f("currency")(props.row.coverage_per_hour)) + " \n                                "), (props.row.coverage_per_hour !== null) ? _c('div', {
          staticClass: "coverage-indicator",
          class: {
            'bad': props.row.coverage_per_hour < _vm.$store.state.config.companyMeta.settings.coverage_per_hour.medium.value, 'avg': _vm.$options.filters.rounded(props.row.coverage_per_hour) >= _vm.$store.state.config.companyMeta.settings.coverage_per_hour.medium.value, 'good': _vm.$options.filters.rounded(props.row.coverage_per_hour) >= _vm.$store.state.config.companyMeta.settings.coverage_per_hour.high.value
          }
        }) : _vm._e()]) : (props.column.field == 'bracket') ? _c('div', [_vm._v("\n                                " + _vm._s(props.row.bracket) + " kr.\n                            ")]) : _c('div', [_vm._v("\n                                " + _vm._s(props.formattedRow[props.column.field]) + "\n                            ")])]
      }
    }], null, false, 603384420)
  }, [_c('div', {
    attrs: {
      "slot": "emptystate"
    },
    slot: "emptystate"
  }, [_vm._v("\n                            Ingen data ...\n                        ")])]) : _c('box-loading', {
    attrs: {
      "height": "350"
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-6"
  }, [(!_vm.selectedBracket) ? _c('div', {
    staticClass: "info"
  }, [_vm._v("\n                Vælg et interval for at se en liste over alle kunder i intervallet.\n            ")]) : _c('customer-grouped-single', {
    attrs: {
      "customers": _vm.groupedCustomers[_vm.selectedBracket],
      "name": _vm.selectedBracket
    }
  })], 1)])])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-49678e64", module.exports)
  }
}

/***/ }),
/* 830 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "placeholder"
  }, [_c('div', {
    staticClass: "placeholder__heading"
  }, [_vm._v("\n            Opgaver uden budget (" + _vm._s(_vm.rows ? _vm.rows.length : '-') + ")\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "placeholder"
  }, [(!_vm.loading) ? _c('vue-good-table', {
    attrs: {
      "columns": _vm.columns,
      "rows": _vm.rows,
      "searchOptions": _vm.searchOptions,
      "paginationOptions": _vm.paginationOptions,
      "sortOptions": _vm.sortOptions,
      "styleClass": "vgt-table"
    },
    scopedSlots: _vm._u([{
      key: "table-row",
      fn: function(props) {
        return [(props.column.field == 'description') ? _c('div', {
          staticClass: "table-column__description",
          attrs: {
            "title": props.row.description
          }
        }, [_vm._v("\n                        " + _vm._s(props.row.description) + "\n                    ")]) : (props.column.field == 'customer.name') ? _c('div', {
          staticClass: "table-column__customer",
          attrs: {
            "title": props.row.customer ? props.row.customer.name : '-'
          }
        }, [_vm._v("\n                        " + _vm._s(props.row.customer ? props.row.customer.name : '-') + "\n                    ")]) : (props.column.field == 'start_date') ? _c('div', [_vm._v("\n                        " + _vm._s(_vm._f("moment")(props.row.start_date, "DD. MMM YYYY")) + "\n                    ")]) : (props.column.field == 'status.name') ? _c('div', {
          staticClass: "coverage-cell"
        }, [_vm._v("\n                        " + _vm._s(props.row.status.name) + "\n                        "), _c('div', {
          staticClass: "coverage-indicator status",
          style: ('background:#' + props.row.status.color + ';')
        })]) : (props.column.field == 'minuba_external_id') ? _c('div', [_c('a', {
          staticClass: "minuba-link",
          attrs: {
            "href": 'https://app.minuba.dk/?op=casedetails&glist=' + props.row.minuba_external_id,
            "target": "_blank"
          }
        }, [_c('i', {
          staticClass: "fas fa-eye"
        })])]) : _c('div', {
          attrs: {
            "title": props.formattedRow[props.column.field]
          }
        }, [_vm._v("\n                        " + _vm._s(props.formattedRow[props.column.field]) + "\n                    ")])]
      }
    }], null, false, 638086115)
  }, [_c('div', {
    attrs: {
      "slot": "emptystate"
    },
    slot: "emptystate"
  }, [_vm._v("\n                    Ingen data ...\n                ")])]) : _c('box-loading', {
    attrs: {
      "height": "350"
    }
  })], 1)])])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-4ad6705f", module.exports)
  }
}

/***/ }),
/* 831 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "economy-learning-potential"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-6"
  }, [_c('costprice-per-hour')], 1), _vm._v(" "), _c('div', {
    staticClass: "col-lg-6"
  }, [_c('costs-division')], 1)])])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-4d666c6b", module.exports)
  }
}

/***/ }),
/* 832 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "compare-revenue"
  }, [_c('div', {
    staticClass: "placeholder"
  }, [_c('div', {
    staticClass: "placeholder__heading"
  }, [_vm._v("\n            Omsætning\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "placeholder padding"
  }, [(!_vm.loading && _vm.series.length > 0) ? _c('vue-apex-charts', {
    ref: "tester",
    attrs: {
      "height": _vm.height,
      "options": _vm.options,
      "series": _vm.series,
      "type": "line"
    }
  }) : _c('box-loading', {
    attrs: {
      "height": "400"
    }
  })], 1)])])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-4f03b8ba", module.exports)
  }
}

/***/ }),
/* 833 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "g-table-wrapper"
  }, [_c('div', {
    staticClass: "table-title"
  }, [_c('d-tooltip', {
    attrs: {
      "placement": "left",
      "identifier": "projects.closedProjects"
    }
  }), _vm._v("\n        " + _vm._s(_vm.title) + "\n    ")], 1), _vm._v(" "), (!_vm.loading) ? _c('vue-good-table', {
    attrs: {
      "columns": _vm.columns,
      "rows": _vm.rows,
      "search-options": _vm.searchOptions,
      "pagination-options": _vm.paginationOptions,
      "sort-options": _vm.sortOptions,
      "styleClass": _vm.styleClass
    },
    scopedSlots: _vm._u([{
      key: "table-row",
      fn: function(props) {
        return [(props.column.field == 'coverage_percent') ? _c('div', {
          staticClass: "coverage-cell"
        }, [_vm._v("\n                " + _vm._s(_vm._f("rounded")(props.row.coverage_percent)) + " \n                "), (props.row.coverage_percent !== null) ? _c('div', {
          staticClass: "coverage-indicator",
          class: {
            'bad': props.row.coverage_percent < _vm.$store.state.config.companyMeta.settings.coverage_percent.medium.value, 'avg': _vm.$options.filters.rounded(props.row.coverage_percent) >= _vm.$store.state.config.companyMeta.settings.coverage_percent.medium.value, 'good': _vm.$options.filters.rounded(props.row.coverage_percent) >= _vm.$store.state.config.companyMeta.settings.coverage_percent.high.value
          }
        }) : _vm._e()]) : (props.column.field == 'case_number') ? _c('div', {
          staticClass: "table-column__ordernumber",
          staticStyle: {
            "text-align": "left"
          }
        }, [_vm._v("\n                " + _vm._s(props.row.case_number) + "\n            ")]) : (props.column.field == 'description') ? _c('div', {
          staticClass: "table-column__description",
          attrs: {
            "title": props.row.description
          }
        }, [_vm._v("\n                " + _vm._s(props.row.description) + "\n            ")]) : (props.column.field == 'customer.name') ? _c('div', {
          staticClass: "table-column__customer",
          attrs: {
            "title": props.row.customer ? props.row.customer.name : '-'
          }
        }, [_vm._v("\n                " + _vm._s(props.row.customer ? props.row.customer.name : '-') + "\n            ")]) : (props.column.field == 'invoices_total') ? _c('div', [_vm._v("\n                " + _vm._s(_vm._f("currency")(props.row.invoices_total)) + "\n            ")]) : (props.column.field == 'coverage') ? _c('div', [_c('project-tooltip', {
          attrs: {
            "project": props.row
          }
        }), _vm._v("\n                " + _vm._s(_vm._f("currency")(props.row.coverage)) + "\n            ")], 1) : (props.column.field == 'coverage_per_hour') ? _c('div', {
          staticClass: "coverage-cell"
        }, [_vm._v("\n                " + _vm._s(_vm._f("currency")(props.row.coverage_per_hour)) + " \n                "), (props.row.coverage_per_hour !== null) ? _c('div', {
          staticClass: "coverage-indicator",
          class: {
            'bad': props.row.coverage_per_hour < _vm.$store.state.config.companyMeta.settings.coverage_per_hour.medium.value, 'avg': _vm.$options.filters.rounded(props.row.coverage_per_hour) >= _vm.$store.state.config.companyMeta.settings.coverage_per_hour.medium.value, 'good': _vm.$options.filters.rounded(props.row.coverage_per_hour) >= _vm.$store.state.config.companyMeta.settings.coverage_per_hour.high.value
          }
        }) : _vm._e()]) : (props.column.field == 'action') ? _c('div', {
          staticClass: "g-table__action",
          on: {
            "click": function($event) {
              return _vm.openExternalLink(props.row.external_id)
            }
          }
        }, [_c('i', {
          staticClass: "fad fa-eye"
        })]) : (props.column.field == 'start_date') ? _c('div', [_vm._v("\n                " + _vm._s(_vm._f("moment")(props.row.start_date, "DD. MMM YYYY")) + "\n            ")]) : (props.column.field == 'type.name') ? _c('div', {
          staticClass: "table-column__description",
          attrs: {
            "title": props.row.type ? props.row.type.name : '-'
          }
        }, [_vm._v("\n                " + _vm._s(props.row.type ? props.row.type.name : '-') + "\n            ")]) : (props.column.field == 'minuba_external_id') ? _c('div', [_c('a', {
          staticClass: "minuba-link",
          attrs: {
            "href": 'https://app.minuba.dk/?op=casedetails&glist=' + props.row.minuba_external_id,
            "target": "_blank"
          }
        }, [_c('i', {
          staticClass: "fas fa-eye"
        })])]) : _c('div', {
          attrs: {
            "title": props.formattedRow[props.column.field]
          }
        }, [_vm._v("\n                " + _vm._s(props.formattedRow[props.column.field]) + "\n            ")])]
      }
    }], null, false, 1603418439)
  }, [_c('div', {
    attrs: {
      "slot": "emptystate"
    },
    slot: "emptystate"
  }, [_vm._v("\n            Ingen data ...\n        ")])]) : _c('box-loading', {
    attrs: {
      "height": "350"
    }
  })], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-4fc3fdd6", module.exports)
  }
}

/***/ }),
/* 834 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "employee-skills-single"
  }, [_c('div', {
    staticClass: "placeholder"
  }, [_c('div', {
    staticClass: "placeholder__heading"
  }, [_vm._v("\n            " + _vm._s(_vm.data.full_name) + "\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "placeholder"
  }, [(!_vm.loading) ? _c('vue-good-table', {
    attrs: {
      "columns": _vm.columns,
      "rows": _vm.rows,
      "search-options": _vm.searchOptions,
      "pagination-options": _vm.paginationOptions,
      "sort-options": _vm.sortOptions,
      "styleClass": _vm.styleClass,
      "row-style-class": _vm.selectedRowClass
    },
    on: {
      "on-row-click": _vm.selectProjectType
    },
    scopedSlots: _vm._u([{
      key: "table-row",
      fn: function(props) {
        return [(props.column.field == 'coverage_percent') ? _c('div', {
          staticClass: "coverage-cell"
        }, [_vm._v("\n                        " + _vm._s(_vm._f("rounded")(props.row.coverage_percent)) + " \n                        "), (props.row.coverage_percent !== null) ? _c('div', {
          staticClass: "coverage-indicator",
          class: {
            'bad': props.row.coverage_percent < _vm.$store.state.config.companyMeta.settings.coverage_percent.medium.value, 'avg': _vm.$options.filters.rounded(props.row.coverage_percent) >= _vm.$store.state.config.companyMeta.settings.coverage_percent.medium.value, 'good': _vm.$options.filters.rounded(props.row.coverage_percent) >= _vm.$store.state.config.companyMeta.settings.coverage_percent.high.value
          }
        }) : _vm._e()]) : (props.column.field == 'name') ? _c('div', {
          staticClass: "table-column__description",
          attrs: {
            "title": props.row.name ? props.row.name : '-'
          }
        }, [_vm._v("\n                        " + _vm._s(props.row.name ? props.row.name : '-') + "\n                    ")]) : (props.column.field == 'coverage') ? _c('div', [_vm._v("\n                        " + _vm._s(_vm._f("currency")(props.row.coverage)) + "\n                    ")]) : (props.column.field == 'invoices_total') ? _c('div', [_vm._v("\n                        " + _vm._s(_vm._f("currency")(props.row.invoices_total)) + "\n                    ")]) : (props.column.field == 'coverage_per_hour') ? _c('div', {
          staticClass: "coverage-cell"
        }, [_vm._v("\n                        " + _vm._s(_vm._f("currency")(props.row.coverage_per_hour)) + " \n                        "), (props.row.coverage_per_hour !== null) ? _c('div', {
          staticClass: "coverage-indicator",
          class: {
            'bad': props.row.coverage_per_hour < _vm.$store.state.config.companyMeta.settings.coverage_per_hour.medium.value, 'avg': _vm.$options.filters.rounded(props.row.coverage_per_hour) >= _vm.$store.state.config.companyMeta.settings.coverage_per_hour.medium.value, 'good': _vm.$options.filters.rounded(props.row.coverage_per_hour) >= _vm.$store.state.config.companyMeta.settings.coverage_per_hour.high.value
          }
        }) : _vm._e()]) : _c('div', [_vm._v("\n                        " + _vm._s(props.formattedRow[props.column.field]) + "\n                    ")])]
      }
    }], null, false, 382675519)
  }, [_c('div', {
    attrs: {
      "slot": "emptystate"
    },
    slot: "emptystate"
  }, [_vm._v("\n                    Ingen data ...\n                ")])]) : _c('box-loading', {
    attrs: {
      "height": "350"
    }
  })], 1)]), _vm._v(" "), _c('br'), _vm._v(" "), (_vm.selectedRow) ? _c('employee-skills-single-projects', {
    attrs: {
      "data": _vm.selectedRow
    }
  }) : _c('div', [_vm._v("\n        Vælg en opgavetype for at se de enkelte opgaver her\n    ")])], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-5106fdba", module.exports)
  }
}

/***/ }),
/* 835 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "btn-group"
  }, [(_vm.selectedOption.name !== undefined) ? _c('li', {
    staticClass: "dropdown-toggle",
    on: {
      "click": function($event) {
        return _vm.toggleMenu()
      }
    }
  }, [_vm._v("\n      " + _vm._s(_vm.selectedOption.name) + "\n      "), _c('span', {
    staticClass: "caret"
  })]) : _vm._e(), _vm._v(" "), (_vm.selectedOption.name === undefined) ? _c('li', {
    staticClass: "dropdown-toggle",
    on: {
      "click": function($event) {
        return _vm.toggleMenu()
      }
    }
  }, [_vm._v("\n      " + _vm._s(_vm.placeholderText) + "\n      "), _c('span', {
    staticClass: "caret"
  })]) : _vm._e(), _vm._v(" "), (_vm.showMenu) ? _c('ul', {
    staticClass: "dropdown-menu"
  }, _vm._l((_vm.options), function(option, idx) {
    return _c('li', {
      key: idx
    }, [_c('a', {
      attrs: {
        "href": "javascript:void(0)"
      },
      on: {
        "click": function($event) {
          return _vm.updateOption(option)
        }
      }
    }, [_vm._v("\n                " + _vm._s(option.name) + "\n            ")])])
  }), 0) : _vm._e()])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-52ebedca", module.exports)
  }
}

/***/ }),
/* 836 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "value-chain"
  }, [(_vm.data) ? _c('div', {
    staticClass: "chain"
  }, [_c('div', {
    staticClass: "chain__title"
  }, [_vm._v("\n            Værdikæde\n            "), _c('div', {
    staticStyle: {
      "font-size": "16px",
      "display": "inline-block"
    }
  }, [_c('d-tooltip', {
    attrs: {
      "placement": "inline",
      "identifier": "index.valuechain"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "links"
  }, [_c('div', {
    staticClass: "link"
  }, [_c('div', {
    staticClass: "name"
  }, [_c('div', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fad fa-file-alt fa-fw"
  }), _vm._v("\n                        " + _vm._s(_vm.data.offer.count) + "\n                    ")]), _vm._v("\n                    Tilbud, der afventer afgørelse\n                ")]), _vm._v(" "), _c('div', {
    staticClass: "coverage"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("Potentielt DB")]), _vm._v("\n                    " + _vm._s(_vm._f("currency")(_vm.data.offer.expected_coverage)) + "\n                ")]), _vm._v(" "), _c('div', {
    staticClass: "revenue"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("Potentiel omsætning")]), _vm._v("\n                    " + _vm._s(_vm._f("currency")(_vm.data.offer.expected_revenue)) + "\n                ")]), _vm._v(" "), (_vm.$auth.user().company.api_provider.slug === 'minuba') ? _c('div', {
    staticClass: "budget"
  }, [_c('span', {
    staticClass: "budget-bar-wrapper"
  }, [_c('span', {
    staticClass: "budget-bar-inner",
    style: ('width:' + (_vm.data.offer.count > 0 ? ((_vm.data.offer.has_budget / _vm.data.offer.count) * 100) : 0) + '%;')
  })]), _vm._v(" "), _c('span', {
    staticClass: "small mt-1"
  }, [_vm._v(_vm._s(_vm.data.offer.has_budget) + " / " + _vm._s(_vm.data.offer.count) + " opgaver har budget")])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "link"
  }, [_c('div', {
    staticClass: "name"
  }, [_c('div', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fad fa-inbox-in fa-fw"
  }), _vm._v("\n                        " + _vm._s(_vm.data.open.count) + "\n                    ")]), _vm._v("\n                    opgaver, der ikke er påbegyndt\n                ")]), _vm._v(" "), _c('div', {
    staticClass: "coverage"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("Forventet DB")]), _vm._v("\n                    " + _vm._s(_vm._f("currency")(_vm.data.open.expected_coverage)) + "\n                ")]), _vm._v(" "), _c('div', {
    staticClass: "revenue"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("Forventet omsætning")]), _vm._v("\n                    " + _vm._s(_vm._f("currency")(_vm.data.open.expected_revenue)) + "\n                ")]), _vm._v(" "), (_vm.$auth.user().company.api_provider.slug === 'minuba') ? _c('div', {
    staticClass: "budget"
  }, [_c('span', {
    staticClass: "budget-bar-wrapper"
  }, [_c('span', {
    staticClass: "budget-bar-inner",
    style: ('width:' + (_vm.data.open.count > 0 ? ((_vm.data.open.has_budget / _vm.data.open.count) * 100) : 0) + '%;')
  })]), _vm._v(" "), _c('span', {
    staticClass: "small mt-1"
  }, [_vm._v(_vm._s(_vm.data.open.has_budget) + " / " + _vm._s(_vm.data.open.count) + " opgaver har budget")])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "link"
  }, [_c('div', {
    staticClass: "name"
  }, [_c('div', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fad fa-clock fa-fw"
  }), _vm._v("\n                        " + _vm._s(_vm.data.ongoing.count) + "\n                    ")]), _vm._v("\n                    igangværende opgaver,\n                    "), _c('br'), _vm._v("\n                    der arbejdes på\n                ")]), _vm._v(" "), _c('div', {
    staticClass: "coverage"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("Forventet DB")]), _vm._v("\n                    " + _vm._s(_vm._f("currency")(_vm.data.ongoing.expected_coverage)) + "\n                ")]), _vm._v(" "), _c('div', {
    staticClass: "revenue"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("Forventet omsætning")]), _vm._v("\n                    " + _vm._s(_vm._f("currency")(_vm.data.ongoing.expected_revenue)) + "\n                ")]), _vm._v(" "), (_vm.$auth.user().company.api_provider.slug === 'minuba') ? _c('div', {
    staticClass: "budget"
  }, [_c('span', {
    staticClass: "budget-bar-wrapper"
  }, [_c('span', {
    staticClass: "budget-bar-inner",
    style: ('width:' + (_vm.data.ongoing.count > 0 ? ((_vm.data.ongoing.has_budget / _vm.data.ongoing.count) * 100) : 0) + '%;')
  })]), _vm._v(" "), _c('span', {
    staticClass: "small mt-1"
  }, [_vm._v(_vm._s(_vm.data.ongoing.has_budget) + " / " + _vm._s(_vm.data.ongoing.count) + " opgaver har budget")])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "link"
  }, [_c('div', {
    staticClass: "name"
  }, [_c('div', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fad fa-check-circle fa-fw"
  }), _vm._v("\n                        " + _vm._s(_vm.data.unbilled.count) + "\n                    ")]), _vm._v("\n                    afsluttede opgaver,\n                    "), _c('br'), _vm._v("\n                    der ikke er fakturerede\n                ")]), _vm._v(" "), _c('div', {
    staticClass: "coverage"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("Forventet DB")]), _vm._v("\n                    " + _vm._s(_vm._f("currency")(_vm.data.unbilled.expected_coverage)) + "\n                ")]), _vm._v(" "), _c('div', {
    staticClass: "revenue"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("Forventet omsætning")]), _vm._v("\n                    " + _vm._s(_vm._f("currency")(_vm.data.unbilled.expected_revenue)) + "\n                ")]), _vm._v(" "), (_vm.$auth.user().company.api_provider.slug === 'minuba') ? _c('div', {
    staticClass: "budget"
  }, [_c('span', {
    staticClass: "budget-bar-wrapper"
  }, [_c('span', {
    staticClass: "budget-bar-inner",
    style: ('width:' + (_vm.data.unbilled.count > 0 ? ((_vm.data.unbilled.has_budget / _vm.data.unbilled.count) * 100) : 0) + '%;')
  })]), _vm._v(" "), _c('span', {
    staticClass: "small mt-1"
  }, [_vm._v(_vm._s(_vm.data.unbilled.has_budget) + " / " + _vm._s(_vm.data.unbilled.count) + " opgaver har budget")])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "link"
  }, [_c('div', {
    staticClass: "name"
  }, [_c('div', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fad fa-envelope-open-dollar fa-fw"
  }), _vm._v("\n                        " + _vm._s(_vm.data.unpaid_invoices.count) + "\n                    ")]), _vm._v("\n                    fakturaer, der endnu ikke er betalt\n                ")]), _vm._v(" "), _c('div', {
    staticClass: "coverage"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("Forventet DB")]), _vm._v("\n                    " + _vm._s(_vm._f("currency")(_vm.data.unpaid_invoices.expected_coverage)) + "\n                ")]), _vm._v(" "), _c('div', {
    staticClass: "revenue"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("Forventet omsætning")]), _vm._v("\n                    " + _vm._s(_vm._f("currency")(_vm.data.unpaid_invoices.expected_revenue)) + "\n                ")])]), _vm._v(" "), _c('div', {
    staticClass: "link"
  }, [_c('div', {
    staticClass: "name"
  }, [_c('div', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fad fa-calendar-exclamation fa-fw"
  }), _vm._v("\n                        " + _vm._s(_vm.data.overdue_invoices.count) + "\n                    ")]), _vm._v("\n                    fakturaer med overskredet betaling\n                ")]), _vm._v(" "), _c('div', {
    staticClass: "coverage"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("Forventet DB")]), _vm._v("\n                    " + _vm._s(_vm._f("currency")(_vm.data.overdue_invoices.expected_coverage)) + "\n                ")]), _vm._v(" "), _c('div', {
    staticClass: "revenue"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("Forventet omsætning")]), _vm._v("\n                    " + _vm._s(_vm._f("currency")(_vm.data.overdue_invoices.expected_revenue)) + "\n                ")])])])]) : _vm._e()])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-55170067", module.exports)
  }
}

/***/ }),
/* 837 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(!_vm.loading) ? _c('div', {
    staticClass: "budget"
  }, [_vm._v("\n        Tryk udenfor input-feltet, når du har indtastet et beløb, for at gemme budgettet.\n        "), _c('br'), _c('br'), _vm._v("\n        Scroll til højre på skærmen for at se alle månederne.\n        "), _c('br'), _c('br'), _vm._v(" "), _vm._l((_vm.accountCategories), function(accountCategory) {
    return (_vm.accountCategories.length > 0) ? _c('div', {
      key: accountCategory.slug,
      staticClass: "placeholder padding",
      staticStyle: {
        "overflow-x": "scroll",
        "margin-bottom": "15px"
      }
    }, [_c('div', {
      staticClass: "title"
    }, [_vm._v("\n                " + _vm._s(accountCategory.name) + "\n            ")]), _vm._v(" "), (accountCategory.accounts.length > 0) ? _c('table', [_vm._m(0, true), _vm._v(" "), _c('tbody', [_vm._l((accountCategory.accounts), function(account) {
      return _c('tr', {
        key: account.uuid
      }, [_c('td', [_vm._v(_vm._s(account.account_number))]), _vm._v(" "), _c('td', {
        staticClass: "name"
      }, [_vm._v(_vm._s(account.name))]), _vm._v(" "), _c('td', [_c('input', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (account.budgets.january),
          expression: "account.budgets.january"
        }],
        attrs: {
          "type": "text"
        },
        domProps: {
          "value": (account.budgets.january)
        },
        on: {
          "blur": function($event) {
            return _vm.updateValue(account.uuid, 'january', account.budgets.january)
          },
          "input": function($event) {
            if ($event.target.composing) { return; }
            _vm.$set(account.budgets, "january", $event.target.value)
          }
        }
      })]), _vm._v(" "), _c('td', [_c('input', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (account.budgets.february),
          expression: "account.budgets.february"
        }],
        attrs: {
          "type": "text"
        },
        domProps: {
          "value": (account.budgets.february)
        },
        on: {
          "blur": function($event) {
            return _vm.updateValue(account.uuid, 'february', account.budgets.february)
          },
          "input": function($event) {
            if ($event.target.composing) { return; }
            _vm.$set(account.budgets, "february", $event.target.value)
          }
        }
      })]), _vm._v(" "), _c('td', [_c('input', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (account.budgets.march),
          expression: "account.budgets.march"
        }],
        attrs: {
          "type": "text"
        },
        domProps: {
          "value": (account.budgets.march)
        },
        on: {
          "blur": function($event) {
            return _vm.updateValue(account.uuid, 'march', account.budgets.march)
          },
          "input": function($event) {
            if ($event.target.composing) { return; }
            _vm.$set(account.budgets, "march", $event.target.value)
          }
        }
      })]), _vm._v(" "), _c('td', [_c('input', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (account.budgets.april),
          expression: "account.budgets.april"
        }],
        attrs: {
          "type": "text"
        },
        domProps: {
          "value": (account.budgets.april)
        },
        on: {
          "blur": function($event) {
            return _vm.updateValue(account.uuid, 'april', account.budgets.april)
          },
          "input": function($event) {
            if ($event.target.composing) { return; }
            _vm.$set(account.budgets, "april", $event.target.value)
          }
        }
      })]), _vm._v(" "), _c('td', [_c('input', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (account.budgets.may),
          expression: "account.budgets.may"
        }],
        attrs: {
          "type": "text"
        },
        domProps: {
          "value": (account.budgets.may)
        },
        on: {
          "blur": function($event) {
            return _vm.updateValue(account.uuid, 'may', account.budgets.may)
          },
          "input": function($event) {
            if ($event.target.composing) { return; }
            _vm.$set(account.budgets, "may", $event.target.value)
          }
        }
      })]), _vm._v(" "), _c('td', [_c('input', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (account.budgets.june),
          expression: "account.budgets.june"
        }],
        attrs: {
          "type": "text"
        },
        domProps: {
          "value": (account.budgets.june)
        },
        on: {
          "blur": function($event) {
            return _vm.updateValue(account.uuid, 'june', account.budgets.june)
          },
          "input": function($event) {
            if ($event.target.composing) { return; }
            _vm.$set(account.budgets, "june", $event.target.value)
          }
        }
      })]), _vm._v(" "), _c('td', [_c('input', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (account.budgets.july),
          expression: "account.budgets.july"
        }],
        attrs: {
          "type": "text"
        },
        domProps: {
          "value": (account.budgets.july)
        },
        on: {
          "blur": function($event) {
            return _vm.updateValue(account.uuid, 'july', account.budgets.july)
          },
          "input": function($event) {
            if ($event.target.composing) { return; }
            _vm.$set(account.budgets, "july", $event.target.value)
          }
        }
      })]), _vm._v(" "), _c('td', [_c('input', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (account.budgets.august),
          expression: "account.budgets.august"
        }],
        attrs: {
          "type": "text"
        },
        domProps: {
          "value": (account.budgets.august)
        },
        on: {
          "blur": function($event) {
            return _vm.updateValue(account.uuid, 'august', account.budgets.august)
          },
          "input": function($event) {
            if ($event.target.composing) { return; }
            _vm.$set(account.budgets, "august", $event.target.value)
          }
        }
      })]), _vm._v(" "), _c('td', [_c('input', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (account.budgets.september),
          expression: "account.budgets.september"
        }],
        attrs: {
          "type": "text"
        },
        domProps: {
          "value": (account.budgets.september)
        },
        on: {
          "blur": function($event) {
            return _vm.updateValue(account.uuid, 'september', account.budgets.september)
          },
          "input": function($event) {
            if ($event.target.composing) { return; }
            _vm.$set(account.budgets, "september", $event.target.value)
          }
        }
      })]), _vm._v(" "), _c('td', [_c('input', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (account.budgets.october),
          expression: "account.budgets.october"
        }],
        attrs: {
          "type": "text"
        },
        domProps: {
          "value": (account.budgets.october)
        },
        on: {
          "blur": function($event) {
            return _vm.updateValue(account.uuid, 'october', account.budgets.october)
          },
          "input": function($event) {
            if ($event.target.composing) { return; }
            _vm.$set(account.budgets, "october", $event.target.value)
          }
        }
      })]), _vm._v(" "), _c('td', [_c('input', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (account.budgets.november),
          expression: "account.budgets.november"
        }],
        attrs: {
          "type": "text"
        },
        domProps: {
          "value": (account.budgets.november)
        },
        on: {
          "blur": function($event) {
            return _vm.updateValue(account.uuid, 'november', account.budgets.november)
          },
          "input": function($event) {
            if ($event.target.composing) { return; }
            _vm.$set(account.budgets, "november", $event.target.value)
          }
        }
      })]), _vm._v(" "), _c('td', [_c('input', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (account.budgets.december),
          expression: "account.budgets.december"
        }],
        attrs: {
          "type": "text"
        },
        domProps: {
          "value": (account.budgets.december)
        },
        on: {
          "blur": function($event) {
            return _vm.updateValue(account.uuid, 'december', account.budgets.december)
          },
          "input": function($event) {
            if ($event.target.composing) { return; }
            _vm.$set(account.budgets, "december", $event.target.value)
          }
        }
      })]), _vm._v(" "), _c('td', {
        staticClass: "totals"
      }, [_vm._v("\n                            " + _vm._s(_vm._f("currency")(Number(account.budgets.january) + Number(account.budgets.february) + Number(account.budgets.march) + Number(account.budgets.april) + Number(account.budgets.may) + Number(account.budgets.june) + Number(account.budgets.july) + Number(account.budgets.august) + Number(account.budgets.september) + Number(account.budgets.october) + Number(account.budgets.november) + Number(account.budgets.december))) + "\n                        ")])])
    }), _vm._v(" "), _c('tr', {
      staticClass: "totals"
    }, [_c('td'), _vm._v(" "), _c('td', {
      staticClass: "name"
    }, [_vm._v("Total")]), _vm._v(" "), _c('td', [_vm._v("\n                            " + _vm._s(_vm.count = null) + "\n                            " + _vm._s(accountCategory.accounts.forEach(function (account) {
      _vm.count = Number(_vm.count + Number(account.budgets.january))
    })) + "\n                            " + _vm._s(_vm._f("currency")(_vm.count)) + "\n                        ")]), _vm._v(" "), _c('td', [_vm._v("\n                            " + _vm._s(_vm.count = null) + "\n                            " + _vm._s(accountCategory.accounts.forEach(function (account) {
      _vm.count = Number(_vm.count + Number(account.budgets.february))
    })) + "\n                            " + _vm._s(_vm._f("currency")(_vm.count)) + "\n                        ")]), _vm._v(" "), _c('td', [_vm._v("\n                            " + _vm._s(_vm.count = null) + "\n                            " + _vm._s(accountCategory.accounts.forEach(function (account) {
      _vm.count = Number(_vm.count + Number(account.budgets.march))
    })) + "\n                            " + _vm._s(_vm._f("currency")(_vm.count)) + "\n                        ")]), _vm._v(" "), _c('td', [_vm._v("\n                            " + _vm._s(_vm.count = null) + "\n                            " + _vm._s(accountCategory.accounts.forEach(function (account) {
      _vm.count = Number(_vm.count + Number(account.budgets.april))
    })) + "\n                            " + _vm._s(_vm._f("currency")(_vm.count)) + "\n                        ")]), _vm._v(" "), _c('td', [_vm._v("\n                            " + _vm._s(_vm.count = null) + "\n                            " + _vm._s(accountCategory.accounts.forEach(function (account) {
      _vm.count = Number(_vm.count + Number(account.budgets.may))
    })) + "\n                            " + _vm._s(_vm._f("currency")(_vm.count)) + "\n                        ")]), _vm._v(" "), _c('td', [_vm._v("\n                            " + _vm._s(_vm.count = null) + "\n                            " + _vm._s(accountCategory.accounts.forEach(function (account) {
      _vm.count = Number(_vm.count + Number(account.budgets.june))
    })) + "\n                            " + _vm._s(_vm._f("currency")(_vm.count)) + "\n                        ")]), _vm._v(" "), _c('td', [_vm._v("\n                            " + _vm._s(_vm.count = null) + "\n                            " + _vm._s(accountCategory.accounts.forEach(function (account) {
      _vm.count = Number(_vm.count + Number(account.budgets.july))
    })) + "\n                            " + _vm._s(_vm._f("currency")(_vm.count)) + "\n                        ")]), _vm._v(" "), _c('td', [_vm._v("\n                            " + _vm._s(_vm.count = null) + "\n                            " + _vm._s(accountCategory.accounts.forEach(function (account) {
      _vm.count = Number(_vm.count + Number(account.budgets.august))
    })) + "\n                            " + _vm._s(_vm._f("currency")(_vm.count)) + "\n                        ")]), _vm._v(" "), _c('td', [_vm._v("\n                            " + _vm._s(_vm.count = null) + "\n                            " + _vm._s(accountCategory.accounts.forEach(function (account) {
      _vm.count = Number(_vm.count + Number(account.budgets.september))
    })) + "\n                            " + _vm._s(_vm._f("currency")(_vm.count)) + "\n                        ")]), _vm._v(" "), _c('td', [_vm._v("\n                            " + _vm._s(_vm.count = null) + "\n                            " + _vm._s(accountCategory.accounts.forEach(function (account) {
      _vm.count = Number(_vm.count + Number(account.budgets.october))
    })) + "\n                            " + _vm._s(_vm._f("currency")(_vm.count)) + "\n                        ")]), _vm._v(" "), _c('td', [_vm._v("\n                            " + _vm._s(_vm.count = null) + "\n                            " + _vm._s(accountCategory.accounts.forEach(function (account) {
      _vm.count = Number(_vm.count + Number(account.budgets.november))
    })) + "\n                            " + _vm._s(_vm._f("currency")(_vm.count)) + "\n                        ")]), _vm._v(" "), _c('td', [_vm._v("\n                            " + _vm._s(_vm.count = null) + "\n                            " + _vm._s(accountCategory.accounts.forEach(function (account) {
      _vm.count = Number(_vm.count + Number(account.budgets.december))
    })) + "\n                            " + _vm._s(_vm._f("currency")(_vm.count)) + "\n                        ")]), _vm._v(" "), _c('td', [_vm._v("\n                            " + _vm._s(_vm.count = null) + "\n                            " + _vm._s(accountCategory.accounts.forEach(function (account) {
      _vm.count = _vm.count + Number(account.budgets.january) + Number(account.budgets.february) + Number(account.budgets.march) + Number(account.budgets.april) + Number(account.budgets.may) + Number(account.budgets.june) + Number(account.budgets.july) + Number(account.budgets.august) + Number(account.budgets.september) + Number(account.budgets.october) + Number(account.budgets.november) + Number(account.budgets.december)
    })) + "\n                            " + _vm._s(_vm._f("currency")(_vm.count)) + "\n                        ")])])], 2)]) : _c('div', [_vm._v("\n                Ingen konti i denne kategori\n            ")])]) : _vm._e()
  })], 2) : _c('box-loading', {
    attrs: {
      "height": "350"
    }
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("#")]), _vm._v(" "), _c('th', {
    staticClass: "name"
  }, [_vm._v("Konto")]), _vm._v(" "), _c('th', [_vm._v("Jan")]), _vm._v(" "), _c('th', [_vm._v("Feb")]), _vm._v(" "), _c('th', [_vm._v("Mar")]), _vm._v(" "), _c('th', [_vm._v("Apr")]), _vm._v(" "), _c('th', [_vm._v("Maj")]), _vm._v(" "), _c('th', [_vm._v("Jun")]), _vm._v(" "), _c('th', [_vm._v("Jul")]), _vm._v(" "), _c('th', [_vm._v("Aug")]), _vm._v(" "), _c('th', [_vm._v("Sep")]), _vm._v(" "), _c('th', [_vm._v("Okt")]), _vm._v(" "), _c('th', [_vm._v("Nov")]), _vm._v(" "), _c('th', [_vm._v("Dec")]), _vm._v(" "), _c('th', {
    staticClass: "totals"
  }, [_vm._v("Total")])])])
}]}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-57bd4472", module.exports)
  }
}

/***/ }),
/* 838 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "projects-operations"
  }, [_c('div', {
    staticClass: "content"
  }, [_c('content-switch', {
    attrs: {
      "items": _vm.switchItems,
      "selectedItem": _vm.selectedItem,
      "counts": _vm.counts
    },
    on: {
      "selectItem": function($event) {
        return _vm.handleSelectItem($event)
      }
    }
  }), _vm._v(" "), _c('offerProjects-table', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.selectedItem === 'offerProjects'),
      expression: "selectedItem === 'offerProjects'"
    }],
    on: {
      "finishedLoading": function($event) {
        return _vm.updateCount('offerProjects', $event)
      }
    }
  }), _vm._v(" "), _c('openProjects-table', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.selectedItem === 'openProjects'),
      expression: "selectedItem === 'openProjects'"
    }],
    on: {
      "finishedLoading": function($event) {
        return _vm.updateCount('openProjects', $event)
      }
    }
  }), _vm._v(" "), _c('snoozedProjects-table', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.selectedItem === 'snoozedProjects'),
      expression: "selectedItem === 'snoozedProjects'"
    }],
    on: {
      "finishedLoading": function($event) {
        return _vm.updateCount('snoozedProjects', $event)
      }
    }
  }), _vm._v(" "), _c('noInvoiceProjects-table', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.selectedItem === 'noInvoiceProjects'),
      expression: "selectedItem === 'noInvoiceProjects'"
    }],
    on: {
      "finishedLoading": function($event) {
        return _vm.updateCount('noInvoiceProjects', $event)
      }
    }
  }), _vm._v(" "), _c('ongoingProjects-table', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.selectedItem === 'ongoingProjects'),
      expression: "selectedItem === 'ongoingProjects'"
    }],
    on: {
      "finishedLoading": function($event) {
        return _vm.updateCount('ongoingProjects', $event)
      }
    }
  }), _vm._v(" "), _c('claimsProjects-table', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.selectedItem === 'openClaims'),
      expression: "selectedItem === 'openClaims'"
    }],
    on: {
      "finishedLoading": function($event) {
        return _vm.updateCount('openClaims', $event)
      }
    }
  }), _vm._v(" "), _c('coming-soon', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.selectedItem === 'projectsCloseToBudget'),
      expression: "selectedItem === 'projectsCloseToBudget'"
    }]
  })], 1)])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-57fbb69c", module.exports)
  }
}

/***/ }),
/* 839 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "employee-revenue"
  }, [_c('div', {
    staticClass: "placeholder"
  }, [_c('div', {
    staticClass: "placeholder__heading"
  }, [_c('d-tooltip', {
    attrs: {
      "placement": "left",
      "identifier": "employees.employeeRevenue"
    }
  }), _vm._v("\n            Hvordan er medarbejdernes indtjening?\n        ")], 1), _vm._v(" "), _c('div', {
    staticClass: "placeholder"
  }, [(!_vm.loading) ? _c('vue-good-table', {
    attrs: {
      "columns": _vm.columns,
      "rows": _vm.rows,
      "search-options": _vm.searchOptions,
      "pagination-options": _vm.paginationOptions,
      "sort-options": _vm.sortOptions,
      "styleClass": _vm.styleClass
    },
    scopedSlots: _vm._u([{
      key: "table-row",
      fn: function(props) {
        return [(props.column.field == 'coverage_percent') ? _c('div', {
          staticClass: "coverage-cell"
        }, [_vm._v("\n                        " + _vm._s(_vm._f("rounded")(props.row.coverage_percent)) + " \n                        "), (props.row.coverage_percent !== null) ? _c('div', {
          staticClass: "coverage-indicator",
          class: {
            'bad': props.row.coverage_percent < _vm.$store.state.config.companyMeta.settings.coverage_percent.medium.value, 'avg': _vm.$options.filters.rounded(props.row.coverage_percent) >= _vm.$store.state.config.companyMeta.settings.coverage_percent.medium.value, 'good': _vm.$options.filters.rounded(props.row.coverage_percent) >= _vm.$store.state.config.companyMeta.settings.coverage_percent.high.value
          }
        }) : _vm._e()]) : (props.column.field == 'total_projects') ? _c('div', {
          staticStyle: {
            "text-align": "left"
          }
        }, [_vm._v("\n                        " + _vm._s(props.row.total_projects) + "\n                    ")]) : (props.column.field == 'name') ? _c('div', {
          staticClass: "table-column__description"
        }, [_vm._v("\n                        " + _vm._s(props.row.name) + "\n                    ")]) : (props.column.field == 'coverage') ? _c('div', {
          staticStyle: {
            "text-align": "left"
          }
        }, [_vm._v("\n                        " + _vm._s(_vm._f("currency")(props.row.coverage)) + "\n                    ")]) : (props.column.field == 'invoices_total') ? _c('div', {
          staticStyle: {
            "text-align": "left"
          }
        }, [_vm._v("\n                        " + _vm._s(_vm._f("currency")(props.row.invoices_total)) + "\n                    ")]) : (props.column.field == 'coverage_per_hour') ? _c('div', {
          staticClass: "coverage-cell"
        }, [_vm._v("\n                        " + _vm._s(_vm._f("currency")(props.row.coverage_per_hour)) + " \n                        "), (props.row.coverage_per_hour !== null) ? _c('div', {
          staticClass: "coverage-indicator",
          class: {
            'bad': props.row.coverage_per_hour < _vm.$store.state.config.companyMeta.settings.coverage_per_hour.medium.value, 'avg': _vm.$options.filters.rounded(props.row.coverage_per_hour) >= _vm.$store.state.config.companyMeta.settings.coverage_per_hour.medium.value, 'good': _vm.$options.filters.rounded(props.row.coverage_per_hour) >= _vm.$store.state.config.companyMeta.settings.coverage_per_hour.high.value
          }
        }) : _vm._e()]) : _c('div', [_vm._v("\n                        " + _vm._s(props.formattedRow[props.column.field]) + "\n                    ")])]
      }
    }], null, false, 3309813152)
  }, [_c('div', {
    attrs: {
      "slot": "emptystate"
    },
    slot: "emptystate"
  }, [_vm._v("\n                    Ingen data ...\n                ")])]) : _c('box-loading', {
    attrs: {
      "height": "350"
    }
  })], 1)])])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-580314bc", module.exports)
  }
}

/***/ }),
/* 840 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "project-type-skills"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-4"
  }, [_c('div', {
    staticClass: "placeholder"
  }, [_c('div', {
    staticClass: "placeholder__heading"
  }, [_c('d-tooltip', {
    attrs: {
      "placement": "left",
      "identifier": "projects.projectTypeSkills"
    }
  }), _vm._v("\n                    Hvilke svende er gode til hvilke opgaver?\n                ")], 1), _vm._v(" "), _c('div', {
    staticClass: "placeholder fit-content"
  }, [(!_vm.loading) ? _c('vue-good-table', {
    attrs: {
      "columns": _vm.columns,
      "rows": _vm.rows,
      "search-options": _vm.searchOptions,
      "pagination-options": _vm.paginationOptions,
      "sort-options": _vm.sortOptions,
      "styleClass": _vm.styleClass,
      "row-style-class": _vm.selectedRowClass
    },
    on: {
      "on-row-click": _vm.selectEmployee
    },
    scopedSlots: _vm._u([{
      key: "table-row",
      fn: function(props) {
        return [(props.column.field == 'type.name') ? _c('div', {
          staticClass: "table-column__description",
          attrs: {
            "title": props.row.type ? props.row.type.name : '-'
          }
        }, [_vm._v("\n                                " + _vm._s(props.row.type ? props.row.type.name : '-') + "\n                            ")]) : _c('div', {
          attrs: {
            "title": props.formattedRow[props.column.field]
          }
        }, [_vm._v("\n                                " + _vm._s(props.formattedRow[props.column.field]) + "\n                            ")])]
      }
    }], null, false, 4229366594)
  }, [_c('div', {
    attrs: {
      "slot": "emptystate"
    },
    slot: "emptystate"
  }, [_vm._v("\n                            Ingen data ...\n                        ")])]) : _c('box-loading', {
    attrs: {
      "height": "350"
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-8"
  }, [(!_vm.selectedRow) ? _c('div', {
    staticClass: "info"
  }, [_vm._v("\n                Vælg en opgavetype for at se hvilke medarbejdere, der er gode til denne\n            ")]) : _c('project-type-skills-single', {
    attrs: {
      "data": _vm.selectedRow
    }
  })], 1)])])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-5949fbe8", module.exports)
  }
}

/***/ }),
/* 841 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "users"
  }, [_c('div', {
    staticClass: "small-title"
  }, [_vm._v("\n        Opret ny bruger\n    ")]), _vm._v(" "), _c('form', {
    staticClass: "create-user",
    attrs: {
      "autocomplete": "off"
    }
  }, [_c('input', {
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "name": "hidden",
      "type": "text",
      "autocomplete": "off"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-6"
  }, [_c('div', {
    staticClass: "name"
  }, [_c('label', [_vm._v("Navn *")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newUser.name),
      expression: "newUser.name"
    }],
    attrs: {
      "type": "text",
      "placeholder": "Navn"
    },
    domProps: {
      "value": (_vm.newUser.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.newUser, "name", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    class: {
      'col-lg-3': _vm.newUser.role_id === 4, 'col-lg-6': _vm.newUser.role_id !== 4
    }
  }, [_c('div', {
    staticClass: "role"
  }, [_c('label', [_vm._v("Brugerrolle *")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newUser.role_id),
      expression: "newUser.role_id"
    }],
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.newUser, "role_id", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    domProps: {
      "value": 2
    }
  }, [_vm._v("Administrator")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": 3
    }
  }, [_vm._v("Bruger")]), _vm._v(" "), (_vm.availableDepartments.length > 0) ? _c('option', {
    domProps: {
      "value": 4
    }
  }, [_vm._v("Afdelingsansvarlig")]) : _vm._e()])])]), _vm._v(" "), (_vm.newUser.role_id === 4) ? _c('div', {
    staticClass: "col-lg-3"
  }, [_c('div', {
    staticClass: "department"
  }, [_c('label', [_vm._v("Vælg afdeling *")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newUser.relation_department_id),
      expression: "newUser.relation_department_id"
    }],
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.newUser, "relation_department_id", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "selected": "",
      "disabled": ""
    },
    domProps: {
      "value": null
    }
  }, [_vm._v("Vælg afdeling ...")]), _vm._v(" "), _vm._l((_vm.availableDepartments), function(department) {
    return (department.name !== 'Virksomheden' && department.name !== 'Ingen afdeling tilknyttet') ? _c('option', {
      key: department.id,
      domProps: {
        "value": department.relation_id
      }
    }, [_vm._v("\n                            " + _vm._s(department.name) + "\n                        ")]) : _vm._e()
  })], 2)])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-6"
  }, [_c('div', {
    staticClass: "email"
  }, [_c('label', [_vm._v("E-mail *")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newUser.email),
      expression: "newUser.email"
    }],
    attrs: {
      "type": "email",
      "name": "iufbw379fb",
      "placeholder": "E-mail"
    },
    domProps: {
      "value": (_vm.newUser.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.newUser, "email", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-6"
  }, [_c('div', {
    staticClass: "password"
  }, [_c('label', [_vm._v("Adgangskode *")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newUser.password),
      expression: "newUser.password"
    }],
    attrs: {
      "type": "password",
      "autocomplete": "new-password",
      "placeholder": "Adgangskode"
    },
    domProps: {
      "value": (_vm.newUser.password)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.newUser, "password", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "small"
  }, [_vm._v("Min. 8 karakterer")])])])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "action",
    attrs: {
      "align": "right"
    }
  }, [_c('div', {
    staticClass: "pretty-button",
    on: {
      "click": function($event) {
        return _vm.createUser()
      }
    }
  }, [_vm._v("\n                Opret\n            ")])])]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "divider"
  }), _vm._v(" "), _c('div', {
    staticClass: "small-title"
  }, [_vm._v("\n        Alle brugere\n    ")]), _vm._v(" "), (_vm.users && !_vm.loading) ? _c('div', {
    staticClass: "list"
  }, [_c('div', {
    staticClass: "row"
  }, _vm._l((_vm.sortedUsers), function(user) {
    return _c('div', {
      key: user.uuid,
      staticClass: "col-lg-6"
    }, [_c('div', {
      staticClass: "user"
    }, [_c('div', {
      staticClass: "name"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (user.name),
        expression: "user.name"
      }],
      attrs: {
        "type": "text"
      },
      domProps: {
        "value": (user.name)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(user, "name", $event.target.value)
        }
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "role"
    }, [_c('select', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (user.role_id),
        expression: "user.role_id"
      }],
      on: {
        "change": [function($event) {
          var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
            return o.selected
          }).map(function(o) {
            var val = "_value" in o ? o._value : o.value;
            return val
          });
          _vm.$set(user, "role_id", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
        }, function($event) {
          user.name = user.name + ' ';
          user.name = user.name.slice(0, -1)
        }]
      }
    }, [_c('option', {
      domProps: {
        "value": 2
      }
    }, [_vm._v("Administrator")]), _vm._v(" "), _c('option', {
      domProps: {
        "value": 3
      }
    }, [_vm._v("Bruger")]), _vm._v(" "), _c('option', {
      domProps: {
        "value": 4
      }
    }, [_vm._v("Afdelingsansvarlig")])])]), _vm._v(" "), (user.role_id === 4) ? _c('div', {
      staticClass: "department"
    }, [_c('select', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (user.relation_department_id),
        expression: "user.relation_department_id"
      }],
      on: {
        "change": function($event) {
          var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
            return o.selected
          }).map(function(o) {
            var val = "_value" in o ? o._value : o.value;
            return val
          });
          _vm.$set(user, "relation_department_id", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
        }
      }
    }, [_c('option', {
      attrs: {
        "selected": "",
        "disabled": ""
      },
      domProps: {
        "value": null
      }
    }, [_vm._v("Vælg afdeling ...")]), _vm._v(" "), _vm._l((_vm.availableDepartments), function(department) {
      return (department.name !== 'Virksomheden' && department.name !== 'Ingen afdeling tilknyttet') ? _c('option', {
        key: department.id,
        domProps: {
          "value": department.relation_id
        }
      }, [_vm._v("\n                                " + _vm._s(department.name) + "\n                            ")]) : _vm._e()
    })], 2)]) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "email"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (user.email),
        expression: "user.email"
      }],
      attrs: {
        "type": "email"
      },
      domProps: {
        "value": (user.email)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(user, "email", $event.target.value)
        }
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "password"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (user.new_password),
        expression: "user.new_password"
      }],
      attrs: {
        "type": "password",
        "placeholder": "Evt. ny adgangskode"
      },
      domProps: {
        "value": (user.new_password)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(user, "new_password", $event.target.value)
        }
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "actions"
    }, [_c('div', {
      staticClass: "action",
      on: {
        "click": function($event) {
          return _vm.updateUser(user)
        }
      }
    }, [_vm._v("\n                            Opdatér\n                        ")]), _vm._v(" "), _c('div', {
      staticClass: "action",
      on: {
        "click": function($event) {
          return _vm.deleteUser(user)
        }
      }
    }, [_vm._v("\n                            Slet\n                        ")])])])])
  }), 0)]) : _c('box-loading', {
    attrs: {
      "height": "350"
    }
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "small",
    staticStyle: {
      "margin-top": "10px"
    }
  }, [_c('div', [_c('b', [_vm._v("Administrator:")]), _vm._v(" Adgang til alle faner og kan ændre indstillinger, administrere brugere mv.")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-top": "5px"
    }
  }, [_c('b', [_vm._v("Bruger:")]), _vm._v(" Læseadgang til alle faner")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-top": "5px"
    }
  }, [_c('b', [_vm._v("Afdelingsansvarlig:")]), _vm._v(" Læseadgang til alle faner undtagen økonomi-relaterede faner og potentiale. Kan kun se data for sin egen afdeling.")])])
}]}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-59df3e14", module.exports)
  }
}

/***/ }),
/* 842 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "placeholder"
  }, [_c('div', {
    staticClass: "placeholder__heading"
  }, [_vm._v("\n        " + _vm._s(_vm.data.name) + "\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "placeholder"
  }, [_c('vue-good-table', {
    attrs: {
      "columns": _vm.columns,
      "rows": _vm.data.sub_projects,
      "search-options": _vm.searchOptions,
      "pagination-options": _vm.paginationOptions,
      "sort-options": _vm.sortOptions,
      "styleClass": _vm.styleClass
    },
    scopedSlots: _vm._u([{
      key: "table-row",
      fn: function(props) {
        return [(props.column.field == 'coverage_percent') ? _c('div', {
          staticClass: "coverage-cell"
        }, [_vm._v("\n                    " + _vm._s(_vm._f("rounded")(props.row.coverage_percent)) + " \n                    "), (props.row.coverage_percent !== null) ? _c('div', {
          staticClass: "coverage-indicator",
          class: {
            'bad': props.row.coverage_percent < _vm.$store.state.config.companyMeta.settings.coverage_percent.medium.value, 'avg': _vm.$options.filters.rounded(props.row.coverage_percent) >= _vm.$store.state.config.companyMeta.settings.coverage_percent.medium.value, 'good': _vm.$options.filters.rounded(props.row.coverage_percent) >= _vm.$store.state.config.companyMeta.settings.coverage_percent.high.value
          }
        }) : _vm._e()]) : (props.column.field == 'total_revenue') ? _c('div', [_vm._v("\n                    " + _vm._s(_vm._f("currency")(props.row.total_revenue)) + "\n                ")]) : (props.column.field == 'total_coverage') ? _c('div', [_c('project-tooltip', {
          attrs: {
            "project": props.row
          }
        }), _vm._v("\n                    " + _vm._s(_vm._f("currency")(props.row.total_coverage)) + "\n                ")], 1) : (props.column.field == 'coverage_per_hour') ? _c('div', {
          staticClass: "coverage-cell"
        }, [_vm._v("\n                    " + _vm._s(_vm._f("currency")(props.row.coverage_per_hour)) + " \n                    "), (props.row.coverage_per_hour !== null) ? _c('div', {
          staticClass: "coverage-indicator",
          class: {
            'bad': props.row.coverage_per_hour < _vm.$store.state.config.companyMeta.settings.coverage_per_hour.medium.value, 'avg': _vm.$options.filters.rounded(props.row.coverage_per_hour) >= _vm.$store.state.config.companyMeta.settings.coverage_per_hour.medium.value, 'good': _vm.$options.filters.rounded(props.row.coverage_per_hour) >= _vm.$store.state.config.companyMeta.settings.coverage_per_hour.high.value
          }
        }) : _vm._e()]) : (props.column.field == 'customer_name') ? _c('div', {
          staticClass: "table-column__customer",
          attrs: {
            "title": props.row.customer_name
          }
        }, [(props.row.customer_name) ? _c('span', [_vm._v("\n                        " + _vm._s(props.row.customer_name) + "\n                    ")]) : _c('span', [_vm._v(" - ")])]) : (props.column.field == 'name') ? _c('div', {
          staticClass: "table-column__description",
          attrs: {
            "title": props.row.name
          }
        }, [_vm._v("\n                    " + _vm._s(props.row.name) + "\n                ")]) : (props.column.field == 'start_date') ? _c('div', [_vm._v("\n                    " + _vm._s(_vm._f("moment")(props.row.start_date, "DD. MMM YYYY")) + "\n                ")]) : (props.column.field == 'minuba_external_id') ? _c('div', [_c('a', {
          staticClass: "minuba-link",
          attrs: {
            "href": 'https://app.minuba.dk/?op=casedetails&glist=' + props.row.minuba_external_id,
            "target": "_blank"
          }
        }, [_c('i', {
          staticClass: "fas fa-eye"
        })])]) : _c('div', [_vm._v("\n                    " + _vm._s(props.formattedRow[props.column.field]) + "\n                ")])]
      }
    }])
  }, [_c('div', {
    attrs: {
      "slot": "emptystate"
    },
    slot: "emptystate"
  }, [_vm._v("\n                Ingen data ...\n            ")])])], 1)])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-5a15332a", module.exports)
  }
}

/***/ }),
/* 843 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "economy-learning-claims"
  }, [_c('div', {
    staticClass: "placeholder"
  }, [_c('div', {
    staticClass: "placeholder__heading"
  }, [_c('d-tooltip', {
    attrs: {
      "placement": "left",
      "identifier": "oekonomi.vaerdikaede"
    }
  }), _vm._v("\n            Værdikæde\n        ")], 1), _vm._v(" "), _c('div', {
    staticClass: "placeholder padding"
  }, [(!_vm.loading) ? _c('div', {
    staticClass: "lines"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "line"
  }, [_c('div', {
    staticClass: "name"
  }, [_vm._v("\n                        " + _vm._s(_vm.figures.offer.count) + "\n                        tilbud, der afventer afgørelse\n                    ")]), _vm._v(" "), _c('div', {
    staticClass: "revenue"
  }, [_vm._v("\n                        " + _vm._s(_vm._f("currency")(_vm.figures.offer.expected_revenue)) + "\n                    ")]), _vm._v(" "), _c('div', {
    staticClass: "coverage"
  }, [_vm._v("\n                        " + _vm._s(_vm._f("currency")(_vm.figures.offer.expected_coverage)) + "\n                    ")])]), _vm._v(" "), _c('div', {
    staticClass: "line"
  }, [_c('div', {
    staticClass: "name"
  }, [_vm._v("\n                        " + _vm._s(_vm.figures.open.count) + "\n                        opgaver, der ikke er påbegyndt\n                    ")]), _vm._v(" "), _c('div', {
    staticClass: "revenue"
  }, [_vm._v("\n                        " + _vm._s(_vm._f("currency")(_vm.figures.open.expected_revenue)) + "\n                    ")]), _vm._v(" "), _c('div', {
    staticClass: "coverage"
  }, [_vm._v("\n                        " + _vm._s(_vm._f("currency")(_vm.figures.open.expected_coverage)) + "\n                    ")])]), _vm._v(" "), _c('div', {
    staticClass: "line"
  }, [_c('div', {
    staticClass: "name"
  }, [_vm._v("\n                        " + _vm._s(_vm.figures.ongoing.count) + "\n                        igangværende opgaver, der arbejdes på\n                    ")]), _vm._v(" "), _c('div', {
    staticClass: "revenue"
  }, [_vm._v("\n                        " + _vm._s(_vm._f("currency")(_vm.figures.ongoing.expected_revenue)) + "\n                    ")]), _vm._v(" "), _c('div', {
    staticClass: "coverage"
  }, [_vm._v("\n                        " + _vm._s(_vm._f("currency")(_vm.figures.ongoing.expected_coverage)) + "\n                    ")])]), _vm._v(" "), _c('div', {
    staticClass: "line"
  }, [_c('div', {
    staticClass: "name"
  }, [_vm._v("\n                        " + _vm._s(_vm.figures.unbilled.count) + "\n                        afsluttede opgaver, der ikke er fakturerede\n                    ")]), _vm._v(" "), _c('div', {
    staticClass: "revenue"
  }, [_vm._v("\n                        " + _vm._s(_vm._f("currency")(_vm.figures.unbilled.expected_revenue)) + "\n                    ")]), _vm._v(" "), _c('div', {
    staticClass: "coverage"
  }, [_vm._v("\n                        " + _vm._s(_vm._f("currency")(_vm.figures.unbilled.expected_coverage)) + "\n                    ")])]), _vm._v(" "), _c('div', {
    staticClass: "line"
  }, [_c('div', {
    staticClass: "name"
  }, [_vm._v("\n                        " + _vm._s(_vm.figures.unpaid_invoices.count) + "\n                        fakturaer, der endnu ikke er betalt\n                    ")]), _vm._v(" "), _c('div', {
    staticClass: "revenue"
  }, [_vm._v("\n                        " + _vm._s(_vm._f("currency")(_vm.figures.unpaid_invoices.expected_revenue)) + "\n                    ")]), _vm._v(" "), _c('div', {
    staticClass: "coverage"
  }, [_vm._v("\n                        " + _vm._s(_vm._f("currency")(_vm.figures.unpaid_invoices.expected_coverage)) + "\n                    ")])]), _vm._v(" "), _c('div', {
    staticClass: "line"
  }, [_c('div', {
    staticClass: "name"
  }, [_vm._v("\n                        " + _vm._s(_vm.figures.overdue_invoices.count) + "\n                        fakturaer med overskredet betaling\n                    ")]), _vm._v(" "), _c('div', {
    staticClass: "revenue"
  }, [_vm._v("\n                        " + _vm._s(_vm._f("currency")(_vm.figures.overdue_invoices.expected_revenue)) + "\n                    ")]), _vm._v(" "), _c('div', {
    staticClass: "coverage"
  }, [_vm._v("\n                        " + _vm._s(_vm._f("currency")(_vm.figures.overdue_invoices.expected_coverage)) + "\n                    ")])]), _vm._v(" "), _c('div', {
    staticClass: "line bold"
  }, [_c('div', {
    staticClass: "name"
  }, [_vm._v("Total")]), _vm._v(" "), _c('div', {
    staticClass: "revenue"
  }, [_vm._v(_vm._s(_vm._f("currency")(_vm.revenueTotal)))]), _vm._v(" "), _c('div', {
    staticClass: "coverage"
  }, [_vm._v(_vm._s(_vm._f("currency")(_vm.coverageTotal)))])])]) : _c('box-loading', {
    attrs: {
      "height": "350"
    }
  })], 1)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "line bold"
  }, [_c('div', {
    staticClass: "name"
  }, [_vm._v("Pipeline")]), _vm._v(" "), _c('div', {
    staticClass: "revenue"
  }, [_vm._v("Potentiel omsætning")]), _vm._v(" "), _c('div', {
    staticClass: "coverage"
  }, [_vm._v("Potentielt DB")])])
}]}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-5d6ac280", module.exports)
  }
}

/***/ }),
/* 844 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: {
      'inline': _vm.placement === 'inline'
    }
  }, [(_vm.identifier !== null && _vm.options.content !== null && _vm.options.content !== '') ? _c('button', {
    directives: [{
      name: "tooltip",
      rawName: "v-tooltip",
      value: (_vm.options),
      expression: "options"
    }],
    class: {
      'spaced': _vm.space
    },
    style: (_vm.styleOptions)
  }, [(_vm.icon) ? _c('i', {
    class: 'fas fa-' + _vm.icon
  }) : _c('i', {
    staticClass: "fas fa-question"
  })]) : _vm._e()])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-5e3ac208", module.exports)
  }
}

/***/ }),
/* 845 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "footer"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "toggle",
    on: {
      "click": function($event) {
        return _vm.toggle()
      }
    }
  }, [_c('i', {
    staticClass: "far fa-book fa-fw"
  }), _vm._v(" "), (_vm.show) ? _c('span', [_vm._v("\n                Skjul ordforklaring\n                "), _c('i', {
    staticClass: "far fa-chevron-up fa-fw"
  })]) : _c('span', [_vm._v("\n                Vis ordforklaring\n                "), _c('i', {
    staticClass: "far fa-chevron-down fa-fw"
  })])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.show),
      expression: "show"
    }],
    staticClass: "explainer"
  }, [_c('div', {
    staticClass: "lines"
  }, _vm._l((_vm.abbreviations), function(line) {
    return _c('div', {
      key: line.abb,
      staticClass: "line"
    }, [_c('div', {
      staticClass: "abb"
    }, [_vm._v("\n                        " + _vm._s(line.abb) + "\n                    ")]), _vm._v(" "), _c('div', {
      staticClass: "exp"
    }, [_vm._v("\n                        " + _vm._s(line.exp) + "\n                    ")]), _vm._v(" "), _c('div', {
      staticClass: "comment"
    }, [_vm._v("\n                        " + _vm._s(line.comment) + "\n                    ")])])
  }), 0)])])])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-5ebecd11", module.exports)
  }
}

/***/ }),
/* 846 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "compare-customer-hours"
  }, [_c('div', {
    staticClass: "placeholder"
  }, [_c('div', {
    staticClass: "placeholder__heading"
  }, [_vm._v("\n            Svendenes tid hos kunderne\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "placeholder padding"
  }, [(!_vm.loading && _vm.series.length > 0) ? _c('vue-apex-charts', {
    ref: "tester",
    attrs: {
      "height": _vm.height,
      "options": _vm.options,
      "series": _vm.series,
      "type": "line"
    }
  }) : _c('box-loading', {
    attrs: {
      "height": "400"
    }
  })], 1)])])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-5f18f122", module.exports)
  }
}

/***/ }),
/* 847 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "economy"
  }, [_c('box-helper', {
    attrs: {
      "headline": "Økonomi",
      "identifier": "economy"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "container section"
  }, [_c('title-block', {
    staticClass: "mb-xl",
    attrs: {
      "headline": "<b>Økonomi</b>",
      "position": "center"
    }
  }, [_c('p', {
    attrs: {
      "slot": "text"
    },
    slot: "text"
  }, [_vm._v("\n                Ét samlet økonomisk overblik over din virksomhed\n            ")])]), _vm._v(" "), (_vm.$route.name === 'EconomyOperations' && _vm.$auth.user().roles[0].name !== 'department-responsible') ? _c('view-toggle', {
    attrs: {
      "operationsName": "Drift",
      "operationsLink": "EconomyOperations",
      "learningName": "Økonomi",
      "learningLink": "EconomyLearning"
    }
  }) : _vm._e(), _vm._v(" "), _c('router-view')], 1)], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-5f59a4e8", module.exports)
  }
}

/***/ }),
/* 848 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "projects"
  }, [_c('box-helper', {
    attrs: {
      "headline": "Opgaver",
      "identifier": "projects"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "container section"
  }, [_c('title-block', {
    staticClass: "mb-xl",
    attrs: {
      "headline": "<b>Opgaver</b>",
      "position": "center"
    }
  }, [_c('p', {
    attrs: {
      "slot": "text"
    },
    slot: "text"
  }, [_vm._v("\n                Ét samlet overblik over dine opgaver\n            ")])]), _vm._v(" "), (_vm.$route.name === 'ProjectsOperations') ? _c('view-toggle', {
    attrs: {
      "operationsName": "Drift",
      "operationsLink": "ProjectsOperations",
      "learningName": "Udvikling / læring",
      "learningLink": "ProjectsLearning"
    }
  }) : _vm._e(), _vm._v(" "), _c('router-view')], 1)], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-6020b3ac", module.exports)
  }
}

/***/ }),
/* 849 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "settings"
  }, [_c('div', {
    staticClass: "container section"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-3"
  }, [_c('div', {
    staticClass: "settings-menu"
  }, [_c('div', {
    staticClass: "menu-item",
    class: {
      'selected': _vm.selected === 'general'
    },
    on: {
      "click": function($event) {
        _vm.selected = 'general'
      }
    }
  }, [_c('i', {
    staticClass: "fas fa-fw fa-cogs"
  }), _vm._v("\n                         \n                        Generelt\n                    ")]), _vm._v(" "), _c('div', {
    staticClass: "menu-item",
    class: {
      'selected': _vm.selected === 'accountPlan'
    },
    on: {
      "click": function($event) {
        _vm.selected = 'accountPlan'
      }
    }
  }, [_c('i', {
    staticClass: "fas fa-fw fa-list"
  }), _vm._v("\n                         \n                        Kontoplan\n                    ")]), _vm._v(" "), _c('div', {
    staticClass: "menu-item",
    class: {
      'selected': _vm.selected === 'budget'
    },
    on: {
      "click": function($event) {
        _vm.selected = 'budget'
      }
    }
  }, [_c('i', {
    staticClass: "fas fa-fw fa-calculator"
  }), _vm._v("\n                         \n                        Budget\n                    ")]), _vm._v(" "), (_vm.$auth.user().company.api_provider.slug === 'minuba') ? _c('div', {
    staticClass: "menu-item",
    class: {
      'selected': _vm.selected === 'valuechainCalculation'
    },
    on: {
      "click": function($event) {
        _vm.selected = 'valuechainCalculation'
      }
    }
  }, [_c('i', {
    staticClass: "fas fa-fw fa-calculator"
  }), _vm._v("\n                         \n                        Værdikæde kalkulation\n                    ")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "menu-item",
    class: {
      'selected': _vm.selected === 'employees'
    },
    on: {
      "click": function($event) {
        _vm.selected = 'employees'
      }
    }
  }, [_c('i', {
    staticClass: "fas fa-fw fa-users"
  }), _vm._v("\n                         \n                        Medarbejdere\n                    ")]), _vm._v(" "), _c('div', {
    staticClass: "menu-item",
    class: {
      'selected': _vm.selected === 'projectStatuses'
    },
    on: {
      "click": function($event) {
        _vm.selected = 'projectStatuses'
      }
    }
  }, [_c('i', {
    staticClass: "fas fa-fw fa-briefcase"
  }), _vm._v("\n                         \n                        Opgavestatus\n                    ")]), _vm._v(" "), _c('div', {
    staticClass: "menu-item",
    class: {
      'selected': _vm.selected === 'excludeProjects'
    },
    on: {
      "click": function($event) {
        _vm.selected = 'excludeProjects'
      }
    }
  }, [_c('i', {
    staticClass: "fas fa-fw fa-times"
  }), _vm._v("\n                         \n                        Skjul opgaver\n                    ")]), _vm._v(" "), _c('div', {
    staticClass: "divider"
  }), _vm._v(" "), _c('div', {
    staticClass: "menu-item",
    class: {
      'selected': _vm.selected === 'users'
    },
    on: {
      "click": function($event) {
        _vm.selected = 'users'
      }
    }
  }, [_c('i', {
    staticClass: "fas fa-fw fa-users"
  }), _vm._v("\n                         \n                        Systembrugere\n                    ")]), _vm._v(" "), _c('div', {
    staticClass: "menu-item",
    class: {
      'selected': _vm.selected === 'user'
    },
    on: {
      "click": function($event) {
        _vm.selected = 'user'
      }
    }
  }, [_c('i', {
    staticClass: "fas fa-fw fa-user"
  }), _vm._v("\n                         \n                        Din profil\n                    ")]), _vm._v(" "), _c('div', {
    staticClass: "divider"
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "font-weight": "bold",
      "margin-bottom": "30px",
      "font-family": "'Montserrat'"
    }
  }, [_vm._v("\n                        Justering af information på opgaverne\n                    ")]), _vm._v(" "), (_vm.$store.state.config.availableDepartments.length > 2) ? _c('div', {
    staticClass: "menu-item",
    class: {
      'selected': _vm.selected === 'cleanup'
    },
    on: {
      "click": function($event) {
        _vm.selected = 'cleanup'
      }
    }
  }, [_c('i', {
    staticClass: "fas fa-fw fa-broom"
  }), _vm._v("\n                         \n                        Opgaver uden afdeling\n                    ")]) : _vm._e(), _vm._v(" "), (_vm.$auth.user().company.api_provider.slug === 'minuba') ? _c('div', {
    staticClass: "menu-item",
    class: {
      'selected': _vm.selected === 'projectsMissingBudget'
    },
    on: {
      "click": function($event) {
        _vm.selected = 'projectsMissingBudget'
      }
    }
  }, [_c('i', {
    staticClass: "fas fa-fw fa-divide"
  }), _vm._v("\n                         \n                        Opgaver uden budget\n                    ")]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-9"
  }, [(_vm.selected === 'accountPlan') ? _c('accountPlan') : _vm._e(), _vm._v(" "), (_vm.selected === 'employees') ? _c('employees') : _vm._e(), _vm._v(" "), (_vm.selected === 'general') ? _c('general') : _vm._e(), _vm._v(" "), (_vm.selected === 'projectStatuses') ? _c('projectStatuses') : _vm._e(), _vm._v(" "), (_vm.selected === 'cleanup') ? _c('cleanup') : _vm._e(), _vm._v(" "), (_vm.selected === 'users') ? _c('users') : _vm._e(), _vm._v(" "), (_vm.selected === 'user') ? _c('user') : _vm._e(), _vm._v(" "), (_vm.selected === 'budget') ? _c('budget') : _vm._e(), _vm._v(" "), (_vm.selected === 'valuechainCalculation') ? _c('valuechain-calculation') : _vm._e(), _vm._v(" "), (_vm.selected === 'excludeProjects') ? _c('exclude-projects') : _vm._e(), _vm._v(" "), (_vm.selected === 'projectsMissingBudget') ? _c('projects-missing-budget') : _vm._e()], 1)])])])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-60f315bb", module.exports)
  }
}

/***/ }),
/* 850 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "compare-coverage-percent"
  }, [_c('div', {
    staticClass: "placeholder"
  }, [_c('div', {
    staticClass: "placeholder__heading"
  }, [_vm._v("\n            DG\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "placeholder padding"
  }, [(!_vm.loading && _vm.series.length > 0) ? _c('vue-apex-charts', {
    ref: "tester",
    attrs: {
      "height": _vm.height,
      "options": _vm.options,
      "series": _vm.series,
      "type": "line"
    }
  }) : _c('box-loading', {
    attrs: {
      "height": "400"
    }
  })], 1)])])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-628e275b", module.exports)
  }
}

/***/ }),
/* 851 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "coming-soon"
  }, [_c('div', {
    staticClass: "container section"
  }, [_c('title-block', {
    staticClass: "mb-xl",
    attrs: {
      "headline": "<b>Kommer snart</b>",
      "position": "center"
    }
  }, [_c('p', {
    attrs: {
      "slot": "text"
    },
    slot: "text"
  }, [_vm._v("\n                Vi er i fuld gang med at videreudvikle indhold til dette faneblad!\n            ")])])], 1)])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-6665b95b", module.exports)
  }
}

/***/ }),
/* 852 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "compare-project-types-for-responsibles"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    class: _vm.selectedRow ? 'col-lg-3' : 'col-lg-6'
  }, [_c('div', {
    staticClass: "placeholder fit-content"
  }, [_c('div', {
    staticClass: "placeholder__heading"
  }, [_vm._v("\n                    Opgavetyper\n                ")]), _vm._v(" "), _c('div', {
    staticClass: "placeholder fit-content"
  }, [(!_vm.loading) ? _c('vue-good-table', {
    attrs: {
      "columns": _vm.columns,
      "rows": _vm.rows,
      "search-options": _vm.searchOptions,
      "pagination-options": _vm.paginationOptions,
      "sort-options": _vm.sortOptions,
      "styleClass": _vm.styleClass,
      "row-style-class": _vm.selectedRowClass
    },
    on: {
      "on-row-click": _vm.selectProjectType
    },
    scopedSlots: _vm._u([{
      key: "table-row",
      fn: function(props) {
        return [(props.column.field == 'coverage_percent') ? _c('div', {
          staticClass: "coverage-cell"
        }, [_vm._v("\n                                " + _vm._s(_vm._f("rounded")(props.row.coverage_percent)) + " \n                                "), (props.row.coverage_percent !== null) ? _c('div', {
          staticClass: "coverage-indicator",
          class: {
            'bad': props.row.coverage_percent < _vm.$store.state.config.companyMeta.settings.coverage_percent.medium.value, 'avg': _vm.$options.filters.rounded(props.row.coverage_percent) >= _vm.$store.state.config.companyMeta.settings.coverage_percent.medium.value, 'good': _vm.$options.filters.rounded(props.row.coverage_percent) >= _vm.$store.state.config.companyMeta.settings.coverage_percent.high.value
          }
        }) : _vm._e()]) : (props.column.field == 'total_revenue') ? _c('div', [_vm._v("\n                                " + _vm._s(_vm._f("currency")(props.row.total_revenue)) + "\n                            ")]) : (props.column.field == 'total_coverage') ? _c('div', [_vm._v("\n                                " + _vm._s(_vm._f("currency")(props.row.total_coverage)) + "\n                            ")]) : (props.column.field == 'coverage_per_hour') ? _c('div', {
          staticClass: "coverage-cell"
        }, [_vm._v("\n                                " + _vm._s(_vm._f("currency")(props.row.coverage_per_hour)) + " \n                                "), (props.row.coverage_per_hour !== null) ? _c('div', {
          staticClass: "coverage-indicator",
          class: {
            'bad': props.row.coverage_per_hour < _vm.$store.state.config.companyMeta.settings.coverage_per_hour.medium.value, 'avg': _vm.$options.filters.rounded(props.row.coverage_per_hour) >= _vm.$store.state.config.companyMeta.settings.coverage_per_hour.medium.value, 'good': _vm.$options.filters.rounded(props.row.coverage_per_hour) >= _vm.$store.state.config.companyMeta.settings.coverage_per_hour.high.value
          }
        }) : _vm._e()]) : _c('div', [_vm._v("\n                                " + _vm._s(props.formattedRow[props.column.field]) + "\n                            ")])]
      }
    }], null, false, 1445950624)
  }, [_c('div', {
    attrs: {
      "slot": "emptystate"
    },
    slot: "emptystate"
  }, [_vm._v("\n                            Ingen data. Husk at angive i indstillingerne hvilke medarbejdere, der skal listes her\n                        ")])]) : _c('box-loading', {
    attrs: {
      "height": "350"
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    class: _vm.selectedRow ? 'col-lg-9' : 'col-lg-6'
  }, [(!_vm.selectedRow) ? _c('div', {
    staticClass: "info"
  }, [_vm._v("\n                Vælg en opgavetype for at se et overblik over de enkelte ansvarlige her\n            ")]) : _vm._e(), _vm._v(" "), (_vm.selectedRow) ? _c('div', [_c('div', {
    staticStyle: {
      "margin-bottom": "5px"
    }
  }, [_c('a', {
    staticStyle: {
      "text-decoration": "none",
      "color": "#172b43",
      "font-weight": "600"
    },
    attrs: {
      "href": "javascript:void(0)"
    },
    on: {
      "click": function($event) {
        _vm.selectedRow = null
      }
    }
  }, [_c('i', {
    staticClass: "far fa-times"
  }), _vm._v(" Luk\n                    ")])])]) : _vm._e(), _vm._v(" "), (_vm.selectedRow) ? _c('project-types-responsibles', {
    attrs: {
      "data": _vm.selectedRow
    }
  }) : _vm._e()], 1)])])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-6b20ccd5", module.exports)
  }
}

/***/ }),
/* 853 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "placeholder fit-content"
  }, [_c('div', {
    staticClass: "placeholder__heading"
  }, [_c('d-tooltip', {
    attrs: {
      "placement": "left",
      "identifier": "oekonomi.leverandoerer"
    }
  }), _vm._v("\n        Leverandører\n    ")], 1), _vm._v(" "), _c('div', {
    staticClass: "placeholder"
  }, [(!_vm.loading) ? _c('vue-good-table', {
    attrs: {
      "columns": _vm.columns,
      "rows": _vm.rows,
      "search-options": _vm.searchOptions,
      "pagination-options": _vm.paginationOptions,
      "sort-options": _vm.sortOptions,
      "styleClass": _vm.styleClass
    },
    scopedSlots: _vm._u([{
      key: "table-row",
      fn: function(props) {
        return [(props.column.field == 'name') ? _c('div', {
          staticClass: "table-column__description"
        }, [_vm._v("\n                    " + _vm._s(props.row.name) + "\n                ")]) : (props.column.field == 'total_quantity') ? _c('div', {
          staticStyle: {
            "text-align": "left"
          }
        }, [_vm._v("\n                    " + _vm._s(_vm._f("number")(props.row.total_quantity)) + "\n                ")]) : (props.column.field == 'total_cost') ? _c('div', {
          staticStyle: {
            "text-align": "left"
          }
        }, [_vm._v("\n                    " + _vm._s(_vm._f("currency")(props.row.total_cost)) + "\n                ")]) : (props.column.field == 'avg_price_per_material') ? _c('div', {
          staticStyle: {
            "text-align": "left"
          }
        }, [_vm._v("\n                    " + _vm._s(_vm._f("currency")(props.row.avg_price_per_material)) + "\n                ")]) : _c('div', [_vm._v("\n                    " + _vm._s(props.formattedRow[props.column.field]) + "\n                ")])]
      }
    }], null, false, 421130365)
  }, [_c('div', {
    attrs: {
      "slot": "emptystate"
    },
    slot: "emptystate"
  }, [_vm._v("\n                Ingen data ...\n            ")])]) : _c('box-loading', {
    attrs: {
      "height": "350"
    }
  })], 1)])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-6c3ec234", module.exports)
  }
}

/***/ }),
/* 854 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "project-type-development"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-6"
  }, [_c('div', {
    staticClass: "placeholder"
  }, [_c('div', {
    staticClass: "placeholder__heading"
  }, [_c('d-tooltip', {
    attrs: {
      "placement": "left",
      "identifier": "projects.coverageDevelopment"
    }
  }), _vm._v("\n                    Udviklingen i DB pr. opgavetype\n                ")], 1), _vm._v(" "), _c('div', {
    staticClass: "placeholder"
  }, [(!_vm.loading) ? _c('vue-good-table', {
    attrs: {
      "columns": _vm.columns,
      "rows": _vm.rows,
      "search-options": _vm.searchOptions,
      "pagination-options": _vm.paginationOptions,
      "sort-options": _vm.sortOptions,
      "styleClass": _vm.styleClass,
      "row-style-class": _vm.selectedRowClass
    },
    on: {
      "on-row-click": _vm.selectProjectType
    },
    scopedSlots: _vm._u([{
      key: "table-row",
      fn: function(props) {
        return [(props.column.field == 'progress_percent') ? _c('div', {
          staticStyle: {
            "text-align": "left"
          }
        }, [(props.row.progress_percent >= 5) ? _c('span', {
          staticClass: "color-good"
        }, [_c('i', {
          staticClass: "fas fa-arrow-up"
        })]) : (props.row.progress_percent === 0 || props.row.progress_percent > -5 && props.row.progress_percent < 5) ? _c('span', [_c('i', {
          staticClass: "fas fa-arrow-right color-avg"
        })]) : _c('span', {
          staticClass: "color-bad"
        }, [_c('i', {
          staticClass: "fas fa-arrow-down"
        })])]) : (props.column.field == 'coverage_avg') ? _c('div', {
          staticStyle: {
            "text-align": "left"
          }
        }, [_vm._v("\n                                " + _vm._s(_vm._f("currency")(props.row.coverage_avg)) + "\n                            ")]) : (props.column.field == 'projects_count') ? _c('div', {
          staticStyle: {
            "text-align": "left"
          }
        }, [_vm._v("\n                                " + _vm._s(_vm._f("number")(props.row.projects_count)) + "\n                            ")]) : (props.column.field == 'name') ? _c('div', {
          staticClass: "table-column__description",
          attrs: {
            "title": props.row.name ? props.row.name : '-'
          }
        }, [_vm._v("\n                                " + _vm._s(props.row.name ? props.row.name : '-') + "\n                            ")]) : _c('div', {
          attrs: {
            "title": props.formattedRow[props.column.field]
          }
        }, [_vm._v("\n                                " + _vm._s(props.formattedRow[props.column.field]) + "\n                            ")])]
      }
    }], null, false, 708878618)
  }, [_c('div', {
    attrs: {
      "slot": "emptystate"
    },
    slot: "emptystate"
  }, [_vm._v("\n                            Ingen data ...\n                        ")])]) : _c('box-loading', {
    attrs: {
      "height": "350"
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-6"
  }, [(!_vm.loading && _vm.series.length > 0) ? _c('div', {
    staticClass: "placeholder fit-content"
  }, [_c('div', {
    staticClass: "placeholder__heading"
  }, [_vm._v("\n                    " + _vm._s(_vm.series[0].name) + "\n                ")]), _vm._v(" "), _c('div', {
    staticClass: "placeholder padding"
  }, [(!_vm.loading && _vm.series.length > 0) ? _c('vue-apex-charts', {
    ref: "tester",
    attrs: {
      "height": _vm.height,
      "options": _vm.options,
      "series": _vm.series,
      "type": "line"
    }
  }) : _vm._e()], 1)]) : _c('div', [_vm._v("\n                Vælg en opgavetype for at se fremgangen i en graf\n            ")])])])])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-6c73c961", module.exports)
  }
}

/***/ }),
/* 855 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "efficiency-graph"
  }, [_c('div', {
    staticClass: "placeholder"
  }, [_c('graph-card', {
    attrs: {
      "heading": "Hvor meget tid bruger svendene hos kunderne?",
      "unit": "%",
      "ylabel": "Timer brugt på kundeopgaver",
      "height": "450",
      "trend": true,
      "endpoint": _vm.efficiencyGraph,
      "paramsInEndpoint": _vm.efficiencyGraphParams,
      "series": _vm.efficiencyGraphSeries
    }
  }, [_c('button', {
    staticStyle: {
      "position": "absolute",
      "top": "0",
      "right": "0",
      "line-height": "50px",
      "margin-right": "15px",
      "outline": "none"
    },
    on: {
      "click": function($event) {
        return _vm.toggleEfficiency()
      }
    }
  }, [(_vm.efficiencyGraph === 'efficiency') ? _c('span', [_vm._v("\n                Vis fordeling pr. ugedag\n            ")]) : (_vm.efficiencyGraph === 'efficiency?weekdays=1') ? _c('span', [_vm._v("\n                Vis fordeling pr. måned\n            ")]) : _vm._e()])])], 1)])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-6c838013", module.exports)
  }
}

/***/ }),
/* 856 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "customer-revenue-single"
  }, [_c('div', {
    staticClass: "placeholder"
  }, [_c('div', {
    staticClass: "placeholder__heading"
  }, [_vm._v("\n            " + _vm._s(_vm.data.name) + "\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "placeholder"
  }, [_c('vue-good-table', {
    attrs: {
      "columns": _vm.columns,
      "rows": _vm.data.projects,
      "search-options": _vm.searchOptions,
      "pagination-options": _vm.paginationOptions,
      "sort-options": _vm.sortOptions,
      "styleClass": _vm.styleClass
    },
    scopedSlots: _vm._u([{
      key: "table-row",
      fn: function(props) {
        return [(props.column.field == 'coverage_percent') ? _c('div', {
          staticClass: "coverage-cell"
        }, [_vm._v("\n                        " + _vm._s(_vm._f("rounded")(props.row.coverage_percent)) + " \n                        "), (props.row.coverage_percent !== null) ? _c('div', {
          staticClass: "coverage-indicator",
          class: {
            'bad': props.row.coverage_percent < _vm.$store.state.config.companyMeta.settings.coverage_percent.medium.value, 'avg': _vm.$options.filters.rounded(props.row.coverage_percent) >= _vm.$store.state.config.companyMeta.settings.coverage_percent.medium.value, 'good': _vm.$options.filters.rounded(props.row.coverage_percent) >= _vm.$store.state.config.companyMeta.settings.coverage_percent.high.value
          }
        }) : _vm._e()]) : (props.column.field == 'description') ? _c('div', {
          staticClass: "table-column__description",
          attrs: {
            "title": props.row.description
          }
        }, [_vm._v("\n                        " + _vm._s(props.row.description) + "\n                    ")]) : (props.column.field == 'coverage') ? _c('div', [_vm._v("\n                        " + _vm._s(_vm._f("currency")(props.row.coverage)) + "\n                    ")]) : (props.column.field == 'invoices_total') ? _c('div', {
          staticStyle: {
            "text-align": "left"
          }
        }, [_vm._v("\n                        " + _vm._s(_vm._f("currency")(props.row.invoices_total)) + "\n                    ")]) : (props.column.field == 'coverage_per_hour') ? _c('div', {
          staticClass: "coverage-cell"
        }, [_vm._v("\n                        " + _vm._s(_vm._f("currency")(props.row.coverage_per_hour)) + " \n                        "), (props.row.coverage_per_hour !== null) ? _c('div', {
          staticClass: "coverage-indicator",
          class: {
            'bad': props.row.coverage_per_hour < _vm.$store.state.config.companyMeta.settings.coverage_per_hour.medium.value, 'avg': _vm.$options.filters.rounded(props.row.coverage_per_hour) >= _vm.$store.state.config.companyMeta.settings.coverage_per_hour.medium.value, 'good': _vm.$options.filters.rounded(props.row.coverage_per_hour) >= _vm.$store.state.config.companyMeta.settings.coverage_per_hour.high.value
          }
        }) : _vm._e()]) : (props.column.field == 'minuba_external_id') ? _c('div', [_c('a', {
          staticClass: "minuba-link",
          attrs: {
            "href": 'https://app.minuba.dk/?op=casedetails&glist=' + props.row.minuba_external_id,
            "target": "_blank"
          }
        }, [_c('i', {
          staticClass: "fas fa-eye"
        })])]) : _c('div', {
          attrs: {
            "title": props.formattedRow[props.column.field]
          }
        }, [_vm._v("\n                        " + _vm._s(props.formattedRow[props.column.field]) + "\n                    ")])]
      }
    }])
  }, [_c('div', {
    attrs: {
      "slot": "emptystate"
    },
    slot: "emptystate"
  }, [_vm._v("\n                    Ingen data ...\n                ")])])], 1)])])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-702551b2", module.exports)
  }
}

/***/ }),
/* 857 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "time-usage-skills"
  }, [_c('div', {
    staticClass: "employee-switcher"
  }, [_c('div', {
    staticClass: "employee-switcher-option",
    class: {
      'selected': _vm.employeeWorkingFieldName === ''
    },
    on: {
      "click": function($event) {
        _vm.employeeWorkingFieldName = ''
      }
    }
  }, [_vm._v("\n            Alle medarbejdere\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "employee-switcher-option",
    class: {
      'selected': _vm.employeeWorkingFieldName === 'Svend, funktionær'
    },
    on: {
      "click": function($event) {
        _vm.employeeWorkingFieldName = 'Svend, funktionær'
      }
    }
  }, [_vm._v("\n            Svende, funktionær\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "employee-switcher-option",
    class: {
      'selected': _vm.employeeWorkingFieldName === 'Svend, timelønnet'
    },
    on: {
      "click": function($event) {
        _vm.employeeWorkingFieldName = 'Svend, timelønnet'
      }
    }
  }, [_vm._v("\n            Svende, timelønnet\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "employee-switcher-option",
    class: {
      'selected': _vm.employeeWorkingFieldName === 'Lærling'
    },
    on: {
      "click": function($event) {
        _vm.employeeWorkingFieldName = 'Lærling'
      }
    }
  }, [_vm._v("\n            Lærlinge\n        ")])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-8"
  }, [_c('div', {
    staticClass: "placeholder fit-content"
  }, [_c('div', {
    staticClass: "placeholder__heading"
  }, [_c('d-tooltip', {
    attrs: {
      "placement": "left",
      "identifier": "employees.timeUsageSkills"
    }
  }), _vm._v("\n                    Hvor gode er vi til at registrere tid?\n                ")], 1), _vm._v(" "), (_vm.data && !_vm.loading) ? _c('div', {
    staticClass: "placeholder"
  }, [(_vm.data) ? _c('vue-good-table', {
    attrs: {
      "columns": _vm.columns,
      "rows": _vm.data.employees,
      "search-options": _vm.searchOptions,
      "pagination-options": _vm.paginationOptions,
      "sort-options": _vm.sortOptions,
      "styleClass": _vm.styleClass
    },
    scopedSlots: _vm._u([{
      key: "table-row",
      fn: function(props) {
        return [(props.column.field == 'available_hours') ? _c('div', {
          staticStyle: {
            "text-align": "left"
          }
        }, [_vm._v("\n                                " + _vm._s(_vm._f("number")(props.row.available_hours)) + "\n                            ")]) : (props.column.field == 'logged_hours') ? _c('div', {
          staticStyle: {
            "text-align": "left"
          }
        }, [_vm._v("\n                                " + _vm._s(_vm._f("number")(props.row.logged_hours)) + "\n                            ")]) : (props.column.field == 'full_name') ? _c('div', {
          staticClass: "table-column__description",
          attrs: {
            "title": props.row.full_name
          }
        }, [_vm._v("\n                                " + _vm._s(props.row.full_name) + "\n                            ")]) : (props.column.field == 'weekly_hours_working') ? _c('div', {
          staticStyle: {
            "text-align": "left"
          }
        }, [_vm._v("\n                                " + _vm._s(props.row.weekly_hours_working) + "\n                            ")]) : (props.column.field == 'avg_per_week') ? _c('div', {
          staticStyle: {
            "text-align": "left"
          }
        }, [_vm._v("\n                                " + _vm._s(_vm._f("number")(props.row.avg_per_week)) + "\n                            ")]) : (props.column.field == 'efficiency') ? _c('div', {
          staticClass: "coverage-cell",
          staticStyle: {
            "text-align": "left"
          }
        }, [_c('span', [_vm._v("\n                                    " + _vm._s(_vm._f("rounded")(props.row.efficiency)) + "\n                                    "), (props.row.efficiency) ? _c('span', [_vm._v("%")]) : _vm._e()]), _vm._v(" "), (props.row.efficiency) ? _c('div', {
          staticClass: "coverage-indicator",
          class: {
            'bad': props.row.efficiency < _vm.$store.state.config.companyMeta.settings.timelogging.medium.value, 'avg': _vm.$options.filters.rounded(props.row.efficiency) >= _vm.$store.state.config.companyMeta.settings.timelogging.medium.value, 'good': _vm.$options.filters.rounded(props.row.efficiency) >= _vm.$store.state.config.companyMeta.settings.timelogging.high.value
          }
        }) : _vm._e()]) : _c('div', [_vm._v("\n                                " + _vm._s(props.formattedRow[props.column.field]) + "\n                            ")])]
      }
    }], null, false, 3014051959)
  }, [_c('div', {
    attrs: {
      "slot": "emptystate"
    },
    slot: "emptystate"
  }, [_vm._v("\n                            Ingen data ...\n                        ")])]) : _vm._e()], 1) : (!_vm.data && !_vm.loading) ? _c('div', {
    staticClass: "placeholder padding"
  }, [_vm._v("\n                    Vi kunne ikke hente data. Tjek, at du har angivet hvilke svende, der skal baseres data på under indstillinger.\n                ")]) : _c('box-loading', {
    attrs: {
      "height": "350"
    }
  })], 1), _vm._v(" "), _c('br'), _vm._v("\n            OBS! Der vises kun medarbejdere, som har registreret tid i den valgte periode.\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-4"
  }, [_c('div', {
    staticClass: "placeholder fit-content"
  }, [_c('div', {
    staticClass: "placeholder__heading"
  }, [_vm._v("\n                    Opsummering\n                ")]), _vm._v(" "), (_vm.data && !_vm.loading) ? _c('div', {
    staticClass: "placeholder padding"
  }, [_c('div', {
    staticClass: "highlight"
  }, [_c('div', {
    staticClass: "text"
  }, [_vm._v("\n                            Timer til rådighed\n                        ")]), _vm._v(" "), _c('div', {
    staticClass: "value"
  }, [_vm._v("\n                            " + _vm._s(_vm._f("number")(_vm.data.totals.available_hours)) + "\n                        ")])]), _vm._v(" "), _c('div', {
    staticClass: "highlight"
  }, [_c('div', {
    staticClass: "text"
  }, [_vm._v("\n                            Timer registreret\n                        ")]), _vm._v(" "), _c('div', {
    staticClass: "value"
  }, [_vm._v("\n                            " + _vm._s(_vm._f("number")(_vm.data.totals.logged_hours)) + "\n                        ")])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "highlights",
    attrs: {
      "align": "center"
    }
  }, [_c('div', {
    staticClass: "value",
    staticStyle: {
      "font-size": "30px",
      "font-weight": "bold",
      "display": "flex",
      "align-items": "center",
      "justify-content": "center"
    }
  }, [(_vm.data.totals.efficiency) ? _c('div', {
    staticClass: "coverage-indicator",
    class: {
      'bad': _vm.data.totals.efficiency < _vm.$store.state.config.companyMeta.settings.timelogging.medium.value, 'avg': _vm.$options.filters.rounded(_vm.data.totals.efficiency) >= _vm.$store.state.config.companyMeta.settings.timelogging.medium.value, 'good': _vm.$options.filters.rounded(_vm.data.totals.efficiency) >= _vm.$store.state.config.companyMeta.settings.timelogging.high.value
    }
  }) : _vm._e(), _vm._v("\n                            " + _vm._s(_vm._f("rounded")(_vm.data.totals.efficiency)) + " %\n                        ")]), _vm._v(" "), _c('div', {
    staticClass: "text"
  }, [_vm._v("\n                            Af timer til rådighed er registreret\n                        ")])])]) : (!_vm.data && !_vm.loading) ? _c('div', {
    staticClass: "placeholder padding"
  }, [_vm._v("\n                    Vi kunne ikke hente data. Tjek, at du har angivet hvilke svende, der skal baseres data på under indstillinger.\n                ")]) : _c('box-loading', {
    attrs: {
      "height": "350"
    }
  })], 1)])])])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-70ce8938", module.exports)
  }
}

/***/ }),
/* 858 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "super-admin"
  }, [_c('div', {
    staticClass: "container section"
  }, [_c('title-block', {
    staticClass: "mb-xl",
    attrs: {
      "headline": "<b>Super admin</b>"
    }
  }, [_c('p', {
    attrs: {
      "slot": "text"
    },
    slot: "text"
  }, [_vm._v("\n                Super Admin indstillinger\n            ")])]), _vm._v(" "), _vm._m(0)], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content"
  }, [_c('b', [_vm._v("Funktioner:")]), _c('br'), _vm._v(" "), _c('ul', [_c('li', [_vm._v("Opret nye virksomheder (onboarding)")])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-6"
  }, [_vm._v("\n                    Block\n                ")]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-6"
  }, [_vm._v("\n                    Block\n                ")])])])
}]}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-70ff05cc", module.exports)
  }
}

/***/ }),
/* 859 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "compare-coverage"
  }, [_c('div', {
    staticClass: "placeholder"
  }, [_c('div', {
    staticClass: "placeholder__heading"
  }, [_vm._v("\n            DB\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "placeholder padding"
  }, [(!_vm.loading && _vm.series.length > 0) ? _c('vue-apex-charts', {
    ref: "tester",
    attrs: {
      "height": _vm.height,
      "options": _vm.options,
      "series": _vm.series,
      "type": "line"
    }
  }) : _c('box-loading', {
    attrs: {
      "height": "400"
    }
  })], 1)])])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-72d1c53a", module.exports)
  }
}

/***/ }),
/* 860 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "employees"
  }, [_c('box-helper', {
    attrs: {
      "headline": "Medarbejdere",
      "identifier": "employees"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "container section"
  }, [_c('title-block', {
    staticClass: "mb-xl",
    attrs: {
      "headline": "<b>Medarbejdere</b>",
      "position": "center"
    }
  }, [_c('p', {
    attrs: {
      "slot": "text"
    },
    slot: "text"
  }, [_vm._v("\n                Ét samlet overblik over dine medarbejdere\n            ")])]), _vm._v(" "), _c('router-view')], 1)], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-72e01a76", module.exports)
  }
}

/***/ }),
/* 861 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "project-statuses"
  }, [(_vm.statuses && _vm.statusTypes) ? _c('div', {
    staticClass: "list"
  }, _vm._l((_vm.statuses), function(status) {
    return _c('div', {
      key: status.uuid,
      staticClass: "project-status"
    }, [_c('div', {
      staticClass: "name"
    }, [_vm._v("\n                " + _vm._s(status.name) + "\n            ")]), _vm._v(" "), _c('div', {
      staticClass: "type"
    }, [_c('b', {
      staticStyle: {
        "font-weight": "600"
      }
    }, [_vm._v("Vælg type:")]), _vm._v("\n                  \n                "), _c('select', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (status.type.uuid),
        expression: "status.type.uuid"
      }],
      on: {
        "change": [function($event) {
          var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
            return o.selected
          }).map(function(o) {
            var val = "_value" in o ? o._value : o.value;
            return val
          });
          _vm.$set(status.type, "uuid", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
        }, function($event) {
          return _vm.update(status, $event)
        }]
      }
    }, [_c('option', {
      domProps: {
        "value": null
      }
    }, [_vm._v("- Ingen type -")]), _vm._v(" "), _vm._l((_vm.statusTypes), function(statusType) {
      return _c('option', {
        key: statusType.uuid,
        domProps: {
          "value": statusType.uuid
        }
      }, [_vm._v("\n                        " + _vm._s(statusType.name) + "\n                    ")])
    })], 2)])])
  }), 0) : _vm._e()])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-74a30572", module.exports)
  }
}

/***/ }),
/* 862 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "hours-with-customers"
  }, [_c('vue-apex-charts', {
    ref: "tester",
    attrs: {
      "options": _vm.chartOptions,
      "series": _vm.chartOptions.series,
      "height": _vm.chartOptions.chart.height
    }
  })], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-77c6b227", module.exports)
  }
}

/***/ }),
/* 863 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "view-toggle"
  }, [_c('div', {
    staticClass: "options"
  }, [_c('div', {
    staticClass: "option drift",
    class: {
      'selected': _vm.$store.state.view === 'operations'
    },
    on: {
      "click": function($event) {
        return _vm.doToggle('operations', _vm.operationsLink)
      }
    }
  }, [_vm._v("\n            " + _vm._s(_vm.operationsName) + "\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "option udvikling",
    class: {
      'selected': _vm.$store.state.view === 'learning'
    },
    on: {
      "click": function($event) {
        return _vm.doToggle('learning', _vm.learningLink)
      }
    }
  }, [_vm._v("\n            " + _vm._s(_vm.learningName) + "\n        ")])])])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-77c8f022", module.exports)
  }
}

/***/ }),
/* 864 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "main-project-type-single"
  }, [_c('div', {
    staticClass: "placeholder"
  }, [_c('div', {
    staticClass: "placeholder__heading"
  }, [_vm._v("\n            " + _vm._s(_vm.data.name) + "\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "placeholder"
  }, [_c('vue-good-table', {
    attrs: {
      "columns": _vm.columns,
      "rows": _vm.data.main_projects,
      "search-options": _vm.searchOptions,
      "pagination-options": _vm.paginationOptions,
      "sort-options": _vm.sortOptions,
      "styleClass": _vm.styleClass,
      "row-style-class": _vm.selectedRowClass
    },
    on: {
      "on-row-click": _vm.selectProjectType
    },
    scopedSlots: _vm._u([{
      key: "table-row",
      fn: function(props) {
        return [(props.column.field == 'coverage_percent') ? _c('div', {
          staticClass: "coverage-cell"
        }, [_vm._v("\n                        " + _vm._s(_vm._f("rounded")(props.row.coverage_percent)) + " \n                        "), (props.row.coverage_percent !== null) ? _c('div', {
          staticClass: "coverage-indicator",
          class: {
            'bad': props.row.coverage_percent < _vm.$store.state.config.companyMeta.settings.coverage_percent.medium.value, 'avg': _vm.$options.filters.rounded(props.row.coverage_percent) >= _vm.$store.state.config.companyMeta.settings.coverage_percent.medium.value, 'good': _vm.$options.filters.rounded(props.row.coverage_percent) >= _vm.$store.state.config.companyMeta.settings.coverage_percent.high.value
          }
        }) : _vm._e()]) : (props.column.field == 'description') ? _c('div', {
          staticClass: "table-column__description",
          attrs: {
            "title": props.row.description
          }
        }, [_vm._v("\n                        " + _vm._s(props.row.description) + "\n                    ")]) : (props.column.field == 'coverage') ? _c('div', [_vm._v("\n                        " + _vm._s(_vm._f("currency")(props.row.coverage)) + "\n                    ")]) : (props.column.field == 'invoices_total') ? _c('div', {
          staticStyle: {
            "text-align": "left"
          }
        }, [_vm._v("\n                        " + _vm._s(_vm._f("currency")(props.row.invoices_total)) + "\n                    ")]) : (props.column.field == 'total_expenses') ? _c('div', {
          staticStyle: {
            "text-align": "left"
          }
        }, [_vm._v("\n                        " + _vm._s(_vm._f("currency")(props.row.total_expenses)) + "\n                    ")]) : (props.column.field == 'coverage_per_hour') ? _c('div', {
          staticClass: "coverage-cell"
        }, [_vm._v("\n                        " + _vm._s(_vm._f("currency")(props.row.coverage_per_hour)) + " \n                        "), (props.row.coverage_per_hour !== null) ? _c('div', {
          staticClass: "coverage-indicator",
          class: {
            'bad': props.row.coverage_per_hour < _vm.$store.state.config.companyMeta.settings.coverage_per_hour.medium.value, 'avg': _vm.$options.filters.rounded(props.row.coverage_per_hour) >= _vm.$store.state.config.companyMeta.settings.coverage_per_hour.medium.value, 'good': _vm.$options.filters.rounded(props.row.coverage_per_hour) >= _vm.$store.state.config.companyMeta.settings.coverage_per_hour.high.value
          }
        }) : _vm._e()]) : (props.column.field == 'name') ? _c('div', {
          staticClass: "table-column__description",
          attrs: {
            "title": props.row.name ? props.row.name : '-'
          }
        }, [_vm._v("\n                        " + _vm._s(props.row.name ? props.row.name : '-') + "\n                    ")]) : (props.column.field == 'external_created_at') ? _c('div', [_vm._v("\n                        " + _vm._s(_vm._f("moment")(props.row.external_created_at, "DD. MMM YYYY")) + "\n                    ")]) : _c('div', {
          attrs: {
            "title": props.formattedRow[props.column.field]
          }
        }, [_vm._v("\n                        " + _vm._s(props.formattedRow[props.column.field]) + "\n                    ")])]
      }
    }])
  }, [_c('div', {
    attrs: {
      "slot": "emptystate"
    },
    slot: "emptystate"
  }, [_vm._v("\n                    Ingen data ...\n                ")])])], 1)])])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-7b821fdc", module.exports)
  }
}

/***/ }),
/* 865 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "g-table-wrapper"
  }, [_c('div', {
    staticClass: "table-title"
  }, [_c('d-tooltip', {
    attrs: {
      "placement": "left",
      "identifier": "projects.openProjects"
    }
  }), _vm._v("\n        Ikke igangsatte opgaver\n    ")], 1), _vm._v(" "), (!_vm.loading) ? _c('vue-good-table', {
    attrs: {
      "columns": _vm.columns,
      "rows": _vm.rows,
      "search-options": _vm.searchOptions,
      "pagination-options": _vm.paginationOptions,
      "sort-options": _vm.sortOptions,
      "styleClass": _vm.styleClass
    },
    scopedSlots: _vm._u([{
      key: "table-row",
      fn: function(props) {
        return [(props.column.field == 'coverage_percent') ? _c('div', {
          staticClass: "coverage-cell"
        }, [_vm._v("\n                " + _vm._s(_vm._f("rounded")(props.row.coverage_percent)) + " \n                "), (props.row.coverage_percent !== null) ? _c('div', {
          staticClass: "coverage-indicator",
          class: {
            'bad': props.row.coverage_percent < _vm.$store.state.config.companyMeta.settings.coverage_percent.medium.value, 'avg': _vm.$options.filters.rounded(props.row.coverage_percent) >= _vm.$store.state.config.companyMeta.settings.coverage_percent.medium.value, 'good': _vm.$options.filters.rounded(props.row.coverage_percent) >= _vm.$store.state.config.companyMeta.settings.coverage_percent.high.value
          }
        }) : _vm._e()]) : (props.column.field == 'status.name') ? _c('div', {
          staticClass: "coverage-cell"
        }, [_vm._v("\n                " + _vm._s(props.row.status.name) + "\n                "), _c('div', {
          staticClass: "coverage-indicator status",
          style: ('background:#' + props.row.status.color + ';')
        })]) : (props.column.field == 'case_number') ? _c('div', {
          staticClass: "table-column__ordernumber",
          staticStyle: {
            "text-align": "left"
          }
        }, [_vm._v("\n                " + _vm._s(props.row.case_number) + "\n            ")]) : (props.column.field == 'description') ? _c('div', {
          staticClass: "table-column__description",
          attrs: {
            "title": props.row.description
          }
        }, [(props.row.calculation_price > 0) ? _c('budget-tooltip', {
          attrs: {
            "project": props.row
          }
        }) : _vm._e(), _vm._v("\n                " + _vm._s(props.row.description ? props.row.description : '-') + "\n            ")], 1) : (props.column.field == 'customer.name') ? _c('div', {
          staticClass: "table-column__customer",
          attrs: {
            "title": props.row.customer ? props.row.customer.name : '-'
          }
        }, [_vm._v("\n                " + _vm._s(props.row.customer ? props.row.customer.name : '-') + "\n            ")]) : (props.column.field == 'action') ? _c('div', {
          staticClass: "g-table__action",
          on: {
            "click": function($event) {
              return _vm.openExternalLink(props.row.external_id)
            }
          }
        }, [_c('i', {
          staticClass: "fad fa-eye"
        })]) : (props.column.field == 'start_date') ? _c('div', [_vm._v("\n                " + _vm._s(_vm._f("moment")(props.row.start_date, "DD. MMM YYYY")) + "\n            ")]) : (props.column.field == 'type.name') ? _c('div', {
          staticClass: "table-column__description",
          attrs: {
            "title": props.row.type ? props.row.type.name : '-'
          }
        }, [_vm._v("\n                " + _vm._s(props.row.type ? props.row.type.name : '-') + "\n            ")]) : (props.column.field == 'minuba_external_id') ? _c('div', [_c('a', {
          staticClass: "minuba-link",
          attrs: {
            "href": 'https://app.minuba.dk/?op=casedetails&glist=' + props.row.minuba_external_id,
            "target": "_blank"
          }
        }, [_c('i', {
          staticClass: "fas fa-eye"
        })])]) : _c('div', {
          attrs: {
            "title": props.formattedRow[props.column.field]
          }
        }, [_vm._v("\n                " + _vm._s(props.formattedRow[props.column.field]) + "\n            ")])]
      }
    }], null, false, 1613006212)
  }, [_c('div', {
    attrs: {
      "slot": "emptystate"
    },
    slot: "emptystate"
  }, [_vm._v("\n            Ingen data ...\n        ")])]) : _c('box-loading', {
    attrs: {
      "height": "350"
    }
  })], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-7d1a7034", module.exports)
  }
}

/***/ }),
/* 866 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "index"
  }, [_c('box-helper', {
    attrs: {
      "headline": "Overblik",
      "identifier": "index"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "container section"
  }, [_c('title-block', {
    staticClass: "mb-xl",
    attrs: {
      "headline": "<b>Overblik</b>",
      "position": "center"
    }
  }, [_c('p', {
    attrs: {
      "slot": "text"
    },
    slot: "text"
  }, [_vm._v("\n                Hvad skal der fokus på i dag?\n            ")])]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [(_vm.$auth.user().roles[0].name !== 'department-responsible') ? _c('div', {
    staticClass: "economy-overview"
  }, [_c('div', {
    staticClass: "row nomargin"
  }, [_c('div', {
    staticClass: "col-lg-4"
  }, [_c('div', {
    staticClass: "text"
  }, [_vm._v("\n                            EBITDA året til dato\n                            "), _c('d-tooltip', {
    attrs: {
      "placement": "inline",
      "identifier": "index.ebitda"
    }
  })], 1), _vm._v(" "), (!_vm.$auth.user().name.includes('Demo')) ? _c('div', {
    staticClass: "number color__main"
  }, [(_vm.calculations && _vm.keyfigures.ebitda) ? _c('span', [_vm._v("\n                                " + _vm._s(_vm._f("currency")(_vm.keyfigures.ebitda)) + "\n                            ")]) : _c('span', [_vm._v("-")])]) : _c('div', {
    staticClass: "number color__main"
  }, [_vm._v("\n                            " + _vm._s(_vm._f("currency")(324353)) + "\n                        ")])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-4"
  }, [_c('div', {
    staticClass: "text"
  }, [_vm._v("\n                            Forventet omsætning i denne måned\n                            "), _c('d-tooltip', {
    attrs: {
      "placement": "inline",
      "identifier": "index.expectedRevenue"
    }
  })], 1), _vm._v(" "), (!_vm.$auth.user().name.includes('Demo')) ? _c('div', {
    staticClass: "number color__good"
  }, [(_vm.calculations && _vm.keyfigures.expected_revenue !== undefined) ? _c('span', [(_vm.keyfigures.expected_revenue !== 0) ? _c('span', [_vm._v("\n                                    " + _vm._s(_vm._f("currency")(_vm.keyfigures.expected_revenue)) + "\n                                ")]) : _c('router-link', {
    staticClass: "small",
    staticStyle: {
      "color": "#fff",
      "margin": "0",
      "padding": "0",
      "cursor": "pointer"
    },
    attrs: {
      "tag": "span",
      "to": {
        name: 'Settings',
        params: {
          'selected': 'budget'
        }
      }
    }
  }, [_vm._v("\n                                    Læg budget nu "), _c('i', {
    staticClass: "fas fa-arrow-right"
  })])], 1) : _c('span', [_vm._v("-")])]) : _c('div', {
    staticClass: "number color__good"
  }, [_vm._v("\n                            " + _vm._s(_vm._f("currency")(538000)) + "\n                        ")])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-4"
  }, [_c('div', {
    staticClass: "text"
  }, [_vm._v("\n                            Forventede udgifter i denne måned\n                            "), _c('d-tooltip', {
    attrs: {
      "placement": "inline",
      "identifier": "index.expectedCosts"
    }
  })], 1), _vm._v(" "), (!_vm.$auth.user().name.includes('Demo')) ? _c('div', {
    staticClass: "number color__bad"
  }, [(_vm.calculations && _vm.keyfigures.expected_costs !== undefined) ? _c('span', [(_vm.keyfigures.expected_costs !== 0) ? _c('span', [_vm._v("\n                                    " + _vm._s(_vm._f("currency")(_vm.keyfigures.expected_costs)) + "\n                                ")]) : _c('router-link', {
    staticClass: "small",
    staticStyle: {
      "color": "#fff",
      "margin": "0",
      "padding": "0",
      "cursor": "pointer"
    },
    attrs: {
      "tag": "span",
      "to": {
        name: 'Settings',
        params: {
          'selected': 'budget'
        }
      }
    }
  }, [_vm._v("\n                                    Læg budget nu "), _c('i', {
    staticClass: "fas fa-arrow-right"
  })])], 1) : _c('span', [_vm._v("-")])]) : _c('div', {
    staticClass: "number color__bad"
  }, [_vm._v("\n                            " + _vm._s(_vm._f("currency")(493000)) + "\n                        ")])])])]) : _vm._e(), _vm._v(" "), _c('value-chain'), _vm._v(" "), _c('div', {
    staticClass: "number-overview"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-2"
  }, [_c('number-card', {
    attrs: {
      "heading": "Tilbud",
      "description": "der afventer afgørelse",
      "number": _vm.calculations.offer,
      "icon": "file-alt",
      "state": "avg",
      "linkParent": "ProjectsOperations",
      "linkChild": "offerProjects",
      "tooltipIdentifier": "index.offerProjects"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-lg-2"
  }, [_c('number-card', {
    attrs: {
      "heading": "Opgaver",
      "description": "der endnu ikke er påbegyndt",
      "number": _vm.calculations.open,
      "icon": "inbox-in",
      "state": "avg",
      "linkParent": "ProjectsOperations",
      "linkChild": "openProjects",
      "tooltipIdentifier": "index.openProjects"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-lg-2"
  }, [_c('number-card', {
    attrs: {
      "heading": "Igangværende opgaver",
      "description": "der arbejdes på lige nu",
      "number": _vm.calculations.ongoing,
      "icon": "clock",
      "state": "bad",
      "linkParent": "ProjectsOperations",
      "linkChild": "ongoingProjects",
      "tooltipIdentifier": "index.ongoingProjects"
    }
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('number-card', {
    attrs: {
      "heading": "Igangværende opgaver",
      "description": 'uden registreringer i ' + _vm.$store.state.config.companyMeta.settings.snoozed_days + ' dage ',
      "number": _vm.calculations.snoozed,
      "icon": "snooze",
      "state": "bad",
      "linkParent": "ProjectsOperations",
      "linkChild": "snoozedProjects",
      "tooltipIdentifier": "index.snoozedProjects"
    }
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('number-card', {
    attrs: {
      "heading": "Reklamationer",
      "description": "der ikke er afsluttet",
      "number": _vm.calculations.claims,
      "icon": "comment-exclamation",
      "state": "good",
      "linkParent": "ProjectsOperations",
      "linkChild": "openClaims",
      "tooltipIdentifier": "index.openClaims"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-lg-2"
  }, [_c('number-card', {
    attrs: {
      "heading": "Afsluttede opgaver",
      "description": "der ikke er fakturerede",
      "number": _vm.calculations.unbilled,
      "icon": "envelope-open-dollar",
      "state": "avg",
      "linkParent": "ProjectsOperations",
      "linkChild": "noInvoiceProjects",
      "tooltipIdentifier": "index.unbilledProjects"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-lg-2"
  }, [_c('number-card', {
    attrs: {
      "heading": "Fakturaer",
      "description": "der endnu ikke er betalt",
      "number": _vm.calculations.payment_pending,
      "icon": "envelope-open-dollar",
      "state": "avg",
      "linkParent": "EconomyOperations",
      "linkChild": "unpaidInvoices",
      "tooltipIdentifier": "index.unpaidInvoices"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-lg-2"
  }, [_c('number-card', {
    attrs: {
      "heading": "Fakturaer",
      "description": 'hvor betaling er overskredet med ' + _vm.$store.state.config.companyMeta.settings.overdue_days + ' dage',
      "number": _vm.calculations.payment_exceeded,
      "icon": "calendar-exclamation",
      "state": "bad",
      "totalValue": _vm.calculations.payment_exceeded_total,
      "linkParent": "EconomyOperations",
      "linkChild": "exceededPayments",
      "tooltipIdentifier": "index.overdueInvoices"
    }
  })], 1)])])], 1)], 1)], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-7dd1bf60", module.exports)
  }
}

/***/ }),
/* 867 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "display": "inline-block"
    }
  }, [_c('v-popover', {
    staticStyle: {
      "display": "inline-block"
    },
    attrs: {
      "offset": "16",
      "options": _vm.options,
      "open": _vm.show,
      "placement": "left"
    }
  }, [_c('button', {
    staticClass: "tooltip-target b3",
    staticStyle: {
      "display": "inline-block"
    },
    on: {
      "mouseover": function($event) {
        _vm.show = true
      },
      "mouseleave": function($event) {
        _vm.show = false
      }
    }
  }, [_c('i', {
    staticClass: "fas fa-calculator fa-fw"
  })]), _vm._v(" "), _c('template', {
    slot: "popover"
  }, [_c('div', {
    staticStyle: {
      "background": "#172b43",
      "color": "#fff",
      "padding": "5px 10px",
      "text-align": "center",
      "margin-bottom": "10px",
      "border-radius": "4px"
    }
  }, [_c('b', [_vm._v("BUDGET")])]), _vm._v(" "), _c('div', {
    staticClass: "line good"
  }, [_c('div', {
    staticClass: "left"
  }, [_vm._v("Forv. omsætning")]), _vm._v(" "), _c('div', {
    staticClass: "right good"
  }, [_vm._v(_vm._s(_vm._f("realCurrency")(_vm.project.calculation_price ? _vm.project.calculation_price : 0)))])]), _vm._v(" "), _c('div', {
    staticClass: "line bad"
  }, [_c('div', {
    staticClass: "left"
  }, [_vm._v("Forv. kostpris")]), _vm._v(" "), _c('div', {
    staticClass: "right bad"
  }, [_vm._v(_vm._s(_vm._f("realCurrency")(_vm.project.calculation_cost ? _vm.project.calculation_cost : 0)))])]), _vm._v(" "), _c('div', {
    staticClass: "divider",
    staticStyle: {
      "margin": "10px 0"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "line total"
  }, [_c('div', {
    staticClass: "left"
  }, [_vm._v("Forv. dækningsbidrag")]), _vm._v(" "), _c('div', {
    staticClass: "right",
    class: {
      'good': _vm.project.calculation_coverage > 0, 'bad': _vm.project.calculation_coverage < 0
    }
  }, [_vm._v(_vm._s(_vm._f("realCurrency")(_vm.project.calculation_coverage ? _vm.project.calculation_coverage : 0)))])])])], 2)], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-804e69b6", module.exports)
  }
}

/***/ }),
/* 868 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "offline-wrapper"
  }, [_c('div', {
    staticClass: "offline-inner"
  }, [_c('div', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fa fa-exclamation-circle"
  })]), _vm._v(" "), _c('h1', [_vm._v("Whoops!")]), _vm._v(" "), _c('h3', [_vm._v("You've lost the connection to the internet.")]), _vm._v(" "), _c('p', {
    staticClass: "description"
  }, [_vm._v("We could not register a live connection to the internet. Since this application uses network functions, please make sure you have a valid network connection and try again.")]), _vm._v(" "), _c('p', [_c('a', {
    attrs: {
      "href": "/"
    }
  }, [_c('button', {
    staticClass: "btn btn-primary"
  }, [_vm._v("Refresh this page")])])])])])
}]}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-87b029dc", module.exports)
  }
}

/***/ }),
/* 869 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "placeholder fit-content"
  }, [_c('div', {
    staticClass: "placeholder__heading"
  }, [_c('d-tooltip', {
    attrs: {
      "placement": "left",
      "identifier": "oekonomi.vareforbrug"
    }
  }), _vm._v("\n        Vareforbrug\n    ")], 1), _vm._v(" "), _c('div', {
    staticClass: "placeholder"
  }, [(!_vm.loading) ? _c('vue-good-table', {
    attrs: {
      "columns": _vm.columns,
      "rows": _vm.rows,
      "search-options": _vm.searchOptions,
      "pagination-options": _vm.paginationOptions,
      "sort-options": _vm.sortOptions,
      "styleClass": _vm.styleClass
    },
    scopedSlots: _vm._u([{
      key: "table-row",
      fn: function(props) {
        return [(props.column.field == 'name') ? _c('div', {
          staticClass: "table-column__description"
        }, [_vm._v("\n                    " + _vm._s(props.row.name) + "\n                ")]) : (props.column.field == 'total_quantity') ? _c('div', {
          staticStyle: {
            "text-align": "left"
          }
        }, [_vm._v("\n                    " + _vm._s(_vm._f("numberWithDecimals")(props.row.total_quantity)) + "\n                ")]) : (props.column.field == 'total_cost') ? _c('div', {
          staticStyle: {
            "text-align": "left"
          }
        }, [_vm._v("\n                    " + _vm._s(_vm._f("currency")(props.row.total_cost)) + "\n                ")]) : _c('div', [_vm._v("\n                    " + _vm._s(props.formattedRow[props.column.field]) + "\n                ")])]
      }
    }], null, false, 146854863)
  }, [_c('div', {
    attrs: {
      "slot": "emptystate"
    },
    slot: "emptystate"
  }, [_vm._v("\n                Ingen data ...\n            ")])]) : _c('box-loading', {
    attrs: {
      "height": "350"
    }
  })], 1)])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-8f9a7272", module.exports)
  }
}

/***/ }),
/* 870 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "cleanup"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("\n        Opgaver uden afdeling\n    ")]), _vm._v(" "), _vm._m(0), _vm._v(" "), (!_vm.loading) ? _c('vue-good-table', {
    attrs: {
      "columns": _vm.columns,
      "rows": _vm.rows,
      "search-options": _vm.searchOptions,
      "pagination-options": _vm.paginationOptions,
      "sort-options": _vm.sortOptions,
      "styleClass": _vm.styleClass
    },
    scopedSlots: _vm._u([{
      key: "table-row",
      fn: function(props) {
        return [(props.column.field == 'coverage_percent') ? _c('div', {
          staticClass: "coverage-cell"
        }, [_vm._v("\n                " + _vm._s(_vm._f("rounded")(props.row.coverage_percent)) + " \n                "), (props.row.coverage_percent !== null) ? _c('div', {
          staticClass: "coverage-indicator",
          class: {
            'bad': props.row.coverage_percent < _vm.$store.state.config.companyMeta.settings.coverage_percent.medium.value, 'avg': _vm.$options.filters.rounded(props.row.coverage_percent) >= _vm.$store.state.config.companyMeta.settings.coverage_percent.medium.value, 'good': _vm.$options.filters.rounded(props.row.coverage_percent) >= _vm.$store.state.config.companyMeta.settings.coverage_percent.high.value
          }
        }) : _vm._e()]) : (props.column.field == 'case_number') ? _c('div', {
          staticClass: "table-column__ordernumber",
          staticStyle: {
            "text-align": "left"
          }
        }, [_vm._v("\n                " + _vm._s(props.row.case_number) + "\n            ")]) : (props.column.field == 'description') ? _c('div', {
          staticClass: "table-column__description"
        }, [_vm._v("\n                " + _vm._s(props.row.description) + "\n            ")]) : (props.column.field == 'customer.name') ? _c('div', {
          staticClass: "table-column__customer"
        }, [(props.row.customer) ? _c('span', [_vm._v("\n                    " + _vm._s(props.row.customer.name) + "\n                ")]) : _c('span', [_vm._v(" - ")])]) : (props.column.field == 'invoices_total') ? _c('div', [_vm._v("\n                " + _vm._s(_vm._f("currency")(props.row.invoices_total)) + "\n            ")]) : (props.column.field == 'coverage') ? _c('div', [_vm._v("\n                " + _vm._s(_vm._f("currency")(props.row.coverage)) + "\n            ")]) : (props.column.field == 'coverage_per_hour') ? _c('div', {
          staticClass: "coverage-cell"
        }, [_vm._v("\n                " + _vm._s(_vm._f("currency")(props.row.coverage_per_hour)) + " \n                "), (props.row.coverage_per_hour !== null) ? _c('div', {
          staticClass: "coverage-indicator",
          class: {
            'bad': props.row.coverage_per_hour < _vm.$store.state.config.companyMeta.settings.coverage_per_hour.medium.value, 'avg': _vm.$options.filters.rounded(props.row.coverage_per_hour) >= _vm.$store.state.config.companyMeta.settings.coverage_per_hour.medium.value, 'good': _vm.$options.filters.rounded(props.row.coverage_per_hour) >= _vm.$store.state.config.companyMeta.settings.coverage_per_hour.high.value
          }
        }) : _vm._e()]) : (props.column.field == 'action') ? _c('div', {
          staticClass: "g-table__action",
          on: {
            "click": function($event) {
              return _vm.openExternalLink(props.row.external_id)
            }
          }
        }, [_c('i', {
          staticClass: "fad fa-eye"
        })]) : (props.column.field == 'start_date') ? _c('div', [_vm._v("\n                " + _vm._s(_vm._f("moment")(props.row.start_date, "DD. MMM YYYY")) + "\n            ")]) : (props.column.field == 'type.name') ? _c('div', {
          staticClass: "table-column__description",
          attrs: {
            "title": props.row.type ? props.row.type.name : '-'
          }
        }, [_vm._v("\n                " + _vm._s(props.row.type ? props.row.type.name : '-') + "\n            ")]) : (props.column.field == 'minuba_external_id') ? _c('div', [_c('a', {
          staticClass: "minuba-link",
          attrs: {
            "href": 'https://app.minuba.dk/?op=casedetails&glist=' + props.row.minuba_external_id,
            "target": "_blank"
          }
        }, [_c('i', {
          staticClass: "fas fa-eye"
        })])]) : _c('div', [_vm._v("\n                " + _vm._s(props.formattedRow[props.column.field]) + "\n            ")])]
      }
    }], null, false, 3305782259)
  }, [_c('div', {
    attrs: {
      "slot": "emptystate"
    },
    slot: "emptystate"
  }, [_vm._v("\n            Ingen data ...\n        ")])]) : _c('div', {
    staticClass: "placeholder"
  }, [_c('box-loading', {
    attrs: {
      "height": "350"
    }
  })], 1)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('br'), _vm._v("\n        Oversigten viser opgaver, der ikke er tildelt en afdeling. Det bør rettes op i dit program  til styring af opgaver, så du får den rigtige information at træffe beslutninger på i de forskellige faneblade i proEBITDA. Vær opmærksom på, at ændringen først slår igennem, når data er blevet synkroniseret igen (hver nat).\n        "), _c('br'), _c('br')])
}]}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-96b483dc", module.exports)
  }
}

/***/ }),
/* 871 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "g-table-wrapper"
  }, [_c('div', {
    staticClass: "table-title"
  }, [_c('d-tooltip', {
    attrs: {
      "identifier": "oekonomi.unpaidInvoices",
      "placement": "left"
    }
  }), _vm._v("\n        Fakturaer, der ikke er betalt\n    ")], 1), _vm._v(" "), (!_vm.loading) ? _c('vue-good-table', {
    attrs: {
      "columns": _vm.columns,
      "rows": _vm.rows,
      "search-options": _vm.searchOptions,
      "pagination-options": _vm.paginationOptions,
      "sort-options": _vm.sortOptions,
      "styleClass": _vm.styleClass
    },
    scopedSlots: _vm._u([{
      key: "table-row",
      fn: function(props) {
        return [(props.column.field == 'description') ? _c('div', {
          staticClass: "table-column__description",
          attrs: {
            "title": props.row.description
          }
        }, [_vm._v("\n                " + _vm._s(props.row.description) + "\n            ")]) : (props.column.field == 'invoice_number') ? _c('div', {
          staticStyle: {
            "text-align": "left"
          }
        }, [_vm._v("\n                " + _vm._s(props.row.invoice_number ? props.row.invoice_number : '-') + "\n            ")]) : (props.column.field == 'external_id') ? _c('div', {
          staticClass: "table-column__external-id"
        }, [_vm._v("\n                " + _vm._s(props.row.external_id) + "\n            ")]) : (props.column.field == 'due_at') ? _c('div', [_vm._v("\n                " + _vm._s(_vm._f("moment")(props.row.due_at, "DD. MMM YYYY")) + "\n            ")]) : (props.column.field == 'amount') ? _c('div', {
          staticStyle: {
            "text-align": "left"
          }
        }, [_vm._v("\n                " + _vm._s(_vm._f("currency")(props.row.amount)) + "\n            ")]) : (props.column.field == 'paid') ? _c('div', {
          staticStyle: {
            "text-align": "left"
          }
        }, [(props.row.paid) ? _c('span', [_vm._v("\n                    Betalt\n                ")]) : _c('span', [_vm._v("\n                    Ikke betalt\n                ")])]) : (props.column.field == 'minuba_external_id') ? _c('div', [_c('a', {
          staticClass: "minuba-link",
          attrs: {
            "href": 'https://app.minuba.dk/?op=casedetails&glist=' + props.row.minuba_external_id,
            "target": "_blank"
          }
        }, [_c('i', {
          staticClass: "fas fa-eye"
        })])]) : _c('div', {
          attrs: {
            "title": props.formattedRow[props.column.field]
          }
        }, [_vm._v("\n                " + _vm._s(props.formattedRow[props.column.field]) + "\n            ")])]
      }
    }], null, false, 2812794680)
  }, [_c('div', {
    attrs: {
      "slot": "emptystate"
    },
    slot: "emptystate"
  }, [_vm._v("\n            Ingen data ...\n        ")])]) : _c('box-loading', {
    attrs: {
      "height": "350"
    }
  })], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-976ca23a", module.exports)
  }
}

/***/ }),
/* 872 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "customers-learning"
  }, [_c('content-switch', {
    attrs: {
      "items": _vm.switchItems,
      "selectedItem": _vm.selectedItem,
      "counts": _vm.counts
    },
    on: {
      "selectItem": function($event) {
        return _vm.handleSelectItem($event)
      }
    }
  }), _vm._v(" "), _c('employee-skills', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.selectedItem === 'employeeSkills'),
      expression: "selectedItem === 'employeeSkills'"
    }]
  }), _vm._v(" "), _c('time-usage', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.selectedItem === 'timeUsage'),
      expression: "selectedItem === 'timeUsage'"
    }]
  }), _vm._v(" "), _c('time-usage-skills', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.selectedItem === 'timeUsageSkills'),
      expression: "selectedItem === 'timeUsageSkills'"
    }]
  }), _vm._v(" "), _c('employee-revenue', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.selectedItem === 'employeeRevenue'),
      expression: "selectedItem === 'employeeRevenue'"
    }]
  }), _vm._v(" "), _c('efficiency-graph', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.selectedItem === 'efficiencyGraph'),
      expression: "selectedItem === 'efficiencyGraph'"
    }]
  }), _vm._v(" "), _c('compare-responsible-employees', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.selectedItem === 'compareResponsibleEmployee'),
      expression: "selectedItem === 'compareResponsibleEmployee'"
    }]
  })], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-9c993686", module.exports)
  }
}

/***/ }),
/* 873 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "main-projects"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-12"
  }, [_c('div', {
    staticClass: "placeholder fit-content"
  }, [_c('div', {
    staticClass: "placeholder__heading"
  }, [_c('d-tooltip', {
    attrs: {
      "placement": "left",
      "identifier": "enterprise.mainProjectType"
    }
  }), _vm._v("\n                    Hvilke konkrete entrepriseopgaver tjenes der penge på?\n                ")], 1), _vm._v(" "), _c('div', {
    staticClass: "placeholder"
  }, [(!_vm.loading) ? _c('vue-good-table', {
    attrs: {
      "columns": _vm.columns,
      "rows": _vm.rows,
      "search-options": _vm.searchOptions,
      "pagination-options": _vm.paginationOptions,
      "sort-options": _vm.sortOptions,
      "styleClass": _vm.styleClass
    },
    scopedSlots: _vm._u([{
      key: "table-row",
      fn: function(props) {
        return [(props.column.field == 'coverage_percent') ? _c('div', {
          staticClass: "coverage-cell"
        }, [_vm._v("\n                                " + _vm._s(_vm._f("rounded")(props.row.coverage_percent)) + " \n                                "), (props.row.coverage_percent !== null) ? _c('div', {
          staticClass: "coverage-indicator",
          class: {
            'bad': props.row.coverage_percent < _vm.$store.state.config.companyMeta.settings.coverage_percent.medium.value, 'avg': _vm.$options.filters.rounded(props.row.coverage_percent) >= _vm.$store.state.config.companyMeta.settings.coverage_percent.medium.value, 'good': _vm.$options.filters.rounded(props.row.coverage_percent) >= _vm.$store.state.config.companyMeta.settings.coverage_percent.high.value
          }
        }) : _vm._e()]) : (props.column.field == 'description') ? _c('div', {
          staticClass: "table-column__description"
        }, [_vm._v("\n                                " + _vm._s(props.row.description) + "\n                            ")]) : (props.column.field == 'name') ? _c('div', {
          staticClass: "table-column__description",
          attrs: {
            "title": props.row.name
          }
        }, [_vm._v("\n                                " + _vm._s(props.row.name) + "\n                            ")]) : (props.column.field == 'customer.name') ? _c('div', {
          staticClass: "table-column__description",
          attrs: {
            "title": props.row.customer.name
          }
        }, [_vm._v("\n                                " + _vm._s(props.row.customer.name) + "\n                            ")]) : (props.column.field == 'coverage') ? _c('div', [_c('project-tooltip', {
          attrs: {
            "project": props.row
          }
        }), _vm._v("\n                                " + _vm._s(_vm._f("currency")(props.row.coverage)) + "\n                            ")], 1) : (props.column.field == 'invoices_total') ? _c('div', [_vm._v("\n                                " + _vm._s(_vm._f("currency")(props.row.invoices_total)) + "\n                            ")]) : (props.column.field == 'coverage_per_hour') ? _c('div', {
          staticClass: "coverage-cell"
        }, [_vm._v("\n                                " + _vm._s(_vm._f("currency")(props.row.coverage_per_hour)) + " \n                                "), (props.row.coverage_per_hour !== null) ? _c('div', {
          staticClass: "coverage-indicator",
          class: {
            'bad': props.row.coverage_per_hour < _vm.$store.state.config.companyMeta.settings.coverage_per_hour.medium.value, 'avg': _vm.$options.filters.rounded(props.row.coverage_per_hour) >= _vm.$store.state.config.companyMeta.settings.coverage_per_hour.medium.value, 'good': _vm.$options.filters.rounded(props.row.coverage_per_hour) >= _vm.$store.state.config.companyMeta.settings.coverage_per_hour.high.value
          }
        }) : _vm._e()]) : (props.column.field == 'external_created_at') ? _c('div', [_vm._v("\n                                " + _vm._s(_vm._f("moment")(props.row.external_created_at, "DD. MMM YYYY")) + "\n                            ")]) : (props.column.field == 'type.name') ? _c('div', {
          staticClass: "table-column__description",
          attrs: {
            "title": props.row.type ? props.row.type.name : '-'
          }
        }, [_vm._v("\n                                " + _vm._s(props.row.type ? props.row.type.name : '-') + "\n                            ")]) : _c('div', {
          attrs: {
            "title": props.formattedRow[props.column.field]
          }
        }, [_vm._v("\n                                " + _vm._s(props.formattedRow[props.column.field]) + "\n                            ")])]
      }
    }], null, false, 3696209278)
  }, [_c('div', {
    attrs: {
      "slot": "emptystate"
    },
    slot: "emptystate"
  }, [_vm._v("\n                            Ingen data ...\n                        ")])]) : _c('box-loading', {
    attrs: {
      "height": "350"
    }
  })], 1)])])])])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-a19a875a", module.exports)
  }
}

/***/ }),
/* 874 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.$auth.user().company.api_provider.slug === 'minuba') ? _c('div', {
    staticClass: "placeholder padding mb-4"
  }, [_c('b', [_vm._v("\n            Hvordan skal værdien af værdikæden beregnes?\n             \n            "), _c('d-tooltip', {
    attrs: {
      "placement": "inline",
      "identifier": 'settings.budget_calc'
    }
  })], 1), _vm._v(" "), _c('br'), _c('br'), _vm._v(" "), _c('label', {
    staticClass: "mr-4"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.budgetCalc),
      expression: "budgetCalc"
    }],
    attrs: {
      "type": "radio",
      "name": "budget-calculation",
      "value": "calculation"
    },
    domProps: {
      "checked": _vm._q(_vm.budgetCalc, "calculation")
    },
    on: {
      "change": [function($event) {
        _vm.budgetCalc = "calculation"
      }, function($event) {
        return _vm.selectBudgetCalc('calculation')
      }]
    }
  }), _vm._v("\n            Kalkulation\n        ")]), _vm._v(" "), _c('label', {
    staticClass: "mr-4"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.budgetCalc),
      expression: "budgetCalc"
    }],
    attrs: {
      "type": "radio",
      "name": "budget-calculation",
      "value": "budget"
    },
    domProps: {
      "checked": _vm._q(_vm.budgetCalc, "budget")
    },
    on: {
      "change": [function($event) {
        _vm.budgetCalc = "budget"
      }, function($event) {
        return _vm.selectBudgetCalc('budget')
      }]
    }
  }), _vm._v("\n            Budget\n        ")]), _vm._v(" "), _c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.budgetCalc),
      expression: "budgetCalc"
    }],
    attrs: {
      "type": "radio",
      "name": "budget-calculation",
      "value": "both"
    },
    domProps: {
      "checked": _vm._q(_vm.budgetCalc, "both")
    },
    on: {
      "change": [function($event) {
        _vm.budgetCalc = "both"
      }, function($event) {
        return _vm.selectBudgetCalc('both')
      }]
    }
  }), _vm._v("\n            Budget + kalkulation\n        ")])]) : _vm._e()])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-a59a59b2", module.exports)
  }
}

/***/ }),
/* 875 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "employee-skills-single-projects"
  }, [_c('div', {
    staticClass: "placeholder"
  }, [_c('div', {
    staticClass: "placeholder__heading"
  }, [_vm._v("\n            " + _vm._s(_vm.data.name) + "\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "placeholder"
  }, [_c('vue-good-table', {
    attrs: {
      "columns": _vm.columns,
      "rows": _vm.data.projects,
      "search-options": _vm.searchOptions,
      "pagination-options": _vm.paginationOptions,
      "sort-options": _vm.sortOptions,
      "styleClass": _vm.styleClass
    },
    scopedSlots: _vm._u([{
      key: "table-row",
      fn: function(props) {
        return [(props.column.field == 'coverage_percent') ? _c('div', {
          staticClass: "coverage-cell"
        }, [_vm._v("\n                        " + _vm._s(_vm._f("rounded")(props.row.coverage_percent)) + " \n                        "), (props.row.coverage_percent !== null) ? _c('div', {
          staticClass: "coverage-indicator",
          class: {
            'bad': props.row.coverage_percent < _vm.$store.state.config.companyMeta.settings.coverage_percent.medium.value, 'avg': _vm.$options.filters.rounded(props.row.coverage_percent) >= _vm.$store.state.config.companyMeta.settings.coverage_percent.medium.value, 'good': _vm.$options.filters.rounded(props.row.coverage_percent) >= _vm.$store.state.config.companyMeta.settings.coverage_percent.high.value
          }
        }) : _vm._e()]) : (props.column.field == 'case_number') ? _c('div', {
          staticClass: "table-column__ordernumber",
          staticStyle: {
            "text-align": "left"
          }
        }, [_vm._v("\n                        " + _vm._s(props.row.case_number) + "\n                    ")]) : (props.column.field == 'description') ? _c('div', {
          staticClass: "table-column__description"
        }, [_vm._v("\n                        " + _vm._s(props.row.description) + "\n                    ")]) : (props.column.field == 'customer.name') ? _c('div', {
          staticClass: "table-column__customer"
        }, [(props.row.customer) ? _c('span', [_vm._v("\n                            " + _vm._s(props.row.customer.name) + "\n                        ")]) : _c('span', [_vm._v(" - ")])]) : (props.column.field == 'invoices_total') ? _c('div', [_vm._v("\n                        " + _vm._s(_vm._f("currency")(props.row.invoices_total)) + "\n                    ")]) : (props.column.field == 'coverage') ? _c('div', [_vm._v("\n                        " + _vm._s(_vm._f("currency")(props.row.coverage)) + "\n                    ")]) : (props.column.field == 'coverage_per_hour') ? _c('div', {
          staticClass: "coverage-cell"
        }, [_vm._v("\n                        " + _vm._s(_vm._f("currency")(props.row.coverage_per_hour)) + " \n                        "), (props.row.coverage_per_hour !== null) ? _c('div', {
          staticClass: "coverage-indicator",
          class: {
            'bad': props.row.coverage_per_hour < _vm.$store.state.config.companyMeta.settings.coverage_per_hour.medium.value, 'avg': _vm.$options.filters.rounded(props.row.coverage_per_hour) >= _vm.$store.state.config.companyMeta.settings.coverage_per_hour.medium.value, 'good': _vm.$options.filters.rounded(props.row.coverage_per_hour) >= _vm.$store.state.config.companyMeta.settings.coverage_per_hour.high.value
          }
        }) : _vm._e()]) : (props.column.field == 'action') ? _c('div', {
          staticClass: "g-table__action",
          on: {
            "click": function($event) {
              return _vm.openExternalLink(props.row.external_id)
            }
          }
        }, [_c('i', {
          staticClass: "fad fa-eye"
        })]) : (props.column.field == 'start_date') ? _c('div', [_vm._v("\n                        " + _vm._s(_vm._f("moment")(props.row.start_date, "DD. MMM YYYY")) + "\n                    ")]) : (props.column.field == 'minuba_external_id') ? _c('div', [_c('a', {
          staticClass: "minuba-link",
          attrs: {
            "href": 'https://app.minuba.dk/?op=casedetails&glist=' + props.row.minuba_external_id,
            "target": "_blank"
          }
        }, [_c('i', {
          staticClass: "fas fa-eye"
        })])]) : _c('div', [_vm._v("\n                        " + _vm._s(props.formattedRow[props.column.field]) + "\n                    ")])]
      }
    }])
  }, [_c('div', {
    attrs: {
      "slot": "emptystate"
    },
    slot: "emptystate"
  }, [_vm._v("\n                    Ingen data ...\n                ")])])], 1)])])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-a7100ece", module.exports)
  }
}

/***/ }),
/* 876 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "economy"
  }, [_c('box-helper', {
    attrs: {
      "headline": "Kunder",
      "identifier": "customers"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "container section"
  }, [_c('title-block', {
    staticClass: "mb-xl",
    attrs: {
      "headline": "<b>Kunder</b>",
      "position": "center"
    }
  }, [_c('p', {
    attrs: {
      "slot": "text"
    },
    slot: "text"
  }, [_vm._v("\n                Ét samlet overblik over dine kunder\n            ")])]), _vm._v(" "), _c('router-view')], 1)], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-a790bfd4", module.exports)
  }
}

/***/ }),
/* 877 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_vm._v("\n\n    Her kan du angive om du ønsker at skjule en eller flere igangværende opgaver.\n    "), _c('br'), _c('br'), _vm._v(" "), _c('i', [_vm._v("Bemærk, at ændringen udelukkende træder i kraft på igangværende opgaver, ikke på afsluttede, bogførte mv.")]), _vm._v(" "), _c('br'), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "placeholder"
  }, [_c('div', {
    staticClass: "placeholder__heading"
  }, [_vm._v("\n            Igangværende opgaver (" + _vm._s(_vm.rows.length > 0 ? _vm.rows.length : '') + ")\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "placeholder"
  }, [(!_vm.loading) ? _c('vue-good-table', {
    attrs: {
      "columns": _vm.columns,
      "rows": _vm.rows,
      "searchOptions": _vm.searchOptions,
      "paginationOptions": _vm.paginationOptions,
      "sortOptions": _vm.sortOptions,
      "styleClass": "vgt-table"
    },
    scopedSlots: _vm._u([{
      key: "table-row",
      fn: function(props) {
        return [(props.column.field == 'description') ? _c('div', {
          staticClass: "table-column__description",
          attrs: {
            "title": props.row.description
          }
        }, [_vm._v("\n                        " + _vm._s(props.row.description) + "\n                    ")]) : (props.column.field == 'customer.name') ? _c('div', {
          staticClass: "table-column__customer",
          attrs: {
            "title": props.row.customer ? props.row.customer.name : '-'
          }
        }, [_vm._v("\n                        " + _vm._s(props.row.customer ? props.row.customer.name : '-') + "\n                    ")]) : (props.column.field == 'start_date') ? _c('div', [_vm._v("\n                        " + _vm._s(_vm._f("moment")(props.row.start_date, "DD. MMM YYYY")) + "\n                    ")]) : (props.column.field == 'status.name') ? _c('div', {
          staticClass: "coverage-cell"
        }, [_vm._v("\n                        " + _vm._s(props.row.status.name) + "\n                        "), _c('div', {
          staticClass: "coverage-indicator status",
          style: ('background:#' + props.row.status.color + ';')
        })]) : (props.column.field == 'show') ? _c('div', [(props.row.show) ? _c('div', {
          staticClass: "coverage-indicator"
        }, [_c('div', {
          staticClass: "coverage-indicator good"
        }), _vm._v("\n                            Synlig\n                        ")]) : _c('div', {
          staticClass: "coverage-indicator"
        }, [_c('div', {
          staticClass: "coverage-indicator bad"
        }), _vm._v("\n                            Ikke synlig\n                        ")])]) : (props.column.field == 'action') ? _c('div', [(props.row.show) ? _c('div', [_c('button', {
          on: {
            "click": function($event) {
              return _vm.updateProject(props.row, false)
            }
          }
        }, [_vm._v("\n                                Skjul\n                            ")])]) : _c('div', [_c('button', {
          on: {
            "click": function($event) {
              return _vm.updateProject(props.row, true)
            }
          }
        }, [_vm._v("\n                                Gør synlig\n                            ")])])]) : (props.column.field == 'minuba_external_id') ? _c('div', [_c('a', {
          staticClass: "minuba-link",
          attrs: {
            "href": 'https://app.minuba.dk/?op=casedetails&glist=' + props.row.minuba_external_id,
            "target": "_blank"
          }
        }, [_c('i', {
          staticClass: "fas fa-eye"
        })])]) : _c('div', {
          attrs: {
            "title": props.formattedRow[props.column.field]
          }
        }, [_vm._v("\n                        " + _vm._s(props.formattedRow[props.column.field]) + "\n                    ")])]
      }
    }], null, false, 3815420189)
  }, [_c('div', {
    attrs: {
      "slot": "emptystate"
    },
    slot: "emptystate"
  }, [_vm._v("\n                    Ingen data ...\n                ")])]) : _c('box-loading', {
    attrs: {
      "height": "350"
    }
  })], 1)])])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-ad10ac3c", module.exports)
  }
}

/***/ }),
/* 878 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box-helper-wrapper"
  }, [_c('div', {
    staticClass: "box-helper-button",
    on: {
      "click": function($event) {
        return _vm.showHelper()
      }
    }
  }, [_vm._m(0)]), _vm._v(" "), (_vm.show) ? _c('div', {
    staticClass: "box-helper",
    on: {
      "click": function($event) {
        return _vm.hideHelper()
      }
    }
  }, [_c('div', {
    staticClass: "content"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "html",
    domProps: {
      "innerHTML": _vm._s(_vm.content)
    }
  })])]) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "button"
  }, [_c('i', {
    staticClass: "fas fa-question fa-fw"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "close"
  }, [_c('i', {
    staticClass: "fas fa-times fa-fw"
  })])
}]}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-b2eeed00", module.exports)
  }
}

/***/ }),
/* 879 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "g-table-wrapper"
  }, [_c('div', {
    staticClass: "table-title"
  }, [_c('d-tooltip', {
    attrs: {
      "placement": "left",
      "identifier": "projects.claims"
    }
  }), _vm._v("\n        Igangværende reklamationer\n    ")], 1), _vm._v(" "), (!_vm.loading) ? _c('vue-good-table', {
    attrs: {
      "columns": _vm.columns,
      "rows": _vm.rows,
      "search-options": _vm.searchOptions,
      "pagination-options": _vm.paginationOptions,
      "sort-options": _vm.sortOptions,
      "styleClass": _vm.styleClass
    },
    scopedSlots: _vm._u([{
      key: "table-row",
      fn: function(props) {
        return [(props.column.field == 'coverage_percent') ? _c('div', {
          staticClass: "coverage-cell"
        }, [_vm._v("\n                " + _vm._s(_vm._f("rounded")(props.row.coverage_percent)) + " \n                "), (props.row.coverage_percent !== null) ? _c('div', {
          staticClass: "coverage-indicator",
          class: {
            'bad': props.row.coverage_percent < _vm.$store.state.config.companyMeta.settings.coverage_percent.medium.value, 'avg': _vm.$options.filters.rounded(props.row.coverage_percent) >= _vm.$store.state.config.companyMeta.settings.coverage_percent.medium.value, 'good': _vm.$options.filters.rounded(props.row.coverage_percent) >= _vm.$store.state.config.companyMeta.settings.coverage_percent.high.value
          }
        }) : _vm._e()]) : (props.column.field == 'status.name') ? _c('div', {
          staticClass: "coverage-cell"
        }, [_vm._v("\n                " + _vm._s(props.row.status.name) + "\n                "), _c('div', {
          staticClass: "coverage-indicator status",
          style: ('background:#' + props.row.status.color + ';')
        })]) : (props.column.field == 'case_number') ? _c('div', {
          staticClass: "table-column__ordernumber",
          staticStyle: {
            "text-align": "left"
          }
        }, [_vm._v("\n                " + _vm._s(props.row.case_number) + "\n            ")]) : (props.column.field == 'description') ? _c('div', {
          staticClass: "table-column__description",
          attrs: {
            "title": props.row.description
          }
        }, [(props.row.calculation_price > 0) ? _c('budget-tooltip', {
          attrs: {
            "project": props.row
          }
        }) : _vm._e(), _vm._v("\n                " + _vm._s(props.row.description ? props.row.description : '-') + "\n            ")], 1) : (props.column.field == 'customer.name') ? _c('div', {
          staticClass: "table-column__customer",
          attrs: {
            "title": props.row.customer ? props.row.customer.name : '-'
          }
        }, [_vm._v("\n                " + _vm._s(props.row.customer ? props.row.customer.name : '-') + "\n            ")]) : (props.column.field == 'action') ? _c('div', {
          staticClass: "g-table__action",
          on: {
            "click": function($event) {
              return _vm.openExternalLink(props.row.external_id)
            }
          }
        }, [_c('i', {
          staticClass: "fad fa-eye"
        })]) : (props.column.field == 'start_date') ? _c('div', [_vm._v("\n                " + _vm._s(_vm._f("moment")(props.row.start_date, "DD. MMM YYYY")) + "\n            ")]) : (props.column.field == 'type.name') ? _c('div', {
          staticClass: "table-column__description",
          attrs: {
            "title": props.row.type ? props.row.type.name : '-'
          }
        }, [_vm._v("\n                " + _vm._s(props.row.type ? props.row.type.name : '-') + "\n            ")]) : (props.column.field == 'minuba_external_id') ? _c('div', [_c('a', {
          staticClass: "minuba-link",
          attrs: {
            "href": 'https://app.minuba.dk/?op=casedetails&glist=' + props.row.minuba_external_id,
            "target": "_blank"
          }
        }, [_c('i', {
          staticClass: "fas fa-eye"
        })])]) : _c('div', {
          attrs: {
            "title": props.formattedRow[props.column.field]
          }
        }, [_vm._v("\n                " + _vm._s(props.formattedRow[props.column.field]) + "\n            ")])]
      }
    }], null, false, 1613006212)
  }, [_c('div', {
    attrs: {
      "slot": "emptystate"
    },
    slot: "emptystate"
  }, [_vm._v("\n            Ingen data ...\n        ")])]) : _c('box-loading', {
    attrs: {
      "height": "350"
    }
  })], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-c22142be", module.exports)
  }
}

/***/ }),
/* 880 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "customer-revenue-single"
  }, [(!_vm.loading) ? _c('div', {
    staticClass: "placeholder"
  }, [_c('div', {
    staticClass: "placeholder__heading"
  }, [_vm._v("\n            " + _vm._s(_vm.data.name) + "\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "placeholder"
  }, [(!_vm.loading) ? _c('vue-good-table', {
    attrs: {
      "columns": _vm.columns,
      "rows": _vm.data.customers,
      "search-options": _vm.searchOptions,
      "pagination-options": _vm.paginationOptions,
      "sort-options": _vm.sortOptions,
      "styleClass": _vm.styleClass
    },
    scopedSlots: _vm._u([{
      key: "table-row",
      fn: function(props) {
        return [(props.column.field == 'coverage_percent') ? _c('div', {
          staticClass: "coverage-cell"
        }, [_vm._v("\n                        " + _vm._s(_vm._f("rounded")(props.row.coverage_percent)) + " \n                        "), (props.row.coverage_percent !== null) ? _c('div', {
          staticClass: "coverage-indicator",
          class: {
            'bad': props.row.coverage_percent < _vm.$store.state.config.companyMeta.settings.coverage_percent.medium.value, 'avg': _vm.$options.filters.rounded(props.row.coverage_percent) >= _vm.$store.state.config.companyMeta.settings.coverage_percent.medium.value, 'good': _vm.$options.filters.rounded(props.row.coverage_percent) >= _vm.$store.state.config.companyMeta.settings.coverage_percent.high.value
          }
        }) : _vm._e()]) : (props.column.field == 'description') ? _c('div', {
          staticClass: "table-column__description",
          attrs: {
            "title": props.row.description
          }
        }, [_vm._v("\n                        " + _vm._s(props.row.description) + "\n                    ")]) : (props.column.field == 'coverage') ? _c('div', [_vm._v("\n                        " + _vm._s(_vm._f("currency")(props.row.coverage)) + "\n                    ")]) : (props.column.field == 'invoices_total') ? _c('div', {
          staticStyle: {
            "text-align": "left"
          }
        }, [_vm._v("\n                        " + _vm._s(_vm._f("currency")(props.row.invoices_total)) + "\n                    ")]) : (props.column.field == 'coverage_per_hour') ? _c('div', {
          staticClass: "coverage-cell"
        }, [_vm._v("\n                        " + _vm._s(_vm._f("currency")(props.row.coverage_per_hour)) + " \n                        "), (props.row.coverage_per_hour !== null) ? _c('div', {
          staticClass: "coverage-indicator",
          class: {
            'bad': props.row.coverage_per_hour < _vm.$store.state.config.companyMeta.settings.coverage_per_hour.medium.value, 'avg': _vm.$options.filters.rounded(props.row.coverage_per_hour) >= _vm.$store.state.config.companyMeta.settings.coverage_per_hour.medium.value, 'good': _vm.$options.filters.rounded(props.row.coverage_per_hour) >= _vm.$store.state.config.companyMeta.settings.coverage_per_hour.high.value
          }
        }) : _vm._e()]) : _c('div', {
          attrs: {
            "title": props.formattedRow[props.column.field]
          }
        }, [_vm._v("\n                        " + _vm._s(props.formattedRow[props.column.field]) + "\n                    ")])]
      }
    }], null, false, 214242423)
  }, [_c('div', {
    attrs: {
      "slot": "emptystate"
    },
    slot: "emptystate"
  }, [_vm._v("\n                    Ingen data ...\n                ")])]) : _vm._e()], 1)]) : _c('box-loading', {
    attrs: {
      "height": "350"
    }
  })], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-c77d3ad0", module.exports)
  }
}

/***/ }),
/* 881 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "g-table-wrapper"
  }, [_c('div', {
    staticClass: "table-title"
  }, [_c('d-tooltip', {
    attrs: {
      "placement": "left",
      "identifier": "projects.snoozedProjects"
    }
  }), _vm._v("\n        Opgaver uden bevægelse de sidste " + _vm._s(_vm.$store.state.config.companyMeta.settings.snoozed_days) + " dage\n    ")], 1), _vm._v(" "), (!_vm.loading) ? _c('vue-good-table', {
    attrs: {
      "columns": _vm.columns,
      "rows": _vm.rows,
      "search-options": _vm.searchOptions,
      "pagination-options": _vm.paginationOptions,
      "sort-options": _vm.sortOptions,
      "styleClass": _vm.styleClass
    },
    scopedSlots: _vm._u([{
      key: "table-row",
      fn: function(props) {
        return [(props.column.field == 'coverage_percent') ? _c('div', {
          staticClass: "coverage-cell"
        }, [_vm._v("\n                " + _vm._s(_vm._f("rounded")(props.row.coverage_percent)) + " \n                "), (props.row.coverage_percent !== null) ? _c('div', {
          staticClass: "coverage-indicator",
          class: {
            'bad': props.row.coverage_percent < _vm.$store.state.config.companyMeta.settings.coverage_percent.medium.value, 'avg': _vm.$options.filters.rounded(props.row.coverage_percent) >= _vm.$store.state.config.companyMeta.settings.coverage_percent.medium.value, 'good': _vm.$options.filters.rounded(props.row.coverage_percent) >= _vm.$store.state.config.companyMeta.settings.coverage_percent.high.value
          }
        }) : _vm._e()]) : (props.column.field == 'status.name') ? _c('div', {
          staticClass: "coverage-cell"
        }, [_vm._v("\n                " + _vm._s(props.row.status.name) + "\n                "), _c('div', {
          staticClass: "coverage-indicator status",
          style: ('background:#' + props.row.status.color + ';')
        })]) : (props.column.field == 'case_number') ? _c('div', {
          staticClass: "table-column__ordernumber",
          staticStyle: {
            "text-align": "left"
          }
        }, [_vm._v("\n                " + _vm._s(props.row.case_number) + "\n            ")]) : (props.column.field == 'description') ? _c('div', {
          staticClass: "table-column__description",
          attrs: {
            "title": props.row.description
          }
        }, [(props.row.calculation_price > 0) ? _c('budget-tooltip', {
          attrs: {
            "project": props.row
          }
        }) : _vm._e(), _vm._v("\n                " + _vm._s(props.row.description ? props.row.description : '-') + "\n            ")], 1) : (props.column.field == 'customer.name') ? _c('div', {
          staticClass: "table-column__customer",
          attrs: {
            "title": props.row.customer ? props.row.customer.name : '-'
          }
        }, [_vm._v("\n                " + _vm._s(props.row.customer ? props.row.customer.name : '-') + "\n            ")]) : (props.column.field == 'action') ? _c('div', {
          staticClass: "g-table__action",
          on: {
            "click": function($event) {
              return _vm.openExternalLink(props.row.external_id)
            }
          }
        }, [_c('i', {
          staticClass: "fad fa-eye"
        })]) : (props.column.field == 'start_date') ? _c('div', [_vm._v("\n                " + _vm._s(_vm._f("moment")(props.row.start_date, "DD. MMM YYYY")) + "\n            ")]) : (props.column.field == 'type.name') ? _c('div', {
          staticClass: "table-column__description",
          attrs: {
            "title": props.row.type ? props.row.type.name : '-'
          }
        }, [_vm._v("\n                " + _vm._s(props.row.type ? props.row.type.name : '-') + "\n            ")]) : (props.column.field == 'minuba_external_id') ? _c('div', [_c('a', {
          staticClass: "minuba-link",
          attrs: {
            "href": 'https://app.minuba.dk/?op=casedetails&glist=' + props.row.minuba_external_id,
            "target": "_blank"
          }
        }, [_c('i', {
          staticClass: "fas fa-eye"
        })])]) : _c('div', {
          attrs: {
            "title": props.formattedRow[props.column.field]
          }
        }, [_vm._v("\n                " + _vm._s(props.formattedRow[props.column.field]) + "\n            ")])]
      }
    }], null, false, 1613006212)
  }, [_c('div', {
    attrs: {
      "slot": "emptystate"
    },
    slot: "emptystate"
  }, [_vm._v("\n            Ingen data ...\n        ")])]) : _c('box-loading', {
    attrs: {
      "height": "350"
    }
  })], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-c8f5e578", module.exports)
  }
}

/***/ }),
/* 882 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box-loading",
    style: ('height:' + _vm.height + 'px;')
  }, [_c('div', {
    staticClass: "inner"
  }, [_c('svg', {
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 512 512"
    }
  }, [_c('path', {
    attrs: {
      "fill": "none",
      "stroke": "#000000",
      "stroke-width": "10",
      "d": "M507.42 114.49c-2.34-9.47-9.66-16.98-19.06-19.61-9.47-2.61-19.65 0-26.65 6.98l-63.87 63.87-44.25-7.36-7.38-44.24 63.87-63.87c6.94-6.92 9.62-17.09 7-26.54-2.62-9.47-10.19-16.83-19.75-19.2C345.6-8.31 291.95 6.54 254.14 44.3c-37.84 37.87-52.21 92.52-38.62 144.7L22.19 382.29c-29.59 29.63-29.59 77.83 0 107.45C36.54 504.09 55.63 512 75.94 512s39.37-7.91 53.71-22.26l193.14-193.11c52.03 13.73 106.8-.72 144.89-38.82 37.81-37.81 52.68-91.39 39.74-143.32zm-62.36 120.7c-31.87 31.81-78.43 42.63-121.77 28.23l-9.38-3.14-206.88 206.84c-16.62 16.62-45.59 16.62-62.21 0-17.12-17.14-17.12-45.06 0-62.21l207.01-206.98-3.09-9.34c-14.31-43.45-3.56-90.06 28.03-121.67C299.48 44.2 329.44 32 360.56 32c6.87 0 13.81.59 20.72 1.81l-69.31 69.35 13.81 83.02L408.84 200l69.3-69.35c6.72 38.25-5.34 76.79-33.08 104.54zM80 416c-8.84 0-16 7.16-16 16s7.16 16 16 16 16-7.16 16-16-7.16-16-16-16z"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "text"
  }, [_vm._v("\n            Indlæser ...\n        ")])])])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-c979e24c", module.exports)
  }
}

/***/ }),
/* 883 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "title-block",
    class: _vm.position + ' ' + _vm.customClass
  }, [_c('div', {
    staticClass: "title",
    domProps: {
      "innerHTML": _vm._s(_vm.headline)
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "divider"
  }), _vm._v(" "), _vm._t("text")], 2)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-cd5cc2c2", module.exports)
  }
}

/***/ }),
/* 884 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "economy-learning"
  }, [_c('content-switch', {
    attrs: {
      "items": _vm.switchItems,
      "selectedItem": _vm.selectedItem,
      "counts": _vm.counts
    },
    on: {
      "selectItem": function($event) {
        return _vm.handleSelectItem($event)
      }
    }
  }), _vm._v(" "), _c('revenue-and-costs', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.selectedItem === 'revenueAndCosts'),
      expression: "selectedItem === 'revenueAndCosts'"
    }]
  }), _vm._v(" "), _c('ebitda', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.selectedItem === 'ebitda'),
      expression: "selectedItem === 'ebitda'"
    }]
  }), _vm._v(" "), (_vm.selectedItem === 'compare') ? _c('compare') : _vm._e(), _vm._v(" "), _c('potential', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.selectedItem === 'potential'),
      expression: "selectedItem === 'potential'"
    }]
  }), _vm._v(" "), _c('keyFigures', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.selectedItem === 'keyFigures'),
      expression: "selectedItem === 'keyFigures'"
    }]
  }), _vm._v(" "), _c('materials', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.selectedItem === 'materials'),
      expression: "selectedItem === 'materials'"
    }]
  }), _vm._v(" "), _c('all-invoices', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.selectedItem === 'allInvoices'),
      expression: "selectedItem === 'allInvoices'"
    }],
    on: {
      "finishedLoading": function($event) {
        return _vm.updateCount('allInvoices', $event)
      }
    }
  })], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-d55ee438", module.exports)
  }
}

/***/ }),
/* 885 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "employees-sub-projects-single"
  }, [_c('div', {
    staticClass: "placeholder"
  }, [_c('div', {
    staticClass: "placeholder__heading"
  }, [_vm._v("\n            " + _vm._s(_vm.data.first_name) + " " + _vm._s(_vm.data.last_name) + "\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "placeholder"
  }, [_c('vue-good-table', {
    attrs: {
      "columns": _vm.columns,
      "rows": _vm.data.sub_projects,
      "search-options": _vm.searchOptions,
      "pagination-options": _vm.paginationOptions,
      "sort-options": _vm.sortOptions,
      "styleClass": _vm.styleClass
    },
    scopedSlots: _vm._u([{
      key: "table-row",
      fn: function(props) {
        return [(props.column.field == 'coverage_percent') ? _c('div', {
          staticClass: "coverage-cell"
        }, [_vm._v("\n                        " + _vm._s(_vm._f("rounded")(props.row.coverage_percent)) + " \n                        "), (props.row.coverage_percent !== null) ? _c('div', {
          staticClass: "coverage-indicator",
          class: {
            'bad': props.row.coverage_percent < _vm.$store.state.config.companyMeta.settings.coverage_percent.medium.value, 'avg': _vm.$options.filters.rounded(props.row.coverage_percent) >= _vm.$store.state.config.companyMeta.settings.coverage_percent.medium.value, 'good': _vm.$options.filters.rounded(props.row.coverage_percent) >= _vm.$store.state.config.companyMeta.settings.coverage_percent.high.value
          }
        }) : _vm._e()]) : (props.column.field == 'description') ? _c('div', {
          staticClass: "table-column__description",
          attrs: {
            "title": props.row.description
          }
        }, [_vm._v("\n                        " + _vm._s(props.row.description) + "\n                    ")]) : (props.column.field == 'coverage') ? _c('div', [_vm._v("\n                        " + _vm._s(_vm._f("currency")(props.row.coverage)) + "\n                    ")]) : (props.column.field == 'invoices_total') ? _c('div', {
          staticStyle: {
            "text-align": "left"
          }
        }, [_vm._v("\n                        " + _vm._s(_vm._f("currency")(props.row.invoices_total)) + "\n                    ")]) : (props.column.field == 'total_expenses') ? _c('div', {
          staticStyle: {
            "text-align": "left"
          }
        }, [_vm._v("\n                        " + _vm._s(_vm._f("currency")(props.row.total_expenses)) + "\n                    ")]) : (props.column.field == 'coverage_per_hour') ? _c('div', {
          staticClass: "coverage-cell"
        }, [_vm._v("\n                        " + _vm._s(_vm._f("currency")(props.row.coverage_per_hour)) + " \n                        "), (props.row.coverage_per_hour !== null) ? _c('div', {
          staticClass: "coverage-indicator",
          class: {
            'bad': props.row.coverage_per_hour < _vm.$store.state.config.companyMeta.settings.coverage_per_hour.medium.value, 'avg': _vm.$options.filters.rounded(props.row.coverage_per_hour) >= _vm.$store.state.config.companyMeta.settings.coverage_per_hour.medium.value, 'good': _vm.$options.filters.rounded(props.row.coverage_per_hour) >= _vm.$store.state.config.companyMeta.settings.coverage_per_hour.high.value
          }
        }) : _vm._e()]) : (props.column.field == 'name') ? _c('div', {
          staticClass: "table-column__description",
          attrs: {
            "title": props.row.name ? props.row.name : '-'
          }
        }, [_vm._v("\n                        " + _vm._s(props.row.name ? props.row.name : '-') + "\n                    ")]) : (props.column.field == 'budget') ? _c('div', [_vm._v("\n                        -\n                    ")]) : (props.column.field == 'efficiency') ? _c('div', [_vm._v("\n                        -\n                    ")]) : _c('div', {
          attrs: {
            "title": props.formattedRow[props.column.field]
          }
        }, [_vm._v("\n                        " + _vm._s(props.formattedRow[props.column.field]) + "\n                    ")])]
      }
    }])
  }, [_c('div', {
    attrs: {
      "slot": "emptystate"
    },
    slot: "emptystate"
  }, [_vm._v("\n                    Ingen data ...\n                ")])])], 1)])])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-d7a65a86", module.exports)
  }
}

/***/ }),
/* 886 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "login"
  }, [_c('div', {
    staticClass: "inner"
  }, [_vm._m(0), _vm._v(" "), (!_vm.showResetPasswordForm) ? _c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "header"
  }, [_vm._v("\n                Login\n            ")]), _vm._v(" "), _c('div', {
    staticClass: "input username"
  }, [_c('label', {
    attrs: {
      "for": "username"
    }
  }, [_vm._v("\n                    Brugernavn\n                ")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.username),
      expression: "username"
    }],
    attrs: {
      "type": "text",
      "name": "username",
      "placeholder": "Indtast brugernavn"
    },
    domProps: {
      "value": (_vm.username)
    },
    on: {
      "keydown": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.login()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.username = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "input password"
  }, [_c('label', {
    attrs: {
      "for": "password"
    }
  }, [_vm._v("\n                    Adgangskode\n                ")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.password),
      expression: "password"
    }],
    attrs: {
      "type": "password",
      "name": "password",
      "placeholder": "Indtast adgangskode"
    },
    domProps: {
      "value": (_vm.password)
    },
    on: {
      "keydown": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.login()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.password = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "meta"
  }, [_c('div', {
    staticClass: "remember-me"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.rememberMe),
      expression: "rememberMe"
    }],
    attrs: {
      "type": "checkbox",
      "name": "remember",
      "id": "remember"
    },
    domProps: {
      "checked": Array.isArray(_vm.rememberMe) ? _vm._i(_vm.rememberMe, null) > -1 : (_vm.rememberMe)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.rememberMe,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.rememberMe = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.rememberMe = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.rememberMe = $$c
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "remember"
    }
  }, [_vm._v("\n                        Husk mig\n                    ")])]), _vm._v(" "), _c('div', {
    staticClass: "forgot-password"
  }, [_c('a', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        return _vm.toggleResetPasswordForm()
      }
    }
  }, [_vm._v("\n                        Glemt adgangskode?\n                    ")])])]), _vm._v(" "), _c('div', {
    staticClass: "button",
    on: {
      "click": function($event) {
        return _vm.login()
      }
    }
  }, [_vm._v("\n                Log ind\n            ")])]) : _c('div', {
    staticClass: "box"
  }, [(!_vm.passwordResetted) ? _c('div', [_c('div', {
    staticClass: "header"
  }, [_vm._v("\n                    Glemt adgangskode\n                ")]), _vm._v(" "), _c('div', {
    staticClass: "input username"
  }, [_c('label', {
    attrs: {
      "for": "username"
    }
  }, [_vm._v("\n                        E-mail\n                    ")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.username),
      expression: "username"
    }],
    attrs: {
      "type": "text",
      "name": "email",
      "placeholder": "Indtast e-mail"
    },
    domProps: {
      "value": (_vm.username)
    },
    on: {
      "keydown": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.doReset()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.username = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "button",
    on: {
      "click": function($event) {
        return _vm.doReset()
      }
    }
  }, [_vm._v("\n                    Nulstil adgangskode\n                ")])]) : _c('div', [_vm._v("\n                Vi har nu nulstillet din adgangskode. Du bør have modtaget en e-mail med en midlertidig adgangskode. Når du logger ind næste gang, anbefaler vi, at du ændrer din kode til noget du selv kan huske.\n            ")])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "logo"
  }, [_c('img', {
    attrs: {
      "src": "/static/img/proebitda_logo.png"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "slogan"
  }, [_vm._v("\n                - Garanterede resultater\n            ")])])
}]}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-d8e10d84", module.exports)
  }
}

/***/ }),
/* 887 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "register-card"
  }, [_c('div', {
    staticClass: "wrapper"
  }, [_c('h3', [_vm._v("Registrer bruger")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('form', {
    attrs: {
      "action": "/#",
      "method": "/post"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.register()
      }
    }
  }, [_c('label', {
    attrs: {
      "for": "username"
    }
  }, [_vm._v("\n                Brugernavn:\n            ")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.username),
      expression: "username"
    }],
    attrs: {
      "type": "text",
      "name": "username",
      "placeholder": "Brugernavn"
    },
    domProps: {
      "value": (_vm.username)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.username = $event.target.value
      }
    }
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('label', {
    attrs: {
      "for": "password"
    }
  }, [_vm._v("\n                Password:\n            ")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.password),
      expression: "password"
    }],
    attrs: {
      "type": "password",
      "name": "password",
      "placeholder": "Password"
    },
    domProps: {
      "value": (_vm.password)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.password = $event.target.value
      }
    }
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "remember"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.rememberMe),
      expression: "rememberMe"
    }],
    attrs: {
      "type": "checkbox",
      "name": "remember"
    },
    domProps: {
      "checked": Array.isArray(_vm.rememberMe) ? _vm._i(_vm.rememberMe, null) > -1 : (_vm.rememberMe)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.rememberMe,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.rememberMe = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.rememberMe = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.rememberMe = $$c
        }
      }
    }
  }), _vm._v(" Husk mig\n            ")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('button', {
    attrs: {
      "type": "submit"
    }
  }, [_vm._v("\n                Registrer\n            ")])])])])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-d921176c", module.exports)
  }
}

/***/ }),
/* 888 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "change-company"
  }, [_c('div', {
    staticClass: "container section"
  }, [_c('div', {
    staticClass: "row"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "col-lg-8"
  }, _vm._l((_vm.companies), function(company) {
    return (_vm.companies && !_vm.loading) ? _c('div', {
      key: company.uuid,
      staticClass: "company"
    }, [_c('div', {
      staticClass: "name"
    }, [_vm._v("\n                        " + _vm._s(company.name) + "\n                        "), _c('br'), _vm._v(" "), (company.api_provider.name === 'Ordrestyring') ? _c('span', {
      staticStyle: {
        "background": "#339861",
        "color": "#fff",
        "font-size": "12px",
        "padding": "2px 6px",
        "margin-top": "4px",
        "display": "inline-block",
        "border-radius": "3px"
      }
    }, [_vm._v("\n                            " + _vm._s(company.api_provider.name) + "\n                        ")]) : _c('span', {
      staticStyle: {
        "background": "#852240",
        "color": "#fff",
        "font-size": "12px",
        "padding": "2px 6px",
        "margin-top": "4px",
        "display": "inline-block",
        "border-radius": "3px"
      }
    }, [_vm._v("\n                            " + _vm._s(company.api_provider.name) + "\n                        ")])]), _vm._v(" "), _c('div', {
      staticClass: "action",
      on: {
        "click": function($event) {
          return _vm.changeCompany(company)
        }
      }
    }, [_vm._v("\n                        Skift til denne virksomhed\n                        "), _c('i', {
      staticClass: "fas fa-arrow-right"
    })])]) : _c('box-loading', {
      attrs: {
        "height": "350"
      }
    })
  }), 0)])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-lg-4"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("\n                    Skift virksomhed\n                ")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('p', [_vm._v("\n                    Som super admin kan du her ændre hvilken virksomhed du ønsker at se data for. Når du vælger en virksomhed, vil applikation opdatere og du ser nu de samme data, som virksomhedens egne brugere ser det.\n                ")])])
}]}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-db2305ca", module.exports)
  }
}

/***/ }),
/* 889 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "placeholder"
  }, [_c('div', {
    staticClass: "placeholder__heading"
  }, [_c('d-tooltip', {
    attrs: {
      "placement": "left",
      "identifier": "oekonomi.kostprisPrTime"
    }
  }), _vm._v("\n        Kostpris pr. time\n    ")], 1), _vm._v(" "), (_vm.data && !_vm.loading && _vm.data.accounts_total && _vm.data.total_hours) ? _c('div', {
    staticClass: "placeholder padding box"
  }, [_c('div', {
    staticClass: "large"
  }, [_vm._v("\n            " + _vm._s(_vm._f("currency")(_vm.data.costprice_per_hour)) + "\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "meta"
  }, [_vm._v("\n            Udregningen er baseret på de totale udgifter til svende divideret med antal timer brugt hos kunderne i perioden\n            "), _vm._v(" "), _c('div', {
    staticClass: "divider"
  }), _vm._v(" "), (_vm.showCalculations) ? _c('div', {
    staticClass: "accounts"
  }, [_vm._l((_vm.data.calculations), function(account) {
    return _c('div', {
      key: account.uuid,
      staticClass: "account"
    }, [_c('div', {
      staticClass: "name"
    }, [_vm._v("\n                        " + _vm._s(account.name) + "\n                    ")]), _vm._v(" "), _c('div', {
      staticClass: "value"
    }, [_vm._v("\n                        " + _vm._s(_vm._f("currency")(Math.abs(account.total_balance))) + "\n                    ")])])
  }), _vm._v(" "), _c('div', {
    staticClass: "account total"
  }, [_c('div', {
    staticClass: "name"
  }, [_vm._v("\n                        Total\n                    ")]), _vm._v(" "), _c('div', {
    staticClass: "value"
  }, [_vm._v("\n                        " + _vm._s(_vm._f("currency")(_vm.data.accounts_total)) + "\n                    ")])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "account total"
  }, [_c('div', {
    staticClass: "name"
  }, [_vm._v("\n                        Antal timer hos kunderne\n                    ")]), _vm._v(" "), _c('div', {
    staticClass: "value"
  }, [_vm._v("\n                        " + _vm._s(_vm._f("number")(_vm.data.total_hours)) + "\n                    ")])])], 2) : _vm._e()])]) : (!_vm.data && _vm.loading) ? _c('box-loading', {
    attrs: {
      "height": "350"
    }
  }) : _c('div', {
    staticClass: "placeholder padding"
  }, [_vm._v("\n        Vi kunne ikke udregne kostprisen. Tjek, at du har angivet hvilke medarbejdere og konti, der skal regnes med i denne udregning. Dette kan du ændre i indstillingerne\n    ")])], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-e1cbaa30", module.exports)
  }
}

/***/ }),
/* 890 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "economy-operations"
  }, [_c('content-switch', {
    attrs: {
      "items": _vm.switchItems,
      "selectedItem": _vm.selectedItem,
      "counts": _vm.counts
    },
    on: {
      "selectItem": function($event) {
        return _vm.handleSelectItem($event)
      }
    }
  }), _vm._v(" "), _c('noInvoiceProjects-table', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.selectedItem === 'noInvoiceProjects'),
      expression: "selectedItem === 'noInvoiceProjects'"
    }],
    on: {
      "finishedLoading": function($event) {
        return _vm.updateCount('noInvoiceProjects', $event)
      }
    }
  }), _vm._v(" "), _c('unpaidInvoices-table', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.selectedItem === 'unpaidInvoices'),
      expression: "selectedItem === 'unpaidInvoices'"
    }],
    on: {
      "finishedLoading": function($event) {
        return _vm.updateCount('unpaidInvoices', $event)
      }
    }
  }), _vm._v(" "), _c('exceeded-payments', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.selectedItem === 'exceededPayments'),
      expression: "selectedItem === 'exceededPayments'"
    }],
    on: {
      "finishedLoading": function($event) {
        return _vm.updateCount('exceededPayments', $event)
      }
    }
  }), _vm._v(" "), _c('all-invoices', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.selectedItem === 'allInvoices'),
      expression: "selectedItem === 'allInvoices'"
    }],
    on: {
      "finishedLoading": function($event) {
        return _vm.updateCount('allInvoices', $event)
      }
    }
  })], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-e9586f9c", module.exports)
  }
}

/***/ }),
/* 891 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "compare-coverage-per-hour"
  }, [_c('div', {
    staticClass: "placeholder"
  }, [_c('div', {
    staticClass: "placeholder__heading"
  }, [_vm._v("\n            DB pr. time\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "placeholder padding"
  }, [(!_vm.loading && _vm.series.length > 0) ? _c('vue-apex-charts', {
    ref: "tester",
    attrs: {
      "height": _vm.height,
      "options": _vm.options,
      "series": _vm.series,
      "type": "line"
    }
  }) : _c('box-loading', {
    attrs: {
      "height": "400"
    }
  })], 1)])])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-eabb0c92", module.exports)
  }
}

/***/ }),
/* 892 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "account-plan"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("\n        Kontoplan\n    ")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "cursor": "pointer",
      "margin-bottom": "15px"
    },
    attrs: {
      "align": "right"
    },
    on: {
      "click": function($event) {
        _vm.showEmptyAccounts = !_vm.showEmptyAccounts
      }
    }
  }, [(!_vm.showEmptyAccounts) ? _c('span', [_vm._v("Vis konti uden bevægelse")]) : _c('span', [_vm._v("Skjul konti uden bevægelse")])]), _vm._v(" "), (!_vm.loading && _vm.accounts && _vm.accountCategories) ? _c('div', {
    staticClass: "accounts"
  }, [_vm._m(0), _vm._v(" "), _vm._l((_vm.filteredAccounts), function(account) {
    return _c('div', {
      key: account.uuid,
      staticClass: "account"
    }, [_c('div', {
      staticClass: "number"
    }, [_vm._v("\n                " + _vm._s(account.account_number) + "\n            ")]), _vm._v(" "), _c('div', {
      staticClass: "name"
    }, [_vm._v("\n                " + _vm._s(account.name) + "\n            ")]), _vm._v(" "), _c('div', {
      staticClass: "value"
    }, [_vm._v("\n                " + _vm._s(_vm._f("currency")(account.balance)) + "\n            ")]), _vm._v(" "), _c('div', {
      staticClass: "category"
    }, [_c('select', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (account.category.uuid),
        expression: "account.category.uuid"
      }],
      on: {
        "change": [function($event) {
          var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
            return o.selected
          }).map(function(o) {
            var val = "_value" in o ? o._value : o.value;
            return val
          });
          _vm.$set(account.category, "uuid", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
        }, function($event) {
          return _vm.updateAccount(account, $event)
        }]
      }
    }, _vm._l((_vm.accountCategories), function(accountCategory) {
      return _c('option', {
        key: accountCategory.uuid,
        domProps: {
          "value": accountCategory.uuid
        }
      }, [_vm._v("\n                        " + _vm._s(accountCategory.name) + "\n                    ")])
    }), 0)]), _vm._v(" "), _c('div', {
      staticClass: "show"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (account.show),
        expression: "account.show"
      }],
      attrs: {
        "type": "checkbox"
      },
      domProps: {
        "checked": Array.isArray(account.show) ? _vm._i(account.show, null) > -1 : (account.show)
      },
      on: {
        "change": [function($event) {
          var $$a = account.show,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = null,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.$set(account, "show", $$a.concat([$$v])))
            } else {
              $$i > -1 && (_vm.$set(account, "show", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
            }
          } else {
            _vm.$set(account, "show", $$c)
          }
        }, function($event) {
          return _vm.toggleAccount(account)
        }]
      }
    }), _vm._v("\n                 \n                "), (!account.show) ? _c('span', [_vm._v("\n                    Skjult\n                ")]) : _vm._e()])])
  })], 2) : _c('box-loading', {
    attrs: {
      "height": "350"
    }
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "account bold"
  }, [_c('div', {
    staticClass: "number"
  }, [_vm._v("Konto")]), _vm._v(" "), _c('div', {
    staticClass: "name"
  }, [_vm._v("Navn")]), _vm._v(" "), _c('div', {
    staticClass: "value"
  }, [_vm._v("Bogført til dato")]), _vm._v(" "), _c('div', {
    staticClass: "category"
  }, [_vm._v("Hovedkonto")]), _vm._v(" "), _c('div', {
    staticClass: "show"
  }, [_vm._v("Vis/skjul")])])
}]}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-ed1d8338", module.exports)
  }
}

/***/ }),
/* 893 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "number-card",
    class: _vm.state,
    on: {
      "click": function($event) {
        return _vm.goTo()
      }
    }
  }, [(_vm.tooltipIdentifier) ? _c('div', {
    staticClass: "tooltip-bottom-right"
  }, [_c('d-tooltip', {
    attrs: {
      "placement": "inline",
      "identifier": _vm.tooltipIdentifier
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "icon"
  }, [_c('i', {
    class: 'fad fa-' + _vm.icon + ' fa-fw'
  })]), _vm._v(" "), _c('div', {
    staticClass: "number",
    class: 'colo__' + _vm.state
  }, [(_vm.number !== false) ? _c('count-to', {
    ref: "counter",
    attrs: {
      "startVal": 0,
      "endVal": Number(_vm.number),
      "duration": 5000,
      "autoplay": true,
      "separator": "."
    }
  }) : _c('span', {
    staticClass: "soon"
  }, [_vm._v("\n            Kommer snart\n        ")])], 1), _vm._v(" "), _c('div', {
    staticClass: "heading"
  }, [_vm._v("\n        " + _vm._s(_vm.heading) + "\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "description"
  }, [_vm._v("\n        " + _vm._s(_vm.description) + "\n    ")])])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-ee45503c", module.exports)
  }
}

/***/ }),
/* 894 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "g-table-wrapper"
  }, [_c('div', {
    staticClass: "table-title"
  }, [_c('d-tooltip', {
    attrs: {
      "placement": "left",
      "identifier": "oekonomi.allInvoices"
    }
  }), _vm._v("\n        Alle fakturaer og kreditnotaer\n    ")], 1), _vm._v(" "), (!_vm.loading) ? _c('vue-good-table', {
    attrs: {
      "columns": _vm.columns,
      "rows": _vm.rows,
      "search-options": _vm.searchOptions,
      "pagination-options": _vm.paginationOptions,
      "sort-options": _vm.sortOptions,
      "styleClass": _vm.styleClass
    },
    scopedSlots: _vm._u([{
      key: "table-row",
      fn: function(props) {
        return [(props.column.field == 'description') ? _c('div', {
          staticClass: "table-column__description",
          attrs: {
            "title": props.row.description
          }
        }, [_vm._v("\n                " + _vm._s(props.row.description) + "\n            ")]) : (props.column.field == 'invoice_number') ? _c('div', {
          staticStyle: {
            "text-align": "left"
          }
        }, [_vm._v("\n                " + _vm._s(props.row.invoice_number ? props.row.invoice_number : '-') + "\n            ")]) : (props.column.field == 'external_id') ? _c('div', {
          staticClass: "table-column__external-id"
        }, [_vm._v("\n                " + _vm._s(props.row.external_id) + "\n            ")]) : (props.column.field == 'due_at') ? _c('div', [_vm._v("\n                " + _vm._s(_vm._f("moment")(props.row.due_at, "DD. MMM YYYY")) + "\n            ")]) : (props.column.field == 'amount') ? _c('div', {
          staticStyle: {
            "text-align": "left"
          }
        }, [_vm._v("\n                " + _vm._s(_vm._f("currency")(props.row.amount)) + "\n            ")]) : (props.column.field == 'paid') ? _c('div', {
          staticStyle: {
            "text-align": "left"
          }
        }, [(props.row.paid) ? _c('span', [_vm._v("\n                    Betalt\n                ")]) : _c('span', [_vm._v("\n                    Ikke betalt\n                ")])]) : (props.column.field == 'minuba_external_id') ? _c('div', [_c('a', {
          staticClass: "minuba-link",
          attrs: {
            "href": 'https://app.minuba.dk/?op=casedetails&glist=' + props.row.minuba_external_id,
            "target": "_blank"
          }
        }, [_c('i', {
          staticClass: "fas fa-eye"
        })])]) : _c('div', {
          attrs: {
            "title": props.formattedRow[props.column.field]
          }
        }, [_vm._v("\n                " + _vm._s(props.formattedRow[props.column.field]) + "\n            ")])]
      }
    }], null, false, 2812794680)
  }, [_c('div', {
    attrs: {
      "slot": "emptystate"
    },
    slot: "emptystate"
  }, [_vm._v("\n            Ingen data ...\n        ")])]) : _c('box-loading', {
    attrs: {
      "height": "350"
    }
  })], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-f1adc6ce", module.exports)
  }
}

/***/ }),
/* 895 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "sub-project-types"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    class: {
      'col-lg-6': !_vm.selectedRow, 'col-lg-3': _vm.selectedRow
    }
  }, [_c('div', {
    staticClass: "placeholder fit-content"
  }, [_c('div', {
    staticClass: "placeholder__heading"
  }, [_vm._v("\n                    Underentrepriser\n                ")]), _vm._v(" "), _c('div', {
    staticClass: "placeholder"
  }, [(!_vm.loading) ? _c('vue-good-table', {
    attrs: {
      "columns": _vm.columns,
      "rows": _vm.rows,
      "search-options": _vm.searchOptions,
      "pagination-options": _vm.paginationOptions,
      "sort-options": _vm.sortOptions,
      "styleClass": _vm.styleClass,
      "row-style-class": _vm.selectedRowClass
    },
    on: {
      "on-row-click": _vm.selectSubProjectType
    },
    scopedSlots: _vm._u([{
      key: "table-row",
      fn: function(props) {
        return [(props.column.field == 'coverage_percent') ? _c('div', {
          staticClass: "coverage-cell"
        }, [_vm._v("\n                                " + _vm._s(_vm._f("rounded")(props.row.coverage_percent)) + " \n                                "), (props.row.coverage_percent !== null) ? _c('div', {
          staticClass: "coverage-indicator",
          class: {
            'bad': props.row.coverage_percent < _vm.$store.state.config.companyMeta.settings.coverage_percent.medium.value, 'avg': _vm.$options.filters.rounded(props.row.coverage_percent) >= _vm.$store.state.config.companyMeta.settings.coverage_percent.medium.value, 'good': _vm.$options.filters.rounded(props.row.coverage_percent) >= _vm.$store.state.config.companyMeta.settings.coverage_percent.high.value
          }
        }) : _vm._e()]) : (props.column.field == 'name') ? _c('div', {
          staticClass: "table-column__description",
          attrs: {
            "title": props.row.name ? props.row.name : '-'
          }
        }, [_vm._v("\n                                " + _vm._s(props.row.name ? props.row.name : '-') + "\n                            ")]) : (props.column.field == 'coverage') ? _c('div', [_vm._v("\n                                " + _vm._s(_vm._f("currency")(props.row.coverage)) + "\n                            ")]) : (props.column.field == 'invoices_total') ? _c('div', [_vm._v("\n                                " + _vm._s(_vm._f("currency")(props.row.invoices_total)) + "\n                            ")]) : (props.column.field == 'coverage_per_hour') ? _c('div', {
          staticClass: "coverage-cell"
        }, [_vm._v("\n                                " + _vm._s(_vm._f("currency")(props.row.coverage_per_hour)) + " \n                                "), (props.row.coverage_per_hour !== null) ? _c('div', {
          staticClass: "coverage-indicator",
          class: {
            'bad': props.row.coverage_per_hour < _vm.$store.state.config.companyMeta.settings.coverage_per_hour.medium.value, 'avg': _vm.$options.filters.rounded(props.row.coverage_per_hour) >= _vm.$store.state.config.companyMeta.settings.coverage_per_hour.medium.value, 'good': _vm.$options.filters.rounded(props.row.coverage_per_hour) >= _vm.$store.state.config.companyMeta.settings.coverage_per_hour.high.value
          }
        }) : _vm._e()]) : (props.column.field == 'budget') ? _c('div', [_vm._v("\n                                -\n                            ")]) : (props.column.field == 'efficiency') ? _c('div', [_vm._v("\n                                -\n                            ")]) : (props.column.field == 'total_expenses') ? _c('div', [_vm._v("\n                                " + _vm._s(_vm._f("currency")(props.row.total_expenses)) + "\n                            ")]) : (props.column.field == 'sub_projects_total_expenses') ? _c('div', [_vm._v("\n                                " + _vm._s(_vm._f("currency")(props.row.sub_projects_total_expenses)) + "\n                            ")]) : _c('div', {
          attrs: {
            "title": props.formattedRow[props.column.field]
          }
        }, [_vm._v("\n                                " + _vm._s(props.formattedRow[props.column.field]) + "\n                            ")])]
      }
    }], null, false, 2348522465)
  }, [_c('div', {
    attrs: {
      "slot": "emptystate"
    },
    slot: "emptystate"
  }, [_vm._v("\n                            Ingen data ...\n                        ")])]) : _c('box-loading', {
    attrs: {
      "height": "350"
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    class: {
      'col-lg-6': !_vm.selectedRow, 'col-lg-9': _vm.selectedRow
    }
  }, [(!_vm.selectedRow) ? _c('div', [_vm._v("\n                Vælg en underentreprise for at se en liste over alle opgaver inden for denne type\n            ")]) : _vm._e(), _vm._v(" "), (_vm.selectedRow) ? _c('div', [_c('div', {
    staticStyle: {
      "margin-bottom": "5px"
    }
  }, [_c('a', {
    staticStyle: {
      "text-decoration": "none",
      "color": "#172b43",
      "font-weight": "600"
    },
    attrs: {
      "href": "javascript:void(0)"
    },
    on: {
      "click": function($event) {
        _vm.selectedRow = null
      }
    }
  }, [_c('i', {
    staticClass: "far fa-times"
  }), _vm._v(" Luk\n                    ")])])]) : _vm._e(), _vm._v(" "), (_vm.selectedRow) ? _c('sub-project-types-single', {
    attrs: {
      "data": _vm.selectedRow
    }
  }) : _vm._e()], 1)])])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-fd6ce220", module.exports)
  }
}

/***/ }),
/* 896 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "responsible-project-types"
  }, [_c('div', {
    staticClass: "placeholder mb-4"
  }, [_c('div', {
    staticClass: "placeholder__heading"
  }, [_vm._v("\n            " + _vm._s(_vm.data.name) + "\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "placeholder"
  }, [_c('vue-good-table', {
    attrs: {
      "columns": _vm.columns,
      "rows": _vm.data.responsibles,
      "search-options": _vm.searchOptions,
      "pagination-options": _vm.paginationOptions,
      "sort-options": _vm.sortOptions,
      "styleClass": _vm.styleClass,
      "row-style-class": _vm.selectedRowClass
    },
    on: {
      "on-row-click": _vm.selectResponsible
    },
    scopedSlots: _vm._u([{
      key: "table-row",
      fn: function(props) {
        return [(props.column.field == 'coverage_percent') ? _c('div', {
          staticClass: "coverage-cell"
        }, [_vm._v("\n                        " + _vm._s(_vm._f("rounded")(props.row.coverage_percent)) + " \n                        "), (props.row.coverage_percent !== null) ? _c('div', {
          staticClass: "coverage-indicator",
          class: {
            'bad': props.row.coverage_percent < _vm.$store.state.config.companyMeta.settings.coverage_percent.medium.value, 'avg': _vm.$options.filters.rounded(props.row.coverage_percent) >= _vm.$store.state.config.companyMeta.settings.coverage_percent.medium.value, 'good': _vm.$options.filters.rounded(props.row.coverage_percent) >= _vm.$store.state.config.companyMeta.settings.coverage_percent.high.value
          }
        }) : _vm._e()]) : (props.column.field == 'total_revenue') ? _c('div', [_vm._v("\n                        " + _vm._s(_vm._f("currency")(props.row.total_revenue)) + "\n                    ")]) : (props.column.field == 'total_coverage') ? _c('div', [_vm._v("\n                        " + _vm._s(_vm._f("currency")(props.row.total_coverage)) + "\n                    ")]) : (props.column.field == 'coverage_per_hour') ? _c('div', {
          staticClass: "coverage-cell"
        }, [_vm._v("\n                        " + _vm._s(_vm._f("currency")(props.row.coverage_per_hour)) + " \n                        "), (props.row.coverage_per_hour !== null) ? _c('div', {
          staticClass: "coverage-indicator",
          class: {
            'bad': props.row.coverage_per_hour < _vm.$store.state.config.companyMeta.settings.coverage_per_hour.medium.value, 'avg': _vm.$options.filters.rounded(props.row.coverage_per_hour) >= _vm.$store.state.config.companyMeta.settings.coverage_per_hour.medium.value, 'good': _vm.$options.filters.rounded(props.row.coverage_per_hour) >= _vm.$store.state.config.companyMeta.settings.coverage_per_hour.high.value
          }
        }) : _vm._e()]) : (props.column.field == 'customer_name') ? _c('div', {
          staticClass: "table-column__customer",
          attrs: {
            "title": props.row.customer_name
          }
        }, [(props.row.customer_name) ? _c('span', [_vm._v("\n                            " + _vm._s(props.row.customer_name) + "\n                        ")]) : _c('span', [_vm._v(" - ")])]) : (props.column.field == 'name') ? _c('div', {
          staticClass: "table-column__description",
          attrs: {
            "title": props.row.name
          }
        }, [_vm._v("\n                        " + _vm._s(props.row.name) + "\n                    ")]) : (props.column.field == 'start_date') ? _c('div', [_vm._v("\n                        " + _vm._s(_vm._f("moment")(props.row.start_date, "DD. MMM YYYY")) + "\n                    ")]) : _c('div', [_vm._v("\n                        " + _vm._s(props.formattedRow[props.column.field]) + "\n                    ")])]
      }
    }])
  }, [_c('div', {
    attrs: {
      "slot": "emptystate"
    },
    slot: "emptystate"
  }, [_vm._v("\n                    Ingen data ...\n                ")])])], 1)]), _vm._v(" "), (_vm.selectedRow) ? _c('project-types-projects', {
    attrs: {
      "data": _vm.selectedRow
    }
  }) : _c('div', [_vm._v("\n        Vælg en ansvarlig for at se dennes opgaver her\n    ")])], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-ff591e1c", module.exports)
  }
}

/***/ }),
/* 897 */,
/* 898 */,
/* 899 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(541);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(3)("046ca6ee", content, false);
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-0466fc80\",\"scoped\":true,\"hasInlineConfig\":false}!../../../../node_modules/sass-loader/lib/loader.js?{\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./ebitda.vue", function() {
     var newContent = require("!!../../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-0466fc80\",\"scoped\":true,\"hasInlineConfig\":false}!../../../../node_modules/sass-loader/lib/loader.js?{\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./ebitda.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 900 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(542);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(3)("214c692e", content, false);
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-06a459bd\",\"scoped\":true,\"hasInlineConfig\":false}!../../../node_modules/sass-loader/lib/loader.js?{\"sourceMap\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./SummaryCard.vue", function() {
     var newContent = require("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-06a459bd\",\"scoped\":true,\"hasInlineConfig\":false}!../../../node_modules/sass-loader/lib/loader.js?{\"sourceMap\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./SummaryCard.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 901 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(543);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(3)("11659dd4", content, false);
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-1313447a\",\"scoped\":true,\"hasInlineConfig\":false}!../../../node_modules/sass-loader/lib/loader.js?{\"sourceMap\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./Sidebar.vue", function() {
     var newContent = require("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-1313447a\",\"scoped\":true,\"hasInlineConfig\":false}!../../../node_modules/sass-loader/lib/loader.js?{\"sourceMap\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./Sidebar.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 902 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(544);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(3)("299ba000", content, false);
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-1837e2a0\",\"scoped\":true,\"hasInlineConfig\":false}!../../../../node_modules/sass-loader/lib/loader.js?{\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./costsDivision.vue", function() {
     var newContent = require("!!../../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-1837e2a0\",\"scoped\":true,\"hasInlineConfig\":false}!../../../../node_modules/sass-loader/lib/loader.js?{\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./costsDivision.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 903 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(545);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(3)("5a11911a", content, false);
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-1bc34b89\",\"scoped\":false,\"hasInlineConfig\":false}!../../../node_modules/sass-loader/lib/loader.js?{\"sourceMap\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=1!./loader.vue", function() {
     var newContent = require("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-1bc34b89\",\"scoped\":false,\"hasInlineConfig\":false}!../../../node_modules/sass-loader/lib/loader.js?{\"sourceMap\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=1!./loader.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 904 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(546);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(3)("4ab7889a", content, false);
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-1bc34b89\",\"scoped\":true,\"hasInlineConfig\":false}!../../../node_modules/sass-loader/lib/loader.js?{\"sourceMap\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./loader.vue", function() {
     var newContent = require("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-1bc34b89\",\"scoped\":true,\"hasInlineConfig\":false}!../../../node_modules/sass-loader/lib/loader.js?{\"sourceMap\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./loader.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 905 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(547);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(3)("649776b8", content, false);
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-1e6fb320\",\"scoped\":false,\"hasInlineConfig\":false}!../../../node_modules/sass-loader/lib/loader.js?{\"sourceMap\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./layout.vue", function() {
     var newContent = require("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-1e6fb320\",\"scoped\":false,\"hasInlineConfig\":false}!../../../node_modules/sass-loader/lib/loader.js?{\"sourceMap\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./layout.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 906 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(548);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(3)("831a3e0e", content, false);
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-1e6fb320\",\"scoped\":false,\"hasInlineConfig\":false}!../../../node_modules/sass-loader/lib/loader.js?{\"sourceMap\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=1!./layout.vue", function() {
     var newContent = require("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-1e6fb320\",\"scoped\":false,\"hasInlineConfig\":false}!../../../node_modules/sass-loader/lib/loader.js?{\"sourceMap\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=1!./layout.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 907 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(549);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(3)("84e891e0", content, false);
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-1fe26433\",\"scoped\":false,\"hasInlineConfig\":false}!../../../../node_modules/sass-loader/lib/loader.js?{\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=1!./potential.vue", function() {
     var newContent = require("!!../../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-1fe26433\",\"scoped\":false,\"hasInlineConfig\":false}!../../../../node_modules/sass-loader/lib/loader.js?{\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=1!./potential.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 908 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(550);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(3)("6fa1a108", content, false);
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-1fe26433\",\"scoped\":true,\"hasInlineConfig\":false}!../../../../node_modules/sass-loader/lib/loader.js?{\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./potential.vue", function() {
     var newContent = require("!!../../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-1fe26433\",\"scoped\":true,\"hasInlineConfig\":false}!../../../../node_modules/sass-loader/lib/loader.js?{\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./potential.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 909 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(551);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(3)("4050c3d4", content, false);
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-20fa3fe5\",\"scoped\":true,\"hasInlineConfig\":false}!../../../node_modules/sass-loader/lib/loader.js?{\"sourceMap\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./comingSoon.vue", function() {
     var newContent = require("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-20fa3fe5\",\"scoped\":true,\"hasInlineConfig\":false}!../../../node_modules/sass-loader/lib/loader.js?{\"sourceMap\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./comingSoon.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 910 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(552);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(3)("1c7f3990", content, false);
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-22a330da\",\"scoped\":true,\"hasInlineConfig\":false}!../../../node_modules/sass-loader/lib/loader.js?{\"sourceMap\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./ProjectTooltip.vue", function() {
     var newContent = require("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-22a330da\",\"scoped\":true,\"hasInlineConfig\":false}!../../../node_modules/sass-loader/lib/loader.js?{\"sourceMap\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./ProjectTooltip.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 911 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(553);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(3)("019861aa", content, false);
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-238bdf1c\",\"scoped\":false,\"hasInlineConfig\":false}!../../../node_modules/sass-loader/lib/loader.js?{\"sourceMap\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=1!./index.vue", function() {
     var newContent = require("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-238bdf1c\",\"scoped\":false,\"hasInlineConfig\":false}!../../../node_modules/sass-loader/lib/loader.js?{\"sourceMap\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=1!./index.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 912 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(554);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(3)("47ccd76d", content, false);
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-238bdf1c\",\"scoped\":true,\"hasInlineConfig\":false}!../../../node_modules/sass-loader/lib/loader.js?{\"sourceMap\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./index.vue", function() {
     var newContent = require("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-238bdf1c\",\"scoped\":true,\"hasInlineConfig\":false}!../../../node_modules/sass-loader/lib/loader.js?{\"sourceMap\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./index.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 913 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(555);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(3)("64a54c0c", content, false);
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-23bfba74\",\"scoped\":true,\"hasInlineConfig\":false}!../../../node_modules/sass-loader/lib/loader.js?{\"sourceMap\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./NoData.vue", function() {
     var newContent = require("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-23bfba74\",\"scoped\":true,\"hasInlineConfig\":false}!../../../node_modules/sass-loader/lib/loader.js?{\"sourceMap\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./NoData.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 914 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(556);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(3)("7fbac454", content, false);
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-242b0c66\",\"scoped\":true,\"hasInlineConfig\":false}!../../../../node_modules/sass-loader/lib/loader.js?{\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./user.vue", function() {
     var newContent = require("!!../../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-242b0c66\",\"scoped\":true,\"hasInlineConfig\":false}!../../../../node_modules/sass-loader/lib/loader.js?{\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./user.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 915 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(557);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(3)("2e150474", content, false);
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-2631a998\",\"scoped\":false,\"hasInlineConfig\":false}!../../../node_modules/sass-loader/lib/loader.js?{\"sourceMap\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=1!./ConfigBar.vue", function() {
     var newContent = require("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-2631a998\",\"scoped\":false,\"hasInlineConfig\":false}!../../../node_modules/sass-loader/lib/loader.js?{\"sourceMap\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=1!./ConfigBar.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 916 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(558);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(3)("52024354", content, false);
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-2631a998\",\"scoped\":true,\"hasInlineConfig\":false}!../../../node_modules/sass-loader/lib/loader.js?{\"sourceMap\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./ConfigBar.vue", function() {
     var newContent = require("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-2631a998\",\"scoped\":true,\"hasInlineConfig\":false}!../../../node_modules/sass-loader/lib/loader.js?{\"sourceMap\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./ConfigBar.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 917 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(559);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(3)("c0937752", content, false);
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-2f6d19d5\",\"scoped\":true,\"hasInlineConfig\":false}!../../../../../node_modules/sass-loader/lib/loader.js?{\"sourceMap\":false}!../../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./pie.vue", function() {
     var newContent = require("!!../../../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-2f6d19d5\",\"scoped\":true,\"hasInlineConfig\":false}!../../../../../node_modules/sass-loader/lib/loader.js?{\"sourceMap\":false}!../../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./pie.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 918 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(560);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(3)("471217fe", content, false);
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-301a1469\",\"scoped\":true,\"hasInlineConfig\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./404.vue", function() {
     var newContent = require("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-301a1469\",\"scoped\":true,\"hasInlineConfig\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./404.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 919 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(561);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(3)("db3599fe", content, false);
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-30dee4b6\",\"scoped\":false,\"hasInlineConfig\":false}!../../../node_modules/sass-loader/lib/loader.js?{\"sourceMap\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=1!./TableCard.vue", function() {
     var newContent = require("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-30dee4b6\",\"scoped\":false,\"hasInlineConfig\":false}!../../../node_modules/sass-loader/lib/loader.js?{\"sourceMap\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=1!./TableCard.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 920 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(562);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(3)("0098343f", content, false);
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-30dee4b6\",\"scoped\":true,\"hasInlineConfig\":false}!../../../node_modules/sass-loader/lib/loader.js?{\"sourceMap\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./TableCard.vue", function() {
     var newContent = require("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-30dee4b6\",\"scoped\":true,\"hasInlineConfig\":false}!../../../node_modules/sass-loader/lib/loader.js?{\"sourceMap\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./TableCard.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 921 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(563);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(3)("39930398", content, false);
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-3756a0f3\",\"scoped\":true,\"hasInlineConfig\":false}!../../../../node_modules/sass-loader/lib/loader.js?{\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./employees.vue", function() {
     var newContent = require("!!../../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-3756a0f3\",\"scoped\":true,\"hasInlineConfig\":false}!../../../../node_modules/sass-loader/lib/loader.js?{\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./employees.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 922 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(564);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(3)("286adda2", content, false);
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-3d3aa354\",\"scoped\":true,\"hasInlineConfig\":false}!../../../../node_modules/sass-loader/lib/loader.js?{\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./general.vue", function() {
     var newContent = require("!!../../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-3d3aa354\",\"scoped\":true,\"hasInlineConfig\":false}!../../../../node_modules/sass-loader/lib/loader.js?{\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./general.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 923 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(565);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(3)("7db60907", content, false);
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-427a9fc7\",\"scoped\":false,\"hasInlineConfig\":false}!../node_modules/sass-loader/lib/loader.js?{\"sourceMap\":false}!../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./App.vue", function() {
     var newContent = require("!!../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-427a9fc7\",\"scoped\":false,\"hasInlineConfig\":false}!../node_modules/sass-loader/lib/loader.js?{\"sourceMap\":false}!../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./App.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 924 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(566);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(3)("6c757bd4", content, false);
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-45eaf5ea\",\"scoped\":true,\"hasInlineConfig\":false}!../../../../node_modules/sass-loader/lib/loader.js?{\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./projectTypesPotential.vue", function() {
     var newContent = require("!!../../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-45eaf5ea\",\"scoped\":true,\"hasInlineConfig\":false}!../../../../node_modules/sass-loader/lib/loader.js?{\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./projectTypesPotential.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 925 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(567);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(3)("81c6baa2", content, false);
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-46c39325\",\"scoped\":false,\"hasInlineConfig\":false}!../../../node_modules/sass-loader/lib/loader.js?{\"sourceMap\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=1!./GraphCard.vue", function() {
     var newContent = require("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-46c39325\",\"scoped\":false,\"hasInlineConfig\":false}!../../../node_modules/sass-loader/lib/loader.js?{\"sourceMap\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=1!./GraphCard.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 926 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(568);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(3)("0f10885e", content, false);
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-46c39325\",\"scoped\":true,\"hasInlineConfig\":false}!../../../node_modules/sass-loader/lib/loader.js?{\"sourceMap\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./GraphCard.vue", function() {
     var newContent = require("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-46c39325\",\"scoped\":true,\"hasInlineConfig\":false}!../../../node_modules/sass-loader/lib/loader.js?{\"sourceMap\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./GraphCard.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 927 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(569);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(3)("00b2eb7b", content, false);
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-52ebedca\",\"scoped\":false,\"hasInlineConfig\":false}!../vue-loader/lib/selector.js?type=styles&index=0!./Dropdown.vue", function() {
     var newContent = require("!!../css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-52ebedca\",\"scoped\":false,\"hasInlineConfig\":false}!../vue-loader/lib/selector.js?type=styles&index=0!./Dropdown.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 928 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(570);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(3)("efc8825e", content, false);
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-55170067\",\"scoped\":true,\"hasInlineConfig\":false}!../../../../node_modules/sass-loader/lib/loader.js?{\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./valueChain.vue", function() {
     var newContent = require("!!../../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-55170067\",\"scoped\":true,\"hasInlineConfig\":false}!../../../../node_modules/sass-loader/lib/loader.js?{\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./valueChain.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 929 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(571);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(3)("28dcc334", content, false);
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-57bd4472\",\"scoped\":true,\"hasInlineConfig\":false}!../../../../node_modules/sass-loader/lib/loader.js?{\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./budget.vue", function() {
     var newContent = require("!!../../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-57bd4472\",\"scoped\":true,\"hasInlineConfig\":false}!../../../../node_modules/sass-loader/lib/loader.js?{\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./budget.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 930 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(572);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(3)("c8adc092", content, false);
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-59df3e14\",\"scoped\":true,\"hasInlineConfig\":false}!../../../../node_modules/sass-loader/lib/loader.js?{\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./users.vue", function() {
     var newContent = require("!!../../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-59df3e14\",\"scoped\":true,\"hasInlineConfig\":false}!../../../../node_modules/sass-loader/lib/loader.js?{\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./users.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 931 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(573);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(3)("b15715a4", content, false);
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-5d6ac280\",\"scoped\":true,\"hasInlineConfig\":false}!../../../../node_modules/sass-loader/lib/loader.js?{\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./revenueAndCosts.vue", function() {
     var newContent = require("!!../../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-5d6ac280\",\"scoped\":true,\"hasInlineConfig\":false}!../../../../node_modules/sass-loader/lib/loader.js?{\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./revenueAndCosts.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 932 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(574);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(3)("1633852c", content, false);
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-5e3ac208\",\"scoped\":true,\"hasInlineConfig\":false}!../../../node_modules/sass-loader/lib/loader.js?{\"sourceMap\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./dTooltip.vue", function() {
     var newContent = require("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-5e3ac208\",\"scoped\":true,\"hasInlineConfig\":false}!../../../node_modules/sass-loader/lib/loader.js?{\"sourceMap\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./dTooltip.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 933 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(575);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(3)("2e31980f", content, false);
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-5ebecd11\",\"scoped\":true,\"hasInlineConfig\":false}!../../../node_modules/sass-loader/lib/loader.js?{\"sourceMap\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./footer.vue", function() {
     var newContent = require("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-5ebecd11\",\"scoped\":true,\"hasInlineConfig\":false}!../../../node_modules/sass-loader/lib/loader.js?{\"sourceMap\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./footer.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 934 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(576);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(3)("9742d360", content, false);
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-6020b3ac\",\"scoped\":false,\"hasInlineConfig\":false}!../../../node_modules/sass-loader/lib/loader.js?{\"sourceMap\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./projects.vue", function() {
     var newContent = require("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-6020b3ac\",\"scoped\":false,\"hasInlineConfig\":false}!../../../node_modules/sass-loader/lib/loader.js?{\"sourceMap\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./projects.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 935 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(577);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(3)("6141737e", content, false);
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-60f315bb\",\"scoped\":true,\"hasInlineConfig\":false}!../../../node_modules/sass-loader/lib/loader.js?{\"sourceMap\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./index.vue", function() {
     var newContent = require("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-60f315bb\",\"scoped\":true,\"hasInlineConfig\":false}!../../../node_modules/sass-loader/lib/loader.js?{\"sourceMap\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./index.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 936 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(578);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(3)("d752a2fa", content, false);
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-70ce8938\",\"scoped\":true,\"hasInlineConfig\":false}!../../../../node_modules/sass-loader/lib/loader.js?{\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./timeUsageSkills.vue", function() {
     var newContent = require("!!../../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-70ce8938\",\"scoped\":true,\"hasInlineConfig\":false}!../../../../node_modules/sass-loader/lib/loader.js?{\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./timeUsageSkills.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 937 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(579);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(3)("7b0b3ff2", content, false);
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-74a30572\",\"scoped\":true,\"hasInlineConfig\":false}!../../../../node_modules/sass-loader/lib/loader.js?{\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./projectStatuses.vue", function() {
     var newContent = require("!!../../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-74a30572\",\"scoped\":true,\"hasInlineConfig\":false}!../../../../node_modules/sass-loader/lib/loader.js?{\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./projectStatuses.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 938 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(580);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(3)("052bcd5c", content, false);
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-77c8f022\",\"scoped\":true,\"hasInlineConfig\":false}!../../../node_modules/sass-loader/lib/loader.js?{\"sourceMap\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./viewToggle.vue", function() {
     var newContent = require("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-77c8f022\",\"scoped\":true,\"hasInlineConfig\":false}!../../../node_modules/sass-loader/lib/loader.js?{\"sourceMap\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./viewToggle.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 939 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(581);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(3)("1b08c1e5", content, false);
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-7dd1bf60\",\"scoped\":false,\"hasInlineConfig\":false}!../../../node_modules/sass-loader/lib/loader.js?{\"sourceMap\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./index.vue", function() {
     var newContent = require("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-7dd1bf60\",\"scoped\":false,\"hasInlineConfig\":false}!../../../node_modules/sass-loader/lib/loader.js?{\"sourceMap\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./index.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 940 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(582);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(3)("1fdeb840", content, false);
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-804e69b6\",\"scoped\":true,\"hasInlineConfig\":false}!../../../node_modules/sass-loader/lib/loader.js?{\"sourceMap\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./BudgetTooltip.vue", function() {
     var newContent = require("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-804e69b6\",\"scoped\":true,\"hasInlineConfig\":false}!../../../node_modules/sass-loader/lib/loader.js?{\"sourceMap\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./BudgetTooltip.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 941 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(583);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(3)("f84eb51a", content, false);
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-87b029dc\",\"scoped\":true,\"hasInlineConfig\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./offline.vue", function() {
     var newContent = require("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-87b029dc\",\"scoped\":true,\"hasInlineConfig\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./offline.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 942 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(584);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(3)("f959c65c", content, false);
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-ad10ac3c\",\"scoped\":true,\"hasInlineConfig\":false}!../../../../node_modules/sass-loader/lib/loader.js?{\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./excludeProjects.vue", function() {
     var newContent = require("!!../../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-ad10ac3c\",\"scoped\":true,\"hasInlineConfig\":false}!../../../../node_modules/sass-loader/lib/loader.js?{\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./excludeProjects.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 943 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(585);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(3)("44b65915", content, false);
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-b2eeed00\",\"scoped\":false,\"hasInlineConfig\":false}!../../../node_modules/sass-loader/lib/loader.js?{\"sourceMap\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./BoxHelper.vue", function() {
     var newContent = require("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-b2eeed00\",\"scoped\":false,\"hasInlineConfig\":false}!../../../node_modules/sass-loader/lib/loader.js?{\"sourceMap\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./BoxHelper.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 944 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(586);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(3)("b940980e", content, false);
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-c979e24c\",\"scoped\":true,\"hasInlineConfig\":false}!../../../node_modules/sass-loader/lib/loader.js?{\"sourceMap\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./BoxLoading.vue", function() {
     var newContent = require("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-c979e24c\",\"scoped\":true,\"hasInlineConfig\":false}!../../../node_modules/sass-loader/lib/loader.js?{\"sourceMap\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./BoxLoading.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 945 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(587);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(3)("352e0059", content, false);
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-cd5cc2c2\",\"scoped\":true,\"hasInlineConfig\":false}!../../../node_modules/sass-loader/lib/loader.js?{\"sourceMap\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./title.vue", function() {
     var newContent = require("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-cd5cc2c2\",\"scoped\":true,\"hasInlineConfig\":false}!../../../node_modules/sass-loader/lib/loader.js?{\"sourceMap\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./title.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 946 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(588);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(3)("ed343036", content, false);
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-d8e10d84\",\"scoped\":true,\"hasInlineConfig\":false}!../../../node_modules/sass-loader/lib/loader.js?{\"sourceMap\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./login.vue", function() {
     var newContent = require("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-d8e10d84\",\"scoped\":true,\"hasInlineConfig\":false}!../../../node_modules/sass-loader/lib/loader.js?{\"sourceMap\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./login.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 947 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(589);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(3)("369db01a", content, false);
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-d921176c\",\"scoped\":true,\"hasInlineConfig\":false}!../../../node_modules/sass-loader/lib/loader.js?{\"sourceMap\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./register.vue", function() {
     var newContent = require("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-d921176c\",\"scoped\":true,\"hasInlineConfig\":false}!../../../node_modules/sass-loader/lib/loader.js?{\"sourceMap\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./register.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 948 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(590);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(3)("54ce704b", content, false);
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-db2305ca\",\"scoped\":true,\"hasInlineConfig\":false}!../../../../node_modules/sass-loader/lib/loader.js?{\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./changeCompany.vue", function() {
     var newContent = require("!!../../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-db2305ca\",\"scoped\":true,\"hasInlineConfig\":false}!../../../../node_modules/sass-loader/lib/loader.js?{\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./changeCompany.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 949 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(591);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(3)("1621ec9d", content, false);
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-e1cbaa30\",\"scoped\":true,\"hasInlineConfig\":false}!../../../../node_modules/sass-loader/lib/loader.js?{\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./costpricePerHour.vue", function() {
     var newContent = require("!!../../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-e1cbaa30\",\"scoped\":true,\"hasInlineConfig\":false}!../../../../node_modules/sass-loader/lib/loader.js?{\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./costpricePerHour.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 950 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(592);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(3)("6a4b019c", content, false);
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-ed1d8338\",\"scoped\":true,\"hasInlineConfig\":false}!../../../../node_modules/sass-loader/lib/loader.js?{\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./accountPlan.vue", function() {
     var newContent = require("!!../../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-ed1d8338\",\"scoped\":true,\"hasInlineConfig\":false}!../../../../node_modules/sass-loader/lib/loader.js?{\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./accountPlan.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 951 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(593);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(3)("7aa97589", content, false);
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-ee45503c\",\"scoped\":true,\"hasInlineConfig\":false}!../../../node_modules/sass-loader/lib/loader.js?{\"sourceMap\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./NumberCard.vue", function() {
     var newContent = require("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-ee45503c\",\"scoped\":true,\"hasInlineConfig\":false}!../../../node_modules/sass-loader/lib/loader.js?{\"sourceMap\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./NumberCard.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 952 */,
/* 953 */,
/* 954 */,
/* 955 */,
/* 956 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ })
],[347]);


// WEBPACK FOOTER //
// static/js/app.3015cba079aacb89095c.js